export const HornadyAttributekeys = [
	'PackagedQTY',
	'PackagedUOM',
	'Weight',
	'WeightUOM',
	'CaseQty',

	'CountryofOrigin',
	'LithiumBattery',
];
export const HornadyFeed = [
	{
		'@odata.etag': '',
		ItemInternalId: 'c6c4b4f4-69f5-4ac5-bc27-be78e50554a3',
		ProductID: '99600XXL',
		ProductName: 'OD Green T-Shirt',
		UPC: '090255721935',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: ' Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Uptc89AW--/dzsrhudlhoe36nmrtabq.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd60bc0d6-0042-4be2-9d62-a1238985b945',
		ProductID: '99600L',
		ProductName: 'OD Green T-Shirt',
		UPC: '090255721911',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: ' Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Uptc89AW--/dzsrhudlhoe36nmrtabq.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f53f6ba-927d-460f-9ffc-481a8a102af4',
		ProductID: '99600M',
		ProductName: 'OD Green T-Shirt',
		UPC: '090255721904',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Uptc89AW--/dzsrhudlhoe36nmrtabq.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c805023-f11a-443f-83be-fc08a59976ea',
		ProductID: '99600XXXL',
		ProductName: 'OD Green T-Shirt',
		UPC: '090255721942',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: ' Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Uptc89AW--/dzsrhudlhoe36nmrtabq.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e0fdfc91-c40a-4312-b328-926bad93bbab',
		ProductID: '99600XL',
		ProductName: 'OD Green T-Shirt',
		UPC: '090255721928',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Uptc89AW--/dzsrhudlhoe36nmrtabq.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ca34a31-219a-4e75-849e-a2ab9c6de04f',
		ProductID: '99601M',
		ProductName: 'Red T-Shirt',
		UPC: '090255721959',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--x0pY2vOg--/qmgj2gycup36rpvyjlg7.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7fc55936-cb03-40d0-b8a1-43e2547159c1',
		ProductID: '99601L',
		ProductName: 'Red T-Shirt',
		UPC: '090255721966',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.360',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--x0pY2vOg--/qmgj2gycup36rpvyjlg7.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '26e68d1e-9065-43c4-9947-c558cf1b0004',
		ProductID: '99601XL',
		ProductName: 'Red T-Shirt',
		UPC: '090255721973',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--x0pY2vOg--/qmgj2gycup36rpvyjlg7.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '444e0adc-9d19-41dc-a268-b65f51c34e62',
		ProductID: '99601XXL',
		ProductName: 'Red T-Shirt',
		UPC: '090255721980',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--x0pY2vOg--/qmgj2gycup36rpvyjlg7.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a0b7262f-69bc-458a-a8c4-44e443bae792',
		ProductID: '99601XXXL',
		ProductName: 'Red T-Shirt',
		UPC: '090255721997',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.000',
		ShelfWidth: '8.500',
		ShelfDepth: '11.000',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Back and front chest logos. Poly cotton blend.',
		ProductImage: 'http://images.salsify.com/image/upload/s--x0pY2vOg--/qmgj2gycup36rpvyjlg7.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '79ea2ad0-7d26-4066-bd70-a685967ac064',
		ProductID: '99693M',
		ProductName: 'Hornady® Outfitter T-Shirt',
		UPC: '090255705478',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HAITI',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 65% cotton, 35% Polyester Poly-cotton blend. Imported',
		ProductImage: 'http://images.salsify.com/image/upload/s---2dXCzpd--/fincnr8zatcljkzcftom.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e6b384f1-99f4-419b-aafa-42f5c42c871c',
		ProductID: '99693XXL',
		ProductName: 'Hornady® Outfitter T-Shirt',
		UPC: '090255705508',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '21.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HAITI',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 65% cotton, 35% Polyester Poly-cotton blend. Imported',
		ProductImage: 'http://images.salsify.com/image/upload/s---2dXCzpd--/fincnr8zatcljkzcftom.png',
		DateLastModified: '2023-11-07 15:06:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '401239ad-2f97-4cb7-ba7f-b0bb1635f010',
		ProductID: '99693XXXL',
		ProductName: 'Hornady® Outfitter T-Shirt',
		UPC: '090255705515',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HAITI',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 65% cotton, 35% Polyester Poly-cotton blend. Imported',
		ProductImage: 'http://images.salsify.com/image/upload/s---2dXCzpd--/fincnr8zatcljkzcftom.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '854de9af-f58d-43b2-9680-a4a0b306ff73',
		ProductID: '99693L',
		ProductName: 'Hornady® Outfitter T-Shirt',
		UPC: '090255705485',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HAITI',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 65% cotton, 35% Polyester Poly-cotton blend. Imported',
		ProductImage: 'http://images.salsify.com/image/upload/s---2dXCzpd--/fincnr8zatcljkzcftom.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2e77c8ee-c2a8-42a0-bd1b-585242f00cff',
		ProductID: '99693XL',
		ProductName: 'Hornady® Outfitter T-Shirt',
		UPC: '090255705492',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HAITI',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 65% cotton, 35% Polyester Poly-cotton blend. Imported',
		ProductImage: 'http://images.salsify.com/image/upload/s---2dXCzpd--/fincnr8zatcljkzcftom.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3687efff-3f19-4873-9e38-54f64027bd1a',
		ProductID: '99602L',
		ProductName: 'Hornady Flannel',
		UPC: '090255723700',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2023-12-19 20:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '54f30f9f-fdaa-48be-af60-b63fa6c528d9',
		ProductID: '99602XL',
		ProductName: 'Hornady Flannel',
		UPC: '090255723717',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.156',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2023-12-19 20:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90df54e6-99cf-4636-a49b-cd850b9b90fe',
		ProductID: '99602XXXL',
		ProductName: 'Hornady Flannel',
		UPC: '090255723731',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2023-12-19 20:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3194a38-b8bf-4842-b724-67b40494a0a0',
		ProductID: '99602XXL',
		ProductName: 'Hornady Flannel',
		UPC: '090255723724',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2023-12-19 20:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8a9b5edd-5be2-40a4-9bc8-3ea111d808c6',
		ProductID: '99602M',
		ProductName: 'Hornady Flannel',
		UPC: '090255723694',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.950',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2023-12-19 20:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '576a73be-e67e-4d0a-ba67-fd096c323e14',
		ProductID: '99602S',
		ProductName: 'Hornady Flannel',
		UPC: '090255723748',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.030',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.000',
		CartonWidth: '8.500',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A hunter's wardrobe is not complete without a great flannel. Made from 100% cotton, this durable yet soft flannel features a double pleat back for ease of movement, left chest pocket with pencil slot and button closure, and internal shirttail microfiber lens cleaner",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jc67qjH---/rqobl40zbui0yzj7i5ug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SVzXQq0s--/nitic3idgdz288jxlgyi.jpg',
		DateLastModified: '2024-01-09 17:00:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f55e3283-16e4-4308-9067-aab54ca649ee',
		ProductID: '397141',
		ProductName: 'A-Tip™ Seating Stem 7mm .284 166 Gr',
		UPC: '090255971415',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971412',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef5f856c-13c6-4f23-82f0-6f3fe02179f1',
		ProductID: '397142',
		ProductName: 'A-Tip™ Seating Stem 7mm .284 190 Gr',
		UPC: '090255971422',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971429',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2024-01-09 16:43:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ddf3f81f-4d54-4e44-a777-7b8433a326f8',
		ProductID: '397138',
		ProductName: 'Seating Stem 6.5mm A-Tip™135/153 Gr',
		UPC: '090255971385',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971382',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '01ab9d57-59a8-4e8d-b6aa-dd24b8d4259f',
		ProductID: '397100',
		ProductName: 'Seating Stem 22 Cal ELD® Match™',
		UPC: '090255971002',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.036',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971009',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.36',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '525e1cd1-730d-4ae1-8b67-d6a3c1ba04d0',
		ProductID: '397143',
		ProductName: 'A-Tip™ Seating Stem 30 Cal .308 176 Gr',
		UPC: '090255971439',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971436',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bf7a8143-e52a-4381-8240-5b122c539b59',
		ProductID: '397139',
		ProductName: 'Seating Stem 6mm A-Tip™ 110 Gr',
		UPC: '090255971392',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971399',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1d10145a-7807-4d93-b322-2f1249e75e8a',
		ProductID: '397140',
		ProductName: 'Seating Stem 30 Cal A-Tip™230/250Gr',
		UPC: '090255971408',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971405',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f30944cc-de3d-4041-ab30-8d35828c1fd7',
		ProductID: '397144',
		ProductName: 'A-Tip™ Seating Stem 338 Cal .338 300 Gr',
		UPC: '090255971446',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971443',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '10090255971382',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX®, A-Tip®, ELD® Match, ELD-X®, FTX® and MonoFlex® bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a30b206a-d677-4ac5-9b01-cee826ee255a',
		ProductID: '98164',
		ProductName: 'Hornady® RAPiD® Safe Bracelet Large',
		UPC: '090255981643',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.125',
		ShelfWidth: '3.5',
		ShelfDepth: '1',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981640',
		CartonHeight: '6.000',
		CartonWidth: '3.000',
		CartonDepth: '0.500',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '9.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255981602',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQT6DX5K--/rwenqozogqkp7t3uu3be.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '439ed472-f43d-4e63-a3ec-24222a311bca',
		ProductID: '98165',
		ProductName: 'Hornady® RAPiD® Safe Bracelet X-Large',
		UPC: '090255981650',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.125',
		ShelfWidth: '3.5',
		ShelfDepth: '1',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981657',
		CartonHeight: '6.000',
		CartonWidth: '3.000',
		CartonDepth: '0.500',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '9.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255981602',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQT6DX5K--/rwenqozogqkp7t3uu3be.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6aff141-a81a-483c-8679-1497b969507b',
		ProductID: '98160',
		ProductName: 'Hornady® RAPiD® Safe Bracelet Small',
		UPC: '090255981605',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.125',
		ShelfWidth: '3.5',
		ShelfDepth: '1',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981602',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '9.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255981602',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQT6DX5K--/rwenqozogqkp7t3uu3be.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ae6c2175-8888-40dc-aeee-4f214a18b820',
		ProductID: '98163',
		ProductName: 'Hornady® RAPiD® Safe Bracelet Medium',
		UPC: '090255981636',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.125',
		ShelfWidth: '3.5',
		ShelfDepth: '1',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981633',
		CartonHeight: '6.000',
		CartonWidth: '3.000',
		CartonDepth: '0.500',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '9.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255981602',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQT6DX5K--/rwenqozogqkp7t3uu3be.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '494aa35f-f8cc-4279-b85c-f57bcc5b742f',
		ProductID: '99604XL',
		ProductName: 'Grey Sweatshirt',
		UPC: '090255724042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		DateLastModified: '2023-12-19 20:09:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '69421223-6e32-4ac2-ad9e-b114f3adf827',
		ProductID: '99604L',
		ProductName: 'Grey Sweatshirt',
		UPC: '090255724035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		DateLastModified: '2023-12-19 20:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '52f58a9b-097b-4fac-92fb-4d891ef71cbd',
		ProductID: '99604M',
		ProductName: 'Grey Sweatshirt',
		UPC: '090255724028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		DateLastModified: '2023-12-19 20:09:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '756a78a1-2522-40cd-8ba0-7d6a8cc11059',
		ProductID: '99604XXL',
		ProductName: 'Grey Sweatshirt',
		UPC: '090255724059',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		DateLastModified: '2023-12-19 20:10:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '132abded-685f-48c7-86d7-88ca3620c004',
		ProductID: '99604XXXL',
		ProductName: 'Grey Sweatshirt',
		UPC: '090255724066',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '1.300',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0zpmZTr--/yg77piswpap4hzhqkodo.png',
		DateLastModified: '2023-12-19 20:10:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b16ebf1e-0ade-46bb-9ff3-cc013cd10e28',
		ProductID: '99599S',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721157',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3b5a2902-9bb5-4c8b-9fcd-430611c66a77',
		ProductID: '99599XL',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721188',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1fffa65a-afc2-41fd-8506-5dd2b8c1652e',
		ProductID: '99599XXL',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721195',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c7b140a9-05c8-4d45-bdfb-24f0914d7848',
		ProductID: '99599L',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721171',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e6568c7-5130-41b4-87f6-49be0446b521',
		ProductID: '99599XXXL',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721201',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '11',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce5846f4-51b8-4df2-979b-251e2e627af0',
		ProductID: '99599M',
		ProductName: 'Camo Solar Hoodie',
		UPC: '090255721164',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Offers superior sun protection & performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun.',
		ProductImage: 'http://images.salsify.com/image/upload/s--mRm1OUjq--/ezoilvruh3sguwnaumgu.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9788a752-d313-4011-ba01-a7d435af03f6',
		ProductID: '9972XL',
		ProductName: 'Hornady® Outfitter Hoodie',
		UPC: '090255716467',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '17',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 52% Cotton, 48% Polyester',
		ProductImage: 'http://images.salsify.com/image/upload/s--J1Ej3SHp--/uzi70uui4itwswy2awx9.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5ea35ed0-c662-4fc8-b148-dcc79b016c08',
		ProductID: '9972L',
		ProductName: 'Hornady® Outfitter Hoodie',
		UPC: '090255716450',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '17',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 52% Cotton, 48% Polyester',
		ProductImage: 'http://images.salsify.com/image/upload/s--J1Ej3SHp--/uzi70uui4itwswy2awx9.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3c43d986-136f-469d-9d9f-4e4064154906',
		ProductID: '9972XXXL',
		ProductName: 'Hornady® Outfitter Hoodie',
		UPC: '090255716481',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '0.00',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 52% Cotton, 48% Polyester',
		ProductImage: 'http://images.salsify.com/image/upload/s--J1Ej3SHp--/uzi70uui4itwswy2awx9.png',
		DateLastModified: '2023-11-07 15:06:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22424eaf-a549-4951-9da1-0996eaf78033',
		ProductID: '9972XXL',
		ProductName: 'Hornady® Outfitter Hoodie',
		UPC: '090255716474',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '17',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 52% Cotton, 48% Polyester',
		ProductImage: 'http://images.salsify.com/image/upload/s--J1Ej3SHp--/uzi70uui4itwswy2awx9.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '065c9abc-e673-4259-9b77-e635a56fdfad',
		ProductID: '9972M',
		ProductName: 'Hornady® Outfitter Hoodie',
		UPC: '090255699708',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '17',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported, 52% Cotton, 48% Polyester',
		ProductImage: 'http://images.salsify.com/image/upload/s--J1Ej3SHp--/uzi70uui4itwswy2awx9.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b40bdf15-4af2-4ed2-8872-a179e129f3c3',
		ProductID: '99598XXXL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255721140',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '11.75',
		ShelfWidth: '11',
		ShelfDepth: '1',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '11.250',
		CartonWidth: '11.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: '60/40 Cotton/Polyester. Double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--j-j_HcHg--/fkb9guyc9kjsaqovclvk.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd82a0ca8-aded-430f-9e11-7a950b606120',
		ProductID: '99598XXL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255721133',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '15',
		ShelfWidth: '12',
		ShelfDepth: '2',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: '60/40 Cotton/Polyester. Double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--j-j_HcHg--/fkb9guyc9kjsaqovclvk.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '995f22cc-c1b4-428a-91c4-f3437873b1f2',
		ProductID: '99598XL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255721126',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '15',
		ShelfWidth: '12',
		ShelfDepth: '2',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: '60/40 Cotton/Polyester. Double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--j-j_HcHg--/fkb9guyc9kjsaqovclvk.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9a29228a-546e-4611-b484-cc9b66591239',
		ProductID: '97301',
		ProductName: 'HIT™ Target Impact Indicator (5 Pack)',
		UPC: '090255973013',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.75',
		ShelfWidth: '6.25',
		ShelfDepth: '1.25',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255973010',
		CartonHeight: '9.750',
		CartonWidth: '6.250',
		CartonDepth: '1.250',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '43.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Shooting Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DEHP',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		BatteryType: 'Polymer Lithium-Ion Cell',
		BatteryQty: '5',
		BatteryWattHour: '5.55',
		BatteryWeight: '28.5',
		LithiumBattery: 'Yes',
		LiBatteryContent: '10.85',
		LiBatteryApp: 'Contained within product',
		MasterPackQty: '40',
		MasterPackUCC: '30090255973014',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '26.0',
		ProductDescription:
			'Ultra-bright light indicates bullet impact on distant steel targets. • Visible up to 1000+ yards with naked eye (weather-dependent). • Easily attaches to most stands with included elastic band. • Rechargeable using micro-USB. • Morse code "H-I-T" blinks for impact distinction •••• •• −. • Accelerometer detects bullet vibrations for activation. Ultra-bright light indicates bullet impact on distant steel targets. • Visible up to 1000+ yards with naked eye (weather-dependent). • Easily attaches to most stands with included elastic band. • Rechargeable using micro-USB. • Morse code "H-I-T" blinks for impact distinction •••• •• −. • Accelerometer detects bullet vibrations for activation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--uWlt_6Lp--/imokqqcvcytva98uk59q.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		DateLastModified: '2024-02-09 09:38:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '488b12fb-1efb-4474-adc0-800392bdfbc8',
		ProductID: '97300',
		ProductName: 'HIT™ Target Impact Indicator (2 Pack)',
		UPC: '090255973006',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9',
		ShelfWidth: '5.75',
		ShelfDepth: '1.5',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255973003',
		CartonHeight: '9.000',
		CartonWidth: '5.750',
		CartonDepth: '1.500',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '17.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Shooting Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DEHP',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		BatteryType: 'Polymer Lithium-Ion Cell',
		BatteryQty: '2',
		BatteryWattHour: '2.22',
		BatteryWeight: '11.4',
		LithiumBattery: 'Yes',
		LiBatteryContent: '4.34',
		LiBatteryApp: 'Contained within product',
		MasterPackQty: '40',
		MasterPackUCC: '30090255973007',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '14.0',
		ProductDescription:
			'Ultra-bright light indicates bullet impact on distant steel targets. • Visible up to 1000+ yards with naked eye (weather-dependent). • Easily attaches to most stands with included elastic band. • Rechargeable using micro-USB. • Morse code "H-I-T" blinks for impact distinction •••• •• −. • Accelerometer detects bullet vibrations for activation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--uWlt_6Lp--/imokqqcvcytva98uk59q.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		DateLastModified: '2024-02-12 08:34:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '526f07f4-d764-4335-b153-27f674c5cd16',
		ProductID: '97300B',
		ProductName: 'HIT™ Target Impact Indicator (50 Pack)',
		UPC: '090255723434',
		PackagedQTY: '50',
		PackagedUOM: 'EA',
		ShelfHeight: '8.25',
		ShelfWidth: '9.25',
		ShelfDepth: '8',
		Weight: '5.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255723431',
		CartonHeight: '8.250',
		CartonWidth: '9.250',
		CartonDepth: '8.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '359.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Shooting Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DEHP',
		Prop65Chem2: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		BatteryType: 'Polymer Lithium-Ion Cell',
		BatteryQty: '50',
		BatteryWattHour: '55.5',
		BatteryWeight: '285',
		LithiumBattery: 'Yes',
		LiBatteryContent: '108.5',
		LiBatteryApp: 'Contained within product',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackUCC: '10090255973003',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Ultra-bright light indicates bullet impact on distant steel targets. • Visible up to 1000+ yards with naked eye (weather-dependent). • Easily attaches to most stands with included elastic band. • Rechargeable using micro-USB. • Morse code "H-I-T" blinks for impact distinction •••• •• −. • Accelerometer detects bullet vibrations for activation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--uWlt_6Lp--/imokqqcvcytva98uk59q.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jEKcVTZd--/wxy9oyefisacaaob4ntt.jpg',
		DateLastModified: '2024-02-09 09:39:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e6cad8bd-17c7-4b7a-ab76-cad506d0a21c',
		ProductID: '99598L',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255721119',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '15',
		ShelfWidth: '12',
		ShelfDepth: '2',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: '60/40 Cotton/Polyester. Double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--j-j_HcHg--/fkb9guyc9kjsaqovclvk.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '477ab82f-94aa-488a-aa75-00b876faa081',
		ProductID: '99598M',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255721102',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '15',
		ShelfWidth: '12',
		ShelfDepth: '2',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'INDIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: '60/40 Cotton/Polyester. Double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--j-j_HcHg--/fkb9guyc9kjsaqovclvk.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '26bf1213-58c6-4a9a-987f-54bf30ae2d14',
		ProductID: '99771XL',
		ProductName: 'Hornady® Black Polo',
		UPC: '090255702255',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NN2ge9-h--/kxfher7kwwu8s4ojtjdv.png',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '96af0965-97e3-46e2-abcd-b49faaee9d00',
		ProductID: '99771L',
		ProductName: 'Hornady® Black Polo',
		UPC: '090255702248',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NN2ge9-h--/kxfher7kwwu8s4ojtjdv.png',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e57eccad-024f-41d3-b5d7-0ead435737bb',
		ProductID: '99771M',
		ProductName: 'Hornady® Black Polo',
		UPC: '090255702231',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NN2ge9-h--/kxfher7kwwu8s4ojtjdv.png',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '374f8d3b-678b-4b1e-aa01-d636cbf3e9c1',
		ProductID: '99771XXXL',
		ProductName: 'Hornady® Black Polo',
		UPC: '090255717921',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '66.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NN2ge9-h--/kxfher7kwwu8s4ojtjdv.png',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '271f5339-51c0-42e1-8046-854c4b744b91',
		ProductID: '99771XXL',
		ProductName: 'Hornady® Black Polo',
		UPC: '090255703122',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NN2ge9-h--/kxfher7kwwu8s4ojtjdv.png',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e547c34-98fe-4c0b-bff9-4deccf0c0cdd',
		ProductID: '99158S',
		ProductName: 'Hornady Big Shot Dog Collar S/M',
		UPC: '090255724103',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '13',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '72',
		CartonUCC: '10090255724100',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '10.8',
		PalletQtyBoxes: '0',
		Retail: '18.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'S/M (12"-18") L/XL (18"-26")',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--f4AsIkjs--/cqchiycllnqh1kdhq7ua.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--f4AsIkjs--/cqchiycllnqh1kdhq7ua.png',
		DateLastModified: '2024-02-07 11:01:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f8daf17-0219-452f-a123-c2dfab2812f1',
		ProductID: '99158L',
		ProductName: 'Hornady Big Shot Dog Collar L/XL',
		UPC: '090255724110',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '72',
		CartonUCC: '10090255724117',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '10.8',
		PalletQtyBoxes: '0',
		Retail: '18.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'S/M (12"-18") L/XL (18"-26")',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--f4AsIkjs--/cqchiycllnqh1kdhq7ua.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--f4AsIkjs--/cqchiycllnqh1kdhq7ua.png',
		DateLastModified: '2024-02-06 06:10:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c224ec60-e54f-4e2d-bee0-85e9dc6d3fad',
		ProductID: '99596L',
		ProductName: 'Camo Fleece Hoodie',
		UPC: '090255721010',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '11',
		ShelfDepth: '14',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front logo. 60/40 Cotton/Polyester; 230gms double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uwATtH9x--/jynnkgaz0syz7cwszfxa.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '734668fe-6f14-43f8-853f-9fe35a8336b4',
		ProductID: '99596XL',
		ProductName: 'Camo Fleece Hoodie',
		UPC: '090255721027',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '14.000',
		CartonWidth: '10.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front logo. 60/40 Cotton/Polyester; 230gms double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uwATtH9x--/jynnkgaz0syz7cwszfxa.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '59f5c57a-3dee-48e6-bcb8-995b4c31e95b',
		ProductID: '99596XXL',
		ProductName: 'Camo Fleece Hoodie',
		UPC: '090255721034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '14.000',
		CartonWidth: '10.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front logo. 60/40 Cotton/Polyester; 230gms double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uwATtH9x--/jynnkgaz0syz7cwszfxa.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c901f992-37fe-494d-aecc-f57205a0ca4e',
		ProductID: '99596M',
		ProductName: 'Camo Fleece Hoodie',
		UPC: '090255721003',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '8',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front logo. 60/40 Cotton/Polyester; 230gms double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uwATtH9x--/jynnkgaz0syz7cwszfxa.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd238d32-053d-4e71-9b92-9941dc71c261',
		ProductID: '99596XXXL',
		ProductName: 'Camo Fleece Hoodie',
		UPC: '090255721041',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '14.000',
		CartonWidth: '10.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front logo. 60/40 Cotton/Polyester; 230gms double lined hood.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uwATtH9x--/jynnkgaz0syz7cwszfxa.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27b06307-0cca-4a9e-8509-8b9c378d3812',
		ProductID: '99108',
		ProductName: 'Hornady® Gun Cheek Piece Black RH',
		UPC: '090255991086',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '7',
		ShelfDepth: '12',
		Weight: '0.230',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '49.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made of tough, nylon Cordura®, this stock pad is the perfect accessory for your rifle - with elastic loops and a zippered accessory pouch. This versatile pouch can hold five cartridges on the exterior while providing a padded cheek weld. Available in left- or right-handed models. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IccDKqWB--/szg7uekt77omohntgxtd.png',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ebe8e6b1-0bb3-451e-b5db-76478ab6ce9b',
		ProductID: '99113',
		ProductName: 'Hornady® Gun Cheek Piece Black LH',
		UPC: '090255991130',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '7',
		ShelfDepth: '12',
		Weight: '0.230',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '49.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made of tough, nylon Cordura®, this stock pad is the perfect accessory for your rifle - with elastic loops and a zippered accessory pouch. This versatile pouch can hold five cartridges on the exterior while providing a padded cheek weld. Available in left- or right-handed models. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IccDKqWB--/szg7uekt77omohntgxtd.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ed59126-59cd-44f9-b0a5-6f265e851242',
		ProductID: '99110',
		ProductName: 'Hornady® Gun Cheek Piece Tan RH',
		UPC: '090255991109',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '7',
		ShelfDepth: '12',
		Weight: '0.230',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '49.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made of tough, nylon Cordura®, this stock pad is the perfect accessory for your rifle - with elastic loops and a zippered accessory pouch. This versatile pouch can hold five cartridges on the exterior while providing a padded cheek weld. Available in left- or right-handed models. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IccDKqWB--/szg7uekt77omohntgxtd.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14dc3922-b852-467e-b7b1-28d175e1b702',
		ProductID: '99692XL',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255703092',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.620',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '64beb65e-86b5-4ab9-9947-7bbaf01223e8',
		ProductID: '99692L',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255703085',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b5583f20-0abf-43fd-aa31-0ef610c1a734',
		ProductID: '99692XXXL',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255717907',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '37279d83-22d0-42f3-851f-c5133f3f85f7',
		ProductID: '99692M',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255703078',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bbda7a76-892f-413b-a2b3-e1602ada3824',
		ProductID: '99692S',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255703061',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '50150e45-0df5-48d6-a116-1f04addbdd74',
		ProductID: '99692XXL',
		ProductName: 'Hornady® Solar Hoodie',
		UPC: '090255703108',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'COLUMBIA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Solar Performance Long Sleeve Hoody offers superior sun protection and performance qualities with the additional benefit of a comfortable hood to offer our highest level of cover from the Sun. Featuring UPF 50+ solar protection, the Solar Performance Long Sleeve is lightweight, comfortable, and sure to keep the sun’s rays from penetrating through to your skin. This fabric is powered by PURE-tech™ cool wicking technology. UPF 50+ sun protection. 100% polyester. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ld2oAZ8I--/rzzcnrchwgwndclcv15b.png',
		DateLastModified: '2023-12-16 09:09:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3373f00-4989-4d1b-a4d1-a62252c64046',
		ProductID: '99595L',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255717990',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b49f39a1-f1db-4c84-9eb8-e5ada5bc494e',
		ProductID: '99595XL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255718003',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a50d6b0-58de-4d5b-bfad-b7a45eaba03d',
		ProductID: '99595XXXL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255718027',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f4db634-ce8c-4ff9-a8fc-548ee56c37f0',
		ProductID: '99595XXXXL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255718034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f73198a-6c13-45db-80da-dbc796c170c7',
		ProductID: '99595M',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255717983',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a8a80fbc-0b90-47a5-b08a-a3e35633c825',
		ProductID: '99595XXL',
		ProductName: 'Hornady Gray Hoodie',
		UPC: '090255718010',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '12',
		ShelfDepth: '18',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Poly-cotton blend. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6w8vF5pd--/dn0mzrlc7ay5tjvwkxbv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c82cefa4-5f62-42ab-b74c-985cfe458f42',
		ProductID: '99731XXL',
		ProductName: 'Hornady® Red Polo',
		UPC: '090255706086',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Poly-cotton blend. Embroidered Hornady logo. Imported. Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8qQzE8PP--/gt1o7wna89eiqmxqpzxw.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ff0b3091-0f8d-4f0b-9cec-1bb50b8ab428',
		ProductID: '99731XL',
		ProductName: 'Hornady® Red Polo',
		UPC: '090255706079',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Poly-cotton blend. Embroidered Hornady logo. Imported. Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8qQzE8PP--/gt1o7wna89eiqmxqpzxw.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7715f8ef-f1be-4112-a25d-a93c6bc43ac9',
		ProductID: '99731XXXL',
		ProductName: 'Hornady® Red Polo',
		UPC: '090255706093',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '66.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Poly-cotton blend. Embroidered Hornady logo. Imported. Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8qQzE8PP--/gt1o7wna89eiqmxqpzxw.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df7f5aa2-f9b6-496a-900d-510cf425f8b6',
		ProductID: '99731L',
		ProductName: 'Hornady® Red Polo',
		UPC: '090255706062',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Poly-cotton blend. Embroidered Hornady logo. Imported. Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8qQzE8PP--/gt1o7wna89eiqmxqpzxw.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7b5891c-0f77-427b-9797-4a705575f4b7',
		ProductID: '99731M',
		ProductName: 'Hornady® Red Polo',
		UPC: '090255706055',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '63.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Poly-cotton blend. Embroidered Hornady logo. Imported. Poly-cotton blend. Embroidered Hornady logo. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8qQzE8PP--/gt1o7wna89eiqmxqpzxw.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8673199b-9e1e-4af6-8e30-e54d5ac4a304',
		ProductID: '9974L',
		ProductName: 'Hornady® Sage & Tan T-Shirt',
		UPC: '090255701166',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'100% cotton with subdued logo, perfect for hunting. Imported. Poly-cotton blend with subdued logo, perfect for hunting. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--z6Tzv5Yz--/bujvzcllcnsme6ngujqp.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '61fe2229-bc78-423c-ab7a-911f4204e64e',
		ProductID: '9974XXL',
		ProductName: 'Hornady® Sage & Tan T-Shirt',
		UPC: '090255701180',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '21.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'100% cotton with subdued logo, perfect for hunting. Imported. Poly-cotton blend with subdued logo, perfect for hunting. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--z6Tzv5Yz--/bujvzcllcnsme6ngujqp.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9baacaa-b46b-4139-a5af-fcfa0e78f2e7',
		ProductID: '9974XL',
		ProductName: 'Hornady® Sage & Tan T-Shirt',
		UPC: '090255701173',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'100% cotton with subdued logo, perfect for hunting. Imported. Poly-cotton blend with subdued logo, perfect for hunting. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--z6Tzv5Yz--/bujvzcllcnsme6ngujqp.png',
		DateLastModified: '2023-11-07 15:06:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa016550-1272-49d7-9906-5d4141f0a7e0',
		ProductID: '9974M',
		ProductName: 'Hornady® Sage & Tan T-Shirt',
		UPC: '090255701159',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'HONDURAS',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'100% cotton with subdued logo, perfect for hunting. Imported. Poly-cotton blend with subdued logo, perfect for hunting. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--z6Tzv5Yz--/bujvzcllcnsme6ngujqp.png',
		DateLastModified: '2023-12-16 09:09:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e74de8c-7664-4186-9521-fed4f0014550',
		ProductID: '99597XXL',
		ProductName: 'Performance 1/4 Zip',
		UPC: '090255721089',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '9',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front chest logo. 85/15 Polyester/Spandex; 155 gms, Performance Fabric. 1/4 zip neckline.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eT6aURQ1--/wwita1fy1kgcgbhfxjlh.jpg',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05daec5b-fcd1-4349-a50e-74e4a7ba3273',
		ProductID: '99597M',
		ProductName: 'Performance 1/4 Zip',
		UPC: '090255721058',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front chest logo. 85/15 Polyester/Spandex; 155 gms, Performance Fabric. 1/4 zip neckline.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eT6aURQ1--/wwita1fy1kgcgbhfxjlh.jpg',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e3806f9-689a-4671-9f09-d0430096cda5',
		ProductID: '99597XL',
		ProductName: 'Performance 1/4 Zip',
		UPC: '090255721072',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '12',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front chest logo. 85/15 Polyester/Spandex; 155 gms, Performance Fabric. 1/4 zip neckline.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eT6aURQ1--/wwita1fy1kgcgbhfxjlh.jpg',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '033239af-0264-4bfd-9ed5-a5eba5f7d7b4',
		ProductID: '99597XXXL',
		ProductName: 'Performance 1/4 Zip',
		UPC: '090255721096',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '9',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '10.000',
		CartonWidth: '9.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front chest logo. 85/15 Polyester/Spandex; 155 gms, Performance Fabric. 1/4 zip neckline.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eT6aURQ1--/wwita1fy1kgcgbhfxjlh.jpg',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2f08e1fb-c3d8-4b3a-90d8-3411a063a9e3',
		ProductID: '99597L',
		ProductName: 'Performance 1/4 Zip',
		UPC: '090255721065',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '10',
		ShelfDepth: '1',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Front chest logo. 85/15 Polyester/Spandex; 155 gms, Performance Fabric. 1/4 zip neckline.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eT6aURQ1--/wwita1fy1kgcgbhfxjlh.jpg',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ec88ad39-84f6-4369-a61f-d679109160ce',
		ProductID: '99594L',
		ProductName: 'American Flag T-Shirt',
		UPC: '090255717747',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'NICARAGUA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--szLT5Taw--/flo84s3cg9u2jvjtvemw.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2bcda4ef-a6ba-42ea-bd3f-88abfbf80a5f',
		ProductID: '99594XXL',
		ProductName: 'American Flag T-Shirt',
		UPC: '090255717761',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '21.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'NICARAGUA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--szLT5Taw--/flo84s3cg9u2jvjtvemw.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '716d3ed5-21fc-46bd-9cf9-ba73a54ed734',
		ProductID: '99594XXXL',
		ProductName: 'American Flag T-Shirt',
		UPC: '090255717778',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'NICARAGUA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--szLT5Taw--/flo84s3cg9u2jvjtvemw.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '62d1b99a-b16b-4815-94aa-2ed5bfac2162',
		ProductID: '99594M',
		ProductName: 'American Flag T-Shirt',
		UPC: '090255717730',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '8',
		ShelfDepth: '10',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'NICARAGUA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--szLT5Taw--/flo84s3cg9u2jvjtvemw.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd1e893fd-49a2-4aaf-ab1f-70680f2e58ac',
		ProductID: '99594XL',
		ProductName: 'American Flag T-Shirt',
		UPC: '090255717754',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '8',
		ShelfDepth: '10.5',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'NICARAGUA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--szLT5Taw--/flo84s3cg9u2jvjtvemw.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e66d84b-e701-49d8-a6bd-446e54b6d56a',
		ProductID: '9963B',
		ProductName: 'Lock-N-Load® Hornady® Target (100 Pack)',
		UPC: '090255199635',
		PackagedQTY: '100',
		PackagedUOM: 'EA',
		ShelfHeight: '12.375',
		ShelfWidth: '12.375',
		ShelfDepth: '1.25',
		Weight: '5.778',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '5.778',
		PalletQtyBoxes: '0',
		Retail: '78.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'TOP',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255299639',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Lock-N-Load® Targets feature a half-inch grid pattern and multiple aiming points. Vivid white bullet holes provide long-range visibility without binoculars or spotting scopes. Immediate feedback makes target practice fun and productive.',
		ProductImage: 'http://images.salsify.com/image/upload/s--cNF6asnK--/esoeg6mpq8nrxpculwp9.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e434e1ca-b5a6-4609-b31a-0cf9ea1b9b19',
		ProductID: '9963',
		ProductName: 'Lock-N-Load® Hornady® Target (10 Pack)',
		UPC: '090255299632',
		PackagedQTY: '10',
		PackagedUOM: 'EA',
		ShelfHeight: '12.375',
		ShelfWidth: '12.375',
		ShelfDepth: '0.125',
		Weight: '0.570',
		WeightUOM: 'LB',
		CaseQty: '12',
		CartonUCC: '10090255299639',
		CartonHeight: '10.875',
		CartonWidth: '4.250',
		CartonDepth: '10.875',
		CartonWeight: '6.84',
		PalletQtyBoxes: '1800',
		Retail: '10.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackUCC: '10090255299639',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Lock-N-Load® Targets feature a half-inch grid pattern and multiple aiming points. Vivid white bullet holes provide long-range visibility without binoculars or spotting scopes. Immediate feedback makes target practice fun and productive.',
		ProductImage: 'http://images.salsify.com/image/upload/s--cNF6asnK--/esoeg6mpq8nrxpculwp9.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22de46b3-1ec0-41d6-b292-0022cfd259b9',
		ProductID: '397111',
		ProductName: 'Seating Stem 30 Cal ELD® Match™ 225 Gr',
		UPC: '090255971118',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971115',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b1b90c6c-d627-46cd-a254-8d77d4580d36',
		ProductID: '6010',
		ProductName: '36 Cal .350 Lead Balls',
		UPC: '090255260106',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.994',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255260103',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.76',
		PalletQtyBoxes: '1440',
		Retail: '12.57',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '36 CAL',
		BulletDiameter: '0.35',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f342cd00-9138-408e-81d7-88422f87c987',
		ProductID: '594287',
		ProductName: 'Match™ Grade Bushing .287',
		UPC: '090255592870',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592877',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.287',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mQUqISPH--/7df70b3b0e1f394e723ed8871f79711fb3a3fa9a.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce8de3fd-75c5-4732-ac56-50acce232fa0',
		ProductID: '2453',
		ProductName: '6mm .243 100 gr InterLock® BTSP',
		UPC: '090255224535',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.517',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224532',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.925',
		PalletQtyBoxes: '900',
		Retail: '40.25',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.405',
		SectionalDensity: '0.242',
		OAL: '1.08',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--99AOeIHn--/7cf1bdf272502a8d6ad51f3ae8a0a9f56d77b46a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81359e5c-c690-4872-a96d-78186251dbdd',
		ProductID: '380068',
		ProductName: 'Case Neck Brush 35 Cal',
		UPC: '090255800685',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800682',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '35 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with the Lock-N-Load® Case Prep Trio, Case Prep Duo, Lock-N-Load® Power Case Prep Center, and Quick Change Hand Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--golXaAf5--/dwplg7kijzopdd7r2ywp.png',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '55078f56-cd87-486e-abea-fb2343c66078',
		ProductID: '9148',
		ProductName: '454 Casull 240 gr XTP® Mag',
		UPC: '090255391480',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391487',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '12.5',
		PalletQtyBoxes: '1120',
		Retail: '55.85',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.16',
		MuzzleVelocity: '1900',
		MuzzleEnergy: '1924',
		SectionalDensity: '0.168',
		Cartridge: '454 CASULL',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '240',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2E-j5u2g--/ff983c41e2a5f3acb96a5a46c0c48e8153a16d35.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0aa43199-e012-4c62-954a-b996ce3ada2c',
		ProductID: '98000',
		ProductName: 'Hornady® Law Enforcement Sticker',
		UPC: '090255980004',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '4',
		ShelfDepth: '5.5',
		Weight: '0.001',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980001',
		CartonHeight: '0.750',
		CartonWidth: '4.000',
		CartonDepth: '5.500',
		CartonWeight: '0.1',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Black and red. Measures 3.125"x4.625"',
		ProductImage: 'http://images.salsify.com/image/upload/s--049zmPGI--/ky7hyqcmtcupoh9b94m3.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af976b85-cf9e-4edf-9f58-bfeaabe86d1b',
		ProductID: '390543',
		ProductName: 'Shell Holder #3',
		UPC: '090255905434',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905431',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ab16c6b9-81e1-4d41-9af5-9ffb9d0abc7f',
		ProductID: '33202',
		ProductName: '338 Cal .338 225 gr SST®',
		UPC: '090255332025',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.405',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255332022',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.075',
		PalletQtyBoxes: '540',
		Retail: '69.65',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.515',
		SectionalDensity: '0.281',
		OAL: '1.436',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SST®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--n1PAGsgH--/d89b4db79933b73c913211f8f356f94c68399a6e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2e8a6208-f4a5-4ae0-b45a-577b6b5810e5',
		ProductID: '99116',
		ProductName: 'Hornady® Tan Ammo Pouch',
		UPC: '090255991161',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '4',
		ShelfDepth: '4',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'In working with our friends at TUFF® products, we offer a simple ammunition pouch for those who want to keep several cartridges on hand and want the flexibility to have them readily available. With Velcro® closure, the pouch includes 10 elastic loops and an interior pocket. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--EjJYw4Ol--/wa1jkb8ilbuwrpabjg7e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cfn1RN5J--/kg7fcv5rvinvfcjprsco.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '840fa96f-6516-4f3a-9cf7-4c726d7f4cd7',
		ProductID: '99129',
		ProductName: 'Hornady® Belt Buckle',
		UPC: '090255991291',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4',
		ShelfDepth: '6',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '0.00',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Cast in antique pewter with raised and recessed relief, this rectangular buckle with rounded corners features the Hornady® logo and slogan, “Accurate. Deadly. Dependable.” Designed to fit belts that are 1½" wide, the buckle measures 4"x3" and can be kept clean by polishing with a damp cloth. Packaged in a black gift box. Made in U.S.A.',
		ProductImage: 'http://images.salsify.com/image/upload/s--xDR3TwMM--/se5ua1ybizbbl5i2q2jx.jpg',
		DateLastModified: '2023-11-07 15:06:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14f18021-19cc-401d-92ec-e8760f99ed0b',
		ProductID: '041224',
		ProductName: 'Lock-N-Load® Neck Turn Tool',
		UPC: '090255412246',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '13',
		ShelfDepth: '4.75',
		Weight: '3.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '6.250',
		CartonWidth: '4.750',
		CartonDepth: '13.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '210.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady® Neck Turn Tool saves handloaders time and effort at the workbench.   Designed for use on a wide variety of case lengths, the Hornady® Neck Turn tool allows for the use of a drill (not included) to make neck turning faster and easier, while providing superior consistency and surface finish.  An adjustment knob enables the user to choose detents for .0005" adjustment increments, or no detents for infinite adjustment.  Mandrels for four popular calibers are included:  22 Cal. 6mm 6.5mm 30 Cal. The Hornady® Neck Turn tool is a winning solution for precision handloaders who want to maximize accuracy. Mandrels for four popular calibers are included:  22 Cal. 6mm 6.5mm 30 Cal. The Hornady® Neck Turn tool is a winning solution for precision handloaders who want to maximize accuracy.',
		ProductImage: 'http://images.salsify.com/image/upload/s--UmiQjWmu--/qrsombrbbftouuabiqpq.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--tnBWs8wY--/pas1xfpyytfk2kwbihss.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--oivWDbg7--/b6yyk5efwnzc43nan9kt.jpg',
		Videos: 'https://vimeo.com/182566229',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4f0fe927-fc80-45f1-8870-2fbf868884d1',
		ProductID: '390955',
		ProductName: 'Trimer Pilot #13 .338',
		UPC: '090255909555',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909552',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--1RijhDHL--/poh7o5hu9w9vjqvvux56.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '148cf12f-8527-4a88-8150-d15cfa6abdf7',
		ProductID: '805514',
		ProductName: '7mm WSM 150 gr. CX™ Outfitter®',
		UPC: '090255719826',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.515',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719823',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.15',
		PalletQtyBoxes: '930',
		Retail: '77.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.455',
		MuzzleVelocity: '3050',
		MuzzleEnergy: '3098',
		SectionalDensity: '0.266',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--RBWyxYYI--/agel4sekfr77egol5gbs.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '248a9571-8e8b-4a9c-b824-d7c58214536d',
		ProductID: '82041',
		ProductName: '300 Win Mag 178 gr ELD-X Precision Hunter',
		UPC: '090255820416',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820413',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.0',
		PalletQtyBoxes: '780',
		Retail: '75.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.552',
		G7BC: '0.278',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3463',
		SectionalDensity: '0.268',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential. Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range. INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--kilyFcQ8--/cn9t4l8h47ozcbpxwob6.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		Videos3: 'https://vimeo.com/367350096',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7931675a-b246-4fc4-af2d-7a09e94abdb4',
		ProductID: '67132',
		ProductName: '45 Cal Sabot with 40 Cal 200 gr SST® ML Bullet',
		UPC: '090255671322',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '5',
		ShelfWidth: '3.325',
		ShelfDepth: '1.5',
		Weight: '0.793',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255671329',
		CartonHeight: '5.500',
		CartonWidth: '7.687',
		CartonDepth: '8.000',
		CartonWeight: '7.93',
		PalletQtyBoxes: '900',
		Retail: '20.87',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Muzzleloading Sabots With Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.265',
		MuzzleVelocity: '2325',
		MuzzleEnergy: '2400',
		SectionalDensity: '0.179',
		Caliber: '45 CAL',
		BulletDiameter: '0.4',
		BulletName: 'SST® ML™',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Sabot: 'Low Drag™ Sabot',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The SST®-ML™ is a phenomenal muzzleloading option and an excellent choice for long range blackpowder hunters.  Other "easy-load" bullets often fail to properly engage the rifling, which does not effectively stabilize the bullet and, as a result, accuracy suffers. But Hornady® sabots fully engage the rifling to keep the SST®-ML™ centered and sealed during firing, allowing for maximum velocity and unparalleled long range performance. Upon impact, the Flex Tip® is compressed into the front of the bullet, causing the bullet to expand. The speed sabot features a fumble-free method of pre-loading pellets. PATENTED FLEX TIP® Flex Tip® design delivers devastating terminal performance at all ranges.  SURGICAL ACCURACY 200+ yard performance.  50% EASIER TO LOAD Much easier to load than conventional sabots.  HIGH PERFORMANCE Hornady® sabots deliver the highest velocities and the flattest trajectories on the market.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--BsJnxEX8--/cczgz8mfgfrpjstjnc6h.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--g8x5xI-h--/q066jq8o0bqaxfvtdbnh.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--mMbZLAfe--/nziuerdzggz33veox2fx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--okgNKDv1--/dioawok6l2ic7hilblrb.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ysYD2PFR--/hkgl0m8r2oydf28a0arl.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f53b3170-9472-4a31-aec5-a715b35b7669',
		ProductID: '98015',
		ProductName: 'Hornady® Stop Sign Sticker',
		UPC: '090255980158',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '3.75',
		ShelfDepth: '4.25',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980155',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red and white. Measures 3.5"x3.5"',
		ProductImage: 'http://images.salsify.com/image/upload/s--HDMsq6Qy--/v33gtt9qs4cp3lcmi5lo.pdf',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66ed5f72-a04e-4ddd-98fe-0bd9903431a3',
		ProductID: 'AB1',
		ProductName: 'Lock-N-Load® Anvil Base Kit',
		UPC: '090255704396',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.500',
		ShelfWidth: '1.750',
		ShelfDepth: '1.000',
		Weight: '0.070',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704393',
		CartonHeight: '10.000',
		CartonWidth: '5.500',
		CartonDepth: '1.500',
		CartonWeight: '0.7',
		PalletQtyBoxes: '0',
		Retail: '19.53',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The anvil attaches to the opposite blade of your caliper when utilizing the Hornady® Lock-N-Load® Headspace Comparator, supplying a large surface area for case heads and bullets to rest, making ogive and headspace measurements easier to obtain.',
		ProductImage: 'http://images.salsify.com/image/upload/s--OmLFon0w--/b9arjmcxg1mt88uu7rjn.jpg',
		DateLastModified: '2024-02-21 14:49:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '924e7cdb-c139-4f0e-9301-4dfacdd49d8b',
		ProductID: '380713',
		ProductName: 'Cartridge Gauge 7mm Rem Mag (.284)',
		UPC: '090255807134',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807131',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9c457d0f-0cb7-47d9-8e7b-70eced35ffa7',
		ProductID: '044148',
		ProductName: 'Seater Die (.430) 44 Cal',
		UPC: '090255441482',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.552',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441489',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2bec10ec-d56b-4735-a43b-7d3718d476d0',
		ProductID: '390611',
		ProductName: 'Shell Holder #56',
		UPC: '090255906110',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.875',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906117',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31a67a79-1019-43ab-aa7b-c16329bfdafa',
		ProductID: '046593',
		ProductName: 'Full-Length Size Die 338 Lapua (.338)',
		UPC: '090255465938',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465935',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da75fe1a-eed5-4c63-b426-1ba9df48a403',
		ProductID: 'B270W',
		ProductName: 'Lock-N-Load® 270 WSM Modified Case',
		UPC: '090255704495',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704492',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '7.97',
		ParentCategory: 'Reloading',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f863b54-81d7-40cb-80fa-a1f16f77c39a',
		ProductID: '35745',
		ProductName: '38 Cal .357 140 gr FTX® (357 Mag)',
		UPC: '090255357455',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.151',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255357452',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.265',
		PalletQtyBoxes: '540',
		Retail: '48.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.16',
		SectionalDensity: '0.157',
		OAL: '0.795',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FTX®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--A1uSTbim--/bba91b28ec2ebd7944eb3d42a657a4d867ae8ce5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PNTdUz9t--/e226f08a47d436f1ecf82fedab07e4ad381f6b87.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--csJYg2SQ--/ztizvbercxtbpusbiwpc.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--24GgDB-4--/edtuxtcb7em33ffll97b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--8-IEe1-j--/r5kb2qjrxsdb1z7mb8yx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--R_KlzV4v--/bp4lzykm2ykrixjfdi8i.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--5-gi86pN--/fleuiowjusbv8rzydx3v.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3d59e8e6-4b63-42e4-adf5-e2c6777e8f31',
		ProductID: '390556',
		ProductName: 'Shell Holder #16',
		UPC: '090255905564',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.047',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905561',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.47',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1cbb6a2a-746d-4d4d-9217-550c486aca37',
		ProductID: '043356',
		ProductName: 'One Shot® Cartridge Cleaning Solution - Gallon',
		UPC: '090255433562',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '7',
		ShelfDepth: '4.25',
		Weight: '9.600',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255433569',
		CartonHeight: '12.750',
		CartonWidth: '14.750',
		CartonDepth: '13.500',
		CartonWeight: '57.6',
		PalletQtyBoxes: '0',
		Retail: '104.88',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'DIETHANOLAMINE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Jug',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Non-toxic and uniquely formulated to clean brass cases. Quickly removes most tarnish, oxidation and carbon buildup. Designed specifically for the Hornady® Lock-N-Load® Sonic Cleaners™ or stainless steel tumblers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--zXFFQ8Pz--/mcdsazidmznmk2txwt6e.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8753fc47-6720-4e7f-b2f4-40b4fdaef08b',
		ProductID: '425',
		ProductName: 'Lock-N-Load® 25 Insert (.257 Cal)',
		UPC: '090255704228',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704225',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--EMu6ENyW--/flusu2epavbmjpemwc45.png',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f985fde5-6962-464f-bc8d-63c9bda7a580',
		ProductID: '546266',
		ProductName: 'Full-Length 2-Die Set 25/35 Win (.257)',
		UPC: '090255562668',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.489',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562665',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.445',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '25-35 WIN',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f985a97a-7705-4a43-b5b7-2121ad0687df',
		ProductID: 'A35',
		ProductName: 'Lock-N-Load® 35 Whelen Modified Case',
		UPC: '090255704655',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.032',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704652',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.32',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '35 WHELEN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--flC7MemD--/c81d073181fe623ca3f65beb4a49cdd932a1a533.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05db3c3b-418c-4f14-b749-3d61fd7310b0',
		ProductID: '75413',
		ProductName: 'SnapSafe® Light Grey In-Wall Safe',
		UPC: '842631100649',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '17.25',
		ShelfWidth: '23.25',
		ShelfDepth: '5.75',
		Weight: '33.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '33.0',
		PalletQtyBoxes: '0',
		Retail: '287.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Auxiliary Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '22',
		ProductExtWidth: '16.25',
		ProductExtDepth: '4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Easy to hide and easy to access — everywhere you want it! These In-Wall Safes install between wall studs within minutes using the included lag bolts Innovative latch mechanism maximizes useable interior space. • Heavy-duty 16 gauge steel body construction and 8 gauge steel door. • Electronic lock with key backup. • Light grey durable powder coated finish. • Ability to orient as left or right opening by simply rotating 180 degrees. • Removeable storage shelves. • Audio and LED visual warning light when battery is running low. • Magnetic jewelry/key hooks, and magnetic document holder. • Includes picture frame hook for easy concealment. • Spring assist door. • 4 AA Batteries (not Included). 16.3"W x 22"H x 4"D Weight: 36 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--LsR7yapD--/litnliwjlje2qjmazay1.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--PE3PHM1w--/dh3ypcz71sje1ry6niie.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--XmKZLp86--/unwh6oqjqsg88d1j9gzk.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--SnSgqZ40--/evhzxpdcmu0qw9zjugr7.png',
		Videos: 'https://vimeo.com/659016450',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e516e02-8108-4e0b-8e10-ba537b19221f',
		ProductID: '90062',
		ProductName: '32 Auto 60 gr XTP®',
		UPC: '090255900620',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.463',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900627',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '4.63',
		PalletQtyBoxes: '1120',
		Retail: '35.01',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.09',
		MuzzleVelocity: '1000',
		MuzzleEnergy: '133',
		SectionalDensity: '0.089',
		Cartridge: '32 AUTO',
		Caliber: '32 CAL',
		BulletDiameter: '0.311',
		BulletName: 'XTP®',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NTWFE7dc--/65814a275ac200d9f15c0c9e45c34bb8755572fd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '329d7aae-83a5-4233-ac1a-db2665da8c85',
		ProductID: '390951',
		ProductName: 'Trimer Pilot #9 .308',
		UPC: '090255909517',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909514',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gVsRKbBp--/ihwckl6f8mlwfyqxg3yz.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ac6afc07-a3ac-4055-862d-dd6e5ae46a11',
		ProductID: '75873',
		ProductName: 'Snapsafe® Handgun Hangers .357 (4 Pack)',
		UPC: '851529004495',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '5',
		ShelfDepth: '2',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004492',
		CartonHeight: '13.500',
		CartonWidth: '5.000',
		CartonDepth: '7.000',
		CartonWeight: '8.0',
		PalletQtyBoxes: '1025',
		Retail: '20.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004496',
		MasterPackHeight: '7.500',
		MasterPackWidth: '14.000',
		MasterPackDepth: '26.000',
		MasterPackWeight: '40.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--rDkxQkqw--/bt1jmscxg5ooypwszqio.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--TDoVbuBV--/snaqr50pytuerojyemae.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--7AGtLsZT--/fj1b37qvubjwll7qbmti.jpg',
		Videos: 'https://vimeo.com/213867180',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c2f19901-6970-4bea-9f4a-9a3ba0c0e714',
		ProductID: '2620',
		ProductName: '6.5mm .264 129 gr SP',
		UPC: '090255226201',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.946',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255226208',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '48.65',
		PalletQtyBoxes: '900',
		Retail: '47.81',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.445',
		SectionalDensity: '0.264',
		OAL: '1.173',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '129',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--D6Thwzg8--/855475e411ade41aa3fb2efc93c55798d04e4c16.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '183f1716-77fa-495f-a1ac-4b853479856c',
		ProductID: '390578',
		ProductName: 'Shell Holder #38',
		UPC: '090255905786',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905783',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4d107fa1-acaa-4a2f-bc7d-a95b22a708db',
		ProductID: '6120',
		ProductName: '58 Cal .570 Lead Balls',
		UPC: '090255261202',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.101',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255261209',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.525',
		PalletQtyBoxes: '900',
		Retail: '14.24',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '58 CAL',
		BulletDiameter: '0.57',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89f92ab2-0e17-456d-bff4-2485ce79925f',
		ProductID: 'A6MMC',
		ProductName: 'Lock-N-Load® 6mm Creedmoor Modified Case',
		UPC: '090255709971',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255709978',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iH8TFAYx--/4f20cfc32fcfe9f210924f14cf411d272fb79b69.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6828f4d9-1340-4eee-8572-cd7eeaca1441',
		ProductID: '390950',
		ProductName: 'Trimer Pilot #8 .300',
		UPC: '090255909500',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.019',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909507',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.19',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.3',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--tAfkCZ5---/lghf7f8l4tlkpdfjlqmf.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1fff73dd-a1d9-471c-8d9f-c9819d4c1e90',
		ProductID: '095350',
		ProductName: 'Lock-N-Load® Bullet Tube 9mm',
		UPC: '090255953503',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '22',
		ShelfWidth: '5',
		ShelfDepth: '1',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '22.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Lock-N-Load® Bullet Tubes for pistol bullets provide a handy, economical way to utilize bullet feeder dies on progressive presses without the complete bullet feeder hopper system. Tubes fit 40+ bullets depending on caliber and weight, and feature a window revealing when quantities are low. Sold in 3-packs.',
		ProductImage: 'http://images.salsify.com/image/upload/s--aoMN8a7F--/cdqyw15buoor2qqfkpii.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c82876d-954e-4323-9354-2e9c7b811fc4',
		ProductID: '046595',
		ProductName: 'Full-Length Size Die 338 Federal (.338)',
		UPC: '090255465952',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465959',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '338 FEDERAL',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cf312b81-016a-4c9e-83cd-2030f360cc5c',
		ProductID: 'A65G',
		ProductName: 'Lock-N-Load® 6.5 Grendel Modified Case',
		UPC: '090255704921',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704928',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XTEor2rQ--/bb376e2040bb99ab3c615a5eaeb0709226516bf9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '87e18268-91eb-459b-a781-75129e1036c8',
		ProductID: '30302',
		ProductName: '30 Cal .308 150 gr SST®',
		UPC: '090255230307',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.296',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230304',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.44',
		PalletQtyBoxes: '540',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		SectionalDensity: '0.226',
		OAL: '1.2',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IwOnLaFR--/2e7d37c1213f63307e2f62938607e2c9eee6eb89.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be72980d-44f1-459c-a38e-07b994f16d30',
		ProductID: '544247',
		ProductName: 'Match™ Grade 2-Die Set 6mm Creedmoor (.243)',
		UPC: '090255542479',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542476',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.8',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '34692cbe-e7a2-46c0-bd4f-68719beb9e06',
		ProductID: '190118',
		ProductName: 'Shot Bushing 7/8 oz',
		UPC: '090255191189',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.071',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191186',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.71',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ab4f9b7-35ab-48d0-b029-274fde4e6593',
		ProductID: '822034',
		ProductName: '300 Winchester Short Magnum 180 gr CX™ Outfitter',
		UPC: '090255719864',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719861',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.95',
		PalletQtyBoxes: '930',
		Retail: '77.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.469',
		MuzzleVelocity: '2900',
		MuzzleEnergy: '3361',
		SectionalDensity: '0.271',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Pyw-Ww_3--/h8mmcntb4sed6h0omhvq.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1370b9ef-fad8-4436-984e-f44659553a1b',
		ProductID: '86243',
		ProductName: '12 GA Varmint Express® #4 Buckshot',
		UPC: '090255862430',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.625',
		ShelfDepth: '4',
		Weight: '1.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862437',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '10.44',
		PalletQtyBoxes: '1120',
		Retail: '22.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppCoyote',
		MuzzleVelocity: '1350',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#4',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Specially loaded to ensure proper functioning in semi-auto and pump shotguns, Hornady® #4 Buckshot provides consistent performance due to our Versatite® wad technology that delivers tight patterns without modification to your gun. RELIABLE FUNCTIONING Specially loaded to ensure proper functioning in semi-auto and pump shotguns.  24 Pellets 2¾" 1350 fps CONSISTENT PERFORMANCE Our Versatite® wad technology delivers tight patterns every single time without modification to your gun.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s---qrUzaCF--/lwuu2rxwl8ggrob0dhje.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--4Mv_5Tp---/iw51omfs3pgepycjr8d9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sNLTJutl--/ndp6oeajg932ohqg15aa.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c10ab79-826d-4e58-9768-bc525fa85908',
		ProductID: '86841',
		ProductName: '348 Winchester Unprimed Cases',
		UPC: '090255868418',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.890',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868415',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '4.45',
		PalletQtyBoxes: '400',
		Retail: '71.07',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '348 WIN',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '67070096-016f-4537-837f-72b502391bec',
		ProductID: '392161',
		ProductName: 'Collet #8 .321/.323 Cal',
		UPC: '090255921618',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921615',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '32 CAL/8MM',
		BulletDiameter: '0.321/0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mv1at-gg--/43a4fdba5c81cf98d667fcc6afdaa0e55c202dcb.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f6cdb09-4f94-4309-b50f-621ebe9452a7',
		ProductID: '26178',
		ProductName: '6.5mm .264 130 gr CX™',
		UPC: '090255261783',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.032',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255261780',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '25.8',
		PalletQtyBoxes: '900',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.489',
		G7BC: '.266',
		MinTwist: '1-8"',
		SectionalDensity: '0.266',
		OAL: '1.465',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'CX™',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--BczMhsfg--/rctpjjx8jkfjyfymzdf8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6b402d31-8703-4f37-a531-20c2a07e3760',
		ProductID: '050094',
		ProductName: 'Cam Lock™',
		UPC: '090255500943',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.316',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500940',
		CartonHeight: '7.000',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '3.16',
		PalletQtyBoxes: '1000',
		Retail: '32.61',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--sGikfk4e--/xmtoxaonb0plnhlxywg4.png',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a0e5238b-efca-499a-a9fa-fc8c0349fea1',
		ProductID: '050142',
		ProductName: 'ID, OD & Trim 3-Way Cutter',
		UPC: '090255501421',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501428',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.5',
		PalletQtyBoxes: '2000',
		Retail: '49.12',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '100',
		MasterPackUCC: '30090255501422',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '15.0',
		ProductDescription:
			'Trim, chamfer and deburr cartridge cases - all in one step. Four custom interchangeable caliber-specific pilots have shoulders for easy setting of interior diameter (ID)_ and outside diameter (OD) cutters. ID cutter with 15 degree blade and OD butter with 30 -degree blade are made of carbide for strength and durability. Just attach to your Hornady trimmer to begin trimming.',
		ProductImage: 'http://images.salsify.com/image/upload/s--B7WVksBA--/jbe7fin6siopty3tcehf.png',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd28f3f17-0fdc-40d5-bbd9-019fe98b15f1',
		ProductID: '8273',
		ProductName: '307 Win 160 gr FTX® LEVERevolution®',
		UPC: '090255382730',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.210',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382737',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.1',
		PalletQtyBoxes: '1400',
		Retail: '56.40',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.33',
		SectionalDensity: '0.241',
		Cartridge: '307 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '160',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Yb6TYkqe--/f542aae051313f7c3b971bd161021724dd20f449.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '909cc919-50d1-4f79-b2af-8a0f0e68716c',
		ProductID: '82741',
		ProductName: '45-70 Government 250 gr MonoFlex® LEVERevolution®',
		UPC: '090255827415',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827412',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '17.0',
		PalletQtyBoxes: '930',
		Retail: '73.37',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.175',
		MuzzleVelocity: '2025',
		MuzzleEnergy: '2276',
		SectionalDensity: '0.17',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ypzjm-rK--/a1d73e497d75e9260f25a39cef964cb855288e45.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '665e9aea-4576-45d5-9cdd-ab350d452433',
		ProductID: '046343',
		ProductName: 'Full-Length Size Die 30/30 Win (.308)',
		UPC: '090255463439',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.514',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463436',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60a1a907-9ea9-4a34-b6db-b43385a9c75d',
		ProductID: '22791',
		ProductName: '22 Cal .224 75 gr ELD® Match',
		UPC: '090255227918',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.160',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227915',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.0',
		PalletQtyBoxes: '900',
		Retail: '39.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.467',
		G7BC: '0.235',
		MinTwist: '1-8"',
		SectionalDensity: '0.214',
		OAL: '1.111',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Vy9ZpgFi--/032b988ba96f24d69dc8f52787bccd5447b77366.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d7de335-62b8-47c8-bfc8-8ba9be6455e6',
		ProductID: '8628',
		ProductName: '6.5mm-284 Unprimed Cases',
		UPC: '090255486285',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.673',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486282',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.365',
		PalletQtyBoxes: '200',
		Retail: '103.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.5-284 (NORMA)',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14a3d2c3-6727-4bf1-b125-8fd6a3b7903e',
		ProductID: '99211',
		ProductName: 'Hornady® Black Cap',
		UPC: '090255992113',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--0s4y3DBk--/xmexzna3o1ungkrxzzlm.png',
		DateLastModified: '2024-01-30 09:36:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4ceafe0-69af-4caf-ab01-4a74c41cf7dc',
		ProductID: '380709',
		ProductName: 'Cartridge Gauge 243 Win (.243)',
		UPC: '090255807097',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807094',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '178ca5f7-fb00-4546-aa60-c9379cb8c402',
		ProductID: '046510',
		ProductName: 'Size Die 327 Fed/32 S&W/H&R (.311)',
		UPC: '090255465105',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.470',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465102',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Three-Die Handgun Die Sets',
		Cartridge: '32 S&W LONG/32 H&R MAG/32 FEDERAL MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6af9e42b-d5ac-421c-a9df-b1f91a9404e2',
		ProductID: 'A330',
		ProductName: 'Lock-N-Load® Headspace Bushing .330',
		UPC: '090255704235',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.146',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704232',
		CartonHeight: '4.750',
		CartonWidth: '10.500',
		CartonDepth: '7.250',
		CartonWeight: '1.46',
		PalletQtyBoxes: '0',
		Retail: '10.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		Caliber: '33 CAL',
		BulletDiameter: '0.33',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. Bushing only. Works with Headspace Gauge, sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VFSOFiSc--/jrryvcxrj7b7lor5idtf.jpg',
		Videos: 'https://vimeo.com/288805295',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9326747-2957-4111-a416-f23a335dddeb',
		ProductID: '8237',
		ProductName: '376 Steyr 270 gr InterLock® SP-RP Dangerous Game™ Series',
		UPC: '090255382372',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.803',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382379',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '10.818',
		PalletQtyBoxes: '396',
		Retail: '116.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.38',
		MuzzleVelocity: '2600',
		MuzzleEnergy: '4052',
		SectionalDensity: '0.274',
		Cartridge: '376 STEYR',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '270',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--BfOiqidL--/b1a8aefbf260d147bf930de2881acdd5809cc11a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a817ab1b-3b04-4013-a74c-ae8f3adf97b2',
		ProductID: '2836',
		ProductName: '7mm .284 166 gr A-TIP Match',
		UPC: '090255228366',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '2.770',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255228363',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '27.7',
		PalletQtyBoxes: '240',
		Retail: '116.75',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '.664',
		G7BC: '.332',
		MinTwist: '1-9.25"',
		SectionalDensity: '0.294',
		OAL: '1.495',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '166',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ybMNRrOo--/dtiw5lq7avzygrdiadko.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6220936f-7d94-45f3-b304-d4cc012f13b7',
		ProductID: '050008',
		ProductName: 'Fast Load Powder Measure Stand',
		UPC: '090255500080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '7.5',
		ShelfDepth: '6.5',
		Weight: '1.310',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500087',
		CartonHeight: '10.000',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '13.1',
		PalletQtyBoxes: '0',
		Retail: '54.61',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Features a rigid frame and extra long arm that lets you fill an entire 50-count Universal Loading Block. The Lock-N-Load® bushing system accommodates any measure with 7⁄8”–14 thread.',
		ProductImage: 'http://images.salsify.com/image/upload/s--GdY-DDGa--/fwvcriaqysffd76sbkqk.jpg',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c9cb19a5-aa9b-4e44-8550-1d398762fc94',
		ProductID: '82667',
		ProductName: '416 Ruger 400 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255826678',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.350',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826675',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '14.1',
		PalletQtyBoxes: '396',
		Retail: '157.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2400',
		MuzzleEnergy: '5115',
		SectionalDensity: '0.33',
		Cartridge: '416 RUGER',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lhf_0-FR--/e612a9eaf4ceb4e7c086740962d7170daf98e1e6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a27631c-d287-43b8-8f97-b50ab47051db',
		ProductID: '544371',
		ProductName: 'Match™ Grade 2-Die Set 300 Norma Mag (.308)',
		UPC: '090255543711',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.620',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543718',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '8.1',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '300 NORMA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4ba95ae-dd7d-4e25-a058-6ed25c314ce2',
		ProductID: '046287',
		ProductName: 'Full-Length Size Die 6.5X68 (.264)',
		UPC: '090255462876',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462873',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X68',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a897381e-a0c8-447b-aadd-0a0fffd8a0a7',
		ProductID: '020043',
		ProductName: 'Case Lube Pad & Loading Tray',
		UPC: '090255020434',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '3.5',
		ShelfDepth: '1.25',
		Weight: '0.377',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255020431',
		CartonHeight: '6.750',
		CartonWidth: '8.000',
		CartonDepth: '7.250',
		CartonWeight: '3.77',
		PalletQtyBoxes: '0',
		Retail: '28.73',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lubes, Cleaners & Polishes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The lid pops off to reveal a universal loading tray and a case Lube pad. Apply sizing lubrication to the pad, and then roll cases over the pad.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NzUfI15Y--/tsqedozupebtueooz1oc.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4f14389a-cae1-4222-ae7f-6c7b377c47ed',
		ProductID: '392627',
		ProductName: 'Shellplate #27 Lock-N-Load®AP™ & Projector',
		UPC: '090255926279',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.565',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926276',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.65',
		PalletQtyBoxes: '0',
		Retail: '53.33',
		ParentCategory: 'Reloading',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a486ee3-5c90-4123-8217-92cc828b9bf9',
		ProductID: '26202',
		ProductName: '6.5mm .264 129 gr SST®',
		UPC: '090255262025',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.991',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255262022',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.865',
		PalletQtyBoxes: '540',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.485',
		SectionalDensity: '0.264',
		OAL: '1.326',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '129',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vmrlK1gK--/c580cdcd9193c39f1d9590a23493c68fd1719f1b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ac42852f-8951-4432-b3f4-416332242eb4',
		ProductID: '99121',
		ProductName: 'Hornady® Bino Harness',
		UPC: '090255991215',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '10',
		ShelfDepth: '13.5',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '31.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'MEXICO',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for comfort and flexibility, this harness distributes the weight of your binoculars over the four elastic straps and form-fitting X panel, alleviating neck pain. Easy to put on and take off, the X panel on the back features an imprinted Hornady® logo.',
		ProductImage: 'http://images.salsify.com/image/upload/s--SYCV8ZdG--/z7wjs24ah37uat1yiilc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--z_CICgWd--/y3ulzxcjbeqs7uujn1rz.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '79e1ff16-5aa0-4fe5-a47d-b5b9e1d49cde',
		ProductID: '095345',
		ProductName: 'Lock-N-Load® AP™ Rifle Bullet Feeder 30 Cal Conversion Kit',
		UPC: '090255953459',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.5',
		ShelfWidth: '10.5',
		ShelfDepth: '4',
		Weight: '3.800',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '10.500',
		CartonWidth: '10.500',
		CartonDepth: '4.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '237.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Caliber: '30 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--uVVq50FN--/lak7qv0trgk2viyto7o4.pdf',
		ProductDescription:
			'The 30 caliber conversion kit will accommodate cartridge sizes from 300 Savage through 300 Rem Ultra Mag.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Z-OVGJDW--/zwoc7htub79mwt9ouzhu.png',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ae9ec11-488b-4afe-855d-202150ccca25',
		ProductID: '046066',
		ProductName: 'Neck Size Die 22 Cal Short (.224)',
		UPC: '090255460667',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.516',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460664',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9b3d8a1c-ba18-4f1f-9998-bfc80ebeca5e',
		ProductID: '546386',
		ProductName: 'Full-Length 2-Die Set 8.15X46R (.337)',
		UPC: '090255563863',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563860',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '8.15X46R',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1ed50c52-8315-43ce-a25f-7fc462576f18',
		ProductID: 'A8X57',
		ProductName: 'Lock-N-Load® 8X57mm Mauser Modified Case',
		UPC: '090255704273',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.028',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704270',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.28',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '8X57 JS',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZD5jWNbD--/3e6e84480530ba4b6d437ff90bc3d74812591d8f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a73f01a2-986d-4833-9314-b68467a28e30',
		ProductID: '546283',
		ProductName: 'Full-Length 2-Die Set 6.5-300 Wby Mag (.264',
		UPC: '090255562835',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562832',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6.5-300 WBY MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f305a542-4783-45cc-b206-922ff2ca4082',
		ProductID: '586050',
		ProductName: 'Powder Funnel 22-45 Cal',
		UPC: '090255860504',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.75',
		ShelfWidth: '2.625',
		ShelfDepth: '3.375',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255860501',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '4.84',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Anti-static funnel fits all calibers between 22 and 45. Squared rim design won’t roll off the table.',
		ProductImage: 'http://images.salsify.com/image/upload/s--XVOGfF3O--/rmcq4zhbhdyfzimp6adg.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '16300edc-d5b8-452d-89bd-91827577ba61',
		ProductID: 'FR206',
		ProductName: '5.56 NATO 55gr FMJ (M193) Frontier®',
		UPC: '090255711424',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '6.375',
		ShelfWidth: '12.375',
		ShelfDepth: '5.625',
		Weight: '26.300',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711421',
		CartonHeight: '6.375',
		CartonWidth: '12.375',
		CartonDepth: '5.625',
		CartonWeight: '26.3',
		PalletQtyBoxes: '96',
		Retail: '787.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE CARTON',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--yvLZTjbh--/12b22cb84912f87ed6791327e7c081d55244a448.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31968686-d134-4ae4-a952-efc8a3a65175',
		ProductID: '82303',
		ProductName: '9.3X62 286 gr InterLock® SP-RP Dangerous Game™ Series',
		UPC: '090255823035',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823032',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '10.2',
		PalletQtyBoxes: '396',
		Retail: '117.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.4',
		MuzzleVelocity: '2360',
		MuzzleEnergy: '3537',
		SectionalDensity: '0.305',
		Cartridge: '9.3X62',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '286',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_tEzEIpW--/8e8998cd5f2a53271b2676926fda3cff135fe21b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '70e1c117-f396-4654-8602-a63bd8f3472f',
		ProductID: '6400',
		ProductName: '00 Buckshot .330 Diameter',
		UPC: '090255264005',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '5.120',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255264002',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '30.72',
		PalletQtyBoxes: '216',
		Retail: '45.48',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Buckshot',
		SectionalDensity: '0.0',
		BulletDiameter: '0.33',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '00',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made with the same dedication to uniformity as Hornady bullets, Hornady Buckshot is cold swaged using a lead alloy hardened with antimony to prevent deformities after firing. This helps it fly straighter and hit harder.  We use a strict roundness tolerance of +.001" to put more pellets in your targets. The industry standard is a +.006" tolerance.  Buckshot is sold in 5 lb. boxes',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--DTvzekSX--/ostdzab9zc7cm5nzangt.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Qjs5bk5P--/macdlmrdrctt0ki6g9nn.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lTGpXr3O--/xa4ijamzgeifkytjhkzi.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93a6c4bd-9d27-42a8-9f86-1433412fc0e0',
		ProductID: '86726',
		ProductName: '32-20 Winchester  Unprimed Cases',
		UPC: '090255867268',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867265',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '3.25',
		PalletQtyBoxes: '400',
		Retail: '51.57',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '32-20 WIN',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c7e60f4a-d119-4767-9577-a0a21a45815a',
		ProductID: '8277',
		ProductName: '25-35 Win 110 gr FTX® LEVERevolution®',
		UPC: '090255382778',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382775',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1400',
		Retail: '58.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.34',
		MuzzleVelocity: '2425',
		MuzzleEnergy: '1436',
		SectionalDensity: '0.238',
		Cartridge: '25-35 WIN',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'FTX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ESRdgd8W--/a63dbda25a2a511c3aeca3bce3699810273fb3b4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19ea44eb-f789-40bf-ae01-5e7c21ad8896',
		ProductID: '80234',
		ProductName: '223 Remington 62 gr FMJ Hornady BLACK®',
		UPC: '090255802344',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.620',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802341',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.2',
		PalletQtyBoxes: '1680',
		Retail: '23.04',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		G1BC: '0.274',
		MuzzleVelocity: '3100',
		MuzzleEnergy: '1323',
		SectionalDensity: '0.177',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ',
		BulletWeightGrain: '62',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xAZvFvPv--/fc083fee7d291c2c08f83b34d39571f0ba6ad946.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b34f40d-26f9-48ba-b1fd-e1456e850a21',
		ProductID: '050150',
		ProductName: '50 BMG Primer Seating Gauge',
		UPC: '090255501506',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.5',
		ShelfWidth: '4.25',
		ShelfDepth: '3.5',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501503',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '10.0',
		PalletQtyBoxes: '0',
		Retail: '190.61',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This precision instrument uses a dial indicator to measure the depth of each primer pocket and the height of each primer. Allows you to consistently seat the primer with the anvil just touching the bottom of the primer pocket every single time.',
		ProductImage: 'http://images.salsify.com/image/upload/s--o2dSM8-Y--/l3ttx6xhbnpvdbhztwgh.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '65dd74eb-1769-4033-a1ef-b0ca1859e0aa',
		ProductID: '98252',
		ProductName: 'Ready Vault™ Shelf Kit',
		UPC: '090255982527',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '11',
		ShelfDepth: '19.25',
		Weight: '4.750',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255982524',
		CartonHeight: '12.000',
		CartonWidth: '12.000',
		CartonDepth: '20.000',
		CartonWeight: '47.5',
		PalletQtyBoxes: '0',
		Retail: '28.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '0',
		ProductExtWidth: '18.5',
		ProductExtDepth: '10',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use in the RAPiD Safe Ready Vault. 100 pound weight capacity. 18.5" x 10".',
		ProductImage: 'http://images.salsify.com/image/upload/s--ndJXtCv4--/rgzqtdqhzimnhgqdz7pi.jpg',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '95ebb173-216e-43df-9b4d-1da86a66b720',
		ProductID: '17105',
		ProductName: '17 Cal .172 25 gr V-MAX®',
		UPC: '090255171051',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.429',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255171058',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '17.16',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.23',
		SectionalDensity: '0.121',
		OAL: '0.672',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '25',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KJpeJoPI--/d32a8f7d07abe156fbae133983e4c30580f97714.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3e60314d-9a1e-4f0a-8aaf-07d32daef552',
		ProductID: '390947',
		ProductName: 'Trimer Pilot #5 .264',
		UPC: '090255909470',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909477',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wpIfefeM--/xaelcnxkksggatpbnh1a.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2dc2f3d7-a28c-4a97-8405-ab9617f9916a',
		ProductID: '190196',
		ProductName: 'Powder Bushing 426',
		UPC: '090255191967',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191964',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20959d0f-1d2d-4cf0-8c12-290358b67f25',
		ProductID: '30717',
		ProductName: '30 Cal .308 176 gr A-TIP Match',
		UPC: '090255307177',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '2.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255307174',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '29.1',
		PalletQtyBoxes: '240',
		Retail: '116.75',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.564',
		G7BC: '0.284',
		MinTwist: '1-12"',
		SectionalDensity: '0.265',
		OAL: '1.38',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '176',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--GQI8VlwH--/rqe1vqqku35uztbk1tvx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '928ef2ac-7b1e-44ef-b8ec-c7830b5ebb37',
		ProductID: '8620B',
		ProductName: '243 Winchester Unprimed Cases',
		UPC: '090255600278',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '48.263',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '96526.0',
		PalletQtyBoxes: '88000',
		Retail: '0.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97616454-9f52-450b-8943-ab8854cf13f5',
		ProductID: '546337',
		ProductName: 'Full-Length 2-Die Set 30 Nosler (.308)',
		UPC: '090255563375',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.590',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563372',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.95',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30 NOSLER',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '40eeccb2-55a0-484f-a7ff-1e5d77c3f579',
		ProductID: '2266B',
		ProductName: '22 Cal .224 55 gr SP with cannelure',
		UPC: '090255622669',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '48.273',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255622666',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '289638.0',
		PalletQtyBoxes: '252000',
		Retail: '0.12',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Traditional Rifle Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		OAL: '0.725',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTSP W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '64909',
		MasterPackUCC: '30090255622660',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '3133352.157',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oohUZfyk--/532ec9d18768be24027cd2104f46486d832cf968.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '33e9fa5b-023c-4401-a9e6-3886c551cdea',
		ProductID: '392227',
		ProductName: 'Assembly Breakaway Cam Wire',
		UPC: '090255922271',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8',
		ShelfWidth: '5',
		ShelfDepth: '1',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '8.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '15.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--l62CROZ5--/pukdfyb7mrxvipf18jr3.png',
		DateLastModified: '2023-12-16 09:02:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51392416-9e72-436a-b091-8e7be144ec20',
		ProductID: '397137',
		ProductName: 'Seating Stem 338 Cal ELD-X® 230 Gr',
		UPC: '090255971378',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971375',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c883ffc-2a16-4347-bbd2-dd48ddaa85ca',
		ProductID: '050172',
		ProductName: 'Case Prep 6-Blade ID Chamfer',
		UPC: '090255501728',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501725',
		CartonHeight: '7.000',
		CartonWidth: '6.000',
		CartonDepth: '1.500',
		CartonWeight: '1.0',
		PalletQtyBoxes: '2000',
		Retail: '20.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '100',
		MasterPackUCC: '30090255501729',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '10.0',
		ProductDescription: 'Fits on Universal Handle, Power Case Prep Center, or Case Prep Trio.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YaZ5-kac--/aa8630f972b0c9e66e821bcda4c29e3c61fc222c.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c501c9b2-4033-4d39-b8cd-b9880eb9de0e',
		ProductID: '99223',
		ProductName: 'Hornady® American Flag Cap',
		UPC: '090255992236',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--C0gXr3bv--/jqwkwueopn9ns5jelddf.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5decf160-58be-4821-ae1c-59b3da23968e',
		ProductID: '86162',
		ProductName: '22 ARC Unprimed Cases',
		UPC: '090255861624',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255861621',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '0.0',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '22 ARC',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition. At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards. Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing. Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures.   TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy. UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible. MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass. CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b2bd40a6-5017-4d04-b0eb-fd5da9cd111f',
		ProductID: '050059',
		ProductName: 'Vernier Ball Micrometer',
		UPC: '090255500592',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.75',
		ShelfWidth: '7.75',
		ShelfDepth: '7.75',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500599',
		CartonHeight: '8.500',
		CartonWidth: '8.250',
		CartonDepth: '17.000',
		CartonWeight: '8.5',
		PalletQtyBoxes: '800',
		Retail: '120.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Measuring Devices',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--xmdPvPmC--/up5iufyd21ke6e1x3s9q.pdf',
		ProductDescription:
			'With a ball anvil and chamfered spindle, the Vernier Ball Micrometer is ideal for accurately measuring case neck thickness within an accuracy of 0.0001". Ratchet stop ensures uniform pressure for measurement repeatability.',
		ProductImage: 'http://images.salsify.com/image/upload/s--sNUQwJOW--/nzgwfmzqhgfrydakg9ku.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--YtAiYH9H--/xwbbbkvxbqha9tvz9sou.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '40e00730-e3c8-4366-adba-b0f44a66b6b6',
		ProductID: 'A375',
		ProductName: 'Lock-N-Load® 375 H&H Modified Case',
		UPC: '090255704969',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704966',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.41',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--m6PGG42u--/ca01beeb7459b61b8344786ab30c1cba2a9e2a36.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '953acc50-1156-4f77-9c9d-a4d473f634a1',
		ProductID: '190137',
		ProductName: 'Powder Bushing 345',
		UPC: '090255191370',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.066',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191377',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.66',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '366e1c26-4721-47d8-9f07-e3929856e30b',
		ProductID: '290032',
		ProductName: 'PTX™ Powder Through Expander .400',
		UPC: '090255900323',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.124',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900320',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.24',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--L_pF45Mi--/o9lwptmiulcttb8iqcwx.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e561729-f25e-431c-84b7-fb4ffadd53a2',
		ProductID: '75908',
		ProductName: 'SnapSafe® Reusable Dehumidifier Bag',
		UPC: '842631100434',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '8',
		ShelfDepth: '4.5',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100431',
		CartonHeight: '8.500',
		CartonWidth: '9.000',
		CartonDepth: '9.000',
		CartonWeight: '6.0',
		PalletQtyBoxes: '1600',
		Retail: '16.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'COBALT DICHLORIDE',
		Prop65Chem2: 'COBALT DICHLORIDE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '1.75',
		ProductExtWidth: '6.5',
		ProductExtDepth: '3',
		MasterPackQty: '20',
		MasterPackUCC: '30842631100435',
		MasterPackHeight: '17.500',
		MasterPackWidth: '8.750',
		MasterPackDepth: '18.500',
		MasterPackWeight: '24.0',
		ProductDescription:
			'Absorbs humidity from enclosed areas and helps prevent rust, mold, and mildew. Recharge in warm oven for infinite reuse. Absorbs humidity from enclosed areas. Helps prevent rust, mold, and mildew. Recharge in warm oven for infinite reuse.',
		ProductImage: 'http://images.salsify.com/image/upload/s--avEoKEco--/kmqr84e8zjmuyffzlqsh.png',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ff11d3c8-2322-4482-8d32-18c453eb4365',
		ProductID: '30191',
		ProductName: '30 Cal .308 110 gr GMX®',
		UPC: '090255301915',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.875',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255301912',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '21.875',
		PalletQtyBoxes: '900',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.305',
		SectionalDensity: '0.166',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '110',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--R4WDgLmm--/f9eb0669aa40844913edf5c250ca9571cabee697.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ff6d37d-398a-4b2d-b1ae-a7a7c7bd77c1',
		ProductID: '390610',
		ProductName: 'Shell Holder #55',
		UPC: '090255906103',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.875',
		ShelfDepth: '0.75',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906100',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c9fa8bd6-5d6b-4c3e-adb4-aa253c7dedb2',
		ProductID: '8605',
		ProductName: '223 Remington Unprimed Cases',
		UPC: '090255486056',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.816',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486053',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.08',
		PalletQtyBoxes: '400',
		Retail: '42.28',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4fbb5ac-9f3e-4b4a-8e6a-83a9a501959f',
		ProductID: 'C6PPC',
		ProductName: 'Lock-N-Load® 6mm PPC .261 Modified Case',
		UPC: '090255704372',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704379',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '7.97',
		ParentCategory: 'Reloading',
		Cartridge: '6MM PPC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3c08da92-9a20-472c-ac1c-db8262f5f275',
		ProductID: '4748',
		ProductName: '470 Cal .474 500 gr DGS®',
		UPC: '090255247480',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.734',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255247487',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '56.01',
		PalletQtyBoxes: '540',
		Retail: '138.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.29',
		SectionalDensity: '0.318',
		OAL: '1.3',
		Caliber: '470 CAL',
		BulletDiameter: '0.474',
		BulletName: 'DGS®',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TMtWnog2--/461e56c62c4e082f1b545044025e5a7d99662b82.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '15b503ec-6d0e-4148-b1c2-688fad6b9ad1',
		ProductID: '190185',
		ProductName: 'Powder Bushing 266',
		UPC: '090255191851',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.069',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191858',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.69',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '18432a95-4b4c-47ad-83e1-04b930ace6b5',
		ProductID: '81504',
		ProductName: '6.5 Creedmoor 100 gr.  ELD-VT™ V-Match™',
		UPC: '090255815047',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815044',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.0',
		PalletQtyBoxes: '1400',
		Retail: '53.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'V-Match™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppVarmint',
		G1BC: '.448',
		G7BC: '.266',
		MinTwist: '1-8"',
		SectionalDensity: '0.205',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD-VT™',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' Whether you’re taking aim in competition or outwitting varmints, make V-Match™ your ammunition of choice. It combines exceptional aerodynamics with high-quality components for match-grade accuracy and violent expansion.  V-MATCH™ Ammunition Innovation, precision and excitement! Elevate your shooting experience, shatter records, and make your mark like never before with Hornady® V-Match™ ammunition. NEW ELD-VT™ BULLET Designed using state-of-the-art technology, this bullet boasts exceptional aerodynamics. It guarantees high-velocity retention, minimal wind deflection, and reduced weight—resulting in ultra-flat trajectories and violent expansion. Whether you’re aiming for victory on the competition range or seeking to outwit varmints, this bullet’s design will provide the ultimate in precision and expansion. PREMIUM COMPONENTS Every round uses the highest quality components that are meticulously loaded to exacting specifications, resulting in match-grade accuracy that’s second to none. MODERN, CLEAN BURNING PROPELLANTS Carefully chosen for their consistency no matter the temperature, you can shoot with confidence, knowing that every trigger pull will be met with the same exceptional performance, whether you’re competing in the heat of summer or varmint hunting in the chill of winter.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--MJkiXUW7--/olot6xfawci1evuthfp6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--2CRdT7l3--/rf0ixozmmqbtw4mubpyh.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--AW1BXxhA--/dklj7flicc64kq7wyfe9.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--MJkiXUW7--/olot6xfawci1evuthfp6.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--pdO7EdA4--/vzv8n4o9jafgqxureora.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--YMg2ZPuC--/neoerym5tuughdhloadq.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Sb45UDyV--/lpgfajaouscv6zagvhy8.png',
		Videos: 'https://vimeo.com/876109355',
		DateLastModified: '2024-02-01 09:42:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '385331e1-26b0-4e2e-abf0-791e8913db9b',
		ProductID: '99300',
		ProductName: 'Hornady® Vintage Camouflage Mesh Cap',
		UPC: '090255993004',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '0.00',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'PHILLIPINES',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--YqvHBhzC--/syxarl5zpjlpc5x37rop.png',
		DateLastModified: '2023-11-07 15:06:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89ab782b-c15a-45f1-8994-bf00dc247559',
		ProductID: 'A264',
		ProductName: 'Lock-N-Load® 264 Win Mag Modified Case',
		UPC: '090255704129',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.038',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704126',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.38',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '264 WIN MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--czKcDPzC--/1478a0528600c890be7facdc71273e64103d27c1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df68f749-d866-4f9e-bf24-d0f7e5f7d0e6',
		ProductID: '046324',
		ProductName: 'Match™ Grade Full-Length Size Die 7mm PRC (.284)',
		UPC: '090255463248',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonWeight: '0.0',
		Retail: '80.37',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackUCC: '10090255463245',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not. The Elliptical Expander is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose. Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies. Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol). No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-02-08 11:02:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2574f976-3d56-4797-81b5-7055b47e39f8',
		ProductID: '190126',
		ProductName: 'Shot Bushing 1 7/8 oz',
		UPC: '090255191264',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191261',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3976440e-0029-4b38-a16a-2c676e60175a',
		ProductID: '544251',
		ProductName: 'Match™ Grade Full-Length Size Die 6mm BR (.243)',
		UPC: '090255542516',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.512',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255542513',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6MM BR REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '53c33eb1-9acd-4c65-a241-6becdd79b9e9',
		ProductID: '380062',
		ProductName: 'Case Neck Brush 17 Cal',
		UPC: '090255800623',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800620',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '17 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with the Lock-N-Load® Case Prep Trio, Case Prep Duo, Lock-N-Load® Power Case Prep Center, and Quick Change Hand Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s---BLCiVeN--/b3lhbrqg6ipdrnwzn9lz.png',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '68eeb8e9-2ac1-409b-b115-c1741b77cf7d',
		ProductID: '99102',
		ProductName: 'Hornady® Reloading Counter Mat',
		UPC: '090255991024',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '17.000',
		ShelfWidth: '26.000',
		ShelfDepth: '0.250',
		Weight: '1.240',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255991021',
		CartonHeight: '4.000',
		CartonWidth: '26.000',
		CartonDepth: '17.000',
		CartonWeight: '31.0',
		PalletQtyBoxes: '500',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ultimate reference tool for your reloading bench. This non-skid bullet mat features the Hornady® bullet line with corresponding caliber, diameter, weight, ballistic coefficient, sectional density, and item number.',
		ProductImage: 'http://images.salsify.com/image/upload/s----3BtzfY--/t8wpmvhdgzqxjsrxrjop.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4iM6Np1x--/rn5pugkqerx2yeufre9f.jpg',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd0b80ce5-e745-4b2f-a764-406a0e5dddc7',
		ProductID: '046277',
		ProductName: 'Full-Length Size Die 257 Wby (.257)',
		UPC: '090255462777',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.615',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462774',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c530fb4e-df1d-4c2d-b8ea-8369c325836f',
		ProductID: '2828',
		ProductName: '7mm .284 150 gr GMX®',
		UPC: '090255228281',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.168',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255228288',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.2',
		PalletQtyBoxes: '900',
		Retail: '53.97',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.464',
		SectionalDensity: '0.266',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'GMX®',
		BulletWeightGrain: '150',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--U00u7L3U--/87ce2c58a6feb016a37ae2ac66b38a62fd685f56.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7d2940ff-ea7b-4409-ad3e-518f9fb9e2a5',
		ProductID: '13/41',
		ProductName: 'Lock-N-Load® 41 Insert (.416 Cal)',
		UPC: '090255704624',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2.0',
		ShelfDepth: '0.75',
		Weight: '0.021',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonWeight: '0.21',
		Retail: '4.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6z93oY0s--/nfnprhd8qxpn4fvqxuzp.png',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb76b5c6-ff16-413b-843e-161d2903c8ed',
		ProductID: '30303',
		ProductName: '30 Cal .308 150 gr SST® (300 Savage)',
		UPC: '090255303032',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.240',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255303039',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.6',
		PalletQtyBoxes: '540',
		Retail: '55.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.37',
		SectionalDensity: '0.226',
		OAL: '1.117',
		Cartridge: '300 SAVAGE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s---DKaHegx--/c8acf8af673f206d577fbb568ee7e79b6c38b27c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '835d2c24-3e73-41e4-a7db-9e7267d88358',
		ProductID: '8680',
		ProductName: '338 Winchester Magnum Unprimed Cases',
		UPC: '090255486803',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486800',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.5',
		PalletQtyBoxes: '200',
		Retail: '88.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '160f4057-55f5-4f17-97ed-4c5b164e15e3',
		ProductID: '8347',
		ProductName: '6.8mm SPC 120 gr SST®',
		UPC: '090255383478',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.915',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383475',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.15',
		PalletQtyBoxes: '1400',
		Retail: '42.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.4',
		MuzzleVelocity: '2460',
		MuzzleEnergy: '1612',
		SectionalDensity: '0.223',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZJIWMub9--/e966ad9f407e2562d471f261e33bf62908577d96.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '78145c74-28d2-4f17-baf6-245692682feb',
		ProductID: 'C450NE',
		ProductName: 'Lock-N-Load®450 Nitro Express Modified Case',
		UPC: '090255705058',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '0.75',
		ShelfDepth: '4',
		Weight: '0.051',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705055',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.51',
		PalletQtyBoxes: '0',
		Retail: '7.97',
		ParentCategory: 'Reloading',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2024-03-05 08:51:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bc098681-6829-44df-ab7a-d1808f0c3e27',
		ProductID: '47474',
		ProductName: '470 cal .474 500 gr DGX® Bonded',
		UPC: '090255474749',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.680',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255474746',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.2',
		PalletQtyBoxes: '540',
		Retail: '150.71',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.29',
		SectionalDensity: '0.318',
		OAL: '1.29',
		Caliber: '470 CAL',
		BulletDiameter: '0.474',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--dIXM-1yU--/7ece3e71f418458b1cdf4e777384724bea43ffb8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '59819958-7f81-4a4d-97ed-508014a0de1f',
		ProductID: '390939',
		ProductName: 'Trimer Pilot #23 480/475',
		UPC: '090255909395',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909392',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '9.55',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '475 CAL/480 CAL',
		BulletDiameter: '0.475/0.480',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--vFE6-8wX--/qnxejwt1vaimbinembwc.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a66c7181-1859-48ea-8b6c-27867707292f',
		ProductID: '99231',
		ProductName: 'Hornady® Red and White Cap',
		UPC: '090255992311',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'PHILLIPINES',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--T9iJx1hx--/uwg68dxqucg8bnahe9oh.png',
		DateLastModified: '2024-01-09 17:01:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '326b7f99-5ad3-40f1-8eee-45988f93fd7e',
		ProductID: '044523',
		ProductName: 'Expander Die 38-357 (.357)',
		UPC: '090255445237',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.479',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445234',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f55276c2-507f-4793-8da9-7685f0cb1d7c',
		ProductID: '390953',
		ProductName: 'Trimer Pilot #11 .323',
		UPC: '090255909531',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.019',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909538',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.19',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--JL2sm1Nn--/dbnthpeuvi8jphinsk3n.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6b15b355-4df4-49b0-b43b-a74f7f977680',
		ProductID: '380711',
		ProductName: 'Cartridge Gauge 270 Win (.277)',
		UPC: '090255807110',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.420',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807117',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '4.2',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a72a35bb-1b74-489e-b265-d1130e800aaf',
		ProductID: '190099',
		ProductName: 'Shot Bushing 1/2 oz #9',
		UPC: '090255190991',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.063',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255190998',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.63',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shot Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Calibrated to measure maximum legal loads for trap and skeet shooting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8791061a-0d26-44ae-867a-80f3dcafe846',
		ProductID: '9153',
		ProductName: '460 S&W 200 gr MonoFlex Handgun Hunter',
		UPC: '090255391534',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.225',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391531',
		CartonHeight: '3.625',
		CartonWidth: '5.312',
		CartonDepth: '13.500',
		CartonWeight: '12.25',
		PalletQtyBoxes: '720',
		Retail: '67.01',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		SectionalDensity: '0.14',
		Cartridge: '460 S&W MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--mnEgSH2c--/rbztshvnilncj2jtbkap.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5086055e-45b1-4926-ba23-1b27185536e4',
		ProductID: '044577',
		ProductName: 'Expander Die 357 Sig (.357)',
		UPC: '090255445770',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.503',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445777',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6977c85e-6949-44fc-acd7-ba195948f0fa',
		ProductID: '45140',
		ProductName: '45 Cal .451 200 gr XTP®',
		UPC: '090255245141',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.014',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245148',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.21',
		PalletQtyBoxes: '540',
		Retail: '43.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.151',
		SectionalDensity: '0.14',
		OAL: '0.585',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'XTP®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--E84w5y0r--/cc90427b703a066d462632f4f8613e0adb6ea754.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c2a23af-f19c-4f53-96d7-841ff7c532f7',
		ProductID: '398112',
		ProductName: 'Flash Hole Deburr Tool',
		UPC: '090255705720',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '1.5',
		ShelfDepth: '0.5',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255705727',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '36.91',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--mQTOmGPF--/pxeefixzqpsv2fu03slr.jpg',
		DateLastModified: '2023-12-16 09:02:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd0ac7412-65b2-489f-8d42-9fa16e6dfdb0',
		ProductID: '546228',
		ProductName: 'Full-Length 2-Die Set 223 Rem (.224)',
		UPC: '090255562286',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.476',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562283',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.38',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '46d325b3-ff07-4e08-b8f1-363b261304bf',
		ProductID: 'FR320',
		ProductName: '5.56 NATO 75 gr BTHP Match T2 Frontier®',
		UPC: '090255711615',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.622',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711612',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '15.55',
		PalletQtyBoxes: '4500',
		Retail: '23.13',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.355',
		MuzzleVelocity: '2860',
		MuzzleEnergy: '1362',
		SectionalDensity: '0.214',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZQ5EvR5H--/42b96366be7baddf9990c093df68bf1dd2795b94.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cb8f5726-1292-4c5f-b918-161b3f99af36',
		ProductID: '594246',
		ProductName: 'Match™ Grade Bushing .246',
		UPC: '090255592467',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592464',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.246',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ta7ukSf3--/3d941d0b3780592196cf36e901ea17046801cab2.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14344aa4-53f6-4816-b4bc-c51d0236c325',
		ProductID: '99146',
		ProductName: 'Hornady® "H" 18" Clock',
		UPC: '090255991468',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '18.75',
		ShelfWidth: '18.75',
		ShelfDepth: '1.5',
		Weight: '2.880',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '100.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--UpU3Mb77--/ll7mka9x62uicasztp0w.png',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd28b23c-f806-43d4-a824-d42f693825fd',
		ProductID: 'B14',
		ProductName: 'Lock-N-Load® Bullet Comparator - Complete Set',
		UPC: '090255704778',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1',
		Weight: '0.298',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704775',
		CartonHeight: '4.500',
		CartonWidth: '7.250',
		CartonDepth: '10.250',
		CartonWeight: '2.98',
		PalletQtyBoxes: '0',
		Retail: '74.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--f2TPMlEa--/o0xrw1df5hqozha9aezy.pdf',
		ProductDescription:
			'Measuring cartridge lengths across the bullet tips is not a reliable (or repeatable) method for measuring loaded rounds. It’s common for variations of up to .025” to exist from one round to the next. Our Bullet Comparator measures rounds from the ogive to provide consistent, precise measurements. You can also use it to check uniformity of bullets from base to ogive. Our Bullet Comparator easily attaches to the blade of your caliper and uses interchangeable inserts (available in sizes from .17 caliber to .45 caliber) to measure from the bullet ogive. Used in conjunction with the O.A.L. Gauge, the Bullet Comparator provides the ultimate in precision measurement. The Bullet Comparator will properly align the O.A.L. Gauge for precise measurement using a caliper. This method allows direct comparison of your loads as you set up your bullet seating die for any selected bullet free-travel (jump). Comparator body and all 14 bullet inserts for bullet diameters: .172," .204," .224" (5.56mm), .243" (6mm), .257," .264," .277," .284" (7mm), .308," .338," .358," .375," .416," .458"',
		ProductImage: 'http://images.salsify.com/image/upload/s--7PdGeQqU--/rcxjbiomulf8u7an65uh.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd6b5fcc1-96a0-454f-837b-32a4235095e8',
		ProductID: '044096',
		ProductName: 'Lock-N-Load® Die Bushing 10 Pack',
		UPC: '090255440966',
		PackagedQTY: '1',
		PackagedUOM: 'BG',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.25',
		Weight: '0.960',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440963',
		CartonHeight: '7.750',
		CartonWidth: '7.250',
		CartonDepth: '8.000',
		CartonWeight: '9.6',
		PalletQtyBoxes: '0',
		Retail: '80.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.  The Patented Hornady® Lock-N-Load® Die Bushings are the easiest way to get the most out of your reloading press.  Simply place your die with bushing into the press and turn to fully seat your die. It’s that simple. The Lock-N-Load® system comes standard on all new Hornady® reloading presses, or you can convert any press with 1¼"-12 threads with the Lock-N-Load® Conversion Kit (sold separately – Hornady® Item # 044099).  Hornady® Lock-N-Load® Die Bushing (10-Pack) includes: Qty 10: Lock-N-Load® Die Bushings with o-rings. Other accessories sold separately.  Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--8Xqgi8QD--/vq6rlef86rwdicg0uwjb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3262c7ec-7a2b-4fab-b679-1e1049e28fda',
		ProductID: '190115',
		ProductName: 'Shot Bushing 1/2 oz',
		UPC: '090255191158',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.080',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191155',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.8',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ee8b979-b821-4476-900f-0151cc28bbdf',
		ProductID: '90904',
		ProductName: '45 Auto 185 gr XTP® American Gunner®',
		UPC: '090255909043',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.895',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909040',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.95',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.139',
		MuzzleVelocity: '970',
		MuzzleEnergy: '386',
		SectionalDensity: '0.13',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'XTP®',
		BulletWeightGrain: '185',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mQOSaq1r--/f4de63c8f8b8e01a2875d9865ed107c1691c87ec.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aea216df-caa4-4fd3-856e-218274016c10',
		ProductID: 'B300R',
		ProductName: 'Lock-N-Load® 300 Rem SAUM Modified Case',
		UPC: '090255704259',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.036',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704256',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.36',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '300 REM SA ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '294140f4-9650-412c-8b53-09ec432bd4c3',
		ProductID: '82206',
		ProductName: '300 WSM 165 gr GMX® Superformance®',
		UPC: '090255822069',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.650',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822066',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '16.5',
		PalletQtyBoxes: '930',
		Retail: '63.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cIHTnGKy--/441872edd180116f6cd61c17d4be720a8dc9d9e9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c262e343-77d6-429a-b048-6cb400ee2601',
		ProductID: '41051',
		ProductName: '405 Cal .411 300 gr InterLock® SP',
		UPC: '090255410518',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.256',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255410515',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '56.4',
		PalletQtyBoxes: '900',
		Retail: '59.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.25',
		SectionalDensity: '0.254',
		OAL: '1.07',
		Cartridge: '405 WIN',
		Caliber: '405 CAL',
		BulletDiameter: '0.411',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4nCfL0DS--/81c548f4686315aaaeda01108d17b0b44d8792ab.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e72d764-edb6-4471-9b78-528295522c91',
		ProductID: 'A2506',
		ProductName: 'Lock-N-Load® 25/06 Rem Modified Case',
		UPC: '090255704822',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.030',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704829',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.3',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lN810Z8T--/0a820d0f9983c6394efcd6f1edeb3ed59c042730.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5bdf0d17-8ef8-439e-a4cd-6ed9561057e7',
		ProductID: '22810',
		ProductName: '7mm .284 120 gr V-MAX®',
		UPC: '090255275070',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.802',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255275077',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.05',
		PalletQtyBoxes: '900',
		Retail: '48.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.365',
		SectionalDensity: '0.213',
		OAL: '1.105',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--dmxSy0-Y--/67ef95e1b2208e0d45cf80ddab4d36935f714314.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c28d082b-1f8b-4fee-afbc-eb285387844e',
		ProductID: 'C450325',
		ProductName: 'Lock-N-Load® 450-400 3.25" Modified Case',
		UPC: '090255705065',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705062',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '13.81',
		ParentCategory: 'Reloading',
		Cartridge: '450-400 NITRO EXP 3¼"',
		Caliber: '400 CAL',
		BulletDiameter: '0.41',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2024-03-05 08:51:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2078b70b-5aff-4584-8b3f-5e54b9e4b0db',
		ProductID: '3210',
		ProductName: '32 Cal .321 170 gr InterLock® FP',
		UPC: '090255232103',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.558',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255232100',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.37',
		PalletQtyBoxes: '540',
		Retail: '48.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.249',
		SectionalDensity: '0.236',
		OAL: '0.915',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		BulletName: 'FP INTERLOCK®',
		BulletWeightGrain: '170',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WMQbOQ9---/dc2ff85ccd6d749d8318751f413fe2caee753314.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '213b5a53-d91b-47b7-99d1-c2c9850bd4f6',
		ProductID: '30731',
		ProductName: '30 Cal .308 208 gr ELD® Match',
		UPC: '090255307313',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.123',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307310',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.845',
		PalletQtyBoxes: '540',
		Retail: '66.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.69',
		G7BC: '0.348',
		MinTwist: '1-10"',
		SectionalDensity: '0.313',
		OAL: '1.535',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '208',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fjGioHx_--/d515daaa9c290452788261401c9c7885dd103aa3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ada84d6b-a5a0-4b08-8960-39f99fa124ac',
		ProductID: '544591',
		ProductName: 'Blank Cartridge 2-Die Set 22-45 Cal',
		UPC: '090255545913',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255545910',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '179.84',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: 'BLANK CART 22-45 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For loading blanks this set produces a star crimp for all popular cartridges from 223 through 45-70. Compatible with 7/8" x 14 TPI presses.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VR-1T2Xk--/73d184a0a871ba9b6db03fbf424183247acf66f6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--EKiFIKtO--/w6qx23nsqih9s9qk5v4j.jpg',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ec251ac-39cc-4700-b600-970ece4a731f',
		ProductID: '98191',
		ProductName: 'RAPiD® Safe AR Gunlocker XL',
		UPC: '090255981919',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '13.5',
		ShelfWidth: '46',
		ShelfDepth: '18.75',
		Weight: '65.660',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255981916',
		CartonHeight: '13.500',
		CartonWidth: '18.750',
		CartonDepth: '46.000',
		CartonWeight: '65.66',
		PalletQtyBoxes: '12',
		Retail: '624.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '10',
		ProductExtWidth: '42',
		ProductExtDepth: '15.25',
		ProductWeight: '62',
		ProductIntHeight: '8.75',
		ProductIntWidth: '40.5',
		ProductIntDepth: '13.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The AR Gunlocker stows neatly under a bed, in a closet or the back of an SUV, providing total security with its fully enclosed design. Available in two sizes, secure up to three tactical-length riflesor shotguns and access them quickly and efficiently, thanks to RFID technology.  FAST AND DEPENDABLE TOUCH-FREE ENTRY RFID[2] activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS For secondary entry method, user can program a four to six digit security code.  CERTIFIED CHILD-RESISTANT Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and hinge attack resistance.  SAFE AND READY AC and battery power ensures your firearm is protected and ready to go 24/7.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 16 gauge steel with four internal hardened locking lugs. Included cable and pre-drilled mounting holes allow additional security.  Contents Include: RAPiD® Safe, Wall Power Supply, RFID Wristband, two RFID Stickers, RFID Key Fob, two Circular Barrel Keys, Security Cable. AR Gunlocker XL - No. 98191 Features: Holds up to three tactical length rifles.* Type: Rifle, Shotgun Exterior Dimensions: 42" x 15.25" x 10" Interior Dimensions: 40.5" x 13.5" x 8.75" Weight: 62 pounds',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--pAN2x0rr--/piom55v4vntxxuctoag1.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--pAN2x0rr--/piom55v4vntxxuctoag1.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Z2Q_pCuA--/dhhlsmerln1t7ivs8x2u.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P7KgmIdZ--/lba897pa8qyvxt6hbnpx.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--POSXxwqC--/itfnejtlbkhwycp1fk6h.png',
		Videos: 'https://vimeo.com/489482620',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89e5c142-b6e5-4c97-b555-eaab021024d6',
		ProductID: '22273',
		ProductName: '22 Cal .224 55 gr GMX®',
		UPC: '090255222739',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.455',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222736',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '18.2',
		PalletQtyBoxes: '1440',
		Retail: '40.59',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.245',
		SectionalDensity: '0.157',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'GMX®',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WhIA4JC4--/c1a417d911de872d8c9f668f9944530e019d8043.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '70f770ad-016a-4ef7-9889-c506b685c0e6',
		ProductID: '99217',
		ProductName: 'Hornady® Gray and Black Cap',
		UPC: '090255992175',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'BANGLADESH',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--iS-UcOD7--/mm1fcnyqugqlhbblk8nx.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e3cf463-aa6d-4fb5-a42c-90a8e90be531',
		ProductID: '546292',
		ProductName: 'Full-Length 2-Die Set 6.5 Mann (.264)',
		UPC: '090255562927',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562924',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6.5X54 M-SCH',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6757f6bd-4eea-448a-a951-c336e930c5e5',
		ProductID: '085003',
		ProductName: 'Lock-N-Load® Classic Kit',
		UPC: '090255850031',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.125',
		ShelfWidth: '17.75',
		ShelfDepth: '21',
		Weight: '25.100',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '8.125',
		CartonWidth: '17.750',
		CartonDepth: '21.000',
		CartonWeight: '25.1',
		PalletQtyBoxes: '20',
		Retail: '485.90',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Precision and ease make the Classic Press a winner. A single stage press is perfect for both beginners and those who want complete control over the entire process. The Lock-N-Load Classic delivers both dependability and precision with its uniquely angled, solid cast frame that offers greater visibility and easier access to the cartridge. Designed to assure perfect die and shell holder alignment, its Lock-N-Load quick change bushing system also makes the process quick and easy. LOCK-N-LOAD® QUICK CHANGE BUSHING SYSTEM Lock-N-Load® bushings not only let you switch from one die to another in a matter of seconds, they also offer the quickest and easiest die setup on the market. Just set the die and tighten the Sure-Loc™ ring on to the Lock-N-Load® bushing. Quickly remove and re-install without the need to readjust the die or keep a separate seater die for each of your pet loads.  POWER-PAC LINKAGE AND SOLID STEEL ARMS Arms rotate on steel pins that run completely through the cast frame. The Power-Pac linkage design multiplies the leverage you apply to the handle, making it easier to size cases and reduces user fatigue.  POSITIVE PRIMING SYSTEM™ (PPS) Once the spent primer ejects at the top of the stroke, you can add a new primer to the PPS and it self-aligns to feed and insert the primer at the bottom of the stroke where leverage is best. Our self-aligning primer arm also allows for easy manual inserting of primers without having to raise the handle. All the work is done at the bottom of the stroke. Works easier than ram prime units and much better than old style primer arms. Small and large punch included.  STRONG ANGLED FRAME This high strength alloy frame offers the rigidity and stability needed for precision reloading, and is guaranteed never to break or fail. The frame's unique angle gives the reloader greater visibility and easier access to the cartridge in the press.  EASY GRIP HANDLE Large, ball-style grip reduces fatigue. The long handle increases leverage and reduces effort. Perfect for the reloading novice, this kit offers everything you need to get started. (Reloading dies and shell holders sold separately.)  Includes: Lock-N-Load® Classic™ Reloading Handbook Lock-N-Load® Powder Measure Digital Scale Lock-N-Load® Die Bushings (3) Primer Catcher Positive Priming™ System Handheld Priming Tool Universal Reloading Block Chamfer & Deburr Tool Powder Trickler Powder Funnel One Shot® Case Lube",
		ProductImage: 'http://images.salsify.com/image/upload/s--mo7RHa2Y--/wtephk0vdu5fclx98pyc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VrhyKEPr--/wzeshhcgqsq6k8cpe9ay.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--2ge0zOrv--/luktnhbkcf0awzxejydf.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ThzEPw6X--/krsz6vxju0cjtev7nluz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--6eoFzjYl--/hxj0yohvyj1q3telx4vr.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--r0K6wY_g--/azzq01nhbgqataa3dfl1.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		Videos: 'https://vimeo.com/365374029',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '427e4a36-f790-45ef-9f69-21a37bfb03b8',
		ProductID: '95103',
		ProductName: 'Hornady® 10-Gun Welded Cabinet',
		UPC: '090255951035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '53',
		ShelfWidth: '17',
		ShelfDepth: '13.4',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '53.000',
		CartonWidth: '17.000',
		CartonDepth: '13.400',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '223.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Welded Gun Cabinets',
		CountryofOrigin: 'CAMBODIA',
		Prop65Chem1: 'lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		ProductExtHeight: '53',
		ProductExtWidth: '17',
		ProductExtDepth: '13.4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This fully welded security cabinet secures firearms that are up to 53 inches long. The anti-pick three point key lock system means only key holders have access. It has storage capacity for everything from rifles, shotguns, and handguns to gear and supplies. Pry-resistant concealed hinges prevent tampering. High-quality steel paired with three-point locking mechanism and barrel key lock provide peace of mind. Fully adjustable shelf and gun racks. Shelf accommodates extra-long shotguns and rifles. Heavy-duty PVC-coated gun racks. Neoprene floor mat. 53"H x 17"W x 13.4"D',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6gzDcMlM--/vvrdphtdndayfyhh3nyo.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xWE3mLtK--/otno7emogeor1vdwwbxa.png',
		DateLastModified: '2024-01-04 15:41:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c09f2be6-8768-4746-83f9-291b3a41f5bd',
		ProductID: '546202',
		ProductName: 'Full-Length 2-Die Set 17/222 (.172)',
		UPC: '090255562026',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562023',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '17-222',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3bd5cd8e-d07e-4a29-80d9-dd3ab25d1a80',
		ProductID: '90933',
		ProductName: '45 Auto+P 160 gr. MonoFlex® Handgun Hunter®',
		UPC: '090255909333',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909330',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '0.0',
		PalletQtyBoxes: '1120',
		Retail: '52.19',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppTargetMatch',
		SectionalDensity: '0.112',
		Cartridge: '45 AUTO+P',
		PressureRating: '+P',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '160',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design. Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact. ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion. PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--5HXegMgy--/swt0lvve8pswnnwxwaoa.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0e3187ce-f4f7-4539-8809-5fac9be69488',
		ProductID: '546284',
		ProductName: 'Full-Length 2-Die Set 6.5X57 (.264)',
		UPC: '090255562842',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562849',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X57',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8aaa9c29-0634-4f8a-a614-76c37b6eec34',
		ProductID: '544353',
		ProductName: 'Match™ Grade 2-Die Set 300 WSM (.308)',
		UPC: '090255543537',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.540',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543534',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.7',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60f0d094-186f-4c3c-b00f-466c65653497',
		ProductID: '594242',
		ProductName: 'Match™ Grade Bushing .242',
		UPC: '090255592429',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592426',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.242',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1nwKsVpy--/2afdbd95444b42ce909ace3b6f2a41318d97fdf5.jpg',
		DateLastModified: '2024-01-11 09:32:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f062433-f38d-496a-8f1c-58a80bd74c1e',
		ProductID: '3015',
		ProductName: '30 Cal .308 110 gr RN',
		UPC: '090255230154',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.634',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255230151',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.85',
		PalletQtyBoxes: '900',
		Retail: '34.07',
		ParentCategory: 'Bullets',
		Applications: 'AppVarmint',
		G1BC: '0.150',
		SectionalDensity: '0.166',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'RN',
		BulletWeightGrain: '110',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jfSUzyMA--/cbmwu7fd2xrubx388vbq.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '308ebb61-ac0a-40f8-808d-b6462a14e066',
		ProductID: '391924',
		ProductName: 'Neck Turn Mandrel 7mm .2813',
		UPC: '090255919240',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.065',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919247',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.65',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.2813',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca1aefdf-8d94-4c29-9fa6-b9895d1af3e1',
		ProductID: 'RF17',
		ProductName: 'Lock-N-Load® 17-22 Rim Thickness Gauge',
		UPC: '090255704150',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.175',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704157',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '4.000',
		CartonWeight: '1.75',
		PalletQtyBoxes: '0',
		Retail: '47.05',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Rimfire Gauge',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Sorting ammo by rim thickness will provide ammo with similar ignition qualities for improved accuracy. This proven technique is used by competitive shooters and varmint hunters. The rimfire gauge attaches to your caliper and includes bushings for use with most .17 and .22 caliber rimfire ammo. (Not compatible with 17 WSM.)',
		ProductImage:
			'http://images.salsify.com/image/upload/s--05kyji3Z--/dce042708687860a29e386f6cb9d52dd7f67d480.jpg',
		DateLastModified: '2023-12-16 08:55:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f6be123-7bc1-4744-9667-4ece3204ced6',
		ProductID: '75240',
		ProductName: 'Snapsafe® Lock Box With Combination Lock XL',
		UPC: '851529004334',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '4.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004331',
		CartonHeight: '11.500',
		CartonWidth: '7.750',
		CartonDepth: '12.750',
		CartonWeight: '22.5',
		PalletQtyBoxes: '500',
		Retail: '49.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. SPECIFICATIONS Dimensions: 10” x 7” x 2” Weight: 6 lbs  FEATURES Easy to operate combination lock mechanism. 1500 lb. rated 4 ft. steel security cable. Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.",
		ProductImage: 'http://images.salsify.com/image/upload/s--2_gr5I45--/tyenorqn2lfpzw43c91a.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--wqnlccMe--/gv4nchnylhb6na0uqpti.png',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '651d565e-e50e-4e52-94ed-4395c7cb92fb',
		ProductID: '95906',
		ProductName: 'Hornady® Canister Dehumidifier XL',
		UPC: '090255959062',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.5',
		ShelfWidth: '6',
		ShelfDepth: '6',
		Weight: '3.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959069',
		CartonHeight: '7.500',
		CartonWidth: '11.000',
		CartonDepth: '15.250',
		CartonWeight: '19.0',
		PalletQtyBoxes: '0',
		Retail: '47.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'COBALT DICHLORIDE',
		Prop65Chem2: 'COBALT DICHLORIDE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '8',
		ProductExtWidth: '5.3',
		ProductExtDepth: '4.8',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--DJ7BbktH--/qxvt1ktckbwlwik0nwcm.pdf',
		ProductDescription:
			'Protect your valuables against rust and corrosion. When the moisture control crystals turn pink, recharge unit by placing it in the oven. Unlimited recharges ensure a lifetime of use. Protect firearms and other valuables from rust and corrosion. Desiccant crystals change color when canister needs recharging. Recharge canister by placing in a 300ºF oven until drying granules turn blue (up to 4 hours). Unlimited recharges, no batteries required. Desiccant: 1500g',
		ProductImage: 'http://images.salsify.com/image/upload/s--ycO2N9lI--/mr2t4ldbb2xfq8b5kgax.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MUB3nekF--/rm1yt6vgwcvydjai376l.jpg',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '42d07f37-c9ff-47d2-aa8c-14fb81ee692c',
		ProductID: '8604',
		ProductName: '204 Ruger Unprimed Cases',
		UPC: '090255486049',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.793',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486046',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '3.965',
		PalletQtyBoxes: '400',
		Retail: '42.28',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '56d66364-9866-46cf-b17d-3583302fd972',
		ProductID: '86834',
		ProductName: '33 Nosler Unprimed Cases',
		UPC: '090255868340',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.960',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868347',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '4.8',
		PalletQtyBoxes: '400',
		Retail: '60.93',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '33 NOSLER',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23140df4-f201-45d2-a77a-dd108c54d2a5',
		ProductID: '99128',
		ProductName: 'Hornady® Bino Case',
		UPC: '090255991284',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '8',
		ShelfDepth: '3',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '12.000',
		CartonWidth: '8.000',
		CartonDepth: '3.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '45.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'MEXICO',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Protect your binoculars, range finder, GPS or spare ammo with this quiet quick-access case. Built from tough, nylon Cordura® with a micro fiber liner and padded sides, the case features heavy-duty zippers and X-panel harness that distributes weight over four elastic straps. Measures 7.5 x 10.2 x 3.4 inches',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--JnolGAZU--/nk7s9pscjxpz7opw89tp.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--JnolGAZU--/nk7s9pscjxpz7opw89tp.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fc09271c-e4d7-4cf9-99df-20098d96fbc4',
		ProductID: '044120',
		ProductName: 'Seater Die #20 (.366)',
		UPC: '090255441208',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441205',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '152fe745-8d9f-4187-b004-ceeb82d957df',
		ProductID: '45159B',
		ProductName: '45 Cal .451 200 gr HAP®',
		UPC: '090255694055',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '52.559',
		WeightUOM: 'LB',
		CaseQty: '1800',
		CartonUCC: '10090255694052',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '94606.2',
		PalletQtyBoxes: '75600',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.151',
		SectionalDensity: '0.14',
		OAL: '0.58',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'HAP®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yey2ipUN--/d38da23b8fb3a0324419ce21a06d2bfdd257e197.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--d2faqfRw--/54e83b5213f25231b53e7f10f411fb2e6e656d33.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1fdde16a-4381-4243-a28f-5695e76d8426',
		ProductID: '544351',
		ProductName: 'Match™ Grade 2-Die Set 300 Win Mag (.308)',
		UPC: '090255543513',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.710',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543510',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '8.55',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd6daa7c9-c227-44d1-8277-1493bb66b925',
		ProductID: '290034',
		ProductName: 'PTX™ Powder Through Expander .451',
		UPC: '090255699883',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.122',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255699880',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.22',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '750bec4a-de34-4a0d-9c97-2d8b6c0925e6',
		ProductID: '044136',
		ProductName: 'Seater Die (.224) 22 Cal W/281',
		UPC: '090255441369',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441366',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '642930e4-1ddd-4a1f-a7ec-ac76dcf75886',
		ProductID: '095330',
		ProductName: 'Bullet Feeder Die 380/9mm',
		UPC: '090255953305',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '7.500',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '380 AUTO/9MM LUGER',
		Caliber: '9MM',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Bullet Feeder Dies are case activated – a bullet will only feed upon contact with a case. The collets are precision machined of solid steel for each caliber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5ODx6Jae--/hwnaibacjc6npxwf3nfe.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e3b17438-e0ee-4143-be83-6148b116388a',
		ProductID: '044700',
		ProductName: 'Seater Die 500 S&W Mag (.500)',
		UPC: '090255447002',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.526',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447009',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cbd51386-296b-4d42-b0b2-880bf4623992',
		ProductID: '594257',
		ProductName: 'Match™ Grade Bushing .257',
		UPC: '090255592573',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592570',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xvJrJyaA--/9b7f0522ffee713b30b8d251c7e426936add3752.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'facf697d-0c38-4033-adb1-aeb924083aa1',
		ProductID: '90287',
		ProductName: '9mm Luger 147 gr XTP Subsonic',
		UPC: '090255902877',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.835',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902874',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.35',
		PalletQtyBoxes: '1120',
		Retail: '34.75',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady® Subsonic Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.212',
		SectionalDensity: '0.167',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '147',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shhh... tell everyone! Hornady® Subsonic Ammunition — designed for accuracy and performance below the speed of sound — now comes in both rifle and handgun loads.  Subsonic Handgun utilizes tried-and-true XTP® bullets that expand reliably at subsonic velocities. The Sub-X bullet used in Subsonic Rifle features a lead core. Long grooves in its gilding metal jacket combine with the bullet’s flat profile and the patented Flex Tip® insert within its hollowpoint cavity to help it expand reliably at low velocities.  Powders are selected for optimal performance and consistency from lot to lot. PROVEN PERFORMANCE Performance of 300 Blackout Subsonic meets or exceeds FBI Protocol terminal ballistic test requirements. The XTP® bullet in Subsonic Handgun has built a world-class reputation for accuracy and stopping power.  SILENT AND STEALTHY Hornady® Subsonic Ammunition doesn’t have the loud report of a supersonic round, and paired with a suppressor, it’s even quieter. Unique powders optimized for subsonic use result in a low flash signature, ideal for either suppressed or unsuppressed performance.  HIGH-QUALITY COMPONENTS With high-quality cartridge cases and primers, Subsonic Ammunition offers the performance and accuracy shooters have come to expect from Hornady. Disclaimer: This is subsonic, i.e., reduced velocity ammunition and will not produce the same muzzle energy as conventionally loaded cartridges. If hunting with this product, be sure to read, understand and comply with all applicable regulations and laws pertaining to bullet energy and/or muzzle velocity for the area and game to be hunted.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--o1weoByO--/eod4xl5zcttdjht9ofic.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZFj1Ta0t--/ekifq9pk0abc74uw27dw.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lUFZkpqB--/lwccm0zykedo0jl0gnlh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fPHiA1qN--/ip5zbi5umrrlje92o0vb.jpg',
		Videos: 'https://vimeo.com/238318324',
		Videos1: 'https://vimeo.com/368031042',
		Videos2: 'https://vimeo.com/257722661',
		Videos3: 'https://vimeo.com/242146498',
		Videos4: 'https://vimeo.com/396530834',
		Videos5: 'https://vimeo.com/368030863',
		Videos6: 'https://vimeo.com/367123504',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b93565e-e71e-4f46-ba65-74b5fcdeb586',
		ProductID: '399693',
		ProductName: 'Trimer Pilot Style Flashole Deburr Tool',
		UPC: '090255996937',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255996934',
		CartonHeight: '3.500',
		CartonWidth: '6.250',
		CartonDepth: '8.250',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '49.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed to deburr and uniform flash holes in cartridge cases quickly and easily, this tool uses floating pilots to guide the cutter directly toward the flash hole of the case, resulting in a clean and uniform hole every time.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IGG8KiCW--/jifmwjmo4gmsd9outosz.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1622fa03-c777-41ad-a926-735a48c019fa',
		ProductID: '594268',
		ProductName: 'Match™ Grade Bushing .268',
		UPC: '090255592689',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592686',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.268',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bjTaZKNn--/cb9c3a074ee12e98209e916a853befd0d66e3492.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e1c241e9-f811-49da-ae3c-7334db90e76d',
		ProductID: '290049',
		ProductName: 'PTX™ Powder Measure Stop',
		UPC: '090255900491',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '1',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255900498',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '10.80',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This component is an add-on to your Case Activated Powder Drop that allows the reloader to adjust the flare on cases utilizing the top and bottom adjustment screws.',
		ProductImage: 'http://images.salsify.com/image/upload/s---MCZftTj--/trxt103c0cxhtwxpkod5.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5666bd80-15d8-40ac-888e-6d7dc1b773eb',
		ProductID: '81353',
		ProductName: '257 Roberts +P 117 gr SST® Superformance®',
		UPC: '090255813531',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.072',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255813538',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.72',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.39',
		MuzzleVelocity: '2946',
		MuzzleEnergy: '2255',
		SectionalDensity: '0.253',
		Cartridge: '257 ROBERTS+P',
		PressureRating: '+P',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'SST®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jgFBy3yW--/f46cd2c325636e3ec3ebcf6f1bc54634d3b436ba.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b588d35-9f4b-45a3-9afe-7c0a1d5ee462',
		ProductID: '043320',
		ProductName: 'Lock-N-Load® Sonic Cleaner™ 2L 110v',
		UPC: '090255433203',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.25',
		ShelfWidth: '10.75',
		ShelfDepth: '8.5',
		Weight: '7.213',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255433200',
		CartonHeight: '18.500',
		CartonWidth: '12.500',
		CartonDepth: '21.750',
		CartonWeight: '28.852',
		PalletQtyBoxes: '112',
		Retail: '222.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Features an 80 watt ceramic heater that enhances cleaning action, which is especially helpful when cleaning gun parts. Its large 2 liter stainless steel tank holds up to three hundred 223 cases or one hundred fifty 308 cases. Combined with One Shot® Sonic Clean™ solution, its microjet action removes carbon residue and other debris from internal and external surfaces of cartridge cases, small gun parts and other small metal equipment. The cleaner’s 5 to 30 minute timer allows you to choose the appropriate cycle for your application. Tank dimensions: 7.25” x 6” x 3” (2L)',
		ProductImage: 'http://images.salsify.com/image/upload/s--5T68-VKd--/odu8uwsgxu677aovdwvt.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dcyJ77Ab--/yqrh71bwog2ayhjq8cqe.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--thVenlRV--/ii0xinl9ztibnit4yyng.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--QKmUU2Dv--/s0qyf6tloaptcuysfph1.jpg',
		Videos: 'https://vimeo.com/182566395',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e6ac6539-a6ff-4895-bbed-a817ce4bb408',
		ProductID: '043350',
		ProductName: 'Lock-N-Load® Sonic Cleaner™ 110v',
		UPC: '090255433500',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.25',
		ShelfWidth: '10.75',
		ShelfDepth: '8.5',
		Weight: '4.430',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255433507',
		CartonHeight: '17.500',
		CartonWidth: '18.000',
		CartonDepth: '22.000',
		CartonWeight: '35.44',
		PalletQtyBoxes: '0',
		Retail: '201.71',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Using a combination of intense ultrasonic cleaning action and a unique cleaning solution, this cleaner quickly removes tarnish, oxidation, and carbon buildup from the entire case, including the inside walls and primer pockets. Use it to clean gun parts and equipment as well. Holds up to two hundred 223 cases or one hundred 308 cases. 1.2L Tank.',
		ProductImage: 'http://images.salsify.com/image/upload/s--DImn9ky---/hxovoops65ydqvv9lwxn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--URgK6tlw--/heegqrsohyzu2ne9k7r8.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dcyJ77Ab--/yqrh71bwog2ayhjq8cqe.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b0ded6ee-b8c0-454e-bdb9-dca3ec8f24de',
		ProductID: '380723',
		ProductName: 'Cartridge Gauge 7mm PRC (.284)',
		UPC: '090255807233',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.355',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807230',
		CartonHeight: '9.000',
		CartonWidth: '5.000',
		CartonDepth: '3.000',
		CartonWeight: '3.55',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067?embedded=true&source=vimeo_logo&owner=28327899',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ded38702-faba-4329-a6e5-92908acecda5',
		ProductID: '546291',
		ProductName: 'Full-Length 2-Die Set 6.5 Grendel (.264)',
		UPC: '090255562910',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.407',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562917',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.035',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a8a1b43-a4cc-49c2-8c16-efaa322cfefd',
		ProductID: '3039B',
		ProductName: '30 Cal .308 155 gr BTHP Match',
		UPC: '090255696004',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '45.416',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonUCC: '10090255696001',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '90832.0',
		PalletQtyBoxes: '84000',
		Retail: '0.37',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.405',
		SectionalDensity: '0.233',
		OAL: '1.15',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EO6fiofg--/c98b36f5b760f414a54a28f6b5e20ef2123ace9b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df97cf73-eea1-489e-8194-3d9a45b9c4bd',
		ProductID: 'D400',
		ProductName: 'Lock-N-Load® Headspace Bushing .400',
		UPC: '090255704549',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704546',
		CartonHeight: '4.750',
		CartonWidth: '10.500',
		CartonDepth: '7.250',
		CartonWeight: '1.0',
		PalletQtyBoxes: '0',
		Retail: '10.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. Bushing only. Works with Headspace Gauge, sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VFSOFiSc--/jrryvcxrj7b7lor5idtf.jpg',
		Videos: 'https://vimeo.com/288805295',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '73d72018-24b8-4ad7-a9d3-ab7c08a7ca68',
		ProductID: '90511',
		ProductName: '357 Mag 135 gr FlexLock® Critical Duty®',
		UPC: '090255905113',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.885',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905110',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.85',
		PalletQtyBoxes: '1120',
		Retail: '46.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.17',
		MuzzleVelocity: '1275',
		MuzzleEnergy: '487',
		SectionalDensity: '0.151',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zEGLD8Zp--/b7c5b81d15019afcce9adbb98ac929f8410ac632.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e5e7254-7021-46b4-adf2-7f5685b830aa',
		ProductID: '80259',
		ProductName: '223 Remington 73 gr ELD® Match Superformance® Match',
		UPC: '090255802597',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802594',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.5',
		PalletQtyBoxes: '1680',
		Retail: '27.79',
		ParentCategory: 'Ammunition',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		G7BC: '0.2',
		SectionalDensity: '0.208',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '73',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge your match rifle! Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Topped with the finest bullets, Superformance® Match™ ammunition marries the very best cartridge cases with extremely stable propellants. These propellants are custom blended for each individual load to provide true ammunition performance enhancement. FAST Superformance®  Match™ ammunition achieves muzzle velocities of 100 – 200 fps faster than ANY conventional ammunition.  ACCURATE Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Superformance® Match™ ammunition - the limits have been broken!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--X4fswI-K--/c475184b2ba83dbaf8b2f846493cd99ddb26158c.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fxQklJQm--/4bf5832ae89ac281a28b1c8791caa71c71f5dcc5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1p4zt9b5--/g5lr8ycpphdp3sqhisg3.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s---8dZEoUU--/v6e5gygwqep8fdkfzjlz.jpg',
		Videos: 'https://vimeo.com/241896524',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a43fd5dc-c26f-41fa-be72-2bc7a070a51f',
		ProductID: '99218',
		ProductName: 'Hornady® 75th Anniversary Cap',
		UPC: '090255992182',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '12.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--eDtz4_HV--/gzfektv10quoif1af0h4.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--eDtz4_HV--/gzfektv10quoif1af0h4.png',
		DateLastModified: '2023-12-19 20:08:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92f16c9d-467c-416d-9a71-dd4fc12d59ea',
		ProductID: '80986',
		ProductName: '308 WIN 165 gr GMX® Outfitter®',
		UPC: '090255809862',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.245',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809869',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.45',
		PalletQtyBoxes: '1400',
		Retail: '54.27',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LNmFEZTM--/090d44ea0912babee6143143e2a3453f096f5624.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0828e791-a0a6-4990-a86c-70e7b11680cd',
		ProductID: '190236',
		ProductName: 'Powder Bushing 507',
		UPC: '090255192360',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.054',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192367',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.54',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1ba2e5d7-7187-4702-9f1b-3ef54aa7cbb9',
		ProductID: '22721',
		ProductName: '270-6.8mm .277 110 gr V-MAX® with cannelure',
		UPC: '090255227215',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.679',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227212',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '41.975',
		PalletQtyBoxes: '900',
		Retail: '46.53',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.37',
		SectionalDensity: '0.205',
		OAL: '1.035',
		Caliber: '6.8MM/270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'V-MAX® W/C',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--yVfEdyMF--/f234ef84dbb37ce5843699b00d0ddf6744dd9dd4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90c9bbd6-ab6e-4987-afea-bcb2600e644e',
		ProductID: '30193',
		ProductName: '30 Cal .308 180 gr GMX®',
		UPC: '090255301939',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.370',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255301936',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.25',
		PalletQtyBoxes: '900',
		Retail: '55.91',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fY4_sWX5--/0b1fd2fd6fec8e178d75b9037985cde28dbeca3b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1898a750-8439-4a20-84fb-68a19d650685',
		ProductID: '2249B',
		ProductName: '22 Cal .224 52 gr BTHP Match',
		UPC: '090255690309',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '45.701',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255690306',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '274206.0',
		PalletQtyBoxes: '252000',
		Retail: '0.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.229',
		SectionalDensity: '0.148',
		OAL: '0.712',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '52',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zUzRHkik--/bf35d3f90ccdd8b846451cf85f3fcb10277754a0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5500a20d-a852-4449-b2fe-5ef4d09259d5',
		ProductID: '046051',
		ProductName: 'Neck Size Die 270 (.277)',
		UPC: '090255460513',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.532',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460510',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd6c3cd32-23ca-4d7a-b078-cfdcaed7ac3c',
		ProductID: '82246',
		ProductName: '450 Bushmaster 250 gr FTX® Hornady BLACK®',
		UPC: '090255822465',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822462',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.0',
		PalletQtyBoxes: '930',
		Retail: '52.91',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.21',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '2687',
		SectionalDensity: '0.175',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'FTX®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--n6tlDDIa--/db5d5fe985860de2aeb1a2952694d1887d1b778f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af69475c-14f8-40d1-a85b-12555d876ba1',
		ProductID: '50100',
		ProductName: '500 S&W .500 350 gr XTP® Mag',
		UPC: '090255600148',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.624',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255600145',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.36',
		PalletQtyBoxes: '540',
		Retail: '69.15',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.145',
		SectionalDensity: '0.2',
		OAL: '0.76',
		Cartridge: '500 S&W MAG',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '350',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'eXtreme Terminal Performance — Magnum Designed for personal defense and medium-game hunting, XTP® Mag™ bullets provide the same controlled expansion, accuracy and dependability that have made XTP® bullets a favorite among target shooters and hunters alike. But XTP® Mag™ bullets are designed to take things a step further — withstanding the higher velocities and impacts of ultra-powerful, magnum handguns while delivering even deeper penetration than standard XTP® bullets. CONTROLLED EXPANSION Precise serrations divide the XTP® Mag™ into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP® Mag™, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Gipwhyja--/c52651abbe3420f73ad697e49c62eb470cff2e15.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--fNEP3eEi--/c6xiskezhxjfyogooood.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--F_Cbrvpn--/tpherltglxbuacgasgkq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--Wu1gxnR3--/aubrxvxeyt2d14nfehgo.jpg',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1478fcff-7a76-4c38-a9af-720f25b15b7d',
		ProductID: '046581',
		ProductName: 'Size Die 50 AE',
		UPC: '090255465815',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465812',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '50 AE',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e32cf4e-b991-4b1a-822d-c4ff43a5bbde',
		ProductID: '085521',
		ProductName: 'Iron Press®Kit With Auto Prime',
		UPC: '090255855210',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8',
		ShelfWidth: '17.75',
		ShelfDepth: '21',
		Weight: '42.500',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '8.000',
		CartonWidth: '17.750',
		CartonDepth: '21.000',
		CartonWeight: '42.5',
		PalletQtyBoxes: '20',
		Retail: '785.11',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The next evolution in single stage press technology. The Lock-N-Load® Iron Press® loader is built to be the heaviest, most rigid press in its class. Tight tolerances in manufacture and assembly combine to provide consistency and precision that will deliver match accurate ammunition, round-after-round, year-after-year. LOCK-N-LOAD® BUSHING SYSTEM Incorporating our patented Lock-N-Load® bushing system, changeovers are lightning fast.  PATENTED SHELL HOLDER PLATFORM The Iron Press® loader, with its patented shell holder platform, allows handloaders to deprime, pause and remove the case to chamfer and deburr, etc., then easily replace and prime.  AUTOMATIC PRIMING SYSTEM The gravity fed Automatic Priming System (sold separately or with the Kit) and innovative accessory mounting deck helps increase reloading efficiency by allowing more processes to happen simultaneously.  SUPERIOR STRENGTH Industry leading strength and further ease of use comes from the spring assist 1-1/8" solid steel ram.  ACCESSORY DECK The accessory mounting deck provides quick access to trays for bullets or cases, and storage for chamfer and deburr tools, case neck brushes, primer pocket cleaners and more. Blurring the lines between single stage and progressive reloading, the Lock-N-Load® Iron Press® Kit is a full-featured reloading kit offering rugged reliability for years of precision reloading.  Includes: Lock-N-Load® Iron Press® Automatic Priming System Die Caddy Component Feed Bin & Bracket Lock-N-Load® Die Bushings (3) Lock-N-Load® Bench Scale Powder Measure Reloading Handbook Unique™ Case Lube Powder Funnel 22-45 cal Digital Caliper Bullet Comparator Set of 6 Shell Holder Kit Chamfer & Deburr Tool Six Neck Brushes Large & Small Primer Pocket Cleaners',
		ProductImage: 'http://images.salsify.com/image/upload/s--Cvj9afn4--/v5msoq3pdilsgxgsp123.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bHApt5M4--/y2vkgji3rfjvrntbubbj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s----OVtRI6--/issvcqyhizyspyqdmcgq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--3GFp8DQL--/ntysbfxerony7xr0nkc9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--2y_OJ9h0--/gvquyhbnelmly6wyelwa.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		Videos: 'https://vimeo.com/163452828',
		Videos1: 'https://vimeo.com/171591391',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '80236f00-cd0c-402d-a635-c4a4f04f6d32',
		ProductID: '544397',
		ProductName: 'Match™ Grade 2-Die Set 338 Norma Mag (.338)',
		UPC: '090255543971',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543978',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '8.0',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '338 NORMA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0ba39f5-33bf-43d3-b0ae-6ea7a9d29020',
		ProductID: '30713',
		ProductName: '30 Cal .308 178 gr ELD® Match',
		UPC: '090255307139',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.668',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307136',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.02',
		PalletQtyBoxes: '540',
		Retail: '58.68',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.547',
		G7BC: '0.275',
		MinTwist: '1-12"',
		SectionalDensity: '0.268',
		OAL: '1.325',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zZURpBtU--/0dde27a9cc60f78535dacef7636c284ad03ef770.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce22a1b4-67f2-4acd-bca4-00ea45a2b94a',
		ProductID: 'FR1405',
		ProductName: '223 Remington 55 gr HP Match Frontier',
		UPC: '090255716153',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.45',
		ShelfDepth: '3.75',
		Weight: '0.732',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255716150',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '7.32',
		PalletQtyBoxes: '1190',
		Retail: '47.00',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--sLCwcKvE--/208f5993336e359d8aa55fe7c8001da04d77db57.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e0918ea-0bff-45bf-b9b2-7ecffaf57b35',
		ProductID: '6414',
		ProductName: '#4 Buckshot .240 Diameter',
		UPC: '090255264142',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '5.247',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255264149',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.482',
		PalletQtyBoxes: '216',
		Retail: '45.48',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Buckshot',
		SectionalDensity: '0.01',
		BulletDiameter: '0.24',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#4',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made with the same dedication to uniformity as Hornady bullets, Hornady Buckshot is cold swaged using a lead alloy hardened with antimony to prevent deformities after firing. This helps it fly straighter and hit harder.  We use a strict roundness tolerance of +.001" to put more pellets in your targets. The industry standard is a +.006" tolerance.  Buckshot is sold in 5 lb. boxes',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kGuNc0W0--/odfe8zcqalmhlpl8jkro.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--syzEbs0s--/vy1pcboy20o71zmmwqd7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lTGpXr3O--/xa4ijamzgeifkytjhkzi.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c38f9542-48ed-452d-8e29-6973f1b616f1',
		ProductID: '820264',
		ProductName: '300 Win Mag 165 gr. CX™ Superformance®',
		UPC: '090255719987',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.608',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719984',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.08',
		PalletQtyBoxes: '780',
		Retail: '76.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.440',
		MuzzleVelocity: '3260',
		MuzzleEnergy: '3893',
		SectionalDensity: '0.248',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--htFGfwKv--/jzcyvtmlxmpakdf4y3if.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df7eac7f-03d9-45d4-a805-2ce6921891df',
		ProductID: '90080',
		ProductName: '380 Auto 90 gr FTX® Critical Defense®',
		UPC: '090255900804',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.608',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900801',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '6.08',
		PalletQtyBoxes: '1120',
		Retail: '36.44',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.099',
		MuzzleVelocity: '1000',
		MuzzleEnergy: '200',
		SectionalDensity: '0.102',
		Cartridge: '380 AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FTX®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kGwpPIGA--/31d5ca9c114799b15389d76a671c06965a18d84c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '28cd4e14-a75b-4ec2-9c39-18314892c3a5',
		ProductID: '046212',
		ProductName: 'Full-Length Size Die 5.7X28 FN (.224)',
		UPC: '090255462128',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462125',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '5.7X28MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39eace4a-a3da-4b0f-ae46-50c343c7ad6c',
		ProductID: '390602',
		ProductName: 'Shell Holder #46',
		UPC: '090255906028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906025',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '07c2ccee-db54-4d41-b497-2f14b8a3092d',
		ProductID: '044117',
		ProductName: 'Seater Die #17 338 WM/340 Wby/8.15',
		UPC: '090255441178',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.601',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441175',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b797f1dc-a0b0-461d-9d90-f056921a64d4',
		ProductID: '75840',
		ProductName: 'Snapsafe® 8 Gun Pistol Rack',
		UPC: '851529004372',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '19',
		ShelfWidth: '7',
		ShelfDepth: '6.25',
		Weight: '2.420',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004379',
		CartonHeight: '9.500',
		CartonWidth: '8.000',
		CartonDepth: '20.000',
		CartonWeight: '12.1',
		PalletQtyBoxes: '350',
		Retail: '23.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.25',
		ProductExtWidth: '18',
		ProductExtDepth: '7',
		ProductWeight: '2.2',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004373',
		MasterPackHeight: '9.500',
		MasterPackWidth: '8.000',
		MasterPackDepth: '20.000',
		MasterPackWeight: '60.5',
		ProductImage: 'http://images.salsify.com/image/upload/s--icSH1Yx_--/gb5sg3zvrh5qn7lua0lw.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8P5E7nNF--/qvbayujclglxateuo1tr.jpg',
		Videos: 'https://vimeo.com/213867149',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ba1b5060-3f8d-4e18-b7fb-b4a3f4d20ece',
		ProductID: '98002',
		ProductName: 'Hornady® Fueled By Hornady Sticker',
		UPC: '090255980028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '3',
		ShelfDepth: '7',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980025',
		CartonHeight: '6.875',
		CartonWidth: '2.500',
		CartonDepth: '1.500',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Black and red. Measures 5.625"x0.6875"',
		ProductImage: 'http://images.salsify.com/image/upload/s--MTd1xnX0--/n6mtwgfmegvz5hyexjqk.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ddd16602-d45d-41ae-9466-1de405eb4ae4',
		ProductID: '8257',
		ProductName: '450 Nitro Express 3¼ 480 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255382570',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.750',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382577',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '16.5',
		PalletQtyBoxes: '396',
		Retail: '243.91',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		MuzzleVelocity: '2150',
		MuzzleEnergy: '4927',
		SectionalDensity: '0.327',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '480',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mJihDaqN--/5079f2e9698da6b8be51e50373504aa8ce07bc96.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:45:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3b694044-c352-47cd-bb62-8147606b4092',
		ProductID: '355721',
		ProductName: '9mm .356 125 gr HAP®',
		UPC: '090255700947',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '9.283',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255700944',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.698',
		PalletQtyBoxes: '216',
		Retail: '125.93',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.158',
		SectionalDensity: '0.141',
		OAL: '0.575',
		Caliber: '9MM',
		BulletDiameter: '0.356',
		BulletName: 'HAP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--OtaGIF8U--/n3udakwoopku73k30dcu.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x967yH_W--/a69cfaa80a6548a4001290ab2d6cbeea13dcaa6e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '933e007c-b9ce-434e-abb8-3b21bc26dfd6',
		ProductID: '046238',
		ProductName: 'Full-Length Size Die 22/6mm (.224)',
		UPC: '090255462388',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462385',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '22-6MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6611d720-e62d-4c72-b870-f5fbb61fa812',
		ProductID: '81198',
		ProductName: '350 Legend 250 gr Sub-X® Subsonic',
		UPC: '090255811988',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.159',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811985',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.59',
		PalletQtyBoxes: '1400',
		Retail: '41.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady® Subsonic Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.265',
		MuzzleVelocity: '1050',
		MuzzleEnergy: '612',
		SectionalDensity: '0.283',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shhh... tell everyone! Hornady® Subsonic Ammunition — designed for accuracy and performance below the speed of sound — now comes in both rifle and handgun loads.  Subsonic Handgun utilizes tried-and-true XTP® bullets that expand reliably at subsonic velocities. The Sub-X bullet used in Subsonic Rifle features a lead core. Long grooves in its gilding metal jacket combine with the bullet’s flat profile and the patented Flex Tip® insert within its hollowpoint cavity to help it expand reliably at low velocities.  Powders are selected for optimal performance and consistency from lot to lot. PROVEN PERFORMANCE Performance of 300 Blackout Subsonic meets or exceeds FBI Protocol terminal ballistic test requirements. The XTP® bullet in Subsonic Handgun has built a world-class reputation for accuracy and stopping power.  SILENT AND STEALTHY Hornady® Subsonic Ammunition doesn’t have the loud report of a supersonic round, and paired with a suppressor, it’s even quieter. Unique powders optimized for subsonic use result in a low flash signature, ideal for either suppressed or unsuppressed performance.  HIGH-QUALITY COMPONENTS With high-quality cartridge cases and primers, Subsonic Ammunition offers the performance and accuracy shooters have come to expect from Hornady.  Disclaimer: This is subsonic, i.e., reduced velocity ammunition and will not produce the same muzzle energy as conventionally loaded cartridges. If hunting with this product, be sure to read, understand and comply with all applicable regulations and laws pertaining to bullet energy and/or muzzle velocity for the area and game to be hunted.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--c2oGeYs_--/wnbpikxtswatfcbcu01l.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--OnqiCBwm--/wktymirx2pkjw3kwuav5.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--txOthdI0--/rqrsgcn95zanqjwccxhh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c2oGeYs_--/wnbpikxtswatfcbcu01l.png',
		Videos: 'https://vimeo.com/606897316',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8ab1714-ef2b-41d5-8687-f4922f54be08',
		ProductID: '044592',
		ProductName: 'Expander Die 44 Spl Cowboy™ (.430)',
		UPC: '090255445923',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445920',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be0572fb-5c06-4c05-9631-435c937ee16a',
		ProductID: '546524',
		ProductName: 'Full-Length 3-Die Set 38 Super Auto (.355)',
		UPC: '090255565249',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565246',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '38 SUPER AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'edd2422a-c457-4898-89b8-dd78a8002253',
		ProductID: '98161',
		ProductName: 'Hornady® RAPiD® Safe Key Fob (2 Pack)',
		UPC: '090255981612',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5',
		ShelfWidth: '3.5',
		ShelfDepth: '0.001',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981619',
		CartonHeight: '1.000',
		CartonWidth: '6.000',
		CartonDepth: '3.000',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '8.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RFID Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		ProductExtHeight: '1.75',
		ProductExtWidth: '1.125',
		ProductExtDepth: '0.001',
		ProductWeight: '0.005',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.  Dimensions: 1.125"H x 1.5"W x 0.125"D IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--JyYNWBgh--/isncdkgylrxycw9eiemf.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '71240e6b-b744-4831-b082-a085e0314659',
		ProductID: '82322',
		ProductName: '375 H&H 300 gr DGS®',
		UPC: '090255823226',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.030',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823223',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '12.18',
		PalletQtyBoxes: '396',
		Retail: '133.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.275',
		MuzzleVelocity: '2530',
		MuzzleEnergy: '4263',
		SectionalDensity: '0.305',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'DGS®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--MQKoDqfZ--/d4278f70c354fa9fb6848fae8e1ffd8fd08477d5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fcf0c1d2-46c1-4f3c-a80b-b28740bdb82e',
		ProductID: '8787',
		ProductName: '475 Linebaugh Unprimed Cases',
		UPC: '090255487879',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.250',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487876',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '11.25',
		PalletQtyBoxes: '200',
		Retail: '116.77',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '475 LINEBAUGH',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1da756e9-a150-41be-9ae1-318f2a534271',
		ProductID: '290038',
		ProductName: 'PTX™ Powder Through Expander .500',
		UPC: '090255699890',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.107',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255699897',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.07',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--sVircrRL--/uv3j6s8qvwmtq0e7bap2.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f530a550-b308-496e-a490-b1f98adf6f1b',
		ProductID: '190145',
		ProductName: 'Powder Bushing 381',
		UPC: '090255191455',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.066',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191452',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.66',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2d42045d-f7ac-4cc9-9ca2-ff1f992df95b',
		ProductID: '546316',
		ProductName: 'Full-Length 2-Die Set 7mm/08 Rem (.284)',
		UPC: '090255563160',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.411',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563167',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.055',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '38b933aa-89be-4734-9526-d087b6c9be74',
		ProductID: '397108',
		ProductName: 'Seating Stem 30 Cal ELD® Match™/A-Max®',
		UPC: '090255971088',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971085',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.34',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '271af184-7012-4c0b-94d3-bb156b5d7931',
		ProductID: '80982',
		ProductName: '308 Win. 150 gr. CX™ Outfitter®',
		UPC: '090255809824',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.000',
		ShelfDepth: '5.250',
		Weight: '1.187',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809821',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.87',
		PalletQtyBoxes: '1400',
		Retail: '58.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.226',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--PJBQ9TJZ--/nu8tjnaydikxbg6myvka.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/294885426',
		Videos1: 'https://vimeo.com/295682086',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/343308040',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df627f21-b803-4c81-ae36-68ef1b28506e',
		ProductID: '044517',
		ProductName: 'Expander Die 9mm Luger/380 Auto (.355)',
		UPC: '090255445176',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.501',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445173',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06dd7a77-9fae-431d-97a1-36b5130518d9',
		ProductID: '392644',
		ProductName: 'Shell Plate #44 Lock-N-Load®AP™ & Projector',
		UPC: '090255926446',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.569',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926443',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.69',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4201c03-f26b-4ef1-8d95-c90fd7f3a16a',
		ProductID: '390542',
		ProductName: 'Shell Holder #2',
		UPC: '090255905427',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905424',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3b681aef-db62-4cd1-b750-503af1f3e59e',
		ProductID: '190198',
		ProductName: 'Powder Bushing 441',
		UPC: '090255191981',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.062',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191988',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.62',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e250e8db-cf7c-4425-9015-01033a7446c1',
		ProductID: '046391',
		ProductName: 'Full-Length Size Die 338 Win Mag (.338)',
		UPC: '090255463910',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463917',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc41cea7-f8b7-4f76-91e8-5289ad5f8435',
		ProductID: '6040',
		ProductName: '45 Cal .440 Lead Balls',
		UPC: '090255260403',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.924',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260400',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '48.1',
		PalletQtyBoxes: '900',
		Retail: '14.92',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '45 CAL',
		BulletDiameter: '0.44',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b00c4cd1-68bb-4b67-afd8-3279264e05a4',
		ProductID: '75210',
		ProductName: 'Snapsafe® Lock Box With Key Lock XL',
		UPC: '851529004242',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '4.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004249',
		CartonHeight: '11.250',
		CartonWidth: '9.000',
		CartonDepth: '12.250',
		CartonWeight: '22.0',
		PalletQtyBoxes: '500',
		Retail: '40.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '6',
		ProductIntHeight: '1.75',
		ProductIntWidth: '6.75',
		ProductIntDepth: '9.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. SPECIFICATIONS Dimensions: 10” x 7” x 2” Weight: 6 lbs  FEATURES Easy to operate steel key lock mechanism. Keyed option includes two keys that are keyed alike. 1500 lb. rated 4 ft. steel security cable. Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.",
		ProductImage: 'http://images.salsify.com/image/upload/s--zMOpd9aD--/mgxtblfazei7lcnilgmx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OJP73Ksq--/tgcxjcq0qtzevtshrlgl.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--T4EoiTF3--/ilddcctlwgoslgjhkbss.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DGMC54d3--/wnieakapnjxcjclhhete.jpg',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eec46766-c3de-4da0-ae7f-bc0dc93c6e67',
		ProductID: '594290',
		ProductName: 'Match™ Grade Bushing .290',
		UPC: '090255592900',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.024',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592907',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.24',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.29',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ROV89R2k--/b7088d5ae9115b9d24c03906a6af233039b0e480.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ba99a60-af35-443d-a1e4-226d7ca4691f',
		ProductID: '546234',
		ProductName: 'Full-Length 2-Die Set 5.6X50 Mag (.224)',
		UPC: '090255562347',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562344',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '5.6X50 MAG',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8e51d96d-3a14-4373-87d2-d3be7fae01be',
		ProductID: '2561',
		ProductName: '25 Cal. .257 134 gr. ELD® Match',
		UPC: '090255225617',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255225614',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '27.75',
		PalletQtyBoxes: '540',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '.645',
		G7BC: '.325',
		MinTwist: '1-7.5"',
		SectionalDensity: '0.29',
		OAL: '1.447',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '134',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot. Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape. DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet. ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions. THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range. INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--RiIUTzc---/npkvj1hy1hqmysufrlsi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/762697797',
		DateLastModified: '2024-03-04 15:45:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5b34fe92-fb63-48f1-865b-0481858f1561',
		ProductID: '3236',
		ProductName: '8mm .323 195 gr InterLock® SP',
		UPC: '090255232363',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.938',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255232360',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.07',
		PalletQtyBoxes: '540',
		Retail: '76.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.41',
		SectionalDensity: '0.267',
		OAL: '1.22',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '195',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--CIiBY5Xv--/368a68d419531d252af21dd06dfdd23340391208.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b7d0db6e-6e61-4c6a-9ccb-a1a3b3e23632',
		ProductID: '544323',
		ProductName: 'Match™ Grade 2-Die Set 280 Ackley Imp (.284',
		UPC: '090255543230',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543237',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.75',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '897fbaea-bcbb-4d5c-af41-28b4ffa207f2',
		ProductID: '81569',
		ProductName: '7-30 Waters 120 gr FTX LEVERevolution',
		UPC: '090255815696',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.990',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815693',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.9',
		PalletQtyBoxes: '1400',
		Retail: '56.40',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.320',
		SectionalDensity: '0.213',
		Cartridge: '7-30 WATERS',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'FTX®',
		BulletWeightGrain: '120',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance. NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines. MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance. OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance.  MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power. In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps. NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--SHrVXRjn--/sobxh3jvpkfunubhdnde.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		Videos1: 'https://vimeo.com/367326209',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '923e4fa1-ad8a-45cf-ab10-1cf08e5c5b49',
		ProductID: '22760B',
		ProductName: '22 Cal .224 62 gr FMJ',
		UPC: '090255266269',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '49.844',
		WeightUOM: 'LB',
		CaseQty: '5500',
		CartonUCC: '10090255266266',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '274142.0',
		PalletQtyBoxes: '231000',
		Retail: '0.13',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.274',
		SectionalDensity: '0.177',
		OAL: '0.735',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ',
		BulletWeightGrain: '62',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '57580',
		MasterPackUCC: '30090255266260',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '2870017.52',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Wy_crdFr--/w0qgcxzkrg610upbeq4a.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89cd4148-4d46-42ea-ba18-9a2a0b061a1e',
		ProductID: '22281',
		ProductName: '22 Cal .224 60 gr V-MAX®',
		UPC: '090255222814',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.936',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222811',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.44',
		PalletQtyBoxes: '1440',
		Retail: '31.60',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.265',
		SectionalDensity: '0.171',
		OAL: '0.873',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cMptbNS3--/d4a23b3de115f545ab8e576a40c960d6bb92d1b4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b05532a-6b55-42e7-87f5-6db4bb3b8ef9',
		ProductID: '046369',
		ProductName: 'Full-Length Size Die 7.65 Belg (.312)',
		UPC: '090255463699',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463696',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7.65 BELG',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '77597209-7d5d-4386-8605-4c7dca80ba9c',
		ProductID: '546217',
		ProductName: 'Full-Length 2-Die Set 22 Creedmoor (.224)',
		UPC: '090255562170',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.520',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562177',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.6',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '22 CREEDMOOR',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31d86a75-2d88-40ff-b675-f0403f9da0d1',
		ProductID: '22520',
		ProductName: '25 Cal .257 75 gr V-MAX®',
		UPC: '090255275049',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '1.139',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255275046',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.56',
		PalletQtyBoxes: '1440',
		Retail: '40.35',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.29',
		SectionalDensity: '0.162',
		OAL: '0.872',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Kbo4eNZ0--/22631dbd1d774a51294ab0493c05848bbdc7fcea.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '425dcd21-f8b9-4839-b5c3-99044dd59fac',
		ProductID: '85586',
		ProductName: '280 Ackley 162 gr ELD-X® Precision Hunter®',
		UPC: '090255855869',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.280',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255855866',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.8',
		PalletQtyBoxes: '1400',
		Retail: '81.84',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.631',
		G7BC: '0.318',
		MuzzleVelocity: '2850',
		MuzzleEnergy: '2921',
		SectionalDensity: '0.287',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--So2R4JDe--/332a1efdca03d06ddc1bdaaac60feb3df485443a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b0eb52b9-4ace-4ce0-aa1a-fd4d85fb9f04',
		ProductID: '8722B',
		ProductName: '9mm Luger Unprimed Cases',
		UPC: '090255710335',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '48.034',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255710332',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '288204.0',
		PalletQtyBoxes: '264000',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Handgun Cartridge Cases',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'abf8b9b2-e623-436a-8fae-44baff0585dd',
		ProductID: '99901',
		ProductName: 'One Shot® Gun Cleaner & Lube 10oz',
		UPC: '090255199017',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8',
		ShelfWidth: '2.75',
		ShelfDepth: '2.75',
		Weight: '0.965',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255199014',
		CartonHeight: '8.250',
		CartonWidth: '5.750',
		CartonDepth: '8.500',
		CartonWeight: '5.79',
		PalletQtyBoxes: '960',
		Retail: '23.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lubes, Cleaners & Polishes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'N-HEXANE',
		Prop65Chem2: 'Butadiene',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Aerosol Can',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® One Shot® with DynaGlide Plus® is a revolutionary formula developed to prevent firearm malfunctions caused by a buildup of lubricants and grime.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ohnjHjzp--/djhr5ba8dgwihqzt9mi3.jpg',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '488b0170-ff04-43a6-91b2-669d5890ad3e',
		ProductID: '044097',
		ProductName: 'Click-Adjust Bullet Seating Micrometer',
		UPC: '090255440973',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440970',
		CartonHeight: '6.000',
		CartonWidth: '2.500',
		CartonDepth: '2.500',
		CartonWeight: '5.0',
		PalletQtyBoxes: '0',
		Retail: '109.73',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '6.000',
		MasterPackWidth: '2.500',
		MasterPackDepth: '2.500',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precisely set bullet seating depth,  just like dialing a scope turret, in click  adjust .001" increments. It’s a quick  and easy way to achieve benchrest  accuracy and consistency without  the extra cost of another  seating die. Hornady ® die  sets already include an in line seater; simply replace  the standard seating  adjustment stem with  the Click-Adjust  Bullet Seating  Micrometer.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s---XZLWt0u--/udkwznslnb123muwviqq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s---XZLWt0u--/udkwznslnb123muwviqq.png',
		Videos: 'https://vimeo.com/876121739',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5cb9a8ed-f5f9-4512-a796-64e468a32176',
		ProductID: '070905',
		ProductName: 'Auto Primer Feed Classic/00-7',
		UPC: '090255709056',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.125',
		ShelfWidth: '3.625',
		ShelfDepth: '0.875',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255709053',
		CartonHeight: '6.000',
		CartonWidth: '8.000',
		CartonDepth: '10.000',
		CartonWeight: '2.5',
		PalletQtyBoxes: '0',
		Retail: '78.28',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Includes both large and small primer tubes. Use with our Positive Priming System™ and there's no more fumbling with primers — priming is 100% hands off. Sold separately.",
		ProductImage:
			'http://images.salsify.com/image/upload/s--Hug5v1r8--/8f2605eb62bb6a4be6c01348461f4e7404100881.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fbebf5c6-5938-4a1b-a0e0-cd45e8c726a1',
		ProductID: '98012',
		ProductName: 'Hornady® Security Sticker',
		UPC: '090255980127',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '4.5',
		ShelfDepth: '5.75',
		Weight: '0.001',
		WeightUOM: 'LB',
		CaseQty: '250',
		CartonUCC: '10090255980124',
		CartonHeight: '2.250',
		CartonWidth: '4.500',
		CartonDepth: '5.750',
		CartonWeight: '0.25',
		PalletQtyBoxes: '450000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red, white, and black with Hornady® Security lock graphic. Measures 4” x 5”',
		ProductImage: 'http://images.salsify.com/image/upload/s---Ey9uF06--/mykcxejaxdt4jovt2lg1.png',
		DateLastModified: '2024-01-30 10:45:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '876958b9-807c-4e96-b6f4-13eac0a2aadd',
		ProductID: '8208',
		ProductName: '300 Remington Ultra Mag 180 gr GMX Outfitter',
		UPC: '090255382082',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.730',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382089',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.3',
		PalletQtyBoxes: '780',
		Retail: '113.12',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--g-300-yr--/ex7yw8thsfchl6nypu0j.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		Videos4: 'https://vimeo.com/367123667',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db108869-b90a-4dae-a850-e96442dd460e',
		ProductID: '010047',
		ProductName: '366 Auto Loader 410 Ga 2-1/2',
		UPC: '090255010473',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '34.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255010470',
		CartonHeight: '20.250',
		CartonWidth: '16.375',
		CartonDepth: '11.750',
		CartonWeight: '34.0',
		PalletQtyBoxes: '27',
		Retail: '2063.53',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Shotshell Reloader',
		Cartridge: '410 BORE',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--a4Loa5IV--/zpxyo8tgcszncvdkddjg.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5cd487a2-847d-483e-88c8-1247c3d07739',
		ProductID: '046049',
		ProductName: 'Neck Size Die 7mm Short (.284)',
		UPC: '090255460490',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.502',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460497',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '602349e7-f8f2-407f-98ab-21b578ee585f',
		ProductID: '809864',
		ProductName: '308 Win 165 gr. CX™ Outfitter®',
		UPC: '090255719833',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.245',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719830',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.45',
		PalletQtyBoxes: '1400',
		Retail: '58.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.440',
		MuzzleVelocity: '2610',
		MuzzleEnergy: '2496',
		SectionalDensity: '0.248',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--_AC5TS4b--/eybh508unuus2iph2llz.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19c5f002-5b91-499c-afe5-608c84cfbb30',
		ProductID: 'E420',
		ProductName: 'Lock-N-Load® Headspace Bushing .420',
		UPC: '090255704617',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.103',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704614',
		CartonHeight: '4.750',
		CartonWidth: '10.500',
		CartonDepth: '7.250',
		CartonWeight: '1.03',
		PalletQtyBoxes: '0',
		Retail: '10.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		Caliber: '44 CAL',
		BulletDiameter: '0.42',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. Bushing only. Works with Headspace Gauge, sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VFSOFiSc--/jrryvcxrj7b7lor5idtf.jpg',
		Videos: 'https://vimeo.com/288805295',
		DateLastModified: '2023-12-16 08:55:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8b55a633-d904-48ec-817b-c1a42e11c3b1',
		ProductID: '811644',
		ProductName: '30-06 SPRG 180 gr. CX™ Outfitter®',
		UPC: '090255719857',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.320',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719854',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.2',
		PalletQtyBoxes: '1400',
		Retail: '60.45',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.469',
		MuzzleVelocity: '2600',
		MuzzleEnergy: '2702',
		SectionalDensity: '0.271',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--NOXCstg---/whprjwkxx4w9mmys5u6z.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75f1b622-d553-4a4b-a9ad-25a49c569610',
		ProductID: '99297',
		ProductName: 'Hornady® Kryptek Camouflage Cap',
		UPC: '090255992977',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '19.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'BANGLADESH',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZFa8lHEZ--/rr9enqmj5473f3zmvjji.jpg',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2cd9380c-811d-4cc8-9568-4dd8ee54857a',
		ProductID: '98253',
		ProductName: 'Ready Vault™ Metal Shelf',
		UPC: '090255982534',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '6.5',
		ShelfDepth: '10',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255982531',
		CartonHeight: '11.000',
		CartonWidth: '13.000',
		CartonDepth: '14.000',
		CartonWeight: '15.5',
		PalletQtyBoxes: '0',
		Retail: '14.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '0',
		ProductExtWidth: '9',
		ProductExtDepth: '3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed to fit the RAPiD Safe Ready Vault but compatible with other Square-Lok™ products. 25 pound weight capacity. 9" x 6".',
		ProductImage: 'http://images.salsify.com/image/upload/s--schRtocc--/e7uelxzbwbshyqyjseid.jpg',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '323a04ce-5b48-49db-b9a5-8df8ee1d1113',
		ProductID: '044172',
		ProductName: 'Taper Crimp Die 45 Auto',
		UPC: '090255441727',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.409',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441724',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b561e8b3-e77c-47e6-bd01-63262155ec44',
		ProductID: '046504',
		ProductName: 'Size Die 30 Carbine (.308)',
		UPC: '090255465044',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.528',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465041',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '30 CARBINE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20d39d14-6574-4c9f-b2a1-4a728f5f5972',
		ProductID: '99126',
		ProductName: 'Hornady® Buck 110 Knife',
		UPC: '090255991260',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1.25',
		ShelfDepth: '4.5',
		Weight: '0.570',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '103.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Nickel (metallic)',
		Prop65Warn1:
			'Warning: This product contains Nickel (Metallic), a chemical known to the State of California to cause cancer , birth defects or other reproductive harm. Visit www.P6Warnings.ca.gov for more information.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Our 110 folding hunter knife features a Macassar Ebony Dymondwood handle and nickel-plated bolsters. The blade is made of 420 HC stainless steel for years of reliable use. Made in the USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--VvIKpAUW--/yr34ggix4rczyetquq2n.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9220bda2-e4a8-4fc6-a328-367b0025399a',
		ProductID: '27402',
		ProductName: '270 Cal .277 150 gr SST®',
		UPC: '090255274028',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.200',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255274025',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.0',
		PalletQtyBoxes: '540',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.525',
		SectionalDensity: '0.279',
		OAL: '1.365',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--BTwoXLCH--/98285d6ec85977e3dd0f00422b2745f93247f67a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e58ae68d-efee-485d-80fc-8478f449a364',
		ProductID: '044112',
		ProductName: 'Seater Die #12 (.308) 30 Cal W/147',
		UPC: '090255441123',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.603',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441120',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39d593bb-77c9-4c15-aa38-548d348cadee',
		ProductID: '99214',
		ProductName: 'Hornady® Black and Red Established Cap',
		UPC: '090255992144',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'BANGLADESH',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Jm8S6_po--/tjynwztsxhjgrm8pe2ry.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '458547df-ee80-45b5-bc14-fb60994c4efc',
		ProductID: '546299',
		ProductName: 'Full-Length 2-Die Set 6.8mm Rem SPC (.277)',
		UPC: '090255562996',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562993',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ff8bbaa4-c280-48e4-9399-faf94fd6c01a',
		ProductID: '6679',
		ProductName: 'Ramrod End SST® Profile 45 Cal',
		UPC: '090255266795',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.027',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255266792',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.27',
		PalletQtyBoxes: '0',
		Retail: '4.59',
		ParentCategory: 'Muzzleloading',
		Caliber: '45 CAL',
		BulletName: 'SST®',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Our muzzleloading ramrod tips are specially designed to protect the tip of Hornady SST-ML, MonoFlex ML and FPB bullets. These ramrod tips eliminate damage to the ogive while seating the bullet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--WnND60Bt--/nekasqazogizma59jshi.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c4676656-99d1-4f5d-8fe9-a876054abda8',
		ProductID: '8618B',
		ProductName: '224 Valkyrie Unprimed Cases',
		UPC: '090255712490',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '53.177',
		WeightUOM: 'LB',
		CaseQty: '3000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '159531.0',
		PalletQtyBoxes: '132000',
		Retail: '0.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '039be8cb-7040-4909-be93-e2beee4daae0',
		ProductID: '82731',
		ProductName: '30-30 Win 140 gr MonoFlex® LEVERevolution®',
		UPC: '090255827316',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.059',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827313',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.59',
		PalletQtyBoxes: '1400',
		Retail: '55.73',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.277',
		MuzzleVelocity: '2465',
		MuzzleEnergy: '1889',
		SectionalDensity: '0.211',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--F7C5epmC--/994661321e0b98dcbad02098c465bc774b489f57.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db0047a2-42f6-4473-ba55-54c2645eb8b8',
		ProductID: '8643',
		ProductName: '7mm Shooting Times Westerner Unprimed Cases',
		UPC: '090255486438',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486435',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.25',
		PalletQtyBoxes: '200',
		Retail: '103.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '7MM STW',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f93a5a4d-7edb-4b32-ab86-9e523a490023',
		ProductID: '81394',
		ProductName: '6mm Creedmoor 90 gr GMX Superformance',
		UPC: '090255813944',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.980',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255813941',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.8',
		PalletQtyBoxes: '1400',
		Retail: '55.45',
		ParentCategory: 'Ammunition',
		G1BC: '0.420',
		SectionalDensity: '0.218',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'GMX®',
		BulletWeightGrain: '90',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--lJMoydl0--/pwbehz89fymeeblfwgef.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '44abfd16-8aaa-4ffb-9e25-ab7ed5d3916e',
		ProductID: '290033',
		ProductName: 'PTX™ Powder Through Expander .430',
		UPC: '090255699876',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255699873',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd7d7b70d-4d8f-4949-9727-acec593baa12',
		ProductID: '2267',
		ProductName: '22 Cal .224 55 gr FMJ-BT with cannelure',
		UPC: '090255222678',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222675',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.0',
		PalletQtyBoxes: '1440',
		Retail: '17.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		OAL: '0.735',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YKqIkYCi--/haleg0vggquwzrcksimo.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd194777c-1c3c-4c21-8dc4-319bd571654f',
		ProductID: '390948',
		ProductName: 'Trimer Pilot #6 .277',
		UPC: '090255909487',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909484',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wrXob-WU--/aid4r09xs45nwt9no8qy.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f48caf15-af93-4ea2-8fc1-bf549c4c99f5',
		ProductID: '393299',
		ProductName: 'Unique™ Case Lube',
		UPC: '090255932997',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.75',
		ShelfWidth: '3',
		ShelfDepth: '3',
		Weight: '0.277',
		WeightUOM: 'LB',
		CaseQty: '12',
		CartonUCC: '10090255932994',
		CartonHeight: '5.250',
		CartonWidth: '7.000',
		CartonDepth: '6.750',
		CartonWeight: '3.324',
		PalletQtyBoxes: '0',
		Retail: '5.80',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lubes, Cleaners & Polishes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For those who want to use a high quality paste lube, this non-petroleum product will not contaminate powder or primers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--nR8uVpTd--/qphh8df9klk6oxtwhaui.jpg',
		DateLastModified: '2023-12-16 09:02:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e3e8918-0911-46ea-b872-8e431aaeb86d',
		ProductID: '3711',
		ProductName: '375 Cal .375 270 gr InterLock® SP-RP',
		UPC: '090255237115',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.036',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255237112',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '50.9',
		PalletQtyBoxes: '900',
		Retail: '48.44',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.38',
		SectionalDensity: '0.274',
		OAL: '1.215',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '270',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RwRGG6pH--/d42cb19895019100c3f252b598a924bc2bbd156f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '33167b81-34c5-41a3-9d38-755e2c50632f',
		ProductID: 'B378',
		ProductName: 'Lock-N-Load® 378 Wby Mag Modified Case',
		UPC: '090255704716',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.053',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704713',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.53',
		PalletQtyBoxes: '0',
		Retail: '8.73',
		ParentCategory: 'Reloading',
		Cartridge: '378 WBY MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b20f57cf-1c79-4aa8-98ee-3102b0b6bafe',
		ProductID: '546370',
		ProductName: 'Full-Length 2-Die Set 7.7 Jap (.312)',
		UPC: '090255563702',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.472',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563709',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.36',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7.7 JAP',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c2a9719-ce12-4413-bc58-1fa0659954e2',
		ProductID: '3330',
		ProductName: '338 Cal .338 250 gr InterLock® RN',
		UPC: '090255233308',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.722',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255233305',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.83',
		PalletQtyBoxes: '540',
		Retail: '96.17',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.291',
		SectionalDensity: '0.313',
		OAL: '1.298',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4rmLNkkE--/4a38822e3703c693409c0195853253505cd28eea.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e784495-eb00-4089-adba-e2b351342e6d',
		ProductID: '594262',
		ProductName: 'Match™ Grade Bushing .262',
		UPC: '090255592627',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592624',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.262',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9oeFJ4PQ--/e43040c6d4b37b08d6dda90dec1e1bcd63d7f12d.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '41a8d9bc-2254-4b55-b4ff-f7a20b5f9703',
		ProductID: '95793',
		ProductName: '4-Gun Rack',
		UPC: '090255957938',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12.75',
		ShelfWidth: '4.75',
		ShelfDepth: '5.25',
		Weight: '2.100',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957935',
		CartonHeight: '13.250',
		CartonWidth: '5.750',
		CartonDepth: '24.500',
		CartonWeight: '10.5',
		PalletQtyBoxes: '0',
		Retail: '27.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--UDxYnPxa--/bi5xnczo5rv8zu6odpu3.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--UDxYnPxa--/bi5xnczo5rv8zu6odpu3.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--2Apk07v3--/akfevpmdibcuxujd7eee.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--qynzkg7T--/igyu8kkd53vcbxfbrzbb.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72acf182-711f-425d-91fe-211107ee52bb',
		ProductID: '75902',
		ProductName: 'Snapsafe® Canister Dehumidifier',
		UPC: '851529004655',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.25',
		ShelfWidth: '6',
		ShelfDepth: '6',
		Weight: '2.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004652',
		CartonHeight: '5.000',
		CartonWidth: '6.000',
		CartonDepth: '28.000',
		CartonWeight: '12.0',
		PalletQtyBoxes: '700',
		Retail: '32.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'COBALT DICHLORIDE',
		Prop65Chem2: 'COBALT DICHLORIDE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '4',
		ProductExtWidth: '5',
		ProductExtDepth: '5',
		ProductWeight: '2',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Protect your valuables against rust and corrosion by utilizing this SnapSafe® Canister Dehumidifier. When the cap indicator turns pink from moisture, the canister is ready to be recharged.  To recharge: place unit in the oven at 325ºF for two hours. Unlimited recharges allows for a lifetime of use. Prevents moisture that can cause rust and mildew in isolated areas like gun safes, cabinets and closets. Indicator system with built in signal to inform user when unit needs recharged. Small, lightweight and requires no batteries. Unlimited recharges ensure a lifetime of use. 5-inch diameter cylinder',
		ProductImage: 'http://images.salsify.com/image/upload/s--2c4KMmBg--/mgrjmoij5s8uzaxbqmry.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--qsmMw_Ov--/m8wya31k6qwqelcb9tsh.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--sTv5ThbB--/baig1rqztnijuk5pvaeo.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--39UikqM3--/dvkmjthdgi3jkalvtd6w.jpg',
		Videos: 'https://vimeo.com/221604896?embedded=true&source=video_title&owner=28327899',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f11e0c01-8831-4b74-928e-bb1c9ed17c1e',
		ProductID: '546545',
		ProductName: 'Full-Length 3-Die Set 44 Auto Mag (.430)',
		UPC: '090255565454',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565451',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '44 AUTO MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfb8ea8a-128b-44d8-b43f-60766e848b72',
		ProductID: '046285',
		ProductName: 'Full-Length Size Die 6.5X57 (.264)',
		UPC: '090255462852',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462859',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X57',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f1a3b799-2f79-4f43-b5e2-1c65ec08d20d',
		ProductID: '044155',
		ProductName: 'Seater Die (.500) 50 AE',
		UPC: '090255441550',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.480',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441557',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '058d0e8c-7cb5-419f-94df-ffaccfed2ac4',
		ProductID: '30501B',
		ProductName: '30 Cal .308 168 gr BTHP Match',
		UPC: '090255691399',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '44.330',
		WeightUOM: 'LB',
		CaseQty: '1800',
		CartonUCC: '10090255691396',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '79794.0',
		PalletQtyBoxes: '75600',
		Retail: '0.37',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.450',
		SectionalDensity: '0.253',
		OAL: '1.23',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1Xn9M-v9--/4fff3186b6a911324d1eabacee1d69431239ab79.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a1074244-ee1f-41be-b6ca-402ba564c423',
		ProductID: '546428',
		ProductName: 'Full-Length 2-Die Set 416 Rigby (.416)',
		UPC: '090255564280',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564287',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '416 RIGBY',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8a342ca3-f522-4725-a2ad-0a6f56aa00ee',
		ProductID: 'FR202',
		ProductName: '5.56 NATO 55 gr FMJ (M193) Frontier®',
		UPC: '090255711400',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '3.75',
		ShelfWidth: '6.453',
		ShelfDepth: '3.656',
		Weight: '4.187',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255711407',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '16.748',
		PalletQtyBoxes: '480',
		Retail: '75.00',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--k_dmxE2j--/4c21a60d82869d46a853c442ab24f0f343134343.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '82b0d9b2-85de-4318-875f-c3ad1a093ecf',
		ProductID: '37084',
		ProductName: '375 Cal .375 250 gr CX™',
		UPC: '090255370843',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255370840',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.5',
		PalletQtyBoxes: '540',
		Retail: '74.05',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.403',
		SectionalDensity: '0.254',
		OAL: '1.55',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'CX™',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--rcRCrEu---/eqsfvjnoy3l2f7rgvkt2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5b2b06b-3ce6-4fbb-986c-0aa09a94f42f',
		ProductID: '98180',
		ProductName: 'Hornady® RAPiD® Safe Shotgun Wall Lock',
		UPC: '090255981803',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5',
		ShelfWidth: '10',
		ShelfDepth: '11.25',
		Weight: '6.500',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255981800',
		CartonHeight: '12.250',
		CartonWidth: '10.750',
		CartonDepth: '16.000',
		CartonWeight: '26.0',
		PalletQtyBoxes: '240',
		Retail: '289.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '8.5',
		ProductExtWidth: '9.2',
		ProductExtDepth: '2.7',
		ProductWeight: '5.676',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed specifically for shotguns, this safe can be mounted horizontally or vertically in closets, behind doors — anywhere you want quick access using an RFID tag. These safes feature the same convenient and tamperproof security as our other RFiD-enabled safes. RFID[2] activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS For secondary entry method, user can program a four to six digit security code.  CERTIFIED CHILD-RESISTANT Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and hinge attack resistance.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 14 gauge steel with two internal hardened locking lugs.  EASY INSTALLIATION The pre-drilled mounting holes make installation quick and easy. Mount in a horizontal or vertical position in closets, behind doors — anywhere you would like quick access using an RFiD tag.  Contents Include: RAPiD® Safe, Wall Power Supply, RFID Wristband, two RFID Stickers, RFID Key Fob, two Circular Barrel Keys.  Features: Keypad, Vertical/Horizontal Mount Type: Fits most shotguns[1] Exterior Dimensions: 8.5"H x 9.2"W x 2.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--wQydIfwZ--/rfhw90klwahple7i7xsg.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--T9phgXAs--/iees6wgflcxjeisgmy5m.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhGgNefR--/rhlaf8houp4p4srsvenf.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--iETT18qy--/iyk2gelsfoz90cwd24k9.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--LsL-xB8j--/fx77opdxxg3i6yryfmdx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--d7LIOf8B--/a0pywl2a9e7bszaekmko.jpg',
		Videos: 'https://vimeo.com/190888308',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '624656a5-c273-422e-a4ea-60788b0c041d',
		ProductID: '98004',
		ProductName: 'Hornady® Red "H" Sticker',
		UPC: '090255980042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '3.25',
		ShelfDepth: '4.25',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980049',
		CartonHeight: '4.375',
		CartonWidth: '3.812',
		CartonDepth: '0.687',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'MIBK',
		Prop65Warn1:
			'Warning: This product can expose you to Methyl Isobutyl Ketone (MIBK), which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red and white. Measures 3.5"x3.5"',
		ProductImage: 'http://images.salsify.com/image/upload/s--qieV-S5h--/xdynlpdvfqwtkmtubkgm.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1755e2b8-d2ac-42e2-a582-edd735aeb4d0',
		ProductID: '8646B',
		ProductName: '7mm-08 Remington Unprimed Cases',
		UPC: '090255600728',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '48.177',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '96354.0',
		PalletQtyBoxes: '88000',
		Retail: '0.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f3d4495d-8228-4531-97ac-20e5634d40ea',
		ProductID: '35580',
		ProductName: '9mm .355 147 gr XTP®',
		UPC: '090255235586',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.200',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235583',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.0',
		PalletQtyBoxes: '900',
		Retail: '35.17',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.212',
		SectionalDensity: '0.167',
		OAL: '0.66',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '147',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--o_sXNMn---/104438830ad37d368c869cfe17ee2ba07e7e4719.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e12a0f9-14b6-475e-a35d-1610633a849a',
		ProductID: '8069',
		ProductName: '28 Nosler 162 ELD-X® Precision Hunter®',
		UPC: '090255380699',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.660',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380696',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.6',
		PalletQtyBoxes: '780',
		Retail: '90.04',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.631',
		G7BC: '0.318',
		MuzzleVelocity: '3175',
		MuzzleEnergy: '3626',
		SectionalDensity: '0.287',
		Cartridge: '28 NOSLER',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NiDmpYuM--/1521d23d178d5448b3012a3d0ac282084da5f79d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '359d8a32-b310-4514-b919-fffc29da79c9',
		ProductID: '8615',
		ProductName: '220 Swift Unprimed Cases',
		UPC: '090255486155',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486152',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '7.0',
		PalletQtyBoxes: '400',
		Retail: '64.60',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '220 SWIFT',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '166ac0d8-beab-4a42-9ec3-f19b23d351d6',
		ProductID: '8241',
		ProductName: '405 Win 300 gr InterLock® SP',
		UPC: '090255382419',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.773',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382416',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '10.638',
		PalletQtyBoxes: '396',
		Retail: '95.59',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.25',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '3224',
		SectionalDensity: '0.254',
		Cartridge: '405 WIN',
		Caliber: '405 CAL',
		BulletDiameter: '0.411',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--F3WHrjmq--/0c0b947cb553f991b317be4b6c55681189fc1313.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9961dc8-43d0-43a0-90b9-3cd892fb42ff',
		ProductID: '3039C',
		ProductName: '30 Cal .308 155 gr BTHP Match  with cannelure',
		UPC: '090255697490',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '45.416',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonUCC: '10090255697497',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '90832.0',
		PalletQtyBoxes: '84000',
		Retail: '0.37',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.405',
		SectionalDensity: '0.233',
		OAL: '1.15',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--qsPaA8ZW--/60fa806290e8d43939a21489c26f1400a04af0cb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e61213b-ce74-4bd5-af08-37f052e86200',
		ProductID: '050160',
		ProductName: 'Lock-N-Load® Case Prep Trio 110/220 Vt',
		UPC: '090255501605',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '7.5',
		ShelfDepth: '4.25',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '14.000',
		CartonWidth: '13.250',
		CartonDepth: '13.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '193.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'ASSEMBLED IN USA W/DOMESTIC & FOREIGN PARTS',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--NgX7MzB_--/v23ehyxpewkscp18hzpp.pdf',
		ProductDescription:
			'Speed up your case prep process with the 3-tool capacity and utilize the onboard storage for optional accessories like our primer pocket cleaners, primer pocket reamers, case neck brushes and any other 8-32 thread tools. With three active stations, you can chamfer, deburr and clean primer pockets without having to change tools. The Lock-N-Load® Case Prep Trio comes with both inside and outside chamfer and deburr tools. Made in the U.S.A.',
		ProductImage: 'http://images.salsify.com/image/upload/s--EDAbneS1--/nvf1mlxkuclbewyg13ge.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Hom2LFTs--/hytqrvy3hbly8awfdcye.jpg',
		Videos: 'https://vimeo.com/145576449',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ab62f35f-1c41-40da-8ac1-2ff2ef495775',
		ProductID: '22420',
		ProductName: '6mm .243 75 gr V-MAX®',
		UPC: '090255275025',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '1.148',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255275022',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.92',
		PalletQtyBoxes: '1440',
		Retail: '39.93',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.33',
		SectionalDensity: '0.181',
		OAL: '0.935',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3lkSLfWS--/f337c8d37ee765a25bf3213918065e8d7c28e9c3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0cf8115d-dbc1-4028-b3d4-356a29c21f7f',
		ProductID: 'FR2415',
		ProductName: '5.56 NATO 55 gr HP Match  Frontier®',
		UPC: '090255712933',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '3.910',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712930',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '31.28',
		PalletQtyBoxes: '512',
		Retail: '139.75',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KlEzCM3X--/5fbe877fe1664d777c10f8b1e6af9ebf3013efe2.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b14f608d-a150-4be5-9b20-a4339c625dac',
		ProductID: '390584',
		ProductName: 'Shell Holder #44',
		UPC: '090255600131',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255600138',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca208778-26bb-44fb-9f0a-0136d03290eb',
		ProductID: '390585',
		ProductName: 'Shell Holder #50',
		UPC: '090255905854',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.284',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905851',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '2.84',
		PalletQtyBoxes: '0',
		Retail: '59.45',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--tYOxdUQv--/bdnebb0dewmrz1c8rraf.jpg',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd7226c9a-1d8d-4152-8eb1-c66c03201d80',
		ProductID: '82242',
		ProductName: '450 Bushmaster 245 gr InterLock American Whitetail',
		UPC: '090255822427',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822424',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '14.5',
		PalletQtyBoxes: '930',
		Retail: '51.07',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.165',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '2633',
		SectionalDensity: '0.171',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '245',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime!  Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--jgT3UIHB--/tgof0i2dxqhbguqrpx9x.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '980c3d16-dd98-4fcd-a122-cc5207ccf0aa',
		ProductID: '99107',
		ProductName: 'Hornady® Universal Gun Sling',
		UPC: '090255991079',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.25',
		ShelfWidth: '2',
		ShelfDepth: '16.5',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '44.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Lead',
		Prop65Chem2: 'Chromium',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Developed by the Hunter Company of Colorado, this durable leather and nylon sling is built to endure the toughest hunts and comes with Hogue® sling swivels.',
		ProductImage: 'http://images.salsify.com/image/upload/s--dKe5cL1s--/wectlqg7oftw1mr1tnjr.png',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0db32fe5-c4da-4f6e-be9c-e8ced5658155',
		ProductID: '2278C',
		ProductName: '22 Cal .224 68 gr BTHP Match  with cannelure',
		UPC: '090255690491',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '44.844',
		WeightUOM: 'LB',
		CaseQty: '4500',
		CartonUCC: '10090255690498',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '201798.0',
		PalletQtyBoxes: '189000',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.355',
		SectionalDensity: '0.194',
		OAL: '0.986',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '68',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '52500',
		MasterPackUCC: '30090255690492',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '2354310.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SXzcLuFs--/82d03dff5d4bd7bff56b543d24f5181acbd86f2a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f53822b-085b-4dfd-8a9a-54af9b798c26',
		ProductID: '397109',
		ProductName: 'Seating Stem 30 Cal ELD® Match™ 208 Gr',
		UPC: '090255971095',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971092',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f055e60b-53f4-42db-ae81-1c3bf16a52ce',
		ProductID: '82432',
		ProductName: '450-400 Nitro Express 3" 400 gr DGX® Bonded',
		UPC: '090255824322',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.500',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255824329',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.0',
		PalletQtyBoxes: '396',
		Retail: '222.59',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.325',
		MuzzleVelocity: '2050',
		MuzzleEnergy: '3732',
		SectionalDensity: '0.34',
		Cartridge: '450-400 NITRO EXP 3"',
		Caliber: '400 CAL',
		BulletDiameter: '0.41',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fse4y-wx--/18e69575dcc531d8e835fc86efeeec9971539f4a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2024-03-05 08:44:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19c91c07-3c2f-4c98-a52d-200266ade877',
		ProductID: '30313',
		ProductName: '30 Cal .308 155 gr ELD® Match',
		UPC: '090255303131',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.338',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255303138',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '35.07',
		PalletQtyBoxes: '540',
		Retail: '58.68',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.461',
		G7BC: '0.232',
		MinTwist: '1-12"',
		SectionalDensity: '0.233',
		OAL: '1.196',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--FsOnkyOa--/07d94823fc39f3a5381fcd3fcba2f8e3baa03b81.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8c25eb75-11ed-4605-9f00-cae02b51e3b7',
		ProductID: '546313',
		ProductName: 'Full-Length 2-Die Set 7mm PRC (.284)',
		UPC: '090255563139',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.520',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonWeight: '7.6',
		Retail: '64.47',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '50000',
		MasterPackUCC: '10090255563136',
		MasterPackWeight: '76000.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press. The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.* *Other accessories sold separately. HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies. Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol). No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2022-10-25 15:51:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f19c5a3-e164-41b8-9ab9-c60779370398',
		ProductID: '046371',
		ProductName: 'Full-Length Size Die 7.7 Jap (.312)',
		UPC: '090255463712',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463719',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7.7 JAP',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e1c961f-7892-4779-9764-e06e43c389f8',
		ProductID: '30620',
		ProductName: '30 Cal. .308 174 gr. ELD-VT™',
		UPC: '090255306200',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255306207',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '540',
		Retail: '58.68',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-VT™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		MinTwist: '1-12"',
		SectionalDensity: '0.262',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-VT™',
		BulletWeightGrain: '174',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady ELD-VT™ bullet is here to redefine your shooting and varmint hunting pursuits, offering unmatched accuracy, explosive fragmentation, and the confidence to take on any challenge – from competitions to long-range varmint hunts. Precision Perfected Born from a culmination of years of ballistic research, the ELD-VT™ pairs the aerodynamics of low drag match bullets with the light weight, high velocity of a varmint bullet, giving the ELD-VT™ a level of uncompromising dual-use performance. Say goodbye to compromise, as this bullet’s match-winning accuracy and violent expansion will set new standards. Explosive Impact The Hornady ELD-VT™ bullet isn’t just about hitting the bullseye – it’s about making a statement when it gets there. Upon impact, the polymer tip drives rearward into the bullet core, causing rapid and dramatic fragmentation, even at low velocity. Advanced Manufacturing Process (AMP) Bullet Jackets A testament to the unwavering commitment to excellence, AMP bullet jackets provide unrivaled consistency in concentricity and thickness, ensuring every ELD-VT™ bullet performs at its peak potential. Heat Shield® Technology ELD-VT™ bullets incorporate the Heat Shield® tip, which is immune to the effects of aerodynamic heating. They retain their shape to maintain the lowest drag over their entire trajectory.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--xjBiiAxO--/zvqt26jw0rxtxfrbsniw.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WyGkcYJB--/ful8k0ufdgsv7xjyzpfi.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--pmytqCwd--/f3nmjpfng5saoyllsfjg.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0K1NqHAh--/chfjtw6rihomshyilysz.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--szcfF2fb--/wnqo8eofoesuzickxo0s.png',
		Videos: 'https://vimeo.com/876107595',
		DateLastModified: '2024-03-04 15:49:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '602c376e-2548-4460-ba1e-5db8360dfe4d',
		ProductID: '392612',
		ProductName: 'Shell Plate #12 Lock-N-Load®AP™ & Projector',
		UPC: '090255926125',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926122',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.66',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a421d0c3-49f8-48e3-90ee-019dee750bc5',
		ProductID: '380063',
		ProductName: 'Case Neck Brush 22 Cal',
		UPC: '090255800630',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '1.5',
		ShelfDepth: '1.2',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800637',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.1',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '22 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with the Lock-N-Load® Case Prep Trio, Case Prep Duo, Lock-N-Load® Power Case Prep Center, and Quick Change Hand Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gaEkx5fP--/tivz27qmwyluopcngd14.png',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75123c1f-ffc1-4b7e-9a8d-75e604ad8373',
		ProductID: '30502',
		ProductName: '30 Cal .308 168 gr A-MAX®',
		UPC: '090255275131',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.557',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255275138',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.355',
		PalletQtyBoxes: '540',
		Retail: '61.13',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Max® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.475',
		MinTwist: '1-12"',
		SectionalDensity: '0.253',
		OAL: '1.275',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'A-MAX® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Perfection every time!!! The Hornady® A-MAX® bullet design grew from a relentless application of everything we know about ballistics and flight characteristics. After all, match shooters demand perfection from their bullets every time they step on the range.  The aerodynamic secant ogive profile, the sharp pointed tip and the unequaled concentricity of the A-MAX® design give it an extremely high ballistic coefficient for near perfection in flight. Product Features ULTRA LOW-DRAG TIP The low-drag and uniform point raises the ballistic coefficient and precisely balances the center of pressure relative to the center of gravity in order to achieve optimal in-flight stability.  SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories.The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero tolerance for concentricity and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique to each caliber and weight of Match™ and A-MAX® bullets to maximize ballistic coefficient and accuracy.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RxVkVzZW--/167725f15a286d8e6236017d366897ef0489537a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fDPQCq39--/61b74b961307cf1849443149347730bdab29b2ea.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ip3cEHjP--/rurh6p8pqcruc6htaogr.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--5vuOssDm--/cv1quwy0mgp7bpsqvypz.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c470803-5730-4857-84a1-4e1a06db8b4e',
		ProductID: '050146',
		ProductName: 'Universal Trim Length Gauge',
		UPC: '090255501469',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '3.75',
		ShelfDepth: '0.5',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501466',
		CartonHeight: '9.000',
		CartonWidth: '5.000',
		CartonDepth: '3.000',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '21.67',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Use this tool to set the case overall length on the Case Prep Center. May be used with 12 popular calibers from the 6mm ARC to the 300 Win Mag, both fired and resized cartridge cases.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vTywG2K0--/jpixxhjbrgehgz0nupd5.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--vTywG2K0--/jpixxhjbrgehgz0nupd5.png',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a5afde5-70a9-45a9-bc26-ff2fa5166149',
		ProductID: '046341',
		ProductName: 'Full-Length Size Die 30-06 (.308)',
		UPC: '090255463415',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.561',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463412',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2a23dc3b-56f2-4519-b110-01546f3ed7f9',
		ProductID: '392158',
		ProductName: 'Collet #5 .277 Cal',
		UPC: '090255921588',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921585',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PSGUowN7--/c03bb0d522783cef2f5249e20ae2aaae27084b30.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '24e3f1c3-3bb2-49ec-b3b2-6a072fc98b61',
		ProductID: '546220',
		ProductName: 'Full-Length 2-Die Set 22/250 Rem (.224)',
		UPC: '090255562200',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.458',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562207',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.29',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af9e5d84-b80c-4bb4-a5c9-ab67fd2b0ee2',
		ProductID: '82312',
		ProductName: '375 H&H 270 gr InterLock® SP-RP',
		UPC: '090255823127',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.918',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823124',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.508',
		PalletQtyBoxes: '396',
		Retail: '87.48',
		ParentCategory: 'Ammunition',
		Applications: 'AppDangerousGame',
		G1BC: '0.38',
		SectionalDensity: '0.274',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '270',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--tMpFswAQ--/463cef59f2fffdd70d7b08b8e1f6c95646ab1549.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e6ad7588-80a2-489f-bd75-e6882bb5684f',
		ProductID: '86751',
		ProductName: '300 Blackout Unprimed Cases',
		UPC: '090255867510',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.691',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867517',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '3.455',
		PalletQtyBoxes: '400',
		Retail: '42.28',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27becea3-5ce7-40dd-854f-18eb2d8e329b',
		ProductID: '546369',
		ProductName: 'Full-Length 2-Die Set 300 WSM (.308)',
		UPC: '090255563696',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.448',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563693',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.24',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '740ca94e-06c2-4b92-bb39-7f713cf1206e',
		ProductID: 'A280AI',
		ProductName: 'Lock-N-Load® 280 Ackley Imp Modified Case',
		UPC: '090255714005',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255714002',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--yvvu_vda--/a757ba5b99d911dcc08965647fb269fc5a7a00be.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e78ce625-a5c8-4500-b6b7-14c1aaf7685d',
		ProductID: '046330',
		ProductName: 'Full-Length Size Die 28 Nosler (.284)',
		UPC: '090255463309',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463306',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '28 NOSLER',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b82d682b-8dc2-4bca-86d6-982ae2037031',
		ProductID: '95870',
		ProductName: 'Hornady® Universal Handgun Hangers',
		UPC: '090255958706',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '11.5',
		ShelfWidth: '4.5',
		ShelfDepth: '1.5',
		Weight: '0.632',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255958703',
		CartonHeight: '5.000',
		CartonWidth: '4.250',
		CartonDepth: '12.250',
		CartonWeight: '3.16',
		PalletQtyBoxes: '1650',
		Retail: '19.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '2',
		ProductExtWidth: '0.25',
		ProductExtDepth: '10.7',
		ProductWeight: '0.6',
		MasterPackQty: '25',
		MasterPackUCC: '30090255958707',
		MasterPackHeight: '5.750',
		MasterPackWidth: '13.000',
		MasterPackDepth: '24.500',
		MasterPackWeight: '15.8',
		ProductDescription:
			'This 4-pack of PVC-coated hardened steel hangers accommodate heavy 22 caliber and larger handguns. Slide onto ½-inch to 1-inch thick shelf. Hardened steel wire supports heavy handguns (22 caliber and larger). PVC coating won’t scratch or damage handgun finish. Maximizes storage in your gun safe or cabinet. Slide onto 1/2-inch to 1-inch thick shelf.  Dimensions 2"H x 2.6"W x 10.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to DI(2-Ethylhexyl) Phthalate, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s---Oaazbbc--/hup9md9dooj2hntgdpc4.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--iqgbk2I4--/hxvcxhljqtnvbjcq8dxo.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1_7iQA2A--/fiw6xbalreqbuqfsiwcw.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ab22f7f-cdf9-440a-9248-ada0987f9f54',
		ProductID: '546324',
		ProductName: 'Full-Length 2-Die Set 7mm Rem BR (.284)',
		UPC: '090255563245',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563242',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7MM BR REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '43cdc74f-66ab-4fe1-9cca-e32cb3a61678',
		ProductID: '3335',
		ProductName: '338 Cal .338 250 gr InterLock® SP-RP',
		UPC: '090255233353',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.724',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255233350',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.86',
		PalletQtyBoxes: '540',
		Retail: '87.15',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.431',
		SectionalDensity: '0.313',
		OAL: '1.34',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mTSPbLoZ--/0e9a83499966e184a05b6ea15deb5deed42f96e4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a34eccb-5c25-4f1e-a311-06efd22a5fed',
		ProductID: '486554',
		ProductName: '3-Die Set 45 Auto .451 American Series',
		UPC: '090255485547',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.83',
		ShelfWidth: '6.5',
		ShelfDepth: '2.5',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255485544',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '14.0',
		PalletQtyBoxes: '0',
		Retail: '52.52',
		ParentCategory: 'Reloading',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Great Dies. Great Value.  Perfect for the handloader looking to maximize the efficiency of their reloads, American Series™ die sets deliver excellent reloading performance at an economical price.  Die bodies are precision reamed from premium steel that is hardened to exacting specifications, then polished to a smooth finish that will endure the rigors of countless reloading sessions. Each die set includes a FREE shell holder. The 3-die American Series™ sizing dies feature an industry-leading titanium nitride sizing ring that reduces friction and case sticking, and helps prolong case life. Select pistol dies are taper-crimp capable (9mm Luger, 40 S&W/10mm, 45 Auto). Sizing dies size to SAAMI specifications. Internal spindles, expanders and seating stems are interchangeable with other brands on the market. All Hornady reloading tools and accessories are warranted against material defects and workmanship for the life of the product.  Basic Reloading Data and extra decapping pins are included with each die set.',
		ProductImage: 'http://images.salsify.com/image/upload/s--vtym8Pio--/av6vyjrwytfu3njb8qiv.png',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '565e3bd4-248e-4c2d-b34a-7c73fe1eaf73',
		ProductID: '546553',
		ProductName: 'Full-Length 3-Die Set 450 Marlin (.458)',
		UPC: '090255565539',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.799',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565536',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.995',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '450 MARLIN',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1904e774-083b-4c3c-8254-25c656763876',
		ProductID: '046720',
		ProductName: 'Size Die 460 S&W',
		UPC: '090255467208',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255467205',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '61.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series V Four-Die Handgun Die Sets',
		Cartridge: '460 S&W MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '729f2969-805c-4d67-8cf2-0a3ada08caef',
		ProductID: '392159',
		ProductName: 'Collet #6 .284 Cal',
		UPC: '090255921595',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921592',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.34',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YVo7XGRn--/4450df83898360b2365d1490fd8969884ee10bde.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a12068b-0509-43ed-a90a-80eb99f754e2',
		ProductID: '190190',
		ProductName: 'Powder Bushing 354',
		UPC: '090255191905',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.067',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191902',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.67',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b75cb24-b7d4-4ade-b386-ddb02b26bc8f',
		ProductID: '392606',
		ProductName: 'Shell Plate #6 Lock-N-Load® AP™ & Projector',
		UPC: '090255926064',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926061',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.5',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '392fab39-4439-45ec-8e5a-478e877cbcc9',
		ProductID: '546208',
		ProductName: 'Full-Length 2-Die Set 219 Zipper (.224)',
		UPC: '090255562088',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562085',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '219 ZIPPER',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8642d343-da51-4127-af43-919e667ee98d',
		ProductID: '82674',
		ProductName: '416 Rem Mag 400 GR DGS® Dangerous Game™ Series',
		UPC: '090255826746',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.315',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826743',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '13.89',
		PalletQtyBoxes: '396',
		Retail: '152.72',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2400',
		MuzzleEnergy: '5115',
		SectionalDensity: '0.33',
		Cartridge: '416 REM MAG',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UygpxP0j--/6a4da68cd50e263db220d4b87f85b987e055091a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '175ec2d3-0528-4de2-b2e8-8686683814cf',
		ProductID: '546393',
		ProductName: 'Full-Length 2-Die Set 338 Lapua (.338)',
		UPC: '090255563931',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563938',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '24276ab8-2677-43df-8c4e-9bdd34ad3f61',
		ProductID: '24444',
		ProductName: '6mm .243 90 gr CX™',
		UPC: '090255244441',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.742',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255244448',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.68',
		PalletQtyBoxes: '1440',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.418',
		MinTwist: '1-7.5"',
		SectionalDensity: '0.218',
		OAL: '1.258',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'CX™',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ygCJj2-F--/dgkhcqbafciwl0djbfwe.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b879d47-0830-4aee-92b1-bb146fcf2e9f',
		ProductID: 'B33N',
		ProductName: 'Lock-N-Load® 33 Nosler Modified Case',
		UPC: '090255715071',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715078',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.55',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '33 NOSLER',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c1d32cd2-58a7-4935-9936-218b15eb98c1',
		ProductID: 'FR2405',
		ProductName: '5.56 NATO 55 gr HP Match Frontier',
		UPC: '090255716160',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.45',
		ShelfDepth: '3.75',
		Weight: '1.370',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255716167',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '13.7',
		PalletQtyBoxes: '1190',
		Retail: '47.00',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6KxQlKPZ--/305d0106a46c2e4d1ad8a471e856c8a900ddb945.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9e96fe6e-9379-4ca1-9de8-b2863fda8d1d',
		ProductID: '3091',
		ProductName: '30 Cal .308 230 gr A-TIP Match',
		UPC: '090255230918',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '3.574',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255230915',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '35.74',
		PalletQtyBoxes: '240',
		Retail: '125.64',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.823',
		G7BC: '0.414',
		MinTwist: '1-9"',
		SectionalDensity: '0.346',
		OAL: '1.76',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--W4HCIzd8--/n657bryf6uvswoj513je.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3cede262-c530-4a47-b93c-fc195d12bd5c',
		ProductID: '99215',
		ProductName: 'Hornady® Camo "H" Cap',
		UPC: '090255992151',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--KiX_lCpk--/hfz2fmh1kscieox9ua4z.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '380ddca3-ac8c-405c-8bc7-7ec4d4d24c4a',
		ProductID: '390581',
		ProductName: 'Shell Holder #41',
		UPC: '090255905816',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905813',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.44',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '15b46cae-8d6e-4e2d-b6aa-b766a0ab6ced',
		ProductID: 'FR120',
		ProductName: '223 Remington 55 gr SP Frontier®',
		UPC: '090255711301',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711308',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '14.15',
		PalletQtyBoxes: '4500',
		Retail: '12.52',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP W/C',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'ORIENTED',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nIkHWnnS--/4f53893a851867cb85079b5d386f98586c0b8fff.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9e47604c-ba80-46d9-9f98-b7e2be89fe0d',
		ProductID: 'A350L',
		ProductName: 'Lock-N-Load® 350 Legend Modified Case',
		UPC: '090255717877',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.005',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255717874',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.05',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dce86c87-bcd9-4e4a-8d02-dd831be61c25',
		ProductID: '046050',
		ProductName: 'Neck Size Die 30/30 Short (.308)',
		UPC: '090255460506',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.498',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460503',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14b8baaf-1da8-4a49-ae7a-ce4e05a06d5c',
		ProductID: '82453',
		ProductName: '444 Marlin 265 gr InterLock® FP Superformance®',
		UPC: '090255824537',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255824534',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '16.0',
		PalletQtyBoxes: '1400',
		Retail: '63.91',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.189',
		MuzzleVelocity: '2400',
		MuzzleEnergy: '3389',
		SectionalDensity: '0.205',
		Cartridge: '444 MARLIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FP',
		BulletWeightGrain: '265',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5orWseG5--/075573765b6d1a458ec77b6be36b8500bec49df6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:09:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca3321da-3e1e-4b9d-933f-24b790d72758',
		ProductID: '046576',
		ProductName: 'Size Die 357 Sig (.355)',
		UPC: '090255465761',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465768',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '357 SIG',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b1a4318-6fb2-41c3-8bb8-1b7b1aeb538a',
		ProductID: '546551',
		ProductName: 'Full-Length 3-Die Set 444 Marlin (.430)',
		UPC: '090255565515',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.695',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565512',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.475',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '444 MARLIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b303658b-7260-47d8-9f89-66dfd64b58da',
		ProductID: '046555',
		ProductName: 'Size Die 45 Auto/AR/WM (.451)',
		UPC: '090255465556',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.463',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465553',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '45 AUTO/45 AR/45 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5176263c-89c8-4bd8-a168-6e468b0892ba',
		ProductID: '390540',
		ProductName: 'Shellholder Kit #1 #2 #5 #16 #35',
		UPC: '090255905403',
		PackagedQTY: '5',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905400',
		CartonHeight: '2.000',
		CartonWidth: '9.000',
		CartonDepth: '6.000',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '27.67',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holder Kit',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.  Kit includes shell holders #1, #2, #5, #16 and #35',
		ProductImage: 'http://images.salsify.com/image/upload/s--IrpdJ1sp--/yp7ectcsfdwpjefbliyy.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ad38fe1-9ac5-448b-9795-9474ecad3507',
		ProductID: '86105',
		ProductName: '250 Savage Unprimed Cases',
		UPC: '090255861051',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.240',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255861058',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.2',
		PalletQtyBoxes: '400',
		Retail: '67.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '250 SAVAGE',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '21c702ef-f420-454d-a194-8fe714b01c96',
		ProductID: '046456',
		ProductName: 'Full-Length Size Die 405 Win (.411)',
		UPC: '090255464566',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464563',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '405 WIN',
		Caliber: '405 CAL',
		BulletDiameter: '0.411',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5561e6e5-9361-4cb9-8c24-ddbe8f05e4b3',
		ProductID: '24585',
		ProductName: '6mm .243 105 gr BTHP Match',
		UPC: '090255245851',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '7.900',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255245858',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.4',
		PalletQtyBoxes: '216',
		Retail: '199.44',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.53',
		SectionalDensity: '0.254',
		OAL: '1.23',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '105',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PXB4Mff_--/agq5t9dknaercdwodrll.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--0bvaZxXQ--/eac1efbf074885548b8c6d510c8c5ad909717f7b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00b08353-36f8-4fb8-a3e0-00ed75aa5c3f',
		ProductID: '150204',
		ProductName: 'Lock-N-Load®Sonic Cleaner™ Basket 1.2L',
		UPC: '090255502046',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '6',
		ShelfDepth: '7',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255502043',
		CartonHeight: '2.500',
		CartonWidth: '6.000',
		CartonDepth: '7.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '16.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--PbQc1Hzu--/dmr7hye4cxmbzzo8u2sk.png',
		DateLastModified: '2023-12-16 08:58:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd9eca2f-7136-44ea-9f09-305ba3b36bd0',
		ProductID: '544339',
		ProductName: 'Match™ Grade 2-Die Set 30-06 Sprg (.308)',
		UPC: '090255543391',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543398',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.75',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b79cef5-a77a-42aa-806a-910c60f2161c',
		ProductID: '30395',
		ProductName: '30 Cal .308 160 gr FTX® (30-30 Win)',
		UPC: '090255303957',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.413',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255303954',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.195',
		PalletQtyBoxes: '540',
		Retail: '55.91',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.33',
		SectionalDensity: '0.241',
		OAL: '1.125',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '160',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iJdPdEUT--/b8eb5cc1a61429957a94774e7370daefff835d86.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9e074d13-b0fc-4ab0-bb84-dd29d9555ada',
		ProductID: '050124',
		ProductName: 'Rifle Micrometer Metering Insert',
		UPC: '090255501247',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.305',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501244',
		CartonHeight: '9.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '3.05',
		PalletQtyBoxes: '0',
		Retail: '48.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For precise measurements, the micrometer inserts allow the user to make and monitor incremental changes and return to previous settings.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nxInv5Jt--/5f6f75c119dc1ed847cf96ac448087d090a5b152.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e02c40e-e45e-4fdf-a4e7-02f2079c455a',
		ProductID: '2286',
		ProductName: '22 Cal .224 90 gr A-TIP Match',
		UPC: '090255222869',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '1.680',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255222866',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '16.8',
		PalletQtyBoxes: '240',
		Retail: '110.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.585',
		G7BC: '0.295',
		MinTwist: '1-7"',
		SectionalDensity: '0.256',
		OAL: '1.267',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--8d7BHxV7--/gfxbi6kjxxo1hrqpevgx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f31a502c-e613-41a4-9d7b-62975ac64a40',
		ProductID: 'A7X57',
		ProductName: 'Lock-N-Load® 7X57 Mauser Modified Case',
		UPC: '090255704433',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.031',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704430',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.31',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '7X57',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vyIjaa6e--/c16c944f766ad0ac3886bb6c7d753bf72980fd03.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee9b74cb-f013-4ae3-a3d2-2b4641dc0b9d',
		ProductID: '96022',
		ProductName: 'TSA Cable Padlock',
		UPC: '090255960228',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '8.75',
		ShelfDepth: '1',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255960225',
		CartonHeight: '7.750',
		CartonWidth: '4.000',
		CartonDepth: '9.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '1500',
		Retail: '28.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '3',
		ProductExtWidth: '1.6',
		ProductExtDepth: '0.5',
		MasterPackQty: '50',
		MasterPackUCC: '30090255960229',
		MasterPackHeight: '16.250',
		MasterPackWidth: '9.750',
		MasterPackDepth: '21.500',
		MasterPackWeight: '35.0',
		ProductDescription:
			'Protect belongings by using this all metal TSA-approved padlock that allows TSA screeners to inspect luggage without damaging the locks.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--2zBdb4We--/ww1bbwas1guwp3jx27zt.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--2zBdb4We--/ww1bbwas1guwp3jx27zt.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--U5F8AXg1--/jwbowxybohuc9gbxp0jt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Lyg_R6u2--/c8l2mdxvowork3uhse3x.jpg',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3deb995d-39b7-47a4-9b92-3d37dff218d5',
		ProductID: '044107',
		ProductName: 'Seater Die #7 (.277) 270 Cal',
		UPC: '090255441079',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.609',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441076',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9adabba7-1159-42c6-89c7-cc24cf76a3ab',
		ProductID: '87263',
		ProductName: '9.3 X 62 Unprimed Cases',
		UPC: '090255872637',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.558',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255872634',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.79',
		PalletQtyBoxes: '200',
		Retail: '60.13',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '9.3X62',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f147d183-7340-430d-8c45-e6fd9a6f9b4a',
		ProductID: '80712',
		ProductName: '7mm PRC 175 gr. ELD-X® Precision Hunter®',
		UPC: '090255720730',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.575',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255720737',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.75',
		PalletQtyBoxes: '780',
		Retail: '72.85',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.689',
		G7BC: '.347',
		SectionalDensity: '0.31',
		Cartridge: '7MM PRC',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '175',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential. Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges. BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory. MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency. DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention. BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range. INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--_3boz_Uy--/sybdhcazfibbfgmyglvy.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dkYIvXw0--/hbigwjvtwxjx69dy1vk4.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xaeopbc8--/fjxkajr4kpv0x98xi9mt.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HYcmrPJn--/jfiglarkrhoa3xephr3n.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--n_2RbnyW--/e4bwpeaupdvmuf8ky5wn.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--bjXU2XgE--/fxoulopkqvhb11unyntd.png',
		ProductImage6: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/763847434',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/163445688',
		Videos3: 'https://vimeo.com/163412123',
		Videos4: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '891b16b9-126c-4acc-a571-874c5754c9eb',
		ProductID: '8204',
		ProductName: '300 Win Mag 150 gr InterLock® SP American Whitetail®',
		UPC: '090255382044',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382041',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.6',
		PalletQtyBoxes: '780',
		Retail: '51.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.338',
		MuzzleVelocity: '3275',
		MuzzleEnergy: '3572',
		SectionalDensity: '0.226',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xHHCGxdF--/cd938e3a24bc1e7122bd9f9ce0ed5225b71dc702.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f242c47-2ed0-4a34-848e-928364c29239',
		ProductID: '546424',
		ProductName: 'Full-Length 2-Die Set 7.62X39 (.308)',
		UPC: '090255564242',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.362',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564249',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.81',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c592ac6-b70e-4dec-a0d1-54c2167a7651',
		ProductID: '82733',
		ProductName: '308 Marlin Express 160 gr FTX® LEVERevolution®',
		UPC: '090255827330',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.209',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827337',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.09',
		PalletQtyBoxes: '1400',
		Retail: '51.08',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.395',
		MuzzleVelocity: '2660',
		MuzzleEnergy: '2514',
		SectionalDensity: '0.241',
		Cartridge: '308 MARLIN EXP',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '160',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4YeItzUj--/072e20f2ebbb16daf2495607a0ce00caf06ee053.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0508ae74-5a39-4f4c-adfc-e8bea6785f25',
		ProductID: '043401',
		ProductName: 'Zip Spindle™ Kit (17-20)',
		UPC: '090255434019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '0.5',
		Weight: '0.090',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255434016',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '17.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.    The Hornady® Die Zip Spindle™ Kit (17-20 cal) is the ideal kit for updating your older Hornady® Sizing Dies to utilize the new threaded spindle design. This kit can also be used for replacement parts (it’s always good to have spares on hand). The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.    This kit includes a threaded spindle lock that tightens the Zip Spindle™ so it will not slip in the die.',
		ProductImage: 'http://images.salsify.com/image/upload/s--TOYZthWW--/cogluhq53vib9gyyjz2r.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0409dc7d-4a5a-4ef5-8440-252524b1b58b',
		ProductID: '095333',
		ProductName: 'Bullet Feeder Die 44 Spl/Mag',
		UPC: '090255953336',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '7.500',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '44 SPL/44 REM MAG',
		Caliber: '44 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Bullet Feeder Dies are case activated – a bullet will only feed upon contact with a case. The collets are precision machined of solid steel for each caliber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5ODx6Jae--/hwnaibacjc6npxwf3nfe.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '164dc72e-fbd7-4387-8f8f-c6d79cf2e1b7',
		ProductID: '752412325',
		ProductName: 'TrekLite® Lock Box - XL with TSA combination lock FDE',
		UPC: '842631100717',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '2.540',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100714',
		CartonHeight: '8.500',
		CartonWidth: '12.000',
		CartonDepth: '15.000',
		CartonWeight: '12.7',
		PalletQtyBoxes: '450',
		Retail: '51.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '1.6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The TrekLite® Lock Box offers heavy-duty protection at a third of the weight of steel! Heavy-duty protection at a third of the weight of steel. Only 1.5 pounds! Convenient 4-Digit TSA lock offers advanced security and 10,000 user programmable codes. Protects firearms, expensive medications, and other valuables while traveling or at home. Easily fits in a suitcase, drawer, or under a car seat. Constructed of advanced, impact-resistant polycarbonate for exceptional toughness. Fits up to full-sized 1911 handguns. Durable, non-slip rubber over-mold provides added impact protection and stability. Foam lining protects firearms and valuables from being marred. Includes 1500 lb. rated security cable† with sturdy cable connector that doesn’t limit interior cargo space. Meets TSA requirements.* External Dimensions: 10" x 7" x 2" Weight: 1.6 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--UCw6oI9l--/vd5gpprp9xemefbvebxj.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--7vevgu-t--/ujombyx500nitxn91pj1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kX212MVt--/kmgzfym6o4hrjdoncegv.png',
		Videos: 'https://vimeo.com/213867264?embedded=true&source=video_title&owner=28327899',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9616427-a3d9-41e5-a7ed-5259fa8d29f7',
		ProductID: '627',
		ProductName: 'Lock-N-Load® 27 Insert (.277 Cal)',
		UPC: '090255704310',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704317',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ksAhTGsz--/opcwidkojv92zcaekuuz.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '946733e0-b9bb-4eea-b70d-676bd98fe2b0',
		ProductID: '28209',
		ProductName: '7mm .284 139 gr InterBond®',
		UPC: '090255282092',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.108',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255282099',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.62',
		PalletQtyBoxes: '540',
		Retail: '92.99',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.246',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '139',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PDDteKJF--/1322e617375d80824487b5fe5226e911ffe31d08.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3fe9382f-95f2-4710-b113-d4b26fb26fc8',
		ProductID: '546555',
		ProductName: 'Full-Length 3-Die Set With Taper Crimp 45 Auto (.451)',
		UPC: '090255565553',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.920',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565550',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.6',
		PalletQtyBoxes: '0',
		Retail: '81.17',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Taper Crimp Handgun Die Sets',
		Cartridge: '45 AUTO/45 AR/45 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® 3-Die Taper Crimp Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin and Decap Pin Retainer is mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.   The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Taper Crimp Seating Die that features intuitive design that allows seating and taper crimping to be completed in one step, eliminating the need for a separate taper crimp die.  Precise control is achieved by the use of the Taper Crimp Adjustment Screw that easily adjusts the amount of crimp on the cartridge without changing bullet seating depth or loosening the lock ring. Hornady® Taper Crimp dies feature an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results.   HORNADY® 3-DIE TAPER CRIMP DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • Taper Crimp Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cja6tvEo--/s5vomxew87obdcclrxwr.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--aROXT8VW--/syxt7m7qvlomyagtd9du.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8cd79da0-9a18-4c0e-9940-4fa0efb575d9',
		ProductID: '546450',
		ProductName: 'Full-Length 2-Die Set 375 Rem Ultra Mag (.375)',
		UPC: '090255564501',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.496',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564508',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.48',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '375 REM ULTRA MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6f3180e0-8cb9-40ef-9555-626c3dad62b2',
		ProductID: '82682',
		ProductName: '500-416 Nitro Express 400 gr DGS®',
		UPC: '090255826821',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.550',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826828',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.3',
		PalletQtyBoxes: '396',
		Retail: '290.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2300',
		MuzzleEnergy: '4698',
		SectionalDensity: '0.33',
		Cartridge: '500-416 NITRO EXP 3¼"',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--qb_PjqoX--/215acd42a2a1cf17f41c7cb0c399afd6670052f4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:47:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '713999a1-bc83-4c42-b669-4e7e66fd7daa',
		ProductID: '8780',
		ProductName: '45 Colt Unprimed Cases',
		UPC: '090255487800',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.870',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487807',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.35',
		PalletQtyBoxes: '200',
		Retail: '62.93',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'acc66145-955e-4c3c-9d22-86b65503369f',
		ProductID: '9251',
		ProductName: '500 S&W Mag 300 gr. MonoFlex Handgun Hunter',
		UPC: '090255392517',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3.000',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255392514',
		CartonHeight: '3.625',
		CartonWidth: '5.312',
		CartonDepth: '13.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '720',
		Retail: '116.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.171',
		Cartridge: '500 S&W MAG',
		Caliber: '50 CAL',
		BulletDiameter: '0.500',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design. Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact. ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion. PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ix3TRxmo--/ntby2ouzeotbgkr7aboq.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '926b1b17-26b9-4e81-bbf2-2676855e600f',
		ProductID: '390551',
		ProductName: 'Shell Holder #11',
		UPC: '090255905519',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905516',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e849358a-8795-418e-be22-2ad197eb1e34',
		ProductID: '22671',
		ProductName: '22 cal .224 55 gr FMJ-BT with cannelure',
		UPC: '090255226713',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '4.168',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255226710',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '25.008',
		PalletQtyBoxes: '216',
		Retail: '85.44',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		OAL: '0.735',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--TvocNbqG--/ncexzse1kkqxjgqs94ko.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YKqIkYCi--/haleg0vggquwzrcksimo.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c283b2f-5ef3-4965-9a86-8d8a9d3be73b',
		ProductID: '80788',
		ProductName: '7.62x39 111 gr. MonoFlex® Hornady BLACK®',
		UPC: '090255807882',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807889',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '1400',
		Retail: '47.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppVarmint',
		SectionalDensity: '0.163',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.3115',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '111',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns. Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA! Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications. Featuring: High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ir4suQID--/hwnzx9pugntnlsmno8j6.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		DateLastModified: '2024-03-04 15:34:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b16ec96e-3c40-4b72-90e2-883a1ceded7d',
		ProductID: '8063',
		ProductName: '7mm Rem Mag 162 gr InterLock® BTSP',
		UPC: '090255380637',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.471',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380634',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '14.71',
		PalletQtyBoxes: '780',
		Retail: '49.97',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.514',
		SectionalDensity: '0.287',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'BTSP',
		BulletWeightGrain: '162',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Yw9fQQ9U--/93cc9be77778a4c2f8542d7b5f92a5799c5b9011.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74ed64f2-b185-45f5-9582-4ac2f073e35d',
		ProductID: '86283',
		ProductName: '6.5 Grendel Unprimed Cases',
		UPC: '090255862836',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.997',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862833',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.985',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9288646e-fd27-4748-a063-36fcc0eed7cb',
		ProductID: '546278',
		ProductName: 'Full-Length 2-Die Set 264 Win Mag (.264)',
		UPC: '090255562781',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.482',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562788',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.41',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '264 WIN MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9eddc454-6dd0-4c7a-82e5-c8ed413825d9',
		ProductID: '594331',
		ProductName: 'Match™ Grade Bushing .331',
		UPC: '090255593310',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593317',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '33 CAL',
		BulletDiameter: '0.331',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cK0Ckb86--/af44ae1df58ac7ff724865d80086d1c7e90cecba.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e904d974-6e33-4b2d-85e7-c1ea8fa69dbe',
		ProductID: 'A300M',
		ProductName: 'Lock-N-Load® 300 Win Mag Modified Case',
		UPC: '090255704730',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.038',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704737',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.38',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nVdd4KEJ--/245f4c502437a105b70fb56adc3fdbde92336e07.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '287622d2-7002-44bc-b7b4-ae55d6e39a8d',
		ProductID: 'HK66',
		ProductName: 'Lock-N-Load® Headspace Kit With Body',
		UPC: '090255704846',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.342',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704843',
		CartonHeight: '10.000',
		CartonWidth: '7.500',
		CartonDepth: '4.750',
		CartonWeight: '3.42',
		PalletQtyBoxes: '0',
		Retail: '57.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--ievB-bgK--/qwv7wl2qlc8pdquktrss.pdf',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. The five bushings that come with the Lock-N-Load® Headspace Comparator provide the ability to check most bottleneck cases, from .17 Rem through belted magnums. Ackley Improved chambers use the same bushing size as the parent case. See chart provided or consult product instructions for cartridge/bushing size details.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wsqltHBL--/xz3j3pts6ei67n6h0mw9.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e4d9a9b6-07e2-4fc9-9894-5d82cbc0327e',
		ProductID: '050147',
		ProductName: 'Cam Lock™ Trimmer Deburr Tool',
		UPC: '090255501476',
		PackagedQTY: '2',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.135',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255501473',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '67.28',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '100',
		MasterPackUCC: '30090255501477',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '13.5',
		ProductDescription:
			'Mounts in place of the cutter to speed the chamfering and deburring process. It also keeps chamfers and deburrs square with the case mouth.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TB81p5DS--/297f3f9db9992cf552250cd33ba43e8d89201acc.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48fd8a19-2080-45d8-a714-d88fc2cb2fac',
		ProductID: '81196',
		ProductName: '350 Legend 170 gr InterLock American Whitetail',
		UPC: '090255811964',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.965',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811961',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.65',
		PalletQtyBoxes: '1400',
		Retail: '35.71',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.215',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '1827',
		SectionalDensity: '0.193',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '170',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime!  Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--B2dtjMAU--/ohuackf5qz9qi5kmlpjy.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd99e62c8-0503-4d06-85af-4137b2012da0',
		ProductID: '190168',
		ProductName: 'Powder Bushing 471',
		UPC: '090255191684',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191681',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8f397b6e-b508-481f-a9d6-496e5e7e4731',
		ProductID: '303704',
		ProductName: '30 Cal .308 150 gr CX™',
		UPC: '090255719550',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4.000',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719557',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.75',
		PalletQtyBoxes: '900',
		Retail: '59.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.440',
		SectionalDensity: '0.226',
		OAL: '1.335',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQWRh-yJ--/a8fl6wenikddpclqqr8s.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--YBHFtVvw--/xhszmnkdtrrq9gs3uw2n.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--pU4uJz_1--/n7fnayfmrxqgdorg08jz.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e11180f-60c9-400c-8d18-a9f6d0207546',
		ProductID: '050207',
		ProductName: 'Rotary Media Sifter',
		UPC: '090255502077',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.5',
		ShelfWidth: '16',
		ShelfDepth: '13.5',
		Weight: '5.500',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255502074',
		CartonHeight: '10.500',
		CartonWidth: '16.000',
		CartonDepth: '13.500',
		CartonWeight: '22.0',
		PalletQtyBoxes: '64',
		Retail: '88.17',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--M2hXLksK--/exfveoptcynzjkdcbkvs.pdf',
		ProductDescription:
			'Quickly separate brass cartridge cases from corn cob or steel pin tumbling media with the Rotary Media Sifter. With a few turns of the handle, media falls to the bottom of the sifter, leaving cases clean and ready to use. Sifter drum locks into place for easy loading, and clear polycarbonate lid allows easy monitoring of progress.',
		ProductImage: 'http://images.salsify.com/image/upload/s--68D4N6tY--/cxcilbrn31khdbfxrpf9.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--R5Vmvmrw--/y0gtlptrvevwpfmbjb3l.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bbsNphLW--/cb7wlej6o4qoiofxnazv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--pQfZvVLo--/oew0xnwmhmyotn6inybw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--kYyvj__3--/owzlrmssoid0vqrfu7j2.png',
		Videos: 'https://vimeo.com/238317976',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90df96fd-1556-45bc-a92b-e7fe2ca0ce7e',
		ProductID: '044102',
		ProductName: 'Seater Die #2 (.224) 22 Cal W/146',
		UPC: '090255441024',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.625',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441021',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f44b6936-447d-4c8a-8663-acdaaf52f829',
		ProductID: '8786',
		ProductName: '460 Smith & Wesson Magnum Unprimed Cases',
		UPC: '090255487862',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.164',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487869',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '5.82',
		PalletQtyBoxes: '200',
		Retail: '61.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '460 S&W MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8f4dea38-9b6d-4c4c-91f5-d6940144b5f6',
		ProductID: 'A762',
		ProductName: 'Lock-N-Load® 7.62X39 .308/.311 Modified Case',
		UPC: '090255704037',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704034',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NGoQSzpC--/eacf0efc976b979df26bb46991f7317089cc91e1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f40b1b66-8d2b-42f6-947a-5c4cc85c0609',
		ProductID: '046045',
		ProductName: 'Neck Size Die 30 Cal (.308)',
		UPC: '090255460452',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.479',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460459',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd253932c-1aa4-40da-9de7-f821135149e9',
		ProductID: '8132',
		ProductName: '250 Savage 100 gr InterLock® SP',
		UPC: '090255381320',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.945',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381327',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.45',
		PalletQtyBoxes: '1400',
		Retail: '61.57',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.35',
		MuzzleVelocity: '2800',
		MuzzleEnergy: '1741',
		SectionalDensity: '0.216',
		Cartridge: '250 SAVAGE',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TCfHDDDT--/6bdbf8096f0c0e37f3377fddc30acf8d7ad7ebac.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '044f338d-950c-472f-ab64-792d4028ef47',
		ProductID: 'C458L',
		ProductName: 'Lock-N-Load® 458 Lott Modified Case',
		UPC: '090255705195',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705192',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6b2b487f-45b0-4d35-a5ad-b4b0dbfda669',
		ProductID: '86935',
		ProductName: '450 Bushmaster Unprimed Cases',
		UPC: '090255869354',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.414',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255869351',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.07',
		PalletQtyBoxes: '200',
		Retail: '64.60',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9905b07b-60da-44e9-ad20-fc9f57400f1b',
		ProductID: '8730',
		ProductName: '38 Special Unprimed Cases',
		UPC: '090255487305',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.290',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487302',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '11.45',
		PalletQtyBoxes: '200',
		Retail: '66.85',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72894635-df73-4d51-82f3-64b45af1340e',
		ProductID: '27356',
		ProductName: '270 Cal .277 145 gr ELD-X®',
		UPC: '090255273564',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.195',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255273561',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.925',
		PalletQtyBoxes: '540',
		Retail: '63.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.536',
		G7BC: '0.27',
		MinTwist: '1-10"',
		SectionalDensity: '0.27',
		OAL: '1.372',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '145',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cubnzEwz--/4e1738964966e1913e4eaac239ca2fb70f780e66.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2486545e-0edc-4a9c-aab3-6a6efbf9585a',
		ProductID: '2265',
		ProductName: '22 Cal .224 55 gr SP',
		UPC: '090255222654',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.857',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222651',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.28',
		PalletQtyBoxes: '1440',
		Retail: '24.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		OAL: '0.7',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IvcGiInu--/8b3ee0ba03e54138b364e13662ee420ff28ba857.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bd7144c9-205a-4c67-b4d0-8ae4bf53fa61',
		ProductID: '392616',
		ProductName: 'Shell Plate #16 Lock-N-Load®AP™ & Projector',
		UPC: '090255926163',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926160',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.5',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6f0e267-c6eb-40f6-a6db-54fbb0c1b803',
		ProductID: '8673',
		ProductName: '375 Ruger Unprimed Cases',
		UPC: '090255486735',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.148',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486732',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.74',
		PalletQtyBoxes: '200',
		Retail: '88.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '328eba5c-01b2-463d-96f5-dcb831f0661e',
		ProductID: '3075',
		ProductName: '30 Cal .308 180 gr InterLock® RN',
		UPC: '090255230758',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.703',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230755',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.545',
		PalletQtyBoxes: '540',
		Retail: '52.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.241',
		SectionalDensity: '0.271',
		OAL: '1.07',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--v3k3u1gp--/7850d11e0823e8f57f0befcb38da2568b90842f5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '822737bd-d952-485d-9682-603a8e92cbe7',
		ProductID: '046447',
		ProductName: 'Full-Length Size Die 300 Rem Ultra Mag (.308',
		UPC: '090255464474',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464471',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f381f6e-6c98-4418-9b15-59fbd3751d46',
		ProductID: '8090',
		ProductName: '308 Win 150 gr InterLock® SP American Whitetail®',
		UPC: '090255380903',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380900',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.0',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.338',
		MuzzleVelocity: '2820',
		MuzzleEnergy: '2649',
		SectionalDensity: '0.226',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--m1p9OXV0--/0a1a3fc4bba7e4f50cc36e820a7b9ac734fe6e05.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '79b5adbf-95ea-435d-a367-24e4aface580',
		ProductID: '046560',
		ProductName: 'Full-Length Size Die 22 Creedmoor (.224)',
		UPC: '090255465600',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465607',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '22 CREEDMOOR',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23010b8b-3a16-4f43-8903-1efa2c57ff72',
		ProductID: '190176',
		ProductName: 'Powder Bushing 516',
		UPC: '090255191769',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.057',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191766',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.57',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db9cd362-cb7e-4b9d-9fdb-6e2dca4965b7',
		ProductID: '80534',
		ProductName: '270 Win 140 gr InterLock® SP American Whitetail®',
		UPC: '090255805345',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805342',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		MuzzleVelocity: '2940',
		MuzzleEnergy: '2687',
		SectionalDensity: '0.261',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime!  Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--9YxtiOvP--/bglbvaeowuhzunfzmnxx.eps',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '729cc0d9-0e5e-4068-a8c3-b7d24697a9f2',
		ProductID: '9249',
		ProductName: '500 S&W Magnum 300 gr FTX®',
		UPC: '090255392494',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.572',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255392491',
		CartonHeight: '3.625',
		CartonWidth: '5.312',
		CartonDepth: '13.500',
		CartonWeight: '15.72',
		PalletQtyBoxes: '720',
		Retail: '110.75',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.12',
		MuzzleVelocity: '1950',
		MuzzleEnergy: '2533',
		SectionalDensity: '0.171',
		Cartridge: '500 S&W MAG',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		BulletName: 'FTX® W/C',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gsAFVY7R--/9a83bd4b1e46689fb700f94955bb42a113e5dae9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '57aa3102-5724-4532-af12-b6922b2fbe5b',
		ProductID: '050170',
		ProductName: 'Lock-N-Load® Power Case Prep Lg Cal Inside Diameter Chamfer',
		UPC: '090255501704',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2.25',
		ShelfDepth: '1',
		Weight: '0.115',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501701',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '1.15',
		PalletQtyBoxes: '0',
		Retail: '40.21',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Chamfer the mouth of your cartridge case. Large size, 45+ Cal. Inside Diameter. Threaded (8-32) for use in products like the Case Prep Trio or the Power Case Prep Center.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bbiw6cIK--/ofj83wswhrn9reqsws26.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1989db76-8b36-4683-8908-27875d81b0ee',
		ProductID: '044390',
		ProductName: 'Seater Die (.308) 8.6 Blackout',
		UPC: '090255443905',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.250',
		ShelfWidth: '1.250',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		Cartridge: '8.6 BLACKOUT',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press. The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers. HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies. Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol). No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '84a8962c-aa89-479b-9565-6150fe928ede',
		ProductID: '044170',
		ProductName: 'Taper Crimp Die 38 Cal/9mm',
		UPC: '090255441703',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.455',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441700',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cb11d7c3-88aa-406c-865d-721ed28d5b44',
		ProductID: '81482',
		ProductName: '6.5 Creedmoor 140 gr BTHP American Gunner®',
		UPC: '090255814828',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '3.125',
		ShelfDepth: '6',
		Weight: '2.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814825',
		CartonHeight: '6.500',
		CartonWidth: '6.750',
		CartonDepth: '16.500',
		CartonWeight: '25.6',
		PalletQtyBoxes: '450',
		Retail: '102.33',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Rifle Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.58',
		MuzzleVelocity: '2690',
		MuzzleEnergy: '2249',
		SectionalDensity: '0.287',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces a variety of rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kcXZTRXE--/iyerxgndyba02kfaeqcr.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VvYVBrjn--/e32310685af453996435cb5acfa6cae72e3aca5d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cn7bWxnr--/jqy5fotaq7bsq8mwwdcx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SzgHkrlW--/zrjrfe1l2jnxjtlm2gdb.jpg',
		Videos: 'https://vimeo.com/163447195',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c53eb07b-c88f-488d-aa83-bd2153e5d0d8',
		ProductID: '24539',
		ProductName: '6mm .243 85 gr InterBond®',
		UPC: '090255245394',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '3.375',
		Weight: '1.307',
		WeightUOM: 'LB',
		CaseQty: '30',
		CartonUCC: '10090255245391',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.21',
		PalletQtyBoxes: '1080',
		Retail: '83.31',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.395',
		SectionalDensity: '0.206',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '85',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--y-znJews--/a79d891c8921d7e289fa6a835032839f0a692c7e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cu0EVyQ0--/zioyqrbujqyhqa8mbp1c.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9dddead1-2bde-4429-8705-0b0ed47930a1',
		ProductID: '86722',
		ProductName: '300 Remington Short Action Ultra Magnum Unprimed Cases',
		UPC: '090255867220',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.840',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867227',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.2',
		PalletQtyBoxes: '200',
		Retail: '73.40',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '300 REM SA ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '99e7e1c3-60bd-4ecb-904f-9eb736fe7a75',
		ProductID: '8670',
		ProductName: '300 Winchester Magnum Unprimed Cases',
		UPC: '090255486704',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.014',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486701',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.07',
		PalletQtyBoxes: '200',
		Retail: '78.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27cc4e9e-55aa-46ff-b0c4-21cdc043e2c8',
		ProductID: '546225',
		ProductName: 'Full-Length 2-Die Set 243 Win SS Mag (.243)',
		UPC: '090255562255',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.410',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562252',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.05',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '243 WSSM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3f0031f-b31c-4666-be54-916909d9f170',
		ProductID: '046247',
		ProductName: 'Full-Length Size Die 244/6mm (.243)',
		UPC: '090255462470',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.571',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462477',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6MM REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e325a5ee-2bd3-4d15-a52f-edebb5728bcc',
		ProductID: '044095',
		ProductName: 'Lock-N-Load® Press Conversion Bushing',
		UPC: '090255440959',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.153',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440956',
		CartonHeight: '4.500',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '1.53',
		PalletQtyBoxes: '0',
		Retail: '13.53',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Simply thread a Hornady® Lock-N-Load® Conversion Kit into your RCBS® Rock Chucker or other reloading press using a 1¼"-12 thread, and you’re ready to start using the Lock-N-Load® System. It’s the easiest way to get the most out of your reloading press. These bushings let you take advantage of Hornady’s® Lock-N-Load® technology even if you own a competitor’s reloading press.  This item contains one Lock-N-Load® bushing and one conversion bushing.',
		ProductImage: 'http://images.salsify.com/image/upload/s--opP6-YZq--/wos3or9x3ra07fdknft9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '389e6aa7-00b1-4d08-b99a-654b0ea19ec6',
		ProductID: '594250',
		ProductName: 'Match™ Grade Bushing .250',
		UPC: '090255592504',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592501',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.25',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Fu3XRk9O--/c58a8f55d846b73da3b85f3457131fa460a1657b.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd94d0a9-fa0d-4434-945b-bc58ff8457de',
		ProductID: '28302',
		ProductName: '7mm .284 154 gr SST®',
		UPC: '090255283020',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.335',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255283027',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '35.025',
		PalletQtyBoxes: '540',
		Retail: '55.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.525',
		SectionalDensity: '0.273',
		OAL: '1.35',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '154',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--dErzKEB5--/9944998bb33eddff113f7ec56693b54534736336.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc0f9bfa-d854-4fb5-bad6-228acbc607b7',
		ProductID: '546390',
		ProductName: 'Full-Length 2-Die Set 338 Win Mag (.338)',
		UPC: '090255563900',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.461',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563907',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.305',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d4341dd-292f-4354-aac4-dd5fc500c4d7',
		ProductID: '80557',
		ProductName: '270 WSM 130 gr GMX® Outfitter®',
		UPC: '090255805574',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.460',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805571',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '14.6',
		PalletQtyBoxes: '930',
		Retail: '72.33',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '.460',
		SectionalDensity: '0.242',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'GMX®',
		BulletWeightGrain: '130',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OVGxQZiA--/90a789837ca7349ab3872eb57b6bbdc67a0a3510.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7ade113-5a91-437f-ab20-5fe30e3c69e6',
		ProductID: '40060',
		ProductName: '10mm .400 200 gr XTP®',
		UPC: '090255240061',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.987',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255240068',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.805',
		PalletQtyBoxes: '540',
		Retail: '42.05',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.199',
		SectionalDensity: '0.179',
		OAL: '0.685',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--tTkxnsp2--/91a6d7dde6fcdcf9384a4e0a9ca510ae22dcfc5d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b1529b17-eaf4-4941-8856-3243f18f7690',
		ProductID: '82203',
		ProductName: '300 WSM 180 gr GMX® Outfitter®',
		UPC: '090255822038',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822035',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.95',
		PalletQtyBoxes: '930',
		Retail: '72.33',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nxh_lPHC--/95e95342521d2252dd48ddbbb818005246acf8f3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '308ed3bb-38e0-42b9-8d0e-2240ffdb6138',
		ProductID: '190232',
		ProductName: 'Powder Bushing 303',
		UPC: '090255192322',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192329',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19f72bba-22fa-4d86-837c-2382b3da7571',
		ProductID: '046289',
		ProductName: 'Full-Length Size Die 6.5 Carcano (.264)',
		UPC: '090255462890',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462897',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X52 CARCANO',
		Caliber: '6.5MM',
		BulletDiameter: '0.267',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '828b0b8e-d8a3-4834-86bc-98e593def878',
		ProductID: '22000',
		ProductName: '20 Cal .204 24 gr NTX®',
		UPC: '090255220001',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.411',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255220008',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '16.44',
		PalletQtyBoxes: '1440',
		Retail: '37.71',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'NTX® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.17',
		SectionalDensity: '0.082',
		OAL: '0.632',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		BulletName: 'NTX®',
		BulletWeightGrain: '24',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"For use in areas that restrict the use of lead. Hornady® NTX® bullets provide peerless performance with a non-traditional core material that combines accuracy, reliability and Hornady® quality for use in areas with restrictions on the use of traditional bullets.  Hornady® has made lead core bullets since 1949. Lead is, and always will be an excellent core material that provides density and hard-hitting energy to a vast array of bullets. However, there are regulations in some areas that restrict the use of lead in bullets.  The non-lead core of the NTX,® which is crafted from a frangible copper alloy, features a small space between it and the shaft of the hard polymer tip, just like the V-MAX.® This specially designed cavity allows the copper-colored tip and shaft to build up increased energy upon impact with the target before driving into the bullet's core with increased force, initiating near-instant expansion and explosive fragmentation. A phenomenal choice when a non-lead bullet is required. FEATURES: Polymer tip and streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. California compatible, lead-free.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0l_BLzy2--/93e796f7413eff6e59197a2012b14e4cd09f6db6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GQ3g8plx--/85317b3a961e55254bafa373ad1d178d60b7c0db.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--W898X6gs--/qewl7jjbryglhp8lmd1h.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--UNBGPdmG--/ocpxte2pzbrramnpp9mx.png',
		Videos: 'https://vimeo.com/359091228',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6000be61-9ca2-41c6-8a4b-71abb35c5972',
		ProductID: '8740',
		ProductName: '357 Magnum Unprimed Cases',
		UPC: '090255487404',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487401',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '11.5',
		PalletQtyBoxes: '200',
		Retail: '90.97',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5af81ef-301b-4386-84d6-b93ad4fabc56',
		ProductID: '22672',
		ProductName: '22 Cal .224 55 gr FMJ-BT with cannelure',
		UPC: '090255226720',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '8.191',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255226727',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '49.146',
		PalletQtyBoxes: '216',
		Retail: '165.45',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		OAL: '0.735',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YKqIkYCi--/haleg0vggquwzrcksimo.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6699397f-31e9-430e-963e-9277c3f41199',
		ProductID: '546300',
		ProductName: 'Full-Length 2-Die Set 270 Win (.277)',
		UPC: '090255563009',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563006',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '303f2a8d-1071-4e11-815d-88aec1a6f917',
		ProductID: '3035',
		ProductName: '30 Cal .308 150 gr InterLock® RN',
		UPC: '090255230352',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.280',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255230359',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '57.0',
		PalletQtyBoxes: '900',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.186',
		SectionalDensity: '0.226',
		OAL: '0.9',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bmu3DW_F--/11fd0e2d391d2757573c9348ed940daef7fdb079.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1ee06e80-4177-4073-87a1-f82f08b2f070',
		ProductID: '3565',
		ProductName: '9.3mm .366 300 gr DGS®',
		UPC: '090255235654',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.280',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235651',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '57.0',
		PalletQtyBoxes: '900',
		Retail: '84.35',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.28',
		SectionalDensity: '0.32',
		OAL: '1.375',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		BulletName: 'DGS®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--akhcgIwK--/530216f308694c870b096065bb525a373cf195f3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4dc5bd55-bff5-401e-823b-326de0233167',
		ProductID: '050074',
		ProductName: 'Quick Change Powder Die',
		UPC: '090255500745',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '7.675',
		Weight: '0.661',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255500742',
		CartonHeight: '1.250',
		CartonWidth: '1.250',
		CartonDepth: '7.675',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed specifically for use with the Case Activated Powder Drop (#050073), this accessory makes changing over your Lock-N-Load® AP™ faster and easier than ever! Includes lower bracket with guide bushing and lock ring. Our Powder Through™ Expanders (left) are designed for use with the Quick Change Powder Die.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jYfVzAtu--/y51rnojbkg5r2spb8gw3.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4f80537-ce27-4507-b257-0cc367b1e6d7',
		ProductID: '95433',
		ProductName: 'One-Gun Keypad Vault',
		UPC: '090255954333',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '11',
		ShelfDepth: '15.5',
		Weight: '10.100',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255954330',
		CartonHeight: '12.000',
		CartonWidth: '16.500',
		CartonDepth: '36.000',
		CartonWeight: '50.5',
		PalletQtyBoxes: '105',
		Retail: '150.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Specialty Gun Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '4',
		BatteryWattHour: '7.48',
		BatteryWeight: '46',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '5.25',
		ProductExtWidth: '9',
		ProductExtDepth: '12.7',
		ProductWeight: '8.8',
		ProductIntHeight: '3',
		ProductIntWidth: '8.6',
		ProductIntDepth: '11.4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Keypad vaults provide reliability, ease of use and affordable protection. The One-Gun Vault offers a spring-loaded door for quick access. Programmable 4 to 6 digit keypad code ensures convenient access to handguns and valuables. Constructed of thick 16-gauge steel. Interior light automatically illuminates when opening. Premium foam interior cradles and protects valuable contents. California Department of Justice approved firearm storage device. Backup barrel key lock with two keys. Requires four AAA batteries (not included). Pre-drilled for easy mounting. Selectable audible and visible low battery indicators. Spring-loaded door for quick access. Fits 1911 size pistols and 4-inch revolvers.[1]  Exterior Dimensions: 12.7" x 9.0" x 5.25" Interior Dimensions: 11.4" x 8.6" x 3"',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--W0OLKrt5--/y9wjzub1wolbguiqyzwc.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--W0OLKrt5--/y9wjzub1wolbguiqyzwc.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ZF1MWfrX--/reuwtty6mdvbcvwqtptx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RdwfvSG9--/xfw2mbkn2b8fs6fpoygz.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0D0XTq3r--/t9vyh16ix6rkdmefspiv.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--OAd1E6lv--/sv77pvojguinrtypispm.jpg',
		Videos: 'https://vimeo.com/488957707',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2a846970-ba53-4c6a-bd3a-2d88d7c3642d',
		ProductID: '041203',
		ProductName: 'Primer Pocket Reamer Kit Sm',
		UPC: '090255412031',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.086',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412038',
		CartonHeight: '2.000',
		CartonWidth: '9.000',
		CartonDepth: '6.000',
		CartonWeight: '0.86',
		PalletQtyBoxes: '0',
		Retail: '19.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oWvKXUMM--/183517afc4cb4f7b32597222317553f67d476946.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a271d652-4647-4a37-978a-2b0e9b0fd224',
		ProductID: '546289',
		ProductName: 'Full-Length 2-Die Set 6.5 Creedmoor (.264)',
		UPC: '090255562897',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.367',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562894',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.835',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da65a986-91d7-4549-bc58-a92eb95d4c53',
		ProductID: 'B257',
		ProductName: 'Lock-N-Load® 257 Wby Mag Modified Case',
		UPC: '090255704686',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704683',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '63184346-a227-458c-8e45-2217f8c6350a',
		ProductID: '044139',
		ProductName: 'Seater Die #36 (.204) 20 Cal',
		UPC: '090255441390',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.621',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441397',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db58ad3c-06dc-4a2f-98aa-155e30c3c3cd',
		ProductID: '808794',
		ProductName: '300 Blackout 110 gr. CX™ Custom™',
		UPC: '090255720006',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.695',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255720003',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.95',
		PalletQtyBoxes: '1680',
		Retail: '45.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.312',
		MuzzleVelocity: '2285',
		MuzzleEnergy: '1275',
		SectionalDensity: '0.166',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and CX™ bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--WK6ZGtCD--/uq0fz2uj5yy5lhpiivvk.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--HeolI584--/urzcgm1q5lgczl1silyq.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Jphs3hu1--/e0sozdbjmrgcrpotbzuk.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--0NTAUWTP--/bpmiaahykjhkc4g0ijqg.jpg',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '288c39e0-1231-4167-ae35-3ff10fda9c35',
		ProductID: '805294',
		ProductName: '270 Winchester 130 gr. CX™ Outfitter®',
		UPC: '090255719796',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.185',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719793',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.85',
		PalletQtyBoxes: '1400',
		Retail: '60.45',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.403',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '2598',
		SectionalDensity: '0.242',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'CX™',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--MDx0vjv3--/wl2qcaxutyeunfoiojob.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6cd87bb6-319c-474f-95ae-0bbb724d23ec',
		ProductID: '3037',
		ProductName: '30 Cal .308 150 gr FMJ-BT',
		UPC: '090255230376',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.298',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230373',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.47',
		PalletQtyBoxes: '540',
		Retail: '37.91',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		SectionalDensity: '0.226',
		OAL: '1.122',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ-BT',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--9ydCTbel--/uueub9tcxbdzvynworvz.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c4dfe0b9-fd9e-4c7b-adcf-b52b7e20de4e',
		ProductID: '095160',
		ProductName: 'Lock-N-Load® Ammo Plant 110 Volt',
		UPC: '090255951608',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '31.5',
		ShelfWidth: '15',
		ShelfDepth: '13',
		Weight: '63.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '31.500',
		CartonWidth: '15.000',
		CartonDepth: '13.000',
		CartonWeight: '63.0',
		PalletQtyBoxes: '12',
		Retail: '1902.75',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--wZRcd6xQ--/mt0bel26bkc7wlhjm5qb.pdf',
		ProductDescription:
			'Progressive reloading that’s smooth, precise and fast. With a single pull of the handle, you’ll feel the difference between this high-performance machine and ordinary reloading presses. You’ll feel the smooth responsiveness, the rugged construction, and most of all, the power! The Power-Pac Linkage System literally multiplies and accelerates the leverage you apply to the handle. And since the AP features automatic indexing, priming and ejection, every pull of the handle give you a precisely loaded round. QUICK CHANGE LOCK-N-LOAD® BUSHING SYSTEM Lock-N-Load® AP™ has a 5-station quick change bushing system that allows quick and easy change overs from 223 to 45 in less than 5 minutes.  QUICK CHANGE METERING INSERTS The Lock-N-Load® powder measure uses quick change metering inserts that allow you to switch from one powder to another with the push of a button. Add one to each die set for the ultimate in quick change overs.  RELIABLE EZJECT™ SYSTEM The EZject™ feature delivers 100% reliable ejection of every cartridge, every time, without any adjustments.  UNIVERSAL CASE RETAINER SPRING The ingenious case retainer spring allows you to quickly and easily remove or insert a case at any point in the loading process.  PRIMING SYSTEM The Lock-N-Load® AP™ System can be changed from large to small primers as easy as 1-2-3: Change the primer seater punch. Change the primer shuttle. Change the primer feed tube. Photo of Case Activated Powder Drop CASE ACTIVATED POWDER DROP Case activated powder drop will dispense a powder charge only when a cartridge case is present.   AUTOMATIC INDEXING Each station moves half a stage on the down stroke and half on the up stroke, making for ultra smooth functioning. This process is much smoother than presses that do all their indexing on the down stroke.  Turn your progressive press into a bench mounted ammo factory! This kit represents the ultimate reloading setup for maximum production in shorter sessions.  The Lock-N-Load® Ammo Plant™ includes the following: Lock-N-Load® AP™ Press Lock-N-Load® AP™ Case Feeder Lock-N-Load® AP™ Pistol Bullet Feeder Lock-N-Load® Die Bushing (10 - pack) Cartridge Bins (x3) Large Primer Pickup Tubes (x3) Small Primer Pickup Tubes (x3) Primer Slide Spring (x2) Pistol Metering Insert and Rotor Rifle Metering Insert and Rotor Powder Cop Deluxe Die Wrench Case Activated Powder Drop Lock-N-Load® Powder Measure Vintage Tin Sign',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--_dOe_GjR--/m1nsgqruw6dtkljyr4lm.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--u2sUSOEm--/ngitikzyaicgaywn2l4n.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--h-wH6zgG--/e9585ctwwilh7kntkvzg.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--zWWdzkKN--/acygfinatwacaa9q6rf4.png',
		Videos: 'https://vimeo.com/300384244',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23f072b0-d9ef-4e87-91a0-6621df6d8198',
		ProductID: '81364',
		ProductName: '257 Wby Magnum 110 gr ELD-X® Precision Hunter®',
		UPC: '090255813647',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.365',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255813644',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '13.65',
		PalletQtyBoxes: '780',
		Retail: '90.04',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.465',
		G7BC: '0.234',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '2564',
		SectionalDensity: '0.238',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--E0G3rzj4--/9f158b2bba1c9ea7801049d342471fd7e6365217.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e716e3d1-97e5-47fb-99d3-452afb6ce8f5',
		ProductID: '17016',
		ProductName: '17 Cal .172 15.5 gr NTX',
		UPC: '090255170160',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.290',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255170167',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '11.6',
		PalletQtyBoxes: '1440',
		Retail: '37.71',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'NTX® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.115',
		SectionalDensity: '0.075',
		OAL: '0.59',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'NTX®',
		BulletWeightGrain: '15.5',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"For use in areas that restrict the use of lead. Hornady® NTX® bullets provide peerless performance with a non-traditional core material that combines accuracy, reliability and Hornady® quality for use in areas with restrictions on the use of traditional bullets.  Hornady® has made lead core bullets since 1949. Lead is, and always will be an excellent core material that provides density and hard-hitting energy to a vast array of bullets. However, there are regulations in some areas that restrict the use of lead in bullets.  The non-lead core of the NTX,® which is crafted from a frangible copper alloy, features a small space between it and the shaft of the hard polymer tip, just like the V-MAX.® This specially designed cavity allows the copper-colored tip and shaft to build up increased energy upon impact with the target before driving into the bullet's core with increased force, initiating near-instant expansion and explosive fragmentation. A phenomenal choice when a non-lead bullet is required. FEATURES: Polymer tip and streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. California compatible, lead-free.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0l_BLzy2--/93e796f7413eff6e59197a2012b14e4cd09f6db6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--TCNpULr2--/dssns2jtfe1gdh0dc1h8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--W898X6gs--/qewl7jjbryglhp8lmd1h.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--UNBGPdmG--/ocpxte2pzbrramnpp9mx.png',
		Videos: 'https://vimeo.com/359091228',
		DateLastModified: '2023-12-16 08:58:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f35bb556-0ce5-4c82-b379-63a52e3b623c',
		ProductID: '82298',
		ProductName: '8x57 JS 196gr BTHP Vintage Match',
		UPC: '090255822984',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.305',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822981',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.05',
		PalletQtyBoxes: '1400',
		Retail: '61.17',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Vintage Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.525',
		MuzzleVelocity: '2500',
		MuzzleEnergy: '2720',
		SectionalDensity: '0.268',
		Cartridge: '8X57 JS',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '196',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Vintage Match™ ammunition is built to replicate the original military performance specifications unique to many vintage rifles. With the advent of the CMP Vintage rifle and Vintage Sniper Matches, Vintage Match™ ammunition was developed with the match shooter in mind and is meant to provide superior quality, off-the-shelf ammunition for the shooter who is looking for a match grade alternative to surplus or hand-loaded ammunition.  Vintage Match™ offers exceptional accuracy for classic service rifles such as the Mauser, Lee-Enfield, Swedish Mauser or any other rifles chambered for these storied cartridges. HORNADY® MATCH™ BULLETS Hornady® Vintage Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Vintage Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Vintage Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NucP_wJ---/802000d5ac99b6e28026a28a09b48a704a40c39c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cb8c9cab-02eb-4f2e-91d0-f36fa2c29ea0',
		ProductID: '050097',
		ProductName: 'Lock-N-Load® Quick Change Hand Tool',
		UPC: '090255500974',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.625',
		ShelfWidth: '2.25',
		ShelfDepth: '1.2',
		Weight: '0.783',
		WeightUOM: 'LB',
		CaseQty: '20',
		CartonUCC: '10090255500971',
		CartonHeight: '7.625',
		CartonWidth: '2.250',
		CartonDepth: '1.200',
		CartonWeight: '15.66',
		PalletQtyBoxes: '640',
		Retail: '87.73',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA*',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ergonomic Lock-N-Load® Quick Change Hand Tool features a dual-sided chuck that allows for the quick changeover of popular case preparation tools like chamfer, deburr, primer pocket reamers and cleaners, brushes or other tools with 8-32 threads. Dual-sided chuck allows quick changeover from one tool to the next Ergonomic design to reduce hand/finger fatigue during case preparation Can be used with chamfer tools, primer pocket reamers and cleaners, brushes, or any tool with 8-32 threads Includes: 3 dual-sided chucks; chamfer/deburr tools; large and small primer pocket cleaners; and neck brushes for the following calibers: 22 cal, 25 cal/6mm, 270 cal/7mm, 30 cal, 35 cal/9mm and 45 cal.',
		ProductImage: 'http://images.salsify.com/image/upload/s--oE3bQU4J--/hau9noptdqkrsnibna9i.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '733ef029-5ea5-48d4-bb33-255fa720e3c2',
		ProductID: '046252',
		ProductName: 'Match™ Grade Full-Length Size Die 338 Lapua Mag (.338)',
		UPC: '090255462524',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462521',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1bc46ad1-71c4-4092-8c03-33c8770dc8b1',
		ProductID: '190119',
		ProductName: 'Shot Bushing 1 oz',
		UPC: '090255191196',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.067',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191193',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.67',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'deef60c6-cc8d-4335-8ee9-2961bcde4e6e',
		ProductID: '8789',
		ProductName: '480 Ruger Unprimed Cases',
		UPC: '090255487893',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.150',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487890',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.75',
		PalletQtyBoxes: '200',
		Retail: '106.41',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '480 RUGER',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60c98d57-efdf-4c32-97f5-0892643cd301',
		ProductID: '546509',
		ProductName: 'Full-Length 3-Die Set 327 Fed/S&W/H&R(.311)',
		UPC: '090255565096',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.778',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565093',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.89',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '32 S&W LONG/32 H&R MAG/32 FEDERAL MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb7bda0a-d1d2-4cab-9452-7aad32058f7b',
		ProductID: '044544',
		ProductName: 'Expander Die 44 Cal (.429-.430)',
		UPC: '090255445442',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.486',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445449',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '890c638c-13b5-44c0-9e7e-a7aec3b807f6',
		ProductID: '050145',
		ProductName: 'Cam Lock™ Trimmer Power Adapter',
		UPC: '090255501452',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2.25',
		ShelfDepth: '1',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501459',
		CartonHeight: '8.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '0',
		Retail: '28.08',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The power adapter for your Cam-Lock™ Trimmer allows you to use a battery-operated screwdriver instead of muscle power to drive your trimming. The adapter replaces the hand crank for easy operation.',
		ProductImage: 'http://images.salsify.com/image/upload/s--WZ1VMgeE--/kwsterfqk7efpltixo7q.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '40738762-d6e2-4c61-a315-6efb2543c300',
		ProductID: '75220',
		ProductName: 'Snapsafe® Lock Box With Key Lock XXL',
		UPC: '851529004273',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '9',
		ShelfDepth: '12.25',
		Weight: '6.260',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004270',
		CartonHeight: '13.000',
		CartonWidth: '10.000',
		CartonDepth: '15.250',
		CartonWeight: '31.3',
		PalletQtyBoxes: '325',
		Retail: '54.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.5',
		ProductExtWidth: '8.5',
		ProductExtDepth: '11.5',
		ProductWeight: '6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--xwCA6kf_--/addeuvzlz5apobjbl9vb.png',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd8eac6c-520f-4639-b6f6-870e501c5018',
		ProductID: '546584',
		ProductName: 'Full-Length 4-Die Set 454 Casull (.452)',
		UPC: '090255565843',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '2.010',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565840',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '10.05',
		PalletQtyBoxes: '0',
		Retail: '133.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series V Four-Die Handgun Die Sets',
		Cartridge: '454 CASULL',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd5447d0d-682e-4d50-aef7-d6c6cd34243c',
		ProductID: '046291',
		ProductName: 'Full-Length Size Die 6.5 Jap (.264)',
		UPC: '090255462913',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462910',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5 JAP',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '687a7dc1-fced-481e-a888-c7235008774b',
		ProductID: '8144',
		ProductName: '25-06 Rem 117 gr InterLock® BTSP American Whitetail®',
		UPC: '090255381443',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.132',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381440',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.32',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.391',
		MuzzleVelocity: '2990',
		MuzzleEnergy: '2322',
		SectionalDensity: '0.253',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--JgCuLcd8--/10344da00a52d126447611ec265534ae070c5f89.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a9c7e01-e328-4122-84c9-df5fcda6d146',
		ProductID: '546206',
		ProductName: 'Full-Length 2-Die Set 218 Bee (.224)',
		UPC: '090255562064',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562061',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '218 BEE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '725997f2-b373-4431-a3d1-ea1d396153ef',
		ProductID: '046306',
		ProductName: 'Full Length Die 7mm PRC (.284)',
		UPC: '090255463064',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.540',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonWeight: '0.0',
		Retail: '53.05',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackUCC: '10090255463061',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers. *Other accessories sold separately. HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-02-22 14:05:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90104773-8b34-49a6-8405-45a359d4d14b',
		ProductID: '86871',
		ProductName: '416 Ruger Unprimed Cases',
		UPC: '090255868715',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.178',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868712',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.89',
		PalletQtyBoxes: '200',
		Retail: '94.04',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '416 RUGER',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bdc7d026-189e-4864-9f31-fe670339b92c',
		ProductID: '041210',
		ProductName: 'Primer Pocket Reamer Package',
		UPC: '090255412109',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.080',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412106',
		CartonHeight: '2.000',
		CartonWidth: '9.000',
		CartonDepth: '6.000',
		CartonWeight: '0.8',
		PalletQtyBoxes: '0',
		Retail: '36.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Primer Pocket Reamer Package makes cases with crimped primer pockets reloadable by cutting away the crimp. Complete with handle, large and small cutter heads. Heads also fit on Power Case Prep Center and Case Prep Trio.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oWvKXUMM--/183517afc4cb4f7b32597222317553f67d476946.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4baef9f1-7406-4100-8e26-a03a420dfa9b',
		ProductID: '546340',
		ProductName: 'Full-Length 2-Die Set 30-06 (.308)',
		UPC: '090255563405',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.389',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563402',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.945',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bc648f27-3e19-416e-8ee9-a7ceeac3687a',
		ProductID: '80593',
		ProductName: '7mm Rem Mag 139 gr SST® Superformance®',
		UPC: '090255805932',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805939',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.6',
		PalletQtyBoxes: '780',
		Retail: '70.88',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '3240',
		SectionalDensity: '0.246',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WVaU0aaG--/e0f272933ba26c40bb3762e838cd1ee6364472c6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ec2f3d6-4c79-4ffe-a169-76db9da68a58',
		ProductID: '594332',
		ProductName: 'Match™ Grade Bushing .332',
		UPC: '090255593327',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593324',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '33 CAL',
		BulletDiameter: '0.332',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6pvIWrp7--/288e1ad55662b6b0404951fd1f4a6bfa49e2957a.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4651614c-2568-449b-8442-a0afa19e1814',
		ProductID: '67714',
		ProductName: '50 Cal. 340 gr. ELD-X® Bore Driver®',
		UPC: '090255677140',
		PackagedQTY: '12',
		PackagedUOM: 'BX',
		ShelfHeight: '7.500',
		ShelfWidth: '5.000',
		ShelfDepth: '1.250',
		Weight: '0.720',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255677147',
		CartonHeight: '5.500',
		CartonWidth: '7.687',
		CartonDepth: '8.000',
		CartonWeight: '7.2',
		PalletQtyBoxes: '960',
		Retail: '21.73',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzeloading',
		ProductLine: 'Bore Driver®',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.315',
		SectionalDensity: '0.195',
		Caliber: '50 CAL',
		BulletDiameter: '0.499',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '340',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		Sabot: 'Sabot',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fast and easy to load, the Bore Driver® delivers the ultimate in muzzleloader performance. At the heart of the system is a polymer base (not a sabot) that seals the bore to deliver maximum energy transfer and accuracy. Atop the base is an ELD-X® or FTX® bullet, featuring a rugged gilding metal jacket coupled with polymer tip technology and an InterLock® ring that delivers maximum lethality. When you have one shot this muzzleloader season, make it count and use the best – Hornady® Bore Driver®!  LOADS FAST AND EASY Without a sabot, the Bore Driver® seats quickly and easily for shot-after-shot performance. MAXIMUM LETHALITY FTX® and ELD-X® bullets incorporate an InterLock® ring that helps retain bullet weight upon impact that when coupled with a tough copper alloy jacket, delivers deep penetration and expansion for the ultimate in on-game lethality. POLYMER TIP Upon impact, the polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion. PERFORMANCE-BOOSTING BASE The polymer base features a post that fits into the bottom of the bullet. This post swells in diameter at ignition for better torque engagement from inside the bullet and the centering petals grip the bullet’s boattail while the skirt engages the rifling to maximize energy transmission.',
		ProductImage: 'http://images.salsify.com/image/upload/s--MrbkQamH--/zodadphpgi58znmfpt5z.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--OGo5Nkkh--/o0acw9qiuzxq6cqo6bln.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--IVm1vS9i--/iux5wzeibndf7dyfmm5h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8AzFTXZh--/g4tcxwgjrtcc3vtldukn.png',
		Videos: 'https://vimeo.com/763843541',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0403459f-f7a7-43b3-8018-d199c2043f4f',
		ProductID: '3410',
		ProductName: '348 Cal .348 200 gr InterLock® FP',
		UPC: '090255234107',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.972',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255234104',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.58',
		PalletQtyBoxes: '540',
		Retail: '53.13',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.246',
		SectionalDensity: '0.236',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		BulletName: 'FP',
		BulletWeightGrain: '200',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--no-Jc_mr--/597285dc369a13fd1d5cca805f25b154714b1ba6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7872e631-56c0-4a38-8271-3051d6f9519b',
		ProductID: '390753',
		ProductName: 'Large Primer Cleaner',
		UPC: '090255907537',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.021',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255907534',
		CartonHeight: '1.000',
		CartonWidth: '6.000',
		CartonDepth: '8.000',
		CartonWeight: '0.21',
		PalletQtyBoxes: '0',
		Retail: '7.88',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--1XhTOrYM--/p8kojeirym11uwiyaedm.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0479a00b-96a0-42ab-8141-a298842fff7e',
		ProductID: '044713',
		ProductName: 'Seater Die 6.8mm Rem Spc (.277)',
		UPC: '090255447132',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447139',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '56edf93b-ef60-4ace-8a66-ece00664daf6',
		ProductID: '75410',
		ProductName: 'Snapsafe® In Wall Safe',
		UPC: '851529004457',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '17.75',
		ShelfDepth: '23.5',
		Weight: '35.150',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '5.500',
		CartonWidth: '17.750',
		CartonDepth: '23.500',
		CartonWeight: '35.15',
		PalletQtyBoxes: '52',
		Retail: '279.99',
		ParentCategory: 'Security',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--1Bi7IGqs--/vvtnqmr4nyyvmi55dg1s.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--EVEgVX4E--/rzrwh8kojnbliaefrrz3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--MP2iNY83--/u9uqjll6czn8jyjv3pya.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0MmdAejE--/nyibdngpq5qip7dzfdc4.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--0EelTxJY--/drki62cd5p2rqjlmtdcd.jpg',
		Videos: 'https://vimeo.com/213867202',
		Videos1: 'https://vimeo.com/370420587',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2dfab351-f2a5-4b83-af83-8f4a84cb6d6a',
		ProductID: '046362',
		ProductName: 'Full-Length Size Die 7.5 Swiss K31 (.308)',
		UPC: '090255463620',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463627',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7.5 SWISS K31',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c1da4154-6acf-4fac-b5b4-5f7575dffecc',
		ProductID: '2442',
		ProductName: '6mm .243 87 gr BTHP',
		UPC: '090255224429',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.337',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224426',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.425',
		PalletQtyBoxes: '900',
		Retail: '38.45',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.376',
		SectionalDensity: '0.21',
		OAL: '0.96',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTHP',
		BulletWeightGrain: '87',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VXeCXgq5--/217be5e8edd6533fef088da691bca1ae7bfb447d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '79baec76-354f-4f2e-89f7-7a63ca12c6fe',
		ProductID: '546503',
		ProductName: 'Full-Length 3-Die Set 30 Carbine (.308)',
		UPC: '090255565034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.784',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565031',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.92',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '30 CARBINE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2072f12b-1ac9-4d89-9e4a-b42b9be05918',
		ProductID: '044654',
		ProductName: 'Lock-N-Load® Control Panel Primer Level Check',
		UPC: '090255446548',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '3.5',
		ShelfDepth: '19',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255446545',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '26.84',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Level Sensor works in conjunction with the Lock-N-Load Control Panel, and is easily adjustable to signal an alarm when the primer tube level reaches the preferred depth for a reminder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8Vbba3Z6--/pyovv1ds2o7ijaedxsf2.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca791231-49de-4d84-bf49-03c01495c2ae',
		ProductID: '050120',
		ProductName: 'Standard Lock-N-Load® Metering Insert',
		UPC: '090255501209',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.500',
		ShelfWidth: '2.000',
		ShelfDepth: '1.500',
		Weight: '0.315',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501206',
		CartonHeight: '10.750',
		CartonWidth: '6.000',
		CartonDepth: '2.000',
		CartonWeight: '3.15',
		PalletQtyBoxes: '0',
		Retail: '21.17',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Switch these metering units in and out of your Lock-N-Load® Powder Measure with just the push of a button. (Not compatible with the Bench Rest Grade Powder Measure.) Meters from 15 to 100 grains of powder.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--f5r1tBOm--/c7d14b61793e069f94bd959e689e316ec399a6bc.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '45426554-7368-461a-ac98-7b9335eab954',
		ProductID: '75414',
		ProductName: 'SnapSafe® Light Grey In-Wall Safe Tall',
		UPC: '842631100656',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '18.75',
		ShelfWidth: '46.5',
		ShelfDepth: '6.5',
		Weight: '64.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '64.0',
		PalletQtyBoxes: '20',
		Retail: '440.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Auxiliary Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '44',
		ProductExtWidth: '16.25',
		ProductExtDepth: '4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Easy to hide and easy to access - everywhere you want it! These In-Wall Safes install between wall studs within minutes using the included lag bolts.  • Innovative latch mechanism maximizes useable interior space. • Heavy-duty 16 gauge steel body construction and 8 gauge steel door. • Electronic lock with key backup. • Light grey durable powder coated finish. • Ability to orient as left or right opening by simply rotating 180 degrees. • Removeable storage shelves. • Audio and LED visual warning light when battery is running low. • Magnetic jewelry/key hooks, and magnetic document holder. • Includes picture frame hook for easy concealment. • Spring assist door. • 4 AA Batteries (not Included). 16.3"W x 44"H x 4"D Weight: 66 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--KDX-DkPf--/cv0klazhwoxtlxwo3nap.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--UyM-_SjH--/ipro4agkrnqgaugwttk9.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ZyPJ0qCA--/l8bi7uakl1dzmyudxhd3.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--L9gGmG-M--/vap5exfijfqew5tvp6q0.png',
		Videos: 'https://vimeo.com/659016450',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cd6f6d20-be42-41cd-bedd-63c8b4f1a629',
		ProductID: '9088',
		ProductName: '44 Mag 300 gr XTP®',
		UPC: '090255390889',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.332',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390886',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '13.32',
		PalletQtyBoxes: '1120',
		Retail: '39.11',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.245',
		MuzzleVelocity: '1150',
		MuzzleEnergy: '881',
		SectionalDensity: '0.232',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Zo29I_Wd--/c0bc7d23fa11443476d56aabdb5ba92129edc1f6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce8a0700-cf7e-4845-8042-a7675e021878',
		ProductID: '546330',
		ProductName: 'Full-Length 2-Die Set 7mm Wby (.284)',
		UPC: '090255563306',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.448',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563303',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.24',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM WBY MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '140fff22-a06b-4a97-bf94-7f2a9a5b5027',
		ProductID: '2229',
		ProductName: '22 Cal .224 45 gr HP BEE',
		UPC: '090255222296',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.710',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222293',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.4',
		PalletQtyBoxes: '1440',
		Retail: '30.48',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.108',
		SectionalDensity: '0.128',
		OAL: '0.498',
		Cartridge: '218 BEE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP',
		BulletWeightGrain: '45',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bR8b5icN--/dd400d906a47ea91ea58fd372ed41c4dc9ddc7e5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ac4b5611-e807-49cb-90c7-629bf16bb3fd',
		ProductID: '390949',
		ProductName: 'Trimer Pilot #7 .284',
		UPC: '090255909494',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909491',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--cokSmQUc--/ebxxw3wzwsehdgr1pugt.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '24692762-b384-4a93-8cae-835f4ac19cbd',
		ProductID: '2260',
		ProductName: '22 Cal .224 55 gr SP SX',
		UPC: '090255222609',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.856',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222606',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.24',
		PalletQtyBoxes: '1440',
		Retail: '24.57',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		OAL: '0.7',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP SX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--FKXZVBf5--/c09e53f0e31d144d848ff0dbec985ec15b9c917e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '433dfa6c-8065-428e-8480-542f4b7e8bfb',
		ProductID: '546365',
		ProductName: 'Full-Length 2-Die Set 300 Rem Ultra Mag (.308)',
		UPC: '090255563658',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563655',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2f61153-d35d-4ca6-967c-dcc5979284e0',
		ProductID: '546309',
		ProductName: 'Full-Length 2-Die Set 7mm Rem SAUM (.284)',
		UPC: '090255563092',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.452',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563099',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.26',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM REM SA ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '621ac4ff-a912-423b-8232-604d1a9607bb',
		ProductID: '546581',
		ProductName: 'Full-Length 3-Die Set Cowboy™ 45 Colt (.452)',
		UPC: '090255565812',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '2.170',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565819',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '10.85',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a79db09-50e5-47d5-ab94-a316b91a633b',
		ProductID: '81534',
		ProductName: '224 Valkyrie 88 gr ELD® Match',
		UPC: '090255815344',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.805',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815341',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.05',
		PalletQtyBoxes: '1400',
		Retail: '40.27',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.545',
		G7BC: '0.274',
		MuzzleVelocity: '2675',
		MuzzleEnergy: '1398',
		SectionalDensity: '0.251',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '88',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xUoeWN7z--/e49e4cf8c2ad69dcc6f78e159292af08ea01c918.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		Videos1: 'https://vimeo.com/294885162',
		Videos2: 'https://vimeo.com/295269764',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e013f7f-4026-4621-a1c7-ee58f98ab175',
		ProductID: '546425',
		ProductName: 'Full-Length 3-Die Set 405 Win (.411)',
		UPC: '090255564259',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.891',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564256',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.455',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '405 WIN',
		Caliber: '405 CAL',
		BulletDiameter: '0.411',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9b17de09-fcfc-457d-b3d0-0e264df04f1f',
		ProductID: '3501',
		ProductName: '35 Cal .355 170 gr InterLock',
		UPC: '090255235012',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.580',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255235019',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.7',
		PalletQtyBoxes: '540',
		Retail: '49.00',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.215',
		SectionalDensity: '0.193',
		OAL: '0.885',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '170',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--VN-TdHdx--/ved4yjyvwp8jmqip3iwh.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b76e1da5-436d-454f-9bed-69b8226920d4',
		ProductID: 'FR100',
		ProductName: '223 Remington 55 gr FMJ Frontier®',
		UPC: '090255711264',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.562',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711261',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '14.05',
		PalletQtyBoxes: '4500',
		Retail: '17.31',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--rrKKSkZ5--/71cb6893d5fcf9e3518e11036fe83b5f9486f7b4.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f2a9850-fc7b-4d81-880e-51a6d7690042',
		ProductID: '392628',
		ProductName: 'Shellplate #28 Lock-N-Load®AP™ & Projector',
		UPC: '090255926286',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.552',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926283',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.52',
		PalletQtyBoxes: '0',
		Retail: '53.33',
		ParentCategory: 'Reloading',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f012ccae-2baa-4f7c-9f1d-848763b3f1fd',
		ProductID: '546421',
		ProductName: 'Full-Length 2-Die Set 450/400 NE(.410)',
		UPC: '090255564211',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564218',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.25',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '450-400 NITRO EXP 3"',
		Caliber: '400 CAL',
		BulletDiameter: '0.41',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2024-03-05 08:41:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '76be6dbe-d1ab-42a6-aa68-33340625bb8f',
		ProductID: '3092',
		ProductName: '30 Cal .308 250 gr A-TIP Match',
		UPC: '090255230925',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '3.860',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255230922',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '38.6',
		PalletQtyBoxes: '240',
		Retail: '125.64',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.878',
		G7BC: '0.442',
		MinTwist: '1-8.5"',
		SectionalDensity: '0.376',
		OAL: '1.87',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--bJVDObJg--/a81ylqiei6rmgaho6hij.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0472f42d-f994-4744-8c7d-261132c9dc82',
		ProductID: 'A450B',
		ProductName: 'Lock-N-Load® 450 Bushmaster Modified Case',
		UPC: '090255705010',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.028',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705017',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.28',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZnPX0TPd--/9ed2ec58212a802efbc695d7d440a41afa2b05de.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '43529385-401b-4ebd-8ef4-4df2b74ac71e',
		ProductID: '90226',
		ProductName: '9mm Luger +P 135 gr FlexLock® Critical Duty®',
		UPC: '090255902266',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.810',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902263',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.1',
		PalletQtyBoxes: '1120',
		Retail: '41.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.195',
		MuzzleVelocity: '1110',
		MuzzleEnergy: '369',
		SectionalDensity: '0.153',
		Cartridge: '9MM LUGER+P',
		PressureRating: '+P',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NgR7NJcO--/c03686fdf1b4c97fa6aec838d0a9f1bc620d5b79.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		Videos2: 'https://vimeo.com/321754395',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8bfb604e-9b74-42cb-85ff-c918c8cb2dcc',
		ProductID: '4167',
		ProductName: '416 Cal .416 400 gr DGS®',
		UPC: '090255601572',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.018',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255601579',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.27',
		PalletQtyBoxes: '540',
		Retail: '101.65',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		SectionalDensity: '0.33',
		OAL: '1.39',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ExcUiN15--/873b0b120cdcc942e682fb677ef782b5dbe571e8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c7b7969-f5cb-4b92-85eb-cf21ef6124d7',
		ProductID: '044708',
		ProductName: 'Seater Die 243 Win SS Mag (.224)',
		UPC: '090255047080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255047087',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5835fca6-9a0a-4376-833c-7777f0a18974',
		ProductID: '2820',
		ProductName: '7mm .284 139 gr InterLock® SP',
		UPC: '090255228205',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.089',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255228202',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.225',
		PalletQtyBoxes: '900',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.392',
		SectionalDensity: '0.246',
		OAL: '1.132',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NRnU0DEI--/3c4415ca1716c86da12881cf8d6639e3962c08c9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ae24b7d0-9281-43bd-acb2-e0d481deff3f',
		ProductID: '86251',
		ProductName: '25-06 Remington Unprimed Cases',
		UPC: '090255862515',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862512',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.25',
		PalletQtyBoxes: '200',
		Retail: '59.79',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-21 10:47:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ceffff6c-4f4d-4515-8a01-fa8433fbe590',
		ProductID: '86240',
		ProductName: '12 GA 00 Buckshot Critical Defense®',
		UPC: '090255862409',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.625',
		ShelfDepth: '4',
		Weight: '0.940',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862406',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '9.4',
		PalletQtyBoxes: '1120',
		Retail: '23.20',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		MuzzleVelocity: '1600',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '00',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle to the line that already includes handgun, Lite and shotgun options. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power — even when environmental conditions aren’t on your side. RELIABLE FUNCTIONING Specially loaded to ensure proper functioning in semi-auto and pump shotguns.  8-Pellets 2 3/4" 1600 fps CONSISTENT PERFORMANCE Our Versatite™ wad technology delivers tight patterns every single time without modification to your gun.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--Tmet7zkd--/mlvoxfutvvshdwv7b4od.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--U9sKOaHj--/177fd693fb1898a81990034bf9f81d875ba2ab60.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lTGpXr3O--/xa4ijamzgeifkytjhkzi.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--X8hKd-Qv--/d3hzw2qr1yo8emtrudnb.png',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '43c3c2f7-b5f5-45b0-bd87-f2520ff21c5b',
		ProductID: '95102',
		ProductName: 'Hornady® 8-Gun Welded Cabinet',
		UPC: '090255951028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '53',
		ShelfWidth: '17',
		ShelfDepth: '11',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '53.000',
		CartonWidth: '17.000',
		CartonDepth: '11.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '197.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Welded Gun Cabinets',
		CountryofOrigin: 'CAMBODIA',
		Prop65Chem1: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		ProductExtHeight: '53',
		ProductExtWidth: '17',
		ProductExtDepth: '11',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This fully welded security cabinet secures firearms that are up to 53 inches long. The anti-pick three point key lock system means only key holders have access. It has storage capacity for everything from rifles, shotguns, and handguns to gear and supplies. Pry-resistant concealed hinges prevent tampering. High-quality steel paired with three-point locking mechanism and barrel key lock provide peace of mind. Fully adjustable shelf and gun racks. Shelf accommodates extra-long shotguns and rifles. Heavy-duty PVC-coated gun racks. Neoprene floor mat. Dimensions: 53"H x 17"W x 11"D',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6gzDcMlM--/vvrdphtdndayfyhh3nyo.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xWE3mLtK--/otno7emogeor1vdwwbxa.png',
		DateLastModified: '2024-01-04 15:41:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '29b28811-ca49-4f2e-a014-73d082385ca7',
		ProductID: '397135',
		ProductName: 'Seating Stem 270 Cal ELD-X® 145 Gr',
		UPC: '090255971354',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.130',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971351',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.3',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '929ab99a-5916-4514-ba9f-735e1b23358c',
		ProductID: '75211',
		ProductName: 'Snapsafe® Lock Box XL Keyed Alike (2 Pack)',
		UPC: '851529004259',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.75',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '8.540',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004256',
		CartonHeight: '11.500',
		CartonWidth: '8.000',
		CartonDepth: '23.000',
		CartonWeight: '42.7',
		PalletQtyBoxes: '250',
		Retail: '80.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '4',
		ProductIntHeight: '1.75',
		ProductIntWidth: '6.75',
		ProductIntDepth: '9.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. SPECIFICATIONS Dimensions: 10” x 7” x 2” Weight: 6 lbs  FEATURES Easy to operate steel key lock mechanism. Keyed option includes two keys that are keyed alike (2-pack option includes four keys). 1500 lb. rated 4 ft. steel security cable (2-pack option includes two cables). Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.",
		ProductImage: 'http://images.salsify.com/image/upload/s--9kWODWjf--/uovlnl9sqkgepnzlwzxi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kOKPg2Ar--/ttr01m8q28msrlxltxwh.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--855nmz5m--/cwrq3qmfhbgwsi8tzejr.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Hn9m89pS--/mvd2ckssry0zqdgw6hgt.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--37dKiJTX--/caa5cvclzkzumwd5oniv.jpg',
		Videos: 'https://vimeo.com/221604953',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5011c24-c617-46d0-8ce1-74cc9e62c5ab',
		ProductID: 'FR1215',
		ProductName: '223 Remington 55 gr SP Frontier®',
		UPC: '090255712858',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '3.906',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712855',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '31.248',
		PalletQtyBoxes: '512',
		Retail: '92.64',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP W/C',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'ORIENTED',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9Wwhl9m3--/ea2d7c1e63492383692621b97fb7061a718ed7cc.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e01f34c3-4724-495a-96b9-ffba9786f6d7',
		ProductID: '8265',
		ProductName: '416 Rigby 400 gr DGS® Dangerous Game™ Series',
		UPC: '090255382655',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.549',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382652',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.294',
		PalletQtyBoxes: '396',
		Retail: '214.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2415',
		MuzzleEnergy: '5180',
		SectionalDensity: '0.33',
		Cartridge: '416 RIGBY',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9w3Y9PLV--/8e6dedae2c730d425f0830f478b96be75c334129.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '456a3913-5c61-4486-94f7-a2f277a87944',
		ProductID: 'FR140',
		ProductName: '223 Remington 55 gr HP Match  Frontier®',
		UPC: '090255711349',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.564',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711346',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '14.1',
		PalletQtyBoxes: '4500',
		Retail: '18.80',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--sLCwcKvE--/208f5993336e359d8aa55fe7c8001da04d77db57.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75ee9041-6d8e-446c-92c2-25f9c8011e0d',
		ProductID: '190159',
		ProductName: 'Powder Bushing 438',
		UPC: '090255191592',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.062',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191599',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.62',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39945424-47df-472f-abda-c0b66c5244f2',
		ProductID: '9151',
		ProductName: '454 Casull 200 gr MonoFlex Handgun Hunter',
		UPC: '090255391510',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.112',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391517',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '11.12',
		PalletQtyBoxes: '1120',
		Retail: '63.73',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		SectionalDensity: '0.14',
		Cartridge: '454 CASULL',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Q33jvqFH--/zqlkfofpd3kovcpq0xpl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7a27d5b-d3f0-42a5-ba5b-f8e6c5dfd09e',
		ProductID: '044164',
		ProductName: 'Seater Die (.264) 6.5 Grendel',
		UPC: '090255441642',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.568',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441649',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a56826a8-510e-4e6c-9158-55820b3affb2',
		ProductID: '546433',
		ProductName: 'Full-Length 3-Die Set 450 NE 3 1/4" (.458)',
		UPC: '090255564334',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564331',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.5',
		PalletQtyBoxes: '0',
		Retail: '164.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2024-03-05 08:41:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c42b764-9faf-4147-b697-7965250eb864',
		ProductID: '90900',
		ProductName: '45 Auto 185 gr FTX® Critical Defense®',
		UPC: '090255909005',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.882',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909002',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.82',
		PalletQtyBoxes: '1120',
		Retail: '41.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.14',
		MuzzleVelocity: '900',
		MuzzleEnergy: '333',
		SectionalDensity: '0.13',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'FTX®',
		BulletWeightGrain: '185',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SLQtKEBV--/9af6fdef37814074ec1d155387937a2e366e886e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c40033c-1338-4bdd-a247-e7ccaba79739',
		ProductID: '90060',
		ProductName: '32 H&R Mag 80gr FTX Critical Defense®',
		UPC: '090255900606',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.5',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900603',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '5.95',
		PalletQtyBoxes: '1120',
		Retail: '47.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.136',
		MuzzleVelocity: '1150',
		MuzzleEnergy: '235',
		SectionalDensity: '0.117',
		Cartridge: '32 H&R MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		BulletName: 'FTX®',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TZyT9qQ_--/1b1fbeee6ab43d5c3b866879d5a02b2b430851cb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4182f67b-a966-450e-90e1-6d1ce6309616',
		ProductID: '046394',
		ProductName: 'Full-Length Size Die 8.5x55 Blaser (.338)',
		UPC: '090255463941',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '8.5X55 BLASER',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers. *Other accessories sold separately. HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 09:09:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06a7b227-ee46-462d-8fee-c11c050160a1',
		ProductID: '546222',
		ProductName: 'Full-Length 2-Die Set 220 Swift (.224)',
		UPC: '090255562224',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562221',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '220 SWIFT',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b4adba9-5843-4f14-a09f-9a354f917d56',
		ProductID: '046275',
		ProductName: 'Full-Length Size Die 257 Roberts (.257)',
		UPC: '090255462753',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.569',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462750',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '257 ROBERTS',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd44274c0-76f9-4e4f-b983-e3c8a8c50972',
		ProductID: '490504',
		ProductName: 'Crimp Starter 20 Ga 6 Pt',
		UPC: '090255945041',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.5',
		ShelfDepth: '0.05',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255945048',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Universal Crimp Starters',
		Cartridge: '20 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--CE5yeAr4--/baehdwiavoqrlfxfwz26.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7fb204ec-13ee-4e6d-94d4-0a2061e8f0a1',
		ProductID: '80462',
		ProductName: '243 WIN 90 gr ELD-X® Precision Hunter®',
		UPC: '090255804621',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.995',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255804628',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.95',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.409',
		MuzzleVelocity: '3150',
		MuzzleEnergy: '1983',
		SectionalDensity: '0.218',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--orQBQICP--/ec32e2885136d5b6603f9fb233b21448778b7e27.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos2: 'https://vimeo.com/160943649',
		Videos3: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8b7282f-896f-455a-a050-00d57979f68a',
		ProductID: '86936',
		ProductName: '450 Nitro Express 3¼ Unprimed Cases',
		UPC: '090255869361',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '1.135',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255869368',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.675',
		PalletQtyBoxes: '400',
		Retail: '71.07',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-03-05 08:50:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bb1fa405-17b3-4808-8b0f-02600737ffc3',
		ProductID: '546583',
		ProductName: 'Full-Length 4-Die Set 460 S&W (.452)',
		UPC: '090255565836',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '2.010',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565833',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '10.05',
		PalletQtyBoxes: '0',
		Retail: '133.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series V Four-Die Handgun Die Sets',
		Cartridge: '460 S&W MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0095f6e0-ff7f-494e-b6eb-f46e82202618',
		ProductID: '190125',
		ProductName: 'Shot Bushing 1 3/4 oz',
		UPC: '090255191257',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191254',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca28ed29-48b2-4f76-bdb6-5878f3ba8151',
		ProductID: '546415',
		ProductName: 'Full-Length 2-Die Set 375 Ruger (.375)',
		UPC: '090255564150',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564157',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e25cef9-cac0-4f3c-bb51-f73da956ea07',
		ProductID: '8741',
		ProductName: '358 Winchester Unprimed Cases',
		UPC: '090255487411',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487418',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.75',
		PalletQtyBoxes: '400',
		Retail: '62.73',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '358 WIN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '918ca345-fc7f-4e84-9b7f-1b5cc1fc9a73',
		ProductID: '594260',
		ProductName: 'Match™ Grade Bushing .260',
		UPC: '090255592603',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592600',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.26',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RZhoLsEQ--/956f63a284f05413ca6d2c378c6139e7ac25e156.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b8e204f-9eda-413c-b135-b3a04667dba4',
		ProductID: '392172',
		ProductName: '50 BMG Shell Head Adapter',
		UPC: '090255921724',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.371',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921721',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '3.71',
		PalletQtyBoxes: '0',
		Retail: '58.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This shellholder adapter is the perfect accessory if there are any plans to reload any other calibers of ammunition on the Hornady Lock-N-Load® 50 BMG press.',
		ProductImage: 'http://images.salsify.com/image/upload/s---rN5aCq5--/btqf46tem83bztbuxgmi.png',
		DateLastModified: '2023-12-16 09:02:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '373ecb3a-2550-4925-a165-dc96ac3c0251',
		ProductID: '96012',
		ProductName: 'Hornady® Magnum Hanging Basket (8.5" X 14")',
		UPC: '090255960129',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '9.2',
		ShelfDepth: '14',
		Weight: '2.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255960126',
		CartonHeight: '10.000',
		CartonWidth: '16.000',
		CartonDepth: '12.200',
		CartonWeight: '11.5',
		PalletQtyBoxes: '315',
		Retail: '25.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '3',
		ProductExtWidth: '9.2',
		ProductExtDepth: '14',
		ProductWeight: '2',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This basket slides neatly onto a ½-inch to 1-inch shelf in your safe, closet or cabinet, creating additional space for legal-sized documents and supports up to 40 pounds. Maximize storage space in safes, closets and cabinets. Slides onto 1/2-inch to 1-inch thick shelf. PVC coating will not scratch or damage shelf or contents. Accommodates 8½ x 14 inch documents. Supports and holds up to 40 pounds.  Dimensions: 3"H x 9.2"W x 14"D WARNING WARNING: This product can expose you to DI(2-Ethylhexyl) Phthalate, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--FH6P-6ov--/er9wbe61bqes4x5sazle.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MkvMSaRt--/hw1yaolfxfuk02z3adjf.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '34f5dc5b-8683-4edd-97d3-49396116c884',
		ProductID: '31000',
		ProductName: '30 Cal .309 90 gr XTP®',
		UPC: '090255310009',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.361',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255310006',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.025',
		PalletQtyBoxes: '900',
		Retail: '31.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.115',
		SectionalDensity: '0.135',
		OAL: '0.52',
		Caliber: '30 CAL',
		BulletDiameter: '0.309',
		BulletName: 'XTP®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6G6BoLKp--/ffb1f07dbcf2c15117cc74e358c170dc6ba4a2f6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f6ce9c9-7b39-4cd4-9b0c-0ebe59442d35',
		ProductID: '586059',
		ProductName: 'Premium Powder Funnel Kit',
		UPC: '090255860597',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.500',
		ShelfWidth: '4.500',
		ShelfDepth: '3.750',
		Weight: '0.820',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255860594',
		CartonHeight: '19.000',
		CartonWidth: '9.500',
		CartonDepth: '9.000',
		CartonWeight: '8.2',
		PalletQtyBoxes: '0',
		Retail: '57.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'High-capacity, non-static aluminum funnel stores nicely in form-fitted storage case. Nine caliber specific bushings allow funnel to fit a variety of case sizes: .224, .243/6mm, .257, .264/6.5mm, .277/6.8mm, .284/7mm, .308, .338, .375.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--aiYAtUqt--/iucywauqprc2mncocw6w.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--aiYAtUqt--/iucywauqprc2mncocw6w.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--a27kIAPN--/fhl1hj0kmib9nbpiev9w.png',
		Videos: 'https://vimeo.com/596193172?embedded=true&source=video_title&owner=28327899',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ec11834-1551-4cd9-b589-1ee3f1b9215b',
		ProductID: '046363',
		ProductName: 'Full-Length Size Die 7.62 Russ (.308)',
		UPC: '090255463637',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463634',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7.62X54R',
		Caliber: '303 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f7a9aa5b-ce2e-4b51-b4b2-76ae3596079b',
		ProductID: '7030',
		ProductName: '25 Cal Gas Checks',
		UPC: '090255270303',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.318',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255270300',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '12.72',
		PalletQtyBoxes: '1440',
		Retail: '54.55',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '25 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed564dac-9809-48cf-8316-f98d9a49e322',
		ProductID: '044147',
		ProductName: 'Seater Die (.410) 41 Mag',
		UPC: '090255441475',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.497',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441472',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '35679f60-ed49-4b88-bd11-131fab42d3de',
		ProductID: '044000',
		ProductName: 'Sure-Loc™ Lock Ring',
		UPC: '090255440003',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.5',
		Weight: '0.067',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440000',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '0.67',
		PalletQtyBoxes: '0',
		Retail: '5.47',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Upgrade your dies with our Sure-Loc™ Lock Rings. Allows precise adjustments of all standard 7⁄8”–14 dies and accessories. Clamps around the whole die and won’t damage the threads. Applies constant pressure across the threads to hold the ring in place.  Wrench Flats: Remove and replace dies without pliers damaging the lock ring.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lSBuSRFF--/47afc1c145458bb6ea0818e85dc6de4098eb96c2.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '095d2550-edd5-4d70-806b-417d254e56a9',
		ProductID: '86723',
		ProductName: '300 Norma Magnum Unprimed Cases',
		UPC: '090255867237',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867234',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '5.5',
		PalletQtyBoxes: '400',
		Retail: '60.93',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '300 NORMA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '53b8b680-9226-455d-ab20-6697f49ed180',
		ProductID: '90300',
		ProductName: '38 Special 90 gr FTX® Critical Defense® Lite',
		UPC: '090255903003',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '1.375',
		ShelfDepth: '2.5',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255903000',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.0',
		PalletQtyBoxes: '1120',
		Retail: '41.31',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.095',
		MuzzleVelocity: '1200',
		MuzzleEnergy: '288',
		SectionalDensity: '0.101',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FTX®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Since their inception, conventional hollow point pistol bullets have performed well, but have never delivered 100% reliability, especially in self-defense situations. The patented Flex Tip®technology used in Critical Defense® ammunition eliminates the clogging and inconsistency that often plagues hollow point bullets. Hornady® achieved this by using the same tip material used in LEVERevolution® ammunition.  All Critical Defense® ammunition is loaded in nickel-plated cases for increased visibility in low-light situations. Premium low flash propellants deliver proven performance, even in very short-barreled handguns, and won't disrupt your vision. Reliable expansion and dependable terminal performance can be counted on for concealed carry and personal protection.  Critical Defense® Lite ammunition offers an effective, reduced recoil option for any shooter looking to minimize felt recoil of their lightweight, compact personal protection firearm.   *A portion of the proceeds from the sale of Critical Defense Lite ammunition is donated to help fund breast cancer research. FTX® BULLET TECHNOLOGY The patented FTX® bullet expands reliably and resists clogging when fired through heavy clothing.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for defensive or personal protection situations and is the ultimate choice for any short barreled, concealed carry style firearm. Bright nickel-plated cartridge cases simplify chamber checks in reduced light, and low-flash propellants help preserve night vision.  DEPENDABLE Details such as nickel-plated cases that resist corrosion and optimized propellants that burn quickly to reduce recoil and limit muzzle flash, help ensure that Critical Defense® ammo is dependable in every situation.  LIGHT & COMPACT Critical Defense Lite® ammunition offers an effective, reduced recoil option for any shooter looking to minimize felt recoil of their lightweight, compact personal protection firearm.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--5CG3DE5f--/naawyolinsun1hafr4h5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xMbe9Avd--/81145d65f9c10c865369ebee8d2b812e2a98375f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x3JhQn2a--/hm75w7ny0ixwzoszbcuv.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--auw5Pu9n--/fnhjpbeum4jxz7kz1ube.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--McBoyD-u--/mvxo26xpxcng13ij567u.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc328df4-1f9d-4497-9b61-7673a9f5b5e6',
		ProductID: '8602',
		ProductName: '22 Hornet Unprimed Cases',
		UPC: '090255486025',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.530',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486022',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '2.65',
		PalletQtyBoxes: '400',
		Retail: '46.45',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '22 HORNET',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bc3c48ce-b500-4486-9da1-11e49a16185b',
		ProductID: '594329',
		ProductName: 'Match™ Grade Bushing .329',
		UPC: '090255593297',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593294',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '8MM',
		BulletDiameter: '0.329',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--uNdi9_Zg--/a1728b8449bd92c8a25ec880fd33805ad80277c7.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd9fbcf80-5f81-4a52-918d-f35ff71ee83e',
		ProductID: '86242',
		ProductName: '12 GA #4 Nickel 3" Turkey',
		UPC: '090255862423',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.75',
		ShelfDepth: '4',
		Weight: '1.328',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862420',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '13.28',
		PalletQtyBoxes: '1120',
		Retail: '19.13',
		ParentCategory: 'Ammunition',
		Applications: 'AppTurkey',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#4',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Your answer for turkeys and coyotes!  Take down turkeys and coyotes up to 50 yards away with accurate, deadly and dependable Heavy Magnum® Shotgun ammunition. HEAVY MAGNUM® TURKEY Available in 3", 12 or 20 gauge loads, Heavy Magnum Turkey® delivers true gobbler knockdown power! Shot deformation is minimized, thanks to the thickest nickel-plating in the industry, which reduces fliers and keeps more pellets on target for dense patterns. The Hornady® Versatite® wad does the patterning, so these loads don\'t require shotgun modification or specialized turkey chokes. At 1300 fps for the 12 gauge load, and 1200 fps for the 20 gauge load, Heavy Magnum® Turkey ammunition allows hunters to achieve lethal results out to 50 yards.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--AbE_tenh--/08b9ca2f1042562e09c95c3b0f9c7e9fae1afd2e.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--niObLXrk--/9bd7c9c57952bc57e14edc18fe04377113e7359b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--0Y1n1BVa--/p3qgsaqdchsmz1aokwtz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s---CFn2L0A--/o3nzxcu8sb7vmsc2mdbi.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CXfxb5xc--/svmkejrcdjo2szhq3ssx.jpg',
		Videos: 'https://vimeo.com/145438803',
		Videos1: 'https://vimeo.com/264506193',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ff0eaac1-500a-4de9-aae3-9a76893e1ae8',
		ProductID: '392162',
		ProductName: 'Collet #9 .338/.358 Cal',
		UPC: '090255921625',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921622',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.34',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '338 CAL/35 CAL',
		BulletDiameter: '0.338/0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4Bjx36yz--/dfa1a54cf7d570500e636f6643a99013e51ee757.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97b8cfef-6332-4118-9b07-4b9c6c2d1ea9',
		ProductID: 'A300A',
		ProductName: 'Lock-N-Load® 300 Blackout Modified Case',
		UPC: '090255706154',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255706151',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--o1IBniXe--/59c5ebf4e1aa917145fcd00e9ce11b742eb6525b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2f0e822-3d61-4c74-8462-e7add13a1a22',
		ProductID: '86263',
		ProductName: '6.5 X 55mm Swedish Unprimed Cases',
		UPC: '090255862638',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862635',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.75',
		PalletQtyBoxes: '200',
		Retail: '67.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f65a694-2cb7-414e-924e-acab39dccc7f',
		ProductID: '3233',
		ProductName: '8mm .323 170 gr SST®',
		UPC: '090255232332',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.555',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255232339',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.325',
		PalletQtyBoxes: '540',
		Retail: '55.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.445',
		SectionalDensity: '0.233',
		OAL: '1.26',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'SST®',
		BulletWeightGrain: '170',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jk1ot6tU--/0a05399637841c3d8210073d3fa160c382442931.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22032ae4-df6e-4f8e-bd50-733ee0677aac',
		ProductID: '25419',
		ProductName: '25 Cal .257 110 gr InterBond®',
		UPC: '090255254198',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '3.375',
		Weight: '1.644',
		WeightUOM: 'LB',
		CaseQty: '30',
		CartonUCC: '10090255254195',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '49.32',
		PalletQtyBoxes: '1080',
		Retail: '90.13',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.39',
		SectionalDensity: '0.238',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '110',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_FVLNQg3--/7af2837f1f1207701e19438970f041857aed3449.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '69b04b63-096c-43ce-b014-2600c7ee340b',
		ProductID: '2635',
		ProductName: '6.5mm .264 143 gr ELD-X®',
		UPC: '090255226355',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.170',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255226352',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.55',
		PalletQtyBoxes: '540',
		Retail: '61.79',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.625',
		G7BC: '0.315',
		MinTwist: '1-8"',
		SectionalDensity: '0.293',
		OAL: '1.43',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '143',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UG0hUsC8--/2a14915a869198403e784c734bc292c1d116e217.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e7a5031-d4cd-4eb6-8fec-6388ff6330a7',
		ProductID: '99119',
		ProductName: 'Hornady® License Plate Cover',
		UPC: '090255991192',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '7.5',
		ShelfDepth: '15',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Bag',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This plastic license plate frame features the classic Hornady® company logo on the bottom and our “Accurate. Deadly. Dependable.®” slogan on the top. Made in the USA.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5Cv9wtGA--/dm2v04mxi3xtfykufjwr.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f6c8779-2cfb-4ec3-b7f6-62fbf00f6400',
		ProductID: '95851',
		ProductName: 'Premium Safe Anchoring Kit',
		UPC: '090255958515',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '6.5',
		ShelfDepth: '1',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255958512',
		CartonHeight: '9.000',
		CartonWidth: '7.500',
		CartonDepth: '6.000',
		CartonWeight: '5.0',
		PalletQtyBoxes: '0',
		Retail: '17.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'HEX CHROME',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.7',
		ProductExtWidth: '5.71',
		ProductExtDepth: '1.8',
		ProductWeight: '0.9',
		MasterPackQty: '30',
		MasterPackUCC: '30090255958516',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '30.0',
		ProductDescription:
			'The Premium Safe Anchoring Kit includes everything needed to secure your Hornady Security® safe to a concrete floor. Four polymer shims help level the safe in place, while the included carbide concrete bit can be used to drill holes in the concrete floor. Place the anchor bolts into the drilled holes and tap into place with a hammer. Tighten the nuts with the included socket until the anchors expand into place. CARBIDE BIT Carbide bit included for drilling holes in concrete floor.  DRIVE SOCKET Tighten nuts on anchor bolts with included drive socket.  DUSTING CLOTH Dusting cloth keeps safe looking new. CALIFORNIA RESIDENTS  WARNING WARNING: Cancer and Reproductive Harm - www.p65warnings.ca.gov.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VHb-MbW9--/svlrb2fphjwwlgmjvyxq.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sWPTzUB0--/zrruxkwbnnko1cxki6i6.png',
		Videos: 'https://vimeo.com/635537793',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '705cfd8d-b903-4845-b332-7fde8e2a931c',
		ProductID: '041211',
		ProductName: 'Primer Pocket Uniformer - Large',
		UPC: '090255412116',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412113',
		CartonHeight: '1.000',
		CartonWidth: '7.000',
		CartonDepth: '6.000',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '21.24',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.  The Hornady® Primer Pocket Uniformer (LARGE Primer) is an excellent tool for the reloader looking to get every bit of consistency from their handloads.  This tool uniforms primer pocket depths, squares the primer pocket to the case head and squares any rounded corners in the primer pockets for the ultimate in consistent ammunition.  The Primer Pocket Uniformer features an adjustable depth stop, a tensioning nut and features 8-32 threads that will work in the Hornady® Universal Accessory Handle, the Hornady® Case Prep Trio, the Hornady® Case Prep Center or any other tool that will receive 8-32 threads (accessories sold separately).  NOTE: This product does not cut the crimp from crimped brass  Hornady® Primer Pocket Uniformer (LARGE Rifle/Pistol) includes: Qty 1: Large Rifle/Pistol Primer Pocket Uniformer/Cutter Head Assembly • Qty 1: Adjustable Depth Stop • Qty 1: Tension Nut • Qty 1: 1/16”  Allen wrench Other accessories sold separately.  Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--Bzk0FPmG--/yd40n4imxsenvuiubnxl.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a340d48b-2460-423f-a3e4-de08f40ae10b',
		ProductID: '75011',
		ProductName: 'Snapsafe® Super Titan Safe',
		UPC: '851529004136',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '23.5',
		ShelfWidth: '42.25',
		ShelfDepth: '64.25',
		Weight: '590.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '23.500',
		CartonWidth: '42.250',
		CartonDepth: '64.250',
		CartonWeight: '590.0',
		PalletQtyBoxes: '1',
		Retail: '2509.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Modular Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '9V',
		BatteryQty: '1',
		BatteryWattHour: '5.49',
		BatteryWeight: '33.9',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '59',
		ProductExtWidth: '38',
		ProductExtDepth: '17.5',
		ProductWeight: '550',
		ProductIntHeight: '53.5',
		ProductIntWidth: '33',
		ProductIntDepth: '14.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'SnapSafe modular safes are easy to assemble and move anywhere. Simply unpack them piece by piece and assemble them close to your desired location. The SnapSafe modular assembly system locks the walls together from the inside, making them as solid and impenetrable as conventional, welded safes. Their 2300°F fire protection offers peace of mind knowing firearms, jewelry, currency and valuable documents are protected from fire and theft. Here’s all the security of a conventional, welded safe in an easy-to-assemble gun vault that moves anywhere piece-by-piece, then locks together in minutes with no tools.  Every Super Titan ships with one full shelf and full gun rack plus a half gun rack with 2 half shelves, so you can configure your vault to meet your needs. The Super Titan features a 15 slot full gun rack. The recommended capacity is 24 long guns when stored in sleeves with the muzzles up and down, less if your guns have optics.  SnapSafe modular safes feature a UL listed digital lock for security and ease of use with a mechanical key backup for use in case of an electromagnetic pulse. EMPs, which can be natural or manmade, can disrupt electronics. The mechanical key will continue to function in such an emergency, allowing access to guns and valuables inside the safe.  SPECIFICATIONS Exterior: 59”H x 38”W x 17.5”D (add 3” for handle) Interior: 53.5”H x 33”W x 14.5”D Door Opening: 52"H x 14.75”W Weight: 550 Lbs. Capacity: 24+ Long Guns SecuRAM™ Lock: UL-listed digital lock with EMP-proof mechanical key backup  FEATURES Delivered right to your door Assembles in minutes without additional tools (wrench included) Modular Assembly System Sledgehammer and pry-bar resistant 3/16” solid steel door 9 gauge steel exterior walls 2300°F one-hour Fire Shield protection Heat activated door fire seals 15 slot full gun rack (Standard) Secures 24+ long guns (Standard) SecuRam™ Digital Lock Eight 1-inch chrome steel live locking bolts Spring-loaded relocker Powder coated finish Lined interior Adjustable lined shelves 1 full shelf and full gun rack and a half gun rack with 2 half shelves Professional grade "non breach seal" dead bolt door Pre-drilled for floor mounting Lifetime Warranty',
		ProductImage: 'http://images.salsify.com/image/upload/s--K3_aWQBr--/nipwtxuresvhhbhyduxa.jpg',
		Videos: 'https://vimeo.com/251154510',
		Videos1: 'https://vimeo.com/220662709',
		Videos2: 'https://vimeo.com/370420587',
		DateLastModified: '2024-01-22 14:38:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af175fbf-88f1-4078-aa7a-8503ef2a2a37',
		ProductID: 'B204',
		ProductName: 'Lock-N-Load® 204 Ruger Modified Case',
		UPC: '090255704945',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704942',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--7qZ62txD--/6bafb5c1ed13c162da2f262d77746d69071b15eb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa0c1b69-50eb-4329-b5de-02fa422ca0d8',
		ProductID: '81489',
		ProductName: '6.5 Creedmoor 129 gr. InterLock® American Whitetail®',
		UPC: '090255814897',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.080',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814894',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.8',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.445',
		MuzzleVelocity: '2820',
		MuzzleEnergy: '2277',
		SectionalDensity: '0.264',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '129',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vm89FsDj--/135774835c34ad3bca5e30b6b3d5486282b1bb2a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '70d0cf49-f12c-4a30-acda-967c93d56c13',
		ProductID: '7050',
		ProductName: '270 Cal Gas Checks',
		UPC: '090255270501',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.616',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255270508',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '15.4',
		PalletQtyBoxes: '900',
		Retail: '60.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '270 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f863cdfd-1a32-4aa7-aa06-6944bac1516a',
		ProductID: '9122',
		ProductName: '10mm Auto 155 gr HP XTP®',
		UPC: '090255391220',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.785',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391227',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.85',
		PalletQtyBoxes: '1120',
		Retail: '35.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.137',
		MuzzleVelocity: '1410',
		MuzzleEnergy: '684',
		SectionalDensity: '0.138',
		Cartridge: '10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_tJEx988--/6765093f2c68639a4e62eac5884905708c53e3da.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a9bb86e1-75ad-413c-927b-e6c788edde52',
		ProductID: '23010',
		ProductName: '30 Cal .308 110 gr V-MAX®',
		UPC: '090255275087',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.680',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255275084',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.0',
		PalletQtyBoxes: '900',
		Retail: '46.01',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.29',
		SectionalDensity: '0.166',
		OAL: '0.917',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--BojEO6bw--/e2d8d9bada361c01f9fb487ef26fbdde5185d16d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22448166-b373-4ec3-b268-82d1da48ca50',
		ProductID: '044593',
		ProductName: 'Expander Die 44/40 Win Cowboy™(.429)',
		UPC: '090255445930',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445937',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c92c8048-5bb0-4274-9508-66faf7aed8be',
		ProductID: '22261',
		ProductName: '22 Cal .224 50 gr V-MAX®',
		UPC: '090255222616',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.787',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222613',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.48',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.242',
		SectionalDensity: '0.142',
		OAL: '0.773',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mhE3PR_K--/a7240cd5c93b5462ff1e644a313bc44680db3249.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '023bd56f-b6c3-47bb-8c5c-15fac50db961',
		ProductID: '392646',
		ProductName: 'Shell Plate #46 Lock-N-Load®AP™ & Projector',
		UPC: '090255926460',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.565',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926467',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.65',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c4f5767-9d71-4bea-942c-415e0500520f',
		ProductID: '92782',
		ProductName: '44 Mag 225 gr FTX® LEVERevolution®',
		UPC: '090255927825',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.134',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255927822',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '11.34',
		PalletQtyBoxes: '1120',
		Retail: '39.07',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.145',
		MuzzleVelocity: '1410',
		MuzzleEnergy: '993',
		SectionalDensity: '0.174',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FTX®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4t8aHZls--/9c2e59cc8819b92d79972474e20db3599467c182.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8629d7f-8d8a-4968-935f-6247f7f498b1',
		ProductID: '544231',
		ProductName: 'Match™ Grade Neck Size Die 22-250 (.224)',
		UPC: '090255542318',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255542315',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0aa344f7-dc3f-445a-ade7-33a043f9ce08',
		ProductID: '83292',
		ProductName: '223 Rem 50 gr. CX™ Superformance®',
		UPC: '090255832921',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.000',
		ShelfWidth: '2.500',
		ShelfDepth: '4.500',
		Weight: '0.580',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255832928',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.8',
		PalletQtyBoxes: '1680',
		Retail: '42.52',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppVarmint',
		G1BC: '.164',
		SectionalDensity: '0.142',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'CX™',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--SSQlWB1D--/pjta2hqszpaimjmaihs4.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--WrGXZhp_--/omhk27s629mlcmrxv5tp.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f448375f-b484-476c-989f-763b26fc7bb4',
		ProductID: '86202',
		ProductName: '243 Winchester Super Short Magnum Unprimed Cases',
		UPC: '090255862027',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862024',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '8.25',
		PalletQtyBoxes: '400',
		Retail: '79.81',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '243 WSSM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd58eab01-7a04-4998-a7f7-614434f675d8',
		ProductID: '546286',
		ProductName: 'Full-Length 2-Die Set 6.5X68 (.264)',
		UPC: '090255562866',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562863',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X68',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed2e5473-44a2-46a2-bca0-9f830aab6bb7',
		ProductID: '6030',
		ProductName: '44 Cal .433 Lead Balls',
		UPC: '090255260304',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.833',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260301',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.825',
		PalletQtyBoxes: '900',
		Retail: '18.01',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '44 CAL',
		BulletDiameter: '0.433',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '17044bcf-cec7-42c8-95b3-9e1125dbd615',
		ProductID: '80468',
		ProductName: '243 Win 87 gr V-MAX® Custom',
		UPC: '090255804683',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.985',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255804680',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.85',
		PalletQtyBoxes: '1400',
		Retail: '52.93',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '.400',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '2028',
		SectionalDensity: '0.21',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '87',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4Y8IRo8M--/ca9ad398c6ad032d71607074b4c74e26434106c1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '386e67f5-5056-4d9a-a888-ffa20ad67c3e',
		ProductID: 'B7MMP',
		ProductName: 'Lock-N-Load® 7mm PRC Modified Case',
		UPC: '090255721331',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255721338',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '7MM PRC',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iH8TFAYx--/4f20cfc32fcfe9f210924f14cf411d272fb79b69.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '73fe5a52-e437-47e4-8dce-5c617d6e7aad',
		ProductID: '546518',
		ProductName: 'Full-Length 3-Die Set 380 Auto (.355)',
		UPC: '090255565188',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.790',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565185',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.95',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '380 AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2d94e09e-3dc5-476e-bdfc-f419b52bddea',
		ProductID: '95072',
		ProductName: 'Hornady® Mobilis™ Safe Double Door MAX',
		UPC: '090255950724',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '31',
		ShelfWidth: '71',
		ShelfDepth: '46',
		Weight: '1159.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '31.000',
		CartonWidth: '71.000',
		CartonDepth: '46.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '6413.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Modular Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '71',
		ProductExtWidth: '46',
		ProductExtDepth: '31',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Discover the ultimate solution for safeguarding your valuable firearms,  ammo and gear with Hornady Security® Mobilis™ Safes. These safes offer an  innovative modular design that ensures you get the security you need without  the complexities of traditional welded safes. Gone are the days of struggling  with moving companies or installers – the Mobilis™ Safes can be transported  and assembled piece by piece in any room of your choice. The included tool  kit provides everything required for assembly, giving you the power to set up  your safe in a matter of minutes. Thick 9 gauge 2-ply steel exterior walls with pry-resistant 3/16" solid steel door with non-breach seal. Nine to fourteen 1-inch steel live locking bolts (depending on model). Square-Lok™ interior organizing system maximizes storage space according to your preferences. Metal Square-Lok™ shelves and rifle/pistol gun racks can be configured to suit your needs. Additional Square-Lok™ accessories can be purchased separately. Built-in 120V outlet and USB power strip. Protective shelf and floor mats. 2300°F one-hour Fire Shield protection and heat-activated door seals. Durable powder-coated finish in matte grey. Stylish black nickel handles and keypad. UL Listed digital lock with EMP mechanical key backup. Pre-drilled for floor mounting. Lifetime warranty. Delivered right to your door.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--Zr2dS2-2--/y5emswz0lvtvuuprzddk.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Zr2dS2-2--/y5emswz0lvtvuuprzddk.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FF3lRNvC--/mjeyjopfrszmajzcx0h8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--R3iKuitX--/nkkm7fcon7i0jdpiijoo.png',
		Videos: 'https://vimeo.com/876117761',
		DateLastModified: '2024-02-28 11:35:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd28bed8f-139f-4fb3-a3d9-3f679b50e2c3',
		ProductID: '8307',
		ProductName: '218 Bee 45 gr HP',
		UPC: '090255383072',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383079',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '5.6',
		PalletQtyBoxes: '1120',
		Retail: '67.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.108',
		MuzzleVelocity: '2750',
		MuzzleEnergy: '756',
		SectionalDensity: '0.128',
		Cartridge: '218 BEE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '45',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EpdQDmml--/3318be1bb822d6319c130146bd3876cf14f63757.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c19f6f3f-748a-43e9-8509-5efdc970f358',
		ProductID: '45031',
		ProductName: '45 Cal .452 395 gr SUB-X®',
		UPC: '090255450316',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.960',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450313',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.4',
		PalletQtyBoxes: '540',
		Retail: '54.39',
		Brand: 'Hornady®',
		ProductLine: 'Sub-X® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '.300',
		SectionalDensity: '0.276',
		OAL: '1.1',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '395',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reliable subsonic expansion Sub-X® (Subsonic — eXpanding) bullets deliver big results without a big bang! Designed to provide deep penetration below the speed of sound, Sub-X® features a lead core. Long grooves in its gilding metal jacket combine with its flat profile and the patented Flex Tip® insert within the bullet’s hollowpoint cavity to help it expand reliably at low velocities. Cannelures provide positive case crimp, making Sub-X® ideal for semiautomatic weapons. EXPANDS AT SUBSONIC VELOCITIES Patented Flex Tip® technology aids in expansion at velocities as low as 900 fps. PROVEN PERFORMANCE Meets FBI protocol for terminal ballistic test requirements. POSITIVE CASE CRIMP Lead core bullet with cannelured jacket provides positive case crimp for use in semiautomatics. WIDE RANGE OF GUNS Designed to fit, feed and function in a variety of firearms, including gas system guns.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--6JPNHdGn--/vanusfuylesq6gow2tp5.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--gsGui1E0--/jxy32i3v4bwciuqzekqd.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OtRGcACm--/l0fdlmxwkhjzevqlazry.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RMzZ3xew--/iyn6cbplk0acvziaeybv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--MQPLrOG4--/eue6m4ovt2wufmjlfiu0.png',
		Videos: 'https://vimeo.com/367134791',
		Videos1: 'https://vimeo.com/368030686',
		DateLastModified: '2024-03-04 15:47:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c7ab4203-6741-4703-84cc-262ea71b233e',
		ProductID: '2275',
		ProductName: '22 Cal .224 60 gr HP',
		UPC: '090255222753',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.934',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222750',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.36',
		PalletQtyBoxes: '1440',
		Retail: '26.77',
		ParentCategory: 'Bullets',
		Applications: 'AppVarmint',
		G1BC: '0.271',
		SectionalDensity: '0.171',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP',
		BulletWeightGrain: '60',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OoixNGA0--/7a9616dce908c1a4963b0ca1fce6661682949d47.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cbb7633f-623f-4180-ae71-5269f1a197ae',
		ProductID: 'FR264',
		ProductName: '5.56 NATO 62 gr FMJ Frontier®',
		UPC: '090255711530',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '7.25',
		ShelfWidth: '3.75',
		ShelfDepth: '11',
		Weight: '17.050',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711537',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '17.05',
		PalletQtyBoxes: '120',
		Retail: '300.00',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.274',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pZUnZL47--/452e37de69918b07c8788c56ff702c7d11fb1a35.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aad20c31-345a-4c7f-8ee4-762c54bff4fb',
		ProductID: 'FR160',
		ProductName: '223 Remington 68 gr BTHP Match  Frontier®',
		UPC: '090255711387',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.598',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711384',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '14.95',
		PalletQtyBoxes: '4500',
		Retail: '21.13',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.355',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '1323',
		SectionalDensity: '0.194',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '68',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Rso0ZYeZ--/699f3712abf273008c41e03a9dd2c0365a97e4e7.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00e2f4f0-f5cd-45d7-bc51-0fe28ecfe803',
		ProductID: '8335',
		ProductName: '22-250 Rem 40 gr V-MAX®',
		UPC: '090255383355',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.793',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383352',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '7.93',
		PalletQtyBoxes: '1400',
		Retail: '30.95',
		ParentCategory: 'Ammunition',
		Applications: 'AppVarmint',
		G1BC: '0.2',
		SectionalDensity: '0.114',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bCKkdEt3--/a329c60fdf91e34a325aab4762b79fcdf39cdab1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cdb796e8-15de-4959-aca9-839d8b092591',
		ProductID: '451611',
		ProductName: '45 Cal .451 230 gr HAP®',
		UPC: '090255701005',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '6.25',
		ShelfDepth: '6.875',
		Weight: '17.075',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255701002',
		CartonHeight: '7.125',
		CartonWidth: '7.562',
		CartonDepth: '8.625',
		CartonWeight: '34.15',
		PalletQtyBoxes: '174',
		Retail: '177.57',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.188',
		SectionalDensity: '0.162',
		OAL: '0.65',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'HAP®',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--gcuL0dMW--/zptvkoutfs0ycvrhbyc0.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XZzwRwJz--/c024643f6decb3ddc5c9d7a203f59e19c08b7818.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f2fb047c-8a59-49ae-89de-a2792db0991c',
		ProductID: '046288',
		ProductName: 'Match™ Grade Full-Length Size Die 6.5 PRC (.264)',
		UPC: '090255462883',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462880',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6.5 PRC',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8a2b6759-be5b-44b2-9c05-bab1a33c6d8e',
		ProductID: 'A7MM08',
		ProductName: 'Lnl® 7Mm-08 Rem Modified Case',
		UPC: '090255704679',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.028',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704676',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.28',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7f39dcd-170e-489a-b480-791a8579cf47',
		ProductID: '9085',
		ProductName: '44 Mag 240 gr XTP®',
		UPC: '090255390858',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.178',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390855',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '11.78',
		PalletQtyBoxes: '1120',
		Retail: '39.11',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.205',
		MuzzleVelocity: '1350',
		MuzzleEnergy: '971',
		SectionalDensity: '0.185',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '240',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ts1u9Sfx--/90317fc0a684698ff7f555332ceac83dc476083a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '32f1e32a-dd4b-4052-86c4-5bcb9dee63e6',
		ProductID: '594334',
		ProductName: 'Match™ Grade Bushing .334',
		UPC: '090255593341',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593348',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '338 CAL',
		BulletDiameter: '0.334',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SIyuKZ5i--/7a022caf8a1ef1612ee19574553715411c5749a2.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bcdc838c-0480-436d-bf51-3612918ce29a',
		ProductID: '22006',
		ProductName: '20 Cal .204 40 gr V-MAX®',
		UPC: '090255220063',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.644',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255220060',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '25.76',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.275',
		SectionalDensity: '0.137',
		OAL: '0.75',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xtVHCGA7--/2d017118abaabc7d4b8d4cb3a8082f3ef74a56ad.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a38ddba8-9acf-4789-9762-037a0a1ad79a',
		ProductID: '83274',
		ProductName: '223 Rem 55 gr GMX® Superformance®',
		UPC: '090255832747',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.591',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255832744',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.91',
		PalletQtyBoxes: '1680',
		Retail: '37.92',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.245',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'GMX®',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--afxzqvRq--/1fee776d180c40c5f10b224160537a935dc2584f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2356e89d-6145-495c-9051-ad806b9dc1d8',
		ProductID: 'FR2015',
		ProductName: '5.56 NATO 55 gr FMJ (M193) Frontier®',
		UPC: '090255712896',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '3.960',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712893',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '31.68',
		PalletQtyBoxes: '512',
		Retail: '128.51',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--d20YXB5x--/2d1d3e4d699fbe90b616bff0f84b511535d88d62.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c20659a9-f3d8-4838-bab3-8cf929532451',
		ProductID: '80971',
		ProductName: '308 Win 168 gr A-MAX® Hornady BLACK®',
		UPC: '090255809718',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809715',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '1400',
		Retail: '46.17',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.475',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2719',
		SectionalDensity: '0.253',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'A-MAX® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5ZTmaENA--/9a0ce6eb37df4cda15be12e7b885970c15e11bc1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ee85857-ac8c-4b67-8dae-447484eb0da7',
		ProductID: '8623',
		ProductName: '12 GA SST® Slug 300 gr FTX®',
		UPC: '090255386233',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.625',
		ShelfDepth: '4.125',
		Weight: '0.441',
		WeightUOM: 'LB',
		CaseQty: '20',
		CartonUCC: '10090255386230',
		CartonHeight: '4.687',
		CartonWidth: '5.625',
		CartonDepth: '11.062',
		CartonWeight: '8.82',
		PalletQtyBoxes: '2160',
		Retail: '20.71',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Shotgun Slug/Buckshot Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.200',
		MuzzleVelocity: '2000',
		MuzzleEnergy: '2664',
		SectionalDensity: '0.171',
		Cartridge: '12 GA',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		BulletName: 'SST®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® SST® Shotgun Slugs feature patented Flex Tip® technology. Take the proven performance of our super-accurate patented bullet and transform your favorite rifled barrel slug gun into a firearm that outperforms some centerfire rifles. In both 12 gauge and the 20 gauge cartridges, Hornady® SST® Shotgun Slugs deliver sub-2" groups at 100 yards and feature the flattest trajectory on the market.  SST® Slugs are designed for use in fully rifled barrels only. PATENTED FTX® BULLET The sharp point increases the ballistic coefficient of the FTX®, allowing it to fly faster, farther and on a flatter trajectory. On impact, the Flex Tip initiates expansion at all velocities.  UNMATCHED LONG RANGE ACCURACY The SST® Shotgun Slug delivers true 200 yard accuracy and you\'ll achieve sub-2" groups at 100 yards. No other slug gun ammo can come close to the performance of the SST®.  HARD-HITTING TERMINAL PERFORMANCE The SST® Shotgun Slug packs a target-dropping punch! The 12 GA 300 gr FTX® delivers a crushing 1793 ft/lbs of energy at 100 yards and the smaller, 20 GA 250 gr FTX® delivers an impressive 1200 ft/lbs of energy at the same distance.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--HYl8Ijtu--/qjhgxckql7naafioran6.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--TGZaNu3b--/r7bl5bwyk1bj7t0kp7zm.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cVSk7Y4w--/yr2qn50v1strcoxjse8i.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Ez6q3Sdz--/u9lsecclldjbdgkukhcg.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--v8SEFX5A--/yyqhblevmdujb1pibb2q.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be70a1fa-7fe4-4e95-88ca-7c5ec080702c',
		ProductID: '99130',
		ProductName: 'Hornady® Reloading Redzone Tin Sign',
		UPC: '090255991307',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '18',
		ShelfWidth: '12',
		ShelfDepth: '0.03',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area. Each have rounded corners and four pre-drilled holes for easy hanging. Measures. 12"x18"',
		ProductImage: 'http://images.salsify.com/image/upload/s--HVgslht8--/dyowzlllflpa8mqkivk9.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4bc1970f-0da5-4c53-b8ec-870082eb6c10',
		ProductID: 'B350',
		ProductName: 'Lock-N-Load® Headspace Bushing .350',
		UPC: '090255704303',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.130',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704300',
		CartonHeight: '4.750',
		CartonWidth: '10.500',
		CartonDepth: '7.250',
		CartonWeight: '1.3',
		PalletQtyBoxes: '0',
		Retail: '10.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		Caliber: '35 CAL',
		BulletDiameter: '0.35',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. Bushing only. Works with Headspace Gauge, sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VFSOFiSc--/jrryvcxrj7b7lor5idtf.jpg',
		Videos: 'https://vimeo.com/288805295',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c24aa986-2cc9-47ce-8925-c981611c3a12',
		ProductID: '392623',
		ProductName: 'Shell Plate #23 Lock-N-Load®AP™ & Projector',
		UPC: '090255926231',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.565',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926238',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.65',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9164f38b-644f-4cc0-9ead-1247943fdc80',
		ProductID: '2845',
		ProductName: '7mm .284 162 gr InterLock® BTSP',
		UPC: '090255228458',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.442',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255228455',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.63',
		PalletQtyBoxes: '540',
		Retail: '51.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.514',
		SectionalDensity: '0.287',
		OAL: '1.323',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UQe9Lzkx--/8f8e8f44beb854203d2959327cfcade8a52dbdc2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c3043eb-c252-4c2b-89a6-a0ec0d66cca9',
		ProductID: '046585',
		ProductName: 'Size Die 475 Linebaugh (.475)',
		UPC: '090255465853',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.459',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465850',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '61.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series V Four-Die Handgun Die Sets',
		Cartridge: '475 LINEBAUGH/480 RUGER',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6f4b9682-2e36-41d9-bb09-188af6e06047',
		ProductID: '22616',
		ProductName: '22 Cal .224 50 gr V-MAX®',
		UPC: '090255226164',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.897',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255226161',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.425',
		PalletQtyBoxes: '900',
		Retail: '74.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.242',
		SectionalDensity: '0.142',
		OAL: '0.773',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--f1NGiHZq--/69f0e18f6af3fe335a99fd0ec2f7f056c043f231.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '86c1f8d9-ca83-4c3c-b24a-325f32bb7f83',
		ProductID: '95791',
		ProductName: 'Square-Lok™ Parts Bin',
		UPC: '090255957914',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '4.5',
		ShelfDepth: '7',
		Weight: '0.560',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957911',
		CartonHeight: '5.000',
		CartonWidth: '7.500',
		CartonDepth: '22.000',
		CartonWeight: '2.8',
		PalletQtyBoxes: '0',
		Retail: '14.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '0',
		ProductExtWidth: '6',
		ProductExtDepth: '3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'No more misplacing smaller items. This bin keeps small parts organized and close at hand.',
		ProductImage: 'http://images.salsify.com/image/upload/s--SHbuwlPa--/av2qlibsnhezwqel5wfq.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2825de15-7116-4ddd-80c2-27ac3e88d96b',
		ProductID: '8108',
		ProductName: '30-06 Springfield 150 gr InterLock® SP American Whitetail®',
		UPC: '090255381085',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381082',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.0',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.338',
		MuzzleVelocity: '2910',
		MuzzleEnergy: '2820',
		SectionalDensity: '0.226',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XKjXnOnf--/323b59f271f99a9a886a1bbdbb7f29ef4889210d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f4e5be56-1b22-4c7c-b33b-a32169707d7c',
		ProductID: '95070',
		ProductName: 'Hornady® Mobilis™ Safe',
		UPC: '090255950700',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '22',
		ShelfWidth: '18',
		ShelfDepth: '59',
		Weight: '465.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '22.000',
		CartonWidth: '18.000',
		CartonDepth: '59.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '2855.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Modular Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '59',
		ProductExtWidth: '22',
		ProductExtDepth: '18',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Discover the ultimate solution for safeguarding your valuable firearms,  ammo and gear with Hornady Security® Mobilis™ Safes. These safes offer an  innovative modular design that ensures you get the security you need without  the complexities of traditional welded safes. Gone are the days of struggling  with moving companies or installers – the Mobilis™ Safes can be transported  and assembled piece by piece in any room of your choice. The included tool  kit provides everything required for assembly, giving you the power to set up  your safe in a matter of minutes. Thick 9 gauge 2-ply steel exterior walls with pry-resistant 3/16" solid steel door with non-breach seal. Nine to fourteen 1-inch steel live locking bolts (depending on model). Square-Lok™ interior organizing system maximizes storage space according to your preferences. Metal Square-Lok™ shelves and rifle/pistol gun racks can be configured to suit your needs. Additional Square-Lok™ accessories can be purchased separately. Built-in 120V outlet and USB power strip. Protective shelf and floor mats. 2300°F one-hour Fire Shield protection and heat-activated door seals. Durable powder-coated finish in matte grey. Stylish black nickel handles and keypad. UL Listed digital lock with EMP mechanical key backup. Pre-drilled for floor mounting. Lifetime warranty. Delivered right to your door.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--AtzCb6t2--/khqgq2nebutlx6cwbnbl.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--AtzCb6t2--/khqgq2nebutlx6cwbnbl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BXDfk8_i--/jqpw3ihyzsf3r5e3peqe.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--daMjbeA0--/sllu6v6oixxnctjolatg.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--W2hQ2e56--/rffku6n9s1xlcgqviut7.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hTvoZYfB--/h9akavn7yumn15dalo04.png',
		Videos: 'https://vimeo.com/876117761',
		Videos1: 'https://vimeo.com/876117761',
		DateLastModified: '2024-02-28 11:59:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14bb74b9-002a-4163-a680-2d4e06c80141',
		ProductID: '80558',
		ProductName: '270 WSM 145 gr ELD-X® Precision Hunter®',
		UPC: '090255805581',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.480',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805588',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '14.8',
		PalletQtyBoxes: '930',
		Retail: '81.84',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.536',
		G7BC: '0.27',
		MuzzleVelocity: '3100',
		MuzzleEnergy: '3094',
		SectionalDensity: '0.27',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '145',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LTkhOO-f--/fc1944cfd015e4d32834b82a2a255c1b544fbd90.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72c1cd7f-7294-4d93-a58c-9a24145e54a2',
		ProductID: '10428',
		ProductName: '38 Cal .358 158 gr SWC HP',
		UPC: '090255104288',
		PackagedQTY: '300',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '7.083',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255104285',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.498',
		PalletQtyBoxes: '216',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Frontier® Lead Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.139',
		SectionalDensity: '0.176',
		Caliber: '38 CAL',
		BulletDiameter: '0.358',
		BulletName: 'SWC/HP',
		BulletWeightGrain: '158',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gg0axdfV--/dc51d3fed48f4fa9f2e037954e788ec76ad67904.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6ee372c9-0e21-4104-ab32-7fdd4e6b080b',
		ProductID: '050102',
		ProductName: 'Vibratory Trickler',
		UPC: '090255708141',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '7.75',
		ShelfDepth: '10.5',
		Weight: '2.050',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255708148',
		CartonHeight: '11.750',
		CartonWidth: '11.000',
		CartonDepth: '16.000',
		CartonWeight: '8.2',
		PalletQtyBoxes: '304',
		Retail: '65.53',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '2',
		BatteryWattHour: '3.74',
		BatteryWeight: '23',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--DjbL9DdD--/n9ks8czmhkmbeqtb4fpy.pdf',
		ProductDescription:
			'Take powder trickling to a new level of accuracy and efficiency with the new Vibratory Trickler.  The Vibratory Trickler, powered by two AAA batteries, features variable settings to trickle all kinds of powders, ensuring the precise amount for each charge. Its modular design means you can use it with or without the base and also makes cleanup quick and easy. Save time and improve reloading accuracy and efficiency with the Vibratory Trickler. High, low and variable settings trickle all forms of powder. Modular design allows user to position Trickler body where needed and makes cleanup quick and easy.  Featuring: Save time and improve reloading accuracy and efficiency. Ideal for getting loads exactly the same every time. High, low and variable settings trickle all forms of powder. Modular design allows user to position Trickler body where needed. Backlit LED buttons. Quick and easy cleanup. Powered by two AAA batteries (not included).',
		ProductImage: 'http://images.salsify.com/image/upload/s--Zh-L-Q9k--/dmt1d5qkgkcwumudumap.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GGTmyxn9--/dng76jo0s2fhhpxaydfj.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uz2Rkj2H--/yfvpupu7hurp1qz6vvec.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--OCogiJRm--/bdrgbdm9aoa726wvqlij.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--_vU6uaks--/oxscqv3m1yqadn0awp4s.png',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '619d9fec-23b7-407f-a18e-173c4386cdf9',
		ProductID: '30396',
		ProductName: '30 Cal .308 160 gr FTX® (308 Marlin Express)',
		UPC: '090255303964',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.427',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255303961',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.405',
		PalletQtyBoxes: '540',
		Retail: '57.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.395',
		SectionalDensity: '0.241',
		OAL: '1.16',
		Cartridge: '308 MARLIN EXP',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '160',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PZj4sAnb--/7568af71993ccfcca0a2688547a64005f1136bb6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '36952ac5-e989-4645-acef-0b0817d48a0c',
		ProductID: '8600',
		ProductName: '222 Remington Unprimed Cases',
		UPC: '090255486001',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486008',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.0',
		PalletQtyBoxes: '400',
		Retail: '46.45',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '222 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a91a817e-4282-443d-9304-e06c81a70265',
		ProductID: '041202',
		ProductName: 'Primer Pocket Reamer Kit Lg',
		UPC: '090255412024',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.089',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412021',
		CartonHeight: '2.000',
		CartonWidth: '9.000',
		CartonDepth: '6.000',
		CartonWeight: '0.89',
		PalletQtyBoxes: '0',
		Retail: '19.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oWvKXUMM--/183517afc4cb4f7b32597222317553f67d476946.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd524eb0b-82a6-4999-bf05-1ef5afe93435',
		ProductID: '98195WIFI',
		ProductName: ' Hornady® RAPiD® Safe Ready Vault™ w/WIFI',
		UPC: '090255719444',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '54.7',
		ShelfWidth: '22',
		ShelfDepth: '18.1',
		Weight: '176.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '176.0',
		PalletQtyBoxes: '8',
		Retail: '1047.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '52.2',
		ProductExtWidth: '19',
		ProductExtDepth: '15.1',
		ProductWeight: '165',
		ProductIntHeight: '51.8',
		ProductIntWidth: '19',
		ProductIntDepth: '12.7',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Security® RAPiD® Safes offer the quickest, most dependable access to your firearm while providing unmatched security from unauthorized users using patented RFID technology.  The SQUARE-LOK™ organizing system allows gun racks (included) and other SQUARE-LOK™ accessories to be mounted in numerous configurations to maximize storage. Hornady Security LED lights, magnetic hooks, hygrometer and dehumidifiers are all compatible (sold separately). WIFI CONNECTIVITY KEEPS YOU INFORMED Keep tabs on your Ready Vault™ safe through your smartphone. Download the Hornady Security® app and receive an alert when the safe is unlocked.  FAST AND DEPENDABLE TOUCH-FREE ENTRY Patented RFID[2] technology unlocks safe faster than keypads and biometrics. Four included RFID tags including watchband tag, key fob, and two decals can be selectively programmed to open this safe and any other RAPiD® Safe you own.  ADAPTABLE STORAGE The Square-Lok™ organizing system allows gun racks (included) and other Square-Lok™ accessories to be mounted in numerous configurations to maximize storage. Hornady Security LED lights, magnetic hooks, hygrometer and dehumidifiers are all compatible (sold separately).  HEAVY-DUTY, TAMPER-PROOF CONSTRUCTION Heavy-duty steel housing and five hardened locking lugs provide confident protection of valuables. Pre-drilled mounting holes allow additional security.  CALIFORNIA RESIDENTS WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov. IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's interior dimensions. Firearm and firearm accessories not included.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--u20LPSmb--/u9jh0wuvl3egbsdocfb6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--rtbZu_LG--/rz5qwv55s6jrz1yi2coq.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--rz-E6Nyc--/j6um1z41pbfqpwnnttyf.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eN5yhtDl--/pzk3it6psrkkutajpdph.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--8jcNpIrS--/jq6ujkdg4yapgz9qvks9.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mJ7bcOw5--/bxxwuz5elqb9xp4cnlu6.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--gla5acmi--/iszzkm73e7utfp0ios4h.jpg',
		Videos: 'https://vimeo.com/653004386',
		Videos1: 'https://vimeo.com/582575908',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3cdd53df-c780-4396-aeae-ab4ac965a7b1',
		ProductID: '046359',
		ProductName: 'Full-Length Size Die 308 Win (.308)',
		UPC: '090255463590',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.496',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463597',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89f1c205-f416-489c-84cc-2cb0125e97cd',
		ProductID: '86289',
		ProductName: '26 Nosler Unprimed Cases',
		UPC: '090255862898',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862895',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.5',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '26 NOSLER',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:49:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '34daf6b1-0749-41c5-8ecb-6ce7966217a6',
		ProductID: '046441',
		ProductName: 'Full-Length Size Die 260 Rem (.264)',
		UPC: '090255464412',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.573',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464419',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e2fbe6c-832b-4ed1-aa41-feeb286bd23e',
		ProductID: '8336',
		ProductName: '22-250 Rem 50 gr V-MAX® Varmint Express®',
		UPC: '090255383362',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.813',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383369',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.13',
		PalletQtyBoxes: '1400',
		Retail: '40.92',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.242',
		MuzzleVelocity: '3800',
		MuzzleEnergy: '1603',
		SectionalDensity: '0.142',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fm4qWUqK--/b15595a6d483b87039001d9eb858268ac428e976.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b0f6157-524b-494a-b879-cef2464f1d8d',
		ProductID: '546351',
		ProductName: 'Full-Length 2-Die Set 300 PRC (.308)',
		UPC: '090255563511',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.590',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563518',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.95',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a46cba31-1d5d-422a-ab7a-3bfb828d8694',
		ProductID: 'FR204',
		ProductName: '5.56 NATO 55gr FMJ (M193) Frontier®',
		UPC: '090255711417',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '7.25',
		ShelfWidth: '3.75',
		ShelfDepth: '11',
		Weight: '16.550',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711414',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '16.55',
		PalletQtyBoxes: '120',
		Retail: '304.59',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KnAWHc6W--/f713c4008fbd94b41de5f2d47c29f47a148d2115.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'adae7a45-b65d-4509-837b-d4588c34784b',
		ProductID: '1137',
		ProductName: 'Lock-N-Load® 37 Insert (.375 Cal)',
		UPC: '090255704556',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704553',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--1eSrHAYA--/znpnuv6zbmvltzi2hp8i.png',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b86ca447-3bf7-4e1c-832a-730ffbc5cf57',
		ProductID: '82672',
		ProductName: '416 Remington 400 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255826722',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.250',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826729',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '13.5',
		PalletQtyBoxes: '396',
		Retail: '157.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2400',
		MuzzleEnergy: '5115',
		SectionalDensity: '0.33',
		Cartridge: '416 REM MAG',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Pxf10RCc--/4a8637658a7ed8b428d6f477951235d2d40a30a4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31c4ce12-3734-4d3a-b98d-0b93823ce2ce',
		ProductID: '044116',
		ProductName: 'Seater Die #16 (.323) 8mm',
		UPC: '090255441161',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.595',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441168',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03185063-3c06-448e-9711-1c7f6d0d593d',
		ProductID: '044168',
		ProductName: 'Seater Die (.452) 45 Colt Cowboy™',
		UPC: '090255441680',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441687',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '304d2734-8695-4397-bf20-cfb90afab1aa',
		ProductID: '35500',
		ProductName: '9mm .355 90 gr XTP®',
		UPC: '090255235500',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235507',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '35.0',
		PalletQtyBoxes: '900',
		Retail: '31.41',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.099',
		SectionalDensity: '0.102',
		OAL: '0.45',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Fc-qIqER--/0e81386f18c818414959da7ab5069b6f3c90fbff.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dad2aa1f-4cb2-4325-9519-866318698e4b',
		ProductID: '76000',
		ProductName: 'Snapsafe® Safe Light 6 LED Red',
		UPC: '851529004778',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '4.5',
		ShelfDepth: '1',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004775',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.5',
		PalletQtyBoxes: '1800',
		Retail: '24.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '100',
		MasterPackUCC: '30851529004779',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '30.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--WVPf5LT---/sizoez1qryhluc5jp3du.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cyMOduG_--/n8y26ufxucipoegdhopa.jpg',
		Videos: 'https://vimeo.com/213867224',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '418ac360-3190-4e4c-a42b-f3d6663b6897',
		ProductID: '044162',
		ProductName: 'Seater Die (.411) 405 Win',
		UPC: '090255441628',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.586',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441625',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'caa3e71c-da99-429d-8ef3-05f7bc79bcfe',
		ProductID: '546320',
		ProductName: 'Full-Length 2-Die Set 280 Rem (.284)',
		UPC: '090255563207',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.524',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563204',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.62',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '280 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b98eada6-9d3d-406b-a732-6244738cc6a6',
		ProductID: '390577T',
		ProductName: 'Shell Holder #37 For Trimmer',
		UPC: '090255701449',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '1.875',
		ShelfDepth: '3.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255701446',
		CartonHeight: '8.000',
		CartonWidth: '5.000',
		CartonDepth: '1.500',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '7.27',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--hcoJdXVV--/h1dwzl1ruc6bmysedsic.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '414ba16e-6b46-4967-b8bb-77764d64d5ac',
		ProductID: '8697',
		ProductName: '458 Lott Unprimed Cases',
		UPC: '090255486971',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486978',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.5',
		PalletQtyBoxes: '200',
		Retail: '109.47',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '047293e0-8d40-4d45-8779-b11b71d280ab',
		ProductID: '86701',
		ProductName: '300 Winchester Short Magnum Unprimed Cases',
		UPC: '090255867015',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867012',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.0',
		PalletQtyBoxes: '200',
		Retail: '88.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cc875208-c301-42e8-a3de-049b0708d3a6',
		ProductID: '044146',
		ProductName: 'Seater Die (.400) 10mm-40 S&W',
		UPC: '090255441468',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441465',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9c94fc08-32ad-498d-8549-78454b8c162a',
		ProductID: '86747',
		ProductName: '375 Flanged Mag Nitro Express Unprimed Cases',
		UPC: '090255867473',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.960',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867470',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '4.8',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '375 FL MAG NITRO EXP',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3fea6002-232c-488b-a2d0-4663ac75e150',
		ProductID: '98159',
		ProductName: 'RFID Watchband Tag',
		UPC: '090255981599',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '3.5',
		ShelfDepth: '0.001',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981596',
		CartonHeight: '3.500',
		CartonWidth: '3.500',
		CartonDepth: '0.050',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RFID Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD® Safe can be programmed to read up to five different tags. Various tags and accessories are available.',
		ProductImage: 'http://images.salsify.com/image/upload/s--msR6fTTt--/zhqhz9mbkx4noolhrva7.jpg',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd856f702-955f-4cb2-99da-fe52a173b833',
		ProductID: '546580',
		ProductName: 'Full-Length 3-Die Set 50 Action Exp (.500)',
		UPC: '090255565805',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565802',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '50 AE',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7bc8d452-08d6-4926-9497-e22d53f06a81',
		ProductID: '546200',
		ProductName: 'Full-Length 2-Die Set 17 Rem (.172)',
		UPC: '090255562002',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.332',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562009',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.66',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '17 REM',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a78f844-e382-45a9-abde-a5fd006469e4',
		ProductID: '546270',
		ProductName: 'Full-Length 2-Die Set 250 Sav (.257)',
		UPC: '090255562705',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562702',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '250 SAVAGE',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '02fea9be-1e75-48f4-9adb-6779c4c794d2',
		ProductID: '546301',
		ProductName: 'Full-Length 2-Die Set 6.5-284 (.264)',
		UPC: '090255563016',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.476',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563013',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.38',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5-284 (NORMA)',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2b4526b1-2178-4a91-9f65-a2c8b9ff59f4',
		ProductID: '6110',
		ProductName: '54 Cal .535 Lead Balls',
		UPC: '090255261103',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.455',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255261100',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.825',
		PalletQtyBoxes: '540',
		Retail: '23.88',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '54 CAL',
		BulletDiameter: '0.535',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd20468e4-8a5a-49ab-850c-246ebe2c8ece',
		ProductID: '80633',
		ProductName: '7mm Rem Mag 162 gr SST® Superformance®',
		UPC: '090255806335',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.566',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255806332',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.66',
		PalletQtyBoxes: '780',
		Retail: '70.88',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.55',
		MuzzleVelocity: '3030',
		MuzzleEnergy: '3302',
		SectionalDensity: '0.287',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EvmW85gL--/f5f0c54b49c3331e4b40305c66e4a237246aa46f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '87425654-0330-405a-9371-6221184ab381',
		ProductID: '546250',
		ProductName: 'Full-Length 2-Die Set 6mm/284 (.243)',
		UPC: '090255562507',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562504',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6MM-284',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a321a8e-adf2-4c54-825a-3396db144fb7',
		ProductID: '046417',
		ProductName: 'Full-Length Size Die 375 H&H (.375)',
		UPC: '090255464177',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464174',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '58157856-495c-44af-8281-21058a36ca5c',
		ProductID: '380065',
		ProductName: 'Case Neck Brush 25 Cal/6mm',
		UPC: '090255800654',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800651',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '25 CAL/6MM',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with the Lock-N-Load® Case Prep Trio, Case Prep Duo, Lock-N-Load® Power Case Prep Center, and Quick Change Hand Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Eee388ol--/axnbyrtiieiluhylkjpa.png',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '524bec2f-cb80-4d89-9aee-8c82d1a7a1d2',
		ProductID: '75280',
		ProductName: 'Snapsafe® Lock Box Cable',
		UPC: '851529004365',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.625',
		ShelfWidth: '5.625',
		ShelfDepth: '1.375',
		Weight: '0.380',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004362',
		CartonHeight: '6.625',
		CartonWidth: '6.125',
		CartonDepth: '8.125',
		CartonWeight: '1.9',
		PalletQtyBoxes: '1320',
		Retail: '17.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '48',
		ProductExtWidth: '0.5',
		ProductExtDepth: '0.5',
		ProductWeight: '0.35',
		MasterPackQty: '20',
		MasterPackUCC: '30851529004366',
		MasterPackHeight: '7.125',
		MasterPackWidth: '12.500',
		MasterPackDepth: '16.500',
		MasterPackWeight: '7.6',
		ProductImage: 'http://images.salsify.com/image/upload/s--IRZSm2aI--/pgvyyfj6ibqqbrkxlagc.jpg',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '720ab813-8971-4c44-99cd-d569714ca603',
		ProductID: '95200',
		ProductName: 'Hornady® Lock Box Large',
		UPC: '090255713763',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '7',
		ShelfDepth: '10.25',
		Weight: '3.850',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255713760',
		CartonHeight: '11.000',
		CartonWidth: '7.750',
		CartonDepth: '11.000',
		CartonWeight: '19.25',
		PalletQtyBoxes: '500',
		Retail: '36.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '1.75',
		ProductExtWidth: '6.5',
		ProductExtDepth: '9.5',
		ProductWeight: '3.1',
		ProductIntHeight: '1.5',
		ProductIntWidth: '6.25',
		ProductIntDepth: '9.25',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Security® Lock Boxes provide secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All Hornady Security® Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable[3] allows maximum storage space inside the box. Lock Boxes also provide security for concealed carry permit holders. Reliable steel barrel lock opens smoothly and comes with two keys. 4-foot steel security cable withstands up to 1,500 pounds of force. Patented space-saving cable receiver allows maximum storage inside box. Durable 16-gauge steel housing protects against pry attempts. Premium foam interior cradles and protects valuable contents.  Fits most 4-inch barrel pistols and some 4-inch revolvers.  Exterior Dimensions: 9.5"H x 6.5"W x 1.75"D Interior Dimensions: 9.25"H x 6.25"W x 1.5"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--EcrK9pBu--/jgncuwkzasdqieehzfcc.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--EcrK9pBu--/jgncuwkzasdqieehzfcc.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_z9ElQ11--/qx95zqvvot4heqpwrsbj.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--K2aQEtX1--/tsj1ucuacs0wxkswmnny.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b728db6d-6a51-4d8a-ac60-e0ec75678a00',
		ProductID: '190141',
		ProductName: 'Powder Bushing 366',
		UPC: '090255191417',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.067',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191414',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.67',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b89f9812-e918-4c6a-a09b-2016057177cd',
		ProductID: '046200',
		ProductName: 'Full-Length Size Die 17 Rem Fireball (.172)',
		UPC: '090255462005',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462002',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '17 REM FIREBALL',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d89564a-103a-48bd-83c2-3f846f1e094f',
		ProductID: '046570',
		ProductName: 'Size Die 458 Win (.458)',
		UPC: '090255465709',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465706',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '25970852-eda3-4f79-9a3c-be2ed618c6be',
		ProductID: '391931',
		ProductName: 'Neck Turn Mandrel 35',
		UPC: '090255919318',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.072',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919315',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.72',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '35 CAL',
		BulletDiameter: '0.3555',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5d041cc-333e-42f7-8f5c-0608d691f006',
		ProductID: '30371',
		ProductName: '30 cal .308 150 gr FMJ-BT',
		UPC: '090255303711',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '11.000',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255303718',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '66.0',
		PalletQtyBoxes: '216',
		Retail: '180.04',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		SectionalDensity: '0.226',
		OAL: '1.122',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ-BT',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sU58g6ic--/axntz8ythd5jdvs3sl0s.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--9ydCTbel--/uueub9tcxbdzvynworvz.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e77c868f-7d4e-4f74-a06d-05629a99a867',
		ProductID: '81622',
		ProductName: '6.5 PRC 130 gr. CX™ Outfitter®',
		UPC: '090255816228',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255816225',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '13.5',
		PalletQtyBoxes: '930',
		Retail: '77.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.489',
		MuzzleVelocity: '2975',
		MuzzleEnergy: '2555',
		SectionalDensity: '0.266',
		Cartridge: '6.5 PRC',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'CX™',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--CoOdTbZn--/wlldphqepcyqkhghapfm.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d6493ec-46df-4a4f-80ca-4637368e4db8',
		ProductID: '86286',
		ProductName: '264 Winchester Magnum Unprimed Cases',
		UPC: '090255862867',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.930',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862864',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.65',
		PalletQtyBoxes: '200',
		Retail: '82.53',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '264 WIN MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2e32549e-2838-44e1-8062-0ff0774c6b15',
		ProductID: '020003',
		ProductName: 'Shotshell Primer Tube Filler',
		UPC: '090255020038',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.75',
		ShelfWidth: '6.75',
		ShelfDepth: '2.25',
		Weight: '0.584',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255020035',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '31.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shotshell Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The same Primer Tube Filler included with the 366 Auto™ ends the time- consuming task of manually inserting primers into the feed tube. Holds a full box of shotshell primers, and fills the tube with a turn of the dial. Won't drop upside-down primers into the tube.",
		ProductImage: 'http://images.salsify.com/image/upload/s--xEWBqz4I--/lakn3uzcsktdhtqmiq1v.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4bb22cca-27af-44b0-b11d-5fef3d512b45',
		ProductID: '30506',
		ProductName: '30 Cal .308 168 gr ELD® Match',
		UPC: '090255305067',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.523',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255305064',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.845',
		PalletQtyBoxes: '540',
		Retail: '58.68',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.523',
		G7BC: '0.263',
		MinTwist: '1-12"',
		SectionalDensity: '0.253',
		OAL: '1.275',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xw9uursN--/6f2e051b11c7b21d9dca7ffe28668bf06bfadd8a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a67091f3-ac52-4187-bfe4-f374dce36591',
		ProductID: '82224',
		ProductName: '300 RCM 178 gr ELD-X® Precision Hunter®',
		UPC: '090255822243',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.530',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822240',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.3',
		PalletQtyBoxes: '930',
		Retail: '70.61',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.552',
		G7BC: '0.278',
		MuzzleVelocity: '2900',
		MuzzleEnergy: '3323',
		SectionalDensity: '0.268',
		Cartridge: '300 RCM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2eMmm1hz--/0929c050e53cb4f65f3cf9498c70ab07efcc8092.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a916052b-6b4c-4c20-8757-42ae21d48e3d',
		ProductID: 'FR240',
		ProductName: '5.56 NATO 55 gr HP Match  Frontier®',
		UPC: '090255711479',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.570',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711476',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '14.25',
		PalletQtyBoxes: '4500',
		Retail: '18.80',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6KxQlKPZ--/305d0106a46c2e4d1ad8a471e856c8a900ddb945.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c6531b9-70e9-47cf-a13d-12a93d27bbe4',
		ProductID: '544207',
		ProductName: 'Match™ Grade 2-Die Set 223 Rem (.224)',
		UPC: '090255542073',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542070',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce0efd4a-facc-4993-bf2d-ece5a0355985',
		ProductID: '546435',
		ProductName: 'Full-Length 3-Die Set 500 NE (.510)',
		UPC: '090255564358',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564355',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '4.5',
		PalletQtyBoxes: '0',
		Retail: '164.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '500 NITRO EXP 3"',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2024-03-05 08:41:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0c47db31-3935-48b0-b0ec-b79343c2aaec',
		ProductID: '33104',
		ProductName: '338 Cal .338 200 gr FTX® (338 Marlin Express)',
		UPC: '090255331042',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.019',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255331049',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.285',
		PalletQtyBoxes: '540',
		Retail: '74.57',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.43',
		SectionalDensity: '0.25',
		OAL: '1.22',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LrDFZHsD--/2980455c5022106f9a26c09abdf94d9862fa2f94.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee15c717-c562-4f23-b733-a3011b4c3488',
		ProductID: '8672',
		ProductName: '300 Weatherby Magnum Unprimed Cases',
		UPC: '090255486728',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.091',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486725',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.455',
		PalletQtyBoxes: '200',
		Retail: '91.07',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '300 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '99da9596-9ed4-46c5-92b2-09b46b888284',
		ProductID: '045508',
		UPC: '090255455083',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255455080',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ProductLine: 'Expander Dies',
		Cartridge: '30 SUPER CARRY',
		Caliber: '32 CAL',
		BulletDiameter: '0.3115',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '89be8ae9-f099-4129-b9aa-bac59e42a0ac',
		ProductID: 'C416R',
		ProductName: 'Lock-N-Load® 416 Rigby Modified Case',
		UPC: '090255705119',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.051',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705116',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.51',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '416 RIGBY',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6968d850-d2da-4197-a7f3-974947bbf9cc',
		ProductID: '044127',
		ProductName: 'Seater Die #27 (.224)22 Cal W/147',
		UPC: '090255441277',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.633',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441274',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48de0f23-9c32-4b40-8c70-d6c2a9a96d61',
		ProductID: '085004',
		ProductName: '50 BMG Press',
		UPC: '090255850048',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20',
		ShelfWidth: '10.5',
		ShelfDepth: '6',
		Weight: '21.718',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255850045',
		CartonHeight: '20.000',
		CartonWidth: '10.500',
		CartonDepth: '6.000',
		CartonWeight: '21.718',
		PalletQtyBoxes: '0',
		Retail: '715.90',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reload your own .50 BMG rounds with accuracy and precision. This single stage press features our exclusive Lock-N-Load® technology in the ram, which means you can change your shell holder over to ram-prime, then move the shell holder to the top plate. Once the holder and ram-prime are set, they stay that way. A quick change to a Lock-N-Load® bushing makes switching over from ram-prime to die use faster, too. SOLID CONSTRUCTION High strength frame offers rigidity and stability, and is guaranteed never to break or fail.  Photo of Technology in Ram LOCK-N-LOAD® TECHNOLOGY IN RAM Turn your shell holder over to ram prime, then move the shell holder to the top plate. Once the holder and ram prime are set, they stay that way.  Photo of Conversion Bushing CONVERSION BUSHING FOR STANDARD DIES The .50 BMG Press comes standard with 1-1/2" x 12 bushing to convert the die head to the Hornady Lock-N-Load® system that accommodates any standard 7/8" x 14 die. Purchase the optional Shell Head Adapter (Item No. 392172) and load any centerfire cartridge you want. This is especially useful if reloading long cartridges that require a very long stroke.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KUHXpT7_--/1413d4fe4bd3157ec0e83dba088e29f4f5bebbeb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MeympxIM--/cycuygsrgnonusxdphnh.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--y9OcAR_B--/can95cxhewcavimyqbwk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--1ftpDYVg--/rxqfccords3gv0gvcjsh.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fd6718d2-628f-42cd-98cd-39b378811310',
		ProductID: '190157',
		ProductName: 'Powder Bushing 429',
		UPC: '090255191578',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.063',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191575',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.63',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8f6033cb-7027-4bfc-8ab9-5bb79cd00f75',
		ProductID: '544277',
		ProductName: 'Match™ Grade 2-Die Set 260 Rem (.264)',
		UPC: '090255542776',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542773',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd21fd915-9645-4e69-bf48-87b821691ee4',
		ProductID: '3727',
		ProductName: '375 Cal. 375 300 gr DGS®',
		UPC: '090255601565',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.270',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255601562',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.05',
		PalletQtyBoxes: '540',
		Retail: '84.35',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.275',
		SectionalDensity: '0.305',
		OAL: '1.305',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'DGS®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Le6YutOe--/8a9defd07e2a3247d07e1d574f350ea24b57b38b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f1a3492-6f6d-48ae-8e70-71fc746dd588',
		ProductID: '095312',
		ProductName: 'Case Feeder Plate Large Pistol',
		UPC: '090255953121',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.125',
		ShelfWidth: '13',
		ShelfDepth: '12.25',
		Weight: '1.580',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255953128',
		CartonHeight: '2.125',
		CartonWidth: '13.000',
		CartonDepth: '12.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '53.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Select from our four Case Feeder Plates tailor-made for the Lock-N-Load Automatic Case Feeder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--0iPUMM8v--/ujvvc4avav3pdibywrdq.png',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93af0bd5-8cb1-4c32-a452-1995975dd9b6',
		ProductID: '390577',
		ProductName: 'Shell Holder #37',
		UPC: '090255905779',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.051',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905776',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.51',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e5632807-8e2e-4636-b7e3-75c58f83d45b',
		ProductID: '80711',
		ProductName: '7mm PRC 180 gr. ELD® Match',
		UPC: '090255720747',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.610',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255720744',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.1',
		PalletQtyBoxes: '780',
		Retail: '70.92',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '.796',
		G7BC: '.401',
		SectionalDensity: '0.319',
		Cartridge: '7MM PRC',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets. HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets. SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity. CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy. STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HwKQsE-V--/xbvrkteir7hv3wttoxh9.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dkYIvXw0--/hbigwjvtwxjx69dy1vk4.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s---km56VfO--/evjke1nfj67taynsrtkm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n_2RbnyW--/e4bwpeaupdvmuf8ky5wn.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--HYcmrPJn--/jfiglarkrhoa3xephr3n.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--xaeopbc8--/fjxkajr4kpv0x98xi9mt.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		Videos: 'https://vimeo.com/763847434',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a39b8fd7-a210-4461-b4ce-12606c2d58a5',
		ProductID: '243704',
		ProductName: '6mm .243 80 gr. CX™',
		UPC: '090255719468',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.668',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255719465',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '26.72',
		PalletQtyBoxes: '1440',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.273',
		SectionalDensity: '0.194',
		OAL: '1.102',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'CX™',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration. MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency.  OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling.  NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--u1Y9w1C---/o0p1ttatjeq6hhiptcav.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0afd2f5c-2769-431d-9465-cd9f7684bd2a',
		ProductID: '8635',
		ProductName: '270 Winchester Unprimed Cases',
		UPC: '090255486353',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.502',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486350',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.51',
		PalletQtyBoxes: '200',
		Retail: '59.79',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '61aa71e6-8c34-497e-b49d-bab896892984',
		ProductID: '010053',
		ProductName: '366 Primer Shut Off',
		UPC: '090255010534',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '2',
		Weight: '0.433',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255010531',
		CartonHeight: '1.250',
		CartonWidth: '1.250',
		CartonDepth: '2.000',
		CartonWeight: '0.433',
		PalletQtyBoxes: '0',
		Retail: '100.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Independently shut off the primer feed tube instead of removing it. Can be retrofitted to nearly any 366 Auto™.',
		ProductImage: 'http://images.salsify.com/image/upload/s--8b7Ri1O9--/jpstlnexylkfpmaaqkyz.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '08ccf7b7-7b08-4569-ab28-2a18b376d0ca',
		ProductID: '87411',
		ProductName: '41 Remington Magnum Unprimed Cases',
		UPC: '090255874112',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.670',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255874119',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.35',
		PalletQtyBoxes: '200',
		Retail: '66.67',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '41 REM MAG',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60933cf4-4ecf-4a67-a292-343a9dd883fe',
		ProductID: '8093',
		ProductName: '308 Win 150 gr SST®',
		UPC: '090255380934',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.152',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380931',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.52',
		PalletQtyBoxes: '1400',
		Retail: '52.13',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		MuzzleVelocity: '2820',
		MuzzleEnergy: '2649',
		SectionalDensity: '0.226',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--733Rr5Vw--/6980873cef184db26cba3477120637e2a61f5e74.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'daaf5e0e-997b-4c95-8544-dd8d66e1a1c5',
		ProductID: '044509',
		UPC: '090255445091',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445098',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.79',
		Brand: 'Hornady®',
		ProductLine: 'Taper Crimp/Seater Dies For Series II Three-Die Taper Crimp Handgun Die Sets',
		Cartridge: '30 SUPER CARRY',
		Caliber: '32 CAL',
		BulletDiameter: '0.3115',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0e711f62-0ffb-431a-8e5c-e46b15afa7d8',
		ProductID: '8784',
		ProductName: '45-70 Government Unprimed Cases',
		UPC: '090255487848',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487845',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.0',
		PalletQtyBoxes: '200',
		Retail: '88.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '002f335e-7cb0-4d6e-9d16-102312de521f',
		ProductID: '546118',
		ProductName: 'Full-Length 2-Die Set 17 Hornet (.172)',
		UPC: '090255561180',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255561187',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '17 HORNET',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2784018-aa69-4990-bad6-73a9f498ab93',
		ProductID: '81164',
		ProductName: '30-06 SPRG 180 gr GMX® Outfitter®',
		UPC: '090255811643',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.320',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811640',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.2',
		PalletQtyBoxes: '1400',
		Retail: '56.27',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--24hOIOEv--/cdab1c9bc2fbb4919f5b8e6230392f6caed88c78.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '030c7976-9e86-4219-9ab1-37f17283e53b',
		ProductID: '546335',
		ProductName: 'Full-Length 2-Die Set 30 TC (.308)',
		UPC: '090255563351',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.420',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563358',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.1',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '30 TC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e1aaaa0-1d2d-40c9-8183-7608f0407d55',
		ProductID: '8618',
		ProductName: '224 Valkyrie Unprimed Cases',
		UPC: '090255486186',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486183',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.0',
		PalletQtyBoxes: '400',
		Retail: '59.79',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '33255a6a-7c42-4693-9919-670b38afdc97',
		ProductID: '3072',
		ProductName: '30 Cal .308 180 gr InterLock® BTSP',
		UPC: '090255230727',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.723',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230724',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.845',
		PalletQtyBoxes: '540',
		Retail: '52.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.452',
		SectionalDensity: '0.271',
		OAL: '1.275',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--CE3LhpXS--/85157de4eb4272f955ab8ed1adf2ccc4c5ecb475.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c8444ac-81c6-4f12-b4ff-30e18fed8dd3',
		ProductID: 'B7WS',
		ProductName: 'Lock-N-Load® 7mm WSM Modified Case',
		UPC: '090255704563',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704560',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ec63a20-2eaa-4544-a817-d24d97957479',
		ProductID: '546321',
		ProductName: 'Full-Length 2-Die Set 280 Ackley Imp (.284)',
		UPC: '090255563214',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563211',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b8ab83a2-3787-48cb-8c3f-260e3de84f83',
		ProductID: '044702',
		ProductName: 'Taper Crimp Die 500 S&W Mag',
		UPC: '090255447026',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.373',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447023',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05799946-0397-4e1f-b457-7766a76e0b40',
		ProductID: '222',
		ProductName: 'Lock-N-Load® 22 Insert (.224Cal/5.56mm)',
		UPC: '090255704358',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704355',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--F3NMfJqc--/uiqtfml3609jgi45yxk4.png',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd371a761-959a-4dbd-99a1-f0f714a2d534',
		ProductID: '95781',
		ProductName: 'Square-Lok™ Shelf 12"W x 12"D',
		UPC: '090255957815',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '14.75',
		ShelfDepth: '14.75',
		Weight: '4.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957812',
		CartonHeight: '29.330',
		CartonWidth: '14.960',
		CartonDepth: '14.760',
		CartonWeight: '22.5',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you. 12"W x 12"D',
		ProductImage: 'http://images.salsify.com/image/upload/s--QW-YQv58--/dahxr00pthalurayiet8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Jcg4mRP1--/smorrilb4nzlc7dzxmck.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b752db17-c573-42b7-9f1e-ead4c15971c2',
		ProductID: '3076',
		ProductName: '30 Cal .308 200 gr ELD-X®',
		UPC: '090255230765',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.980',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230762',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.7',
		PalletQtyBoxes: '540',
		Retail: '69.15',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.597',
		G7BC: '0.301',
		MinTwist: '1-10"',
		SectionalDensity: '0.301',
		OAL: '1.53',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DE01QfF3--/4715a367e1a8175ee0f36797a22f80297cf2ecf4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '836dd605-c2d7-4f53-907a-03e946c896a0',
		ProductID: '010041',
		ProductName: '366 Auto Loader 12 Ga 2-3/4',
		UPC: '090255010411',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '32.150',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255010418',
		CartonHeight: '20.250',
		CartonWidth: '16.375',
		CartonDepth: '11.750',
		CartonWeight: '32.15',
		PalletQtyBoxes: '27',
		Retail: '1719.60',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Shotshell Reloader',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--fl8hiEi0--/d9fvaqkfzq23mky7kblt.pdf',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--_Uf2N6QN--/pkd99ojydeqynvmbitpt.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c511dd2a-7c07-4c13-9c1f-731c36cde02f',
		ProductID: '85507',
		ProductName: '6.5x55 140 gr SST® Superformance®',
		UPC: '090255855074',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.225',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255855071',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.25',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.52',
		MuzzleVelocity: '2735',
		MuzzleEnergy: '2325',
		SectionalDensity: '0.287',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--q0BqwRHJ--/8249731d5ddb016b025094139884f76d86a2b392.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '795365d2-9737-47a8-b3e3-796ebf12a524',
		ProductID: '86706',
		ProductName: '30 Nosler Unprimed Cases',
		UPC: '090255867060',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.980',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867067',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '4.9',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '30 NOSLER',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '47cda08b-1cc4-4c2e-8726-00c765cbe732',
		ProductID: '8637',
		ProductName: '270 Winchester Short Magnum Unprimed Cases',
		UPC: '090255486377',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486374',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.0',
		PalletQtyBoxes: '200',
		Retail: '88.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8d967300-c07d-4e9d-b44d-da263ccfcfd8',
		ProductID: '26175',
		ProductName: '6.5mm .264 120 gr ELD® Match',
		UPC: '090255261752',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.820',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255261759',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.5',
		PalletQtyBoxes: '900',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.486',
		G7BC: '0.245',
		MinTwist: '1-9"',
		SectionalDensity: '0.246',
		OAL: '1.203',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--u6LxRs2E--/29dce42e1dc7c96b4ab8421d7f7f4871ff4ab152.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f025a6b-0927-4c89-8cc8-80e6a9925bd9',
		ProductID: '397116',
		ProductName: 'Seating Stem 35 Cal FTX® 200 Gr',
		UPC: '090255971163',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.042',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971160',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.42',
		PalletQtyBoxes: '0',
		Retail: '7.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6e0934c-5f59-4884-a747-2caee49b6463',
		ProductID: '046223',
		ProductName: 'Full-Length Size Die 220 Swift (.224)',
		UPC: '090255462234',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462231',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '220 SWIFT',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4bd651b7-4495-431b-bd39-53186349bea6',
		ProductID: '95430',
		ProductName: 'Two-Gun Keypad Vault',
		UPC: '090255954302',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10.5',
		ShelfDepth: '14.5',
		Weight: '14.350',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255954309',
		CartonHeight: '11.500',
		CartonWidth: '15.250',
		CartonDepth: '23.000',
		CartonWeight: '28.7',
		PalletQtyBoxes: '56',
		Retail: '169.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Specialty Gun Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '4',
		BatteryWattHour: '7.48',
		BatteryWeight: '46',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '8.8',
		ProductExtWidth: '9',
		ProductExtDepth: '12.7',
		ProductWeight: '12.3',
		ProductIntHeight: '6.3',
		ProductIntWidth: '8.6',
		ProductIntDepth: '11.4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--Qr39t543--/lswhow27jv9je28zymnf.pdf',
		ProductDescription:
			'This vault’s removable shelf provides twice the interior space while it fits neatly on a desk or nightstand. Program a four- to six-digit code to ensure security, or use the key lock backup. Programmable 4 to 6 digit keypad code ensures optimum security for handguns and valuables. Interior light automatically illuminates when opening the safe. Compact Size easily fits on a desk or shelf. Spring-loaded door opens immediately for quick access. Removable interior shelf is ideal for storing a second handgun or other valuables. Protective foam liner safeguards handguns and valuables from damage. Constructed of thick 16-gauge steel. Pre-drilled for easy mounting. Requires four AAA batteries (not included). Selectable audible and visible low-battery indicators. Backup barrel key lock.  Fits 1911 size pistols and 4-inch revolvers.[1]  Exterior Dimensions: 12.7"H x 9"W x 8.8"D Interior Dimensions: 11.4”H x 8.6”W x 6.3”D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--Geq5gifh--/ittejkvthta576t4fow6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Geq5gifh--/ittejkvthta576t4fow6.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--T31me7b8--/a6kqt8covba3topt54mg.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--68RyWDIf--/lntyijgaa4bjjr909ba8.png',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfb3ea83-6498-4402-a457-cefa678e4cf6',
		ProductID: 'B234',
		ProductName: 'Lock-N-Load® Bullet Comparator - Basic Set',
		UPC: '090255704051',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '4',
		ShelfDepth: '1',
		Weight: '0.205',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704058',
		CartonHeight: '4.750',
		CartonWidth: '7.250',
		CartonDepth: '10.000',
		CartonWeight: '2.05',
		PalletQtyBoxes: '0',
		Retail: '43.45',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--f2TPMlEa--/o0xrw1df5hqozha9aezy.pdf',
		ProductDescription:
			'Measuring cartridge lengths across the bullet tips is not a reliable (or repeatable) method for measuring loaded rounds. It’s common for variations of up to .025” to exist from one round to the next. Our Bullet Comparator measures rounds from the ogive to provide consistent, precise measurements. You can also use it to check uniformity of bullets from base to ogive. Our Bullet Comparator easily attaches to the blade of your caliper and uses interchangeable inserts (available in sizes from .17 caliber to .45 caliber) to measure from the bullet ogive. Used in conjunction with the O.A.L. Gauge, the Bullet Comparator provides the ultimate in precision measurement. The Bullet Comparator will properly align the O.A.L. Gauge for precise measurement using a caliper. This method allows direct comparison of your loads as you set up your bullet seating die for any selected bullet free-travel (jump). Comparator body and 7 bullet inserts for bullet diameters: .224" (5.56mm), .243" (6mm), .257", .264" (6.5mm), .277", .284" (7mm), .308" (7.62 & 8mm)',
		ProductImage: 'http://images.salsify.com/image/upload/s--2CUfb3Ym--/cz2n1o4ignzktvgndktt.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--46owpJBx--/xzbp9up9lmxwie7sqnme.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4a8be0b6-fb0d-4c15-8f9e-c9e2f630a6f0',
		ProductID: '90281',
		ProductName: '9mm Luger+P 115 gr MonoFlex Handgun Hunter',
		UPC: '090255902815',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.715',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902812',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.15',
		PalletQtyBoxes: '1120',
		Retail: '50.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		G1BC: '0.129',
		SectionalDensity: '0.13',
		Cartridge: '9MM LUGER+P',
		PressureRating: '+P',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--6IV65ady--/xj9awzhxrskezhc5iyeo.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92906562-afc6-46d2-854f-c42c01b9d141',
		ProductID: '27309',
		ProductName: '270 Cal .277 130 gr InterBond®',
		UPC: '090255273090',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.981',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255273097',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.715',
		PalletQtyBoxes: '540',
		Retail: '92.99',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.46',
		SectionalDensity: '0.242',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '130',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--t9E4xBOd--/36f070673ec464bfae7ac4f7c07de22c5569b1fd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f62ddda-6edb-417b-bbc3-af8f6ae49a37',
		ProductID: '98003',
		ProductName: 'Hornady® Team Hornady® Transfer Sticker',
		UPC: '090255980035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '3',
		ShelfDepth: '8',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980032',
		CartonHeight: '8.000',
		CartonWidth: '2.680',
		CartonDepth: '1.500',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red and white. Measures 2.375"x6"',
		ProductImage: 'http://images.salsify.com/image/upload/s--60FR5Jdq--/b4mrcn1rmb1wmfagffec.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '77cbd2aa-a5cb-4a9c-8996-435dd9796155',
		ProductID: '35577B',
		ProductName: '9mm .355 124 gr FMJ RN',
		UPC: '090255635577',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '52.501',
		WeightUOM: 'LB',
		CaseQty: '2900',
		CartonUCC: '10090255635574',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '152252.9',
		PalletQtyBoxes: '121800',
		Retail: '0.14',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.145',
		SectionalDensity: '0.141',
		OAL: '0.595',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--BJ404MV7--/1bfe40f3b69972b7f21393b7e57950a2ed37c4d6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b4ba6620-ecee-4e8b-926c-916c22768a30',
		ProductID: '86280B',
		ProductName: '6mm Creedmoor Unprimed Cases',
		UPC: '090255708455',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '44.034',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '88068.0',
		PalletQtyBoxes: '88000',
		Retail: '0.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6825ff79-f0bb-4efb-9753-2d2e6e3bf7f6',
		ProductID: '45010',
		ProductName: '45 Cal .458 250 gr MonoFlex®',
		UPC: '090255450101',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.886',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450108',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.29',
		PalletQtyBoxes: '540',
		Retail: '74.20',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'MonoFlex® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.175',
		SectionalDensity: '0.17',
		OAL: '1.105',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A solid option for your lever gun. By combining the technologies of the GMX® and FTX® bullet design, the MonoFlex® bullet gives lever gun shooters another option. Constructed of a copper alloy, MonoFlex® bullets offer hunters a solid that won't separate, and when recovered, retains 95% of its original weight. Copper alloy differs from solid copper in that it is harder, tougher and does not foul or increase pressure the way solid copper bullets do.  Upon impact, the patented Flex Tip® design initiates immediate expansion, even at the lower velocities often encountered in mid to long range lever gun shooting situations. Its deep penetration and high weight retention combine to produce yet another accurate, deadly and dependable choice for lever gun hunters. PATENTED FLEX TIP® DESIGN Safe to use in all tubular magazines and initiates expansion, even at lower velocities.  MONOLITHIC CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration and 95% weight retention.  BALLISTICALLY EFFICIENT SECANT OGIVE PROFILE Delivers the flattest possible trajectories from lever guns.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--ww23_sg7--/4976484691f0ced7ffe398aac84a74b029e36daa.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lhwYXdgJ--/d5a46e3036aadbffb59a20164c17b789ff96bcad.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8hVQSXwY--/a19voudldx4vifinrkg0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--gWBXpGIc--/x2dgohrlgnrxags0ss7p.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--3uG1h8n7--/gycnsi5k1gyttk06jqp6.jpg',
		Videos: 'https://vimeo.com/359615915',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9c1f0656-3409-4497-bde7-9719ccc2ae2d',
		ProductID: '044191',
		ProductName: 'Seater Die (.264) 26 Nosler',
		UPC: '090255441918',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441915',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20a1d076-9364-40a6-99fe-f1db8ebfab7b',
		ProductID: '99296',
		ProductName: 'Hornady® Mossy Oak Camouflage Cap',
		UPC: '090255992960',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '19.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'BANGLADESH',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--u9IVT6sX--/hndd8umuqazpk1prnniu.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2fff8c8c-17bf-485a-8c89-5b1eb700a086',
		ProductID: '8760B',
		ProductName: '45 Automatic Unprimed Cases',
		UPC: '090255601084',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '54.591',
		WeightUOM: 'LB',
		CaseQty: '4500',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '245659.5',
		PalletQtyBoxes: '198000',
		Retail: '0.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Handgun Cartridge Cases',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '741e497d-1d68-48eb-99c5-f4d0c9e3db89',
		ProductID: '046317',
		ProductName: 'Full-Length Size Die 7mm/08 Rem (.284)',
		UPC: '090255463170',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.497',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463177',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60e29b46-2e87-4455-baa6-43ab5a7d070d',
		ProductID: '390560',
		ProductName: 'Shell Holder #20',
		UPC: '090255905601',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905608',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dec73a3b-851d-46f4-92ed-ff056501ecbc',
		ProductID: '30470',
		ProductName: '30 Cal .308 165 gr GMX®',
		UPC: '090255304701',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.297',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255304708',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.425',
		PalletQtyBoxes: '900',
		Retail: '53.97',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--sfnaueQK--/f13f85386350979c8fa5d9ad849695cf008abcce.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a7e446c4-8b09-4a44-815c-38d4b43f8e0c',
		ProductID: '546376',
		ProductName: 'Full-Length 2-Die Set 8X60S (.323)',
		UPC: '090255563764',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563761',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '8X60S',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '540a37ae-225b-48a0-ba77-45b3554fb9c2',
		ProductID: '22440',
		ProductName: '6mm .243 87 gr V-MAX®',
		UPC: '090255275032',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.334',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255275039',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.35',
		PalletQtyBoxes: '900',
		Retail: '41.17',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.4',
		SectionalDensity: '0.21',
		OAL: '1.037',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '87',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Sfp_sIuP--/26bc7bf1cae6b27d156660c6e4360dfa0d8d59aa.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '41223491-aac3-4dab-b2d7-86502f0f28d0',
		ProductID: '546569',
		ProductName: 'Full-Length 3-Die Set 458 Win (.458)',
		UPC: '090255565690',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.879',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565697',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.395',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60b0cb69-7b29-45c8-b5ef-c7e1755a5c24',
		ProductID: '28309',
		ProductName: '7mm .284 154 gr InterBond®',
		UPC: '090255283099',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.326',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255283096',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.89',
		PalletQtyBoxes: '540',
		Retail: '97.53',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.525',
		SectionalDensity: '0.273',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '154',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3eTj0i3_--/e42fcc7b0b72ab05df85c597d2d903af8319b8f5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '86ac997e-981f-4325-a74b-d6aac9d4a3d5',
		ProductID: '546243',
		ProductName: 'Full-Length 2-Die Set 6mm GT (.243)',
		UPC: '090255562439',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonWeight: '7.0',
		Retail: '83.24',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6MM GT',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '50000',
		MasterPackUCC: '10090255562436',
		MasterPackWeight: '70000.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press. The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.* *Other accessories sold separately. HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies. Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol). No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-02-08 16:35:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d50c9f3-4364-4c89-951c-92027f4d0e25',
		ProductID: '095360',
		ProductName: 'Lock-N-Load® AP™ Powder Funnel Die',
		UPC: '090255953602',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '4.75',
		ShelfDepth: '3.5',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '3.500',
		CartonWidth: '4.750',
		CartonDepth: '4.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '35.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For ultra precision on the AP™ press, this die allows handloaders to trickle and weigh each individual powder charge. Includes two insert bushings that accommodate cases from .22 to .50 caliber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--3rsnq6vf--/j1sxgp6ern0p94omjjvv.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--y2U1eZtR--/uf8zk7dmv5dpthtnlzbt.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '57f9a7e2-bcca-4cc6-a50b-e7dd53c977dd',
		ProductID: '82240',
		ProductName: '338 Marlin Express 200 gr FTX® LEVERevolution®',
		UPC: '090255822403',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.492',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822400',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '14.92',
		PalletQtyBoxes: '930',
		Retail: '60.59',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.43',
		MuzzleVelocity: '2565',
		MuzzleEnergy: '2922',
		SectionalDensity: '0.25',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--j9RnL00O--/9fb460d0a085d1414bf76b60620aacf62fb5ccde.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3c11d63-2a51-4a60-9836-340972a9bfb4',
		ProductID: '81481',
		ProductName: '6.5 Creedmoor 95 gr V-MAX® Varmint Express®',
		UPC: '090255814811',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.980',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814818',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.8',
		PalletQtyBoxes: '1400',
		Retail: '50.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.365',
		MuzzleVelocity: '3300',
		MuzzleEnergy: '2297',
		SectionalDensity: '0.195',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '95',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wT6Ejlqd--/703df442878767f590a8549f7a44555e7fd8dccf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f0fd495-3710-4f91-81b6-8fc5b07ddfb4',
		ProductID: '490500',
		ProductName: 'Crimp Starter 12 Ga 8 Pt',
		UPC: '090255945003',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.5',
		ShelfDepth: '0.05',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255945000',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Universal Crimp Starters',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--CE5yeAr4--/baehdwiavoqrlfxfwz26.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f74ee55b-3a5c-4416-b306-338ac310023b',
		ProductID: '546506',
		ProductName: 'Full-Length 3-Die Set 32 Auto (.311)',
		UPC: '090255565065',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.770',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565062',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.85',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '32 AUTO',
		Caliber: '32 CAL',
		BulletDiameter: '0.311',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa7072ba-bd92-43eb-95f0-58baa62afd0e',
		ProductID: '305015',
		ProductName: '30 Cal .308 168 gr BTHP Match',
		UPC: '090255350159',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '6.25',
		ShelfDepth: '6.875',
		Weight: '12.775',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255350156',
		CartonHeight: '7.125',
		CartonWidth: '7.562',
		CartonDepth: '8.625',
		CartonWeight: '25.55',
		PalletQtyBoxes: '174',
		Retail: '242.19',
		ParentCategory: 'Bullets',
		G1BC: '0.45',
		SectionalDensity: '0.253',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '168',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PXB4Mff_--/agq5t9dknaercdwodrll.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Rnrbt1rb--/0571b91af4446fa1d5c0227bbd1880cd13b6706b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5fa19612-2059-48d8-940b-b57bc33687b3',
		ProductID: '391928',
		ProductName: 'Neck Turn Mandrel 30 Cal .3055',
		UPC: '090255919288',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.028',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919285',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.28',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.3055',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c2810c5b-77b6-4fbe-9978-7036682b7899',
		ProductID: '546422',
		ProductName: 'Full-Length 2-Die Set 460 Wby (.458)',
		UPC: '090255564228',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564225',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '460 WBY MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b1804ed1-a907-41b3-8e60-1949cae84cab',
		ProductID: '046254',
		ProductName: 'Full-Length Size Die 6mm Creedmoor (.243)',
		UPC: '090255462548',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462545',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '13ad7027-f0bc-4eed-8c11-69020f8ad7d4',
		ProductID: '060005',
		ProductName: 'Spring Finger 410 Ga (2 Pack)',
		UPC: '090255600056',
		PackagedQTY: '2',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.021',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255600053',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.21',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Wad Guide Spring Fingers (2-Pack)',
		Cartridge: '410 BORE',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Plastic spring fingers hold the case mouth open to easily insert wads. Standard on all Hornady reloaders, these will fit wad guides of most other makes.',
		ProductImage: 'http://images.salsify.com/image/upload/s--C-Bww4V9--/o5tyoeybcceklnchbch8.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9dbb6522-36c2-4fc0-92e7-51230bada2f8',
		ProductID: '90282',
		ProductName: '9mm Luger 147 gr XTP®',
		UPC: '090255902822',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.835',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902829',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.35',
		PalletQtyBoxes: '1120',
		Retail: '33.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.212',
		MuzzleVelocity: '975',
		MuzzleEnergy: '310',
		SectionalDensity: '0.167',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '147',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VZvgqrWN--/4fbf8b76e40a4e295ec2c2bef2a4a45fbc8d8212.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3250a2d-6592-4549-80e1-3f4a875593aa',
		ProductID: '35527B',
		ProductName: '9mm .355 100 gr FMJ',
		UPC: '090255635522',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '51.130',
		WeightUOM: 'LB',
		CaseQty: '3500',
		CartonUCC: '10090255635529',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '178955.0',
		PalletQtyBoxes: '147000',
		Retail: '0.14',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.158',
		SectionalDensity: '0.113',
		OAL: '0.47',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4LWjkJvq--/237ebacf73ec1beaa5fda7e56b62da4b512db543.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'afa8d764-f196-4ab0-b302-78e1fea8f0d1',
		ProductID: '392165',
		ProductName: 'Collet #12 .430 Cal',
		UPC: '090255921656',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921653',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--O4SR_Ohx--/1da726107764e2595ee44124328c6221362ead83.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ec77f385-8166-4049-acfe-98448aa3f634',
		ProductID: '8327',
		ProductName: '223 Rem 55 gr V-MAX® Varmint Express®',
		UPC: '090255383270',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.585',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383277',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.85',
		PalletQtyBoxes: '1680',
		Retail: '35.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TYb6xhBF--/74586e61a41deb421fab9aea4b4febf3ced086f7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '28e68bc5-9873-4df6-a376-6cdfdb8f3c62',
		ProductID: '99399',
		ProductName: 'Hornady® OD Green Beanie',
		UPC: '090255993998',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '8',
		ShelfDepth: '8.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ORdW7ryf--/lkpb6aihztumleognhyr.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef7ebad6-a7f0-4706-949e-81870379da7d',
		ProductID: '544241',
		ProductName: 'Match™ Grade 2-Die Set 6mm PPC (.243)',
		UPC: '090255542417',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542414',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.25',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6MM PPC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27d45ed6-02f5-4dea-9d05-06a60d3ba444',
		ProductID: '392154',
		ProductName: 'Collet #1 .17 Cal',
		UPC: '090255921540',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.048',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921547',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.48',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '17 CAL',
		BulletDiameter: '0.17',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--F9ekwThJ--/380ff8c2ea922b70ab8aa82fcafcf8def7015bf8.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfa94ca1-428a-4f84-a5fc-6bc3e471749b',
		ProductID: '85578',
		ProductName: '7mm-08 Rem 150 gr ELD-X® Precision Hunter®',
		UPC: '090255855784',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.165',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255855781',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.65',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.574',
		G7BC: '0.289',
		MuzzleVelocity: '2770',
		MuzzleEnergy: '2555',
		SectionalDensity: '0.266',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--JqhzIkd7--/4815c225612641954c06f8511e70ea673bb79326.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '406c293b-56fb-4f9e-b013-0befe396b756',
		ProductID: '75900',
		ProductName: 'SnapSafe® Rechargeable Gun Safe Dehumidifier Medium',
		UPC: '851529004662',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.25',
		ShelfWidth: '7',
		ShelfDepth: '2.5',
		Weight: '1.170',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004669',
		CartonHeight: '7.500',
		CartonWidth: '7.500',
		CartonDepth: '10.000',
		CartonWeight: '5.85',
		PalletQtyBoxes: '720',
		Retail: '29.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.625',
		ProductExtWidth: '4',
		ProductExtDepth: '1.25',
		ProductWeight: '1',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Absorb humidity and prevent rust or mildew in gun safes, closets, pantries and other enclosed areas. Moisture-control crystals change from orange to green, indicating when the unit needs recharging. Dry out and recharge the crystals by plugging into 110V electrical outlet until crystals turn orange again. Absorbs humidity from enclosed areas and helps prevent mold and mildew. Perfect for closets, gun safes, pantries and other enclosed areas. No cords are needed for the dehumidifier to work. Moisture-control crystals change color to indicate when the unit needs recharging. Simply plug-in to recharge and dry out the crystals for continued use. Contains no harmful chemicals and is child, pet, and home safe. Effective in spaces up to 333 cubic feet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Kv10EMwM--/ruouhtxrkcg7vyz0t4ln.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--fS5aEYhx--/usojgvapvtgtgcvnnr9g.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Ha32MVGt--/t9vy7uzbhrpmrwti4riu.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Af2NqWK1--/njvvpd4in5vd6qxyqua3.jpg',
		Videos: 'https://vimeo.com/221605062',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a671a7f0-c77a-448b-8a44-c5dff133639e',
		ProductID: '546402',
		ProductName: 'Full-Length 2-Die Set 350 Rem Mag (.358)',
		UPC: '090255564020',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564027',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '350 REM MAG',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0a8d3bf-f420-4795-8819-ef68e508137a',
		ProductID: '046507',
		ProductName: 'Size Die 32 Auto (.311)',
		UPC: '090255465075',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.464',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465072',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Three-Die Handgun Die Sets',
		Cartridge: '32 AUTO',
		Caliber: '32 CAL',
		BulletDiameter: '0.311',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '55e7c3ba-7068-45ab-827b-b97ef15cb323',
		ProductID: '190121',
		ProductName: 'Shot Bushing 1 1/4 oz',
		UPC: '090255191219',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.061',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191216',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.61',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e62df685-0496-4b91-b3f4-f2d8ff9724e3',
		ProductID: '045507',
		ProductName: 'Expander Die 350 Legend (.355)',
		UPC: '090255455076',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255455073',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b33c282-7d54-4742-bfdd-4cdabcb77fdb',
		ProductID: '75872',
		ProductName: 'Snapsafe® Handgun Hangers .220 (4 Pack)',
		UPC: '851529004501',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '4.5',
		ShelfDepth: '0.5',
		Weight: '0.580',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004508',
		CartonHeight: '5.000',
		CartonWidth: '5.000',
		CartonDepth: '12.500',
		CartonWeight: '2.9',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004502',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '14.5',
		ProductImage: 'http://images.salsify.com/image/upload/s--rDkxQkqw--/bt1jmscxg5ooypwszqio.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--7AGtLsZT--/fj1b37qvubjwll7qbmti.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--TDoVbuBV--/snaqr50pytuerojyemae.jpg',
		Videos: 'https://vimeo.com/213867180',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3c6c68b8-6cd0-4851-8056-86bc3322f14a',
		ProductID: '98190',
		ProductName: 'Hornady® RAPiD® Safe AR Gunlocker',
		UPC: '090255981902',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '49.2',
		ShelfWidth: '17.7',
		ShelfDepth: '9.5',
		Weight: '53.500',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255981909',
		CartonHeight: '49.200',
		CartonWidth: '17.700',
		CartonDepth: '11.800',
		CartonWeight: '53.5',
		PalletQtyBoxes: '16',
		Retail: '526.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '6.75',
		ProductExtWidth: '42',
		ProductExtDepth: '15.25',
		ProductWeight: '50',
		ProductIntHeight: '5.5',
		ProductIntWidth: '40.5',
		ProductIntDepth: '13.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The AR Gunlocker stows neatly under a bed, in a closet or the back of an SUV, providing total security with its fully enclosed design. Available in two sizes, secure up to three tactical-length riflesor shotguns and access them quickly and efficiently, thanks to RFID technology.  FAST AND DEPENDABLE TOUCH-FREE ENTRY RFID[2] activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS For secondary entry method, user can program a four to six digit security code.  CERTIFIED CHILD-RESISTANT Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and hinge attack resistance.  SAFE AND READY AC and battery power ensures your firearm is protected and ready to go 24/7.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 16 gauge steel with four internal hardened locking lugs. Included cable and pre-drilled mounting holes allow additional security.  Contents Include: RAPiD® Safe, Wall Power Supply, RFID Wristband, two RFID Stickers, RFID Key Fob, two Circular Barrel Keys, Security Cable. Features: Keypad, Fully Enclosed, 2 Gun Capacity, Vertical/Horizontal Mount Type: Rifle, Shotgun Exterior Dimensions: 42" x 15.25" x 6.75" Interior Dimensions: 40.5" x 13.5" x 5.5" Weight: 50 pounds',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--ck4eLfy1--/lmsuaqsmedjkp0oggtf1.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ck4eLfy1--/lmsuaqsmedjkp0oggtf1.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VxAwc98T--/xnnmjazr6rohf0rsloyj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hX6B2Nm8--/eu7lhn4m3iykdahvuitd.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--i9RCKTK4--/d6whvnvfpiiuxyxcdkm8.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--SC9351kz--/sehnzyxq7hmdoivfhsm6.jpg',
		Videos: 'https://vimeo.com/190884932',
		Videos1: 'https://vimeo.com/489482620',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef74ad3d-7b76-4c36-b03a-2422b0a58d39',
		ProductID: '35557B',
		ProductName: '9mm .355 115 gr FMJ RN',
		UPC: '090255635553',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '50.416',
		WeightUOM: 'LB',
		CaseQty: '3000',
		CartonUCC: '10090255635550',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '151248.0',
		PalletQtyBoxes: '126000',
		Retail: '0.14',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.14',
		SectionalDensity: '0.13',
		OAL: '0.55',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--78Klmiko--/73727760533108c7c65efd65c4f610dde9c5fd2a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7d0ab4ad-c230-4080-b2ab-e2ab8bc992af',
		ProductID: '82144',
		ProductName: '300 Remington Short Action Ultra Mag 178 gr ELD-X® Precision Hunter®',
		UPC: '090255821444',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.540',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821441',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.4',
		PalletQtyBoxes: '780',
		Retail: '90.04',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.552',
		G7BC: '0.278',
		MuzzleVelocity: '2950',
		MuzzleEnergy: '3439',
		SectionalDensity: '0.268',
		Cartridge: '300 REM SA ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ktAfP606--/762bb3491ae59b48d5eb915b14c304c5c396fb10.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '899940d3-7d9c-42a2-9d68-af908a8ec441',
		ProductID: '2550',
		ProductName: '25 Cal .257 117 gr InterLock® RN',
		UPC: '090255225501',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.766',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255225508',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.15',
		PalletQtyBoxes: '900',
		Retail: '47.61',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.243',
		SectionalDensity: '0.253',
		OAL: '0.969',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--z_9G0qX_--/625054bcca0fb1c300308896c633afc800333d58.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '04443741-944c-4498-8332-364ea4bc0d7c',
		ProductID: '380712',
		ProductName: 'Cartridge Gauge 7mm-08 Rem (.284)',
		UPC: '090255807127',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807124',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b8b2257e-0159-418a-9c7c-99522184ead4',
		ProductID: '546434',
		ProductName: 'Full-Length 2-Die Set 470 NE 3 1/4" (.474)',
		UPC: '090255564341',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564348',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.25',
		PalletQtyBoxes: '0',
		Retail: '164.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '470 NITRO EXP 3¼"',
		Caliber: '470 CAL',
		BulletDiameter: '0.474',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2024-03-05 08:41:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '37ee4580-0e82-4151-9d10-5aaeb77217ae',
		ProductID: '86236',
		ProductName: '12 GA Superformance Slug 300 gr MonoFlex',
		UPC: '090255862362',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.625',
		ShelfDepth: '4.125',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '20',
		CartonUCC: '10090255862369',
		CartonHeight: '4.687',
		CartonWidth: '5.625',
		CartonDepth: '11.062',
		CartonWeight: '9.0',
		PalletQtyBoxes: '2160',
		Retail: '26.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.200',
		MuzzleVelocity: '1950',
		MuzzleEnergy: '2533',
		SectionalDensity: '0.142',
		Cartridge: '12 GA',
		Caliber: '55 CAL',
		BulletDiameter: '0.55',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--UJUeaBeT--/swqyjyndng78wzsmi20s.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--WxZS_svc--/tinu22rccs2glleex91y.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--uQ872TJ3--/mgjkpjlrk751j2golowm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_qtal2wU--/vroxo0ol71mzh5mt5nj2.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--AmWoYqWZ--/g6dmjyr2dlzx28mdrgvq.jpg',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f7edc16-3138-420d-9be4-8efbc8a5ab78',
		ProductID: '2740',
		ProductName: '270 Cal .277 150 gr InterLock® SP',
		UPC: '090255227406',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.271',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255227403',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.065',
		PalletQtyBoxes: '540',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.462',
		SectionalDensity: '0.279',
		OAL: '1.222',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AaQv7IUV--/f9d1e121a49f6dd3c5a9ad8cdbff274db994277c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ddf0e94-8dd0-4944-8440-3a3db9cb18f6',
		ProductID: '8210',
		ProductName: '300 H&H 180 gr InterBond®',
		UPC: '090255382105',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.540',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382102',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.4',
		PalletQtyBoxes: '780',
		Retail: '93.99',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.48',
		SectionalDensity: '0.271',
		Cartridge: '300 H&H MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERBOND® W/C',
		BulletWeightGrain: '180',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LkWjZRW5--/907349dc92f98d397c3fa59622081efdc8972676.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ecc50cbf-4817-4806-a582-4fb588a68e03',
		ProductID: 'A6MMB',
		ProductName: 'Lock-N-Load® 6mm BR Rem Modified Case',
		UPC: '090255704204',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704201',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '6MM BR REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8Eb7z1MA--/8b9b54a1a79a3a99e1d55c9a2692c5631727f596.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed2e7fef-700a-406b-8fcf-dc0a84b091c5',
		ProductID: '35700',
		ProductName: '38 Cal .357 110 gr XTP®',
		UPC: '090255235708',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.666',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235705',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '41.65',
		PalletQtyBoxes: '900',
		Retail: '31.41',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.131',
		SectionalDensity: '0.123',
		OAL: '0.495',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8jUSZqE3--/3e7047002c8a5f694ea05f9378648895b02437ce.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c8cee6a-83fe-4467-9947-16fc0a20f663',
		ProductID: '2250B',
		ProductName: '22 Cal .224 53 gr HP Match',
		UPC: '090255690330',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '46.559',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255690337',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '279354.0',
		PalletQtyBoxes: '252000',
		Retail: '0.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.218',
		SectionalDensity: '0.151',
		OAL: '0.713',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '53',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Wd28sOw_--/064a0134503ce699eccc8b275bf1a42bfda7938a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4fdb6a0a-9202-41e3-8bda-78229cce6501',
		ProductID: '190163',
		ProductName: 'Powder Bushing 456',
		UPC: '090255191639',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.061',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191636',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.61',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6be420dd-8c6d-4fa6-8b4f-67733d0bbcf3',
		ProductID: '99241',
		ProductName: '11th Edition Hornady® Handbook of Cartridge Reloading',
		UPC: '090255992410',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.75',
		ShelfWidth: '9.25',
		ShelfDepth: '6.25',
		Weight: '3.380',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255992417',
		CartonHeight: '9.750',
		CartonWidth: '9.750',
		CartonDepth: '13.000',
		CartonWeight: '33.8',
		PalletQtyBoxes: '700',
		Retail: '59.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Reloading Handbook & Videos',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The 11th Edition Handbook of Cartridge Reloading includes the latest Hornady bullets, along with new cartridges, powders and more. It is filled with handloading techniques, bullet information and reloading data – it’s a one-stop shop for support of Hornady component bullets.  New cartridges include the latest efficient and accurate Hornady developments like the 6mm ARC, match-winning 6mm Creedmoor and high-powered 6.5 PRC and 300 PRC. Featuring Over 1,000 pages of reloading data, techniques and bullet information. 200+ different calibers featuring a variety of loads using Hornady® bullets. An impressive lineup of new and expanded data that incorporates new powders, new bullets like the A-Tip® Match and new additions in the ELD-X, ELD Match, GMX, FTX, Sub-X and more. New cartridge additions like the 6mm ARC, 6.5 PRC, 300 PRC, 224 Valkyrie, 350 Legend and 28 Nosler. Well over 1,500 load combinations were shot to update and expand the reloading pages in this edition. Three ways to get the Hornady Handbook of Cartridge Reloading.  HORNADY® RELOADING APP Like the bound and eBook versions, the Hornady® Reloading App provides all the information needed to successfully reload a variety of rifle and handgun cartridges. Plus you can save favorites, add notes and more. Reloading data is avialable as low as 99¢ per cartridge or purchase a subscription for $19.99 and receive new data before the next book is printed.   HARDCOVER BOOK This invaluable resource has over 1000 pages of data on all Hornady bullets. Purchase this hard-bound book and get reloading results.   ELECTRONIC BOOK Download the Reloading Handbook as an Apple® iBook or get it on your Kindle®. Take it with you anywhere!',
		ProductImage: 'http://images.salsify.com/image/upload/s--aA0YAhAu--/nvmfibzreoz3qpfb6eyu.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--EWl6D1cH--/oiuazdhjvk48bw1gn8g0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--12lzz6Be--/jlyral6pwejideo6kqcw.png',
		Videos: 'https://vimeo.com/536079004',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e4f63ef-61c7-42e8-a5fe-8496e482a6db',
		ProductID: '99282',
		ProductName: 'Hornady® Gray Mountain Cap',
		UPC: '090255992823',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--EIBGMv1J--/fzwrzgouvshof18j4497.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2a84c7d1-77cf-4fb6-953c-a1d5b55980bb',
		ProductID: '546532',
		ProductName: 'Full-Length 3-Die Set 9X23 (.355)',
		UPC: '090255565324',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565321',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '9X23 WIN',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4adadbe1-e915-4316-9847-e41eee319894',
		ProductID: '81531',
		ProductName: '224 Valkyrie 60 gr V-MAX® Varmint Express®',
		UPC: '090255815313',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.735',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815310',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '7.35',
		PalletQtyBoxes: '1400',
		Retail: '37.85',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.265',
		MuzzleVelocity: '3300',
		MuzzleEnergy: '1451',
		SectionalDensity: '0.171',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX® W/C',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--CJw3DDq5--/2e0562de931bc20309edc4164e9adabe200c563f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		Videos: 'https://vimeo.com/295269764',
		Videos1: 'https://vimeo.com/294885162',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5356910e-5d5b-4b94-85ea-70c2c9b951c6',
		ProductID: '6060',
		ProductName: '44 Cal .451 Lead Balls',
		UPC: '090255260601',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.080',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260608',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.0',
		PalletQtyBoxes: '900',
		Retail: '17.01',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '44 CAL',
		BulletDiameter: '0.451',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '698c5997-e99f-4423-a490-f8d94696e8f5',
		ProductID: '90504',
		ProductName: '357 Mag 125 gr XTP® American Gunner®',
		UPC: '090255905045',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905042',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '9.0',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.151',
		MuzzleVelocity: '1500',
		MuzzleEnergy: '624',
		SectionalDensity: '0.14',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Z3dCHD3H--/eb1e94acea0205e23d0eb715160c3931b22cba78.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0a9ac60c-0952-4d0f-9414-b36f31947efa',
		ProductID: '80944',
		ProductName: '308 Win 150 gr. CX™ Superformance®',
		UPC: '090255809442',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.152',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809449',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.52',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.418',
		SectionalDensity: '0.226',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--xNcu_Ox2--/qmhpnz5jsgxzfkxfhsiq.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--WrGXZhp_--/omhk27s629mlcmrxv5tp.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0982f26e-0e01-4694-b753-124a2e1e0cc8',
		ProductID: '594286',
		ProductName: 'Match™ Grade Bushing .286',
		UPC: '090255592863',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.024',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592860',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.24',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.286',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3Osnbgms--/9e958534fc658d3a83bb3bc320e581527e67c5c1.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7871d58d-c453-4a5c-9036-bda27f1cdac3',
		ProductID: '546406',
		ProductName: 'Full-Length 2-Die Set 358 Norma Mag (.358)',
		UPC: '090255564068',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564065',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '358 NORMA MAG',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '117cd6b0-7762-41dd-9022-22e3798f7d03',
		ProductID: '8632',
		ProductName: '260 Remington Unprimed Cases',
		UPC: '090255486322',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486329',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.25',
		PalletQtyBoxes: '400',
		Retail: '64.60',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f814f1d8-78a3-42ef-9975-e7e131b76594',
		ProductID: '76002',
		ProductName: 'Snapsafe® Safe Light 30 LED White',
		UPC: '851529004792',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '29',
		ShelfWidth: '3.25',
		ShelfDepth: '2.5',
		Weight: '0.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004799',
		CartonHeight: '5.500',
		CartonWidth: '6.000',
		CartonDepth: '29.250',
		CartonWeight: '4.0',
		PalletQtyBoxes: '480',
		Retail: '45.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '6',
		BatteryWattHour: '11.22',
		BatteryWeight: '69',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '40',
		MasterPackUCC: '30851529004793',
		MasterPackHeight: '21.000',
		MasterPackWidth: '29.500',
		MasterPackDepth: '30.500',
		MasterPackWeight: '32.0',
		ProductDescription:
			'Ideal for gun safes, closets, cabinets, drawers and corridors, this light bar features long-lasting LED lights.  With ON/OFF/AUTO modes, the light bar can be set to illuminate when motion is detected. When set to AUTO mode, the LED light automatically turns on at night when motion is detected within a 10-foot range, and it automatically turns to standby mode at night 20 seconds after no motion is detected.  Easy to install, these lights require AAA batteries (not included).  Bracket Hardware: Attach the bracket with screw and washer, then push the body of light into the bracket. Magnetic Strip: Apply the magnetic strips on the back of the light, then attach to any metal surface. Caution: Indoor use only. Keep away from high humidity. Take out the batteries if not in use for a long time.',
		ProductImage: 'http://images.salsify.com/image/upload/s--WVPf5LT---/sizoez1qryhluc5jp3du.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cyMOduG_--/n8y26ufxucipoegdhopa.jpg',
		Videos: 'https://vimeo.com/213867224',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd69f12ad-56a4-48a1-a9a3-570a87fe9ce4',
		ProductID: '45052',
		ProductName: '45 Cal .458 410 gr SUB-X®',
		UPC: '090255450521',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.060',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450528',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.9',
		PalletQtyBoxes: '540',
		Retail: '56.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Sub-X® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '.285',
		SectionalDensity: '0.279',
		OAL: '1',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '410',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reliable subsonic expansion Sub-X® (Subsonic — eXpanding) bullets deliver big results without a big bang! Designed to provide deep penetration below the speed of sound, Sub-X® features a lead core. Long grooves in its gilding metal jacket combine with its flat profile and the patented Flex Tip® insert within the bullet’s hollowpoint cavity to help it expand reliably at low velocities. Cannelures provide positive case crimp, making Sub-X® ideal for semiautomatic weapons. EXPANDS AT SUBSONIC VELOCITIES Patented Flex Tip® technology aids in expansion at velocities as low as 900 fps. PROVEN PERFORMANCE Meets FBI protocol for terminal ballistic test requirements. POSITIVE CASE CRIMP Lead core bullet with cannelured jacket provides positive case crimp for use in semiautomatics. WIDE RANGE OF GUNS Designed to fit, feed and function in a variety of firearms, including gas system guns.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--6JPNHdGn--/vanusfuylesq6gow2tp5.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--BPfBtcJD--/u88burdxkcaas9xgqqqc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OtRGcACm--/l0fdlmxwkhjzevqlazry.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RMzZ3xew--/iyn6cbplk0acvziaeybv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--MQPLrOG4--/eue6m4ovt2wufmjlfiu0.png',
		Videos: 'https://vimeo.com/367134791',
		Videos1: 'https://vimeo.com/368030686',
		DateLastModified: '2024-03-04 15:47:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0f9bdcd-db39-4e8f-a54c-018477756c85',
		ProductID: '83433',
		ProductName: '243 Win 75 gr V-MAX® Superformance® Varmint',
		UPC: '090255834338',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.975',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255834335',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.75',
		PalletQtyBoxes: '1400',
		Retail: '48.08',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.330',
		MuzzleVelocity: '3580',
		MuzzleEnergy: '2134',
		SectionalDensity: '0.181',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--3JPdG1jO--/e0medcndfxgexdbnbyld.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '96fa4601-6be0-43f7-807e-559d50fd2b9c',
		ProductID: '99136',
		ProductName: 'Hornady® Tin Stop Sign',
		UPC: '090255991369',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '10',
		ShelfDepth: '0.03',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area. Each have rounded corners and four pre-drilled holes for easy hanging. Measures 10"x10"',
		ProductImage: 'http://images.salsify.com/image/upload/s--CGjQjJM6--/xkvd1irvo6mrq3qmib0q.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bc28003d-bb06-4d47-9c72-dccaa0e16f17',
		ProductID: '544610',
		ProductName: 'Match™ Grade 2-Die Set 6mmx47 Lapua (.243)',
		UPC: '090255546101',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255546108',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6MMX47 LAPUA',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af50f2e2-a6ac-462c-b259-00f8c407fc4b',
		ProductID: '30738',
		ProductName: '30 Cal .308 190 gr CX™',
		UPC: '090255307382',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.682',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255307389',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '17.05',
		PalletQtyBoxes: '900',
		Retail: '61.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.575',
		MinTwist: '1-10"',
		SectionalDensity: '0.286',
		OAL: '1.645',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--kMNg34ro--/uvbtbse6r43lbfx7smnz.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0700b7e2-b292-4f42-8dd8-d60ba7629bbb',
		ProductID: '546294',
		ProductName: 'Full-Length 2-Die Set 6.5 Rem Mag (.264)',
		UPC: '090255562941',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562948',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6.5 REM MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cab5e646-5033-4f4c-a415-d6539d00cd4a',
		ProductID: '3235',
		ProductName: '8mm .323 170 gr InterLock® RN',
		UPC: '090255232356',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.543',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255232353',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.145',
		PalletQtyBoxes: '540',
		Retail: '58.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.217',
		SectionalDensity: '0.233',
		OAL: '0.925',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '170',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--L-GrgM13--/02048785a8fc030a4c222eeb77689363fa394177.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3967f6c9-3a6a-41eb-9ace-86d8c32f4006',
		ProductID: '90001',
		ProductName: '5.7x28 40 gr. V-MAX® Hornady® BLACK®',
		UPC: '090255720426',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255720423',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '4.5',
		PalletQtyBoxes: '1120',
		Retail: '35.53',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		SectionalDensity: '0.114',
		Cartridge: '5.7X28MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns. Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA! Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications. Featuring: High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ibXMNV97--/emnv04cl1tuimzr8f4bd.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		Videos: 'https://vimeo.com/876115387',
		DateLastModified: '2023-12-27 07:25:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22ec3b7a-8273-4468-bc07-20b0d57cfd6b',
		ProductID: '86244',
		ProductName: '12 GA #6 Nickel 3" Turkey',
		UPC: '090255862447',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.75',
		ShelfDepth: '4',
		Weight: '1.342',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862444',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '13.42',
		PalletQtyBoxes: '1120',
		Retail: '19.13',
		ParentCategory: 'Ammunition',
		Applications: 'AppTurkey',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#6',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Your answer for turkeys and coyotes!  Take down turkeys and coyotes up to 50 yards away with accurate, deadly and dependable Heavy Magnum® Shotgun ammunition. HEAVY MAGNUM® TURKEY Available in 3", 12 or 20 gauge loads, Heavy Magnum Turkey® delivers true gobbler knockdown power! Shot deformation is minimized, thanks to the thickest nickel-plating in the industry, which reduces fliers and keeps more pellets on target for dense patterns. The Hornady® Versatite® wad does the patterning, so these loads don\'t require shotgun modification or specialized turkey chokes. At 1300 fps for the 12 gauge load, and 1200 fps for the 20 gauge load, Heavy Magnum® Turkey ammunition allows hunters to achieve lethal results out to 50 yards.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--AbE_tenh--/08b9ca2f1042562e09c95c3b0f9c7e9fae1afd2e.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--upXWjMIS--/8d91d3c352baa46fd4378041d40cb419702a207e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--0Y1n1BVa--/p3qgsaqdchsmz1aokwtz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s---CFn2L0A--/o3nzxcu8sb7vmsc2mdbi.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CXfxb5xc--/svmkejrcdjo2szhq3ssx.jpg',
		Videos: 'https://vimeo.com/145438803',
		Videos1: 'https://vimeo.com/264506193',
		DateLastModified: '2024-01-09 17:51:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e9061fec-09cd-4718-8811-5c1d46d2d951',
		ProductID: '86288',
		ProductName: '6.5 PRC Unprimed Cases',
		UPC: '090255862881',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862888',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.5',
		PalletQtyBoxes: '200',
		Retail: '78.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.5 PRC',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8b0c5637-dda8-44c6-8f92-93da0aa7e34e',
		ProductID: '546396',
		ProductName: 'Full-Length 2-Die Set 357 Herrett (.357)',
		UPC: '090255563962',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563969',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '357 HERRETT',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa35c272-11ad-4a1f-ac44-cfb38b176030',
		ProductID: '046038',
		ProductName: 'Neck Size Die 20 Cal (.204)',
		UPC: '090255460384',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.503',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460381',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '558f087f-78f6-4aef-8551-ec38f11d1c2e',
		ProductID: '8644',
		ProductName: '8 X 57 JRS Unprimed Cases',
		UPC: '090255486445',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.460',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486442',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.3',
		PalletQtyBoxes: '200',
		Retail: '58.21',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '8X57 JRS',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66b1fccb-45fc-40c3-a0ad-7308c591aae3',
		ProductID: '546290',
		ProductName: 'Full-Length 2-Die Set 6.5 Jap (.264)',
		UPC: '090255562903',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562900',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5 JAP',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '912b41f9-5d4a-4b17-b4e0-786a4ca2d52b',
		ProductID: '397133',
		ProductName: 'Seating Stem 30 Cal ELD-X®',
		UPC: '090255971330',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971337',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8e74a1ff-f949-4e8c-aa07-7ba7c2675293',
		ProductID: '752122325',
		ProductName: 'TrekLite® Lock Box - XL with keylock FDE',
		UPC: '842631100700',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '2.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100707',
		CartonHeight: '8.500',
		CartonWidth: '12.000',
		CartonDepth: '15.750',
		CartonWeight: '12.0',
		PalletQtyBoxes: '450',
		Retail: '42.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '1.6',
		ProductIntHeight: '1.75',
		ProductIntWidth: '6.75',
		ProductIntDepth: '9.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The TrekLite® Lock Box offers heavy-duty protection at a third of the weight of steel! Heavy-duty protection at a third of the weight of steel. Only 1.5 pounds! Convenient 4-Digit TSA lock offers advanced security and 10,000 user programmable codes. Protects firearms, expensive medications, and other valuables while traveling or at home. Easily fits in a suitcase, drawer, or under a car seat. Constructed of advanced, impact-resistant polycarbonate for exceptional toughness. Fits up to full-sized 1911 handguns. Durable, non-slip rubber over-mold provides added impact protection and stability. Foam lining protects firearms and valuables from being marred. Includes 1500 lb. rated security cable† with sturdy cable connector that doesn’t limit interior cargo space. Meets TSA requirements.* External Dimensions: 10" x 7" x 2" Weight: 1.6 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--bseGGV7D--/u5umhqpx89ifldp3xvlf.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--85AwZVgM--/vdhjcuetmaogi1x9jmq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--9F7GfXIe--/gb7nyv5vrlxpawdq5ftz.png',
		Videos: 'https://vimeo.com/213867264?embedded=true&source=video_title&owner=28327899',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '660e3424-0ea5-4d88-848d-ec19e885fd73',
		ProductID: '594362',
		ProductName: 'Match™ Grade Bushing .362',
		UPC: '090255593624',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593621',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.362',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Vl_RPGxv--/0d490b953431d23d68a2134f1ce8a07d3dc08a87.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4dd69a88-5a19-4793-946f-24ca167f0ad1',
		ProductID: '046513',
		ProductName: 'Size Die 9mm Makarov  (.364)',
		UPC: '090255465136',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465133',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '9X18 MAKAROV',
		Caliber: '9X18 MAKAROV',
		BulletDiameter: '0.364',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8b864ada-5b10-413d-9c44-494de5ca43b6',
		ProductID: '546269',
		ProductName: 'Full-Length 2-Die Set 260 Rem (.264)',
		UPC: '090255562699',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.501',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562696',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.505',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '048c24c5-6ad2-4f31-b359-ec22e4ba78eb',
		ProductID: '33381',
		ProductName: '338 Cal .338 285 gr ELD® Match',
		UPC: '090255333817',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.150',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255333814',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.25',
		PalletQtyBoxes: '540',
		Retail: '72.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.829',
		G7BC: '0.417',
		MinTwist: '1-10"',
		SectionalDensity: '0.356',
		OAL: '1.74',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '285',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IrrCJ4X2--/1debcf42832634f99e42551d0de890de5f13e68b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '182c6fbb-75a1-4556-9495-16683a2241fe',
		ProductID: '7140',
		ProductName: '45 Cal Gas Checks',
		UPC: '090255271409',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.321',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255271406',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '19.815',
		PalletQtyBoxes: '540',
		Retail: '79.07',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '45 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1066b8ae-0113-4333-85db-26a66e4c8fe5',
		ProductID: '28506',
		ProductName: '7mm .284 190 gr A-TIP Match',
		UPC: '090255285062',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '3.105',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255285069',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '31.05',
		PalletQtyBoxes: '240',
		Retail: '116.75',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '.838',
		G7BC: '.422',
		MinTwist: '1-8"',
		SectionalDensity: '0.337',
		OAL: '1.66',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--MlKOlUkY--/wmramymbuhubunuczq5c.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '12d7723b-b64f-4184-8fa0-ef466731de81',
		ProductID: '8026',
		ProductName: '223 Rem 75 gr BTHP Match',
		UPC: '090255380262',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.635',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380269',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.35',
		PalletQtyBoxes: '1680',
		Retail: '35.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		MuzzleVelocity: '2790',
		MuzzleEnergy: '1296',
		SectionalDensity: '0.214',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Bs_pN5uU--/d57cf28abee21c314a0015919bd03fb40c63db60.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8fe4b39-c1ec-4a88-ac9a-b6b1a6053d5f',
		ProductID: '546412',
		ProductName: 'Full-Length 2-Die Set 9.3X62 (.366)',
		UPC: '090255564129',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564126',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '9.3X62',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '46c77ac1-6d35-417e-9c68-a67ee2e51c2f',
		ProductID: '546587',
		ProductName: 'Full-Length 4-Die Set 500 Linebaugh (.510)',
		UPC: '090255565874',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565871',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.5',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '500 LINEBAUGH',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3fda2cf6-c89e-4d24-9e48-0dbcd705a759',
		ProductID: '8629',
		ProductName: '6.8 Remington SPC Unprimed Cases',
		UPC: '090255486292',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.053',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486299',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.265',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '71fe1d19-37c8-4ce9-b30d-0b907fffbb79',
		ProductID: '190160',
		ProductName: 'Powder Bushing 444',
		UPC: '090255191608',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191605',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51ebed8f-e38a-46af-8826-d595d1670523',
		ProductID: '390601',
		ProductName: 'Shell Holder #51',
		UPC: '090255906011',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906018',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd6108d06-c55b-4631-8f9d-030bd128aeaa',
		ProductID: '81532',
		ProductName: '224 Valkyrie 75 gr BTHP Hornady BLACK®',
		UPC: '090255815320',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.775',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815327',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '7.75',
		PalletQtyBoxes: '1400',
		Retail: '38.12',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '1499',
		SectionalDensity: '0.214',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NoVrgPbC--/b1499a59ccc8d7fa88639bf979703dff128aedec.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		Videos3: 'https://vimeo.com/294885162',
		Videos4: 'https://vimeo.com/295269764',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6ae5529c-dcbb-4214-893c-db61c5ea428e',
		ProductID: '95104',
		ProductName: 'Hornady® 12-Gun Welded Cabinet',
		UPC: '090255951042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '53',
		ShelfWidth: '20',
		ShelfDepth: '15',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '53.000',
		CartonWidth: '20.000',
		CartonDepth: '15.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '265.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Welded Gun Cabinets',
		CountryofOrigin: 'CAMBODIA',
		Prop65Chem1: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		ProductExtHeight: '53',
		ProductExtWidth: '20',
		ProductExtDepth: '15',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This fully welded security cabinet secures firearms that are up to 53 inches long. The anti-pick three point key lock system means only key holders have access. It has storage capacity for everything from rifles, shotguns, and handguns to gear and supplies. Pry-resistant concealed hinges prevent tampering. High-quality steel paired with three-point locking mechanism and barrel key lock provide peace of mind. Fully adjustable shelf and gun racks. Shelf accommodates extra-long shotguns and rifles. Heavy-duty PVC-coated gun racks. Neoprene floor mat. Dimensions: 53"H x 20"W x 15"D',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--WR7WYXD6--/jiwgwpgv3x9vjoqo0et0.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6gzDcMlM--/vvrdphtdndayfyhh3nyo.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xWE3mLtK--/otno7emogeor1vdwwbxa.png',
		DateLastModified: '2024-01-04 15:41:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b7a72b4d-2f01-457f-8b77-ba73854e4928',
		ProductID: '010355',
		ProductName: '366 Auto Die Set 28 Ga',
		UPC: '090255013559',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.375',
		ShelfWidth: '7.625',
		ShelfDepth: '6.625',
		Weight: '2.850',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255013556',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '2.85',
		PalletQtyBoxes: '0',
		Retail: '461.39',
		ParentCategory: 'Reloading',
		Cartridge: '28 GA',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--T_9cNez3--/nwcgqhrdvoo6hcilhku8.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90cb2f66-45e9-4371-bac8-e9ee76c1e065',
		ProductID: '75820',
		ProductName: 'Snapsafe® 4 Gun Pistol Rack',
		UPC: '851529004211',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.25',
		ShelfWidth: '7',
		ShelfDepth: '6.25',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004218',
		CartonHeight: '9.750',
		CartonWidth: '8.000',
		CartonDepth: '11.000',
		CartonWeight: '5.75',
		PalletQtyBoxes: '700',
		Retail: '14.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.25',
		ProductExtWidth: '10.25',
		ProductExtDepth: '7',
		ProductWeight: '1.1',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004212',
		MasterPackHeight: '11.000',
		MasterPackWidth: '12.000',
		MasterPackDepth: '41.000',
		MasterPackWeight: '28.75',
		ProductImage: 'http://images.salsify.com/image/upload/s--SAVP_k50--/qmuwb3fntsawaa6rwblk.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lJNa07g2--/luetquv7ih9qzigu6nwq.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jPfrj_Cl--/egfjyxbd1nqhk2kehwds.png',
		Videos: 'https://vimeo.com/213867149',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5b8c1afe-e767-4a37-91e2-78e01bd5e3b3',
		ProductID: '020049',
		ProductName: 'One Shot® Primer Sealer Kit',
		UPC: '090255200492',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.140',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255200499',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.4',
		PalletQtyBoxes: '0',
		Retail: '30.75',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'TETRACHLOROETHYLENE',
		Prop65Chem2: 'TOLUENE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This air-cured, industrial grade sealant protects from moisture and extends the shelf-life of your ammo. Simply apply to the primer after loading and let air dry. Included four - 3 oz. tubes.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--ildklX5C--/n1dyjdbw6m3z4bnrlved.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--zza3bu8R--/vc20mpsugrzs77yspv0n.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5c0380a-e372-431e-9a58-2b93edb35749',
		ProductID: '190097',
		ProductName: 'Shot Bushing 1 1/8 oz #8',
		UPC: '090255190977',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255190974',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shot Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Calibrated to measure maximum legal loads for trap and skeet shooting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ea7cb88-6f15-438e-86c7-fae52d2ca78a',
		ProductID: '82738',
		ProductName: '348 WIN 200 gr FTX® LEVERevolution®',
		UPC: '090255827385',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.585',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827382',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.85',
		PalletQtyBoxes: '930',
		Retail: '90.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.32',
		MuzzleVelocity: '2560',
		MuzzleEnergy: '2910',
		SectionalDensity: '0.236',
		Cartridge: '348 WIN',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8lfvbCRn--/880a5b0ed4e3087a0ae9324d6b75ab0e1d082f24.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		Videos1: 'https://vimeo.com/294885227',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81603c30-5376-4ee5-b279-e345c51740cc',
		ProductID: '546449',
		ProductName: 'Full-Length 2-Die Set 375 Flanged Mag NE (.375)',
		UPC: '090255564495',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564492',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '164.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '375 FL MAG NITRO EXP',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f7e1e2aa-c4ea-4e01-9a74-8536043cf2ee',
		ProductID: '546341',
		ProductName: 'Full-Length 2-Die Set 30-06 Ack Imp (.308)',
		UPC: '090255563412',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.440',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563419',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.2',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30-06 ACKLEY IMP',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6addf431-ca85-40f0-aefc-9b7cfbb656bb',
		ProductID: '86241',
		ProductName: '12 GA #5 Nickel 3" Turkey',
		UPC: '090255862416',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.75',
		ShelfDepth: '4',
		Weight: '1.332',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862413',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '13.32',
		PalletQtyBoxes: '1120',
		Retail: '19.13',
		ParentCategory: 'Ammunition',
		Applications: 'AppTurkey',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#5',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Your answer for turkeys and coyotes!  Take down turkeys and coyotes up to 50 yards away with accurate, deadly and dependable Heavy Magnum® Shotgun ammunition. HEAVY MAGNUM® TURKEY Available in 3", 12 or 20 gauge loads, Heavy Magnum Turkey® delivers true gobbler knockdown power! Shot deformation is minimized, thanks to the thickest nickel-plating in the industry, which reduces fliers and keeps more pellets on target for dense patterns. The Hornady® Versatite® wad does the patterning, so these loads don\'t require shotgun modification or specialized turkey chokes. At 1300 fps for the 12 gauge load, and 1200 fps for the 20 gauge load, Heavy Magnum® Turkey ammunition allows hunters to achieve lethal results out to 50 yards.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--AbE_tenh--/08b9ca2f1042562e09c95c3b0f9c7e9fae1afd2e.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YKzxkQ72--/b894807cad51c1014446cbe4edf3e7a9f186a40e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--0Y1n1BVa--/p3qgsaqdchsmz1aokwtz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s---CFn2L0A--/o3nzxcu8sb7vmsc2mdbi.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CXfxb5xc--/svmkejrcdjo2szhq3ssx.jpg',
		Videos: 'https://vimeo.com/145438803',
		Videos1: 'https://vimeo.com/264506193',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3a521c3d-84c4-4990-8f39-aaff61511507',
		ProductID: '25418',
		ProductName: '25 Cal .257 110 gr ELD-X®',
		UPC: '090255254181',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.720',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255254188',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '43.0',
		PalletQtyBoxes: '900',
		Retail: '61.79',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.465',
		G7BC: '0.234',
		MinTwist: '1-10"',
		SectionalDensity: '0.238',
		OAL: '1.224',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GjMiqEcj--/71e41ea15d08e17de889c8657454b658596b1f76.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0bf5ef1-a506-4376-b0e0-e9a88f353785',
		ProductID: '190131',
		ProductName: 'Powder Bushing 318',
		UPC: '090255191318',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191315',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'de9f07f5-b8c7-4b3f-be42-4d926cade9e3',
		ProductID: '190178',
		ProductName: 'Powder Bushing 525',
		UPC: '090255191783',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.056',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191780',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.56',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c387e739-ca1a-4c45-8b55-7b498fbe3f50',
		ProductID: '095314',
		ProductName: 'Case Feeder Plate Small Rifle',
		UPC: '090255953145',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.125',
		ShelfWidth: '13',
		ShelfDepth: '12.25',
		Weight: '1.607',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255953142',
		CartonHeight: '2.125',
		CartonWidth: '13.000',
		CartonDepth: '12.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '53.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Select from our four Case Feeder Plates tailor-made for the Lock-N-Load Automatic Case Feeder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--0iAzrvgG--/typxupi39wyjmuvdqmee.png',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce9f3632-5bd6-4d46-8cb7-4685e400c546',
		ProductID: '99226',
		ProductName: 'Hornady® OD Green & Black Mesh Cap',
		UPC: '090255992267',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '0.00',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s---pIUfG5P--/gmhtgntjjsrwvbxj9tu3.png',
		DateLastModified: '2023-11-07 15:06:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03323462-c78a-4974-bf26-8317287c8d89',
		ProductID: '91296',
		ProductName: '357 Sig 135 gr FlexLock® Critical Duty®',
		UPC: '090255912968',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.695',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255912965',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '6.95',
		PalletQtyBoxes: '1120',
		Retail: '44.01',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.170',
		MuzzleVelocity: '1225',
		MuzzleEnergy: '450',
		SectionalDensity: '0.153',
		Cartridge: '357 SIG',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--HiVtSRzP--/501c1ca6669c02e0370abe873e05afbb41d24a1b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93da67ac-90d8-44ec-a580-aeadfe63c125',
		ProductID: '95792',
		ProductName: '2-Gun Rack',
		UPC: '090255957921',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '4.75',
		ShelfDepth: '5.5',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957928',
		CartonHeight: '7.500',
		CartonWidth: '6.000',
		CartonDepth: '24.500',
		CartonWeight: '6.0',
		PalletQtyBoxes: '0',
		Retail: '14.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--SNYQY7Z7--/cvaw8gpqezukm3mcaiup.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--SNYQY7Z7--/cvaw8gpqezukm3mcaiup.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--2Apk07v3--/akfevpmdibcuxujd7eee.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--qynzkg7T--/igyu8kkd53vcbxfbrzbb.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b4043fa-ed96-4725-a433-f6f5084fbfcc',
		ProductID: '45161B',
		ProductName: '45 Cal .451 230 gr HAP®',
		UPC: '090255693232',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '50.416',
		WeightUOM: 'LB',
		CaseQty: '1500',
		CartonUCC: '10090255693239',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '75624.0',
		PalletQtyBoxes: '63000',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.188',
		SectionalDensity: '0.162',
		OAL: '0.65',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'HAP®',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yey2ipUN--/d38da23b8fb3a0324419ce21a06d2bfdd257e197.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zIFfCwVS--/12448bc71eefe45f9e6395579281831d89e22725.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cdab7097-3d20-40d2-85fd-bc3094f4abf5',
		ProductID: '86281',
		ProductName: '6.5 Creedmoor Unprimed Cases',
		UPC: '090255697414',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.260',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255697411',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.3',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '528565e6-c316-43e6-8433-e5c1f0aeadf0',
		ProductID: '99291',
		ProductName: 'Hornady® Brown & Tan Camouflage Mesh Cap',
		UPC: '090255992915',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'BANGLADESH',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--AoX013SV--/jmrpfxqetl9xw5toynhu.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a2d342dc-43b8-4f7b-a13c-77a475bbc6fb',
		ProductID: '546392',
		ProductName: 'Full-Length 2-Die Set 340 Wby (.338)',
		UPC: '090255563924',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.522',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563921',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.61',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '340 WBY MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd0332953-1dc0-4d24-a8f3-4794d2d3befe',
		ProductID: '81446',
		ProductName: '25-06 Rem 90 gr GMX® Superformance®',
		UPC: '090255814460',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814467',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.41',
		PalletQtyBoxes: '1400',
		Retail: '60.45',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.29',
		SectionalDensity: '0.195',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'GMX®',
		BulletWeightGrain: '90',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GsLsQAys--/1ac106d66bd19eae4091d624be58ba0b93576fe6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48180819-0844-4a78-9089-4231a64d8f40',
		ProductID: '190114',
		ProductName: 'Shot Bushing 11/16 oz',
		UPC: '090255191141',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.076',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191148',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.76',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2b14433b-5e3a-4f36-acbd-320147fe367b',
		ProductID: '81587',
		ProductName: '280 Remington 150 gr ELD-X® Precision Hunter®',
		UPC: '090255815870',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815877',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '1400',
		Retail: '60.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.574',
		G7BC: '0.289',
		MuzzleVelocity: '2925',
		MuzzleEnergy: '2849',
		SectionalDensity: '0.266',
		Cartridge: '280 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--T7S05rzi--/14761b23b4891e8424d88424e1dcb173a3687914.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b777b0d8-7552-44ef-98b0-f0be7989d73c',
		ProductID: '3040',
		ProductName: '30 Cal .308 165 gr InterLock® SP',
		UPC: '090255230406',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.506',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230403',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.59',
		PalletQtyBoxes: '540',
		Retail: '48.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.387',
		SectionalDensity: '0.248',
		OAL: '1.173',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WaDPuYeF--/0f4116e9663c5a422ca2f350d6c6bfcfc0693ad9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7fc3bcb5-19b4-4104-9b64-b96c52b0a0d9',
		ProductID: '2444',
		ProductName: '6mm .243 90 gr GMX',
		UPC: '090255224443',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.742',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224440',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '18.55',
		PalletQtyBoxes: '900',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.422',
		SectionalDensity: '0.218',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'GMX®',
		BulletWeightGrain: '90',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--sGY9djJE--/i3nzy9dqdb5rlru0h9no.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4cfc44e0-f69b-4c04-89d4-0c16ad269ef0',
		ProductID: '050111',
		ProductName: 'M2 Digital Bench Scale',
		UPC: '090255501117',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.25',
		ShelfWidth: '7.25',
		ShelfDepth: '9',
		Weight: '2.375',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255501114',
		CartonHeight: '11.500',
		CartonWidth: '14.750',
		CartonDepth: '18.500',
		CartonWeight: '19.0',
		PalletQtyBoxes: '384',
		Retail: '260.79',
		Brand: 'Hornady®',
		ProductLine: 'Powder Scales & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made from the same high quality, precision load cell found on the Auto Charge®, the high performance Bench Scale is the perfect addition to your reloading bench. With a capacity of 1500 grains, you can weigh powder, bullets, cases, cartridges and more. The large LCD display is easy to read and weighs precisely to a tenth (0.1) of a grain. Included are two calibration weights, AC adaptor, 220V adaptor, and metal powder pan.',
		ProductImage: 'http://images.salsify.com/image/upload/s--CCxZ3mc9--/yv2bnpqpiznj5aspynye.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--bc2xEhfr--/qi3nrqdo6qt74owmazsm.png',
		Videos: 'https://vimeo.com/586367872',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cb760585-c111-4e26-a4e1-678d587c2025',
		ProductID: '99227',
		ProductName: 'Hornady® Gray Cap',
		UPC: '090255992274',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'SRI LANKA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--v6xpC6Az--/xfu1ivgcptvaddhaddvu.jpg',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e654189-aad1-4c0c-9ad8-3adc689a7977',
		ProductID: '041200',
		ProductName: 'Primer Pocket Cleaner Tool - Large',
		UPC: '090255412000',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412007',
		CartonHeight: '10.000',
		CartonWidth: '6.000',
		CartonDepth: '1.500',
		CartonWeight: '1.0',
		PalletQtyBoxes: '0',
		Retail: '10.28',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.  The Hornady® Primer Pocket Cleaner Tool (LARGE Primer) is a complete system for cleaning out Large Pistol or Large Rifle Primer pockets to help ensure consistent primer seating and ignition by clearing any brass irregularities from the primer pocket area, or to clear debris or carbon from the primer pocket of fired brass.   NOTE: This product does not cut the crimp from crimped brass  Hornady® Primer Pocket Cleaner Tool includes: Qty 1: Hornady® Universal Accessory Handle • Qty 1: Primer Pocket Cleaner Head (Large Rifle/Pistol)  Other accessories sold separately.  Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--E4FUg6-E--/di6ucf4m2vvh4cvhzdnm.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0c6faef0-8f6f-4b5b-bd48-bea8c5ae0d1f',
		ProductID: '190116',
		ProductName: 'Shot Bushing 5/8 oz',
		UPC: '090255191165',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.077',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191162',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.77',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c393db0-e598-4b77-84e6-11baddf19670',
		ProductID: '752102325',
		ProductName: 'SnapSafe® Lock Box - XL FDE',
		UPC: '842631100694',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '4.260',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100691',
		CartonHeight: '11.250',
		CartonWidth: '9.000',
		CartonDepth: '12.250',
		CartonWeight: '21.3',
		PalletQtyBoxes: '500',
		Retail: '42.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '6',
		ProductIntHeight: '1.75',
		ProductIntWidth: '6.75',
		ProductIntDepth: '9.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. Easy to operate steel key lock mechanism. Keyed option includes two keys that are keyed alike (2-pack option includes four keys). 1500 lb. rated 4 ft. steel security cable† (2-pack option includes two cables). Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. Dimensions: 10” x 7” x 2” Weight: 6 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--yRsmVY22--/ybp7zngwa4lu1448hbfr.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--QbGNthcq--/aeruigbtaghi7cew5fav.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KjNPaE3N--/aqq9tz0kpqlygsvpn0do.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--TrP2qSwf--/oby9ybzifaz51t0esv09.png',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f58ea766-fcba-4872-be89-3dfc05293cf6',
		ProductID: '8690',
		ProductName: '376 Steyr Unprimed Cases',
		UPC: '090255486902',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486909',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.0',
		PalletQtyBoxes: '200',
		Retail: '97.33',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '376 STEYR',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c053c17-60e3-497d-b9b0-3cd534e88c60',
		ProductID: '81396',
		ProductName: '6mm Creedmoor 105 gr BTHP Hornady BLACK®',
		UPC: '090255813968',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255813965',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.0',
		PalletQtyBoxes: '1400',
		Retail: '43.51',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.53',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '2043',
		SectionalDensity: '0.254',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '105',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ueh2rdlB--/ac2ea84daf22a1fe26a47ede63581e150091bcb2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'beb0d18f-223a-4752-b671-46a551e22ad5',
		ProductID: '546117',
		ProductName: 'Full-Length 2-Die Set 17 Rem Fireball .172',
		UPC: '090255561173',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.338',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255561170',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.69',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '17 REM FIREBALL',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b1a1d811-5db2-41de-8911-9c1c97632184',
		ProductID: '392163',
		ProductName: 'Collet #10 .375 Cal',
		UPC: '090255921632',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921639',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.41',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--G2kDYXr3--/f690cf7ae51bd9b7e27cafa943a7c3f67ecf445b.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb2e23ea-5391-47e2-ba97-428754decc9f',
		ProductID: '42404',
		ProductName: '423 cal .423 400 gr DGX® Bonded',
		UPC: '090255424041',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.960',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255424048',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.4',
		PalletQtyBoxes: '540',
		Retail: '125.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.315',
		SectionalDensity: '0.319',
		OAL: '1.31',
		Caliber: '423 CAL',
		BulletDiameter: '0.423',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zO8CWHLK--/b4194886911969e69e3056cdd76372195ca4b3d3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3fb74f00-1c5b-4ec5-8a60-b06c6cf7fc95',
		ProductID: '044106',
		ProductName: 'Seater Die #6 (.264) 6.5mm W/146',
		UPC: '090255441062',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.604',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441069',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f356c1fc-c744-4112-b77f-357017f76d6a',
		ProductID: 'C375R',
		ProductName: 'Lock-N-Load® 375 Ruger Modified Case',
		UPC: '090255705041',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705048',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.41',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '15d58493-9f2d-4076-a379-a56e1394ca73',
		ProductID: '546374',
		ProductName: 'Full-Length 2-Die Set 32/40 Win (.321)',
		UPC: '090255563740',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563747',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '32-40 WIN',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5d1bb09e-f80c-4553-8048-38cddf8969e0',
		ProductID: '8230',
		ProductName: '338 Lapua 250 gr BTHP Match',
		UPC: '090255382303',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.085',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382300',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '12.51',
		PalletQtyBoxes: '396',
		Retail: '171.37',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.67',
		MuzzleVelocity: '2860',
		MuzzleEnergy: '4540',
		SectionalDensity: '0.313',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9A6CpsNV--/d8d575412a805fec6dc0de3651e80571fc685cba.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '525cdf9d-bf96-4dcf-a157-e135f294f0b4',
		ProductID: '3070',
		ProductName: '30 Cal .308 180 gr InterLock® SP',
		UPC: '090255230703',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.713',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230700',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.695',
		PalletQtyBoxes: '540',
		Retail: '49.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.425',
		SectionalDensity: '0.271',
		OAL: '1.228',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wDQ0ZP79--/73251540cfc8c40ce038a9cb510608dc7f5e3437.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e89fcb72-4c91-4993-be33-5ecff4c74404',
		ProductID: '480042',
		ProductName: 'Magnum Reloading Block With Sleeve',
		UPC: '090255800425',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.25',
		ShelfWidth: '8.75',
		ShelfDepth: '1.25',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800422',
		CartonHeight: '10.250',
		CartonWidth: '10.250',
		CartonDepth: '14.250',
		CartonWeight: '12.0',
		PalletQtyBoxes: '0',
		Retail: '31.81',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'This large caliber reloading tray holds fifty 50 caliber cases or shotgun shells.',
		ProductImage: 'http://images.salsify.com/image/upload/s--TwsZAvcD--/oeuoeq4bp72sg397obff.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--SQ2W1AZd--/qzpkjapbd4oi96hu2fk1.png',
		DateLastModified: '2023-12-16 09:02:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5963fb8c-1540-48c2-ac71-c9ebc31c2f1e',
		ProductID: '546408',
		ProductName: 'Full-Length 2-Die Set 358 Win (.358)',
		UPC: '090255564082',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564089',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '358 WIN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c97a4bd0-b110-43b1-9398-92db13cbd92a',
		ProductID: '41000',
		ProductName: '41 Cal .410 210 gr XTP®',
		UPC: '090255241006',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.158',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255241003',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.37',
		PalletQtyBoxes: '540',
		Retail: '46.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.182',
		SectionalDensity: '0.178',
		OAL: '0.67',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		BulletName: 'XTP®',
		BulletWeightGrain: '210',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NfhqmBHO--/b5489f7ac21d86ce50768565ba2473460d093adc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9bf9498e-53e9-43a1-ba46-dfde6c72ef7f',
		ProductID: '8324',
		ProductName: '220 Swift 55 gr V-MAX® Varmint Express®',
		UPC: '090255383249',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.884',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383246',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.84',
		PalletQtyBoxes: '1400',
		Retail: '49.53',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		MuzzleVelocity: '3680',
		MuzzleEnergy: '1654',
		SectionalDensity: '0.157',
		Cartridge: '220 SWIFT',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vqMHgLTV--/12a8d0a04c68124aa98a3b49ddf30e9b25e77c70.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '944a975f-1e61-42bc-91af-d34787c44bff',
		ProductID: '91000',
		ProductName: '9 x 18mm Makarov 95 gr FTX® Critical Defense®',
		UPC: '090255910001',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.660',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255910008',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '6.6',
		PalletQtyBoxes: '1120',
		Retail: '40.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.135',
		MuzzleVelocity: '1000',
		MuzzleEnergy: '211',
		SectionalDensity: '0.102',
		Cartridge: '9X18 MAKAROV',
		Caliber: '9X18 MAKAROV',
		BulletDiameter: '0.3645',
		BulletName: 'FTX®',
		BulletWeightGrain: '95',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--0cjpEsVB--/9b43da47c5570f02f06999bc1ab164fa8b31ef25.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '157cddbd-f464-46f8-842f-3b5da0ee2e15',
		ProductID: '81604',
		ProductName: '6mm ARC 105 gr BTHP Hornady BLACK®',
		UPC: '090255816044',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.860',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255816041',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.6',
		PalletQtyBoxes: '1400',
		Retail: '39.13',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '.530',
		MuzzleVelocity: '2750',
		MuzzleEnergy: '1763',
		SectionalDensity: '0.254',
		Cartridge: '6MM ARC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '105',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tested, selected and fielded by a specialized group within the U.S. DoD for its multipurpose combat rifle program, the versatile 6mm ARC does much of what larger cartridges can and everything that smaller cartridges can’t. Designed to meet the needs of the world’s toughest critics, the 6mm ARC utilizes efficient, high-BC bullets to deliver unprecedented performance from the AR-15 platform. Commercial 6mm ARC offerings will feature bullets selected to deliver ideal performance for hunting, match shooting and personal protection applications.  The 6mm ARC achieves results never before delivered from the AR-15 platform with the ultimate blend of system weight, performance and shootability. Equally at home in AR-15 platforms and short or micro action bolt guns, this load is suitable for applications from personal defense to match shooting, hunting, and military and law enforcement.  Balanced application of cartridge, chamber and propellant design is coupled with bullet selection for optimum all-range performance and barrel life. The 6mm ARC provides excellent terminal performance from an assortment of bullets for a variety of applications. Proudly made in the USA! Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms Gun manufacturers include: Adams Arms, APF Armory, Barrett, Brownells, Brenton, Christensen, CMC Triggers, CMMG, GAP, Geissele, Howa, Lantac, Mile High Shooting Accessories, Mossberg, NEMO, Noveske, Odin Works, Proof, Radical Firearms, SanTan Tactical, Savage, Seekins Precision, Uintah Precision, Wilson Combat',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--7HyCAxOT--/ibehibosn13mskgtflxj.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--o-bXd60H--/hma7qkculz2welnao45h.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_yN2K5ZI--/uygyuhyqwuue2ii0ubrt.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jpvfO_PT--/kpquvbdq3jk2ukxfx7zb.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0U1QXSEC--/xzviqvt4yshbe431ytjm.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7HyCAxOT--/ibehibosn13mskgtflxj.png',
		Videos: 'https://vimeo.com/424873712',
		Videos1: 'https://vimeo.com/419030730',
		Videos2: 'https://vimeo.com/429735159',
		Videos3: 'https://vimeo.com/427177089',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0fb71187-591b-4468-9658-82c0b4e51f88',
		ProductID: '390944',
		ProductName: 'Trimer Pilot #2 .228',
		UPC: '090255909449',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.017',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909446',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.17',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '22 CAL',
		BulletDiameter: '0.228',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--fcsA6lUI--/qgax3gbylhn4vb79r2cq.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6967e27b-9168-4cd5-8135-e061ef194cc0',
		ProductID: '046056',
		ProductName: 'Neck Size Die 7mm Mag (.284)',
		UPC: '090255460568',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.463',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460565',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66323e95-0c20-4475-802b-e669119b1727',
		ProductID: '399697',
		ProductName: 'Quick Detach Universal Mounting Plate Assembly',
		UPC: '090255996975',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '17',
		ShelfWidth: '8',
		ShelfDepth: '3',
		Weight: '8.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '16.750',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '94.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--ziMns2Dc--/kloql9vrtbqf5tdaazqm.pdf',
		ProductDescription:
			'Quickly and easily attach and detach presses and other reloading tools with the Quick Detach Universal Mounting Plate System. Just mount the aluminum blocks to a bench or table for a strong clamp and stability. Presses and tools can be attached to multiple plates and switched out for use. Maximizes production where bench space is limited. Cam locks keep the plate stable during use but allow for quick release to change out plates during press or reloading processes.  Mounting hole configurations fit a variety of presses and reloading tools.  Compatible Tools & Equipment Lock-N-Load® AP Lock-N-Load® Iron Press Lock-N-Load® Classic 50 BMG 366 Auto Shotgun Press Lock-N-Load® Bullet Feeders Cam Lock™ Trimmer Lock-N-Load® Concentricity Tool Neck Turning Tool',
		ProductImage: 'http://images.salsify.com/image/upload/s--xXFaL_63--/knhmthusfrrfrjdrifgk.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--NrlPS3Rz--/djt6uexpjns2ujjlt8tu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--7msWdR4A--/zzxa1lrqpsl87ik1jgtk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--EhIgJYOX--/ellw0el7jh0iu7nm497p.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--52xNJYih--/izcdrxsvkc6691ugego2.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--19A-jEGG--/gdxfvd4x0ntgldgx48vn.jpg',
		Videos: 'https://vimeo.com/287279753',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60943f0b-a17e-4d4e-b66f-38720ed0b1e5',
		ProductID: '190169',
		ProductName: 'Powder Bushing 474',
		UPC: '090255191691',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191698',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'edd8ed26-1327-4782-ac25-8801ad54d4f9',
		ProductID: '99112',
		ProductName: 'Hornady® Joyce Hornady Tin Sign',
		UPC: '090255991123',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '18',
		ShelfWidth: '12',
		ShelfDepth: '0.03',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area. Each have rounded corners and four pre-drilled holes for easy hanging. Measures 12"x18"',
		ProductImage: 'http://images.salsify.com/image/upload/s--a40jSVhx--/xczhzw8ttgogd5gethwp.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9923cd2-99bd-42a4-9f57-f81f40b67e49',
		ProductID: '3320',
		ProductName: '338 Cal .338 225 gr InterLock® SP-RP',
		UPC: '090255233209',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.366',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255233206',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '50.49',
		PalletQtyBoxes: '540',
		Retail: '79.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.397',
		SectionalDensity: '0.281',
		OAL: '1.253',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--dbbtgKWb--/cf923421b93376c2356dd5ca2ebcfdf94e097453.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f64ce876-6e0e-4783-8a36-710412751ae4',
		ProductID: '044571',
		ProductName: 'Expander Die 405 Win (.411)',
		UPC: '090255445718',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.431',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445715',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '046f9692-7bc5-407b-9f1e-138bdaf55d9c',
		ProductID: '095310',
		ProductName: 'Case Feeder Plate Small Pistol',
		UPC: '090255953107',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.125',
		ShelfWidth: '13',
		ShelfDepth: '12.25',
		Weight: '1.610',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255953104',
		CartonHeight: '2.125',
		CartonWidth: '13.000',
		CartonDepth: '12.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '53.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Select from our four Case Feeder Plates tailor-made for the Lock-N-Load Automatic Case Feeder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--BpH1Lwku--/zs2eay2wz0tdafyzhxiy.png',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '77cdac7d-bf54-40ea-b0aa-0f2d1e88d331',
		ProductID: '544253',
		ProductName: 'Match™ Grade Neck Size Die 6mm PPC (.243)',
		UPC: '090255542530',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.516',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255542537',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6MM PPC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48551d74-d946-4287-a453-a8c86ebb857d',
		ProductID: '8225',
		ProductName: '303 British 150 gr InterLock® SP',
		UPC: '090255382259',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.240',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255382256',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.4',
		PalletQtyBoxes: '1400',
		Retail: '60.37',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.361',
		MuzzleVelocity: '2685',
		MuzzleEnergy: '2401',
		SectionalDensity: '0.22',
		Cartridge: '303 BRITISH',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x3OL_2YN--/11ed8ceacd643422b48dd43add01961b9c02e70b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '35de29e7-2019-4a51-9102-67bbab7e1097',
		ProductID: '391908',
		ProductName: 'Neck Turn Mandrel 17 .172',
		UPC: '090255919080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.058',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919087',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.58',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--epISBUHy--/nedqrxmuuinzxkzdnrqv.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4afa178-de33-4977-9069-48b234f66d90',
		ProductID: '75911',
		ProductName: 'Snapsafe® Magnetic Safe Hook',
		UPC: '842631100250',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.75',
		ShelfWidth: '4.5',
		ShelfDepth: '2.5',
		Weight: '0.583',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100257',
		CartonHeight: '5.500',
		CartonWidth: '5.250',
		CartonDepth: '9.500',
		CartonWeight: '2.915',
		PalletQtyBoxes: '1500',
		Retail: '21.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '3.14',
		ProductExtWidth: '4.5',
		ProductExtDepth: '3.5',
		ProductWeight: '0.5',
		MasterPackQty: '30',
		MasterPackUCC: '30842631100251',
		MasterPackHeight: '11.250',
		MasterPackWidth: '10.500',
		MasterPackDepth: '16.000',
		MasterPackWeight: '17.49',
		ProductDescription:
			'This little two-pronged hook does big work, holding gun cases, binoculars, range bags and other accessories.   Heavy-duty magnets securely store gear. Rated for 15 lbs. Position on corner of any gun safe.',
		ProductImage: 'http://images.salsify.com/image/upload/s--efpk9sJ7--/zfvoqmgcur3dt5nuzzzi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--wAlyhCtY--/igon9adprsbmc6e29cyo.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--e8nO6kNr--/ur7nxilw7dr7rbiwiktn.jpg',
		Videos: 'https://vimeo.com/267243780',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ec71a63-29d4-4189-803b-f4e4a32aad53',
		ProductID: '046525',
		ProductName: 'Size Die 38 Super Auto (.355)',
		UPC: '090255465259',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.501',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465256',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '38 SUPER AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f6fbe26-7049-4d62-b4c6-5d4e4ed51274',
		ProductID: '32005',
		ProductName: '32 Cal .321 165 gr FTX®',
		UPC: '090255320053',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.450',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255320050',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.75',
		PalletQtyBoxes: '540',
		Retail: '61.55',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.31',
		SectionalDensity: '0.229',
		OAL: '1.055',
		Cartridge: '32 WIN SPL',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		BulletName: 'FTX®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZN-7rzAa--/f0a05ba11473fb45d882a52f193cba097fee8560.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '54a1ff67-e14c-402f-acac-581688136447',
		ProductID: 'A270',
		ProductName: 'Lock-N-Load® 270 Win Modified Case',
		UPC: '090255704297',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.031',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704294',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.31',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fH9aGc5d--/f7d32ce9ee74f9110b0481fddf750d35af426c7d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2b64810e-b079-4512-8f48-fe8e2321306e',
		ProductID: '83171',
		ProductName: '17 HMR® 15.5 gr NTX® Varmint Express® Rimfire',
		UPC: '090255831719',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.407',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255831716',
		CartonHeight: '4.250',
		CartonWidth: '8.750',
		CartonDepth: '15.500',
		CartonWeight: '16.28',
		PalletQtyBoxes: '5200',
		Retail: '26.61',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Rimfire Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.115',
		MuzzleVelocity: '2525',
		MuzzleEnergy: '219',
		SectionalDensity: '0.075',
		Cartridge: '17 HMR',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'NTX®',
		BulletWeightGrain: '15.5',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--G-gIssbn--/bbb0eca0fc21cfaec42c4a3ce97c59268ab7ce5e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--FypGWu-y--/xoqoyn6gw7mvw87fxazk.jpg',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc21ab27-c3e3-40a8-9157-744e834953aa',
		ProductID: '82026',
		ProductName: '300 Win Mag 165 gr GMX® Superformance®',
		UPC: '090255820263',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.608',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820260',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.08',
		PalletQtyBoxes: '780',
		Retail: '70.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kPk1Lldr--/773d7ba9a99c3c2fa9c52d0edc6d9f25fcd720e4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f2e24b0b-946f-4a5c-bc8b-c49baa40d774',
		ProductID: '8264',
		ProductName: '470 Nitro Express 500 gr DGS® Dangerous Game™ Series',
		UPC: '090255382648',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.904',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382645',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '17.424',
		PalletQtyBoxes: '396',
		Retail: '290.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.29',
		MuzzleVelocity: '2150',
		MuzzleEnergy: '5132',
		SectionalDensity: '0.318',
		Cartridge: '470 NITRO EXP 3¼"',
		Caliber: '470 CAL',
		BulletDiameter: '0.474',
		BulletName: 'DGS®',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mZbC0pgV--/d32e8cb24a6ea284a62638a47e9536309d438ea0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:46:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c630fd8a-b4d3-46d3-844e-32f7a1dcdd2d',
		ProductID: '544229',
		ProductName: 'Match™ Grade Full-Length Size Die 223 Rem (.224)',
		UPC: '090255542295',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.544',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255542292',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e2f1e0d-fdc4-4645-b994-60a69585fbb4',
		ProductID: '190140',
		ProductName: 'Powder Bushing 360',
		UPC: '090255191400',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.068',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191407',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.68',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2d47a67b-0620-4491-9324-69c40d0219a8',
		ProductID: '046353',
		ProductName: 'Full-Length Size Die 300 Win Mag (.308)',
		UPC: '090255463538',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.610',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463535',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3eb078be-b557-49cb-8396-33ce040ee695',
		ProductID: '190150',
		ProductName: 'Powder Bushing 402',
		UPC: '090255191509',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.065',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191506',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.65',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4f2be0a-70fd-4153-a230-826414690b08',
		ProductID: '8692',
		ProductName: '444 Marlin Unprimed Cases',
		UPC: '090255486926',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486923',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.5',
		PalletQtyBoxes: '200',
		Retail: '82.28',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '444 MARLIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f4e7fecf-9197-4771-bbe0-62e32fd4f532',
		ProductID: 'B30N',
		ProductName: 'Lock-N-Load® 30 Nosler Modified Case',
		UPC: '090255715064',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715061',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.55',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '30 NOSLER',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66d64761-9bcc-441e-a693-563b9da1933c',
		ProductID: '546464',
		ProductName: 'Full-Length 2-Die Set 458 SOCOM (.458)',
		UPC: '090255564648',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564645',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '458 SOCOM',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db13bf88-7641-48ba-a685-4660fc4d30f6',
		ProductID: '95820',
		ProductName: 'Hornady® 4 Gun Pistol Rack',
		UPC: '090255958201',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.25',
		ShelfWidth: '7',
		ShelfDepth: '6.25',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255958208',
		CartonHeight: '9.750',
		CartonWidth: '8.250',
		CartonDepth: '10.750',
		CartonWeight: '6.0',
		PalletQtyBoxes: '630',
		Retail: '13.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.25',
		ProductExtWidth: '10.25',
		ProductExtDepth: '7',
		ProductWeight: '1.2',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Store guns in your safe or anywhere with these handy gun racks made in four different widths. The rack helps maximize storage space while offering a secure and balanced rack designed for compact pistols, full-size handguns, revolvers, and semi-autos. Its PVC coating prevents scratches or marring. Store guns right side up or upside down, depending on your preference. Ability to maximize storage space while offering a secure and balanced rack. Designed for compact pistols, full size handguns, revolvers and semi autos. Option to store guns right side up or upside down. PVC coating won’t scratch or damage handgun’s finish. Free up room in your gun safe or cabinet. Use at the range to hold handguns while not in use.  Dimensions 4-Gun Rack: 5.1"H x 9"W x 6.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to DI(2-Ethylhexyl) Phthalate, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.',
		ProductImage: 'http://images.salsify.com/image/upload/s--m382pjBq--/c1abaz2w2kkqyvup0bbj.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XUT11nWo--/numm5gtahwejuyzows6r.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--9PzVkBKA--/sat12ca6oz7vpkryuzzh.png',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '98e47190-e58c-4808-8cb0-00ce759604ed',
		ProductID: '399692',
		ProductName: 'Universal Accessory Bin & Bracket',
		UPC: '090255996920',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5',
		ShelfWidth: '4',
		ShelfDepth: '3',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255996927',
		CartonHeight: '5.000',
		CartonWidth: '4.000',
		CartonDepth: '3.000',
		CartonWeight: '4.0',
		PalletQtyBoxes: '0',
		Retail: '26.84',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--QnEQ5ao_--/mnizeajba5p2oh7e5qqb.pdf',
		ProductDescription:
			'The swiveling base of this cartridge bin bracket allows for adaptability on the Lock-N-Load® AP™ and Classic™ Presses. Use it to conveniently store finished rounds.',
		ProductImage: 'http://images.salsify.com/image/upload/s--sdKCxSd7--/j8rbspikjgvix6ctigvx.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b6cc86b3-30cc-43c6-9c15-4d3cc9df3bf6',
		ProductID: '044588',
		ProductName: 'Taper Crimp Die 454 Casull',
		UPC: '090255445886',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.406',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445883',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a1d19470-ed08-4115-9002-0bd5ac84f32b',
		ProductID: '046331',
		ProductName: 'Full-Length Size Die 7mm Wby (.284)',
		UPC: '090255463316',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463313',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM WBY MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5ad88b51-823d-4125-bda1-fb2bb6e087c1',
		ProductID: 'B28N',
		ProductName: 'Lock-N-Load® 28 Nosler Modified Case',
		UPC: '090255715057',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715054',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.55',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '28 NOSLER',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'efd4aa70-cd02-4495-bf7c-c00f25027ade',
		ProductID: '26333',
		ProductName: '6.5mm .264 147 gr ELD® Match',
		UPC: '090255263336',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.228',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255263333',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.42',
		PalletQtyBoxes: '540',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.697',
		G7BC: '0.351',
		MinTwist: '1-8"',
		SectionalDensity: '0.301',
		OAL: '1.455',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '147',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wVZo6_Hk--/d2500c5922aa71f8a65190257642ac8a67312e4d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6a144110-39f7-4bcd-8da3-9824ebe1bea3',
		ProductID: 'FR1005',
		ProductName: '223 Remington 55 gr FMJ Frontier',
		UPC: '090255715231',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.45',
		ShelfDepth: '3.75',
		Weight: '1.365',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715238',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '13.65',
		PalletQtyBoxes: '1190',
		Retail: '43.25',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--rrKKSkZ5--/71cb6893d5fcf9e3518e11036fe83b5f9486f7b4.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1fa4ea3f-1736-4071-bf3d-c5591922840d',
		ProductID: '044594',
		ProductName: 'Expander Die 45 Colt Cowboy™ (.452)',
		UPC: '090255445947',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.800',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445944',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e892c22d-fdb1-4ae0-be7d-cdc09794e3f5',
		ProductID: 'B300',
		ProductName: 'Lock-N-Load®300 Rem Ultra Mag Modified Case',
		UPC: '090255704884',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704881',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4cb04d92-1694-485e-a413-9837fb7a9a44',
		ProductID: '95770',
		ProductName: 'Square-Lok™ Document Holder',
		UPC: '090255957709',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0',
		ShelfWidth: '0',
		ShelfDepth: '0',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957706',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductImage: 'http://images.salsify.com/image/upload/s--etdvhVVX--/miha1gzigp9bvqqlkjt3.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ae454edb-9efc-4d92-baa1-6b98edbeedae',
		ProductID: 'C1550',
		ProductName: 'Lock-N-Load® OAL Gauge Curved',
		UPC: '090255704174',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '16.25',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.210',
		WeightUOM: 'LB',
		CaseQty: '24',
		CartonUCC: '10090255704171',
		CartonHeight: '17.250',
		CartonWidth: '11.250',
		CartonDepth: '10.000',
		CartonWeight: '5.04',
		PalletQtyBoxes: '0',
		Retail: '58.07',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® OAL Gauges',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® O.A.L. Gauge is universally acclaimed as the most accurate, easy-to-use and reliable method of regulating seating depth and the resulting "jump" to the rifling. For all autoloader, lever-action, or pump-action rifles. Also fits all bolt-action and single-shot firearms. Inserts into chamber through ejection port. Not compatible with Adapter "D" or short-bodied cases. Achieve precise bullet seating depth. To use the Lock-N-Load® O.A.L. Gauge, you will need a Modified Case (sold separately) to fit your firearm\'s chamber and thread it onto the gauge. These specially prepared modified cases are threaded at the case-head and have a .002" oversized neck to accept the same bullets you intend to load.  This is critical, as the Lock-N-Load® O.A.L. Gauge dimensions obtained will be accurate to .001". These results cannot be attained with competitive products, which use a simulated bullet with an arbitrary shape.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VOUW6VPQ--/wryi0itqtpi6u6sbxndm.psd',
		ProductImage1: 'http://images.salsify.com/image/upload/s--tq89hFDR--/jszzp6sydb17vgh9tc0o.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--zXH6bqr_--/xevupilm2drkonvwgnmv.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Zhisw7d1--/jxvpck9rathtx1amdr2t.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--r7cLLclA--/vdcsetexniugq3fi2yxg.jpg',
		ProductImage5:
			'http://images.salsify.com/image/upload/s--qDyR9e9X--/f66a9b86c017da4530347f4395b662240f53261b.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '015bc2b2-4c1a-4d33-b55b-ce1d0d4b3e8a',
		ProductID: '90240',
		ProductName: '9mm Luger 100 gr FTX® Critical Defense® Lite',
		UPC: '090255902402',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.680',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902409',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '6.8',
		PalletQtyBoxes: '1120',
		Retail: '37.05',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.11',
		MuzzleVelocity: '1125',
		MuzzleEnergy: '281',
		SectionalDensity: '0.113',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FTX®',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Since their inception, conventional hollow point pistol bullets have performed well, but have never delivered 100% reliability, especially in self-defense situations. The patented Flex Tip®technology used in Critical Defense® ammunition eliminates the clogging and inconsistency that often plagues hollow point bullets. Hornady® achieved this by using the same tip material used in LEVERevolution® ammunition.  All Critical Defense® ammunition is loaded in nickel-plated cases for increased visibility in low-light situations. Premium low flash propellants deliver proven performance, even in very short-barreled handguns, and won't disrupt your vision. Reliable expansion and dependable terminal performance can be counted on for concealed carry and personal protection.  Critical Defense® Lite ammunition offers an effective, reduced recoil option for any shooter looking to minimize felt recoil of their lightweight, compact personal protection firearm.   *A portion of the proceeds from the sale of Critical Defense Lite ammunition is donated to help fund breast cancer research. FTX® BULLET TECHNOLOGY The patented FTX® bullet expands reliably and resists clogging when fired through heavy clothing.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for defensive or personal protection situations and is the ultimate choice for any short barreled, concealed carry style firearm. Bright nickel-plated cartridge cases simplify chamber checks in reduced light, and low-flash propellants help preserve night vision.  DEPENDABLE Details such as nickel-plated cases that resist corrosion and optimized propellants that burn quickly to reduce recoil and limit muzzle flash, help ensure that Critical Defense® ammo is dependable in every situation.  LIGHT & COMPACT Critical Defense Lite® ammunition offers an effective, reduced recoil option for any shooter looking to minimize felt recoil of their lightweight, compact personal protection firearm.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--5CG3DE5f--/naawyolinsun1hafr4h5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1ZTxGyaB--/3b2f1be66783f183ee53ddc3de9b250b94607d1b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x3JhQn2a--/hm75w7ny0ixwzoszbcuv.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--auw5Pu9n--/fnhjpbeum4jxz7kz1ube.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--McBoyD-u--/mvxo26xpxcng13ij567u.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd33ec90b-d36c-4f42-ba9e-32102af6af4e',
		ProductID: '397134',
		ProductName: 'Seating Stem 30 Cal ELD-X® 212 Gr',
		UPC: '090255971347',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971344',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a5efdbc-3e4a-4aa3-bd3b-1288ffe462c3',
		ProductID: '546242',
		ProductName: 'Full-Length 2-Die Set 240 Wby (.243)',
		UPC: '090255562422',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.510',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562429',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.55',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '240 WBY MAG',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '56b7847d-6743-41ab-8c8e-a2204166dbd1',
		ProductID: '2542',
		ProductName: '25 Cal .257 110 gr FTX®',
		UPC: '090255709773',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255709770',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.5',
		PalletQtyBoxes: '900',
		Retail: '46.92',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.34',
		SectionalDensity: '0.238',
		OAL: '1.1',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'FTX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EEQ2DTYY--/4002076381b0c886113b39db65c1d2a391101cf5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '503dc427-28e3-416b-bdae-b5beb7b7a123',
		ProductID: '050030',
		ProductName: '366 Auto Loader Powder/Shot Shut-Off',
		UPC: '090255500301',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.375',
		ShelfWidth: '7.625',
		ShelfDepth: '6.625',
		Weight: '1.025',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255500308',
		CartonHeight: '3.250',
		CartonWidth: '4.250',
		CartonDepth: '8.750',
		CartonWeight: '1.025',
		PalletQtyBoxes: '0',
		Retail: '65.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Independently shut off the the powder instead of removing it.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ubmea4nM--/dawwsutrooi8owqm75fm.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd122af18-b283-42ee-922f-50b8ceb4dc13',
		ProductID: '8610',
		ProductName: '22-250 Remington Unprimed Cases',
		UPC: '090255486100',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.275',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486107',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.375',
		PalletQtyBoxes: '400',
		Retail: '61.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c43b3122-b19c-4ce1-be0c-c30ad533f49c',
		ProductID: '75200',
		ProductName: 'Snapsafe® Lock Box With Key Lock LG',
		UPC: '851529004020',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '7',
		ShelfDepth: '10.25',
		Weight: '3.890',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004027',
		CartonHeight: '10.500',
		CartonWidth: '7.750',
		CartonDepth: '11.250',
		CartonWeight: '19.45',
		PalletQtyBoxes: '500',
		Retail: '37.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '1.75',
		ProductExtWidth: '6.5',
		ProductExtDepth: '9.5',
		ProductWeight: '3.3',
		ProductIntHeight: '1.5',
		ProductIntWidth: '6.25',
		ProductIntDepth: '9.25',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. SPECIFICATIONS Dimensions: 9.5” x 6.5” x 1.75” Weight: 4 lbs.  FEATURES Easy to operate steel key lock mechanism. Keyed option includes two keys that are keyed alike  1500 lb. rated 4 ft. steel security cable Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.",
		ProductImage: 'http://images.salsify.com/image/upload/s--2K-bxOD_--/rkxivqkluc0tjodeodzf.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--AUMDyDFc--/v6l9qyzp4cjwau31wnuy.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--aIYZegHt--/qcvadivkbbrqyskqduzt.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DrqsQ0Fh--/bahpl5sr3bsbcu8iwrkx.jpg',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '86f26d5b-9095-4b9b-b07b-02dcfd88acde',
		ProductID: 'FR262',
		ProductName: '5.56 NATO 62 gr FMJ Frontier®',
		UPC: '090255711523',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '3.75',
		ShelfWidth: '6.453',
		ShelfDepth: '3.656',
		Weight: '4.300',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255711520',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '17.2',
		PalletQtyBoxes: '480',
		Retail: '86.25',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.274',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8RZClJiE--/ca928f14cec1461354c05787ea10a4d72c02bee3.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f707b279-1833-4618-b9fa-58c01a89d96f',
		ProductID: '83266',
		ProductName: '223 Rem 35 gr NTX® Superformance® Varmint',
		UPC: '090255832662',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.532',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255832669',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.32',
		PalletQtyBoxes: '1680',
		Retail: '38.07',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.177',
		MuzzleVelocity: '4000',
		MuzzleEnergy: '1243',
		SectionalDensity: '0.1',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'NTX®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ltOIrK5h--/1164ec1cf1424aeeb1da938c068f26bdcadf0eac.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f32c2cf8-24ae-4a84-9327-d352e10abd2a',
		ProductID: '546385',
		ProductName: 'Full-Length 2-Die Set 8X56 Hung-Mann (.329)',
		UPC: '090255563856',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563853',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '8X56 HUNGARIAN-MANN',
		Caliber: '8X56R',
		BulletDiameter: '0.329',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c55aabf-4da0-49ad-a4ab-012e2b86c89c',
		ProductID: '8721',
		ProductName: '338 Marlin Express Unprimed Cases',
		UPC: '090255487213',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.638',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487210',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '8.19',
		PalletQtyBoxes: '400',
		Retail: '65.44',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '778491d0-baea-4bda-98f1-9ba2474dd0cd',
		ProductID: '190172',
		ProductName: 'Powder Bushing 483',
		UPC: '090255191721',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.056',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191728',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.56',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6db09c14-9ace-4237-90be-5d6cb76e5254',
		ProductID: '2250',
		ProductName: '22 Cal .224 53 gr HP Match',
		UPC: '090255222500',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.832',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222507',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.28',
		PalletQtyBoxes: '1440',
		Retail: '29.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.218',
		SectionalDensity: '0.151',
		OAL: '0.713',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '53',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Wd28sOw_--/064a0134503ce699eccc8b275bf1a42bfda7938a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e8383def-9ef8-4c23-87e3-daf54a14990a',
		ProductID: '050240',
		ProductName: 'Magnum Digital Vibratory Tumbler',
		UPC: '090255502404',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.6',
		ShelfWidth: '12.9',
		ShelfDepth: '12.9',
		Weight: '7.850',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255502401',
		CartonHeight: '20.000',
		CartonWidth: '13.500',
		CartonDepth: '13.500',
		CartonWeight: '15.7',
		PalletQtyBoxes: '62',
		Retail: '167.88',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--0rV1uKCL--/armycdy2cbw0qqhfrt7n.pdf',
		ProductDescription:
			'Clean and polish large quantities of brass to a brilliant finish before loading, eliminating abrasive foreign particles that can scratch the inside of your dies. Brass cases cleaned with vibratory action enhances the smooth function of reloading presses and dies, and makes finished reloads look like new. Clean and polish large quantities of brass quickly and efficiently. Larger drum holds up to (600) 38 Special cases, (250) 30-06 cases or equivalent. Tumble for up to eight hours with digital timer. Vibratory action cleans brass to brilliant shine. Tumbling makes dies and other equipment operate more smoothly.',
		ProductImage: 'http://images.salsify.com/image/upload/s--V_VqO22d--/mglulmpnabzum776ytes.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MGY-F6P5--/duxgrd70mk65nnsh0eih.png',
		Videos: 'https://vimeo.com/294885458',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'baf4b8c3-adc9-4a49-8b94-eedfca0867e3',
		ProductID: '8061',
		ProductName: '7mm Rem Mag 154 gr SST® Superformance®',
		UPC: '090255380613',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.525',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380610',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.25',
		PalletQtyBoxes: '780',
		Retail: '70.88',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.525',
		MuzzleVelocity: '3100',
		MuzzleEnergy: '3286',
		SectionalDensity: '0.273',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '154',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iRnC9f-M--/b39b0fc27db130b891375d569dcf28cba7b8c97d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1969d24d-a023-4c91-b069-56efca1d6969',
		ProductID: '80524',
		ProductName: '270 Win 130 gr. CX™ Superformance®',
		UPC: '090255805246',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.236',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805243',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.36',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.403',
		MuzzleVelocity: '3190',
		MuzzleEnergy: '2937',
		SectionalDensity: '0.242',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'CX™',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--om64Tuxy--/yneu5kwj3byekvc8rrv4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--WrGXZhp_--/omhk27s629mlcmrxv5tp.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '066e3263-811b-4c7c-9f11-76a5b47d72ff',
		ProductID: '355281',
		ProductName: '9mm .355 115 gr HAP®',
		UPC: '090255706864',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '8.550',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255706861',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.3',
		PalletQtyBoxes: '216',
		Retail: '100.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.129',
		SectionalDensity: '0.13',
		OAL: '0.54',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'HAP®',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--U_-JiOVS--/hrpy1bqk3v5xo0cbbb9k.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AcGjzfrh--/74230449a32fc11b3fe6c60ad99204b6a1e18707.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '005baffd-fbf5-4e87-93e9-18c31cf0904f',
		ProductID: '390564',
		ProductName: 'Shell Holder #24',
		UPC: '090255905649',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905646',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '44fff379-e931-4a88-b4fe-37b5334e7835',
		ProductID: '046321',
		ProductName: 'Full-Length Size Die 280 Rem (.284)',
		UPC: '090255463217',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.557',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463214',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '280 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bf71390d-a0a8-425b-87c0-4e09560afa4a',
		ProductID: '98196WIFI',
		ProductName: 'RAPiD® Safe Compact Ready Vault w/WIFI',
		UPC: '090255719451',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '54.5',
		ShelfWidth: '13.9',
		ShelfDepth: '13',
		Weight: '77.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '77.0',
		PalletQtyBoxes: '18',
		Retail: '536.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '52.2',
		ProductExtWidth: '10',
		ProductExtDepth: '10',
		ProductWeight: '80',
		ProductIntHeight: '51',
		ProductIntWidth: '9.8',
		ProductIntDepth: '8',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Security® RAPiD® Safes offer the quickest, most dependable access to your firearm while providing unmatched security from unauthorized users using patented RFID technology.  The SQUARE-LOK™ organizing system allows gun racks (included) and other SQUARE-LOK™ accessories to be mounted in numerous configurations to maximize storage. Hornady Security LED lights, magnetic hooks, hygrometer and dehumidifiers are all compatible (sold separately). WIFI CONNECTIVITY KEEPS YOU INFORMED Keep tabs on your Ready Vault™ safe through your smartphone. Download the Hornady Security® app and receive an alert when the safe is unlocked.  FAST AND DEPENDABLE TOUCH-FREE ENTRY Patented RFID[2] technology unlocks safe faster than keypads and biometrics. Four included RFID tags including watchband tag, key fob, and two decals can be selectively programmed to open this safe and any other RAPiD® Safe you own.  ADAPTABLE STORAGE The Square-Lok™ organizing system allows gun racks (included) and other Square-Lok™ accessories to be mounted in numerous configurations to maximize storage. Hornady Security LED lights, magnetic hooks, hygrometer and dehumidifiers are all compatible (sold separately).  HEAVY-DUTY, TAMPER-PROOF CONSTRUCTION Heavy-duty steel housing and five hardened locking lugs provide confident protection of valuables. Pre-drilled mounting holes allow additional security. CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  1. IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's interior dimensions. Firearm and firearm accessories not included.  2. U.S. Patent: 9,530,266 | 10,233,687 3. U.S. Des. Pat. D786,047",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--H_ictZna--/crps0tnss65jvd2v7c0u.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--H_ictZna--/crps0tnss65jvd2v7c0u.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WZx2hoB2--/oqfrrm5i5s5rj3qcnf05.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--sP6izsJC--/pyai0qpmnl62h3dmderf.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--6xNFSgkX--/vuxnszgi6gcpgsmq4zh4.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--A-s6Oaqq--/ec42sqprfaozamgqhsjz.png',
		Videos: 'https://vimeo.com/653004386',
		Videos1: 'https://vimeo.com/582575908',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bb0099c3-9056-48c7-8c6b-9d0d2b5f5384',
		ProductID: '546547',
		ProductName: 'Full-Length 4-Die Set 480 Ruger/475 Linebaugh (.475)',
		UPC: '090255565478',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.931',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565475',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.655',
		PalletQtyBoxes: '0',
		Retail: '133.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series V Four-Die Handgun Die Sets',
		Cartridge: '475 LINEBAUGH/480 RUGER',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd71ebfd1-1ecb-4417-b705-009a61c04662',
		ProductID: '046218',
		ProductName: 'Match™ Grade Full-Length Size Die 6.5-284 Norma (.264)',
		UPC: '090255462180',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462187',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6.5-284 (NORMA)',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '71a0e64e-9993-4891-b78a-8a7d90ef76ce',
		ProductID: '2830',
		ProductName: '7mm .284 154 gr InterLock® SP',
		UPC: '090255228304',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.328',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255228301',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.92',
		PalletQtyBoxes: '540',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.433',
		SectionalDensity: '0.273',
		OAL: '1.223',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '154',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--smmekeU7--/9bcfaca6e995fe9bdee76baae18865ca0206d662.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9488e145-b7f4-406c-9f0d-a945434df27b',
		ProductID: '546354',
		ProductName: 'Full-Length 2-Die Set 303 Sav (.308)',
		UPC: '090255563542',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563549',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '303 SAVAGE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '08b7b65d-3df4-482b-80fd-27971a13d0b5',
		ProductID: '27190',
		ProductName: '6.8mm/270 Cal 100 gr GMX®',
		UPC: '090255271904',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.803',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255271901',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.12',
		PalletQtyBoxes: '1440',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.274',
		SectionalDensity: '0.186',
		Caliber: '6.8MM/270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'GMX®',
		BulletWeightGrain: '100',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nuoce1Tr--/20d2d79e9fd42df03181b2f646d0cd2164e1cec2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8820aef-b25c-4e61-a9ae-39bcab6ab43d',
		ProductID: '80881',
		ProductName: '300 Blackout 135 gr FTX®',
		UPC: '090255808810',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.775',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255808817',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '7.75',
		PalletQtyBoxes: '1680',
		Retail: '45.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.274',
		MuzzleVelocity: '2085',
		MuzzleEnergy: '1303',
		SectionalDensity: '0.203',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--lHD4ep2Y--/r55iub1e61oxuqtcmu3i.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f7c686e5-7c50-4cc6-a5b4-7919eab4e2e1',
		ProductID: '26209',
		ProductName: '6.5mm .264 129 gr InterBond®',
		UPC: '090255262094',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.951',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255262091',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '48.775',
		PalletQtyBoxes: '900',
		Retail: '92.99',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.264',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '129',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gN0dJpRB--/dd0a3a56c1e833b72ba34680437109e771717959.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ae933e3-6736-4dce-8c58-e4ed3fc3feaa',
		ProductID: '044178',
		ProductName: 'Taper Crimp Seater Die 10mm/40S&W',
		UPC: '090255441789',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441786',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp/Seater Dies For Series II Three-Die Taper Crimp Handgun Die Sets',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Taper Crimp Die features intuitive design that allows seating and taper crimping to be completed in one step, eliminating the need for a separate taper crimp die.  Precise control is achieved by the use of the Taper Crimp Adjustment Screw that easily adjusts the amount of crimp on the cartridge without changing bullet seating depth or loosening the lock ring. Hornady® Taper Crimp dies feature an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® TAPER CRIMP DIE COMES COMPLETE WITH: Hornady® Taper Crimp Die and Sure-Loc™ Lock Ring 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--aROXT8VW--/syxt7m7qvlomyagtd9du.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ab46c57c-6973-4955-abdc-8c5dfc4ae8e1',
		ProductID: '392164',
		ProductName: 'Collet #11 .410 Cal',
		UPC: '090255921649',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921646',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.41',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--fIqZWTBe--/fab0b455c76d32fb111e5f4e24247f1a8ac2272f.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '877f9cc6-ae13-46fb-b0d4-fcbfe064f4a2',
		ProductID: '261104',
		ProductName: '6.5mm .264 120 gr CX™',
		UPC: '090255719482',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.952',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719489',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '23.8',
		PalletQtyBoxes: '900',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.428',
		SectionalDensity: '0.246',
		OAL: '1.403',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'CX™',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--CG-EqqAm--/c6iesqow2ee4z7h41mnu.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c05c35e7-a1a3-4eee-8723-56229d21e1bf',
		ProductID: '046048',
		ProductName: 'Neck Size Die 6.5mm Short (.264)',
		UPC: '090255460483',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.504',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460480',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '87b7075a-9eeb-4b01-8278-52bc147d0add',
		ProductID: '95432',
		ProductName: 'Keypad Vault',
		UPC: '090255954326',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '14',
		ShelfDepth: '10.5',
		Weight: '6.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255954323',
		CartonHeight: '11.500',
		CartonWidth: '15.250',
		CartonDepth: '23.750',
		CartonWeight: '31.75',
		PalletQtyBoxes: '140',
		Retail: '136.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Specialty Gun Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.6',
		ProductExtWidth: '12',
		ProductExtDepth: '8.3',
		ProductWeight: '4.6',
		ProductIntHeight: '2.4',
		ProductIntWidth: '11.5',
		ProductIntDepth: '6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--LhA-OBvR--/gmnncnatbzgiyc6gpzrg.pdf',
		ProductDescription:
			'Improved keypad eases code programming for maximum security while the durable 16-gauge steel housing wards off pry attempts. Interior light makes identifying valuables a breeze. Programmable 4 to 6 digit keypad code ensures optimum security for handguns and valuables. Durable 16-gauge steel housing wards off pry attempts. Interior light makes locating valuables a breeze. Premium foam interior cradles and protects valuable contents. California Department of Justice approved. Two barrel keys provide backup entry method. Requires four AAA batteries (not included). Pre-drilled for easy mounting. Audible and visible systems indicate low battery level.  Fits 1911 size pistols and 4-inch revolvers.  Exterior Dimensions: 12"H x 8.3"W x 2.6"D Interior Dimensions: 11.5”H x 6.0”W x 2.4”D CALIFORNIA RESIDENTS  WARNING: This product can expose you to DI(2-Ethylhexyl) Phthalate, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--WPWdtKzl--/gfcnuorx78uxnjqnx9db.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--WPWdtKzl--/gfcnuorx78uxnjqnx9db.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--pSInZNLQ--/vf2nsfetxt5xnnslff6r.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--DWBzeBpX--/lwpirgdxfphsjvtfttm3.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--RnQ0a1pR--/mwhygwzjjsp9fgoqhtgz.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--CdNcSb8Z--/k5jcpnrrrjmm0w17krth.png',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '98743691-5853-498e-8e56-d2b2b8184fc5',
		ProductID: '046260',
		ProductName: 'Match™ Grade Full-Length Size Die 6.5X47 Lapua (.264)',
		UPC: '090255462609',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462606',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6.5X47 LAPUA',
		Caliber: '6.5MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b8d713d9-59a9-40e6-bc00-4f744e6aeb28',
		ProductID: '9132',
		ProductName: '40 S&W 155 gr XTP®',
		UPC: '090255391329',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.769',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391326',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.69',
		PalletQtyBoxes: '1120',
		Retail: '33.73',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.137',
		MuzzleVelocity: '1180',
		MuzzleEnergy: '479',
		SectionalDensity: '0.138',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--maLwwq8g--/2b6594d03c1a6d8a84b2828c825808dfd36cc643.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '34541d31-c35d-443c-ba04-6b96ae0f57cd',
		ProductID: '044174',
		ProductName: 'Taper Crimp Die 475 Lin/480 Rg',
		UPC: '090255441741',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.394',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441748',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92d854ad-ea77-4648-9403-9f485cc95416',
		ProductID: '397101',
		ProductName: 'Seating Stem 25 Cal ELD® Match™',
		UPC: '090255971019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.500',
		ShelfWidth: '1.875',
		ShelfDepth: '1.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971016',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		SectionalDensity: '0.29',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '134',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23298477-354d-4953-8391-d21e5a572cc1',
		ProductID: '8605B',
		ProductName: '223 Remington Unprimed Cases',
		UPC: '090255697438',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '47.234',
		WeightUOM: 'LB',
		CaseQty: '3500',
		CartonUCC: '10090255697435',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '165319.0',
		PalletQtyBoxes: '154000',
		Retail: '0.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '983ce86d-15ad-4458-9236-e993dea9bfd0',
		ProductID: '99156',
		ProductName: 'Hornady® Frisbee Dog Toy',
		UPC: '090255991567',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '12',
		ShelfDepth: '12',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '36',
		CartonUCC: '10090255991564',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '21.6',
		PalletQtyBoxes: '0',
		Retail: '18.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--F_tQlHoe--/fzo4dns9jgoyzwz3mvec.png',
		DateLastModified: '2024-03-05 07:25:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '99a8e50f-8a32-4908-9b9f-4ffd0e11c734',
		ProductID: '4500',
		ProductName: '45 Cal .458 300 gr HP',
		UPC: '090255245004',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.309',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245001',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.635',
		PalletQtyBoxes: '540',
		Retail: '39.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.197',
		SectionalDensity: '0.204',
		OAL: '0.8',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'HP INTERLOCK®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Yd4JAGSK--/88f858538a3e5d1db986a82c354f41694a4282be.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4915f686-5232-438e-b905-f823d6f6cbe2',
		ProductID: '397121',
		ProductName: 'Seating Stem 50 Cal FTX® 300 Gr',
		UPC: '090255971217',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.049',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971214',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.49',
		PalletQtyBoxes: '0',
		Retail: '7.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74303a7e-d85d-4fff-b0b3-a95bac7ef17b',
		ProductID: '90926',
		ProductName: '45 Auto +P 220 gr FlexLock® Critical Duty®',
		UPC: '090255909265',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909262',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '10.0',
		PalletQtyBoxes: '1120',
		Retail: '42.44',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.18',
		MuzzleVelocity: '975',
		MuzzleEnergy: '464',
		SectionalDensity: '0.155',
		Cartridge: '45 AUTO+P',
		PressureRating: '+P',
		Caliber: '45 CAL',
		BulletDiameter: '0.45',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '220',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--0ssOAKtB--/c72018eb15e167c301bdcab7a1b92d8ab018e8c6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eea3b9d4-aeaf-44a2-9d41-73846c1e0513',
		ProductID: '75281',
		ProductName: 'Snapsafe® Lock Box Cable W/Padlock (2 Pack)',
		UPC: '842631100168',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '7',
		ShelfDepth: '1',
		Weight: '0.963',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100165',
		CartonHeight: '3.500',
		CartonWidth: '7.000',
		CartonDepth: '12.000',
		CartonWeight: '4.815',
		PalletQtyBoxes: '1080',
		Retail: '11.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '20',
		MasterPackUCC: '30842631100169',
		MasterPackHeight: '8.000',
		MasterPackWidth: '13.000',
		MasterPackDepth: '14.500',
		MasterPackWeight: '19.26',
		ProductDescription:
			'These cable padlocks prevent firearm operation when properly secured through the receiver and/or magwell. Fits most handguns, rifles and shotguns Two solid steel locks, keyed alike Two-pack comes with four keys Protective PVC cable covers',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZAhJ5pZC--/eoyppp8rbayjzowgtbv6.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9DZtYcJd--/rchq6xgidx8mudbddddp.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--odBu449Y--/qafch2lkhq7lcylscleb.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--fZ0w0Gc2--/wvbmiorw0qb8wxvgyywe.jpg',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb1da1c1-05fa-476a-9f3e-998632c3d232',
		ProductID: '392629',
		ProductName: 'Shell Plate #29 Lock-N-Load®AP™ & Projector',
		UPC: '090255926293',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926290',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.66',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '99920297-6b43-4c29-9efe-6cde5d67cfab',
		ProductID: '390957',
		ProductName: 'Trimer Pilot #15 .358',
		UPC: '090255909579',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909576',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '35 CAL',
		BulletDiameter: '0.359',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VHUq49Cb--/n7jz1fo33rcn5e5zrtek.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6fcb09be-d51c-4c5d-a23a-b968c9c707b8',
		ProductID: '8269',
		ProductName: '500 Nitro Express 3" 570 gr DGS® Dangerous Game™ Series',
		UPC: '090255382693',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '3.092',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382690',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '18.552',
		PalletQtyBoxes: '396',
		Retail: '303.52',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2120',
		MuzzleEnergy: '5688',
		SectionalDensity: '0.313',
		Cartridge: '500 NITRO EXP 3"',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		BulletName: 'DGS®',
		BulletWeightGrain: '570',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6RWVZ2yL--/b4cee4977ca13856b94a13fcf9c85fb96342cb4a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:47:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a2e79a0a-8fc9-436f-941f-75ccc6d83654',
		ProductID: '86381',
		ProductName: '280 Ackley Improved Unprimed Cases',
		UPC: '090255863819',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255863816',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.0',
		PalletQtyBoxes: '200',
		Retail: '72.91',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '986d5da1-2ceb-471b-9696-fb839fc36bc2',
		ProductID: '90216',
		ProductName: '9mm +P Luger 124 gr FlexLock® Critical Duty®',
		UPC: '090255902167',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.760',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902164',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.6',
		PalletQtyBoxes: '1120',
		Retail: '41.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.165',
		MuzzleVelocity: '1175',
		MuzzleEnergy: '380',
		SectionalDensity: '0.141',
		Cartridge: '9MM LUGER+P',
		PressureRating: '+P',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--0q8q6uM6--/2fa0979589115096c1b4c8a5c76e4793087816d8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '751b86a7-a182-41bb-95f3-9553dac4bb16',
		ProductID: '26110',
		ProductName: '6.5mm .264 120 gr GMX®',
		UPC: '090255221107',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.952',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255221104',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '23.8',
		PalletQtyBoxes: '900',
		Retail: '50.21',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.45',
		SectionalDensity: '0.246',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'GMX®',
		BulletWeightGrain: '120',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iyftH_tV--/a865bf393fc0fc84223eda25eb9f78b0092df1fa.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b4b1f0f9-ece9-4989-9450-09588b62071f',
		ProductID: '396490',
		ProductName: 'Die Wrench',
		UPC: '090255964905',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '2.75',
		ShelfDepth: '1',
		Weight: '0.318',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255964902',
		CartonHeight: '4.500',
		CartonWidth: '6.250',
		CartonDepth: '8.250',
		CartonWeight: '3.18',
		PalletQtyBoxes: '0',
		Retail: '12.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Fits the flats of the Custom Grade™ dies spindle assembly, lock rings and die body.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AWAIIw2N--/c425588b82da67bc2899f5b22019969ffed251bf.jpg',
		DateLastModified: '2023-12-16 09:02:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '86575759-3454-41c0-970c-3609c928cbba',
		ProductID: '046201',
		ProductName: 'Full-Length Size Die 17 Rem (.172)',
		UPC: '090255462012',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.525',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462019',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '17 REM',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a7e1c0e2-9494-4d87-9ef4-0d2fb7e3f5cf',
		ProductID: '86404',
		ProductName: '7mm PRC Unprimed Cases',
		UPC: '090255864045',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255864042',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.0',
		PalletQtyBoxes: '200',
		Retail: '78.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '7MM PRC',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition. At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards. Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing. Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy. UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible. MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass. CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cdd6c224-3c99-4973-ab58-bc9292661ca4',
		ProductID: 'B270',
		ProductName: 'Lock-N-Load® 270 Wby Mag Modified Case',
		UPC: '090255704365',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704362',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '7.97',
		ParentCategory: 'Reloading',
		Cartridge: '270 WBY MAG',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'de0d25fa-41ca-47b3-b51b-25ba40e0dfbb',
		ProductID: '22240',
		ProductName: '22 Cal .224 35 gr NTX®',
		UPC: '090255200003',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.574',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255200000',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '22.96',
		PalletQtyBoxes: '1440',
		Retail: '37.71',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'NTX® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.177',
		SectionalDensity: '0.1',
		OAL: '0.725',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'NTX®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"For use in areas that restrict the use of lead. Hornady® NTX® bullets provide peerless performance with a non-traditional core material that combines accuracy, reliability and Hornady® quality for use in areas with restrictions on the use of traditional bullets.  Hornady® has made lead core bullets since 1949. Lead is, and always will be an excellent core material that provides density and hard-hitting energy to a vast array of bullets. However, there are regulations in some areas that restrict the use of lead in bullets.  The non-lead core of the NTX,® which is crafted from a frangible copper alloy, features a small space between it and the shaft of the hard polymer tip, just like the V-MAX.® This specially designed cavity allows the copper-colored tip and shaft to build up increased energy upon impact with the target before driving into the bullet's core with increased force, initiating near-instant expansion and explosive fragmentation. A phenomenal choice when a non-lead bullet is required. FEATURES: Polymer tip and streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. California compatible, lead-free.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0l_BLzy2--/93e796f7413eff6e59197a2012b14e4cd09f6db6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RqwBdfgr--/c64a41508072a4772dc23cd144ca72f678ebf2e3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--W898X6gs--/qewl7jjbryglhp8lmd1h.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--UNBGPdmG--/ocpxte2pzbrramnpp9mx.png',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b0989e14-ce7c-47f5-8497-9e3c889c8a34',
		ProductID: 'A340',
		ProductName: 'Lock-N-Load® 340 Wby Mag Modified Case',
		UPC: '090255704587',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.036',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704584',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.36',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '340 WBY MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hjJKCDna--/7a77ff02d76049059d4f6e294c18d195c2777175.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '25fc0f2b-40dc-4c52-aa8e-d95e8868fc5f',
		ProductID: '6003',
		ProductName: '32 Cal .315 Lead Balls',
		UPC: '090255260038',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.744',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255260035',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.76',
		PalletQtyBoxes: '1440',
		Retail: '13.60',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '32 CAL',
		BulletDiameter: '0.315',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c82bfde-37f9-45fa-9b3f-cdec9775d9b8',
		ProductID: '304704',
		ProductName: '30 Cal .308 165 gr CX™',
		UPC: '090255719567',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.297',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719564',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.425',
		PalletQtyBoxes: '900',
		Retail: '59.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.440',
		SectionalDensity: '0.248',
		OAL: '1.426',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--gQWRh-yJ--/a8fl6wenikddpclqqr8s.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5621702-8808-463b-9594-294202c33702',
		ProductID: '546262',
		ProductName: 'Full-Length 2-Die Set 25/06 Rem (.257)',
		UPC: '090255562620',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.467',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562627',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.335',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7cc1deb-7ed8-4da6-8c59-bba54059b2ab',
		ProductID: '324',
		ProductName: 'Lock-N-Load® 24 Insert (.243/6mm)',
		UPC: '090255704167',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704164',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5hI12eGb--/dbxd10ejshfit3eyaefd.png',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '78328c2d-e41c-4a64-9c27-53b8824c2a60',
		ProductID: '546338',
		ProductName: 'Full-Length 2-Die Set 30 Merrill (.308)',
		UPC: '090255563382',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563389',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30 MERRILL',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5b4c78e-c466-443b-a7f5-c96df82c2f57',
		ProductID: '82339',
		ProductName: '338 Win Mag 225 gr GMX Outfitter',
		UPC: '090255823394',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.733',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255823391',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.33',
		PalletQtyBoxes: '780',
		Retail: '77.25',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.470',
		SectionalDensity: '0.281',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'GMX®',
		BulletWeightGrain: '225',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--gIY4Pdcw--/aqds8oxezmniqdycwdve.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		Videos4: 'https://vimeo.com/367123667',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '462576e1-f190-4d3a-abc9-7c73391e9bcb',
		ProductID: '12458',
		ProductName: '45 Cal .454 255 gr FP Cowboy',
		UPC: '090255124583',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '7.575',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255124580',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.45',
		PalletQtyBoxes: '216',
		Retail: '69.32',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Frontier® Lead Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.117',
		SectionalDensity: '0.177',
		Caliber: '45 CAL',
		BulletDiameter: '0.454',
		BulletName: 'FP COWBOY™',
		BulletWeightGrain: '255',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--t12nV4cK--/129d3cbe7d3dbddcf34e15844b1e75cc30bf3269.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5d74c19b-a09a-487b-93dd-07ede8575463',
		ProductID: '8057',
		ProductName: '7mm-08 Rem 139 gr InterLock® SP American Whitetail®',
		UPC: '090255380576',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380573',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.0',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.392',
		MuzzleVelocity: '2840',
		MuzzleEnergy: '2489',
		SectionalDensity: '0.246',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--exOOvEtQ--/e288646c8f6c295ff216014d4570c65e01d9f0b9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '26289f85-699d-46c6-bb08-8a84c61ece8b',
		ProductID: '44105',
		ProductName: '44 Cal .430 225 gr FTX® (44 Mag)',
		UPC: '090255481051',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.386',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255481058',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '50.79',
		PalletQtyBoxes: '540',
		Retail: '59.81',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppLargeGame',
		G1BC: '0.15',
		SectionalDensity: '0.174',
		OAL: '0.85',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FTX®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--A1uSTbim--/bba91b28ec2ebd7944eb3d42a657a4d867ae8ce5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NescsW4S--/f6f08c395c2ec940bd310fa1313c12d48b417878.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--csJYg2SQ--/ztizvbercxtbpusbiwpc.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--24GgDB-4--/edtuxtcb7em33ffll97b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--8-IEe1-j--/r5kb2qjrxsdb1z7mb8yx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--R_KlzV4v--/bp4lzykm2ykrixjfdi8i.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--5-gi86pN--/fleuiowjusbv8rzydx3v.jpg',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3ad9f95-a8e3-4161-b371-ef4b4149bb41',
		ProductID: '81543',
		ProductName: '22 ARC 88 gr. ELD® Match',
		UPC: '090255815436',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.795',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815433',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '7.95',
		PalletQtyBoxes: '1400',
		Retail: '39.13',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		SectionalDensity: '0.251',
		Cartridge: '22 ARC',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '88',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets. HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets. SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity. CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy. STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ikyFH2As--/uhev5edluacg7hehfxpu.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ig8fUZrI--/o2zglbuxuty13tutbwxt.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--UKCqyswt--/mdnjryhr5n4afc7gg7xw.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--uzxbbZnD--/rwd4cybxkozc6hh4ab7w.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--AMyTTpCR--/casfhsn5lydjp9gx5jws.jpg',
		ProductImage5:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		Videos: 'https://vimeo.com/876104327',
		DateLastModified: '2024-01-08 15:23:04',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5d17aa60-d588-4ce5-9f8f-a578cd39c6df',
		ProductID: 'A65C',
		ProductName: 'Lock-N-Load® 6.5 Creedmoor Modified Case',
		UPC: '090255705133',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705130',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '276ead32-9590-4611-95a3-31cb83da40cf',
		ProductID: '594264',
		ProductName: 'Match™ Grade Bushing .264',
		UPC: '090255592641',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592648',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--T1kTp7Ir--/37f367e21b8801e4c0670b048f3e57489e90277b.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e4ef5e64-d001-4bc7-ad42-eee349cea68e',
		ProductID: '544249',
		ProductName: 'Match™ Grade 2-Die Set 6mm BR (.243)',
		UPC: '090255542493',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.570',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542490',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.85',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6MM BR REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '454b78ea-ad40-4cee-a971-905f31cb2aba',
		ProductID: '546510',
		ProductName: 'Full-Length 3-Die Set 8mm Lebel Rev (.326)',
		UPC: '090255565102',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565109',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '8MM LEBEL REVOLVER',
		Caliber: '8MM',
		BulletDiameter: '0.326',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '742dc833-97c9-4742-b986-d8f09ca5964d',
		ProductID: '544355',
		ProductName: 'Match™ Grade 2-Die Set 308 Win (.308)',
		UPC: '090255543551',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543558',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '183ec907-0db8-49e2-8ba0-4c019bb363f2',
		ProductID: '3729',
		ProductName: '375 Cal .375 390 gr A-TIP Match',
		UPC: '090255237290',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '2.63',
		ShelfDepth: '2.63',
		Weight: '1.640',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255237297',
		CartonHeight: '3.500',
		CartonWidth: '7.000',
		CartonDepth: '14.375',
		CartonWeight: '16.4',
		PalletQtyBoxes: '600',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.987',
		G7BC: '0.497',
		MinTwist: '1-11"',
		SectionalDensity: '0.396',
		OAL: '2.04',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '390',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HfIJumgM--/jyfplou6lwrptyghayzg.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '165e5abe-558d-4671-b9df-2dd6f5a725ba',
		ProductID: '80990',
		ProductName: '308 Win 165 gr. CX™ Superformance®',
		UPC: '090255809909',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.187',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809906',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.87',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.440',
		MuzzleVelocity: '2750',
		MuzzleEnergy: '2771',
		SectionalDensity: '0.248',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--powtyKK3--/bqc9m29nxp5q3vbxlupo.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'de7c1fe9-768c-46cd-a02b-9f08e3157c4d',
		ProductID: '390548',
		ProductName: 'Shell Holder #8',
		UPC: '090255905489',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.047',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905486',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.47',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '732ea1c8-8fec-4f8b-b678-022bcf438b08',
		ProductID: '046055',
		ProductName: 'Neck Size Die 270 Mag (.277)',
		UPC: '090255460551',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.463',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460558',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '65a175ed-404f-4df5-99cd-5b46db8fbb94',
		ProductID: '398509',
		ProductName: 'Lock-N-Load® Primer Pickup Tube Sm 3 Pack',
		UPC: '090255985092',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '16',
		ShelfWidth: '4',
		ShelfDepth: '0.75',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255985099',
		CartonHeight: '6.500',
		CartonWidth: '6.500',
		CartonDepth: '16.000',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '39.84',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Stocking your reloading bench with extra primer pick-up tubes will allow you to load more rounds without stopping to refill primers. Compatible with the Lock-N-Load® AP™ and Lock-N-Load® Iron Press™ *Not compatible with 1911 Auto Primer Tube Filler*',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZUJOjVud--/fthgrtqwh25w7cbsmhht.jpg',
		DateLastModified: '2023-12-16 09:02:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '55f26eda-3480-4986-b130-af48799057d3',
		ProductID: '82208',
		ProductName: '300 WSM 200 gr ELD-X® Precision Hunter®',
		UPC: '090255822083',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.630',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822080',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '16.3',
		PalletQtyBoxes: '930',
		Retail: '80.37',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.597',
		G7BC: '0.301',
		MuzzleVelocity: '2820',
		MuzzleEnergy: '3531',
		SectionalDensity: '0.301',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4ElHrDtE--/901c910f13b367bfce15b678490d0b3c0f0e8993.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00aa13c9-29d1-4f4e-a286-29480e5543e8',
		ProductID: '050130',
		ProductName: 'Lock-N-Load® Bench Rest Grade Powder Measure',
		UPC: '090255501308',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '4.5',
		ShelfDepth: '15.25',
		Weight: '3.522',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501305',
		CartonHeight: '10.000',
		CartonWidth: '11.300',
		CartonDepth: '17.300',
		CartonWeight: '35.22',
		PalletQtyBoxes: '0',
		Retail: '217.87',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'You’ll receive all the advantages of Lock-N-Load® technology with the added benefit of more precise measuring. That precision comes from a specially designed chrome-plated metering insert and a smaller metering chamber to promote more consistent and uniform filling.  The micrometer adjustment gives positive reference for metering adjustments and you can install pre-set metering units by simply pushing the button on the outside of the metering chamber. Measurements adjust from 20 to 65 grains. All moving parts have been plated for protection and long life, and the rotor requires NO lubrication.',
		ProductImage: 'http://images.salsify.com/image/upload/s--h4uBRlxQ--/cofla5v5izvnqj3clnwu.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4bd4d02c-0d0d-42c8-8e5a-87d92520a476',
		ProductID: '99213',
		ProductName: 'Hornady® Camo Shield Cap',
		UPC: '090255992137',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6at3UXPH--/dh4w11ztfoa9alpnt2ac.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e82c80de-079b-4ed3-a3df-c97105d2736a',
		ProductID: '046206',
		ProductName: 'Full-Length Size Die 20 Vartarg (.204)',
		UPC: '090255462067',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462064',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '20 VT',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6dc37db4-2b5b-4932-b851-59dfdf4e1686',
		ProductID: 'A350',
		ProductName: 'Lock-N-Load® 350 Rem Mag Modified Case',
		UPC: '090255704891',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704898',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '350 REM MAG',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--q18IJmQK--/9e37d97f5b2163e1f3df2de4c6f29ecdb04aba6b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '897c0030-1847-48a8-8f64-f50a2c20b721',
		ProductID: '594245',
		ProductName: 'Match™ Grade Bushing .245',
		UPC: '090255592450',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592457',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.245',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3bH1b5IW--/035b1cab12f1a1209021b41b54cd78b6c7f309bf.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f8339c6-447d-4cb3-8916-5566640000a8',
		ProductID: 'B764',
		ProductName: 'Lock-N-Load® 7X64mm Brenneke Modified Case',
		UPC: '090255704334',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.032',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704331',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.32',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '7X64',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f53cbf34-6bcb-4578-bf41-86bceaebe07e',
		ProductID: '26302',
		ProductName: '6.5mm .264 140 gr SST®',
		UPC: '090255263022',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.124',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255263029',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.86',
		PalletQtyBoxes: '540',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.52',
		SectionalDensity: '0.287',
		OAL: '1.403',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ckHWetou--/92becdf6897e8cd51b5bc5bd5bb930a7167f4538.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c7f81f7-b3b8-433c-84ea-20cf92e2929c',
		ProductID: '594244',
		ProductName: 'Match™ Grade Bushing .244',
		UPC: '090255592443',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592440',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.244',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Gh2H7giW--/37a2da226286bb94066c742bc4de6ff99bcebecc.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ebae086-f4eb-45f3-b95b-f95e7802251c',
		ProductID: '5050',
		ProductName: '505 Cal .505 525 gr DGX® (505 Gibbs)',
		UPC: '090255250503',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.900',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255250500',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '58.5',
		PalletQtyBoxes: '540',
		Retail: '157.67',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.27',
		SectionalDensity: '0.294',
		OAL: '1.2',
		Cartridge: '505 GIBBS',
		Caliber: '505 CAL',
		BulletDiameter: '0.505',
		BulletName: 'DGX®',
		BulletWeightGrain: '525',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady DGX (Dangerous Game eXpanding) bullet is built for controlled expansion on the toughest, most dangerous game in the world. Constructed with a tough, copper-clad steel jacket and high antimony lead core, it provided limited, controlled expansion with deep penetration and high weight retention.   Built with the same profile as corresponding DGS (Dangerous Game Solid) bullets to match point of impact, Hornady provides the perfect combination of both expanding and non-expanding bullets for any situation.  FLAT NOSE  The flat nose aids in expansion and straight penetration, reducing possible deflections.  SERRATED NOSE SECTION The serrated nose section of the jacket and the sidewall thickness profile give the ultimate combination of controlled expansion, weight retention and depth of penetration.  COPPER CLAD STEEL JACKET The thick, heavy copper clad steel jacket penetrates deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--HyiVmHTW--/f5995721ba78a38311f004273d4962d6fc653f75.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--vMYh26i1--/sx7vpfjdxfwypzpfdnfb.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1XxKorrq--/tkj9lnz6kobfgo6liphf.jpg',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b241396d-e276-4fc1-a98e-e668475510a8',
		ProductID: '480025',
		ProductName: 'Powder Baffle (2 Pack)',
		UPC: '090255840254',
		PackagedQTY: '2',
		PackagedUOM: 'BG',
		ShelfHeight: '7.5',
		ShelfWidth: '4.75',
		ShelfDepth: '1.5',
		Weight: '0.054',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255840251',
		CartonHeight: '10.000',
		CartonWidth: '5.000',
		CartonDepth: '5.000',
		CartonWeight: '0.54',
		PalletQtyBoxes: '0',
		Retail: '17.07',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shotshell Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The same baffles as included with the 366 Auto™. Prevents powder and shot from compacting or clogging.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uP3jz7X---/vcx6hzsjv2glus9q6tl9.png',
		DateLastModified: '2023-12-16 09:02:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '772d9aa0-31fe-4607-a00b-e2069dc019be',
		ProductID: 'A300W',
		ProductName: 'Lock-N-Load® 300 Wby Mag Modified Case',
		UPC: '090255704808',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.039',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704805',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.39',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '300 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pOdt9v59--/927a0c17621e52bad00b66465c48d2a04cfdedcb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d3f1f5b-b045-42cb-adcd-9d6ac7aa7ab0',
		ProductID: 'FR401',
		ProductName: '300 Blackout 125 gr FMJ Frontier',
		UPC: '090255716344',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.45',
		ShelfDepth: '3.75',
		Weight: '1.715',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255716341',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '17.15',
		PalletQtyBoxes: '1190',
		Retail: '73.00',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 300 Blackout Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.250',
		MuzzleVelocity: '2175',
		MuzzleEnergy: '1313',
		SectionalDensity: '0.188',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--M0Qht0yU--/c77e69aeff262401e00c7a9476b8ba5e7662bea6.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '55fa28d3-b42b-4950-b9c1-4bf84e17141c',
		ProductID: 'FR1415',
		ProductName: '223 Remington 55 gr HP Match  Frontier®',
		UPC: '090255712872',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '3.930',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712879',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '31.44',
		PalletQtyBoxes: '512',
		Retail: '139.75',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8mQVzAgI--/ba4ca4c8ef64ab8d50c13fa16b67051e0dd2b038.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f6488d59-6077-4765-8426-a77fd384a7c6',
		ProductID: '22416',
		ProductName: '22 Cal .224 40 gr V-MAX®',
		UPC: '090255224160',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.544',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224167',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.6',
		PalletQtyBoxes: '900',
		Retail: '74.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.2',
		SectionalDensity: '0.114',
		OAL: '0.684',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nYeVZRTL--/4e8595809807dfc11a8654bb7186cfc489297ccc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7533646b-ec3d-472f-896c-3f03af4ce67c',
		ProductID: '22252',
		ProductName: '22 Cal .224 35 gr V-MAX®',
		UPC: '090255222524',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.569',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222521',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '22.76',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.109',
		SectionalDensity: '0.1',
		OAL: '0.517',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--q0IQ1Muk--/44260e0588b4d9e3fcf29fee10624cf7147f3b49.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '99ea0401-cbbe-4398-8400-f89602938288',
		ProductID: '30190',
		ProductName: '30 Cal .308 125 gr GMX®',
		UPC: '090255301908',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.983',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255301905',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '24.575',
		PalletQtyBoxes: '900',
		Retail: '53.97',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.295',
		SectionalDensity: '0.188',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '125',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iwPnBZsI--/7181869738af3cb4b8e82ce8a5aee06c7affcd14.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f32cd0e3-98f4-42cd-91e7-3e5d631e3275',
		ProductID: '80904',
		ProductName: '308 Win 165 gr InterLock® SP American Whitetail®',
		UPC: '090255809046',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809043',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.435',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2671',
		SectionalDensity: '0.248',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime!  Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HVtaPGSp--/yg1e7xjw9czniiaeyqms.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e8475898-c3ca-42d4-9d09-2c5d639bd117',
		ProductID: '044661',
		ProductName: 'Lock-N-Load® Light Strip',
		UPC: '090255446616',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.07',
		ShelfWidth: '3.54',
		ShelfDepth: '1.57',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255446613',
		CartonHeight: '8.000',
		CartonWidth: '3.000',
		CartonDepth: '1.000',
		CartonWeight: '3.0',
		PalletQtyBoxes: '2080',
		Retail: '26.24',
		Brand: 'Hornady®',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '40',
		MasterPackUCC: '30090255446617',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '12.0',
		ProductDescription:
			'Light up your press with the Hornady® Lock-N-Load® Light Strip. With an adhesive backing, the Lock-N-Load Light Strip can be used on any press or location on your reloading bench for extra light to help eliminate shadows, making safety and quality checks easier than ever. The Lock-N-Load® Light Strip features LED lights for a long life and plugs into a standard 110V outlet or Lock-N-Load Control Panel. Eliminates shadows LED lights for long life cycle Plugs into a standard 110V outlet or Lock-N-Load Control Panel',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--dJUSzm2Y--/sh5kj9g0k4vwqqykskuk.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--dJUSzm2Y--/sh5kj9g0k4vwqqykskuk.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ax-XW54l--/ge5sszwyhbtijpqnhtys.jpg',
		Videos: 'https://vimeo.com/593420939?embedded=true&source=video_title&owner=28327899',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c0a300dd-64d5-4ab1-85fc-99b33392b941',
		ProductID: '050104',
		ProductName: 'G3-1500 Electronic Scale',
		UPC: '090255501049',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '6',
		ShelfDepth: '6',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501046',
		CartonHeight: '7.000',
		CartonWidth: '7.000',
		CartonDepth: '13.000',
		CartonWeight: '4.5',
		PalletQtyBoxes: '2520',
		Retail: '85.11',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '2',
		BatteryWattHour: '3.74',
		BatteryWeight: '23',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This compact, battery operated trickle-compatible scale offers a maximum reference measurement of 1500 grains.  Features a precision load cell with 1/10th grain accuracy and constant readout up to 500 grains, offering the flexibility to trickle powder into the pan or weigh charges, bullets or cases directly POWER: Two AAA BATTERIES (not included)',
		ProductImage: 'http://images.salsify.com/image/upload/s--GQY0eu_D--/psvxib5ng6nemhvqdtfr.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--PyrrnAwa--/zz84qiokbkxerbeukmdr.png',
		DateLastModified: '2023-12-16 08:58:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7487cd08-69c0-41ca-aad1-660db1475025',
		ProductID: '96001',
		ProductName: 'Hornady® Cordless Led Safe Light (20 Led White)',
		UPC: '090255960013',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.75',
		ShelfWidth: '3.25',
		ShelfDepth: '2.5',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255960010',
		CartonHeight: '16.000',
		CartonWidth: '3.250',
		CartonDepth: '2.500',
		CartonWeight: '2.25',
		PalletQtyBoxes: '640',
		Retail: '29.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '6',
		BatteryWattHour: '11.22',
		BatteryWeight: '69',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '0.6',
		ProductExtWidth: '13',
		ProductExtDepth: '0.7',
		ProductWeight: '0.22',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--vV74UVPr--/icfbhcmvhoyp2xxkzfyk.pdf',
		ProductDescription:
			'Twenty white LEDs provide 70 lumens of light for gun safes, closets, cabinets, drawers and corridors. With on/off/auto modes, light bar can be set to illuminate when motion is detected and shut off after 20 seconds. 20 bright LEDs provide 70 lumens of light to conveniently illuminate a large area. Ideal for gun safes, closets, cabinets, drawers and corridors. Features long-lasting LED lights. With ON/OFF/AUTO modes, the light bar can be set to illuminate when motion is detected and shuts off after 20 seconds. Easy to install with included mounting clips.  Dimensions 0.6"H x 13"W x 0.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--94KkB_Rf--/pp7gbifpayznb6d51rjw.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--z8aGze91--/vw9wnxsehshlzpnd55re.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '87c04b14-162c-46a1-8acb-54dd1b863d29',
		ProductID: '8585',
		ProductName: '458 Win 500 gr DGS® Dangerous Game™ Series',
		UPC: '090255385854',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.513',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255385851',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.078',
		PalletQtyBoxes: '396',
		Retail: '199.39',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2140',
		MuzzleEnergy: '5084',
		SectionalDensity: '0.341',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--P0kAbzKi--/5f161a774fe080d82f0657409e8c8b8750d94735.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-02-21 09:43:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9248313b-0c68-4f3f-b19f-26ab179344fc',
		ProductID: '546515',
		ProductName: 'Full-Length 3-Die Set 9mm Luger/9X21 (.355)',
		UPC: '090255565157',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.796',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565154',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.98',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '9MM LUGER/9X21',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '30138dea-eda4-4e9a-a0ba-7c3c806d2b44',
		ProductID: '046528',
		ProductName: 'Size Die 38 Spl, 357 Mag, 357 Max (.357)',
		UPC: '090255465280',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.465',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465287',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '38 SPL/357 MAG/357 REM MAX',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '184d3d34-31ae-48bf-bddf-ffb2478844bc',
		ProductID: 'C1000',
		ProductName: 'Lock-N-Load® OAL Gauge Straight',
		UPC: '090255704006',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '16.25',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.277',
		WeightUOM: 'LB',
		CaseQty: '24',
		CartonUCC: '10090255704003',
		CartonHeight: '10.000',
		CartonWidth: '11.250',
		CartonDepth: '17.250',
		CartonWeight: '6.648',
		PalletQtyBoxes: '0',
		Retail: '50.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® OAL Gauges',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® O.A.L. Gauge is universally acclaimed as the most accurate, easy-to-use and reliable method of regulating seating depth and the resulting "jump" to the rifling. For all bolt-action and single-shot firearms, or any firearm with straight-line access to the chamber. This model is preferred, as it is most precise and user friendly. Achieve precise bullet seating depth. To use the Lock-N-Load® O.A.L. Gauge, you will need a Modified Case (sold separately) to fit your firearm\'s chamber and thread it onto the gauge. These specially prepared modified cases are threaded at the case-head and have a .002" oversized neck to accept the same bullets you intend to load.  This is critical, as the Lock-N-Load® O.A.L. Gauge dimensions obtained will be accurate to .001". These results cannot be attained with competitive products, which use a simulated bullet with an arbitrary shape.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IHOCOXR4--/a2ba496fe32ce0561e237e81d258bbd312ecabef.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--tq89hFDR--/jszzp6sydb17vgh9tc0o.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--zXH6bqr_--/xevupilm2drkonvwgnmv.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Zhisw7d1--/jxvpck9rathtx1amdr2t.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--r7cLLclA--/vdcsetexniugq3fi2yxg.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4f6ee77f-5952-43d8-8fc6-5c6a9476964c',
		ProductID: '190231',
		ProductName: 'Powder Bushing 291',
		UPC: '090255192315',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.070',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192312',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.7',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6533d7f1-c9bb-472a-97e1-b554f6304c0f',
		ProductID: '391909',
		ProductName: 'Neck Turn Mandrel 20 .204',
		UPC: '090255919097',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.057',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919094',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.57',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--S5NS4dp1--/ziojvpcxjkecp1vwkbkd.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4f24500f-98aa-4913-ab21-99f10dcc278c',
		ProductID: '8640',
		ProductName: '7mm Remington Magnum Unprimed Cases',
		UPC: '090255486407',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.967',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486404',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.835',
		PalletQtyBoxes: '200',
		Retail: '78.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e63f07b1-5127-47b8-83bd-a2fe027657e6',
		ProductID: '594330',
		ProductName: 'Match™ Grade Bushing .330',
		UPC: '090255593303',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593300',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '33 CAL',
		BulletDiameter: '0.33',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GNiA0rH8--/f585bb3a22bbad288e73f5ae177401825d9e757e.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '652c1442-24f5-4166-a616-7dedf8da28a8',
		ProductID: '75909',
		ProductName: 'Snapsafe® Hygrometer',
		UPC: '842631100236',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '3.5',
		ShelfDepth: '1.5',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100233',
		CartonHeight: '6.000',
		CartonWidth: '6.000',
		CartonDepth: '7.500',
		CartonWeight: '1.5',
		PalletQtyBoxes: '1500',
		Retail: '27.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '2',
		BatteryWattHour: '3.74',
		BatteryWeight: '23',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '4.3',
		ProductExtWidth: '3.1',
		ProductExtDepth: '1.2',
		ProductWeight: '0.3',
		MasterPackQty: '60',
		MasterPackUCC: '30842631100237',
		MasterPackHeight: '18.500',
		MasterPackWidth: '12.750',
		MasterPackDepth: '15.250',
		MasterPackWeight: '18.0',
		ProductDescription:
			'Ensure the best environment for guns, accessories and other valuables in your safe or vault room. Displays current temperature and humidity and recent extremes in Fahrenheit or Celsius. Large LCD display. Fold-out stand for storage on shelf or floor. Powered by two AAA batteries (not included).',
		ProductImage: 'http://images.salsify.com/image/upload/s--AN3A6cmP--/hrjd0p0zjaxkponvnqer.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--NYX0DJGd--/zn7ubni0ixivyjtwc30j.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--o_QZ_q5l--/eu4gwu9mqykpe5g9qpza.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--4Rhre6aD--/povvdfre7aeiytpwlc0u.jpg',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '771c7282-19df-403e-a554-8ce58a6096c9',
		ProductID: '47500',
		ProductName: '475 Cal .475 325 gr XTP® Mag',
		UPC: '090255475005',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.448',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255475002',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.72',
		PalletQtyBoxes: '540',
		Retail: '59.48',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.15',
		SectionalDensity: '0.206',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '325',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'eXtreme Terminal Performance — Magnum Designed for personal defense and medium-game hunting, XTP® Mag™ bullets provide the same controlled expansion, accuracy and dependability that have made XTP® bullets a favorite among target shooters and hunters alike. But XTP® Mag™ bullets are designed to take things a step further — withstanding the higher velocities and impacts of ultra-powerful, magnum handguns while delivering even deeper penetration than standard XTP® bullets. CONTROLLED EXPANSION Precise serrations divide the XTP® Mag™ into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP® Mag™, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LeznkicO--/a3fe9f07cc16140e579b9c58ff2b073a06bdacac.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--fNEP3eEi--/c6xiskezhxjfyogooood.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--F_Cbrvpn--/tpherltglxbuacgasgkq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--Wu1gxnR3--/aubrxvxeyt2d14nfehgo.jpg',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9edbe15d-7f2c-49f4-b989-c3cdf7bf2faa',
		ProductID: '594247',
		ProductName: 'Match™ Grade Bushing .247',
		UPC: '090255592474',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592471',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.247',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pfiEI8Yu--/7d975a58d26423baa555e69cddfb52a8a0c8b6be.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bd085af7-248a-47bd-bd31-319d229c32db',
		ProductID: 'FR282',
		ProductName: '5.56 NATO 62 gr SP Frontier®',
		UPC: '090255711561',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '3.75',
		ShelfWidth: '6.453',
		ShelfDepth: '3.656',
		Weight: '4.375',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255711568',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '17.5',
		PalletQtyBoxes: '480',
		Retail: '83.75',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.264',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTSP',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WIIWJMc6--/8e430508ef88d148b26b925f501cc095c18e19b9.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e98db357-6f68-4848-ba77-5bdb781773c0',
		ProductID: '86938',
		ProductName: '500 Nitro Express 3 Unprimed Cases',
		UPC: '090255869385',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '1.172',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255869382',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.86',
		PalletQtyBoxes: '400',
		Retail: '123.51',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '500 NITRO EXP 3"',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-03-05 08:50:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4550e95d-e8d4-4bbb-97f0-112b6e5b4113',
		ProductID: '86877',
		ProductName: '500-416 Nitro Express Unprimed Cases',
		UPC: '090255868777',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868774',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.75',
		PalletQtyBoxes: '400',
		Retail: '132.65',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '500-416 NITRO EXP 3¼"',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-03-05 08:48:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ac423f60-bee0-45ac-9248-f87d1f3154cc',
		ProductID: '046301',
		ProductName: 'Full-Length Size Die 270 Win (.277)',
		UPC: '090255463019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.560',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463016',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '63f19b44-2a40-4430-b87f-cb43050b8d77',
		ProductID: '98006',
		ProductName: 'Hornady® Team Hornady® Antler Sticker',
		UPC: '090255980066',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '5',
		ShelfDepth: '6',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980063',
		CartonHeight: '0.750',
		CartonWidth: '5.000',
		CartonDepth: '6.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'MIBK',
		Prop65Warn1:
			'Warning: This product can expose you to Methyl Isobutyl Ketone (MIBK), which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red and white. Measures 5.5"x3.875"',
		ProductImage: 'http://images.salsify.com/image/upload/s--dl4zw5OV--/eid71ncrguuiafd8tien.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '816708bb-e324-4e56-825e-e57a2db7c933',
		ProductID: '35105',
		ProductName: '35 Cal .358 200 gr FTX® (35 Rem)',
		UPC: '090255351057',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.023',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255351054',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.345',
		PalletQtyBoxes: '540',
		Retail: '69.75',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.3',
		SectionalDensity: '0.223',
		OAL: '1.115',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RFPZcGD5--/fceb3a511f75c22e2d803589b53f44f0c1ab4dc7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a36c8f5-f925-4147-ae20-ff32fb4b47cc',
		ProductID: '020050',
		ProductName: 'Crimp Starter Assembly Package 12 Ga',
		UPC: '090255020502',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.159',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255020509',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '25.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Crimp Starter Assemblies',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--h9UH25nm--/r1vx89l4f0rp5rwq4yuq.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '58033853-1e6d-4e25-bb20-ac97734c83c5',
		ProductID: '399694',
		ProductName: 'Iron Press® Powder Measure Bracket',
		UPC: '090255996944',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '16.5',
		ShelfWidth: '8.5',
		ShelfDepth: '3.5',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255996941',
		CartonHeight: '4.500',
		CartonWidth: '6.500',
		CartonDepth: '12.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '26.84',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This metal bracket attaches to the Iron Press® and holds your Powder Measure in place for convenient use.',
		ProductImage: 'http://images.salsify.com/image/upload/s--vQ6cAHRZ--/wct0i385ofxp1ubkv2tp.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '391d0d3d-bc1b-42db-ab0c-3f2de5cf66bb',
		ProductID: '046361',
		ProductName: 'Full-Length Size Die 7.5 Swiss (.308)',
		UPC: '090255463613',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.569',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463610',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7.5 SWISS (7.5X55)',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8a4903c-9ad0-4beb-8c8c-eaa205dc6d5c',
		ProductID: '95909',
		ProductName: 'Hornady® Digital Hygrometer',
		UPC: '090255959093',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959090',
		CartonHeight: '4.500',
		CartonWidth: '6.750',
		CartonDepth: '9.500',
		CartonWeight: '2.0',
		PalletQtyBoxes: '1500',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '2',
		BatteryWattHour: '3.74',
		BatteryWeight: '23',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '5.125',
		ProductExtWidth: '3.25',
		ProductExtDepth: '1',
		ProductWeight: '0.29',
		MasterPackQty: '60',
		MasterPackUCC: '30090255959094',
		MasterPackHeight: '16.000',
		MasterPackWidth: '14.500',
		MasterPackDepth: '19.250',
		MasterPackWeight: '24.0',
		ProductDescription:
			'Hygrometer displays high/low for temperature and humidity in Fahrenheit or Celsius on large touchscreen display. Install quick-connect bracket on interior door or wall of safe or vault room, or use fold-out stand. Indoor thermometer and humidity sensor for safes and vault rooms. Displays high/low for both temperature and humidity in either Fahrenheit or Celsius. Large touchscreen display. Install the quick-connect bracket on interior door or wall to save shelf space and allow easy viewing and retrieval. Includes fold-out stand for convenient storage on shelf or floor of safe. Powered by two AAA batteries (not included).  Dimensions: 5 1/8" x 3 1/4" x 1" CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--VMJ5Mzdg--/c652rokvrj5bsdmiscjr.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--wR6UQnQh--/ydceyltlcukseuv6z9wi.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--u_B9KW0C--/rnh1vlj6emrz1alxdnxi.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3e2a2887-e99a-4cee-a16c-f44f310b73d5',
		ProductID: '12108',
		ProductName: '45 Cal .452 200 gr SWC',
		UPC: '090255121087',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '2.625',
		ShelfWidth: '4',
		ShelfDepth: '5.375',
		Weight: '6.029',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255121084',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '48.232',
		PalletQtyBoxes: '288',
		Retail: '34.99',
		ParentCategory: 'Bullets',
		Applications: 'AppPersonalDefense',
		G1BC: '0.07',
		SectionalDensity: '0.14',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'SWC',
		BulletWeightGrain: '200',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UXjzjFsG--/e5f33ee45b7a1a67a0c655c7db173c39c3fa423c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '538965b3-a5b6-4697-ac9f-495c7d14f670',
		ProductID: '8684',
		ProductName: '338 Lapua Magnum Unprimed Cases',
		UPC: '090255868326',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.145',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868323',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.725',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 09:00:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e8509541-69f7-44e7-b47c-c58a92f5d3ba',
		ProductID: '391932',
		ProductName: 'Neck Turn Mandrel 375',
		UPC: '090255919325',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.073',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919322',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.73',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '375 CAL',
		BulletDiameter: '0.3725',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '989a6a5c-eb3d-417a-8fd8-1ec4700d0b76',
		ProductID: '99123',
		ProductName: 'Hornady® Lock-N-Load® Bolt Ball',
		UPC: '090255991239',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '1.25',
		ShelfDepth: '3.125',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255991236',
		CartonHeight: '5.900',
		CartonWidth: '3.540',
		CartonDepth: '3.150',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This accessory enables better bolt handling for faster reloads and is easy to grip when shooting with gloves. No altering of the original bolt required. It adapts to most conventional round bolt handles.',
		ProductImage: 'http://images.salsify.com/image/upload/s--fYSyS5TN--/oskiqenwqualrf4vh4gn.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3be3ade5-4d6d-4b27-b80e-6b4f371ef526',
		ProductID: '2440',
		ProductName: '6mm .243 87 gr SP',
		UPC: '090255224405',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '3.375',
		Weight: '1.327',
		WeightUOM: 'LB',
		CaseQty: '30',
		CartonUCC: '10090255224402',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.81',
		PalletQtyBoxes: '1080',
		Retail: '30.71',
		ParentCategory: 'Bullets',
		Applications: 'AppVarmint',
		G1BC: '0.327',
		SectionalDensity: '0.21',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'SP',
		BulletWeightGrain: '87',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3x-m8xml--/2bb35ea34cb4d63d49def5f7a3016fdd5af40d80.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66961c19-7040-4420-a9c9-a6a783976556',
		ProductID: 'A221',
		ProductName: 'Lock-N-Load® 221 Rem Fireball Modified Case',
		UPC: '090255704211',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.016',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704218',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.16',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '221 REM FIREBALL',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--JlNW2Opw--/f44ef75460f080ec363fd1aec42a30c09e7934c6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f6d4c509-eba1-4c98-9828-79907de89f48',
		ProductID: '546420',
		ProductName: 'Full-Length 2-Die Set 10.3X60 (.415)',
		UPC: '090255564204',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564201',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '10.3X60R SWISS',
		Caliber: '416 CAL',
		BulletDiameter: '0.415',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a1fd373-6034-4df9-95b9-c1871a92a4e7',
		ProductID: '050068',
		ProductName: 'Lock-N-Load® Auto Charge™ Powder Manager',
		UPC: '090255500684',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '15.5',
		ShelfDepth: '6.75',
		Weight: '4.306',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255500681',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '17.224',
		PalletQtyBoxes: '96',
		Retail: '421.25',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD / DEHP',
		Prop65Chem2: 'LEAD / DEHP',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An easy-to-use keypad, combined with a large, easy-to-read backlit display, automatic and manual dispense options, trickle function, three speed settings, overcharge protection, and easy clean out, make this the single most effective powder measure on the market. Three speed settings to optimize dispense speed to powder size, shape and charge weight. 1000 gr. hopper capacity. Charge weight of up to 300 gr. +/- 0.1 gr. accuracy. Quick & easy calibration. Easy and quick powder changes and cleanup through side drain.',
		ProductImage: 'http://images.salsify.com/image/upload/s--dqiIjPD2--/iaqshxbxfzz76fgciftw.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lp4Bf0Vg--/ghqbqlkyapx3yz2o7jaa.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ae9kUhHl--/j9rgp4jjocjrfngy9mf3.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--nuMGMaoa--/phpcmeeyh6dxqspzapwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--a6HkE6UG--/ohau6dxyuqm1pzzkudjr.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--i6_0eTlN--/fpffsqqirrimibzzywvq.pdf',
		Videos: 'https://vimeo.com/145576171',
		Videos1: 'https://vimeo.com/182563666',
		DateLastModified: '2024-02-22 12:58:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '65e17edd-c459-4a5f-88dc-4cde20a9e90c',
		ProductID: '546516',
		ProductName: 'Full-Length 3-Die Set With Taper Crimp 9mm/9X21 (.355)',
		UPC: '090255565164',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565161',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.25',
		PalletQtyBoxes: '0',
		Retail: '81.17',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Taper Crimp Handgun Die Sets',
		Cartridge: '9MM LUGER/9X21',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® 3-Die Taper Crimp Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin and Decap Pin Retainer is mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.   The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Taper Crimp Seating Die that features intuitive design that allows seating and taper crimping to be completed in one step, eliminating the need for a separate taper crimp die.  Precise control is achieved by the use of the Taper Crimp Adjustment Screw that easily adjusts the amount of crimp on the cartridge without changing bullet seating depth or loosening the lock ring. Hornady® Taper Crimp dies feature an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results.   HORNADY® 3-DIE TAPER CRIMP DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • Taper Crimp Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cja6tvEo--/s5vomxew87obdcclrxwr.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--aROXT8VW--/syxt7m7qvlomyagtd9du.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd746a9d2-bc92-44db-8fb8-54104b70c53a',
		ProductID: '81621',
		ProductName: '6.5 PRC 143 gr ELD-X® Precision Hunter®',
		UPC: '090255816211',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.380',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255816218',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '13.8',
		PalletQtyBoxes: '930',
		Retail: '69.45',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.625',
		G7BC: '0.315',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '2782',
		SectionalDensity: '0.293',
		Cartridge: '6.5 PRC',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '143',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kMC5Ragf--/994bb46d44a2561d10375bab23e0e174d995a3cd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		Videos3: 'https://vimeo.com/242146237',
		Videos4: 'https://vimeo.com/248794378',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4fcf4464-c20e-4628-adc9-e01a1fd9cc72',
		ProductID: '546304',
		ProductName: 'Full-Length 2-Die Set 7-30 Waters (.284)',
		UPC: '090255563047',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563044',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7-30 WATERS',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fe9a5afe-71bb-428e-ac99-9868dacf22ee',
		ProductID: '8665',
		ProductName: '30-06 Springfield Unprimed Cases',
		UPC: '090255486650',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.538',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486657',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.69',
		PalletQtyBoxes: '200',
		Retail: '59.79',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6b562c21-0a19-4ec8-a887-5344e42176ef',
		ProductID: '046349',
		ProductName: 'Full-Length Size Die 300 Sav (.308)',
		UPC: '090255463491',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.504',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463498',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '300 SAVAGE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '96dfc0df-5d32-41d9-801c-7c4c180c29cc',
		ProductID: '390568',
		ProductName: 'Shell Holder #28',
		UPC: '090255905687',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905684',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'abbb4304-9b9b-4492-825b-8b0846ff558b',
		ProductID: '190122',
		ProductName: 'Shot Bushing 1 3/8 oz',
		UPC: '090255191226',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191223',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '40d6d62a-23d4-4aae-95b8-01836308519e',
		ProductID: '91267',
		ProductName: '10mm Auto 135 gr MonoFlex Handgun Hunter',
		UPC: '090255912678',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.721',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255912675',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.21',
		PalletQtyBoxes: '1120',
		Retail: '52.19',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		MuzzleVelocity: '1315',
		MuzzleEnergy: '518',
		SectionalDensity: '0.121',
		Cartridge: '10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--cC4lx6RS--/dlylmpf7w0bmeauu2oxl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5bbed3dd-7a64-4f0a-9774-34fb55c77c02',
		ProductID: '82747',
		ProductName: '45-70 Government 325 gr FTX® LEVERevolution®',
		UPC: '090255827477',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.753',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827474',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '17.53',
		PalletQtyBoxes: '930',
		Retail: '60.59',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.23',
		MuzzleVelocity: '2000',
		MuzzleEnergy: '2886',
		SectionalDensity: '0.221',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'FTX®',
		BulletWeightGrain: '325',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZUqu6mQD--/a64d42642fb9ffcc8b6744c45f7c394e70141c5b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2024-01-08 15:23:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd222cf2e-daa4-41c5-a02f-2fe09d70f10f',
		ProductID: '80543',
		ProductName: '270 Win 130 gr SST® Superformance®',
		UPC: '090255805437',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.209',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805434',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.09',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.46',
		MuzzleVelocity: '3200',
		MuzzleEnergy: '2956',
		SectionalDensity: '0.242',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IfjpdN-D--/6ac39f988c796616c6cee8598fbb4725efac15bb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '719d9d12-af54-423d-93cf-03b789f6e9d4',
		ProductID: '046338',
		ProductName: 'Match™ Grade Full-Length Size Die 300 PRC (.308)',
		UPC: '090255463385',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463382',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5ef19069-b5a5-4281-85c0-ac4699eb1617',
		ProductID: '81093',
		ProductName: '30-06 Springfield 150 gr SST® Superformance®',
		UPC: '090255810936',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.270',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255810933',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.7',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		MuzzleVelocity: '3080',
		MuzzleEnergy: '3159',
		SectionalDensity: '0.226',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZS1wK1Pi--/5dae1c1caba7c9cb7b29a222c227e89a856eb26c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e31920e1-7313-45f8-a81a-83f706aba9da',
		ProductID: '190164',
		ProductName: 'Powder Bushing 459',
		UPC: '090255191646',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.061',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191643',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.61',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e33b125-03de-4d60-be82-8f3ad8083eb3',
		ProductID: '75904',
		ProductName: 'Snapsafe® Dehumidifier Rod 18"',
		UPC: '851529004631',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '24',
		ShelfWidth: '4.5',
		ShelfDepth: '1.25',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004638',
		CartonHeight: '4.250',
		CartonWidth: '4.500',
		CartonDepth: '24.125',
		CartonWeight: '3.25',
		PalletQtyBoxes: '600',
		Retail: '30.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD / DEHP',
		Prop65Chem2: 'LEAD / DEHP',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '18',
		ProductExtWidth: '0.9',
		ProductExtDepth: '0.9',
		ProductWeight: '0.5',
		MasterPackQty: '40',
		MasterPackUCC: '30851529004632',
		MasterPackHeight: '20.000',
		MasterPackWidth: '11.750',
		MasterPackDepth: '25.125',
		MasterPackWeight: '26.0',
		ProductDescription:
			'Eliminate moisture and prevent rust and corrosion with electric dehumidifier rods available in three sizes. Ideal for gun safes, closets and small enclosures, the rods come with snap-on feet and should be positioned on a level surface. Available in three sizes!  Minimize condensation, mildew, humidity and dampness. Provides permanent, maintenance-free solutions for humidity control in gun safes, closets and small enclosures. Prevents rust and corrosion.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uN3CtPt9--/tmp3qo5u4bswobcsb5pi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--43GDKQKQ--/edjqtjwrygeolb2ygiwn.jpg',
		Videos: 'https://vimeo.com/217549258',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd04d9513-39d0-4006-af87-5c456c2c89a2',
		ProductID: '190158',
		ProductName: 'Powder Bushing 432',
		UPC: '090255191585',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.062',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191582',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.62',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6126e08c-f1e6-45c9-b7f1-fae4e4762f8e',
		ProductID: '290030',
		ProductName: 'PTX™ Powder Through Expander .355',
		UPC: '090255900309',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.75',
		ShelfDepth: '1',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900306',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd12d7b64-c152-4aa7-b004-983008b77c25',
		ProductID: '546249',
		ProductName: 'Full-Length 2-Die Set 22/6mm (.224)',
		UPC: '090255562491',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562498',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '22-6MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2342c298-b20d-4704-a0e1-0eb1abf06a31',
		ProductID: '82662',
		ProductName: '450 Rigby 480 gr DGS®',
		UPC: '090255826623',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.816',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826620',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '16.896',
		PalletQtyBoxes: '396',
		Retail: '183.91',
		ParentCategory: 'Ammunition',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		SectionalDensity: '0.327',
		Cartridge: '450 RIGBY',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '480',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--FJwaaoX5--/939ddd3e4b932f74d6fdb77f30777244ae9ea447.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6cf5d45-ba5d-4100-8900-da7717e6fb88',
		ProductID: '8664',
		ProductName: '7.62 X 39 Unprimed Cases',
		UPC: '090255486643',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.990',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486640',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.95',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ff7e4f5-e191-4fde-854e-0a93c6dba4af',
		ProductID: '390752',
		ProductName: 'Small Primer Cleaner',
		UPC: '090255907520',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.021',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255907527',
		CartonHeight: '1.000',
		CartonWidth: '5.000',
		CartonDepth: '7.000',
		CartonWeight: '0.21',
		PalletQtyBoxes: '0',
		Retail: '7.88',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--1XhTOrYM--/p8kojeirym11uwiyaedm.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b938b829-926a-4088-acd2-0255e29a66dd',
		ProductID: '33201',
		ProductName: '338 Cal .338 225 gr GMX',
		UPC: '090255332018',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.740',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255332015',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '26.1',
		PalletQtyBoxes: '540',
		Retail: '62.19',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.470',
		SectionalDensity: '0.281',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'GMX®',
		BulletWeightGrain: '225',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--9x_Ji57N--/evk8oozzfvgeelxoopur.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b01e8292-59b4-4969-bc7f-1c1fa181cb28',
		ProductID: 'B7MMW',
		ProductName: 'Lnl® 7Mm Wby Mag Modified Case',
		UPC: '090255704044',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704041',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '7MM WBY MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a14930e6-7091-4ff7-ac73-7dcbfcd31f5a',
		ProductID: 'A218',
		ProductName: 'Lock-N-Load® 218 Bee Modified Case',
		UPC: '090255704143',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.014',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704140',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.14',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '218 BEE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kbx9bEtF--/11d4313955e9fb67eed834ff00ae93b02f8e04e1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9a43cb0d-a5b5-4f0a-ad0d-cc2459af67df',
		ProductID: '7120',
		ProductName: '375 Cal Gas Checks',
		UPC: '090255271201',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '0.998',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255271208',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '14.97',
		PalletQtyBoxes: '540',
		Retail: '69.93',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '375 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6590d4c7-a0b5-4b15-b9a8-607c59bbb680',
		ProductID: '35557',
		ProductName: '9mm .355 115 gr FMJ RN',
		UPC: '090255355574',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.759',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255355571',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '43.975',
		PalletQtyBoxes: '900',
		Retail: '23.41',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.14',
		SectionalDensity: '0.13',
		OAL: '0.55',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mOV6T7gN--/928c1ecabb9d5238792d29e467788cef4c9ad710.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e2a2400-1a13-475a-9486-c0e4e2be143d',
		ProductID: '95260',
		ProductName: 'TrekLite® Lock Box XXL',
		UPC: '090255952605',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.500',
		ShelfWidth: '13.000',
		ShelfDepth: '4.000',
		Weight: '4.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255952602',
		CartonHeight: '19.500',
		CartonWidth: '13.500',
		CartonDepth: '11.250',
		CartonWeight: '22.0',
		PalletQtyBoxes: '245',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '3.3',
		ProductExtWidth: '12.2',
		ProductExtDepth: '10.1',
		ProductIntHeight: '2.9',
		ProductIntWidth: '11.8',
		ProductIntDepth: '7.3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The TrekLite® Lock Box lives up to its name with groundbreaking security technology to protect your handguns and other valuables. Dual 4-Digit TSA lock offers advanced security and 10,000 user programmable codes. Protects firearms, ammo, and other valuables while traveling or at home. Constructed of advanced, impact-resistant polycarbonate for exceptional toughness. Fits up to two full-sized 1911 handguns. Durable, non-slip rubber over mold provides added impact protection and stability. Includes 1500 lb. rated security cable with patented cable connector that maximizes cargo space. Sized to fit 8.5 x 11" documents. CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  1. IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  2. U.S. Patent: 9,530,266 | 10,233,687 3. U.S. Des. Pat. D786,047',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--MS93YK48--/fqjo8imufuhcik4wtwmx.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--MS93YK48--/fqjo8imufuhcik4wtwmx.png',
		Videos: 'https://vimeo.com/638830336',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '35fdb354-6a14-45e9-a0cc-f81f4f1aaa37',
		ProductID: '546362',
		ProductName: 'Full-Length 2-Die Set 7.62 Russ (.308)',
		UPC: '090255563627',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563624',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7.62X54R',
		Caliber: '303 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a06b9dc0-f8ab-4961-a573-a2f724c4619f',
		ProductID: '046334',
		ProductName: 'Full-Length Size Die 300 PRC (.308)',
		UPC: '090255463347',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463344',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cd9207f9-9d72-4749-8cd1-348827f9dd6e',
		ProductID: '190165',
		ProductName: 'Powder Bushing 462',
		UPC: '090255191653',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.061',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191650',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.61',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd45afc3c-ecbd-4ae5-9eff-d1690e6e7f44',
		ProductID: '90000',
		ProductName: '5.7x28 40 gr. FTX® Critical Defense®',
		UPC: '090255900002',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '0',
		ShelfWidth: '0',
		ShelfDepth: '0',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900009',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '0.0',
		PalletQtyBoxes: '1120',
		Retail: '38.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Rifle Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		SectionalDensity: '0.114',
		Cartridge: '5.7X28MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FTX®',
		BulletWeightGrain: '40',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power. The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time. FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers. DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision. DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--CJezoGDm--/dohoguq3jpl058esjaxs.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--f092WcSJ--/qbjgyzgpbtawlyby79iw.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		Videos: 'https://vimeo.com/876115387',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8dcf4231-e645-47b2-b5f5-270d74fca245',
		ProductID: '399671',
		ProductName: 'Lock-N-Load® Attachment Adapter',
		UPC: '090255996715',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.5',
		ShelfDepth: '1',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255996712',
		CartonHeight: '7.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '2.5',
		PalletQtyBoxes: '0',
		Retail: '9.08',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Use with your power drill for your case prep needs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZwMOFcFr--/fc6ebc7b620fb27e193a6327705ebbae87f58047.jpg',
		DateLastModified: '2023-12-16 09:02:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f2e144de-6e9b-4193-8512-e62022faa894',
		ProductID: '26173',
		ProductName: '6.5mm .264 123 gr SST® (Grendel/LBC/Lapua)',
		UPC: '090255261738',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255261735',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.25',
		PalletQtyBoxes: '900',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.51',
		SectionalDensity: '0.252',
		OAL: '1.242',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ub8WxV4g--/6b2aa4ca617629027052c1ea1c4cc9ae990624b8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '57e262c9-bd2a-42a2-9767-759dbc0a9f30',
		ProductID: '27302',
		ProductName: '270 Cal .277 130 gr SST®',
		UPC: '090255200317',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.984',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255200314',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '49.6',
		PalletQtyBoxes: '900',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.46',
		SectionalDensity: '0.242',
		OAL: '1.242',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IAsQTtZo--/251d3c746ae782f5cb76998f6f96726e740f224e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ea03df1-aa86-4be9-a232-3c8809493b6c',
		ProductID: '546303',
		ProductName: 'Full-Length 2-Die Set 6mm Hagar (.243)',
		UPC: '090255706413',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.460',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255706410',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.3',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6MM HAGAR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00c133f8-f2eb-44d3-8e82-a0721829da64',
		ProductID: '391919',
		ProductName: 'Neck Turn Mandrel 6.5 Cal .2615',
		UPC: '090255919196',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919193',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '6.5MM',
		BulletDiameter: '0.2615',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f2f44fb9-97de-4989-82c1-9509990d6b43',
		ProductID: '046202',
		ProductName: 'Full-Length Size Die 17 Hornet (.172)',
		UPC: '090255462029',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462026',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '17 HORNET',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48e7496a-d53b-4500-9894-a789200a32e5',
		ProductID: 'A250',
		ProductName: 'Lock-N-Load® 250 Sav Modified Case',
		UPC: '090255704754',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.027',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704751',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.27',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '250 SAVAGE',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gh41YArt--/5a284b8ec2ba06ac825a0cb874456384c8e91a91.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1ab59125-4fdd-411e-8d54-da50d48daeb7',
		ProductID: '28202',
		ProductName: '7mm .284 139 gr SST®',
		UPC: '090255282023',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.131',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255282020',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.965',
		PalletQtyBoxes: '540',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.246',
		OAL: '1.27',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xbsT7Bbe--/7354fa5993f7d354d5f7c88c1bf1a572ea99bae1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b5481c2a-548f-4ab8-a6f6-9b25c9d069c7',
		ProductID: '546211',
		ProductName: 'Full-Length 2-Die Set 224 Valkyrie (.224)',
		UPC: '090255562118',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562115',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b3331c2-3dc0-447a-bb26-4df90bd943dd',
		ProductID: '044505',
		ProductName: 'Expander Die 30 Carbine (.308)',
		UPC: '090255445053',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.474',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445050',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4d598822-a5bf-4df1-ad42-740693fdc1cb',
		ProductID: '45033',
		ProductName: '45 Cal .458 480 gr DGS®',
		UPC: '090255450330',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.593',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450337',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '53.895',
		PalletQtyBoxes: '540',
		Retail: '124.04',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		SectionalDensity: '0.327',
		OAL: '1.325',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '480',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--HdWGo0ln--/9de8867e04336dfce34abe8928f00dd0f699d406.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2024-03-05 08:40:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a2cd3f78-d25d-42e4-98db-e60bde8c805d',
		ProductID: '044161',
		ProductName: 'Seater Die (.277) 270 Win Short Mag',
		UPC: '090255441611',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.586',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441618',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27f514d2-b667-49b3-b459-8ae9dd7c64e7',
		ProductID: '046396',
		ProductName: 'Full Length Die 350 Legend (.355)',
		UPC: '090255463965',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463962',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '64.08',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series V Four-Die Rifle Die Sets',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6995e46e-6939-4e1a-974f-efc83b10e732',
		ProductID: '26336',
		ProductName: '6.5mm .264 140 gr GMX',
		UPC: '090255263367',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.750',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255263364',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '68.75',
		PalletQtyBoxes: '900',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		G1BC: '0.350',
		SectionalDensity: '0.287',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'GMX®',
		BulletWeightGrain: '140',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--c4CNKcKf--/nneeafe4ommur6j9rpd8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75669c5b-c619-4b43-8692-29d786b5e66c',
		ProductID: '8720',
		ProductName: '9mm Luger Unprimed Cases',
		UPC: '090255487206',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.660',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487203',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '8.3',
		PalletQtyBoxes: '400',
		Retail: '76.08',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cd957ceb-3b4d-4bc0-9e4e-79b3e4363e6e',
		ProductID: '76001',
		ProductName: 'Snapsafe® Safe Light 20 LED White',
		UPC: '851529004785',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.75',
		ShelfWidth: '3.25',
		ShelfDepth: '2.5',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004782',
		CartonHeight: '5.250',
		CartonWidth: '4.750',
		CartonDepth: '16.500',
		CartonWeight: '2.25',
		PalletQtyBoxes: '900',
		Retail: '34.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '6',
		BatteryWattHour: '11.22',
		BatteryWeight: '69',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '0.6',
		ProductExtWidth: '13',
		ProductExtDepth: '0.7',
		ProductWeight: '0.22',
		MasterPackQty: '50',
		MasterPackUCC: '30851529004786',
		MasterPackHeight: '11.000',
		MasterPackWidth: '17.000',
		MasterPackDepth: '25.000',
		MasterPackWeight: '22.5',
		ProductDescription:
			'Ideal for gun safes, closets, cabinets, drawers and corridors, this light bar features long-lasting LED lights.  With ON/OFF/AUTO modes, the light bar can be set to illuminate when motion is detected. When set to AUTO mode, the LED light automatically turns on at night when motion is detected within a 10-foot range, and it automatically turns to standby mode at night 20 seconds after no motion is detected.  Easy to install, these lights require AAA batteries (not included).  Bracket Hardware: Attach the bracket with screw and washer, then push the body of light into the bracket. Magnetic Strip: Apply the magnetic strips on the back of the light, then attach to any metal surface. Caution: Indoor use only. Keep away from high humidity. Take out the batteries if not in use for a long time.',
		ProductImage: 'http://images.salsify.com/image/upload/s--WVPf5LT---/sizoez1qryhluc5jp3du.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cyMOduG_--/n8y26ufxucipoegdhopa.jpg',
		Videos: 'https://vimeo.com/213867224',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eab3103f-806a-4f86-84e1-e5124eb3c87f',
		ProductID: '546391',
		ProductName: 'Full-Length 2-Die Set 338/378 Wby (.338)',
		UPC: '090255563917',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563914',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '338-378 WBY MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b398c1fa-76c7-4f3b-961e-18aec3d795d6',
		ProductID: '8337',
		ProductName: '22-250 Rem 55 gr V-MAX® Varmint Express®',
		UPC: '090255383379',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.860',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383376',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.6',
		PalletQtyBoxes: '1400',
		Retail: '40.92',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		MuzzleVelocity: '3680',
		MuzzleEnergy: '1654',
		SectionalDensity: '0.157',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2vYAiN5u--/b4b5a4bcb0ca2ab3e1b7d42c6deef67bb4f22e22.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ec1fd91-6238-441a-957a-cf3ce0d6cac3',
		ProductID: '82334',
		ProductName: '375 H&H Magnum 300 gr DGX® Bonded',
		UPC: '090255823349',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.050',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823346',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '396',
		Retail: '138.33',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.275',
		MuzzleVelocity: '2530',
		MuzzleEnergy: '4263',
		SectionalDensity: '0.305',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--HCPmraQc--/37227855dc96a47310f727556ca41b3be9f6aa4c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4224b93d-899d-4bd2-8375-fe7c803f7cf7',
		ProductID: '490001',
		ProductName: 'Tube Hopper 2 Ft',
		UPC: '090255900019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '2.25',
		ShelfDepth: '24',
		Weight: '0.396',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '2.250',
		CartonWidth: '2.250',
		CartonDepth: '24.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '29.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shotshell Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"With nearly twice the volume of our standard hoppers, you'll turn out more reloads between refills of your shot.",
		ProductImage: 'http://images.salsify.com/image/upload/s--cVV16iXS--/xvlmcoi4zdge7mv52ic7.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '47a3c384-5991-46ae-a12e-cb28577eb7ac',
		ProductID: 'FR280',
		ProductName: '5.56 NATO 62 gr SP Frontier®',
		UPC: '090255711554',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.588',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711551',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '14.7',
		PalletQtyBoxes: '4500',
		Retail: '13.52',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.264',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTSP',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'ORIENTED',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kjXbuDt4--/5eafe1f79465c3ea85cec9ff71b18bb0475626ca.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eca4feab-7908-4b8a-9bbd-c7bc7162c7b4',
		ProductID: '8658',
		ProductName: '30-378 Weatherby Magnum Unprimed Cases',
		UPC: '090255486582',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.160',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486589',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '5.8',
		PalletQtyBoxes: '400',
		Retail: '57.28',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '30-378 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '32971580-9b25-48c5-a2e8-85c4b6559139',
		ProductID: '546582',
		ProductName: 'Full-Length 3-Die Set 45 Colt (.452)',
		UPC: '090255565829',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.675',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565826',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.375',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f6f977f3-8f76-4924-8621-af6b933ce8c5',
		ProductID: '823314',
		ProductName: '375 H&H Mag 250 gr CX™ Outfitter',
		UPC: '090255719918',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255719915',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.1',
		PalletQtyBoxes: '396',
		Retail: '117.73',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.403',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '4047',
		SectionalDensity: '0.254',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'CX™',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Tuu4LJZE--/efr5yockjlqkxtzrcvkq.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7edc65e8-21bf-4f88-81b2-f2da5eb15b52',
		ProductID: '594284',
		ProductName: 'Match™ Grade Bushing .284',
		UPC: '090255592849',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592846',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--onrUg-v_--/318bc609989a89f32fb2d624590fa2d5883a60e7.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3af3266d-fee6-4189-94f2-0d91f58d8e57',
		ProductID: '2267B',
		ProductName: '22 Cal .224 55 gr FMJ-BT with cannelure',
		UPC: '090255622676',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '48.273',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255622673',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '289638.0',
		PalletQtyBoxes: '270000',
		Retail: '0.12',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		OAL: '0.735',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '64909',
		MasterPackUCC: '30090255622677',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '3133352.157',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YKqIkYCi--/haleg0vggquwzrcksimo.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f2b08ba-fdae-44f5-a8fe-a6794473d6bc',
		ProductID: '050076',
		ProductName: 'Lock-N-Load® Concentricity Tool',
		UPC: '090255500769',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '12',
		ShelfDepth: '6',
		Weight: '3.583',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '4.500',
		CartonWidth: '12.000',
		CartonDepth: '6.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '211.67',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Measuring Devices',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Lead / Toluene',
		Prop65Chem2: 'Lead / Toluene',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This tool identifies and eliminates bullet runout (or wobble). Just place ammunition in the tool, roll it, identify runout and use the dial indicator thumbscrew to adjust. Provides improved accuracy for handloaders, and can be used to true up factory ammo too.',
		ProductImage: 'http://images.salsify.com/image/upload/s--9om8hvDt--/h2q6vca7oc2otd4ivjso.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ecf3b22a-52a8-4cc0-9c82-2510d3d6d4b0',
		ProductID: '391915',
		ProductName: 'Neck Turn Mandrel 25 Cal .2545',
		UPC: '090255919158',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.063',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919155',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.63',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '25 CAL',
		BulletDiameter: '0.2545',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20531403-f98c-42b3-ac4b-54867f061e1c',
		ProductID: '050071',
		ProductName: 'Micrometer',
		UPC: '090255500714',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.625',
		ShelfWidth: '5.75',
		ShelfDepth: '1.125',
		Weight: '0.623',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500711',
		CartonHeight: '6.000',
		CartonWidth: '6.000',
		CartonDepth: '6.000',
		CartonWeight: '6.23',
		PalletQtyBoxes: '0',
		Retail: '40.00',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--xmdPvPmC--/up5iufyd21ke6e1x3s9q.pdf',
		ProductDescription:
			'Calipers are good for measuring down to .001", but for actual bullet diameter for 1/10th of .001", you MUST use a micrometer. Also useful for checking expanders and any place an EXACT measurement is a necessity.',
		ProductImage: 'http://images.salsify.com/image/upload/s--03hBWXBB--/pbaxq4ruqagsj9cpgtcw.jpg',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f4f2b776-2ef0-45f6-ac70-ff127e5ddf60',
		ProductID: '8661B',
		ProductName: '308 Winchester Unprimed Cases',
		UPC: '090255600438',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '49.005',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '98010.0',
		PalletQtyBoxes: '88000',
		Retail: '0.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a90a5ae1-d116-4509-8df0-a8e62a3435b9',
		ProductID: '22831',
		ProductName: '22 Cal .224 80 gr ELD® Match',
		UPC: '090255228311',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255228318',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '30.75',
		PalletQtyBoxes: '900',
		Retail: '39.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.485',
		G7BC: '0.244',
		MinTwist: '1-8"',
		SectionalDensity: '0.228',
		OAL: '1.155',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ti-ybgZ2--/9aeee47056d3f7ca1afef0da4bcc0df9d9bde3b4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e5a18956-905d-4593-bc98-37477f4c53da',
		ProductID: '046281',
		ProductName: 'Full-Length Size Die 6.5-06 (.264)',
		UPC: '090255462814',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462811',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5-06',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f70b0317-41f3-4a97-859a-9fed2e5eb987',
		ProductID: '45201',
		ProductName: '45 Cal .452 250 gr FTX® (450 Bushmaster)',
		UPC: '090255452013',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.917',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255452010',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.925',
		PalletQtyBoxes: '900',
		Retail: '51.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.21',
		SectionalDensity: '0.175',
		OAL: '0.947',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'FTX®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SlnDfrWp--/b246110a4194837d9e229498f4ef78e105a39c8b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f194d8a0-a511-4960-926c-3c0fc83dccfb',
		ProductID: '8749',
		ProductName: '44 Special Unprimed Cases',
		UPC: '090255487497',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.768',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487494',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.84',
		PalletQtyBoxes: '200',
		Retail: '70.65',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '44 SPL',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ffe23ba5-58e0-4a08-866b-5b9f368fc74f',
		ProductID: '45218',
		ProductName: '45 Cal .452 225 gr FTX® (45 Colt)',
		UPC: '090255452181',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.365',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255452188',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '50.475',
		PalletQtyBoxes: '540',
		Retail: '59.81',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppLargeGame',
		G1BC: '0.145',
		SectionalDensity: '0.157',
		OAL: '0.805',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'FTX®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--A1uSTbim--/bba91b28ec2ebd7944eb3d42a657a4d867ae8ce5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--JGfrxU5Q--/55e0f3f6b176a88899d9b5c212c21693917fbf97.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--csJYg2SQ--/ztizvbercxtbpusbiwpc.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--24GgDB-4--/edtuxtcb7em33ffll97b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--8-IEe1-j--/r5kb2qjrxsdb1z7mb8yx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--R_KlzV4v--/bp4lzykm2ykrixjfdi8i.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--5-gi86pN--/fleuiowjusbv8rzydx3v.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9cd299c2-da59-43d9-a367-55eabccc9620',
		ProductID: '546216',
		ProductName: 'Full-Length 2-Die Set 22 PPC (.224)',
		UPC: '090255562163',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562160',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '22 PPC',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c5aa2f7-97ca-4a34-84d3-1515c28d0338',
		ProductID: '81362',
		ProductName: '257 Wby Mag 90 gr GMX Outfitter',
		UPC: '090255813623',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.330',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255813620',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '13.3',
		PalletQtyBoxes: '780',
		Retail: '81.81',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.465',
		SectionalDensity: '0.195',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'GMX®',
		BulletWeightGrain: '90',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--lCtrBYo8--/zivotcgrqfht9vsvnyy9.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		Videos4: 'https://vimeo.com/367123667',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27a25bbb-4167-4b7a-bb75-025f0514f003',
		ProductID: '546344',
		ProductName: 'Full-Length 2-Die Set 30/40 Krag (.308)',
		UPC: '090255563443',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563440',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30-40 KRAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2dad0b95-db9d-475f-854c-8725367f23bd',
		ProductID: '8640B',
		ProductName: '7mm Remington Magnum Unprimed Cases',
		UPC: '090255600711',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '40.491',
		WeightUOM: 'LB',
		CaseQty: '1200',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '48589.2',
		PalletQtyBoxes: '52800',
		Retail: '0.78',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfc8cf0d-63e7-40d2-899b-ad4a4a50d55e',
		ProductID: '050171',
		ProductName: 'Lock-N-Load® Power Case Prep Large Caliber OD Deburr',
		UPC: '090255501711',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2.25',
		ShelfDepth: '1',
		Weight: '0.125',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501718',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '1.25',
		PalletQtyBoxes: '0',
		Retail: '40.21',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Chamfer the mouth of your cartridge case. Large size, 45+ Cal. Outside Diameter. Threaded (8-32) for use in products like the Case Prep Trio or the Power Case Prep Center.',
		ProductImage: 'http://images.salsify.com/image/upload/s--3pA7_yyh--/w4rxds6no363gdtfq0fc.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ff269bb-b826-4926-a0ba-58046b056a73',
		ProductID: '90700',
		ProductName: '44 Special 165 gr FTX® Critical Defense®',
		UPC: '090255907001',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255907008',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1120',
		Retail: '38.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.125',
		MuzzleVelocity: '900',
		MuzzleEnergy: '297',
		SectionalDensity: '0.127',
		Cartridge: '44 SPL',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FTX®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--MgNH5Lay--/836a07d0bdbbdf1f92a83afbd03e1e13357ac328.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e6138ed2-7a64-4999-8c9b-43552ac0b91b',
		ProductID: '594336',
		ProductName: 'Match™ Grade Bushing .336',
		UPC: '090255593365',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593362',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '338 CAL',
		BulletDiameter: '0.336',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Qip4ljLR--/41255ea904d71a7b90369a8872d5f760c48013d9.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '68484a8c-27a1-4eee-8bdd-820e1ed4a309',
		ProductID: '546389',
		ProductName: 'Full-Length 2-Die Set 338 Ultra Mag (.338)',
		UPC: '090255563894',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.514',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563891',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.57',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '338 REM ULTRA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '689c51b8-5342-40d5-bb1b-017e6bccb85a',
		ProductID: '391913',
		ProductName: 'Neck Turn Mandrel 6mm .2395',
		UPC: '090255919134',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919131',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '6MM',
		BulletDiameter: '0.2395',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '21c8838e-4cc2-4900-bcfa-b178930553ed',
		ProductID: '81202',
		ProductName: '30-40 Krag 180 gr SP Custom',
		UPC: '090255812022',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.290',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255812029',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.9',
		PalletQtyBoxes: '1400',
		Retail: '62.41',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.425',
		MuzzleVelocity: '2430',
		MuzzleEnergy: '2360',
		SectionalDensity: '0.271',
		Cartridge: '30-40 KRAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--7UXvOgDb--/e20e93090626901184708e76d4c0ae6539a9d1a3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '288f3b78-f561-4c5d-9ed1-2036d71c53bc',
		ProductID: '823394',
		ProductName: '338 Win Mag 225 gr. CX™ Outfitter®',
		UPC: '090255719895',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.733',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719892',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.33',
		PalletQtyBoxes: '780',
		Retail: '82.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.490',
		MuzzleVelocity: '2800',
		MuzzleEnergy: '3917',
		SectionalDensity: '0.281',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'CX™',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZrUAzuaN--/qdfgin8rerqxnkic6h3w.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '871402e8-f95d-4063-9bed-27cf77ef4b2a',
		ProductID: '390541',
		ProductName: 'Shell Holder #1',
		UPC: '090255905410',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905417',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2b87c4c-0a35-4f67-9851-591469a165f0',
		ProductID: '99138',
		ProductName: 'Blaze Orange Hunting Vest',
		UPC: '090255991383',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.75',
		ShelfWidth: '7',
		ShelfDepth: '12',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '16.99',
		ParentCategory: 'Shop',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most. Machine wash cold do not bleach, tumble dry low.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--xoj8XhR7--/f4r4ywginj7h368ap41e.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--xoj8XhR7--/f4r4ywginj7h368ap41e.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cffd6234-18da-46f4-aec3-8d00e976a6ee',
		ProductID: '45054',
		ProductName: '45 cal .458 500 gr DGX® Bonded',
		UPC: '090255450545',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.670',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450542',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.05',
		PalletQtyBoxes: '540',
		Retail: '125.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		SectionalDensity: '0.341',
		OAL: '1.36',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--f06LCm1d--/d3cd212567594c906b41fc0a307c81f629ce0bb6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '40f16097-138a-4eda-8919-77b1ccc69527',
		ProductID: '594338',
		ProductName: 'Match™ Grade Bushing .338',
		UPC: '090255593389',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593386',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--eoa-LTrJ--/c9776aca5bddf95349c7742f6c9751989ec67275.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7f56e6de-d432-476e-8283-970e1f1a86eb',
		ProductID: '6688',
		ProductName: 'Lock-N-Load® Blackpowder FPB® EZ-Loader',
		UPC: '090255166880',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '1.5',
		ShelfDepth: '6',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255166887',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '8.59',
		ParentCategory: 'Muzzleloading',
		BulletName: 'FPB®',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady Blackpowder EZ-Loader makes bullets "straighten up and fly right" in muzzleloader guns without a false muzzle. This handy guide helps seat FPB projectiles so they start straight in the barrel. Put the EZ-Loader on the end of your muzzle, add the bullet, and start it with your ball starter or ramrod.',
		ProductImage: 'http://images.salsify.com/image/upload/s--fSDWz-Dx--/niwxgy8zsqgifughnxcd.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dbf4c0c6-54ec-465e-80e6-ecff268460b4',
		ProductID: '3077',
		ProductName: '30 Cal .308 212 gr ELD-X®',
		UPC: '090255230772',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.177',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230779',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.655',
		PalletQtyBoxes: '540',
		Retail: '69.15',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.673',
		G7BC: '0.336',
		MinTwist: '1-10"',
		SectionalDensity: '0.319',
		OAL: '1.597',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '212',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AuHAPEYQ--/385ede5f63fc3c104ea1849255d7a87742ca251c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7eb63d9b-7736-4cb8-96e0-ef6d870c879d',
		ProductID: '544650',
		ProductName: 'Match™ Grade 2-Die Set 6.5X47 Lapua (.264)',
		UPC: '090255546507',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.449',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255546504',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.245',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6.5X47 LAPUA',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1d684642-beab-40f9-8842-eadcae075d46',
		ProductID: '41694',
		ProductName: '416 cal .416 400 gr DGX® Bonded',
		UPC: '090255416947',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.993',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255416944',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.895',
		PalletQtyBoxes: '540',
		Retail: '106.72',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		SectionalDensity: '0.33',
		OAL: '1.37',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hvs0xA5n--/5e51aa4c3fb056b5ed58662c8aff5f0bf4799cd0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '24b18457-c3a1-4a74-b66d-84df6d78c289',
		ProductID: '99118',
		ProductName: 'Hornady® Ammo Sold Here Tin Sign',
		UPC: '090255991185',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '18',
		ShelfWidth: '12',
		ShelfDepth: '0.03',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area. Each have rounded corners and four pre-drilled holes for easy hanging. Measures 18"x12"',
		ProductImage: 'http://images.salsify.com/image/upload/s--9eX8wOl0--/etgkj7pc4h08v6ysg3ug.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '735df255-e722-4c39-b9ef-32a00b1ce356',
		ProductID: '594270',
		ProductName: 'Match™ Grade Bushing .270',
		UPC: '090255592702',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.257',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592709',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.57',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '270 CAL',
		BulletDiameter: '0.27',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DJ72eiMW--/fd3f2919ed46fd62bc2548266fdab4243ef04773.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8dd8f0b7-270b-4d2f-9156-ef07340430a3',
		ProductID: '046377',
		ProductName: 'Full-Length Size Die 8X60S (.323)',
		UPC: '090255463774',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463771',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '8X60S',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '71d3aac6-dd51-4114-8ebe-5c35033e2610',
		ProductID: '046044',
		ProductName: 'Neck Size Die 7mm (.284)',
		UPC: '090255460445',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.474',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460442',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8bdf5903-25f6-480c-8715-46f29d46b1aa',
		ProductID: '392603',
		ProductName: 'Shell Plate #3 Lock-N-Load® AP™ & Projector',
		UPC: '090255926033',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.546',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926030',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.46',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da252fe6-7c26-4472-8f53-9cc826988799',
		ProductID: '83172',
		ProductName: '17 HMR 20 gr HP XTP® Varmint Express® Rimfire',
		UPC: '090255831726',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.438',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255831723',
		CartonHeight: '4.250',
		CartonWidth: '8.750',
		CartonDepth: '15.500',
		CartonWeight: '17.52',
		PalletQtyBoxes: '5200',
		Retail: '23.79',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Rimfire Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.125',
		MuzzleVelocity: '2375',
		MuzzleEnergy: '250',
		SectionalDensity: '0.097',
		Cartridge: '17 HMR',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'XTP®',
		BulletWeightGrain: '20',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. HARD-HITTING XTP® (EXTREME TERMINAL PERFORMANCE) TECHNOLOGY The 20 gr. XTP® features an accurate and hard hitting hollow point bullet for a wide range of varmits.  HONEST 200-YARD PERFORMANCE The flat trajectory delivered by the 17 HMR® makes it the most accurate long-range rimfire ever made.  SELECT BRASS The uniformity of the Hornady® 17 HMR® case is equaled only by ultra-expensive match ammo, and case geometry helps provide this new cartridge’s unequaled performance!  PROPELLANT The powerful new propellants available today make the 17 HMR® the most accurate, hardest-hitting rimfire cartridge available.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iIk9wBF7--/e4f5b1b8cb88122ea17f4553f9b4493c8b82f22b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--nml7rzEP--/u9on9wmfdkvwssn4fpdo.jpg',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd1af0b5b-830a-4bdf-8d2d-b2936fa0fbd6',
		ProductID: '3131',
		ProductName: '303 Cal .3105 174 gr FMJ BT',
		UPC: '090255231311',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.600',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255231318',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.0',
		PalletQtyBoxes: '540',
		Retail: '56.68',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.470',
		SectionalDensity: '0.258',
		OAL: '1.263',
		Caliber: '303 CAL',
		BulletDiameter: '0.3105',
		BulletName: 'FMJ-BT',
		BulletWeightGrain: '174',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--6tOwE0io--/r7j6t88tpmuedf5sajx8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6f8d6cf0-000f-4da8-a61b-940d57aa7572',
		ProductID: '046590',
		ProductName: 'Full-Length Size Die 204 Ruger (.204)',
		UPC: '090255465907',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.518',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465904',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '140cdee1-2987-47cd-a4a6-97887cda77a4',
		ProductID: '044090',
		ProductName: 'Microjust™ Seating Micrometer',
		UPC: '090255440904',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.258',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440901',
		CartonHeight: '9.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '2.58',
		PalletQtyBoxes: '0',
		Retail: '45.04',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Add the MicroJust™ to a Custom Grade Hornady® seating die, and you can precisely set bullet seating depth in .001” increments. It’s a quick and easy way to achieve benchrest accuracy and consistency without the extra cost of another seating die. Hornady® die sets already include an in-line seater; simply replace the standard seating adjustment stem with the MicroJust™ seating micrometer. Not for Taper Crimp/Seater Dies.',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTxkKQPy--/fvoiimhqj0o45untvvbd.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0f99843c-ce8f-4fe1-a566-e8763e3d11f8',
		ProductID: '8730B',
		ProductName: '38 Special Unprimed Cases',
		UPC: '090255601015',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '46.620',
		WeightUOM: 'LB',
		CaseQty: '4500',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '209790.0',
		PalletQtyBoxes: '198000',
		Retail: '0.29',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Handgun Cartridge Cases',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c5ae459-ba16-4258-a315-a212d9b8d6f0',
		ProductID: '301934',
		ProductName: '30 Cal .308 180 gr CX™',
		UPC: '090255719574',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.370',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719571',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.25',
		PalletQtyBoxes: '900',
		Retail: '61.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.469',
		SectionalDensity: '0.271',
		OAL: '1.515',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--KEfXO9Gm--/tcpiqsj2wj6aw6yojg88.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '055be3b0-781b-4e8f-877c-9a7739fea259',
		ProductID: '8097',
		ProductName: '308 Win 168 gr BTHP Match',
		UPC: '090255380972',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380979',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.3',
		PalletQtyBoxes: '1400',
		Retail: '51.44',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.45',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2719',
		SectionalDensity: '0.253',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lhMHWnUn--/9d88c36911bef19db15c4620f1d49cb7963f45f7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '88c2e877-ecfc-4104-8810-a0c370b4aae6',
		ProductID: '546382',
		ProductName: 'Full-Length 2-Die Set 8mm Maus(8X57Js) .323',
		UPC: '090255563825',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.495',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563822',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.475',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '8X57',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b180ffe7-cab4-4522-bd34-af397dc634af',
		ProductID: '82223',
		ProductName: '338 Win Mag 200 gr SST® Superformance®',
		UPC: '090255822236',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.680',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822233',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.8',
		PalletQtyBoxes: '780',
		Retail: '73.88',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.455',
		MuzzleVelocity: '3030',
		MuzzleEnergy: '4077',
		SectionalDensity: '0.25',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SST®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1rP8xo2l--/03212632b42fabc61397c6832bac3e0f383af1de.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be02244a-f2e0-41d6-addb-936bae0b014e',
		ProductID: 'A8MM',
		ProductName: 'Lock-N-Load® 8mm Rem Mag Modified Case',
		UPC: '090255704341',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.042',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704348',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.42',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '8MM REM MAG',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DXUuEeG0--/9dc30adb575518fef99661eb6088a9d6f4fc21db.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '26889627-75dd-495e-91e7-0cea6d57a224',
		ProductID: '546372',
		ProductName: 'Full-Length 2-Die Set 32 Win Spl (.321)',
		UPC: '090255563726',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563723',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '32 WIN SPL',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ec63d857-85d5-4ffd-9774-8b454ac03cce',
		ProductID: '99284',
		ProductName: 'Hornady® OD & Tan Mesh Cap',
		UPC: '090255229844',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gB2joHV7--/mn1appcq9zbj49bgqhqd.png',
		DateLastModified: '2023-12-19 20:09:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '877b2733-f774-46b3-9fae-9178ec24ee36',
		ProductID: '546328',
		ProductName: 'Full-Length 2-Die Set 7mm TCU (.284)',
		UPC: '090255563283',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563280',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7MM TCU',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cae43172-b463-4624-983f-0d54d1a4d53e',
		ProductID: '546419',
		ProductName: 'Full-Length 2-Die Set 30/378 Wby Mag (.308)',
		UPC: '090255564198',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564195',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30-378 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '01a63fc0-4773-4455-8773-c4cdc2bf356e',
		ProductID: '82744',
		ProductName: '444 Marlin 265 gr FTX® LEVERevolution®',
		UPC: '090255827446',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.557',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827443',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '15.57',
		PalletQtyBoxes: '1400',
		Retail: '67.67',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.225',
		MuzzleVelocity: '2325',
		MuzzleEnergy: '3181',
		SectionalDensity: '0.205',
		Cartridge: '444 MARLIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FTX®',
		BulletWeightGrain: '265',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Xl9uBr1j--/e61e1af732cbc48044b7d82e377137d27101d79b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e3357f7-7c54-46d5-81ce-72a210968572',
		ProductID: '83209',
		ProductName: '204 Ruger 24 gr NTX® Superformance® Varmint',
		UPC: '090255832099',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.553',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255832096',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.53',
		PalletQtyBoxes: '1680',
		Retail: '37.95',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.17',
		MuzzleVelocity: '4400',
		MuzzleEnergy: '1032',
		SectionalDensity: '0.082',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		BulletName: 'NTX®',
		BulletWeightGrain: '24',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2Ucfg3u1--/9f38f4d1f91584d3298e37fdf69db66b665a1a0d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed85ee4a-9bad-49ee-81d1-9636c5d9674d',
		ProductID: '380715',
		ProductName: 'Cartridge Gauge 30-30 Win (.308)',
		UPC: '090255709650',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255709657',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c3dab03-346c-4643-ba7d-d9c808e5fda6',
		ProductID: '397132',
		ProductName: 'Seating Stem 7mm ELD-X® 175 Gr',
		UPC: '090255971323',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971320',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e5512344-729a-454e-80d0-056377ed0973',
		ProductID: '046286',
		ProductName: 'Full-Length Size Die 22 Nosler (.224)',
		UPC: '090255462869',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462866',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '22 NOSLER',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'afe7b714-1402-452a-bca3-f6943f9fcae7',
		ProductID: '99159',
		ProductName: 'Hornady® Big Shot Dog Leash',
		UPC: '090255991598',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '72',
		CartonUCC: '10090255991595',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '21.6',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: "6' long.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--Td0H8GOQ--/vj6tps4ywgumllbwntzs.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Td0H8GOQ--/vj6tps4ywgumllbwntzs.png',
		DateLastModified: '2024-02-06 06:11:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f2966c58-ca26-46bd-b933-4b22059d7332',
		ProductID: '8635B',
		ProductName: '270 Winchester Unprimed Cases',
		UPC: '090255600674',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '38.305',
		WeightUOM: 'LB',
		CaseQty: '1500',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '57457.5',
		PalletQtyBoxes: '66000',
		Retail: '0.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4e8b023-0eba-43eb-97d0-ee10227f61d9',
		ProductID: '544227',
		ProductName: 'Match™ Grade Neck Size Die 223 Rem (.224)',
		UPC: '090255542271',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.537',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255542278',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74e32ed5-ef75-4262-ba1d-70ae7095f3fd',
		ProductID: '050004',
		ProductName: 'Lock-N-Load® Classic Single Primer Tube (LARGE Primer)',
		UPC: '090255500042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9',
		ShelfWidth: '1',
		ShelfDepth: '0.25',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '9.000',
		CartonWidth: '1.000',
		CartonDepth: '0.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '13.80',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.    The Hornady® Lock-N-Load® Classic Single Primer Tube (LARGE Primer) holds LARGE primers in the automatic feed attachment of the Hornady® Lock-N-Load® Classic Press.  Simply preload the Primer Tube with primers by pushing the Primer Pickup at the end of the tube onto each individual primer until the tube is fully loaded.  This allows the primers to be picked up via a “hands-free” process.  Once loaded the tube may be affixed to the press or a handloader can load multiple tubes in reserve to help speed up the priming operation.   Hornady® Lock-N-Load® Classic Single Primer Tube Includes: Qty 1: Primer Tube (LARGE Primer) with Primer Pickup attached • Qty 1: Cotter Pin Holds up to 70 primers Other accessories sold separately.  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--IVz0-mJ0--/nzopsajlje7bksqpkcfy.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '840bc57c-f96f-457d-820e-1f8858ee028d',
		ProductID: '9078',
		ProductName: '41 Mag 190 gr FTX® LEVERevolution®',
		UPC: '090255390780',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.990',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390787',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '9.9',
		PalletQtyBoxes: '1120',
		Retail: '39.07',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.165',
		MuzzleVelocity: '1620',
		MuzzleEnergy: '1107',
		SectionalDensity: '0.161',
		Cartridge: '41 REM MAG',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		BulletName: 'FTX®',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2zlg1Jo5--/de248531e0d2334881e5470761e2aac9ec398339.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6afc3373-eb6d-4763-9046-06d1efc979d8',
		ProductID: 'A338R',
		ProductName: 'Lock-N-Load® 338 RCM Modified Case',
		UPC: '090255697971',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255697978',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '338 RCM',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Z_lVFqkC--/80061a7a7a524a592c22356d940f978dd6b1836c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3616571-3ac8-4e2e-aba0-55b85dd8d5e1',
		ProductID: '546204',
		ProductName: 'Full-Length 2-Die Set 17/223 (.172)',
		UPC: '090255562040',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562047',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '17-223',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2b9eb881-4b45-4936-b061-0d9c22362094',
		ProductID: '6620',
		ProductName: '50 Cal 385 gr HB-HP',
		UPC: '090255266207',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '5',
		ShelfWidth: '3.325',
		ShelfDepth: '1.5',
		Weight: '1.326',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255266204',
		CartonHeight: '5.500',
		CartonWidth: '7.687',
		CartonDepth: '8.000',
		CartonWeight: '13.26',
		PalletQtyBoxes: '900',
		Retail: '14.57',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Great Plains®',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.002',
		Caliber: '50 CAL',
		BulletDiameter: '5.1',
		BulletName: 'HB-HP',
		BulletWeightGrain: '385',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made Especially for Hunting Pre-lubricated for easy loading, the tapered base lets you start the bullet easily. Cold forming from pure lead eliminates air pockets and the thin skirt, longer bearing surface, and hollow point bullet design make it a highly devastating and accurate black powder legend. ACCURATE 1" groups at 100 yards.  NO LUBE Pre-lubed for easy loading and minimal fouling.  HARD HITTING Pure lead delivers maximum expansion and penetration.  HIGH PERFORMANCE Time proven design delivers performance to take on any game.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--nhHdUDrV--/dzbihchrcncdmyaciq9b.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--AnJoKahR--/gmasxazkkhvwjgac7shi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s---rP678Q2--/hqsdvko7utfdpkqeua2g.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '084ddd13-e564-4fc8-8bcd-3c2a83b8323a',
		ProductID: '046519',
		ProductName: 'Size Die 380 Auto (.355)',
		UPC: '090255465198',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.484',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465195',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '380 AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee2414fb-0956-44e7-83e1-b2533986f640',
		ProductID: '044719',
		ProductName: 'Expander Die 460 S&W',
		UPC: '090255447194',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447191',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '158c9465-325b-4b2b-9b79-c083b10939da',
		ProductID: '82666',
		ProductName: '416 Ruger 400 gr DGS® Dangerous Game™ Series',
		UPC: '090255826661',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.351',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826668',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '14.106',
		PalletQtyBoxes: '396',
		Retail: '152.72',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.319',
		MuzzleVelocity: '2400',
		MuzzleEnergy: '5115',
		SectionalDensity: '0.33',
		Cartridge: '416 RUGER',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x9JVOn7c--/1392e860dc9cfb937d416c8d1cef7005d7a6293e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '08cf7b06-7d90-41d0-a7b2-00fba7856122',
		ProductID: '044582',
		ProductName: 'Expander Die 50 AE',
		UPC: '090255445824',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445821',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8efbeb99-8bce-4627-b715-d87b98f0b758',
		ProductID: '050018',
		ProductName: 'Auto Primer Feeder Body for Classic/00-7',
		UPC: '090255500189',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.75',
		ShelfWidth: '0.375',
		ShelfDepth: '0.1',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500186',
		CartonHeight: '4.500',
		CartonWidth: '4.375',
		CartonDepth: '6.250',
		CartonWeight: '2.5',
		PalletQtyBoxes: '0',
		Retail: '36.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--Y1ENf1_D--/uefwnwdeaoic7zm6io4c.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3a805c9e-1c40-429f-9b1c-0b49e2b52d13',
		ProductID: 'FR104',
		ProductName: '223 Remington 55 gr FMJ Frontier®',
		UPC: '090255711288',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '7.25',
		ShelfWidth: '3.75',
		ShelfDepth: '11',
		Weight: '16.550',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711285',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '16.55',
		PalletQtyBoxes: '120',
		Retail: '0.00',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pKJXESVW--/0f52fe127d9f3f0f44730dfcf487ac5453ac179f.jpg',
		DateLastModified: '2023-11-08 15:18:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7db7fb74-4cfb-40d0-ba26-e9fccbc37299',
		ProductID: 'FR400',
		ProductName: '300 Blackout 125 gr FMJ Frontier®',
		UPC: '090255713978',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.750',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255713975',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '7.5',
		PalletQtyBoxes: '1680',
		Retail: '29.20',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 300 Blackout Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.25',
		MuzzleVelocity: '2175',
		MuzzleEnergy: '1313',
		SectionalDensity: '0.188',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--M0Qht0yU--/c77e69aeff262401e00c7a9476b8ba5e7662bea6.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a0803de9-5f99-489c-840b-fe8797228257',
		ProductID: '91318',
		ProductName: '358 Win 200 gr InterLock® SP',
		UPC: '090255913187',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.315',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913184',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.15',
		PalletQtyBoxes: '1400',
		Retail: '59.55',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.282',
		MuzzleVelocity: '2475',
		MuzzleEnergy: '2720',
		SectionalDensity: '0.223',
		Cartridge: '358 WIN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and GMX® bullets, providing an all-around line of hunting ammunition for your preferred shooting experience.  EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game.  BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xx90KKHV--/09f8a2e95c5ebb8b53297c6bf2b88f6a0359d130.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1cc0bc82-4e64-494b-99aa-ca4319b19432',
		ProductID: '390609',
		ProductName: 'Shell Holder #54',
		UPC: '090255906097',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.875',
		ShelfDepth: '0.75',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906094',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e67aa69e-1ab0-447b-9384-7bfee02d28c6',
		ProductID: '8717',
		ProductName: '32 H & R Magnum Unprimed Cases',
		UPC: '090255487176',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.770',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487173',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.85',
		PalletQtyBoxes: '200',
		Retail: '71.59',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '32 H&R MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c057961d-bd36-4efb-b533-6bd0f24dd5d7',
		ProductID: '8760',
		ProductName: '45 Automatic Unprimed Cases',
		UPC: '090255487602',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487609',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '7.0',
		PalletQtyBoxes: '400',
		Retail: '70.17',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '750c3eab-977b-4d75-9579-4dd426ea9268',
		ProductID: 'C470N',
		ProductName: 'Lock-N-Load® 470 Nitro Modified Case',
		UPC: '090255705072',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '0.75',
		ShelfDepth: '0.75',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705079',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '13.81',
		ParentCategory: 'Reloading',
		Cartridge: '470 NITRO EXP 3¼"',
		Caliber: '470 CAL',
		BulletDiameter: '0.474',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2024-03-05 08:51:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '02cb3c98-f9ab-4f35-b859-f438abd2ac6f',
		ProductID: '90012',
		ProductName: '25 Auto 35 gr XTP®',
		UPC: '090255900125',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.330',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900122',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '3.3',
		PalletQtyBoxes: '1120',
		Retail: '33.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.072',
		MuzzleVelocity: '900',
		MuzzleEnergy: '63',
		SectionalDensity: '0.079',
		Cartridge: '25 AUTO',
		Caliber: '25 CAL',
		BulletDiameter: '0.251',
		BulletName: 'XTP®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LcrZ04zJ--/f5f46a80195aef9c7df41248c81d4c28cbfbc8f7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '44abad35-4740-4f48-9380-70c7f82a79ff',
		ProductID: '95908',
		ProductName: 'Reusable Dehumidifier Bag',
		UPC: '090255959086',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '8',
		ShelfDepth: '4.5',
		Weight: '1.230',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959083',
		CartonHeight: '8.250',
		CartonWidth: '5.000',
		CartonDepth: '9.500',
		CartonWeight: '6.15',
		PalletQtyBoxes: '900',
		Retail: '13.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'COBALT DICHLORIDE',
		Prop65Chem2: 'COBALT DICHLORIDE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '1.75',
		ProductExtWidth: '6.5',
		ProductExtDepth: '3',
		MasterPackQty: '25',
		MasterPackUCC: '30090255959087',
		MasterPackHeight: '8.500',
		MasterPackWidth: '9.500',
		MasterPackDepth: '26.250',
		MasterPackWeight: '30.75',
		ProductDescription:
			'Prevent moisture damage in gun safes, cabinets and other enclosed areas. Recharge in warm oven for infinite reuse.  450gr. of desiccant',
		ProductImage: 'http://images.salsify.com/image/upload/s--pIopQs3V--/k0uz74evf83fvqo81pmy.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Pq4vD7Da--/j45tmqfxlgz9vlurjv68.jpg',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74840285-887f-4288-89e5-7364e475040e',
		ProductID: '050009',
		ProductName: 'Case Sizing Lube',
		UPC: '090255500097',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.166',
		WeightUOM: 'LB',
		CaseQty: '12',
		CartonUCC: '10090255500094',
		CartonHeight: '3.750',
		CartonWidth: '5.500',
		CartonDepth: '9.250',
		CartonWeight: '1.992',
		PalletQtyBoxes: '0',
		Retail: '7.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lubes, Cleaners & Polishes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This is the classic no-fail method of lubricating cases. Just apply a few drops of Hornady sizing lubrication to your lube pad and lube several cases at once.',
		ProductImage: 'http://images.salsify.com/image/upload/s--QafNNWCr--/p23uemiatwf5ihsmlcmo.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f07f2779-f5f7-4990-b09c-ab6aad24fd01',
		ProductID: '044535',
		ProductName: 'Expander Die 10mm-40 Cal (.400)',
		UPC: '090255445350',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.503',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445357',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed5617f9-5b1b-4d2e-a1d3-87bea9224368',
		ProductID: '282704',
		ProductName: '7mm .284 139 gr CX™',
		UPC: '090255719529',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.078',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719526',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '26.95',
		PalletQtyBoxes: '900',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.429',
		SectionalDensity: '0.246',
		OAL: '1.415',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'CX™',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--XtndaqA3--/aowczqt5mdztrqwkfdrs.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '53b5aad1-b1aa-4a6e-b489-3a1a784ac275',
		ProductID: '45160',
		ProductName: '45 Cal .451 230 gr XTP®',
		UPC: '090255245165',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.444',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245162',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.66',
		PalletQtyBoxes: '540',
		Retail: '43.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.188',
		SectionalDensity: '0.162',
		OAL: '0.65',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'XTP®',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--A6QcfWOh--/f911033a39860b31b37def76f2dd4449a1546c0a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06eb3d7e-4558-42ab-9639-7d6e57ca49f9',
		ProductID: '81030',
		ProductName: '30 Carbine 110 GR FTX Critical Defense®',
		UPC: '090255810301',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.815',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255810308',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.15',
		PalletQtyBoxes: '1120',
		Retail: '43.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Rifle Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.178',
		MuzzleVelocity: '2000',
		MuzzleEnergy: '977',
		SectionalDensity: '0.166',
		Cartridge: '30 CARBINE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--9FXfaIjW--/c5af05d9b6ad4e722289a84ab899f9669829a6f2.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s---eI8RUIi--/f6f2b8f884fb620df1732360cebffc5d20a0d6ec.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/238317634',
		Videos1: 'https://vimeo.com/257722358',
		Videos2: 'https://vimeo.com/241903262',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b10c08c-8459-4913-be86-73f529fc5c67',
		ProductID: '010049',
		ProductName: 'Gas Assist Retro Fit/366 Loaders',
		UPC: '090255010497',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '10.625',
		ShelfDepth: '3.25',
		Weight: '2.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255010494',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '21.0',
		PalletQtyBoxes: '0',
		Retail: '190.08',
		ParentCategory: 'Reloading',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The 366 Gas Assist option will make you feel like you have a new reloader! It provides automatic, smooth, and reliable indexing for consistent primer feeding and no spilled shot. Best of all, it works with nearly any of the 366 loaders - past and present.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wyQScxK9--/ihwynkdwjqrbblgfdlr8.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '330dab36-59b8-46ad-8848-1598b3fc04af',
		ProductID: '044135',
		ProductName: 'Seater Die #6.5 (.264) 6.5mm W/146',
		UPC: '090255441352',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441359',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ba57cc4-d694-4e2d-bd7d-be53c34b3323',
		ProductID: '390607',
		ProductName: 'Shell Holder #52',
		UPC: '090255906073',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906070',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ad670353-0e82-4c1c-8d5b-17fbdc7451dc',
		ProductID: '046413',
		ProductName: 'Full-Length Size Die 9.3X62 (.366)',
		UPC: '090255464139',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464136',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '9.3X62',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '87dc2fae-5cbb-4d3f-b992-7b068f873442',
		ProductID: '390972',
		ProductName: 'Cam Lock™ Trimmer Cutter',
		UPC: '090255909722',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909729',
		CartonHeight: '2.000',
		CartonWidth: '9.000',
		CartonDepth: '6.000',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '28.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--FRmNTn0g--/r0kmuyvgwcatiymlvzjn.jpg',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22fa1658-1039-40c2-a177-f5bea103e598',
		ProductID: 'FR200',
		ProductName: '5.56 NATO 55 gr FMJ (M193) Frontier®',
		UPC: '090255711394',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.574',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711391',
		CartonHeight: '4.391',
		CartonWidth: '4.813',
		CartonDepth: '12.219',
		CartonWeight: '14.35',
		PalletQtyBoxes: '4500',
		Retail: '17.31',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--II9OOfAb--/2c336eccf0dbad60d0136545c8c5d172c5cc88af.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '91d45709-addf-4dbb-ba1e-050b4079aae5',
		ProductID: '95900',
		ProductName: 'Hornady® Rechargeable Gun Safe Dehumidifier',
		UPC: '090255959000',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.25',
		ShelfWidth: '7',
		ShelfDepth: '2.5',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959007',
		CartonHeight: '7.500',
		CartonWidth: '7.000',
		CartonDepth: '10.750',
		CartonWeight: '5.5',
		PalletQtyBoxes: '1020',
		Retail: '26.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '6',
		ProductExtWidth: '4',
		ProductExtDepth: '1.5',
		ProductWeight: '0.84',
		MasterPackQty: '20',
		MasterPackUCC: '30090255959001',
		MasterPackHeight: '9.500',
		MasterPackWidth: '13.000',
		MasterPackDepth: '21.500',
		MasterPackWeight: '22.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--Outqlf4m--/z2kbukgvncihq6wsvgu0.pdf',
		ProductDescription:
			'Absorb humidity and prevent rust or mildew in gun safes or other enclosed areas. Moisture-control crystals change color when unit needs recharging. Recharge by plugging into 110V electrical outlet. Safeguards firearms and other valuables from mold and mildew. Eliminates humidity in enclosed spaces up to 333 cubic feet. Quick-connect bracket makes mounting unit easy in gun safes, closets or pantries. Removes humidity without electricity or batteries. Color-shifting moisture-control crystals signal when recharging is necessary. Simply plug in to dry out crystals and recharge unit for renewed effectiveness. Contains no harmful chemicals — child, pet and home safe.  Dimensions: 1.5"H x 4"W x 6"D IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--_U9mOv87--/fgmjqiqlky8u9sohk9bi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--jecu7YRT--/b2fhtowxcgxajhvatkpz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--n-1Uys3n--/meg1f5pdohljr9d5ya19.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8d616132-58e9-40f7-abbd-8267bb53490f',
		ProductID: '044158',
		ProductName: 'Seater Die (.475) 475 Linebaugh',
		UPC: '090255441581',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.512',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441588',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '32f408ae-f0b6-4c98-8ec5-22107d3371b4',
		ProductID: '480001',
		ProductName: 'Measure Seal',
		UPC: '090255840018',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.125',
		ShelfWidth: '0.125',
		ShelfDepth: '0.08',
		Weight: '0.002',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.125',
		CartonWidth: '0.125',
		CartonDepth: '0.080',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '2.37',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shotshell Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--enKIRj4p--/cdmzvyf2ojh8rkefstmc.png',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51137125-0ea0-4d02-a656-c79ecfcf9f2b',
		ProductID: '390960',
		ProductName: 'Trimer Pilot #18 .429',
		UPC: '090255909609',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.023',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909606',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.23',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '429 CAL',
		BulletDiameter: '0.429',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--aFe5RYnm--/qehcirrzohvbezjwlyz7.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a44f41a1-79ee-437e-b4a3-5e8978a681eb',
		ProductID: '8655B',
		ProductName: '30-30 Winchester Unprimed Cases',
		UPC: '090255698688',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '44.148',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '88296.0',
		PalletQtyBoxes: '88000',
		Retail: '0.56',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4a2d4140-fdbd-4289-901a-741d85ef6790',
		ProductID: '390750',
		ProductName: 'Small Primer Reamer',
		UPC: '090255907506',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.000',
		ShelfWidth: '2.000',
		ShelfDepth: '1.000',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255907503',
		CartonHeight: '5.500',
		CartonWidth: '5.000',
		CartonDepth: '2.000',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '14.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--WX9jq-LH--/qhlsyk4udsrspfljksqz.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb8db83d-7ca6-45fc-ba54-551c554ea552',
		ProductID: '190100',
		ProductName: 'Shot Bushing 3/4 oz #9',
		UPC: '090255191004',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.070',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191001',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.7',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shot Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Calibrated to measure maximum legal loads for trap and skeet shooting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8c41a10-4783-4970-8e7a-557df3fec468',
		ProductID: '2249C',
		ProductName: '22 Cal .224 52 gr BTHP Match  with cannelure',
		UPC: '090255690316',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '45.701',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255690313',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '274206.0',
		PalletQtyBoxes: '252000',
		Retail: '0.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.229',
		SectionalDensity: '0.148',
		OAL: '0.712',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '52',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DKoaGx0C--/50f4c54ce8d821465797bee22a0daa65104083b9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9a66941c-f4ed-4fa7-b815-ef8961b2f1cd',
		ProductID: '546214',
		ProductName: 'Full-Length 2-Die Set 22 K-Hornet (.224)',
		UPC: '090255562149',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562146',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '22 K-HORNET',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f7196f9c-881e-4efd-b091-46574fcdbaea',
		ProductID: '546244',
		ProductName: 'Full-Length 2-Die Set 243 Win (.243)',
		UPC: '090255562446',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.520',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562443',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.6',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '284a164d-a6a2-4b35-b151-4356a51ebed1',
		ProductID: '28284',
		ProductName: '7mm .284 150 gr CX™',
		UPC: '090255282849',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.168',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255282846',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.2',
		PalletQtyBoxes: '900',
		Retail: '59.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.455',
		SectionalDensity: '0.266',
		OAL: '1.49',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--3iLhfZr---/qjek7k5ipkuje3yhvlxe.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c4d54496-d109-4a09-be10-6ef958abeff9',
		ProductID: '8262',
		ProductName: '458 Lott 500 gr DGS® Dangerous Game™ Series',
		UPC: '090255382624',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.640',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382621',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.84',
		PalletQtyBoxes: '396',
		Retail: '211.55',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2300',
		MuzzleEnergy: '5873',
		SectionalDensity: '0.341',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LBjQK3_f--/8bc62696980f7be673ff944eaead12fd51a2fa0a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81c1f087-f9d0-45a4-9510-f2a8e45ff5ac',
		ProductID: '046303',
		ProductName: 'Full-Length Size Die 284 Win (.284)',
		UPC: '090255463033',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463030',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '284 WIN',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8e683ae6-c2e9-4036-b38e-a75dbbd0c50a',
		ProductID: 'D1202',
		ProductName: 'Lock-N-Load® 22 Hornet Adapter & Case',
		UPC: '090255704266',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704263',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '34.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® OAL Gauges',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs. Contains Modified Case and Adapter D for 22 Hornet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZhiqvJDC--/vn8jgi3vxfydgn7mcqlr.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc8eef31-d111-4ada-88cf-27f519b4146c',
		ProductID: '82381',
		ProductName: '404 Jeffery 400 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255823813',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.458',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823810',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '14.748',
		PalletQtyBoxes: '396',
		Retail: '228.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.325',
		MuzzleVelocity: '2300',
		MuzzleEnergy: '4698',
		SectionalDensity: '0.319',
		Cartridge: '404 JEFFERY',
		Caliber: '423 CAL',
		BulletDiameter: '0.423',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--FgYAHzhm--/7db46c5ac0777a65d0001eb3e821ee27e7e42b84.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee84ea4c-e128-4765-a1b5-33e2e23fbae2',
		ProductID: '8742',
		ProductName: '40 Smith & Wesson Unprimed Cases',
		UPC: '090255487428',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.060',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487425',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.3',
		PalletQtyBoxes: '200',
		Retail: '76.88',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'de940970-262c-4f40-8da1-a4982dfe8898',
		ProductID: '594265',
		ProductName: 'Match™ Grade Bushing .265',
		UPC: '090255592658',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592655',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.265',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AMESSeCV--/57fdc3179ae86b2b50e37fff9ff96fdcf37de1b9.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '16e80b45-5c2c-4906-875c-2196484467c5',
		ProductID: '83204',
		ProductName: '204 Ruger 32 gr V-MAX® Superformance® Varmint',
		UPC: '090255832044',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255832041',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.66',
		PalletQtyBoxes: '1680',
		Retail: '34.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.21',
		MuzzleVelocity: '4225',
		MuzzleEnergy: '1268',
		SectionalDensity: '0.11',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '32',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SOAX20N5--/439772d661bb30eda43fefcd338b0982f7d8ae4a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '366b8f62-095a-4646-bcb8-bf45b5bc7390',
		ProductID: '80573',
		ProductName: '7mm-08 Rem 139 gr SST® Superformance®',
		UPC: '090255805734',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.145',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805731',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.45',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		MuzzleVelocity: '2950',
		MuzzleEnergy: '2686',
		SectionalDensity: '0.246',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Cvh-xRDh--/e03cac1bfb3ad4c21a64ed683438472ea97c5af9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '228177b1-c6ae-4e53-b6b9-837a54c6abce',
		ProductID: '390580',
		ProductName: 'Shell Holder #40',
		UPC: '090255905809',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905806',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.44',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bd3d7fa5-a67c-42f9-ad22-417736590c56',
		ProductID: '86249',
		ProductName: '12 GA 00 Buckshot Hornady BLACK®',
		UPC: '090255862492',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.625',
		ShelfDepth: '4',
		Weight: '0.915',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862499',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '9.15',
		PalletQtyBoxes: '1120',
		Retail: '21.52',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		MuzzleVelocity: '1600',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '00',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--A2_VCOr5--/m9s3qcsut3hqqmsjgmj3.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--rbQ7WHSk--/473e242ba6e17c879d018f4fd28defd7dfbe15ab.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75118520-a39d-4391-bd9b-ad9c5e8210dd',
		ProductID: '3037B',
		ProductName: '30 Cal .308 150 gr FMJ-BT',
		UPC: '090255630374',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '46.130',
		WeightUOM: 'LB',
		CaseQty: '2100',
		CartonUCC: '10090255630371',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '96873.0',
		PalletQtyBoxes: '94500',
		Retail: '0.25',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		SectionalDensity: '0.226',
		OAL: '1.122',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ-BT',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--9ydCTbel--/uueub9tcxbdzvynworvz.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8605d737-9f03-4db1-9a96-372573b953a0',
		ProductID: '044177',
		ProductName: 'Taper Crimp Seater Die 9mm/9X21',
		UPC: '090255441772',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441779',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '40.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp/Seater Dies For Series II Three-Die Taper Crimp Handgun Die Sets',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Taper Crimp Die features intuitive design that allows seating and taper crimping to be completed in one step, eliminating the need for a separate taper crimp die.  Precise control is achieved by the use of the Taper Crimp Adjustment Screw that easily adjusts the amount of crimp on the cartridge without changing bullet seating depth or loosening the lock ring. Hornady® Taper Crimp dies feature an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® TAPER CRIMP DIE COMES COMPLETE WITH: Hornady® Taper Crimp Die and Sure-Loc™ Lock Ring 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--aROXT8VW--/syxt7m7qvlomyagtd9du.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '18578f36-5715-4e18-be75-247e69641498',
		ProductID: '392609',
		ProductName: 'Shell Plate #9 Lock-N-Load® AP™ & Projector',
		UPC: '090255926095',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.611',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926092',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '6.11',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f6fd2bc8-65fb-44e5-9ea4-c6638c4ea41d',
		ProductID: '046596',
		ProductName: 'Full-Length Size Die 6.5 Creedmoor (.264)',
		UPC: '090255465969',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.503',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465966',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e8339a19-a98b-4c19-844f-d41e161750ba',
		ProductID: '046242',
		ProductName: 'Match™ Grade Full-Length Size Die 300 WSM (.308)',
		UPC: '090255462425',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462422',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3da24354-27da-4a56-818b-156347966b97',
		ProductID: '050303',
		ProductName: 'One Shot® Tumbler Media Cob',
		UPC: '090255503036',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '5.5',
		ShelfDepth: '5.5',
		Weight: '5.000',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255503033',
		CartonHeight: '10.750',
		CartonWidth: '12.000',
		CartonDepth: '16.000',
		CartonWeight: '30.0',
		PalletQtyBoxes: '240',
		Retail: '25.27',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Toluene in Labels',
		Prop65Chem2: 'Toluene in Labels',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This abrasive media, made of ground corn cob, removes tarnish and other residue from cartridge cases. Use with One Shot® Metal Polish for a shiny, like-new finish.',
		ProductImage: 'http://images.salsify.com/image/upload/s--6cPCqsFf--/naeg1xqmuyckthtraenm.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8d87520-2433-4965-b2d0-3a8b3b652345',
		ProductID: 'A32',
		ProductName: 'Lock-N-Load® 32 Special Modified Case',
		UPC: '090255705164',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.024',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705161',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.24',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '32 WIN SPL',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--eNX-eiCo--/79542b762f23e8879b589d3c6c723f6927d5f4c4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e84337e2-c4b4-45a4-8e2c-5678c370f482',
		ProductID: '45200',
		ProductName: '45 Cal .452 250 gr XTP®',
		UPC: '090255245202',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.730',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245209',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.95',
		PalletQtyBoxes: '540',
		Retail: '47.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.146',
		SectionalDensity: '0.175',
		OAL: '0.663',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'XTP®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5q08mXo9--/578000332aea5d8d919118313f3fa0f1f19249b8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60e81527-e7f7-4d8f-a291-842716cc6043',
		ProductID: '933',
		ProductName: 'Lock-N-Load® 33 Insert (.338 Cal)',
		UPC: '090255704488',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.023',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704485',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.23',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--aCqQkUyH--/to58hbks5mpodtnshj6s.png',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '50fac5a5-886c-4b91-877f-a0a58b83595a',
		ProductID: '546566',
		ProductName: 'Full-Length 3-Die Set 45/70 Govt (.458)',
		UPC: '090255565669',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.804',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565666',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.02',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39a77330-5fcf-417a-8917-6a9076c6fb70',
		ProductID: '91224',
		ProductName: '100 Auto 155 gr. XTP® American Gunner®',
		UPC: '090255912241',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.785',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255912248',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.85',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		SectionalDensity: '0.138',
		Cartridge: '10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '.400',
		BulletName: 'XTP®',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--QdFebvJ0--/sotgzaoup0jo2wly3vgb.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05659a3e-822b-4e43-ab07-3f33f90855c9',
		ProductID: '050080',
		ProductName: 'Digital Caliper',
		UPC: '090255500806',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '3.5',
		ShelfDepth: '9.75',
		Weight: '0.653',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500803',
		CartonHeight: '4.250',
		CartonWidth: '10.750',
		CartonDepth: '12.250',
		CartonWeight: '6.53',
		PalletQtyBoxes: '2000',
		Retail: '58.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Measuring Devices',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		BatteryType: 'LR44',
		BatteryQty: '2',
		BatteryWattHour: '0.24',
		BatteryWeight: '4.6',
		LithiumBattery: 'No',
		MasterPackQty: '50',
		MasterPackUCC: '30090255500807',
		MasterPackHeight: '10.750',
		MasterPackWidth: '12.250',
		MasterPackDepth: '20.500',
		MasterPackWeight: '32.65',
		ProductDescription:
			'Precisely measure case length, inside and outside case diameter, bullet length, primer pocket depth and overall cartridge length. Features quick repeat and measuring speed, an extra large LCD screen and accuracy to .001.” Battery and protective storage case included.',
		ProductImage: 'http://images.salsify.com/image/upload/s--yaquCjoy--/td6yukn5urz1g5e8ryh8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--UY5omOaR--/s4ocn6d66eccidyo0gcx.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c0e804d0-51e3-44ac-99ea-65cae7b7bb3d',
		ProductID: '86627',
		ProductName: '30-40 Krag Unprimed Cases',
		UPC: '090255866278',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255866275',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '6.75',
		PalletQtyBoxes: '200',
		Retail: '69.57',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '30-40 KRAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60418458-c55b-4589-bb65-fe72a2468297',
		ProductID: '397120',
		ProductName: 'Seating Stem 45 Cal FTX®/MFX®',
		UPC: '090255971200',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971207',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '7.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2f51e160-f9d4-47f0-b123-72dd00af4f6e',
		ProductID: '86281B',
		ProductName: '6.5 Creedmoor Unprimed Cases',
		UPC: '090255862812',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '43.977',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '87954.0',
		PalletQtyBoxes: '88000',
		Retail: '0.56',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '84b78fc1-f3bc-4800-bab6-cb11fad958fc',
		ProductID: '82043',
		ProductName: '300 Win Mag 178 gr ELD® Match',
		UPC: '090255820430',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.605',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820437',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.05',
		PalletQtyBoxes: '780',
		Retail: '76.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.547',
		G7BC: '0.275',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3463',
		SectionalDensity: '0.268',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gllFGJtM--/77c1707c50a14ce57d505db8f5867e4bad9b92cb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a386c242-f095-4ee4-aa58-0cca1d996ffb',
		ProductID: '190107',
		ProductName: 'Shot Bushing 1 oz #7 1/2',
		UPC: '090255191073',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.067',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191070',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.67',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shot Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Calibrated to measure maximum legal loads for trap and skeet shooting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '22888e59-0dbc-4c94-938b-74ad69b13323',
		ProductID: '83005',
		ProductName: '17 Hornet 20 gr V-MAX® Superformance® Varmint',
		UPC: '090255830057',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255830054',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '4.0',
		PalletQtyBoxes: '1120',
		Retail: '34.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.185',
		MuzzleVelocity: '3650',
		MuzzleEnergy: '592',
		SectionalDensity: '0.097',
		Cartridge: '17 HORNET',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '20',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xq0mcXIM--/50a8d1fd0e42738dd132361dc59b9a951e7de1d4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '571e35c9-74f1-4917-b42d-79786f1064d3',
		ProductID: 'A6MM',
		ProductName: 'Lock-N-Load® 6mm Rem Modified Case',
		UPC: '090255704136',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.030',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704133',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.3',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '6MM REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xKT6mP3L--/97462bc527d753e9235bf26a27ad50060a482663.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9eebf3ca-25cb-4177-b6e1-ee11bb7fa030',
		ProductID: '190194',
		ProductName: 'Powder Bushing 396',
		UPC: '090255191943',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.066',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191940',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.66',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '42b57e1e-847e-449d-ac2d-2cec6cb90d04',
		ProductID: '397110',
		ProductName: 'Seating Stem 338 Cal ELD® Match™',
		UPC: '090255971101',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971108',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b7addb6-e46c-42b6-8fdb-285fe570dd1a',
		ProductID: '814904',
		ProductName: '6.5 Creedmoor 120 gr CX™ Superformance®',
		UPC: '090255719963',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719960',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.6',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.428',
		MuzzleVelocity: '3050',
		MuzzleEnergy: '2479',
		SectionalDensity: '0.246',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'CX™',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s---7lF4f7T--/zokjksp5b79mntglymqm.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f1fcb7f9-a4be-44fa-b864-38f5be9fb622',
		ProductID: '060009',
		ProductName: 'Small Decapping Pin (6 Pk)',
		UPC: '090255600094',
		PackagedQTY: '6',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.013',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255600091',
		CartonHeight: '1.000',
		CartonWidth: '7.000',
		CartonDepth: '6.000',
		CartonWeight: '0.13',
		PalletQtyBoxes: '0',
		Retail: '14.47',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--GkLir-C5--/itj66jjkzlrya0r9ja5i.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9262ecad-e1b4-4907-943c-72b59eb5812c',
		ProductID: '390576',
		ProductName: 'Shell Holder #36',
		UPC: '090255905762',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.047',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905769',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.47',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e46d637-7a1e-47f9-b54d-24a6db5b919c',
		ProductID: '8734',
		ProductName: '38 Super Comp Unprimed Cases',
		UPC: '090255487343',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487340',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.5',
		PalletQtyBoxes: '200',
		Retail: '83.68',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '38 SUPER COMP',
		Caliber: '9MM',
		BulletDiameter: '0.356',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5da45a9d-6f4d-4d5b-8520-7b0cbd5f4dba',
		ProductID: '041212',
		ProductName: 'Primer Pocket Uniformer - Small',
		UPC: '090255412123',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412120',
		CartonHeight: '1.000',
		CartonWidth: '5.000',
		CartonDepth: '7.000',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '21.24',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading accessories have been developed by reloaders, for reloaders to complement existing Hornady® products and enhance the reloading process.  The Hornady® Primer Pocket Uniformer (SMALL Primer) is an excellent tool for the reloader looking to get every bit of consistency from their handloads.  This tool uniforms primer pocket depths, squares the primer pocket to the case head and squares any rounded corners in the primer pockets for the ultimate in consistent ammunition.  The Primer Pocket Uniformer features an adjustable depth stop, a tensioning nut and features 8-32 threads that will work in the Hornady® Universal Accessory Handle, the Hornady® Case Prep Trio, the Hornady® Case Prep Center or any other tool that will receive 8-32 threads (accessories sold separately).  NOTE: This product does not cut the crimp from crimped brass  Hornady® Primer Pocket Uniformer (SMALLRifle/Pistol) includes: Qty 1: Small Rifle/Pistol Primer Pocket Uniformer/Cutter Head Assembly • Qty 1: Adjustable Depth Stop • Qty 1: Tension Nut • Qty 1: 1/16”  Allen wrench Other accessories sold separately.  Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--Bzk0FPmG--/yd40n4imxsenvuiubnxl.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e5e2b389-179b-4ee5-a140-556b8f8bd0c5',
		ProductID: '80866',
		ProductName: '308 Win 125 gr SST® Custom Lite®',
		UPC: '090255808667',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.075',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255808664',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.75',
		PalletQtyBoxes: '1400',
		Retail: '52.72',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom Lite® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.305',
		MuzzleVelocity: '2675',
		MuzzleEnergy: '1986',
		SectionalDensity: '0.188',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Custom Lite® ammunition provides reduced recoil and muzzle blast from the most popular calibers, and puts the fun back into shooting for kids, women, and every shooter looking to keep recoil to a minimum while still enjoying the use of their favorite rifle.  Loaded with Hornady® SST® bullets, Custom Lite® ammunition is designed to deliver less felt recoil and a modified trajectory that still provides the accurate, deadly, and dependable performance you rely on from Hornady®. Putting the fun back into shooting! REDUCED RECOIL By using slightly lighter bullets and modified propellants, shooters will achieve significant recoil reduction over standard loads.  PROVEN BULLETS Loaded with SST® bullets, Custom Lite® ammunition delivers flat trajectories and hard-hitting performance.  CONSISTENT COMPONENTS Like all Hornady® ammunition, we match powders to each load for optimum pressure, velocity and consistency. High quality cases and primers contribute to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6oVKOBUf--/1c348e96fb23e1beecff7a7ab10ef45c36ca77fe.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--4R4XJY1N--/fdf5689780cb7a89749a990ec22c46775c959348.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--IedbEBai--/cg0qkaxwzqakis570swr.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rU_sQxe2--/jftbvatdsf6czstqk9mn.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Sli1o3qn--/cc6ihett8589l4lhvhjw.jpg',
		Videos: 'https://vimeo.com/96125085',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5f1a99d-42b3-4d0b-b74c-8507c72c517a',
		ProductID: '044154',
		ProductName: 'Seater Die (.364) 9X18 Makarov',
		UPC: '090255441543',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.523',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441540',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e4ebcb49-8e23-4b42-b44f-5af03d0ca015',
		ProductID: '87291',
		ProductName: '35 Whelen Unprimed Cases',
		UPC: '090255872910',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.513',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255872917',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.565',
		PalletQtyBoxes: '200',
		Retail: '67.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '35 WHELEN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e68e1a7a-ea9d-4f12-8b12-597db1ba000f',
		ProductID: '82180',
		ProductName: '300 Win Mag 195 gr ELD® Match',
		UPC: '090255821802',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.630',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821809',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.3',
		PalletQtyBoxes: '780',
		Retail: '76.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.584',
		G7BC: '0.292',
		MuzzleVelocity: '2930',
		MuzzleEnergy: '3717',
		SectionalDensity: '0.294',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '195',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wCl0HQ7r--/69cf06daf06221aed20533f97895a7abdd2a7234.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '248596d0-4ec7-439c-aa1b-93f7f1aaffae',
		ProductID: '392630',
		ProductName: 'Shell Plate #30 Lock-N-Load®AP™ & Projector',
		UPC: '090255926309',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.568',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926306',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.68',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '814d6f9d-4487-4a16-b2ca-f226ddbaf0c3',
		ProductID: '90224',
		ProductName: '9mm Luger +P 124 gr XTP® American Gunner®',
		UPC: '090255902242',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.765',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902249',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.65',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.165',
		MuzzleVelocity: '1175',
		MuzzleEnergy: '380',
		SectionalDensity: '0.141',
		Cartridge: '9MM LUGER+P',
		PressureRating: '+P',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs.  Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cT-9ZgzE--/97aae6d9fcef5d6a639431781d0810e580f3c9bf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66f73e05-35a2-4210-828a-85d2aeb948ff',
		ProductID: '546223',
		ProductName: 'Full-Length 2-Die Set 223 WSSM (.224)',
		UPC: '090255562231',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.432',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562238',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.16',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '223 WSSM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '651f5d06-04cd-4c6a-8311-34ce4a5abc15',
		ProductID: '95907',
		ProductName: 'Wireless Hygrometer',
		UPC: '090255959079',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '4',
		ShelfDepth: '2.3',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959076',
		CartonHeight: '4.500',
		CartonWidth: '7.500',
		CartonDepth: '12.500',
		CartonWeight: '2.75',
		PalletQtyBoxes: '0',
		Retail: '37.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '60',
		MasterPackUCC: '30090255959070',
		MasterPackHeight: '18.250',
		MasterPackWidth: '13.000',
		MasterPackDepth: '24.000',
		MasterPackWeight: '33.0',
		ProductDescription:
			'Remote sensor measures temperature and humidity inside your safe. Hygrometer features a large touchscreen and displays high/low in either Fahrenheit or Celsius at both the base and remote units. Use the integrated stand or mount with magnets, hanging hole or Square-Lok™ mount. Remote sensor measures temperature and humidity. Displays high/low for both temperature and humidity in either Fahrenheit or Celsius. Large touchscreen display. Snaps into the Hornady® Square-Lok™ system. Integrated stand, powerful magnets, or Hornady® Square-Lok™ mount allows placement anywhere.',
		ProductImage: 'http://images.salsify.com/image/upload/s--hTeuegDO--/icrkuio0psrlr33yjnd6.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ddb0bbff-9f69-45b4-8ad2-d758fab27e29',
		ProductID: '8154',
		ProductName: '264 Win Mag 140 gr InterLock® SP',
		UPC: '090255381542',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.430',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381549',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '14.3',
		PalletQtyBoxes: '780',
		Retail: '73.75',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.465',
		SectionalDensity: '0.287',
		Cartridge: '264 WIN MAG',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '140',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RAjlwPMm--/ce56c1a2df2829c51f99fa1c82f8ef49103bfe02.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8db4799a-41db-4b80-8012-39bc68e9b4bb',
		ProductID: '90362',
		ProductName: '38 Special 158 gr XTP®',
		UPC: '090255903621',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.920',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255903628',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '9.2',
		PalletQtyBoxes: '1120',
		Retail: '38.40',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.206',
		MuzzleVelocity: '800',
		MuzzleEnergy: '225',
		SectionalDensity: '0.177',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '158',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DUH-loox--/40c5a5efa52ea109dc3028bfb6606c1b872ad2b5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e0fed028-db36-4840-805f-e706c431ec09',
		ProductID: '546352',
		ProductName: 'Full-Length 2-Die Set 300 Win Mag (.308)',
		UPC: '090255563528',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.538',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563525',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.69',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6263c45-d45c-4304-98ab-9c25ba7fd038',
		ProductID: '8316',
		ProductName: '222 Rem 50 gr V-MAX® Superformance® Varmint',
		UPC: '090255383164',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383161',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.6',
		PalletQtyBoxes: '1680',
		Retail: '34.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.242',
		MuzzleVelocity: '3345',
		MuzzleEnergy: '1242',
		SectionalDensity: '0.142',
		Cartridge: '222 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s---4i0xHZL--/d04ccd9c256e19d51b873a57ca98571ab12917de.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2d516df5-ee48-4d9b-972e-5ffc4caf7af8',
		ProductID: '24370',
		ProductName: '6mm .243 80 gr GMX®',
		UPC: '090255224375',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.668',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224372',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '16.7',
		PalletQtyBoxes: '900',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.3',
		SectionalDensity: '0.194',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'GMX®',
		BulletWeightGrain: '80',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--f8LiMvJI--/3176a7788b38afc62cdeca15bc0bbd6bd7826d7d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc94eaab-baf1-4468-a3ae-55eb49ab8ae5',
		ProductID: '81124',
		ProductName: '30-06 Springfield 150 gr. CX™ Superformance®',
		UPC: '090255811247',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.265',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811244',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.65',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.418',
		SectionalDensity: '0.226',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--OYJqFU3F--/jmtmurdyhoxv581ju21d.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--WrGXZhp_--/omhk27s629mlcmrxv5tp.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5392cfb-7050-43a7-ac0b-2747b07c171f',
		ProductID: '046457',
		ProductName: 'Full-Length Size Die 458 Lott (.458)',
		UPC: '090255464573',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464570',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3b04672c-0ac9-416f-928c-ae632e9b4702',
		ProductID: '83170',
		ProductName: '17 HMR® 17 gr V-MAX® Varmint Express® Rimfire',
		UPC: '090255831702',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.417',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255831709',
		CartonHeight: '4.500',
		CartonWidth: '17.188',
		CartonDepth: '8.000',
		CartonWeight: '16.68',
		PalletQtyBoxes: '5200',
		Retail: '23.79',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Rimfire Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.125',
		MuzzleVelocity: '2550',
		MuzzleEnergy: '245',
		SectionalDensity: '0.082',
		Cartridge: '17 HMR',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '17',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--E0jTHW4R--/d42b1ee2bf5ce8b8e62a5c94400356f8892b61c5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--J8IGn6Ib--/ofpocgd7g1ix6lhfd9sw.jpg',
		DateLastModified: '2024-02-21 09:48:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '16cfc760-bea5-470e-a85e-27399012f4c0',
		ProductID: 'A257',
		ProductName: 'Lock-N-Load® 257 Roberts Modified Case',
		UPC: '090255704518',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.029',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704515',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.29',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '257 ROBERTS',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SLDCYc6X--/1160d3054657ce2939b5dd28a4f7efa8f6c437ff.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b982a35c-04a9-4d54-a366-ac26bc65f7f3',
		ProductID: '8694',
		ProductName: '458 Winchester Magnum Unprimed Cases',
		UPC: '090255486940',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.868',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486947',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.34',
		PalletQtyBoxes: '200',
		Retail: '101.92',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0a68e646-99a1-4c71-b658-90de3f7ff014',
		ProductID: '30904',
		ProductName: '30 Cal .308 225 gr ELD® Match',
		UPC: '090255309041',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.366',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255309048',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '50.49',
		PalletQtyBoxes: '540',
		Retail: '68.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.777',
		G7BC: '0.391',
		MinTwist: '1-10"',
		SectionalDensity: '0.339',
		OAL: '1.68',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6QaK8nJt--/72d7e37dd8bc68ca58d273026cff9de1c24b0f7f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ab1e73e-7548-42cc-8762-11958178049b',
		ProductID: '75221',
		ProductName: 'Snapsafe® Lock Box XXL Keyed Alike (2 Pack)',
		UPC: '851529004266',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '9',
		ShelfDepth: '12.25',
		Weight: '12.580',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004263',
		CartonHeight: '13.000',
		CartonWidth: '10.000',
		CartonDepth: '30.000',
		CartonWeight: '62.9',
		PalletQtyBoxes: '125',
		Retail: '109.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.5',
		ProductExtWidth: '8.5',
		ProductExtDepth: '11.5',
		ProductWeight: '6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--vlj2_fwU--/mzlp7wy3779echrlj5ut.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--37dKiJTX--/caa5cvclzkzumwd5oniv.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Hn9m89pS--/mvd2ckssry0zqdgw6hgt.jpg',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '78bc4df9-7928-456c-9716-ecdbbc25d1f2',
		ProductID: '3130',
		ProductName: '303 Cal .312 174 gr InterLock® RN',
		UPC: '090255231304',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.608',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255231301',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.12',
		PalletQtyBoxes: '540',
		Retail: '53.57',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.262',
		SectionalDensity: '0.255',
		OAL: '1.02',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '174',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TutcHjEk--/e2326a9b979af758418ae94bf7b67d14371fcf9e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3a118bac-1457-45e3-871e-e1b96bc8f4a1',
		ProductID: '75432',
		ProductName: 'Snapsafe® Keypad Vault',
		UPC: '842631100205',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.25',
		ShelfWidth: '13.25',
		ShelfDepth: '9.75',
		Weight: '6.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100202',
		CartonHeight: '11.125',
		CartonWidth: '14.250',
		CartonDepth: '22.500',
		CartonWeight: '32.0',
		PalletQtyBoxes: '240',
		Retail: '114.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Specialty Gun Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.25',
		ProductExtWidth: '11',
		ProductExtDepth: '8.5',
		ProductWeight: '4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Keypad Vaults take up little space but deliver big security. Offered in configurations to meet a variety of needs, these safes protect your handgun, electronics, or documents from damage or theft while keeping them close at hand for ready access. Recognized by the California Department of Justice as an approved Firearm Storage Device (FSD). 20-gauge steel housing. Foam-lined interior. Program more than 12 million access codes. Powered by four AA batteries (not included). Overall: 8.5”W x 11”H x 2.25”D Weight: 4 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--MAagxdpg--/hezp678vjnnbal9oi8o8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_pLy5Qf6--/eeu7gjhew3xpfhvaa6ee.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rlJnZxKp--/wrymnh0gluywzz9bagpv.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--uHRLqOwC--/etprcibwslbc4rnrghax.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--WlLX9TS1--/wnbidfg4mrbakoj6tm61.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--MMOFOe43--/mffpfszq78txrhjlaswb.jpg',
		Videos: 'https://vimeo.com/266768905',
		Videos1: 'https://vimeo.com/266770315',
		Videos2: 'https://vimeo.com/370420587',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4cab1699-4def-4b0e-879c-63ae8ca44b6c',
		ProductID: '546430',
		ProductName: 'Full-Length 2-Die Set 416 Wby (.416)',
		UPC: '090255564303',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564300',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '416 WBY MAG',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f86c91b-1897-4909-9333-6f51464993bf',
		ProductID: '332704',
		ProductName: '338 Cal .338 185 gr CX™',
		UPC: '090255719581',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719588',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.25',
		PalletQtyBoxes: '900',
		Retail: '65.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.407',
		SectionalDensity: '0.231',
		OAL: '1.43',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'CX™',
		BulletWeightGrain: '185',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--6NVytmyV--/yyhkw6tdwms2oz62oz8d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a5390ab-cefe-4731-9d7f-ea4ac1c7b1e2',
		ProductID: '046208',
		ProductName: 'Full-Length Size Die 20 Tactical (.204)',
		UPC: '090255462081',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462088',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '20 TACTICAL',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '939ea40b-1bde-4057-a4dc-858faf597276',
		ProductID: '390959',
		ProductName: 'Trimer Pilot #17 .410',
		UPC: '090255909593',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.022',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909590',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.22',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--0rCnPBvf--/njizxzttazianu6mn3ms.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '253246e3-68f2-43da-a11f-c97ed098bf7f',
		ProductID: '546537',
		ProductName: 'Full-Length 3-Die Set 38/55 WCF (.375)',
		UPC: '090255565379',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565376',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.75',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '38-55 WIN',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '27c502bb-f997-4dad-b8b1-5c5dae9f860f',
		ProductID: '3017B',
		ProductName: '30 Cal .308 110 gr FMJ',
		UPC: '090255630176',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '48.273',
		WeightUOM: 'LB',
		CaseQty: '3000',
		CartonUCC: '10090255630173',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '144819.0',
		PalletQtyBoxes: '126000',
		Retail: '0.00',
		ParentCategory: 'Bullets',
		Applications: 'AppVarmint',
		G1BC: '0.178',
		SectionalDensity: '0.166',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '110',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--1kf5KOnz--/jqc6uczhwarvlmorad1z.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-11-07 15:20:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8cfc92d1-2453-4003-9819-42f2aa617fe5',
		ProductID: '480040',
		ProductName: 'Universal Loading Block With Sleeve',
		UPC: '090255800401',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.500',
		ShelfWidth: '6.000',
		ShelfDepth: '1.000',
		Weight: '0.357',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800408',
		CartonHeight: '10.000',
		CartonWidth: '8.500',
		CartonDepth: '6.500',
		CartonWeight: '3.57',
		PalletQtyBoxes: '0',
		Retail: '12.27',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This double-sided block holds 50 cases and helps streamline powder charging and inspection. Fits 223, 308 and magnum case size heads. Also works with the Hornady® Fast Load Powder Measure Stand.',
		ProductImage: 'http://images.salsify.com/image/upload/s--coqCBNto--/bhtrkpbxhgvturtpbf5j.jpg',
		DateLastModified: '2023-12-16 09:02:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '475cd8b3-c3c9-4f4d-9ab4-a880a07ce4dc',
		ProductID: '392657',
		ProductName: 'Shell Plate #57 Lock-N-Load®AP™ & Projector',
		UPC: '090255926576',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926573',
		CartonHeight: '4.000',
		CartonWidth: '6.000',
		CartonDepth: '4.000',
		CartonWeight: '5.5',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Cartridge: '30 SUPER CARRY',
		Caliber: '32 CAL',
		BulletDiameter: '0.3115',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5bc123a9-7880-4cfe-b14a-d65ed6bc536e',
		ProductID: '392635',
		ProductName: 'Shell Plate #35 Lock-N-Load®AP™ & Projector',
		UPC: '090255926354',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.611',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926351',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '6.11',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0a88fff4-87bd-42f7-b373-c0d39bcfb37a',
		ProductID: '290036',
		ProductName: 'PTX™ Powder Through Expander .452',
		UPC: '090255900361',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900368',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dced0b60-3663-4e50-955e-f160ce15325c',
		ProductID: 'FR1015',
		ProductName: '223 Remington 55 gr FMJ  Frontier®',
		UPC: '090255712834',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '3.879',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712831',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '31.032',
		PalletQtyBoxes: '512',
		Retail: '128.51',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 223 Rem Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3TUhDzER--/c111763f3c24b3bc24e110262a9321b5017e772e.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a968974-7786-4aeb-b632-856b2d3b1b39',
		ProductID: '3562',
		ProductName: '9.3mm .366 250 gr GMX®',
		UPC: '090255235623',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255235620',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.5',
		PalletQtyBoxes: '540',
		Retail: '84.88',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.36',
		SectionalDensity: '0.267',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		BulletName: 'GMX®',
		BulletWeightGrain: '250',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5t7JXloH--/701a77cbb1d50bd410331729de0e080de6ccd1f9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0414419-60ac-4eab-956e-37b91871eb5f',
		ProductID: '99212',
		ProductName: 'Hornady® Blaze Orange Cap',
		UPC: '090255992120',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'VIETNAM',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bOB6eomV--/jac6tyglpeo5y6t7cfs0.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9ff30373-0703-40e1-90e3-6bb9de8d12d3',
		ProductID: '392636',
		ProductName: 'Shell Plate #36 Lock-N-Load®AP™ & Projector',
		UPC: '090255926361',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926368',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.63',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '56a1caa4-5426-4ca8-93b1-e59fce61d999',
		ProductID: '80563',
		ProductName: '270 Win 140 gr SST® Superformance®',
		UPC: '090255805635',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.267',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805632',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.67',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.495',
		MuzzleVelocity: '3090',
		MuzzleEnergy: '2968',
		SectionalDensity: '0.261',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bVBeJhgF--/27bd31dab2036959f4ae2f59e7a11cdaaaac5d89.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '34fa66c2-3127-4f1f-a511-469b958535f9',
		ProductID: '046424',
		ProductName: 'Full-Length Size Die 458 SOCOM (.458)',
		UPC: '090255464245',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464242',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '458 SOCOM',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '220ad38a-fab8-4462-be60-a6ad002918f4',
		ProductID: '044653',
		ProductName: 'Lock-N-Load® Control Panel Powder Level Check',
		UPC: '090255446531',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '12.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255446538',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.75',
		PalletQtyBoxes: '0',
		Retail: '26.84',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Level Sensor works in conjunction with the Lock-N-Load Control Panel, and is easily adjustable to signal an alarm when the powder hopper reaches the preferred depth for a reminder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--WW3i5CRD--/dxopm3dq4fxelmp5kulo.jpg',
		Videos: 'https://vimeo.com/96133806',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81621774-65ed-445c-9429-1e14a66d018f',
		ProductID: 'B300S',
		ProductName: 'Lock-N-Load® 300 Savage Modified Case',
		UPC: '090255703320',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255703327',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '300 SAVAGE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dbb36e12-1c87-4cbb-93f6-bbb107481fd2',
		ProductID: 'B2000',
		ProductName: 'Lock-N-Load® Bullet Comparator Body',
		UPC: '090255704082',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.058',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704089',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '0.58',
		PalletQtyBoxes: '0',
		Retail: '20.24',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--f2TPMlEa--/o0xrw1df5hqozha9aezy.pdf',
		ProductDescription:
			'Measuring cartridge lengths across the bullet tips is not a reliable (or repeatable) method for measuring loaded rounds. It’s common for variations of up to .025” to exist from one round to the next. Our Bullet Comparator measures rounds from the ogive to provide consistent, precise measurements. You can also use it to check uniformity of bullets from base to ogive. Our Bullet Comparator easily attaches to the blade of your caliper and uses interchangeable inserts (available in sizes from .17 caliber to .45 caliber) to measure from the bullet ogive. Used in conjunction with the O.A.L. Gauge, the Bullet Comparator provides the ultimate in precision measurement. The Bullet Comparator will properly align the O.A.L. Gauge for precise measurement using a caliper. This method allows direct comparison of your loads as you set up your bullet seating die for any selected bullet free-travel (jump).',
		ProductImage: 'http://images.salsify.com/image/upload/s--46owpJBx--/xzbp9up9lmxwie7sqnme.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd98d5fcf-3422-45fc-b5f8-e8235c97f792',
		ProductID: '95788',
		ProductName: 'Square-Lok™ 18" Panel',
		UPC: '090255957884',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '20',
		ShelfDepth: '38.25',
		Weight: '27.900',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255957881',
		CartonHeight: '39.170',
		CartonWidth: '21.060',
		CartonDepth: '7.480',
		CartonWeight: '55.8',
		PalletQtyBoxes: '0',
		Retail: '159.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you. 18”W x 36”H',
		ProductImage: 'http://images.salsify.com/image/upload/s--FKH7sMe6--/q9fs5vbdcdwekejiknpf.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4c312fc-246a-4f7e-8352-d4a68a0c376e',
		ProductID: '044126',
		ProductName: 'Seater Die #26 (.308-.310) 7.62X39',
		UPC: '090255441260',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.515',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441267',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6e4c0c1d-9ce3-46fe-8273-7aff62384862',
		ProductID: 'A222',
		ProductName: 'Lock-N-Load® 222 Rem Modified Case',
		UPC: '090255704389',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.017',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704386',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.17',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '222 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--trkdLeF9--/c8ecc06c2dbc324af64d574a644654de77024ea6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'db746ef5-1f01-483f-b138-7b71fd2b50a9',
		ProductID: '046041',
		ProductName: 'Neck Size Die 6mm (.243/.244)',
		UPC: '090255460414',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.483',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460411',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '6MM',
		BulletDiameter: '0.243/0.244',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da97cf52-de62-4b8b-880b-88b87465196a',
		ProductID: '8638',
		ProductName: '280 Remington Unprimed Cases',
		UPC: '090255486384',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486381',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.5',
		PalletQtyBoxes: '200',
		Retail: '64.60',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '280 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af70503f-32b1-416d-a30a-3cea75574406',
		ProductID: '2240',
		ProductName: '22 Cal .224 50 gr SP SX',
		UPC: '090255222401',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.787',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222408',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.48',
		PalletQtyBoxes: '1440',
		Retail: '24.57',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.214',
		SectionalDensity: '0.142',
		OAL: '0.66',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP SX®',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Z-rHhq7m--/8bccdd503a38795d9e29897b22ee80efc467520d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be09df5c-64bc-4810-a68d-c5c1bdaac508',
		ProductID: '594292',
		ProductName: 'Match™ Grade Bushing .292',
		UPC: '090255592924',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592921',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.292',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--o8A83aR8--/2b08796bd4c1f7d38be68eed768096100e20712e.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19dd70dd-7fa0-49f5-b46a-bea9b812efad',
		ProductID: '546312',
		ProductName: 'Full-Length 2-Die Set 7X64 (.284)',
		UPC: '090255563122',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563129',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7X64',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b77123de-2c96-4d5d-be18-e440f33b4f55',
		ProductID: '75891',
		ProductName: 'Snapsafe® Silicone Sock - Rifle',
		UPC: '851529004693',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '6',
		ShelfDepth: '1.75',
		Weight: '0.640',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004690',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '3.2',
		PalletQtyBoxes: '600',
		Retail: '0.00',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'SOLVENTS',
		Prop65Chem2: 'SOLVENTS',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '75',
		MasterPackUCC: '30851529004694',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '48.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--iy-MU7Fy--/yvgtnrzzwyyprqdpp5id.jpg',
		Videos: 'https://vimeo.com/221429348',
		DateLastModified: '2023-11-07 15:02:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b6e1bf93-8b81-4cd5-8ed6-5cf607ed9537',
		ProductID: '044143',
		ProductName: 'Seater Die (.312) 327 Fed/32 S&W/H&R',
		UPC: '090255441437',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.553',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441434',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cb779cc7-2240-4baf-b973-e936bc231952',
		ProductID: 'A22250',
		ProductName: 'Lock-N-Load® 22-250 Rem Modified Case',
		UPC: '090255704693',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.027',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704690',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.27',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Mm43P5a5--/6199b9a4bc1f73c5dbd1f9ef7d9da41b3e1b0987.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8976b9a-f918-4fe5-a585-f62d139f7c5a',
		ProductID: '90063',
		ProductName: '32 Auto 60 gr FTX® Critical Defense®',
		UPC: '090255900637',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900634',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '5.0',
		PalletQtyBoxes: '1120',
		Retail: '37.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.07',
		MuzzleVelocity: '1000',
		MuzzleEnergy: '133',
		SectionalDensity: '0.089',
		Cartridge: '32 AUTO',
		Caliber: '32 CAL',
		BulletDiameter: '0.311',
		BulletName: 'FTX®',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pxuC5FEq--/0496322ac2edb7d109ecaa56d401960a09fcfa08.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		Videos1: 'https://vimeo.com/295270437',
		Videos2: 'https://vimeo.com/294885327',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e0b25d8b-b45e-4afd-bd22-f78fc018636f',
		ProductID: '80260',
		ProductName: '223 Remington 73 gr Critical Defense®',
		UPC: '090255802603',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.640',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802600',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.4',
		PalletQtyBoxes: '1680',
		Retail: '36.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Rifle Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.26',
		MuzzleVelocity: '2790',
		MuzzleEnergy: '1262',
		SectionalDensity: '0.208',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FTX®',
		BulletWeightGrain: '73',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKoEV_aJ--/zdwwzqo49qghiibnanqz.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EGnFPekN--/b0115bc4a5d68f6536fbe502128f5b962135f56a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ryDaQrK3--/kcfhxhg0kodiwcr6over.png',
		ProductImage2:
			'http://images.salsify.com/image/upload/s--9FXfaIjW--/c5af05d9b6ad4e722289a84ab899f9669829a6f2.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--wly5_HJT--/yt7vaaptixnx6sz5ph6o.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--WtiVk7N3--/xr3oximw0vgyhtgsvcmi.jpg',
		Videos: 'https://vimeo.com/238317634',
		Videos1: 'https://vimeo.com/257722358',
		Videos2: 'https://vimeo.com/241903262',
		Videos3: 'https://vimeo.com/286002665',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b6538ab8-68c3-48e5-b97a-6eb4182d93a3',
		ProductID: 'B338',
		ProductName: 'Lock-N-Load®338 Rem Ultra Mag Modified Case',
		UPC: '090255704181',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.042',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704188',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.42',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '338 REM ULTRA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '863b1d52-9b12-4682-af50-29ac3e0c6941',
		ProductID: '2263B',
		ProductName: '22 cal .224 55 gr HP',
		UPC: '090255702767',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '48.273',
		WeightUOM: 'LB',
		CaseQty: '6000',
		CartonUCC: '10090255702764',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '289638.0',
		PalletQtyBoxes: '270000',
		Retail: '0.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppPersonalDefense',
		G1BC: '0.254',
		SectionalDensity: '0.157',
		OAL: '0.755',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '64909',
		MasterPackUCC: '30090255702768',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '3133352.157',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zt_ifALk--/95faba75844563bab8af662422f35593fec26a4d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d68078c-b876-4e6e-8c3a-01639d56fa41',
		ProductID: '050006',
		ProductName: 'Primer Turning Plate',
		UPC: '090255500066',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '4.375',
		ShelfDepth: '4.375',
		Weight: '0.109',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500063',
		CartonHeight: '9.000',
		CartonWidth: '5.000',
		CartonDepth: '3.000',
		CartonWeight: '1.09',
		PalletQtyBoxes: '0',
		Retail: '10.08',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Orients all primer either up or down. A “must have” if you’re using an automatic primer feed with a pick-up tube.',
		ProductImage: 'http://images.salsify.com/image/upload/s--iH92xO73--/w9m0zkmzquqyv3iphule.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4afd2cf6-8ac0-4690-9dbe-915d27954ff4',
		ProductID: '9150',
		ProductName: '454 Casull 300 gr XTP® Mag',
		UPC: '090255391503',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.405',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391500',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '14.05',
		PalletQtyBoxes: '1120',
		Retail: '55.85',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.18',
		MuzzleVelocity: '1650',
		MuzzleEnergy: '1813',
		SectionalDensity: '0.21',
		Cartridge: '454 CASULL',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--AF5-VqhL--/c5148359e4c4e5c685daba7d10146bcad9d5e57e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e3064e4-6da4-4508-b9d3-921f9f1621f8',
		ProductID: '3045',
		ProductName: '30 Cal .308 165 gr InterLock® BTSP',
		UPC: '090255230451',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.572',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230458',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.58',
		PalletQtyBoxes: '540',
		Retail: '48.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.435',
		SectionalDensity: '0.248',
		OAL: '1.195',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Aqk7zkp7--/d25ea6d11f7bbbd1be7611374c5174be68f04285.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '996ebae7-d6b9-460f-84f8-9d87900dc2cb',
		ProductID: '046283',
		ProductName: 'Full-Length Size Die 6.5X55 (.264)',
		UPC: '090255462838',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.570',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462835',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '98a0de3c-473d-4957-9ad1-2c2891c38a39',
		ProductID: '30501',
		ProductName: '30 Cal .308 168 gr BTHP Match',
		UPC: '090255230512',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.518',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230519',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.77',
		PalletQtyBoxes: '540',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.45',
		SectionalDensity: '0.253',
		OAL: '1.23',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1Xn9M-v9--/4fff3186b6a911324d1eabacee1d69431239ab79.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '85cd70c0-1800-49db-831e-e8b14cf95968',
		ProductID: '35710',
		ProductName: '38 Cal .357 125 gr XTP®',
		UPC: '090255235715',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.883',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235712',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.075',
		PalletQtyBoxes: '900',
		Retail: '31.41',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.151',
		SectionalDensity: '0.14',
		OAL: '0.55',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RfGJZ6Bd--/9367d803ddd7d9c5fff4386aa9f9747f6d116feb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8dd6b63-f4d3-48df-9cf4-471931c1da04',
		ProductID: 'A9362',
		ProductName: 'Lock-N-Load® 9.3X62 Modified Case',
		UPC: '090255704938',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.032',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704935',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.32',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '9.3X62',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vEzmr4fg--/cf53cc6b6415236bfe218a6f0f29de16d77a510e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '30a301f7-1b1e-4e86-8cc5-1cfb8a0b54eb',
		ProductID: '046043',
		ProductName: 'Neck Size Die 6.5mm (.264)',
		UPC: '090255460438',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.492',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460435',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '293a1ce1-189b-44cb-9041-14f7c20eb28a',
		ProductID: '33389',
		ProductName: '338 Cal .338 300 gr A-TIP Match',
		UPC: '090255333893',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '4.660',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255333890',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '46.6',
		PalletQtyBoxes: '240',
		Retail: '145.21',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.863',
		G7BC: '0.435',
		MinTwist: '1-10"',
		SectionalDensity: '0.375',
		OAL: '1.865',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YAuEkAuj--/kqgl4fskiff99wkqqjqd.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2024-03-06 16:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a9a1a504-1cd4-40d2-bbb0-f934df1d6b80',
		ProductID: '9052',
		ProductName: '357 Mag 130 gr MonoFlex Handgun Hunter',
		UPC: '090255390520',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.888',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390527',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.88',
		PalletQtyBoxes: '1120',
		Retail: '53.53',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.146',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--68hK0bl7--/ovh8tqjtusy9d89gt3t4.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df774f50-cb9d-4aa7-ad3e-0eb8f0e27292',
		ProductID: '391930',
		ProductName: 'Neck Turn Mandrel 338',
		UPC: '090255919301',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919308',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '338 CAL',
		BulletDiameter: '0.3355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4da0a94-9bbb-4a09-a96f-6a3b146916ec',
		ProductID: '10408',
		ProductName: '38 Cal .358 158 gr SWC',
		UPC: '090255104080',
		PackagedQTY: '300',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '7.050',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255104087',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.3',
		PalletQtyBoxes: '216',
		Retail: '49.93',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Frontier® Lead Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.135',
		SectionalDensity: '0.176',
		Caliber: '38 CAL',
		BulletDiameter: '0.358',
		BulletName: 'SWC',
		BulletWeightGrain: '158',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5fIlj1Aa--/d97129fe7340a25de3530e9dee5352bd4ccc509c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa790e88-9520-4dac-b2f7-625eb462bb60',
		ProductID: '821974',
		ProductName: '300 Win Mag 180 gr. CX™ Outfitter®',
		UPC: '090255719871',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719878',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.95',
		PalletQtyBoxes: '780',
		Retail: '75.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.469',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3502',
		SectionalDensity: '0.271',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Un7fv-ah--/adrol5zaxpsbw8av3kue.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2d0a564a-62e6-41f5-a5ac-3cb7d1f14afd',
		ProductID: '22402',
		ProductName: '22 Cal. .224 50 gr. CX™',
		UPC: '090255224023',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.500',
		Weight: '0.428',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255224020',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '17.12',
		PalletQtyBoxes: '1440',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppVarmint',
		G1BC: '.164',
		MinTwist: '1-12"',
		SectionalDensity: '0.142',
		OAL: '0.763',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'CX™',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--KAjEDcqs--/hwrtpyodl4vh3zcshpyx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--YBHFtVvw--/xhszmnkdtrrq9gs3uw2n.png',
		Videos: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4408d19d-a0ea-4fb4-bb05-0cb5d3cda7ba',
		ProductID: '190147',
		ProductName: 'Powder Bushing 390',
		UPC: '090255191479',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.057',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191476',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.57',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c5e73d92-33b3-4210-8f26-8a83a5d79b32',
		ProductID: '2278B',
		ProductName: '22 Cal .224 68 gr BTHP Match',
		UPC: '090255690484',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '44.844',
		WeightUOM: 'LB',
		CaseQty: '4500',
		CartonUCC: '10090255690481',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '201798.0',
		PalletQtyBoxes: '189000',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.355',
		SectionalDensity: '0.194',
		OAL: '0.986',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '68',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vYCze9iI--/b8b840a6d79d2378abef800979e31aabc28fe4b8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '24e607a6-a343-4190-96f9-05ef2f0d1889',
		ProductID: '45015',
		ProductName: '45 Cal .458 325 gr FTX® (45-70 & 450 Marlin)',
		UPC: '090255450156',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.460',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450153',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.9',
		PalletQtyBoxes: '540',
		Retail: '54.47',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.23',
		SectionalDensity: '0.221',
		OAL: '1.1',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'FTX®',
		BulletWeightGrain: '325',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ciBjWBwX--/d3ddf821a504b1980e7737b9a1d2e028bbe66cd4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a9be7f8e-bcc2-4351-a370-6c2aba6b8851',
		ProductID: '2270',
		ProductName: '22 Cal .224 60 gr SP',
		UPC: '090255222708',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.937',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222705',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.48',
		PalletQtyBoxes: '1440',
		Retail: '25.67',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.264',
		SectionalDensity: '0.171',
		OAL: '0.755',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--FGjzTdvH--/4ddda54ff4c7f2f2e6d1f788f1644c0991e88536.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1d85c7b0-bbb4-4bc2-930c-1b5a8d29adf5',
		ProductID: '594285',
		ProductName: 'Match™ Grade Bushing .285',
		UPC: '090255592856',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592853',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.285',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x5OR3oDu--/c0ea89ecfb219214ade9a2ebb297bf285e3c0816.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '265224d4-d0cb-4139-b76c-84e9386f03e7',
		ProductID: '546394',
		ProductName: 'Full-Length 2-Die Set 348 Win (.348)',
		UPC: '090255563948',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563945',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '348 WIN',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f18836a7-d4de-4354-ae14-581688cd2fb0',
		ProductID: '82162',
		ProductName: '300 PRC 225 gr ELD® Match',
		UPC: '090255821628',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.830',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821625',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '18.3',
		PalletQtyBoxes: '780',
		Retail: '76.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.777',
		G7BC: '0.391',
		MuzzleVelocity: '2810',
		MuzzleEnergy: '3945',
		SectionalDensity: '0.339',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_o29y0V1--/4731c2663c41f168c6e6e6459e9ae2cef604025f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		Videos1: 'https://vimeo.com/294885189',
		Videos2: 'https://vimeo.com/295448905',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2513f6b2-4d47-44de-bf94-46364f5888d4',
		ProductID: '8325',
		ProductName: '223 Rem 40 gr V-MAX® Varmint Express®',
		UPC: '090255383256',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.553',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383253',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.53',
		PalletQtyBoxes: '1680',
		Retail: '27.24',
		ParentCategory: 'Ammunition',
		Applications: 'AppVarmint',
		G1BC: '0.2',
		SectionalDensity: '0.114',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ctsCjTij--/871173ac21eae942f3244273098780c857a37402.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bbd2d9cf-6bad-4826-85f3-1fbb7f06e957',
		ProductID: '546336',
		ProductName: 'Full-Length 2-Die Set 30 Luger (.308)',
		UPC: '090255563368',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563365',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '30 LUGER',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dbc2bbe5-e57d-40cf-9339-2ec122bb148c',
		ProductID: '80956',
		ProductName: '308 Win 155 gr ELD® Match',
		UPC: '090255809565',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809562',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.5',
		PalletQtyBoxes: '1400',
		Retail: '42.57',
		ParentCategory: 'Ammunition',
		Applications: 'AppTargetMatch',
		G1BC: '0.461',
		G7BC: '0.232',
		SectionalDensity: '0.233',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '155',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ga3yiSgj--/e9b96b57f84aa826bfbf991532f3af272b2d2363.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd4866bb5-afd7-4e83-ae8f-662d46fe90a8',
		ProductID: '2441',
		ProductName: '6mm .243 90 gr ELD-X®',
		UPC: '090255224412',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.384',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224419',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.6',
		PalletQtyBoxes: '900',
		Retail: '61.79',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.409',
		G7BC: '0.206',
		MinTwist: '1-10"',
		SectionalDensity: '0.218',
		OAL: '1.104',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VUA0S21F--/e3cf500ac3cdd22649e6e89d47c0dad9de3001fd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ba3f8f97-7583-4f96-a575-f41711ea5ac0',
		ProductID: 'C30378',
		ProductName: 'Lock-N-Load® 30/378 Wby Modified Case',
		UPC: '090255704648',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.75',
		ShelfDepth: '0.75',
		Weight: '0.052',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704645',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.52',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '30-378 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ee7163b-d125-4d42-aee5-e73267d61fc0',
		ProductID: '390956',
		ProductName: 'Trimer Pilot #14 .348',
		UPC: '090255909562',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.020',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909569',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.2',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--59WYKM44--/pma8blirqmmaktsnzag3.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b94a190-ca23-4896-b861-2f7e55e682ad',
		ProductID: '490313',
		ProductName: 'Crimp Starter 12 Gauge Paper',
		UPC: '090255943139',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.5',
		ShelfDepth: '0.05',
		Weight: '0.036',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255943136',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.36',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Universal Crimp Starters',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--CE5yeAr4--/baehdwiavoqrlfxfwz26.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b2022e5-33e9-4c24-afda-106f913e6259',
		ProductID: 'FR700',
		ProductName: '6.5 Grendel 123 gr FMJ Frontier',
		UPC: '090255716368',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255716365',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1400',
		Retail: '31.04',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 6.5 Grendel Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '.420',
		MuzzleVelocity: '2580',
		MuzzleEnergy: '1818',
		SectionalDensity: '0.252',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'FMJ',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--i668u2wP--/mclxsyeimp0b0cvwznwh.png',
		DateLastModified: '2024-01-08 15:22:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '07d41f15-cc82-4014-a9af-720f6d0ff95f',
		ProductID: '8687',
		ProductName: '416 Rigby Unprimed Cases',
		UPC: '090255486872',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '1.161',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486879',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.805',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '416 RIGBY',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 09:00:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90a05f6f-1f92-4c73-9e5c-cd01f7f1bc91',
		ProductID: '90044',
		ProductName: '4.6x30mm 38 gr. V-MAX® Hornady BLACK®',
		UPC: '090255900446',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.500',
		Weight: '0.480',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900443',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '4.8',
		PalletQtyBoxes: '1120',
		Retail: '37.95',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		SectionalDensity: '0.162',
		Cartridge: '4.6X30MM',
		Caliber: '4.6 CAL',
		BulletDiameter: '0.183',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '38',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--eTH3vgdO--/bnn9pj0qpuawj2pwt0yz.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '71d71b59-6a44-48de-a10d-8d32db3e5f2c',
		ProductID: '50101',
		ProductName: '50 AE .500 300 gr XTP® Mag',
		UPC: '090255501018',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.265',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255501015',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.975',
		PalletQtyBoxes: '540',
		Retail: '72.55',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.12',
		SectionalDensity: '0.171',
		OAL: '0.665',
		Cartridge: '50 AE',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'eXtreme Terminal Performance — Magnum Designed for personal defense and medium-game hunting, XTP® Mag™ bullets provide the same controlled expansion, accuracy and dependability that have made XTP® bullets a favorite among target shooters and hunters alike. But XTP® Mag™ bullets are designed to take things a step further — withstanding the higher velocities and impacts of ultra-powerful, magnum handguns while delivering even deeper penetration than standard XTP® bullets. CONTROLLED EXPANSION Precise serrations divide the XTP® Mag™ into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP® Mag™, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GttIEcxR--/3b630c46888f7ea1bf0f7114d9771a981f24bad3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--fNEP3eEi--/c6xiskezhxjfyogooood.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--F_Cbrvpn--/tpherltglxbuacgasgkq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--Wu1gxnR3--/aubrxvxeyt2d14nfehgo.jpg',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ff60b058-8163-4f54-a81e-dae134367279',
		ProductID: '046284',
		ProductName: 'Full-Length Size Die 6.5 PRC (.264)',
		UPC: '090255462845',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462842',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5 PRC',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '840bace2-7a2c-49a0-923f-17accdbe5adc',
		ProductID: '043200',
		ProductName: 'Die Maintenance Kit',
		UPC: '090255432008',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '0.5',
		Weight: '0.157',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255432005',
		CartonHeight: '6.750',
		CartonWidth: '1.750',
		CartonDepth: '0.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '19.67',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This comprehensive Hornady® Die Maintenance Kit includes all the small parts and accessories a reloader may need to keep any reloading interruptions to a minimum. The Hornady® Die Maintenance Kit Includes: Qty 1: Sure-Lock® Lock Ring • Qty 2: Zip Spindle™ • Qty 3: Headed Decap Pins • Qty 1: Decap Pin Retainer • Qty 1: 3/32 Allen Wrench • Qty 5: Retaining Rings  Other accessories sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--iCMa0dJN--/xhhq5wtvwx0zal43yol8.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b79eef74-2611-4391-911d-ce7616ee6fe9',
		ProductID: '2266',
		ProductName: '22 Cal .224 55 gr SP with cannelure',
		UPC: '090255222661',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.856',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222668',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.24',
		PalletQtyBoxes: '1440',
		Retail: '24.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		OAL: '0.725',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTSP W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oohUZfyk--/532ec9d18768be24027cd2104f46486d832cf968.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20701742-1ccb-4668-b0c2-3692442f816c',
		ProductID: '30459',
		ProductName: '30 Cal .308 165 gr InterBond®',
		UPC: '090255304596',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.450',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255304593',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.75',
		PalletQtyBoxes: '540',
		Retail: '98.40',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '165',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pIlMKOZ0--/161b1e16b2f5fef601331f4bfecfb834e5671de5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '09a0c4e0-7422-413c-9255-9f0069d004ef',
		ProductID: 'B240',
		ProductName: 'Lock-N-Load® 240 Wby Mag Modified Case',
		UPC: '090255704907',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.032',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704904',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.32',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '240 WBY MAG',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--X4autAlR--/ae0d4a004d6f140ee06b7797d6d459a780a8e8ad.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '216abc5c-e3b7-4e6c-81cf-05cb2cad7dbb',
		ProductID: '041228',
		ProductName: 'Primer Pocket Single Stage Swage Tool (308)',
		UPC: '090255412284',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.25',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.825',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '5.250',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '90.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Cartridge: '308 WIN/7.62X51 NATO',
		Caliber: '30 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Single-Stage Primer Pocket Swage Tool The Single Stage Primer Pocket Swage Tool quickly and cleanly removes crimps on cartridge case primer pockets. Available in 223/5.56 and 308/7.62x51 sizes, swage depth can be adjusted to accomodate various brands of cases. Swaging out the crimps instead of cutting them eliminates trims and mess. It is designed to be used on any compatible single stage press, and comes with swage tool, case handle, and shell holder to make your job easier.',
		ProductImage: 'http://images.salsify.com/image/upload/s--9yA5hNnI--/tvxowcftp78gme1qzium.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e3fb36d-5e23-442f-b87f-018084ebabec',
		ProductID: '392610',
		ProductName: 'Shell Plate #10 Lock-N-Load®AP™ & Projector',
		UPC: '090255926101',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.557',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926108',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.57',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3f80693-8c53-47fa-94ac-c9f3e03804a2',
		ProductID: '45230',
		ProductName: '45 Cal .452 300 gr XTP®',
		UPC: '090255245233',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.239',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245230',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.585',
		PalletQtyBoxes: '540',
		Retail: '30.47',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.18',
		SectionalDensity: '0.21',
		OAL: '0.78',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'XTP®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vvSFX6OF--/41dc971c2071b8752a4bee1080c03c899e53b4e0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c70bc72a-13e2-4647-95f8-21a6ad413af1',
		ProductID: '75416',
		ProductName: 'Snapsafe® Vault Door (32" X 80")',
		UPC: '851529004860',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.25',
		ShelfWidth: '87',
		ShelfDepth: '44.5',
		Weight: '390.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '14.240',
		CartonWidth: '87.000',
		CartonDepth: '44.500',
		CartonWeight: '390.0',
		PalletQtyBoxes: '1',
		Retail: '1819.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Vault Doors',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '9V',
		BatteryQty: '1',
		BatteryWattHour: '5.49',
		BatteryWeight: '33.9',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '80',
		ProductExtWidth: '32',
		ProductExtDepth: '6.3',
		ProductWeight: '330',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Enhance the security of any closet, room, or storm shelter with the SnapSafe Vault Door. Its thick steel construction and easy installation allow an effective and affordable way to protect an existing area from theft and unintended intrusion.  Your SnapSafe vault door comes standard with a SecuRam™ digital lock with key backup. 12 gauge door and door frame. Nine 1" live locking bolts. SecuRam™ digital lock with key backup (standard). Steel trimmed exterior. All tools and hardware are included in the handy tool kit. For Standard 32" door opening Door height: 81" Inside clearance width: 27.4" Outside width: 32.8"',
		ProductImage: 'http://images.salsify.com/image/upload/s--GbSh0fbR--/jrcnbfsc7hfjddll6znz.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--nTfLwYSI--/r7pjmjvnedw49qjeaud7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--u6Vw40g4--/yhn2shzsycr25fgv26nn.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--mLJvifI6--/oh73hx7o7yb0gt6mnqnv.pdf',
		Videos: 'https://vimeo.com/213867331',
		Videos1: 'https://vimeo.com/370420587',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48557ef6-7a21-40d8-bdba-f09ebf32824d',
		ProductID: '546342',
		ProductName: 'Full-Length 2-Die Set 30/30 Win (.308)',
		UPC: '090255563429',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.436',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563426',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.18',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca784ea7-f6e1-453c-8da1-b3e7503d732a',
		ProductID: '046454',
		ProductName: 'Full-Length Size Die 7mm Rem Ultra Mag (.284',
		UPC: '090255464542',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.575',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464549',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM REM ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e75b2c12-1967-4c3d-b40c-8d61c8a36d3c',
		ProductID: '046248',
		ProductName: 'Match™ Grade Full-Length Size Die 300 Norma Mag (.308)',
		UPC: '090255462487',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462484',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '300 NORMA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93a15c19-14ab-4b7c-b077-8facd809534d',
		ProductID: '044190',
		ProductName: 'Seater Die (.458) 45 Cal W/281',
		UPC: '090255441901',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441908',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4901639a-5872-49ff-ae9d-96eda59809f6',
		ProductID: '7040',
		ProductName: '6.5mm Gas Checks',
		UPC: '090255270402',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.346',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255270409',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '8.65',
		PalletQtyBoxes: '900',
		Retail: '57.79',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '6.5MM',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a39e25b-c9d1-42f7-9659-55157c36add7',
		ProductID: '046240',
		ProductName: 'Match™ Grade Full-Length Size Die 300 Win Mag (.308)',
		UPC: '090255462401',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462408',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '770081d0-2ed6-4a1b-9120-49f101f3d848',
		ProductID: '544311',
		ProductName: 'Match™ Grade 2-Die Set 7mm Rem SAUM (.284)',
		UPC: '090255543117',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543114',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.25',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '7MM REM SA ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '847a74f6-56ae-4148-800c-bf201279e8f3',
		ProductID: '380705',
		ProductName: 'Cartridge Gauge 44 Mag (.430)',
		UPC: '090255807059',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807056',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4748a7ff-c72a-4197-b566-11956302cb1b',
		ProductID: '8102',
		ProductName: '30 Carbine 110 gr FMJ',
		UPC: '090255381023',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.625',
		ShelfDepth: '5.25',
		Weight: '1.520',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381020',
		CartonHeight: '5.687',
		CartonWidth: '5.937',
		CartonDepth: '11.187',
		CartonWeight: '15.2',
		PalletQtyBoxes: '840',
		Retail: '47.87',
		ParentCategory: 'Ammunition',
		G1BC: '0.178',
		SectionalDensity: '0.166',
		Cartridge: '30 CARBINE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ',
		BulletWeightGrain: '110',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZX5lqHis--/d6b306ec3a5238195d5087e2fefc7895c330abde.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8743e23a-99a3-4a78-af27-76cc428258e2',
		ProductID: '8309',
		ProductName: '222 Rem 35 gr NTX® Superformance® Varmint',
		UPC: '090255383096',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.515',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383093',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.15',
		PalletQtyBoxes: '1680',
		Retail: '35.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.17',
		MuzzleVelocity: '3760',
		MuzzleEnergy: '1099',
		SectionalDensity: '0.1',
		Cartridge: '222 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'NTX®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Compressed Copper Alloy',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--dhlFNBLZ--/af90026a8765921e2a4af756e1439b5955b4e25b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '895dd246-efae-4fef-9bd9-743db2dc473f',
		ProductID: '4507',
		ProductName: '45 Cal .458 500 gr DGS®',
		UPC: '090255245073',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.743',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245070',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '56.145',
		PalletQtyBoxes: '540',
		Retail: '109.44',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		SectionalDensity: '0.341',
		OAL: '1.372',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--eBI53HTU--/2529c71cb2de6410bd6f67b65acc4fbab32a0cc5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '477ba04f-5f42-417f-953a-c631dc21d259',
		ProductID: '044169',
		ProductName: 'Seater Die 38 Spl/357 Mag Cowboy™',
		UPC: '090255441697',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441694',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3079b89-4475-47fc-8054-975b5e097dcf',
		ProductID: '046583',
		ProductName: 'Size Die 45 Colt (.452)',
		UPC: '090255465839',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.465',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465836',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fde22d5a-be5e-4573-9c4d-3fd8cae071d5',
		ProductID: '22606',
		ProductName: '20 Cal .204 40 gr V-MAX®',
		UPC: '090255226065',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.539',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255226062',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.475',
		PalletQtyBoxes: '900',
		Retail: '74.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.275',
		SectionalDensity: '0.137',
		OAL: '0.75',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '40',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mdHdseS7--/7be35ddb5bd60a4a92f36c12c51606507603b38e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fe346890-aad2-45c5-b08a-2a001e1202d1',
		ProductID: '81247',
		ProductName: '5.45 x 39MM 60 gr V-MAX Hornady BLACK',
		UPC: '090255812473',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255812470',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.0',
		PalletQtyBoxes: '1680',
		Retail: '26.60',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		G1BC: '0.285',
		MuzzleVelocity: '2810',
		MuzzleEnergy: '1052',
		SectionalDensity: '0.175',
		Cartridge: '5.45X39',
		Caliber: '5.45 CAL',
		BulletDiameter: '0.2215',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '60',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA! Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--RsyHaCKg--/cmkwpcghq7orsg2mdkyj.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '901e15cb-79df-40fc-b1c5-bc645ec22078',
		ProductID: '9115',
		ProductName: '45 Colt 255 gr Cowboy',
		UPC: '090255391152',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.178',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391159',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '11.78',
		PalletQtyBoxes: '1120',
		Retail: '35.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppTargetMatch',
		G1BC: '0.117',
		MuzzleVelocity: '725',
		MuzzleEnergy: '298',
		SectionalDensity: '0.177',
		Cartridge: '45 COLT',
		Caliber: '45 CAL',
		BulletDiameter: '0.454',
		BulletName: 'COWBOY™',
		BulletWeightGrain: '255',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Western Action Shooting Action Shooters demand total reliability from their ammo — and Hornady delivers! Like all Hornady ammo, our Cowboy™ rounds are engineered to perform flawlessly. Thanks to our swaged bullets, the projectile flattens at the target instead of fragmenting. Our propellants are the cleanest-burning, and the diamond knurling means the bullet is lubed the entire length of the bearing surface. It all adds up to the highest quality ammo on the market. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--pi2AAYaK--/ganwhfvg67oxlbahwtap.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5TYCGwnO--/84c0bda96fa56c425fd518f5a2c9c99583dca72a.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce722704-7b77-42c5-9e7c-635892de6aaf',
		ProductID: '4305',
		ProductName: '44 Cal .430 265 gr FTX® (444 Marlin)',
		UPC: '090255243055',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.017',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255243052',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '30.255',
		PalletQtyBoxes: '540',
		Retail: '52.93',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FTX® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.225',
		SectionalDensity: '0.205',
		OAL: '1.035',
		Cartridge: '444 MARLIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FTX®',
		BulletWeightGrain: '265',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lp-ZD9rc--/d9264839b5f92f70baa6686909c3dba3eea2f068.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e271ad40-a433-4cda-8205-82898a110a2a',
		ProductID: '046232',
		ProductName: 'Match™ Grade Full-Length Size Die 284 Win (.284)',
		UPC: '090255462326',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462323',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '284 WIN',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '41d8e703-2697-451f-8c90-5985ac409b5f',
		ProductID: '33270',
		ProductName: '338 Cal .338 185 gr GMX®',
		UPC: '090255332704',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255332701',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.25',
		PalletQtyBoxes: '900',
		Retail: '62.19',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.42',
		SectionalDensity: '0.231',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'GMX®',
		BulletWeightGrain: '185',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--So3sfZE1--/511319edc8e49c44ce5e9246b2a002e39383e0c7.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c18bbe20-5796-4663-8e74-47536bd50ca4',
		ProductID: '2638',
		ProductName: '6.5mm .264 153 gr A-TIP Match',
		UPC: '090255226386',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '2.474',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255226383',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '24.74',
		PalletQtyBoxes: '240',
		Retail: '114.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.704',
		G7BC: '0.355',
		MinTwist: '1-8"',
		SectionalDensity: '0.314',
		OAL: '1.524',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '153',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--IL1oQdyz--/lqms6ujllscf5fsd0zla.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e674de73-7c6b-4526-9281-ab36bac506cc',
		ProductID: '546521',
		ProductName: 'Full-Length 3-Die Set 38 S&W (.357)',
		UPC: '090255565218',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565215',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '38 S&W',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c9240b12-3e74-4ca4-85b2-7b92cc4e31e2',
		ProductID: '046234',
		ProductName: 'Match™ Grade Full-Length Size Die 7mm Rem Mag (.284)',
		UPC: '090255462340',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462347',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '32b4959c-e9b5-41ce-8351-7c3a8f84be7c',
		ProductID: '76011',
		ProductName: 'Snapsafe® Hanging Shelf Basket LG',
		UPC: '851529004761',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '11.75',
		ShelfDepth: '9',
		Weight: '2.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004768',
		CartonHeight: '9.625',
		CartonWidth: '12.325',
		CartonDepth: '15.625',
		CartonWeight: '13.0',
		PalletQtyBoxes: '225',
		Retail: '29.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '7.5',
		ProductExtWidth: '11.75',
		ProductExtDepth: '9',
		ProductWeight: '2.3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Ideal for gun safes, these coated wire baskets maximize storage for ammo and accessories. Simply slide onto a .5" - 1" thick shelf. Holds up to 40 pounds.  Easy Install Holds up to 40 pounds. Maximizes storage for ammo and accessories. Coated wire will not damage accessories. Dimensions: 11.75”W x 7.5”H x 9”D Weight: 2.36 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--QnJLgu86--/q3fy0svofkx6to28vzt4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--592dLG2f--/nnlyasbgr4zr5vdv8naz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uR89_2AV--/egensng2dct2lr1k7t0a.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--phm3NZXu--/vqe59lxhkooefsrjfidp.jpg',
		Videos: 'https://vimeo.com/213931086',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd9eb5cdd-6618-41bd-b64d-866f2a07de8e',
		ProductID: '190135',
		ProductName: 'Powder Bushing 336',
		UPC: '090255191356',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.068',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191353',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.68',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4117b694-5831-4eb4-b599-7cf97dee9faa',
		ProductID: '594291',
		ProductName: 'Match™ Grade Bushing .291',
		UPC: '090255592917',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592914',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.291',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VmfnaZGj--/9cad5d90957976b9c58d68f8eb843d3de4adcddb.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '96bcb778-a54b-46fa-9c0c-d151bb814fb5',
		ProductID: '398511',
		ProductName: 'Lock-N-Load® Primer Pickup Tube Lg 3 Pack',
		UPC: '090255985115',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '16',
		ShelfWidth: '4',
		ShelfDepth: '0.75',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255985112',
		CartonHeight: '6.500',
		CartonWidth: '6.500',
		CartonDepth: '16.000',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '39.84',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Stocking your reloading bench with extra primer pick-up tubes will allow you to load more rounds without stopping to refill primers. Compatible with the Lock-N-Load® AP™ and Lock-N-Load® Iron Press™ *Not compatible with 1911 Auto Primer Tube Filler*',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZUJOjVud--/fthgrtqwh25w7cbsmhht.jpg',
		DateLastModified: '2023-12-16 09:02:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bf77ef30-ad45-468e-be4e-fd41220e28e4',
		ProductID: '046327',
		ProductName: 'Full-Length Size Die 7mm Rem Mag (.284)',
		UPC: '090255463279',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.540',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463276',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9e222bed-5b24-4358-92ec-67524a96231f',
		ProductID: '044153',
		ProductName: 'Seater Die (.458) 458 Win-460 Wby',
		UPC: '090255441536',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.592',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441533',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6143a1d1-6cbb-4bc1-903e-1ddd1f10a1df',
		ProductID: '82313',
		ProductName: '338 Lapua Magnum 270 gr ELD-X® Precision Hunter®',
		UPC: '090255823134',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.190',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823131',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '13.14',
		PalletQtyBoxes: '396',
		Retail: '176.07',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.757',
		G7BC: '0.381',
		MuzzleVelocity: '2800',
		MuzzleEnergy: '4699',
		SectionalDensity: '0.338',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '270',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6-F1yIE8--/d50aaa9abaa80e53fc1f8ec0e05cb59342f35f54.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dcdec1c9-87cd-4019-b48c-918647fec302',
		ProductID: '90311',
		ProductName: '38 Special +P 110 gr FTX® Critical Defense®',
		UPC: '090255903119',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.755',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255903116',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.55',
		PalletQtyBoxes: '1120',
		Retail: '41.31',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.131',
		MuzzleVelocity: '1090',
		MuzzleEnergy: '290',
		SectionalDensity: '0.123',
		Cartridge: '38 SPL+P',
		PressureRating: '+P',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FTX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OnsMN54f--/7c59380338f95b90547c71c2a8a7629c792cd95a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c10ea143-93ac-4a11-bc2c-b0784e1d562d',
		ProductID: '99240',
		ProductName: 'Hornady® Handbook 10th Edition',
		UPC: '090255992403',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.625',
		ShelfWidth: '9.25',
		ShelfDepth: '6.25',
		Weight: '3.380',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255992400',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '33.8',
		PalletQtyBoxes: '500',
		Retail: '42.93',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Featuring over 1,000 pages of reloading data, techniques and bullet information, the 10th Edition Handbook gives hand loaders access to over 200 different calibers featuring a variety of loads using Hornady® bullets. You'll find an impressive lineup of new and expanded data that incorporates new powders, new bullets like the ELD-X® and ELD® Match, plus more cartridges like the .280 Ackley Improved, 7x64 Brenneke and the .338 Federal. Well over 1,300 load combinations were shot to update and expand the reloading pages in this edition. Whether you're a novice or seasoned hand loader, this book will provide everything needed to successfully reload your favorite cartridges. Three ways to get the Hornady Handbook of Cartridge Reloading.  NEW! HORNADY® RELOADING APP Like the bound and eBook versions, the new Hornady® Reloading App provides all the information needed to successfully reload a variety of rifle and handgun cartridges. Plus you can save favorites, add notes and more. Reloading data is available as low as 99¢ per cartridge or purchase a subscription and receive new data before the next edition of the book is printed.   HARDCOVER BOOK This invaluable resource has over 900 pages of data on all Hornady bullets. Purchase this hard-bound book and get reloading results.   ELECTRONIC BOOK Download the Reloading Handbook as an Apple® iBook or get it on your Kindle®. Take it with you anywhere!",
		ProductImage: 'http://images.salsify.com/image/upload/s--TkZRGxfo--/zjztzivneio0xnv8zih8.jpg',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '414c29a7-f4e0-4f48-b399-607b0d4c290a',
		ProductID: '7060',
		ProductName: '7mm Gas Checks',
		UPC: '090255270600',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.679',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255270607',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '16.975',
		PalletQtyBoxes: '900',
		Retail: '67.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '7MM',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c1e0df42-e7e3-412a-b78e-a54be5a7e52b',
		ProductID: '046046',
		ProductName: 'Neck Size Die 35 Caliber (.358)',
		UPC: '090255460469',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.489',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460466',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0b720eab-6d80-477a-956b-d52efab9efc5',
		ProductID: '046233',
		ProductName: 'Full-Length Size Die 225 Win (.224)',
		UPC: '090255462333',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.511',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462330',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '225 WIN',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b1785c52-9ad0-4434-b249-5242fb4073ea',
		ProductID: '095316',
		ProductName: 'Case Feeder Plate Large Rifle',
		UPC: '090255953169',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.125',
		ShelfWidth: '13',
		ShelfDepth: '12.25',
		Weight: '1.571',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255953166',
		CartonHeight: '2.125',
		CartonWidth: '13.000',
		CartonDepth: '12.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '53.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Select from our four Case Feeder Plates tailor-made for the Lock-N-Load Automatic Case Feeder.',
		ProductImage: 'http://images.salsify.com/image/upload/s--MwLZkebr--/zv2q5ycsnd5jzwxkm3fi.png',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '07de622d-f475-4fd9-a3ef-d4d49e2204ff',
		ProductID: '83200',
		ProductName: '22 WMR 45 gr FTX® Critical Defense®',
		UPC: '090255832006',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.623',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255832003',
		CartonHeight: '4.250',
		CartonWidth: '8.750',
		CartonDepth: '15.250',
		CartonWeight: '24.92',
		PalletQtyBoxes: '5200',
		Retail: '24.24',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.11',
		MuzzleVelocity: '1000',
		MuzzleEnergy: '100',
		SectionalDensity: '0.128',
		Cartridge: '22 WMR',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FTX®',
		BulletWeightGrain: '45',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--EIwR2VM---/jmbgn9lehhysbpgkojpq.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Xoie6q4n--/d23324a37e7e49ebe3daf0da3590db269c48565c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--tvrzqzp2--/f0tpvyuiihnt4jgaigor.jpg',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd5164dbf-792f-4903-a670-b999cac97b08',
		ProductID: '594256',
		ProductName: 'Match™ Grade Bushing .256',
		UPC: '090255592566',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592563',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.256',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--QjGXjsec--/67e2df53b1c07bac058a03e9aeae1699bc09d881.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '52e92b03-2b56-4a21-a95b-3574693c51e4',
		ProductID: '98005',
		ProductName: 'Hornady® Frontier® Sticker',
		UPC: '090255980059',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '5',
		ShelfDepth: '5',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980056',
		CartonHeight: '1.000',
		CartonWidth: '5.000',
		CartonDepth: '5.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red, white and blue with Frontier Logo. Measures 3” x 4.5”',
		ProductImage: 'http://images.salsify.com/image/upload/s--Lm8XONgV--/q9tmcfhc0im2zj9yoxh1.png',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4a587fd4-6a03-4eb6-adfe-3ceb3ea3699e',
		ProductID: '544359',
		ProductName: 'Match™ Grade Full-Length Size Die 308 Win (.308)',
		UPC: '090255543599',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255543596',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 09:05:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8975cf7e-14a5-4e5e-9bf3-f687828ef5ab',
		ProductID: '390583',
		ProductName: 'Shell Holder #43',
		UPC: '090255905830',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905837',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'baebb95b-1e7b-4b67-891f-2cb933070b0f',
		ProductID: '22272',
		ProductName: '22 Cal .224 55 gr V-MAX® with cannelure',
		UPC: '090255222722',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.858',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222729',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.32',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		SectionalDensity: '0.157',
		OAL: '0.813',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX® W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--u3kMpUAx--/7f7f30fd3b10f091d3c0facbb91dd3e777f1411e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b39fae39-f1c5-4b2a-939a-ae660ef3b129',
		ProductID: '99294',
		ProductName: 'Hornady® Camouflage Fleece Beanie',
		UPC: '090255992946',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '8',
		ShelfDepth: '8.5',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'SRI LANKA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--TyNLCh27--/czx80ae42riulxrf8nrp.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--TyNLCh27--/czx80ae42riulxrf8nrp.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75ce252d-6f0a-495f-b5d1-8c0a73e6d313',
		ProductID: '91364',
		ProductName: '40 S&W 180 gr XTP® American Gunner®',
		UPC: '090255913644',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.840',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913641',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.4',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.164',
		MuzzleVelocity: '950',
		MuzzleEnergy: '361',
		SectionalDensity: '0.161',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PhzSxFof--/df06c6cabace24a3d93d2c5ddec6f9570e52f073.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8851d6fc-78ee-40d5-95cd-920a974ff8c9',
		ProductID: '398309',
		ProductName: 'Lock-N-Load®AP™ Case Feeder & EZ-JECT Conversion Kit',
		UPC: '090255983098',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '16',
		ShelfDepth: '3.25',
		Weight: '3.176',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255983095',
		CartonHeight: '6.000',
		CartonWidth: '16.000',
		CartonDepth: '3.250',
		CartonWeight: '3.176',
		PalletQtyBoxes: '0',
		Retail: '138.77',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--_SEoCxtU--/onbjucjexb5l6wfh7d8d.jpg',
		DateLastModified: '2023-12-16 09:02:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92a338cc-fcdb-49e5-957d-f8603eabfa47',
		ProductID: '8693',
		ProductName: '450 Marlin Unprimed Cases',
		UPC: '090255486933',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486930',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.25',
		PalletQtyBoxes: '200',
		Retail: '84.81',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '450 MARLIN',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ba6211e-4190-47f9-8b77-1f259a4b5680',
		ProductID: '86222',
		ProductName: '12 GA Heavy Magnum® Coyote BB 3"',
		UPC: '090255862225',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.75',
		ShelfDepth: '4',
		Weight: '1.252',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862222',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '12.52',
		PalletQtyBoxes: '1120',
		Retail: '24.60',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Heavy Magnum® Coyote Shotshell Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		MuzzleVelocity: '1300',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: 'BB',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Your answer for turkeys and coyotes!  Take down turkeys and coyotes up to 50 yards away with accurate, deadly and dependable Heavy Magnum® Shotgun ammunition. Hornady® Heavy Magnum® Coyote loads deliver lethal results and minimal pelt damage out to 50 yards. Loaded with 1½ ounces of nickel plated lead shot in your choice of BB or 00 buckshot, these 3 inch, 12 gauge shotshells are the perfect answer for close range predators. Both loads feature the Hornady® Versatite® wad that strips cleanly from the shot string for excellent pattern density and a short shot column for maximum effect on target. Not only are these loads extremely effective, they're also an economical choice when compared to expensive tungsten options.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--h8s1T-Ug--/8117a85c1746fe37cc8b779adb680fb9f1e05c77.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8A4Waxz1--/3b08eef63147cf57823e56afbd93353311741204.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--P1oTzS5E--/khk5elsx4vpbo0o0lhxk.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--DF4FDMl_--/jhanliibnzab9h9ifix2.jpg',
		Videos: 'https://vimeo.com/183547438',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2a1fbea-4e90-42ef-a894-a99cebc27bd6',
		ProductID: '044541',
		ProductName: 'Expander Die 41 Mag (.410)',
		UPC: '090255445411',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.499',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445418',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3e161d7-de96-4798-a80e-16324b2e2e1f',
		ProductID: '75212',
		ProductName: 'Snapsafe® Treklite™ Lock Box With Key Lock XL',
		UPC: '851529004716',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '2.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004713',
		CartonHeight: '8.500',
		CartonWidth: '12.000',
		CartonDepth: '15.750',
		CartonWeight: '12.5',
		PalletQtyBoxes: '450',
		Retail: '40.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '1.6',
		ProductIntHeight: '1.75',
		ProductIntWidth: '6.75',
		ProductIntDepth: '9.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The TrekLite® Lock Box offers heavy-duty protection at a third of the weight of steel! SPECIFICATIONS External Dimensions: 10" x 7" x 2" Weight: 1.6 lbs  FEATURES Easy to operate steel key lock mechanism. Protects firearms, expensive medications, and other valuables while traveling or at home. Easily fits in a suitcase, drawer, or under a car seat. Constructed of advanced, impact-resistant polycarbonate for exceptional toughness. Fits up to full-sized 1911 handguns. Durable, non-slip rubber over-mold provides added impact protection and stability. Foam lining protects firearms and valuables from being marred. Includes 1500 lb. rated security cable with sturdy cable connector that doesn’t limit interior cargo space. Meets TSA requirements.* *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.',
		ProductImage: 'http://images.salsify.com/image/upload/s--1Adsweju--/ik4ochm0fvmozzzmpjs1.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GNfKT21O--/smajfcx3qdslde1canka.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ty_5-dnp--/vfues7kkkbzywlbprlzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--TY7KWO4K--/fvrtnoweohsgfbpoomzv.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--4CUMyYOp--/glf2sgysr23hoimeqrox.jpg',
		Videos: 'https://vimeo.com/213867264',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eea19768-de56-41c9-aa2b-a1784cb8a23a',
		ProductID: '6090',
		ProductName: '50 Cal .490 Lead Balls',
		UPC: '090255260908',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.678',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260905',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '66.95',
		PalletQtyBoxes: '900',
		Retail: '18.72',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '50 CAL',
		BulletDiameter: '0.49',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75c71bd1-5ee4-496d-a410-86f57ee56090',
		ProductID: '046453',
		ProductName: 'Full-Length Size Die 300 Win Short Mag(.308)',
		UPC: '090255464535',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.538',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464532',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '777c80c6-77ef-4267-89e1-6ffaa00f099f',
		ProductID: '75250',
		ProductName: 'Snapsafe® Lock Box With Combination Lock XXL',
		UPC: '851529004570',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '9',
		ShelfDepth: '12.5',
		Weight: '6.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004577',
		CartonHeight: '12.500',
		CartonWidth: '9.750',
		CartonDepth: '15.500',
		CartonWeight: '32.5',
		PalletQtyBoxes: '275',
		Retail: '62.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.5',
		ProductExtWidth: '8.5',
		ProductExtDepth: '11.5',
		ProductWeight: '6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--0RebydV8--/ydtbfv5bpxjccbyaz55b.png',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-11-07 15:02:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3f22aae-8c69-420a-991d-569650148dfc',
		ProductID: '046443',
		ProductName: 'Full-Length Size Die 6.5-284 (.264)',
		UPC: '090255464436',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.559',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464433',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5-284 (NORMA)',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fa843628-3f2f-4db8-b334-fdcf98723ce1',
		ProductID: 'B7MM',
		ProductName: 'Lnl®7Mm Rem Ultra Mag Mod Case',
		UPC: '090255704013',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704010',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.44',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '7MM REM ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f5bcfe7-6bef-4abc-9604-463a3d7ad5ba',
		ProductID: '046399',
		ProductName: 'Full-Length Size Die 35 Rem (.358)',
		UPC: '090255463996',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463993',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '35 REM',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc3bbf65-3bc4-47d3-b918-56e322fbbfe1',
		ProductID: '546282',
		ProductName: 'Full-Length 2-Die Set 6.5X55 (.264)',
		UPC: '090255562828',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.496',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562825',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.48',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b7e7b85b-e317-4ce4-858f-d3d363b4ded6',
		ProductID: '190171',
		ProductName: 'Powder Bushing 480',
		UPC: '090255191714',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191711',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c72211bc-971f-47e2-aa37-f7554800838d',
		ProductID: '390563',
		ProductName: 'Shell Holder #23',
		UPC: '090255905632',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905639',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.44',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81147c0f-4a11-47f8-b648-862362a70e3f',
		ProductID: '546353',
		ProductName: 'Full-Length 2-Die Set 300 RCM (.308)',
		UPC: '090255563535',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.462',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563532',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.31',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '300 RCM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ae60b638-bc68-41d0-a71a-57b3e3a17dcc',
		ProductID: '91256',
		ProductName: '10mm Auto 175 gr FlexLock® Critical Duty®',
		UPC: '090255912562',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.835',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255912569',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.35',
		PalletQtyBoxes: '1120',
		Retail: '43.12',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.16',
		MuzzleVelocity: '1160',
		MuzzleEnergy: '523',
		SectionalDensity: '0.156',
		Cartridge: '10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '175',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TcVzbmTz--/b8081b6eb82cdcfdbd8b1040c11c6953649ad3a0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5c2fceef-2229-431c-b39c-4032e1f6fd52',
		ProductID: '397115',
		ProductName: 'Seating Stem 30 Cal FTX®/MFX®',
		UPC: '090255971156',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971153',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '7.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b0226348-b8ec-4845-b647-f933a1de8c05',
		ProductID: '594258',
		ProductName: 'Match™ Grade Bushing .258',
		UPC: '090255592580',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592587',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.258',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ui0yr7FS--/e075d265b0d1d9ee10e76c2ab63e695def762a6e.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '595aba1d-9083-4dd5-9f9e-c65574d94251',
		ProductID: '806114',
		ProductName: '7mm Rem Mag 150 gr. CX™ Outfitter®',
		UPC: '090255719819',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719816',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '14.5',
		PalletQtyBoxes: '780',
		Retail: '75.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.455',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '2997',
		SectionalDensity: '0.266',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--FdNyvi0Q--/vyxiae5lqrgdw4laovxr.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7097459a-783c-4102-a55f-46c1ed200d39',
		ProductID: '594311',
		ProductName: 'Match™ Grade Bushing .311',
		UPC: '090255593112',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593119',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '30 CAL',
		BulletDiameter: '0.311',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wlNeIdUw--/bf86df19f325bd9efb0952a526672b813085159e.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '491d0603-8e83-481b-b525-71d0b39c6da9',
		ProductID: '30718',
		ProductName: '30 Cal .308 175 gr SUB-X®',
		UPC: '090255307184',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.600',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307181',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.0',
		PalletQtyBoxes: '540',
		Retail: '59.33',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Sub-X® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '.300',
		SectionalDensity: '0.264',
		OAL: '1.16',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '175',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reliable subsonic expansion Sub-X® (Subsonic — eXpanding) bullets deliver big results without a big bang! Designed to provide deep penetration below the speed of sound, Sub-X® features a lead core. Long grooves in its gilding metal jacket combine with its flat profile and the patented Flex Tip® insert within the bullet’s hollowpoint cavity to help it expand reliably at low velocities. Cannelures provide positive case crimp, making Sub-X® ideal for semiautomatic weapons. EXPANDS AT SUBSONIC VELOCITIES Patented Flex Tip® technology aids in expansion at velocities as low as 900 fps. PROVEN PERFORMANCE Meets FBI protocol for terminal ballistic test requirements. POSITIVE CASE CRIMP Lead core bullet with cannelured jacket provides positive case crimp for use in semiautomatics. WIDE RANGE OF GUNS Designed to fit, feed and function in a variety of firearms, including gas system guns.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--6JPNHdGn--/vanusfuylesq6gow2tp5.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--OYTixXRT--/ti9imzlhkqhrilklkego.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OtRGcACm--/l0fdlmxwkhjzevqlazry.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RMzZ3xew--/iyn6cbplk0acvziaeybv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Pcv-K6q9--/n7qqzc0bqjb3ccn8xowf.png',
		Videos: 'https://vimeo.com/367134791',
		Videos1: 'https://vimeo.com/368030686',
		DateLastModified: '2024-03-04 15:46:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '489474cf-37e9-4b04-b03f-ebe9b5aa6cc3',
		ProductID: '390559',
		ProductName: 'Shell Holder #19',
		UPC: '090255905595',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905592',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3f69b26b-8d97-4f1e-83a2-9d29721c2d48',
		ProductID: '75810',
		ProductName: 'Snapsafe® 2 Gun Pistol Rack',
		UPC: '851529004204',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '5',
		ShelfDepth: '4.5',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004201',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '4.5',
		PalletQtyBoxes: '750',
		Retail: '20.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004205',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '22.5',
		ProductImage: 'http://images.salsify.com/image/upload/s--NRIV8Yq_--/vkivzfiwiiuqjdzxueci.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--vxvBwFOj--/xydxknv6crmdnh6iwhah.jpg',
		Videos: 'https://vimeo.com/213867149',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f63d3101-c3af-4cfb-b3e7-67d6abae22ea',
		ProductID: '3415',
		ProductName: '348 Cal .348 200 gr FTX®',
		UPC: '090255234152',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.970',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255234159',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.55',
		PalletQtyBoxes: '540',
		Retail: '57.77',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.32',
		SectionalDensity: '0.236',
		Caliber: '348 CAL',
		BulletDiameter: '0.348',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--uH1tAA1G--/d1fcb3deecdabeaffa32c28ec3f47d372db0bc3c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Xc1QHRlN--/ec79c72516343a2df64988589d21451f10f49501.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Ebvz-wcI--/kapenct36gny3vgv4rq7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6_ona8Ce--/lm4agjgxg9a99wcrulzd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CCLX8KG---/sjfoqhsqct7dunermkrh.png',
		Videos: 'https://vimeo.com/359889923',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e91fd58b-741f-480b-b3d9-63341fac2ff3',
		ProductID: '99133',
		ProductName: 'Hornady® Scope Cover',
		UPC: '090255991338',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '4.25',
		ShelfDepth: '17',
		Weight: '0.005',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Safeguard your scopes from dings, scratches, dirt and moisture. Constructed of high-quality neoprene that wicks moisture away from the scope and helps protect it from rust and corrosion. Will not work on scopes with tall target-style turrets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZN1OUQ0m--/kifisk8kuvfd7anhutqz.png',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a7c89797-867f-4f37-b499-30c2f688e585',
		ProductID: '046204',
		ProductName: 'Match™ Grade Full-Length Size Die 6mm Creedmoor (.243)',
		UPC: '090255462043',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462040',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2eba857d-e6b6-415e-9ecb-54d5b8cae7e9',
		ProductID: '41010',
		ProductName: '41 Cal .410 190 gr FTX®',
		UPC: '090255410105',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.850',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255410102',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.75',
		PalletQtyBoxes: '540',
		Retail: '44.24',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.165',
		SectionalDensity: '0.161',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		BulletName: 'FTX®',
		BulletWeightGrain: '190',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Extend the range of your lever gun. Hornady® FTX® bullets revolutionized lever gun ballistics, creating a new level of performance for these popular firearms. Lever gun enthusiasts can now harness the accuracy, power and long-range performance of a tipped bullet that's safe to load in tubular magazines.  Hornady® offers the same Flex Tip® technology for handguns that revolutionized lever guns. Typical hollow point pistol bullets deliver good performance at modest velocities, but have a tendency to expand too quickly and sacrifice penetration at the higher velocities achieved with lever action guns. PATENTED FLEX TIP® BULLET TECHNOLOGY Upon impact, the soft tip compresses into the bullet, initiating immediate expansion across a wide range of velocities. Safe to shoot in tubular magazines as well as any other firearm.  INTERLOCK® RING The one-piece, high antimony lead core of the FTX® is mechanically locked to the jacket with an InterLock ring. This, along with a specially designed jacket, results in reliable performance and maximum weight retention for deep penetration on large or heavy-bodied game animals.  BALLISTICALLY EFFICIENT SECANT OGIVE Pioneered by Hornady,® the secant ogive profile delivers stability, flat trajectories and amazing accuracy.  SPECIALLY ENGINEERED JACKET The heavy jacket over the shank of the bullet combined with our proven InterLock® design controls expansion and enhances accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--A1uSTbim--/bba91b28ec2ebd7944eb3d42a657a4d867ae8ce5.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--y9BGeV5e--/50720fea65eaf182d1c381af2ba07bedbd7baeee.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--csJYg2SQ--/ztizvbercxtbpusbiwpc.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--24GgDB-4--/edtuxtcb7em33ffll97b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--8-IEe1-j--/r5kb2qjrxsdb1z7mb8yx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--R_KlzV4v--/bp4lzykm2ykrixjfdi8i.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--5-gi86pN--/fleuiowjusbv8rzydx3v.jpg',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '82462a12-7272-41e9-8b9c-31f4a5d7c992',
		ProductID: '046598',
		ProductName: 'Full-Length Size Die 6.5 Grendel (.264)',
		UPC: '090255465983',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465980',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f3046d72-d1c9-4932-bc86-a2e33049fca6',
		ProductID: 'B300W',
		ProductName: 'Lock-N-Load® 300 WSM Win Modified Case',
		UPC: '090255704952',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704959',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d8c42b0-21cc-4f12-a05c-1b03405503e6',
		ProductID: '3140B',
		ProductName: '7.62 Cal .310 123 gr SP',
		UPC: '090255631401',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '50.330',
		WeightUOM: 'LB',
		CaseQty: '2800',
		CartonUCC: '10090255631408',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '140924.0',
		PalletQtyBoxes: '117600',
		Retail: '0.31',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.252',
		SectionalDensity: '0.183',
		OAL: '0.85',
		Cartridge: '7.62x39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		BulletName: 'SP',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--abz8GoeW--/60b09cdb9f05533fc6378f65ab647a7cf4c4dcba.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '740d3a29-3017-41b3-9993-133885ed678d',
		ProductID: '81268',
		ProductName: '5.56 NATO 73 gr ELD® Match Superformance® Match',
		UPC: '090255812688',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.660',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255812685',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.6',
		PalletQtyBoxes: '1680',
		Retail: '27.79',
		ParentCategory: 'Ammunition',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		G7BC: '0.2',
		SectionalDensity: '0.208',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '73',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge your match rifle! Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Topped with the finest bullets, Superformance® Match™ ammunition marries the very best cartridge cases with extremely stable propellants. These propellants are custom blended for each individual load to provide true ammunition performance enhancement. FAST Superformance®  Match™ ammunition achieves muzzle velocities of 100 – 200 fps faster than ANY conventional ammunition.  ACCURATE Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Superformance® Match™ ammunition - the limits have been broken!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--X4fswI-K--/c475184b2ba83dbaf8b2f846493cd99ddb26158c.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OjkmsJEi--/443b67e30608568629a83b37253b749e9e96bd34.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1p4zt9b5--/g5lr8ycpphdp3sqhisg3.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s---8dZEoUU--/v6e5gygwqep8fdkfzjlz.jpg',
		Videos: 'https://vimeo.com/241896524',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8383e29b-8285-40c2-baa9-5f3f2f336795',
		ProductID: '190123',
		ProductName: 'Shot Bushing 1 1/2 oz',
		UPC: '090255191233',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191230',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '372b7d12-c906-41e7-966d-41ed44f1a405',
		ProductID: '043355',
		ProductName: 'One Shot® Cartridge Cleaning Solution - Quart',
		UPC: '090255433555',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.625',
		ShelfWidth: '5.125',
		ShelfDepth: '2.125',
		Weight: '2.536',
		WeightUOM: 'LB',
		CaseQty: '12',
		CartonUCC: '10090255433552',
		CartonHeight: '8.000',
		CartonWidth: '14.750',
		CartonDepth: '11.000',
		CartonWeight: '30.432',
		PalletQtyBoxes: '0',
		Retail: '34.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'DIETHANOLAMINE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Jug',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Non-toxic and uniquely formulated to clean brass cases. Quickly removes most tarnish, oxidation and carbon buildup. Designed specifically for the Hornady® Lock-N-Load® Sonic Cleaners™ or stainless steel tumblers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--3Abu4JX6--/n1getiw3gmaxmr1rc5pf.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e54f22b4-6ce5-4c07-bc2c-7017c8e601c4',
		ProductID: '35740',
		ProductName: '38 Cal .357 140 gr XTP®',
		UPC: '090255235746',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.102',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235743',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.55',
		PalletQtyBoxes: '900',
		Retail: '35.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.169',
		SectionalDensity: '0.157',
		OAL: '0.605',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--CipQZhfF--/24334c0040e7ce0961970db63bf77887f21051de.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ab9d405f-b12f-4ef9-b1af-7d60ecbc2160',
		ProductID: '86406',
		ProductName: '284 Winchester Unprimed Cases',
		UPC: '090255864069',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255864066',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.5',
		PalletQtyBoxes: '200',
		Retail: '96.35',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '284 WIN',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2704a1cb-8958-411a-87a2-ad803e37d5ab',
		ProductID: '390572',
		ProductName: 'Shell Holder #32',
		UPC: '090255905724',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905721',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c9ebad92-54bd-4b76-a2ae-ffd06db7b43a',
		ProductID: '83176',
		ProductName: '17 Mach 2® 15.5 gr NTX® Varmint Express® Rimfire',
		UPC: '090255831764',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255831761',
		CartonHeight: '6.500',
		CartonWidth: '9.250',
		CartonDepth: '13.000',
		CartonWeight: '30.0',
		PalletQtyBoxes: '4000',
		Retail: '18.04',
		ParentCategory: 'Ammunition',
		Applications: 'AppVarmint',
		G1BC: '0.115',
		SectionalDensity: '0.075',
		Cartridge: '17 MACH 2',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'NTX®',
		BulletWeightGrain: '15.5',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mDAC8Zbk--/83db38fcda4c66dddfe3e18e58bc8fc4c8430f88.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ddd097fb-abc4-441f-9b9a-f0963a442708',
		ProductID: '82331',
		ProductName: '375 H&H Mag 250 gr GMX® Outfitter®',
		UPC: '090255823318',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823315',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.1',
		PalletQtyBoxes: '396',
		Retail: '109.61',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.43',
		SectionalDensity: '0.254',
		Cartridge: '375 H&H MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'GMX®',
		BulletWeightGrain: '250',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--op_veAUd--/82241db1bd4f5afa4d90785fe238b92ad345b938.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '43b45d3a-f440-4e8c-aad4-f1a39bc17a66',
		ProductID: '81171',
		ProductName: '30-06 Springfield 168 gr ELD® M1 Garand Vintage Match™',
		UPC: '090255811711',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.285',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811718',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.85',
		PalletQtyBoxes: '1400',
		Retail: '61.17',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Vintage Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.523',
		MuzzleVelocity: '2710',
		MuzzleEnergy: '2739',
		SectionalDensity: '0.253',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Vintage Match™ ammunition is built to replicate the original military performance specifications unique to many vintage rifles. With the advent of the CMP Vintage rifle and Vintage Sniper Matches, Vintage Match™ ammunition was developed with the match shooter in mind and is meant to provide superior quality, off-the-shelf ammunition for the shooter who is looking for a match grade alternative to surplus or hand-loaded ammunition.  Vintage Match™ offers exceptional accuracy for classic service rifles such as the Mauser, Lee-Enfield, Swedish Mauser or any other rifles chambered for these storied cartridges. HORNADY® MATCH™ BULLETS Hornady® Vintage Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Vintage Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Vintage Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PhdNzVOL--/a41df54d323874d37ce000f78e4fa7503a2f2959.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0c7e6c0b-89f7-4f78-b2c3-87145cb4ecbb',
		ProductID: '085005',
		ProductName: '50 BMG Press Kit',
		UPC: '090255850055',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20',
		ShelfWidth: '10.5',
		ShelfDepth: '6',
		Weight: '26.704',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255850052',
		CartonHeight: '20.000',
		CartonWidth: '10.500',
		CartonDepth: '6.000',
		CartonWeight: '26.704',
		PalletQtyBoxes: '0',
		Retail: '1184.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Get the .50 BMG Press along with a .50 Cal Die Set and 50 BMG shell holder when you purchase the kit. Created from select steel and heat-treated for durability and a lifetime of reloading, the Hornady® Custom Grade 50 Cal. Die Set is so well crafted, it’s guaranteed never to break or wear out from normal use.  The Kit Includes Hornady® 50 BMG Reloading Press Hornady® 50 BMG Reloading Die Set 50 BMG Shell Holder 1½"x12 Conversion Bushing',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KUHXpT7_--/1413d4fe4bd3157ec0e83dba088e29f4f5bebbeb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aiwNYKIk--/oeerzgmhx4spjke4cjzl.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '28ff9f2e-a6f5-4384-ac7c-9ed424e26892',
		ProductID: '2458',
		ProductName: '6mm .243 105 gr BTHP Match',
		UPC: '090255224580',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255224587',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.0',
		PalletQtyBoxes: '900',
		Retail: '41.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.53',
		SectionalDensity: '0.254',
		OAL: '1.23',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '105',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UKLrZ8aZ--/c5558b02f6715ac6ed8e00a57eeb2090780b9394.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c808c8b5-7acd-419b-9437-410b1c52c8e1',
		ProductID: '190148',
		ProductName: 'Powder Bushing 393',
		UPC: '090255191486',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.065',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191483',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.65',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1816aff1-261d-4494-9d3b-eb91b4151297',
		ProductID: '8553',
		ProductName: '260 Rem 130 gr ELD® Match',
		UPC: '090255385533',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.095',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255385530',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.95',
		PalletQtyBoxes: '1400',
		Retail: '53.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.506',
		G7BC: '0.255',
		MuzzleVelocity: '2840',
		MuzzleEnergy: '2328',
		SectionalDensity: '0.266',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ay6RW4DC--/373b7dbde8b456e6cd0b2c24bfb1b6c071f4426b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72e925c5-8e8a-4433-8e08-a737c68975fd',
		ProductID: '044165',
		ProductName: 'Seater Die (.308) 300 Blackout',
		UPC: '090255441659',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441656',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '83fb1735-a192-470e-9343-b5bb8d32ba7a',
		ProductID: '6720',
		ProductName: '50 Cal Sabot with 44 Cal 240 gr HP XTP® Bullet',
		UPC: '090255267204',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '5',
		ShelfWidth: '3.325',
		ShelfDepth: '1.5',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255267201',
		CartonHeight: '5.500',
		CartonWidth: '7.687',
		CartonDepth: '8.000',
		CartonWeight: '10.0',
		PalletQtyBoxes: '900',
		Retail: '17.31',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Muzzleloading Sabots With Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.205',
		SectionalDensity: '0.185',
		Caliber: '50 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '240',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Sabot: 'Low Drag™ Sabot',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'A Huge Boost In Performance Effective in both traditional and modern muzzleloading rifles, these green saboted projectiles use the XTP® bullet which is specifically designed for deep penetration and proper expansion at all practical muzzleloading velocities. ACCURATE 1" group at 100 yards.  NO LUBE Sabots do not require additional lube.  HARD HITTING Hornady XTP® bullets deliver devastating terminal performance at all ranges.  HIGH PERFORMANCE Hornady sabots deliver the highest velocities and the flattest trajectories on the market.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vFABePzF--/ms5n6u4vmetrrcphgbje.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--pxe9aW-F--/j8xhikhc6vo7lp1bux18.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--q-Ffy7vL--/ggwa1cgqrojx4uniwtsc.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '46aad4d5-aa96-4a26-85be-5170dabe1b56',
		ProductID: '392619',
		ProductName: 'Shell Plate #19 Lock-N-Load®AP™ & Projector',
		UPC: '090255926194',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.613',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926191',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '6.13',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6f13a946-ee23-475e-a3c0-8c5fa8501710',
		ProductID: '1420',
		ProductName: 'Lock-N-Load® 20 Insert (.204 Cal)',
		UPC: '090255704761',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704768',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '204 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5VKtg53N--/shoeoofs03xtjjr71tbh.png',
		DateLastModified: '2023-12-16 08:58:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8a10712-ab14-481b-b3ee-99d617aa8d93',
		ProductID: 'A308',
		ProductName: 'Lock-N-Load® 308 Win Modified Case',
		UPC: '090255704426',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704423',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VXbuKVIY--/22e553e803837352a29ba8379423520eb35eec9e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '25c56158-791e-4781-932a-54251cc47b44',
		ProductID: '804574',
		ProductName: '243 Win 80 gr. CX™ Outfitter®',
		UPC: '090255719765',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.960',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719762',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.6',
		PalletQtyBoxes: '1400',
		Retail: '58.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.273',
		MuzzleVelocity: '3200',
		MuzzleEnergy: '1819',
		SectionalDensity: '0.194',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'CX™',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--sQiQpfw7--/bcykllf5iwi5qcc7bobx.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f874201-35bb-4eaa-ad59-c27435eaa157',
		ProductID: '095300',
		ProductName: 'Case Feeder Lock-N-Load® AP™ 110 Volt',
		UPC: '090255953008',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '25.5',
		ShelfWidth: '16.375',
		ShelfDepth: '13',
		Weight: '16.750',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '25.500',
		CartonWidth: '16.375',
		CartonDepth: '13.000',
		CartonWeight: '16.75',
		PalletQtyBoxes: '24',
		Retail: '673.39',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"With our high volume Lock-N-Load® Case Feeder, the Lock-N-Load® AP™ just got faster. It has the highest torque motor in the industry and an extra large case bowl that makes it possible to load over 500 rounds of high quality ammunition per hour, depending on experience and proficiency. The Lock-N-Load® Case Feeder comes complete with everything you need except the case feeder plates, which are sold separately. ADAPTS TO YOUR LOCK-N-LOAD®AP™ PRESS The Case Feeder bolts to Lock-N-Load® AP™ presses with serial number 7000 and higher. For serial numbers below 7000, we offer a sub-plate conversion kit.  (Not compatible with the Projector™ press.)  CHANGE OVERS ARE EASY Changing the Lock-N-Load® Case Feeder from one cartridge to another is quick and simple. Change overs typically take about 5 minutes.  FEEDS EVERY CARTRIDGE If Hornady® makes a standard shell plate for it, the cartridge will also feed through the hopper.  FAIL-SAFE CASE SLIDE MECHANISM Slotted cam wire fixture prevents damage from misfed cases or incorrectly adjusted shuttle.  CARTRIDGE ADAPTERS INCLUDED The Case Feeder comes with six cartridge adapters to ensure proper feeding of your cases into the shell plate. The instructions include a V-Block usage chart so there's no guessing about which adapter to use.",
		ProductImage: 'http://images.salsify.com/image/upload/s--Xyo3G96V--/apbkoummtsermkuphfbu.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CwUfZ_C---/yz8iaxpj8ft5dnqlkevn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--zLwsWSzL--/w636iscixx2eerzn0hs7.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14a2e828-21e8-4e15-86fc-fc123b698010',
		ProductID: '28452',
		ProductName: '7mm .284 162 gr SST®',
		UPC: '090255284522',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.436',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255284529',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.54',
		PalletQtyBoxes: '540',
		Retail: '55.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.55',
		SectionalDensity: '0.287',
		OAL: '1.393',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ztgJqzF7--/b8439cd09b99ce1f93249500c90eb0fbe7cfcbe0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51180a8e-ba57-40c9-8554-635b02057265',
		ProductID: '90242',
		ProductName: '9mm Luger 124 gr XTP®',
		UPC: '090255902426',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.777',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902423',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.77',
		PalletQtyBoxes: '1120',
		Retail: '33.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.165',
		MuzzleVelocity: '1110',
		MuzzleEnergy: '339',
		SectionalDensity: '0.141',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WlK9Zr1Y--/33a99874865abf50d33a4042c540bb9d51ff81fd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fa93c313-6cda-45d2-a616-09cb81d5e4f0',
		ProductID: '30192',
		ProductName: '30 Cal .308 125 gr HP',
		UPC: '090255301922',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.886',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255301929',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.15',
		PalletQtyBoxes: '900',
		Retail: '53.07',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Rifle Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.320',
		SectionalDensity: '0.188',
		OAL: '0.995',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--YfsqaF-H--/xp12kykqlqh0ptida4sk.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '44336079-e46f-466f-b975-0c713a6f1930',
		ProductID: '35780',
		ProductName: '38 Cal .357 158 gr FP XTP®',
		UPC: '090255235784',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.335',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235781',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '58.375',
		PalletQtyBoxes: '900',
		Retail: '35.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.199',
		SectionalDensity: '0.177',
		OAL: '0.66',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FP-XTP®',
		BulletWeightGrain: '158',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pLyr1hZT--/f15693fc9a0cb15529474e7dc5543ac1d8644e74.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a295cbd-83c7-4a34-bc5e-091cff2c9144',
		ProductID: '390604',
		ProductName: 'Shell Holder #48',
		UPC: '090255906042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906049',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '5.0',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '726b714c-6976-4de8-9995-fcca2b8c7c09',
		ProductID: '80897',
		ProductName: '300 Blackout 125 gr HP American Gunner®',
		UPC: '090255808971',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '2.625',
		ShelfDepth: '5.25',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255808978',
		CartonHeight: '5.687',
		CartonWidth: '5.937',
		CartonDepth: '14.687',
		CartonWeight: '17.5',
		PalletQtyBoxes: '800',
		Retail: '87.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Rifle Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.32',
		MuzzleVelocity: '2175',
		MuzzleEnergy: '1313',
		SectionalDensity: '0.188',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces a variety of rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kcXZTRXE--/iyerxgndyba02kfaeqcr.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9JED4Z93--/cd5366b3f6f4979c4f0df4b67bba877cb66d7252.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cn7bWxnr--/jqy5fotaq7bsq8mwwdcx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SzgHkrlW--/zrjrfe1l2jnxjtlm2gdb.jpg',
		Videos: 'https://vimeo.com/163447195',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0a2624e-eb78-4bd9-869e-e3a311fff712',
		ProductID: '046224',
		ProductName: 'Match™ Grade Full-Length Size Die 7mm Rem Saum (.284)',
		UPC: '090255462241',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462248',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '7MM REM SA ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '104593d7-a37f-4b3d-907b-a081aca12187',
		ProductID: '046587',
		ProductName: 'Size Die 450 Marlin (.458)',
		UPC: '090255465877',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465874',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '450 MARLIN',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72193d4d-33cc-4d74-99c1-e1673676582d',
		ProductID: '546207',
		ProductName: 'Full-Length 2-Die Set 22 Nosler (.224)',
		UPC: '090255562071',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562078',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '22 NOSLER',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9c377005-8892-4339-abcc-e191fd1ed00c',
		ProductID: '095210',
		ProductName: 'Lock-N-Load® AP™ Primer Feed System',
		UPC: '090255952100',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '2.25',
		ShelfDepth: '16',
		Weight: '0.916',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255952107',
		CartonHeight: '9.500',
		CartonWidth: '11.750',
		CartonDepth: '17.500',
		CartonWeight: '0.916',
		PalletQtyBoxes: '0',
		Retail: '75.27',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--0G3nhbIc--/cvoikavq4sx8pittly8i.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b79baffe-1634-4e20-815f-c2c1ebdb5cfc',
		ProductID: '3232',
		ProductName: '8mm .323 150 gr InterLock® SP',
		UPC: '090255232325',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.287',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255232322',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.305',
		PalletQtyBoxes: '540',
		Retail: '52.32',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.29',
		SectionalDensity: '0.205',
		OAL: '0.992',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ZQfRoiUi--/aa877dfcebbe562615df3e8a11d7e6a872f01248.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8d69bcee-e632-400b-8b21-9ac888445073',
		ProductID: '392601',
		ProductName: 'Shell Plate #1 Lock-N-Load® AP™ & Projector',
		UPC: '090255926019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.565',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926016',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.65',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2bf370b1-9b0d-41a2-b790-9a923dd2289a',
		ProductID: '546423',
		ProductName: 'Full-Length 2-Die Set 404 Jeffery (.423)',
		UPC: '090255564235',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564232',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '164.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '404 JEFFERY',
		Caliber: '423 CAL',
		BulletDiameter: '0.423',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd3f29243-197c-48cd-a152-94462c05af57',
		ProductID: '546201',
		ProductName: 'Full-Length 2-Die Set 204 Ruger (.204)',
		UPC: '090255562019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.473',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562016',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.365',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '204 RUGER',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '41adc65e-f0c0-45f4-a000-553f569c7970',
		ProductID: '3010',
		ProductName: '30 Cal .308 110 gr SP',
		UPC: '090255230109',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.684',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255230106',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.1',
		PalletQtyBoxes: '900',
		Retail: '38.45',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.256',
		SectionalDensity: '0.166',
		OAL: '0.83',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SP',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--33VYYWsK--/e2b39d387e7de5c91053023150c2b8f62c8070c9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '013c7e1a-eac5-4495-a419-e1e3d9006047',
		ProductID: '046047',
		ProductName: 'Neck Size Die 6mm Short (.243)',
		UPC: '090255460476',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.507',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460473',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '959ad0b9-d74b-4184-a8a6-0290622847f3',
		ProductID: '2825',
		ProductName: '7mm .284 139 gr InterLock® BTSP',
		UPC: '090255228250',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.110',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255228257',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.75',
		PalletQtyBoxes: '900',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.453',
		SectionalDensity: '0.246',
		OAL: '1.147',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '139',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XhtFBFZD--/829b71f35c61ed8933ea4d52de9420a3bd97c463.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6586af4b-720f-4286-939d-f25b61705bda',
		ProductID: '594366',
		ProductName: 'Match™ Grade Bushing .366',
		UPC: '090255593662',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593669',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--aRw_LYUe--/f7ca1ef25b3173153f29f26ec40818aa5d73cbe4.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ede07a99-aa5f-457d-aa55-29176ca3d761',
		ProductID: '3708',
		ProductName: '375 Cal .375 250 gr GMX®',
		UPC: '090255237085',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255237082',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.5',
		PalletQtyBoxes: '540',
		Retail: '84.88',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.43',
		SectionalDensity: '0.254',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'GMX®',
		BulletWeightGrain: '250',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jM480Yv9--/eaf0b1f5397522bc8046d49ef60851f02188fc60.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1dd094e5-0bf1-457c-9909-7bf7bd0dd869',
		ProductID: '8256',
		ProductName: '450 Nitro Express 3 1/4" 480 gr DGS® Dangerous Game™ Series',
		UPC: '090255382563',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.800',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382560',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '16.8',
		PalletQtyBoxes: '396',
		Retail: '238.79',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		MuzzleVelocity: '2150',
		MuzzleEnergy: '4927',
		SectionalDensity: '0.327',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGS®',
		BulletWeightGrain: '480',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EKqANY93--/095f40a95c8f1ddd7f82e77a609265b92853a73f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:45:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f4472669-2062-4637-9d7f-5753d53c90f6',
		ProductID: '095331',
		ProductName: 'Bullet Feeder Die 38/357 Mag',
		UPC: '090255953312',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '7.500',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '38 SPL/357 MAG',
		Caliber: '38 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Bullet Feeder Dies are case activated – a bullet will only feed upon contact with a case. The collets are precision machined of solid steel for each caliber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5ODx6Jae--/hwnaibacjc6npxwf3nfe.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c3e79fa1-e203-409c-9a6e-0bae9c524faf',
		ProductID: '190133',
		ProductName: 'Powder Bushing 327',
		UPC: '090255191332',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.069',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191339',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.69',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5f3ea96d-f6cd-46d1-bd85-1c02da1d7a59',
		ProductID: '355571',
		ProductName: '9mm .355 115 gr FMJ-RN',
		UPC: '090255710250',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '8.575',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255710257',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.45',
		PalletQtyBoxes: '216',
		Retail: '111.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.14',
		SectionalDensity: '0.13',
		OAL: '0.55',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kv740NZO--/hm5pqwsub0vuqjlnsull.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hv8sUG_K--/cd2a8379c7dfb5008740b210dd620327d80b336b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed97b2eb-7edd-488a-9772-bb95db7138c1',
		ProductID: '3234',
		ProductName: '8mm .323 180 gr GMX®',
		UPC: '090255232349',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255232346',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '35.0',
		PalletQtyBoxes: '900',
		Retail: '76.15',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.42',
		SectionalDensity: '0.246',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wjQauxNU--/bf9c049e093cc6894d92659b987cf1ee59da147b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7bf57cea-f9a8-4a67-bdf1-2a8451148229',
		ProductID: '90250',
		ProductName: '9mm Luger 115 gr FTX® Critical Defense®',
		UPC: '090255902501',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.746',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902508',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.46',
		PalletQtyBoxes: '1120',
		Retail: '37.05',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.129',
		MuzzleVelocity: '1135',
		MuzzleEnergy: '329',
		SectionalDensity: '0.13',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FTX®',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--tngVjpCn--/d7cd9d94881a6a22c0dce58e66336be29afc1f13.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2024-02-14 06:30:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31bdf4e2-c063-4b8b-bf8a-c7329e7dfc8f',
		ProductID: '90070',
		ProductName: '32 NAA 80gr FTX Critical Defense®',
		UPC: '090255706567',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255706564',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '5.5',
		PalletQtyBoxes: '1120',
		Retail: '35.84',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.136',
		SectionalDensity: '0.117',
		Cartridge: '32 NAA',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		BulletName: 'FTX®',
		BulletWeightGrain: '80',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--7Sp_M0xd--/8183433a72b3802ce00a9f618b8ef6f2acf481df.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6fc9b027-e153-4beb-96b5-eb19f57d7ce1',
		ProductID: '044159',
		ProductName: 'Seater Die (.308)300 Rem Ultra Mag',
		UPC: '090255441598',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.643',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441595',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '066c8e7a-fceb-42df-9844-25f3031cac14',
		ProductID: '546465',
		ProductName: 'Full-Length 3-Die Set 458 Lott (.458)',
		UPC: '090255564655',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564652',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.0',
		PalletQtyBoxes: '0',
		Retail: '87.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Rifle Die Sets',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '659bd04e-9e8f-4fc1-ab94-acff852e1f29',
		ProductID: '26331',
		ProductName: '6.5mm .264 140 gr ELD® Match',
		UPC: '090255263312',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.100',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255263319',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.5',
		PalletQtyBoxes: '540',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.646',
		G7BC: '0.326',
		MinTwist: '1-8"',
		SectionalDensity: '0.287',
		OAL: '1.374',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--c7HIYn04--/c92c7a761fca57419e08e131178df1ec50cfffa6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dfc786e2-9286-4c35-9700-c17a00a15028',
		ProductID: '044550',
		ProductName: 'Expander Die 450 Bushmaster (.452)',
		UPC: '090255445503',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445500',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ded80dbc-dd5f-4ebc-b56f-2e4782ebb011',
		ProductID: '81553',
		ProductName: '7x57 Mauser 139 gr SST® Superformance®',
		UPC: '090255815535',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.213',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815532',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.13',
		PalletQtyBoxes: '1400',
		Retail: '45.81',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.246',
		Cartridge: '7X57',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '139',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--rT2wzN-S--/6a66b051593c055178a4e06b6d3a7698e01a96a5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5dc389f8-2479-4533-a94e-559be84a8e76',
		ProductID: 'B6PPC',
		ProductName: 'Lock-N-Load® 6PPC Sako Modified Case',
		UPC: '090255704440',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704447',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '6MM PPC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b6fa691-1c90-46db-ad81-dab74f5cee9f',
		ProductID: '83481',
		ProductName: '6.8mm SPC 100 gr GMX® Custom',
		UPC: '090255834819',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.870',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255834816',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '8.7',
		PalletQtyBoxes: '1400',
		Retail: '43.12',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.274',
		SectionalDensity: '0.186',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		BulletName: 'GMX®',
		BulletWeightGrain: '100',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--m9Mgn5BO--/ead27d4d8549e4bb2115276e553054939975d961.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3cc765e3-254b-4284-8709-814e25ecab8c',
		ProductID: '050129',
		ProductName: 'Micrometer For Handgun Rotor & Metering Assembly',
		UPC: '090255501292',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501299',
		CartonHeight: '12.000',
		CartonWidth: '7.000',
		CartonDepth: '2.000',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '55.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For precise measurements, the micrometer inserts allow the user to make and monitor incremental changes and return to previous settings.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ygeH2-oT--/aprxueptdemmvfwvbopa.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b9d7cf5d-4dce-4168-ae76-955128ebdfc8',
		ProductID: '83202',
		ProductName: '22 WMR 30 gr V-MAX® Varmint Express® Rimfire',
		UPC: '090255832020',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.625',
		ShelfWidth: '1.75',
		ShelfDepth: '3.375',
		Weight: '0.526',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255832027',
		CartonHeight: '4.500',
		CartonWidth: '17.188',
		CartonDepth: '8.000',
		CartonWeight: '21.04',
		PalletQtyBoxes: '5200',
		Retail: '22.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Rimfire Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.095',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '322',
		SectionalDensity: '0.085',
		Cartridge: '22 WMR',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '30',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5EsOUVj2--/2c08ba4af1490a816e0db2edd0d5ab58147f6405.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--S37lp994--/j0iocfjcvmk2m7ere9tz.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--YYxJe_an--/zdagpde6vxl0hagoxmfl.jpg',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2a26255d-0c0b-4c66-addd-95d8bf16a32b',
		ProductID: '050078',
		ProductName: 'Hornady® Precision Measurement System',
		UPC: '090255500783',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.75',
		ShelfWidth: '8.5',
		ShelfDepth: '7.5',
		Weight: '11.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255500780',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '342.00',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision reloaders know the most consistent cartridges are built with the most consistent components. The Hornady® Multi-Purpose Measurement Tool allows the reloader to sort components according to size and quality by comparing bullet ogive location, cartridge base to ogive location, headspace location and overall case length.  Measure bullet runout for true cartridge case concentricity, and identify inconsistencies such as case and bullet dents. Base weighs nearly 8 pounds and has leveling feet for stability. Tool includes five headspace bushings, seven bullet comparators and accessory mount. Provides improved accuracy for handloaders. Can be used to sort factory ammunition. Base weighs nearly 8 pounds. Has leveling feet for stability. Includes five headspace bushings, seven bullet comparators, and accessory mount. Provides improved accuracy for handloaders, and can be used to sort factory ammo too.',
		ProductImage: 'http://images.salsify.com/image/upload/s--vbLclsFi--/jju1bkkfmutlpzjplbqf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lURduLCY--/tiewdlvhyswzxu7mc5hm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--9jZzTvyS--/azoqb6ytui5mhqgaec2k.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--v5Wj1SnY--/t9tzrgphdaijwatakimj.jpg',
		Videos: 'https://vimeo.com/368029907',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5daeb1c-5a85-4aae-a780-42068f502958',
		ProductID: 'FR266',
		ProductName: '5.56 NATO 62 gr FMJ Frontier®',
		UPC: '090255711547',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '6.375',
		ShelfWidth: '12.375',
		ShelfDepth: '5.625',
		Weight: '27.200',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711544',
		CartonHeight: '6.375',
		CartonWidth: '12.375',
		CartonDepth: '5.625',
		CartonWeight: '27.2',
		PalletQtyBoxes: '96',
		Retail: '637.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.274',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE CARTON',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--S2pVWIuv--/82e3a17dabe683ee4e8926debb06446824aad234.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8b0c665-ec27-471b-b01e-cfba73281986',
		ProductID: '546297',
		ProductName: 'Full-Length 2-Die Set 270 WSM (.277)',
		UPC: '090255562972',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.459',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562979',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.295',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '09409f13-b2ff-41bd-afe8-575a7e98303f',
		ProductID: '546527',
		ProductName: 'Full-Length 3-Die Set 38 Spl /357 Mag/357 Max (.357)',
		UPC: '090255565270',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.766',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565277',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.83',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '38 SPL/357 MAG/357 REM MAX',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee92cfba-d1a4-464b-8040-6170e4696081',
		ProductID: '95902',
		ProductName: 'Hornady® Canister Dehumidifier',
		UPC: '090255959024',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.25',
		ShelfWidth: '6',
		ShelfDepth: '6',
		Weight: '2.150',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959021',
		CartonHeight: '5.250',
		CartonWidth: '11.250',
		CartonDepth: '15.250',
		CartonWeight: '10.75',
		PalletQtyBoxes: '630',
		Retail: '27.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'COBALT DICHLORIDE',
		Prop65Chem2: 'COBALT DICHLORIDE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '4',
		ProductExtWidth: '5.3',
		ProductExtDepth: '4.8',
		ProductWeight: '2',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Protect your valuables against rust and corrosion. When the moisture control crystals turn pink, recharge unit by placing it in the oven. Unlimited recharges ensure a lifetime of use. Protect firearms and other valuables from rust and corrosion. Desiccant crystals change color when canister needs recharging. Recharge canister by placing in a 300ºF oven until drying granules turn blue (up to 4 hours). Unlimited recharges, no batteries required.  Dimensions: 4"H x 5.3"W x 4.8"D IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--vET1CTo1--/tnlg8fn4v8mypszuf3hc.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s---IZjNerf--/r4vq9krsq75k3yukwblb.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--9Haod8lo--/s2khfc2qwgvyeukzzsrh.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ae758a40-ee03-4c33-8281-5a166f067326',
		ProductID: '544329',
		ProductName: 'Match™ Grade 2-Die Set 7mm WSM (.284)',
		UPC: '090255543292',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543299',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.5',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19bce42d-99df-4729-8c32-83286bedce00',
		ProductID: '80552',
		ProductName: '7mm WSM 162 gr ELD-X® Precision Hunter®',
		UPC: '090255805529',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.520',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805526',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.2',
		PalletQtyBoxes: '930',
		Retail: '81.84',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.631',
		G7BC: '0.318',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '3237',
		SectionalDensity: '0.287',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GOxHJqb_--/c713bbaff9b278fc147e6bb94c9594522db66782.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d4f4aa3-2b81-4643-bfd9-f4d47eba09f5',
		ProductID: '8648',
		ProductName: '8 X 57 JS Unprimed Cases',
		UPC: '090255486483',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486480',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '6.75',
		PalletQtyBoxes: '200',
		Retail: '67.88',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '8X57 JS',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5beda6d7-5d33-4362-af21-4acb90f88e88',
		ProductID: '392167',
		ProductName: 'Collet #14 .204 Cal',
		UPC: '090255921670',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.047',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921677',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.47',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OQ2WT67d--/e2ba5243072f07ec9815e24472caeb28f6323e01.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd5513456-41ee-4c1a-8a04-15758fe4d66a',
		ProductID: '397112',
		ProductName: 'Seating Stem 7mm ELD® Match™ 180 Gr',
		UPC: '090255971125',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971122',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e24459c1-d740-4598-8c38-337a0c0abfbd',
		ProductID: '044113',
		ProductName: 'Seater Die (.311-.312) 32Aut-32/20',
		UPC: '090255441130',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.521',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441137',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '981ff7a0-c58c-487a-8538-6e492200cc27',
		ProductID: '254104',
		ProductName: '25 Cal .257 90 gr CX™',
		UPC: '090255719475',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.748',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255719472',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '18.7',
		PalletQtyBoxes: '900',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'CX™ Bullets',
		GeneralApplication: 'Hunting',
		G1BC: '.273',
		SectionalDensity: '0.195',
		OAL: '1.135',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'CX™',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			" The CX™ (Copper alloy eXpanding) bullet from Hornady represents the most advanced monolithic hunting bullet on the market. Its optimized design offers extended range performance, greater accuracy, high weight retention, and deep penetration.  MONOLITHIC COPPER ALLOY BULLET One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention. HEAT SHIELD® TIP The Heat Shield® Tip is made of a heat resistant polymer that resists aerodynamic heating and provides a consistently high BC for the bullet's entire flight path. The Heat Shield® tip also gives the bullet a perfect meplat (tip) for bullet-to-bullet and lot-to-lot consistency. OPTIMUM GROOVE GEOMETRY The grooves on the CX™ bullet maximize aerodynamic performance while effectively reducing bearing surface and fouling. NONTRADITIONAL OPTION FOR LARGE GAME Fully California compatible and appropriate for use in other areas that require nontraditional bullets, CX™ provides a great option for everything from medium-size to large game",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--RXLqS-zv--/jphatjynfzi7dtigwcks.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Hb8LJ-lg--/dnr1zllofhwsh4kuagra.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6PlLxR_--/hnvjovcpoge44lvmxgnl.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KdNfyAgw--/fcrbtncemngkkglc2bo1.png',
		Videos: 'https://vimeo.com/638844521',
		Videos1: 'https://vimeo.com/631397601',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ea70854-e860-418a-aa36-181ebc0875f5',
		ProductID: '98166',
		ProductName: 'Hornady® RAPiD® Safe Adjustable Wristband',
		UPC: '090255981667',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.75',
		ShelfWidth: '4.125',
		ShelfDepth: '1',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255981664',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '0',
		Retail: '21.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RFID Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'Lead',
		Prop65Chem2: 'Chromium',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		ProductWeight: '0.07',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Every Hornady Security RAPiD Safe can be programmed to read up to five different RFID tags. Various tags and accessories are available.  Dimensions: 0.125"H x 0.625"W x 10"D',
		ProductImage: 'http://images.salsify.com/image/upload/s--ETPY3uFh--/vqyd6eucdyekezppvpgr.jpg',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f127c1a-e644-437a-bad5-eeead7b0a863',
		ProductID: '095140',
		ProductName: 'Lock-N-Load® AP™ Tool Caddy',
		UPC: '090255951400',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '11',
		ShelfWidth: '4',
		ShelfDepth: '4',
		Weight: '2.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Improve efficiency and convenience by storing frequently used tools directly on your AP™ press. Install the bracket and caddy on either side of the press and rotate to the desired position. Then, insert supplied tools, including three combination wrenches, four hex wrenches, needle nose pliers, and a Hornady® Deluxe Die Wrench, for quick access and efficient organization.',
		ProductImage: 'http://images.salsify.com/image/upload/s--3NSsk2Lz--/xzlajnosjdpngesusc4q.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f5d706e1-88ac-446b-969d-7db602455df5',
		ProductID: '046534',
		ProductName: 'Size Die 10mm/40 S&W (.400)',
		UPC: '090255465341',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.462',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465348',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '40 S&W/10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6b1c0c5a-6a47-41cd-8d1a-5e1ac10ade53',
		ProductID: '490503',
		ProductName: 'Crimp Starter 20 Ga 8 Pt',
		UPC: '090255945034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.5',
		ShelfDepth: '0.05',
		Weight: '0.040',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255945031',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.4',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Universal Crimp Starters',
		Cartridge: '20 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--CE5yeAr4--/baehdwiavoqrlfxfwz26.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0abbbebd-56d0-4b4f-a100-453280c3d433',
		ProductID: '8728',
		ProductName: '32 Winchester Special Unprimed Cases',
		UPC: '090255487282',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.202',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487289',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.01',
		PalletQtyBoxes: '400',
		Retail: '64.77',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '32 WIN SPL',
		Caliber: '32 CAL',
		BulletDiameter: '0.321',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a0464a69-782f-42cc-965b-472cad9ca59c',
		ProductID: '9070',
		ProductName: '44 Special 180 gr XTP®',
		UPC: '090255390704',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.937',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390701',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '9.37',
		PalletQtyBoxes: '1120',
		Retail: '26.99',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.138',
		SectionalDensity: '0.139',
		Cartridge: '44 SPL',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--M3us0ZJ_--/dee794a980f4fdd84fb43279699551e1885c27c3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06f740c3-9f83-4a8b-a0a9-38d04764e4fe',
		ProductID: '83464',
		ProductName: '6.8mm SPC 110 gr V-MAX® Hornady BLACK®',
		UPC: '090255834642',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255834649',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1400',
		Retail: '39.13',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady BLACK® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		G1BC: '0.37',
		MuzzleVelocity: '2575',
		MuzzleEnergy: '1619',
		SectionalDensity: '0.205',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady BLACK® ammunition features versatile loads optimized for excellent performance from America’s favorite guns.  Loaded with legendary Hornady® bullets, Hornady BLACK® ammunition is designed to fit, feed and function in a variety of platforms. Proudly made in the USA!  Direct impingement, gas piston, suppressed, unsuppressed, inertia, bolt, pump, supersonic, subsonic, rifle, mid-length, carbine or pistol – Hornady BLACK ammunition delivers superior performance for a variety of applications.  Featuring:  High-Quality Cases, Primers Propellant Versatile Hornady bullet options Optimized performance from various platforms',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--RaFQP6RZ--/c2395dada2b26f14ed504acb147a929e54f5b35b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lxT6YXDH--/8d4285a2e537d40fc864a16c8b7ab04e02c01ac4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MfjiHbk---/tw9f73znt8jrsocdwqhn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--poCK8RGV--/aue8mnovopbsnwbe1p5c.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Um563m6l--/bdwiwrqiwoj2trbtuw5t.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jvGXkujd--/uwn8nhaicausez8gbfyw.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--Dc86bWMV--/wl5ssl8pwtxlwkzh4vb2.png',
		Videos: 'https://vimeo.com/195532286',
		Videos1: 'https://vimeo.com/188881257',
		Videos2: 'https://vimeo.com/401371862',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '64a9623b-1b84-4c84-b97b-92997db20f6f',
		ProductID: '546399',
		ProductName: 'Full-Length 2-Die Set 338 RCM (.338)',
		UPC: '090255563993',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563990',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.25',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '338 RCM',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cdc11253-c07c-45f3-a6c8-01b54b1a3f7d',
		ProductID: '546534',
		ProductName: 'Full-Length 3-Die Set With Taper Crimp 10mm/40 S&W (.400)',
		UPC: '090255565348',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.890',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565345',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.45',
		PalletQtyBoxes: '0',
		Retail: '81.17',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Taper Crimp Handgun Die Sets',
		Cartridge: '40 S&W/10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® 3-Die Taper Crimp Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin and Decap Pin Retainer is mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.   The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Taper Crimp Seating Die that features intuitive design that allows seating and taper crimping to be completed in one step, eliminating the need for a separate taper crimp die.  Precise control is achieved by the use of the Taper Crimp Adjustment Screw that easily adjusts the amount of crimp on the cartridge without changing bullet seating depth or loosening the lock ring. Hornady® Taper Crimp dies feature an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results.   HORNADY® 3-DIE TAPER CRIMP DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • Taper Crimp Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cja6tvEo--/s5vomxew87obdcclrxwr.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--aROXT8VW--/syxt7m7qvlomyagtd9du.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6de0d0c7-fc33-43e2-a302-c4cbbc26d72b',
		ProductID: '27409',
		ProductName: '270 Cal .277 150 gr InterBond®',
		UPC: '090255274097',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.268',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255274094',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.02',
		PalletQtyBoxes: '540',
		Retail: '97.33',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.525',
		SectionalDensity: '0.279',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '150',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--k1fncati--/36885da45f12784a994efa6d6284fa5261c0bb65.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd18d16b0-f65c-4d6a-936b-6a104d0ceeef',
		ProductID: '050149',
		ProductName: 'Universal Trim Length Gauge',
		UPC: '090255501490',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '0.5',
		ShelfDepth: '0.15',
		Weight: '0.015',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501497',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.15',
		PalletQtyBoxes: '0',
		Retail: '19.57',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Use this tool to set the case overall length on the Case Prep Center. May be used with 11 popular calibers from the 6.5 Grendel to the 375 H&H Mag, both fired and resized cartridge cases.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFCLDG6R--/hlz0lftlpa06ksflrewt.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f7a55d7a-8df8-49af-89dd-7af68a05c4f1',
		ProductID: '546504',
		ProductName: 'Full-Length 3-Die Set 7.5 Swiss Ord (.312)',
		UPC: '090255565041',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565048',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '142.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Handgun Die Sets',
		Cartridge: '7.5 SWISS ORDNANCE',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a036d68-a4eb-447a-a746-14dd4ac13729',
		ProductID: '050012',
		ProductName: 'Lock-N-Load® Power Case Prep Center 110 Volt',
		UPC: '090255500127',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.625',
		ShelfWidth: '19.125',
		ShelfDepth: '13.625',
		Weight: '24.550',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '9.625',
		CartonWidth: '19.125',
		CartonDepth: '13.625',
		CartonWeight: '24.55',
		PalletQtyBoxes: '20',
		Retail: '908.05',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Save space on your bench and valuable time during the reloading process! The Lock-N-Load® Power Case Prep Center saves reloaders time and bench space by rolling all the necessary case prep functions into one unit. Its all-in-one versatility combines a power trimmer with chamfer/deburr tools, large and small primer pocket cleaners, six popular neck brush sizes (22 cal, 25 cal/6mm, 270 cal/6.5mm/7mm, 30 cal, 35 cal and 45 cal) and pilots in same calibers. Also includes shell holders 1, 2, 5, 16 and 35.  Features The trimmer is micro adjustable to .001" for precise and consistent trimming. Rugged housing and a powerful motor will give years of dependable service. Trims small to large cases measuring ¾" to 3¼". Removable trays are easy to detach and provide ample collection space for shavings. Innovative design keeps metal shavings in the catch trays and out of the cases. Easy grip handle offers leverage. Arrange the chamfer/deburr tools, primer pocket cleaners and neck brushes however you want on the front panel. Optional flash hole deburr tool, primer pocket reamer, primer pocket uniformer and additional neck brushes can be purchased separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--tYLK0Fao--/zvirx19wzmoyxhrrqu2h.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s---Mer0Om5--/gc0lo76gihlumapop9jw.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--w1oh4_Xi--/uptlfvgudhoqhsobgprv.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--oHDwjikd--/f2azbm9kglwyvn8xidvv.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--XlzQ5t2s--/jva0hwsy7gszkhk3kxyi.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--5T5-4f9V--/tchtlwbcsrxrli3axlbc.jpg',
		Videos: 'https://vimeo.com/145576420',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd51a0ec9-421f-4697-9d62-b0091e614295',
		ProductID: '044206',
		ProductName: 'Seater Die (.224) 22 Hornet',
		UPC: '090255442069',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.625',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255442066',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5b9ea4a9-0f6e-40ec-87dc-59db1202fab3',
		ProductID: '98168',
		ProductName: 'Hornady® RAPiD® Safe RFID Sticker (2 Pack)',
		UPC: '090255981681',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5',
		ShelfWidth: '3.5',
		ShelfDepth: '0.001',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '6.125',
		CartonWidth: '3.500',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '5.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RFID Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		ProductExtHeight: '1.125',
		ProductExtWidth: '1.125',
		ProductExtDepth: '0.001',
		ProductWeight: '0.001',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The RAPiD® Safe RFiD Adhesive Decal is made for use with any RFiD-enabled safe from Hornady Security. By using RFiD technology, there’s no need to find a key, register a fingerprint, or remember a combination.   The decals can adhere to plastic, glass, metal, wood — nearly any surface. Many people choose to adhere them to their mobile phone.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wgLAF3sW--/kyhutowy2zdexzubckpf.jpg',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '877cc11b-703a-4a40-996b-2eaa7ab85b73',
		ProductID: '4300',
		ProductName: '44 Cal .430 265 gr InterLock® FP',
		UPC: '090255243000',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.973',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255243007',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '59.595',
		PalletQtyBoxes: '540',
		Retail: '0.00',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.189',
		SectionalDensity: '0.205',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'FP',
		BulletWeightGrain: '265',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5OyU_7Zb--/105274a14208095ac054800ca1bc4f0b5db93e2a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-11-08 09:06:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '98d38039-a046-49e1-b6bb-ed37deec8a26',
		ProductID: '546203',
		ProductName: 'Full-Length 2-Die Set 5.7X28 FN (.224)',
		UPC: '090255562033',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.350',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562030',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.75',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '5.7X28MM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a61387cb-44c8-4692-8ae8-41efdd770992',
		ProductID: '046597',
		ProductName: 'Full-Length Size Die 338 Marlin Exp (.308)',
		UPC: '090255465976',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465973',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3c8f3ec6-20f5-4c65-b11d-ef6e2b0b5775',
		ProductID: '75914',
		ProductName: 'SnapSafe® Magnetic Swivel Hooks (2 Pk)',
		UPC: '842631100526',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.5',
		ShelfWidth: '4.5',
		ShelfDepth: '1.5',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100523',
		CartonHeight: '7.500',
		CartonWidth: '6.000',
		CartonDepth: '7.750',
		CartonWeight: '2.25',
		PalletQtyBoxes: '2000',
		Retail: '21.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '50',
		MasterPackUCC: '30842631100527',
		MasterPackHeight: '8.500',
		MasterPackWidth: '16.250',
		MasterPackDepth: '24.750',
		MasterPackWeight: '22.5',
		ProductDescription:
			'Powerful 1¼" diameter rare earth magnets allow hooks to be placed on any metal surface (i.e. cabinets, safes, shelving, appliances, etc.). Magnets rated for up to 65 pounds.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ScPJtQcx--/sbnwymdcriu88wasgn6z.jpg',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd71de95a-fde1-4091-aabe-4681df50734e',
		ProductID: '546440',
		ProductName: 'Full-Length 2-Die Set 7mm STW (.284)',
		UPC: '090255564402',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564409',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7MM STW',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '463de231-f3ac-458e-8600-ff0405988de8',
		ProductID: '81197',
		ProductName: '350 Legend 165 gr FTX Custom',
		UPC: '090255811971',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.950',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811978',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.5',
		PalletQtyBoxes: '1400',
		Retail: '39.99',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.250',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '1773',
		SectionalDensity: '0.187',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		BulletName: 'FTX®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--wPtmupQI--/rtpddhexlpbafcchwunw.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c8d6f1b-7ec0-4fb3-a70f-a6b851434e07',
		ProductID: '050100',
		ProductName: 'Powder Trickler',
		UPC: '090255501001',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.75',
		ShelfWidth: '6.25',
		ShelfDepth: '5.75',
		Weight: '0.171',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501008',
		CartonHeight: '8.750',
		CartonWidth: '8.250',
		CartonDepth: '10.250',
		CartonWeight: '1.71',
		PalletQtyBoxes: '900',
		Retail: '22.39',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Trickle the last few tenths of a grain of powder into a dropped and weighed charge for “0” variation. Features a wide, stable base, is easy to clean, and uses a small amount of powder to fill.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YXbLKlxi--/32f73c84cc2fa3814508306cb9d9f80189d2576f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--X1mA77wY--/pa0ye0khkhxsn4csrtqv.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e18c95ec-b768-40e7-be7e-5ee2b77256b4',
		ProductID: '010052',
		ProductName: '366 Auto 20 Ga Gas Assist 2-3/4',
		UPC: '090255010527',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '32.554',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '32.554',
		PalletQtyBoxes: '27',
		Retail: '1558.47',
		ParentCategory: 'Reloading',
		Cartridge: '20 GA',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--a4Loa5IV--/zpxyo8tgcszncvdkddjg.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--xYNrv8ia--/hbpp5fai4fpl8rxt4k18.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '82237a7e-f185-4d95-a175-d015f5a69c28',
		ProductID: '86721',
		ProductName: '300 Ruger Compact Magnum Unprimed Cases',
		UPC: '090255867213',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.892',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867210',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.46',
		PalletQtyBoxes: '200',
		Retail: '83.37',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '300 RCM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '42f7ab86-9542-4ccb-bfdf-558cc1a28fb6',
		ProductID: '75881',
		ProductName: 'Snapsafe® Gun Rack - Vehicle Headrest (2 Pack)',
		UPC: '851529004709',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '5.5',
		ShelfDepth: '8.5',
		Weight: '0.760',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004706',
		CartonHeight: '9.500',
		CartonWidth: '6.250',
		CartonDepth: '8.250',
		CartonWeight: '3.8',
		PalletQtyBoxes: '1350',
		Retail: '11.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '4',
		ProductExtWidth: '1.75',
		ProductExtDepth: '6',
		ProductWeight: '0.586',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Coated wire hooks secure to each headrest (driver and passenger seats) and hang behind seat to hold a long gun. Can be used to hold range bags, clothing or grocery bags as well. Great idea for over the headrest rifle storage. Wire rack secures long guns behind headrest. Coated wire will not scratch or mar firearms. Doubles as storage for range bags, clothing or grocery bags as well. Dimensions: 1.75”W x 4”H x 6”D Weight: 0.586 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--zPdP_v9U--/kpxiijqd6zfpx5yeln9q.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ndw5Lvl---/bmv58p3dqp3nkc7z6sgk.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--0K57L-xC--/fh8owbiuk1ffi0ua3ic2.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--5pCEnTAG--/wvqttoz9xdcynx3tr5gl.jpg',
		Videos: 'https://vimeo.com/225307961',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '35836fca-dd5f-4679-8f77-35943f95b610',
		ProductID: '546272',
		ProductName: 'Full-Length 2-Die Set 256 Win (.257)',
		UPC: '090255562729',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562726',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '256 WIN',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '923cc792-8c78-4af8-9a80-b481b8d4593d',
		ProductID: '99157',
		ProductName: 'Hornady® 75th Anniversary Tin Sign',
		UPC: '090255991574',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '6',
		ShelfDepth: '12',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--5wRGkrjx--/l4hgwcxkps5mp3tn7ff7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--5wRGkrjx--/l4hgwcxkps5mp3tn7ff7.png',
		DateLastModified: '2023-12-19 20:08:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '129d1d8d-dba7-4bc2-a805-3709eb6f26df',
		ProductID: '81490',
		ProductName: '6.5 Creedmoor 120 gr GMX® Superformance®',
		UPC: '090255814903',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814900',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.6',
		PalletQtyBoxes: '1400',
		Retail: '57.21',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.45',
		SectionalDensity: '0.246',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'GMX®',
		BulletWeightGrain: '120',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KkZrsxKC--/c9f55f301a9ee1fd17c4ca7067691da582050a2c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '888c0f14-c106-48b4-8419-a721a912f8b0',
		ProductID: '75400',
		ProductName: 'Snapsafe® Under Bed Safe XXL',
		UPC: '851529004433',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '11.5',
		ShelfWidth: '53.5',
		ShelfDepth: '29',
		Weight: '150.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '11.500',
		CartonWidth: '29.000',
		CartonDepth: '53.500',
		CartonWeight: '150.0',
		PalletQtyBoxes: '7',
		Retail: '677.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Auxiliary Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '7',
		ProductExtWidth: '48',
		ProductExtDepth: '24',
		ProductWeight: '150',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Store valuable belongings out of sight while maintaining easy access with the SnapSafe® Under Bed Safe. Available in three sizes! Slide-out drawer accommodates firearms, jewelry, documents, and more. Digital lock with key backup can be programmed with 3 to 8 digit access code. Pry-resistant door keeps children and unauthorized users from gaining access. Constructed of 14-gauge heavy-duty steel, with pre-drilled holes for permanent installation. Robust 5-foot cable provides added security when anchored to a stationary object. 48"W x 7”H x 24”D Weight: 150 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--dOjwvbKe--/v8re6yloyagxhitpz5te.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--AjFyiRTm--/syuaf2cw7g2dsx45ikst.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--WXGhaip0--/sihsrsaa3lpaozsw2wh8.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--OW5lVwJw--/trl8dc761vdbiqgcab1f.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KHXTnv17--/bvrd3pzqdyvzg1ujxh1i.jpg',
		Videos: 'https://vimeo.com/266771633',
		Videos1: 'https://vimeo.com/266773069',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef7adc29-bbc4-44eb-96ac-aa085791548f',
		ProductID: '380710',
		ProductName: 'Cartridge Gauge 6.5 Creedmoor (.264',
		UPC: '090255807103',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807100',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a668b6d6-0b0f-4223-9ec5-985ee430beec',
		ProductID: '26100',
		ProductName: '6.5mm .264 100 gr ELD® Match',
		UPC: '090255709490',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.518',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255709497',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.95',
		PalletQtyBoxes: '900',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.385',
		G7BC: '0.194',
		MinTwist: '1-9"',
		SectionalDensity: '0.205',
		OAL: '1.055',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xY-FfsOg--/6742c71c509e19a505a6b10f1deb9625c139ab5f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '08045d23-8294-489c-b031-dca233a18d82',
		ProductID: '80237',
		ProductName: '223 Rem 55 gr HP American Gunner®',
		UPC: '090255802375',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '2.625',
		ShelfDepth: '5.25',
		Weight: '1.385',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802372',
		CartonHeight: '5.687',
		CartonWidth: '5.937',
		CartonDepth: '14.687',
		CartonWeight: '13.85',
		PalletQtyBoxes: '800',
		Retail: '62.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Rifle Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.254',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs.  Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces a variety of rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting.  HORNADY® BULLETS HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance.  VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers.  QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kcXZTRXE--/iyerxgndyba02kfaeqcr.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--kylo5um6--/ed29bd22a613b1297e99c50c0ee3f8c8ecd61c62.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cn7bWxnr--/jqy5fotaq7bsq8mwwdcx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SzgHkrlW--/zrjrfe1l2jnxjtlm2gdb.jpg',
		Videos: 'https://vimeo.com/163447195',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a603bb2d-99de-434f-b3cf-24133c7b8beb',
		ProductID: '82229',
		ProductName: '300 RCM 165 gr GMX® Superformance®',
		UPC: '090255822298',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.515',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822295',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.15',
		PalletQtyBoxes: '930',
		Retail: '56.31',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Cartridge: '300 RCM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--O_GywRKs--/043186fad6f8ea314f650381b869ca919ec57c9d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '57d52a6c-1875-4a8f-b5a3-2fc977d2b495',
		ProductID: '392652',
		ProductName: 'Shellplate #52 Lock-N-Load®AP™ & Projector',
		UPC: '090255926521',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926528',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.5',
		PalletQtyBoxes: '0',
		Retail: '53.33',
		ParentCategory: 'Reloading',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6351523d-d601-4d08-b17a-252e7c59c503',
		ProductID: '305016',
		ProductName: '30 Cal .308 168 gr BTHP Match',
		UPC: '090255305012',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '6.262',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255305019',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.572',
		PalletQtyBoxes: '216',
		Retail: '123.64',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.450',
		SectionalDensity: '0.253',
		OAL: '1.23',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1Xn9M-v9--/4fff3186b6a911324d1eabacee1d69431239ab79.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a8adad8-f45e-49dd-a8f2-30d65339932b',
		ProductID: '33371',
		ProductName: '338 Cal .338 270 gr ELD-X®',
		UPC: '090255333718',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.043',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255333715',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '30.645',
		PalletQtyBoxes: '540',
		Retail: '75.00',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.757',
		G7BC: '0.381',
		MinTwist: '1-10"',
		SectionalDensity: '0.338',
		OAL: '1.69',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '270',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_Elb4kU9--/66306667b2e72dc93ecf76192e939a26ff37cce3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '453e605f-aee3-49e4-9cb8-3ed9be280125',
		ProductID: '546238',
		ProductName: 'Full-Length 2-Die Set 5.6X52R (.227)',
		UPC: '090255562385',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562382',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '5.6X52R',
		Caliber: '22 CAL',
		BulletDiameter: '0.227',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e617c71f-0dba-435d-a663-2d6cb6676dce',
		ProductID: 'FR402',
		ProductName: '300 Blackout 125 gr FMJ Frontier',
		UPC: '090255716351',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '4.990',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255716358',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '39.92',
		PalletQtyBoxes: '512',
		Retail: '217.75',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 300 Blackout Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.250',
		MuzzleVelocity: '2175',
		MuzzleEnergy: '1313',
		SectionalDensity: '0.188',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--M0Qht0yU--/c77e69aeff262401e00c7a9476b8ba5e7662bea6.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '38c048cd-0291-4777-9a74-7854171631b3',
		ProductID: '546224',
		ProductName: 'Full-Length 2-Die Set 222 Rem (.224)',
		UPC: '090255562248',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.485',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562245',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.425',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '222 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8bdf1c56-2303-4d44-a1eb-4d9161654910',
		ProductID: '390606',
		ProductName: 'Shell Holder #45',
		UPC: '090255906066',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906063',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '10594618-7888-4d29-bf5c-ba76417447e2',
		ProductID: '83028',
		ProductName: '22 Hornet 45 gr SP',
		UPC: '090255830286',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.625',
		ShelfDepth: '5.25',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255830283',
		CartonHeight: '5.687',
		CartonWidth: '5.937',
		CartonDepth: '11.187',
		CartonWeight: '9.0',
		PalletQtyBoxes: '840',
		Retail: '65.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.202',
		MuzzleVelocity: '2665',
		MuzzleEnergy: '710',
		SectionalDensity: '0.128',
		Cartridge: '22 HORNET',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP MATCH™',
		BulletWeightGrain: '45',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--irxIxy2Q--/9999bfb1568292caaeecdf5d5c510433e74a037a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bc0ca198-007b-48a5-9404-4f81c1786056',
		ProductID: '813944',
		ProductName: '6mm Creedmoor 90 gr. CX™ Superformance®',
		UPC: '090255719949',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.980',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719946',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.8',
		PalletQtyBoxes: '1400',
		Retail: '63.15',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.418',
		G7BC: '.218',
		MuzzleVelocity: '3325',
		MuzzleEnergy: '2209',
		SectionalDensity: '0.218',
		Cartridge: '6MM CREEDMOOR',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'CX™',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--1T7LaQnF--/okfwigl1klsmqrbdcxpi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ffe6f91f-ba6f-45ee-98cd-fce2cef548d2',
		ProductID: '546528',
		ProductName: 'Full-Length 3-Die Set Cowboy™ 38 Spl/357 Mag (.357)',
		UPC: '090255565287',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565284',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.5',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '38 SPL/357 MAG/357 REM MAX',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '475400fe-a022-46f7-ae81-d3eb54bcea97',
		ProductID: '8025',
		ProductName: '223 Rem 53 gr V-MAX® Superformance® Varmint',
		UPC: '090255380255',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380252',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.0',
		PalletQtyBoxes: '1680',
		Retail: '36.33',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.29',
		MuzzleVelocity: '3465',
		MuzzleEnergy: '1413',
		SectionalDensity: '0.151',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '53',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9gMh84hF--/39881cfae43d86de0202c75c9af23b22b5d0ee05.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b85880cd-7d6c-4bfd-8822-f1780efb09e1',
		ProductID: '190260',
		ProductName: 'Universal Handle Accessory',
		UPC: '090255192605',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192602',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '2.5',
		PalletQtyBoxes: '0',
		Retail: '5.21',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Fits all our case-neck brushes, and large and small primer pocket cleaning heads.',
		ProductImage: 'http://images.salsify.com/image/upload/s--YNRx0CYU--/rd4kpsuxrrnxiu5sq2q0.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '45be90a4-38e4-4cb9-85e2-33f756431c03',
		ProductID: '33361',
		ProductName: '338 Cal .338 250 gr BTHP',
		UPC: '090255333619',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.916',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255333616',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.74',
		PalletQtyBoxes: '540',
		Retail: '50.05',
		ParentCategory: 'Bullets',
		Applications: 'AppTargetMatch',
		G1BC: '0.67',
		SectionalDensity: '0.313',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '250',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WXOjT4da--/dc9fb92e0eb5c1390f085fb44bf4c3f88e792e93.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '970ce5a4-3f4f-4192-b1d7-e94d3d336ea1',
		ProductID: '390603',
		ProductName: 'Shell Holder #47',
		UPC: '090255906035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.043',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906032',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.43',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '91797ef7-089c-420c-be7a-9dfc3933ed26',
		ProductID: '046567',
		ProductName: 'Size Die 45/70 Govt (.458)',
		UPC: '090255465679',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.533',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465676',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '59.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Rifle Die Sets',
		Cartridge: '45-70 GOVT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fe3cb971-1372-4460-acec-1047179d3b2e',
		ProductID: 'C375',
		ProductName: 'Lock-N-Load® Headspace Bushing .375',
		UPC: '090255704471',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.128',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704478',
		CartonHeight: '4.750',
		CartonWidth: '10.500',
		CartonDepth: '7.250',
		CartonWeight: '1.28',
		PalletQtyBoxes: '0',
		Retail: '10.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Headspace Gauge & Bushings',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Headspace Comparator extends brass life, improves accuracy, and enhances safety. The gauge measures variations in brass before and after firing or re-sizing. It allows for headspace comparison between fire-formed brass and re-sized brass. Bushing only. Works with Headspace Gauge, sold separately.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VFSOFiSc--/jrryvcxrj7b7lor5idtf.jpg',
		Videos: 'https://vimeo.com/288805295',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '49f9ceb3-0281-4b50-b837-7391a313b50f',
		ProductID: '8636',
		ProductName: '275 Rigby Unprimed Cases',
		UPC: '090255486360',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.420',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486367',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '7.1',
		PalletQtyBoxes: '400',
		Retail: '67.88',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '275 RIGBY',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '60d332c8-b884-46a0-9cee-d8ae1a0df6b6',
		ProductID: '190153',
		ProductName: 'Powder Bushing 414',
		UPC: '090255191530',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191537',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9a8902ca-bb20-4f2f-b15f-a55f07b1e7e0',
		ProductID: '397131',
		ProductName: 'Seating Stem 7mm ELD-X® 150/162 Gr',
		UPC: '090255971316',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971313',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5d27683a-210e-4e2a-9e18-f43ea52822e4',
		ProductID: '10208',
		ProductName: '38 Cal .358 148 gr HBWC',
		UPC: '090255102086',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '5.577',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255102083',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '33.462',
		PalletQtyBoxes: '216',
		Retail: '44.52',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Frontier® Lead Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.047',
		SectionalDensity: '0.165',
		Caliber: '38 CAL',
		BulletDiameter: '0.358',
		BulletName: 'HBWC',
		BulletWeightGrain: '148',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Rpg63-9O--/c4121e8d39b89bdb881a8c360852927ad6d0dff2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c83d81aa-fc42-4702-a51d-d370d8b1818f',
		ProductID: '8625B',
		ProductName: '25-06 Remington Unprimed Cases',
		UPC: '090255600698',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '39.163',
		WeightUOM: 'LB',
		CaseQty: '1500',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '58744.5',
		PalletQtyBoxes: '66000',
		Retail: '0.72',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7dd173dc-7a70-43b7-ad2b-75bc3e9d0498',
		ProductID: '75013',
		ProductName: 'Snapsafe® Super Titan XXL Double Door',
		UPC: '851529004808',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '28.5',
		ShelfWidth: '50.5',
		ShelfDepth: '65',
		Weight: '915.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '28.500',
		CartonWidth: '50.500',
		CartonDepth: '65.000',
		CartonWeight: '915.0',
		PalletQtyBoxes: '1',
		Retail: '3819.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Modular Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '9V',
		BatteryQty: '1',
		BatteryWattHour: '5.49',
		BatteryWeight: '33.9',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '59',
		ProductExtWidth: '46',
		ProductExtDepth: '30',
		ProductWeight: '900',
		ProductIntHeight: '53.5',
		ProductIntWidth: '41',
		ProductIntDepth: '26.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'SnapSafe modular safes are easy to assemble and move anywhere. Simply unpack them piece by piece and assemble them close to your desired location. The SnapSafe modular assembly system locks the walls together from the inside, making them as solid and impenetrable as conventional, welded safes. Their 2300°F fire protection offers peace of mind knowing firearms, jewelry, currency and valuable documents are protected from fire and theft. Here’s all the security of a conventional, welded safe in an easy-to-assemble gun vault that moves anywhere piece-by-piece, then locks together in minutes with no tools. Super Titan home fire safe provides your documents, valuables, firearms and jewelry with protection from fire and theft.  Every Super Titan ships with one full shelf and full gun rack, plus a half gun rack with two half shelves, to let you configure your vault to meet your needs. The Super Titan Double Doors feature a full gun rack. The recommended capacity is 56 long guns (XXL) when stored in sleeves with the muzzles up and down, fewer if your guns have optics.  Exterior: 59"H x 46"W x 30"D (add 3" for handle) Interior: 53.5"H x 41"W x 26.5”D Door Opening: 52"H x 37”W Locking Bolts: 14 Weight: 900 lbs. (Shipping: 905 lbs) Capacity: 56+ Long Guns SecuRAM™ Lock: UL-listed digital lock with EMP-proof mechanical key backup  FEATURES Delivered right to your door. Assembles in minutes without additional tools (wrench included). Modular Assembly System. Sledgehammer- and pry-bar resistant 3/16" solid-steel door. Thick 9 gauge 2-ply steel exterior walls 2300°F one-hour Fire Shield protection. Heat-activated door fire seals. Internal panels are made of magnesium oxide (MgO) and are nearly impervious to fire, moisture, insects and mold Comes standard with an EMP Lock that offers electronic or mechanical opening operation. 14 1-inch chrome steel live locking bolts. Spring-loaded relocker. Powder-coated finish. Lined interior. Adjustable lined shelves. One full shelf, one full gun rack, two half shelves and a divided shelf Professional grade "non-breach seal" dead-bolt door. Pre-drilled for floor mounting. Lifetime warranty.',
		ProductImage: 'http://images.salsify.com/image/upload/s--GCQqrmYW--/slowocxzdrgi7d7vl83h.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--iSNUNgpW--/ryxx5dxrhzahhycl6v8c.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3TUSewEz--/v1dd8sxgwrgkxvzpt6oa.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0f3JoqWW--/cbyf2o0ush8shgf2sz2e.png',
		Videos: 'https://vimeo.com/220662709',
		Videos1: 'https://vimeo.com/370420587',
		DateLastModified: '2024-01-22 14:38:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d58c95c-c9c5-41d2-932b-9ef86d9b73a3',
		ProductID: '90061',
		ProductName: '327 Federal Mag 80 gr FTX Critical Defense',
		UPC: '090255900613',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900610',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '5.0',
		PalletQtyBoxes: '1120',
		Retail: '47.25',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.136',
		SectionalDensity: '0.117',
		Cartridge: '327 FEDERAL MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		BulletName: 'FTX®',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--bM0fm4bm--/kcv9cfgc2koesyvavzsa.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ceeebd6b-c2b8-4295-8b8b-6db214bc33a0',
		ProductID: '80636',
		ProductName: '7mm Rem Mag 162 gr ELD-X® Precision Hunter®',
		UPC: '090255806366',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.510',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255806363',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.1',
		PalletQtyBoxes: '780',
		Retail: '75.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.631',
		G7BC: '0.318',
		MuzzleVelocity: '2975',
		MuzzleEnergy: '3183',
		SectionalDensity: '0.287',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OX-oDyee--/ba3c6cce8c5d84aa096c45cb7f1049ce761f7ddf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9ba5f6e2-4525-450a-be9a-359dad0841ea',
		ProductID: '3140',
		ProductName: '7.62 Cal .310 123 gr SP',
		UPC: '090255231403',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.864',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255231400',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.6',
		PalletQtyBoxes: '900',
		Retail: '45.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.252',
		SectionalDensity: '0.183',
		OAL: '0.85',
		Cartridge: '7.62x39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--abz8GoeW--/60b09cdb9f05533fc6378f65ab647a7cf4c4dcba.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f12dd6ce-54cc-40ef-a87f-a5e1aa348cbf',
		ProductID: '046040',
		ProductName: 'Neck Size Die 22 Cal (.224)',
		UPC: '090255460407',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.497',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460404',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a56362da-cc5b-4a78-a26b-c2cbd4c293f1',
		ProductID: '380706',
		ProductName: 'Cartridge Gauge 45 Auto (.451)',
		UPC: '090255807066',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.175',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807063',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '1.75',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9dde5ca9-a5b3-412f-b627-0bdfb05e20a1',
		ProductID: '95229',
		ProductName: 'Dual-Lid Lock Box',
		UPC: '090255952292',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.5',
		ShelfWidth: '12.125',
		ShelfDepth: '2.5',
		Weight: '5.950',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255952299',
		CartonHeight: '13.390',
		CartonWidth: '11.220',
		CartonDepth: '12.990',
		CartonWeight: '29.75',
		PalletQtyBoxes: '0',
		Retail: '57.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Lock Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '11',
		ProductExtDepth: '10',
		ProductWeight: '5.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Keep two handguns secure or store ammo safely and separately from your firearm in one space saving, easy-to-carry lock box. This unique design provides two spaces in one, each with a separate lid and keyed alike lock. The built-in handle makes it simple to transport. Durable 16-gauge steel housing Steel security cable with patented connector Two keyed alike steel barrel locks Foldable carry handle Premium foam interior Overall Exterior Dimensions: 11"W x 10"D x 2"H Interior Dimensions: See illustration Weight: 5.5 lbs IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check the dimensions of your firearm against the safe\'s interior dimensions. Firearm and firearm accessories are not included.',
		ProductImage: 'http://images.salsify.com/image/upload/s--dRhKcgxg--/n5ixxceklzxn1xvbnhey.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--57e4hRDT--/fdmzswjhgcgzzjfcn7im.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jXDd7Mgy--/yocb4kikwisoezpebarr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--o5tI6mdo--/wqbrndukwo8oo4c5frik.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--Sq_wNjgx--/bmnhepshhqol4lmjcd5k.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--DPC0QVAx--/zwmic0dkxuamrz2emlaq.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--qRY5UjnZ--/wfnqq00mrwojaxcqk5qx.png',
		Videos: 'https://vimeo.com/763814581',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93ee8b71-85a7-45e2-8105-327e1cd93b5d',
		ProductID: '050180',
		ProductName: 'Case Prep Duo 110 Volt',
		UPC: '090255501803',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10.9',
		ShelfWidth: '8',
		ShelfDepth: '2.4',
		Weight: '1.850',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255501800',
		CartonHeight: '9.000',
		CartonWidth: '9.750',
		CartonDepth: '11.000',
		CartonWeight: '7.4',
		PalletQtyBoxes: '640',
		Retail: '86.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '3.7V Lithium',
		BatteryQty: '1',
		LithiumBattery: 'Yes',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--LnKdKCLA--/aoovmn3xfeoq3bfopkte.pdf',
		ProductDescription:
			'Make quick work of various reloading chores with this cordless, rechargeable multifunction tool that accommodates case neck brushes, primer pocket cleaners, and chamfer/deburr accessories. With the easy to swivel body and integrated rubber feet, use it in the straight configuration on your bench top, or rotate it 180 degrees for an ergonomic handheld power tool. Use with the 8-32 spindle head for various reloading functions or remove the spindle head and use as a powered screwdriver with standard ¼-inch hex bits (not included). Comes with plug-in charger, ID and OD chamfer tools.',
		ProductImage: 'http://images.salsify.com/image/upload/s--uWtQadc6--/pcqatjrdgqnh07dfql9x.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fK6mym-C--/mhin4pdlfvf2exfql8f7.png',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da6be86c-a079-4ea3-90af-480f8822ea86',
		ProductID: '3074',
		ProductName: '30 Cal .308 178 gr ELD-X®',
		UPC: '090255230741',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.665',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230748',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.975',
		PalletQtyBoxes: '540',
		Retail: '63.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.552',
		G7BC: '0.278',
		MinTwist: '1-12"',
		SectionalDensity: '0.268',
		OAL: '1.396',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VYVDZ-CA--/5f1ed24c8ae1eaff7d8f52d016baa494f39ace1c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8366ab15-db49-456d-9eff-af23d20a667f',
		ProductID: '390570',
		ProductName: 'Shell Holder #30',
		UPC: '090255905700',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905707',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d251bb4-afed-4c8f-a32e-2b58905e21f9',
		ProductID: '22762',
		ProductName: '22 Cal. .224 62 gr. ELD-VT™',
		UPC: '090255227628',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '0.992',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227625',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '24.8',
		PalletQtyBoxes: '900',
		Retail: '39.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-VT™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		G1BC: '.395',
		G7BC: '.199',
		MinTwist: '1-8"',
		SectionalDensity: '0.177',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD-VT™',
		BulletWeightGrain: '62',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady ELD-VT™ bullet is here to redefine your shooting and varmint hunting pursuits, offering unmatched accuracy, explosive fragmentation, and the confidence to take on any challenge – from competitions to long-range varmint hunts. Precision Perfected Born from a culmination of years of ballistic research, the ELD-VT™ pairs the aerodynamics of low drag match bullets with the light weight, high velocity of a varmint bullet, giving the ELD-VT™ a level of uncompromising dual-use performance.  Say goodbye to compromise, as this bullet’s match-winning accuracy and violent expansion will set new standards. Explosive Impact The Hornady ELD-VT™ bullet isn’t just about hitting the bullseye – it’s about making a statement when it gets there.  Upon impact, the polymer tip drives rearward into the bullet core, causing rapid and dramatic fragmentation, even at low velocity. Advanced Manufacturing Process (AMP) Bullet Jackets A testament to the unwavering commitment to excellence, AMP bullet jackets provide unrivaled consistency in concentricity and thickness, ensuring every ELD-VT™ bullet performs at its peak potential. Heat Shield® Technology ELD-VT™ bullets incorporate the Heat Shield® tip, which is immune to the effects of aerodynamic heating. They retain their shape to maintain the lowest drag over their entire trajectory.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--5GqmaAKT--/endnuctusfrtitai8gsy.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WyGkcYJB--/ful8k0ufdgsv7xjyzpfi.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--pmytqCwd--/f3nmjpfng5saoyllsfjg.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0K1NqHAh--/chfjtw6rihomshyilysz.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--szcfF2fb--/wnqo8eofoesuzickxo0s.png',
		Videos: 'https://vimeo.com/876107595',
		DateLastModified: '2024-03-04 15:49:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '412892c2-5b22-4346-ab6f-74489d40d7e9',
		ProductID: '546387',
		ProductName: 'Full-Length 2-Die Set 325 WSM (.323)',
		UPC: '090255563870',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563877',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '325 WSM',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bcc11de3-aeb5-4a42-82b4-e8b4877131e2',
		ProductID: '150215',
		ProductName: 'Lock-N-Load® Sonic Cleaner™ Indirect Tank 7L',
		UPC: '090255502152',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.750',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.51',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Accessory for Hornady lock-n-load Sonic Cleaner 7L Clean 2 small batches simultaneously 7 liter Tank',
		ProductImage: 'http://images.salsify.com/image/upload/s--M8lGb5q3--/ixzr4uixoq0kv7a2hkzj.jpg',
		DateLastModified: '2023-12-16 08:58:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e932722-850e-4881-a173-c1bce3509736',
		ProductID: '24372',
		ProductName: '6mm .243 80 gr. ELD-VT™',
		UPC: '090255243727',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.256',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255243724',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.4',
		PalletQtyBoxes: '900',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-VT™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		G1BC: '.405',
		G7BC: '.202',
		MinTwist: '1-8"',
		SectionalDensity: '0.194',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'ELD-VT™',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady ELD-VT™ bullet is here to redefine your shooting and varmint hunting pursuits, offering unmatched accuracy, explosive fragmentation, and the confidence to take on any challenge – from competitions to long-range varmint hunts. Precision Perfected Born from a culmination of years of ballistic research, the ELD-VT™ pairs the aerodynamics of low drag match bullets with the light weight, high velocity of a varmint bullet, giving the ELD-VT™ a level of uncompromising dual-use performance. Say goodbye to compromise, as this bullet’s match-winning accuracy and violent expansion will set new standards. Explosive Impact The Hornady ELD-VT™ bullet isn’t just about hitting the bullseye – it’s about making a statement when it gets there. Upon impact, the polymer tip drives rearward into the bullet core, causing rapid and dramatic fragmentation, even at low velocity. Advanced Manufacturing Process (AMP) Bullet Jackets A testament to the unwavering commitment to excellence, AMP bullet jackets provide unrivaled consistency in concentricity and thickness, ensuring every ELD-VT™ bullet performs at its peak potential. Heat Shield® Technology ELD-VT™ bullets incorporate the Heat Shield® tip, which is immune to the effects of aerodynamic heating. They retain their shape to maintain the lowest drag over their entire trajectory.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--sdm-nkJ1--/xt7vcyggchv31gd57iac.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WyGkcYJB--/ful8k0ufdgsv7xjyzpfi.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--pmytqCwd--/f3nmjpfng5saoyllsfjg.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0K1NqHAh--/chfjtw6rihomshyilysz.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eOAGpf1w--/qi8zxhzx2kb1cgn5scwe.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--szcfF2fb--/wnqo8eofoesuzickxo0s.png',
		Videos: 'https://vimeo.com/876107595',
		DateLastModified: '2024-03-04 15:49:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '997fece2-6de3-4a67-86c7-0f6add6d9ab5',
		ProductID: '380704',
		ProductName: 'Cartridge Gauge 40 S&W (.400)',
		UPC: '090255807042',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807049',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3903368e-4d92-439b-923e-36e5d23bd09b',
		ProductID: '397106',
		ProductName: 'Seating Stem 6.5mm ELD® Match™',
		UPC: '090255971064',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.030',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971061',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.3',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b0b799b8-ee68-4b5f-8409-2e72d5a82cfe',
		ProductID: '594263',
		ProductName: 'Match™ Grade Bushing .263',
		UPC: '090255592634',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592631',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.263',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Hyj-SFKg--/f1f36309fab11fef46633adf783932cbea578e78.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9b2cf1b0-0845-4082-b203-8a57a81ee3b8',
		ProductID: '90324',
		ProductName: '38 Special 125 gr XTP ® American Gunner®',
		UPC: '090255903249',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.825',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255903246',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.25',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.151',
		MuzzleVelocity: '900',
		MuzzleEnergy: '225',
		SectionalDensity: '0.14',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'XTP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--9HXm_Bn9--/648077e7ee5f7da4b709b5dc6e1c011ecc49a900.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '115759e9-2ed9-4ba5-a479-03453bfa21a2',
		ProductID: '86464',
		ProductName: '7-30 Waters Unprimed Cases',
		UPC: '090255864649',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255864646',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.5',
		PalletQtyBoxes: '400',
		Retail: '60.13',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '7-30 WATERS',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72bd8e55-30a3-4409-a872-f81f19a75b22',
		ProductID: '8710',
		ProductName: '380 Automatic Unprimed Cases',
		UPC: '090255487107',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.470',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487104',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '7.35',
		PalletQtyBoxes: '400',
		Retail: '70.84',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '380 AUTO',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bcc7a7c3-ec5d-42eb-a767-07b6664e0d7f',
		ProductID: '546334',
		ProductName: 'Full-Length 2-Die Set 30 Herrett (.308)',
		UPC: '090255563344',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563341',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30 HERRETT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b040ac93-6ed1-4ab5-a8fe-413fc4dee482',
		ProductID: '75421',
		ProductName: 'SnapSafe® Premium Vault Door Gray',
		UPC: '842631100779',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.250',
		ShelfWidth: '87.000',
		ShelfDepth: '44.500',
		Weight: '410.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '14.250',
		CartonWidth: '87.000',
		CartonDepth: '44.500',
		CartonWeight: '410.0',
		PalletQtyBoxes: '1',
		Retail: '2369.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Vault Doors',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '80',
		ProductExtWidth: '36',
		ProductExtDepth: '6.3',
		ProductWeight: '350',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Enhance the security of any closet, room, or storm shelter with the SnapSafe Vault Door. Its thick steel construction and easy installation allow an effective and affordable way to protect an existing area from theft and unintended intrusion. Utilize and configure the accessories that work best for you with the revolutionary Square-Lok™ organizing system. 36"W x 80"H In-Swing Door.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--rVITP48e--/cy0edyx1wltmurt8l5zr.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--rVITP48e--/cy0edyx1wltmurt8l5zr.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DZGH8skM--/vx1qbq1m9qgitzxiayzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--g18Y86Im--/cs8sjrhofkq5jlj0zvc7.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--cYCdrlAy--/npffv2gfut5dikfdq6ox.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--4DAuNXOt--/crgxhdofmc4jh1dkwxpl.png',
		Videos: 'https://vimeo.com/807924551',
		Videos1: 'https://vimeo.com/807937718',
		Videos2: 'https://vimeo.com/807946436',
		Videos3: 'https://vimeo.com/807953002',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8f9bfcc4-8fd1-4e59-bd82-5561d9f7e393',
		ProductID: '594293',
		ProductName: 'Match™ Grade Bushing .293',
		UPC: '090255592931',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592938',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '7MM',
		BulletDiameter: '0.293',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RCewh86f--/c5a326032b4976953e1b6fab167115934093e085.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cd3caa62-0b6c-49dd-9f63-f538d257f666',
		ProductID: '95898',
		ProductName: 'Rapid Dry Dehumidifier Stone',
		UPC: '090255958980',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.8',
		ShelfWidth: '2.6',
		ShelfDepth: '1.1',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255958987',
		CartonHeight: '16.300',
		CartonWidth: '12.600',
		CartonDepth: '9.100',
		CartonWeight: '18.0',
		PalletQtyBoxes: '0',
		Retail: '30.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'TAIWAN',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '40',
		MasterPackUCC: '30090255958981',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '18.0',
		ProductDescription:
			'Sized perfectly for gun cases, the Rapid Dry Dehumidifier Stone can be recharged in the microwave. Dimensions: 4.8" x 2.6" x 1.1" (12.2 x 6.6 x 2.8cm) Net weight: 0.3 lbs. (120g)',
		ProductImage: 'http://images.salsify.com/image/upload/s--g7PoZWni--/eiip3tx8vfgq7o1dn9c2.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ZdV0fNim--/v3eww5ica5mejmrhr7u2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--2p7TrZze--/nzxk1p2j9xhw6pleodan.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3e7585be-0718-4835-97eb-d6b18d20db89',
		ProductID: '99263',
		ProductName: 'Hornady® Khaki Mesh Cap',
		UPC: '090255992632',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--a3SXRjZb--/gakoz2tote1o01u3gine.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bec889e1-a334-4a29-8587-45e4a616341d',
		ProductID: '9926',
		ProductName: 'Hornady® Neck Gaiter',
		UPC: '090255299267',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.15',
		ShelfWidth: '5.5',
		ShelfDepth: '6',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		Packaging: 'Bag',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Imported. 100% polyester.',
		ProductImage: 'http://images.salsify.com/image/upload/s--y71YcOI3--/lfumlyoo1hktalucmijr.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f04fb76-64cd-4532-92e0-6825cb2bd682',
		ProductID: '80611',
		ProductName: '7mm Rem Mag 150 gr GMX® Outfitter®',
		UPC: '090255806113',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255806110',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '14.5',
		PalletQtyBoxes: '780',
		Retail: '68.33',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.464',
		SectionalDensity: '0.266',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'GMX®',
		BulletWeightGrain: '150',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--F0nSl8Lw--/eceb4a0e69f22e1958b37455e0e1fed4335e6f45.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '839640e2-c592-4f67-9837-8b35a0a947f7',
		ProductID: '045800',
		ProductName: 'Taper Crimp Die 350 Legend (.355)',
		UPC: '090255458008',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255458005',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This die removes the flare from the case mouth and crimps case mouth around the bullet while maintaining a sharp edge for proper head-space. Improves feeding of reloaded cases in semi-automatic handguns.',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd3382472-52db-451f-ae98-306868e2e723',
		ProductID: '397118',
		ProductName: 'Seating Stem 45 Cal FTX® 200 Gr',
		UPC: '090255971187',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.066',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971184',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.66',
		PalletQtyBoxes: '0',
		Retail: '7.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df32dbdc-217b-464e-9b5c-6b6b42d95068',
		ProductID: '8047',
		ProductName: '243 Win 100 gr InterLock® BTSP American Whitetail®',
		UPC: '090255380477',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380474',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.0',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.405',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '1945',
		SectionalDensity: '0.242',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--mSyyg5Gn--/7ea5e3b47237a4981753e26d3021334873744460.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '905232f8-31ed-4368-878a-13bd633e8273',
		ProductID: '010050',
		ProductName: '366 Auto 12 Ga Gas Assist 2-3/4',
		UPC: '090255010503',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '32.700',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255010500',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '32.7',
		PalletQtyBoxes: '27',
		Retail: '1558.47',
		ParentCategory: 'Reloading',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--mH6Kbl6v--/hmp6wpvvqy0jtqvkan3k.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--xYNrv8ia--/hbpp5fai4fpl8rxt4k18.jpg',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b55b65a6-6d20-488d-abec-b2185ed1e892',
		ProductID: '823374',
		ProductName: '375 Ruger 250 gr. CX™ Outfitter®',
		UPC: '090255719901',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.930',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255719908',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.58',
		PalletQtyBoxes: '396',
		Retail: '113.39',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.403',
		MuzzleVelocity: '2800',
		MuzzleEnergy: '4352',
		SectionalDensity: '0.254',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'CX™',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--fAWpbV-0--/ab7n8wl20gdk7zhunfqw.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1421c207-8a44-44d8-9b2b-b07c38d60b4a',
		ProductID: '3503',
		ProductName: '35 Cal .357 250 gr SUB-X®',
		UPC: '090255235036',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.714',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255235033',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.71',
		PalletQtyBoxes: '540',
		Retail: '59.33',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Sub-X® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '.265',
		SectionalDensity: '0.28',
		OAL: '1.245',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.357',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reliable subsonic expansion Sub-X® (Subsonic — eXpanding) bullets deliver big results without a big bang! Designed to provide deep penetration below the speed of sound, Sub-X® features a lead core. Long grooves in its gilding metal jacket combine with its flat profile and the patented Flex Tip® insert within the bullet’s hollowpoint cavity to help it expand reliably at low velocities. Cannelures provide positive case crimp, making Sub-X® ideal for semiautomatic weapons. EXPANDS AT SUBSONIC VELOCITIES Patented Flex Tip® technology aids in expansion at velocities as low as 900 fps. PROVEN PERFORMANCE Meets FBI protocol for terminal ballistic test requirements. POSITIVE CASE CRIMP Lead core bullet with cannelured jacket provides positive case crimp for use in semiautomatics. WIDE RANGE OF GUNS Designed to fit, feed and function in a variety of firearms, including gas system guns.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--6JPNHdGn--/vanusfuylesq6gow2tp5.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--nR0617oJ--/grui1gytksxzbzzbosvk.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OtRGcACm--/l0fdlmxwkhjzevqlazry.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RMzZ3xew--/iyn6cbplk0acvziaeybv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--MQPLrOG4--/eue6m4ovt2wufmjlfiu0.png',
		Videos: 'https://vimeo.com/367134791',
		Videos1: 'https://vimeo.com/368030686',
		DateLastModified: '2024-03-04 15:46:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ac1b8747-d88a-4a6a-ae6d-665fa710189d',
		ProductID: '9080',
		ProductName: '44 Mag 200 gr XTP®',
		UPC: '090255390803',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.079',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390800',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '10.79',
		PalletQtyBoxes: '1120',
		Retail: '39.11',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.17',
		MuzzleVelocity: '1500',
		MuzzleEnergy: '999',
		SectionalDensity: '0.155',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XTUJpDBZ--/f93c85ca2e2a251a9434570d356ea0cf6438e65b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af5e22cf-9493-483c-98b6-faf3ae121c46',
		ProductID: '86751B',
		ProductName: '300 Blackout Unprimed Cases',
		UPC: '090255703276',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '48.205',
		WeightUOM: 'LB',
		CaseQty: '4000',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '192820.0',
		PalletQtyBoxes: '176000',
		Retail: '0.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fcf92804-4155-456c-a6b1-9d100a7d7a98',
		ProductID: '3019',
		ProductName: '30 Cal .308 125 gr SST®',
		UPC: '090255230192',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.894',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255230199',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.35',
		PalletQtyBoxes: '900',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.305',
		SectionalDensity: '0.188',
		OAL: '1.045',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Qx6DxE1D--/7005f58079cd33eda63ca9c62591cb3afe4bbcc0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '84b73003-3873-435a-a880-13b7ce5697b4',
		ProductID: '390567',
		ProductName: 'Shell Holder #27',
		UPC: '090255905670',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905677',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d879a9a-c191-45b8-91e2-e9bedba073f7',
		ProductID: '98177',
		ProductName: 'Hornady® RAPiD® Safe 2600KP Large',
		UPC: '090255981773',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '10',
		ShelfDepth: '12.5',
		Weight: '8.050',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255981770',
		CartonHeight: '13.750',
		CartonWidth: '10.750',
		CartonDepth: '16.000',
		CartonWeight: '32.2',
		PalletQtyBoxes: '240',
		Retail: '248.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.9',
		ProductExtWidth: '8.7',
		ProductExtDepth: '10.7',
		ProductWeight: '6.5',
		ProductIntHeight: '2.2',
		ProductIntWidth: '7.7',
		ProductIntDepth: '7',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The RAPiD® Safe 2600KP and 2700KP models include a keypad that offers a secondary entry method where the user can program a 4 to 6 digit security code in addition to the RFID-enabled access methods. Available in two sizes, the 2600KP and 2700KP offer convenient, tamper-proof security for handguns and other valuables. FAST AND DEPENDABLE TOUCH-FREE ENTRY RFID activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS For secondary entry method, user can program a four to six digit security code.  CERTIFIED CHILD-RESISTANT Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and hinge attack resistance.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 14 gauge steel with two internal hardened locking lugs.  SAFE AND READY AC power means your handgun is both protected and ready to go 24/7.  MOBILE SECURITY Included cable allows the safe to be secured in virtually any location. Meets TSA requirements for handgun safety in checked luggage.  RAPiD® Safe 2600KP (Large) Features: Keypad Type: 4-Inch Barrel Pistols / 2-Inch Revolvers Exterior Dimensions: 10.7" x 8.7" x 2.9" Interior Dimensions: 7" x 7.7" x 2.2"   CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.',
		ProductImage: 'http://images.salsify.com/image/upload/s--r8kDk1a4--/u9xgrwm0qnkedyqjhgaq.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GhyZ7EgI--/loihjosjgw7vfznamf0e.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--UrzTiXfA--/tu6fzxszzvurbrtlu3h0.png',
		Videos: 'https://vimeo.com/190884888',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e7664edd-69b8-40c4-968f-6d6f4a96cdec',
		ProductID: '45177B',
		ProductName: '45 Cal .451 230 gr FMJ-RN',
		UPC: '090255645170',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '50.416',
		WeightUOM: 'LB',
		CaseQty: '1500',
		CartonUCC: '10090255645177',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '75624.0',
		PalletQtyBoxes: '63000',
		Retail: '0.23',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.184',
		SectionalDensity: '0.162',
		OAL: '0.65',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--qXy-90Wt--/80951d632030e2aad719535c812d85d20757a72f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4b6301c-b2e5-4a57-88f5-691510598358',
		ProductID: '190143',
		ProductName: 'Powder Bushing 372',
		UPC: '090255191431',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191438',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '863fd886-7f9f-41f3-ae88-989291b88bdd',
		ProductID: 'A223',
		ProductName: 'Lock-N-Load® 223 Rem Modified Case',
		UPC: '090255704525',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.017',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704522',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.17',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1vmJ0zHG--/82f742545ee4d8376095dc19d2ac55021c100069.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b74bcacf-d5c2-4bb2-b40c-10c17f881ea9',
		ProductID: '380714',
		ProductName: 'Cartridge Gauge 300 Blackout (.308)',
		UPC: '090255807141',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807148',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e5caa25-17d8-43a9-b3f7-5367bc7dffbc',
		ProductID: '75420',
		ProductName: 'SnapSafe® Premium Vault Door Off White',
		UPC: '842631100762',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.250',
		ShelfWidth: '87.000',
		ShelfDepth: '44.500',
		Weight: '397.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '14.250',
		CartonWidth: '87.000',
		CartonDepth: '44.500',
		CartonWeight: '397.0',
		PalletQtyBoxes: '1',
		Retail: '2369.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Vault Doors',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '80',
		ProductExtWidth: '36',
		ProductExtDepth: '6.3',
		ProductWeight: '350',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Enhance the security of any closet, room, or storm shelter with the SnapSafe Vault Door. Its thick steel construction and easy installation allow an effective and affordable way to protect an existing area from theft and unintended intrusion. Utilize and configure the accessories that work best for you with the revolutionary Square-Lok™ organizing system.  36"W x 80"H In-Swing Door.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uzAFIqJt--/cbd4zx83ttik188nrrri.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--uzAFIqJt--/cbd4zx83ttik188nrrri.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--wLsPi6pV--/dy17timwe1ngb60i71sz.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--F31iapH5--/rjoo94tdvdnn9ey9ftek.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--cYCdrlAy--/npffv2gfut5dikfdq6ox.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--4DAuNXOt--/crgxhdofmc4jh1dkwxpl.png',
		Videos: 'https://vimeo.com/807924551',
		Videos1: 'https://vimeo.com/807937718',
		Videos2: 'https://vimeo.com/807946436',
		Videos3: 'https://vimeo.com/807953002',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd279f385-249c-48d0-8763-0cb58952742c',
		ProductID: '8739',
		ProductName: '357 Sig Unprimed Cases',
		UPC: '090255487398',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.115',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487395',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.575',
		PalletQtyBoxes: '400',
		Retail: '60.59',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '357 SIG',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ad9220c4-154f-4230-af2e-19f530add64d',
		ProductID: 'A30TC',
		ProductName: 'Lock-N-Load® 30TC Modified Case',
		UPC: '090255705034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.027',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705031',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.27',
		PalletQtyBoxes: '0',
		Retail: '6.65',
		ParentCategory: 'Reloading',
		Cartridge: '30 TC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--z7ni5ugK--/2f9c6cb401aba43c252255fa3d4bb3169cf735c9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '565ce524-ee6a-493c-90d1-781a85ff39d8',
		ProductID: '046584',
		ProductName: 'Size Die 454 Casull (.452)',
		UPC: '090255465846',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.458',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465843',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '61.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series V Four-Die Handgun Die Sets',
		Cartridge: '454 CASULL',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '197732ef-8ca8-45e6-a890-3691bc15cf2e',
		ProductID: '117',
		ProductName: 'Lock-N-Load® 17 Insert (.17 Cal)',
		UPC: '090255704099',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.080',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704096',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.8',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '17 CAL',
		BulletDiameter: '0.17',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ppxyc_E9--/mlbmo4pv7w407qtecbop.png',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fc3f92c5-9b21-4072-ad9c-555cd3e4d4fd',
		ProductID: '546400',
		ProductName: 'Full-Length 2-Die Set 35 Whelen (.358)',
		UPC: '090255564006',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564003',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.8',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '35 WHELEN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '062d32eb-73e0-44e2-927f-baca9f610521',
		ProductID: '390552',
		ProductName: 'Shell Holder #12',
		UPC: '090255905526',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905523',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3c1eb24-f630-4786-a473-1e711bd37450',
		ProductID: '190129',
		ProductName: 'Powder Bushing 309',
		UPC: '090255191295',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191292',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '20258fea-a4e6-4e8a-b745-eab32a25c74b',
		ProductID: '546349',
		ProductName: 'Full-Length 2-Die Set 300 Blackout .308',
		UPC: '090255563498',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563495',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a0355a4b-5c5c-432b-985f-41cb5dee0d76',
		ProductID: '046540',
		ProductName: 'Size Die 41 Mag (.410)',
		UPC: '090255465402',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.468',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465409',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Three-Die Handgun Die Sets',
		Cartridge: '41 AE/41 REM MAG',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f8296daf-1aed-462d-9055-567dc8d4e6ac',
		ProductID: '99104',
		ProductName: 'Hornady® Coaster Set (4 Pk)',
		UPC: '090255991048',
		PackagedQTY: '4',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '5.25',
		ShelfDepth: '5.25',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '31.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Set of four 4¼” square absorbent stone coasters with cork backing imprinted with weathered Hornady® logo.',
		ProductImage: 'http://images.salsify.com/image/upload/s--D0kpGDiM--/szdniwbuqvgzklbrhoq0.jpg',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74799111-ebd3-4aec-b2ad-ca29236e5d37',
		ProductID: '9993',
		ProductName: 'One Shot® Metal Polish',
		UPC: '090255299939',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.125',
		ShelfWidth: '1.875',
		ShelfDepth: '1.875',
		Weight: '0.719',
		WeightUOM: 'LB',
		CaseQty: '24',
		CartonUCC: '10090255299936',
		CartonHeight: '11.500',
		CartonWidth: '9.000',
		CartonDepth: '8.500',
		CartonWeight: '17.256',
		PalletQtyBoxes: '0',
		Retail: '17.12',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Hornady Tumbling Media, this water-based, bio-degradable product cleans, polishes, and protects all metals except aluminum.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KPv_3hJW--/32941de9c84d2ddbd1185feb39f4f5735bcc36f4.jpg',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cda5b443-3e42-4485-b3e7-91948902f3de',
		ProductID: '8650',
		ProductName: '30 Carbine Unprimed Cases',
		UPC: '090255486506',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486503',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '6.0',
		PalletQtyBoxes: '200',
		Retail: '103.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '30 CARBINE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4bd88512-86d3-4975-819b-b9e8f6ac2199',
		ProductID: '050033',
		ProductName: 'Stuck Case Remover',
		UPC: '090255500332',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.75',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.227',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500339',
		CartonHeight: '3.500',
		CartonWidth: '6.250',
		CartonDepth: '8.250',
		CartonWeight: '2.27',
		PalletQtyBoxes: '0',
		Retail: '28.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Easily remove stuck cases from dies by drilling and tapping the stuck case. Consists of #7 drill bit and ¼ inch-20 tap.',
		ProductImage: 'http://images.salsify.com/image/upload/s--tck_dtk2--/nsfamzaijaqobsf2pwmx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1UEOhZwh--/egyoyea5dn1xf6o6nvfp.jpg',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1a3de8a9-e515-4f88-ad80-d1fc7e6aa44b',
		ProductID: '82002',
		ProductName: '300 Win Mag 200 gr ELD-X® Precision Hunter®',
		UPC: '090255820027',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.665',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820024',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.65',
		PalletQtyBoxes: '780',
		Retail: '75.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.597',
		G7BC: '0.301',
		MuzzleVelocity: '2860',
		MuzzleEnergy: '3632',
		SectionalDensity: '0.301',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--G52DT2Q1--/de3e1e63a0b346e517ddf273a1c5341ab2ae615d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '440ae4d6-56ed-4ba1-99bd-0f4423056bf3',
		ProductID: '8070',
		ProductName: '275 Rigby 140 gr InterLock® SP',
		UPC: '090255380705',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.195',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380702',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.95',
		PalletQtyBoxes: '1400',
		Retail: '72.57',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.392',
		MuzzleVelocity: '2680',
		MuzzleEnergy: '2217',
		SectionalDensity: '0.248',
		Cartridge: '275 RIGBY',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--uYI0Eplm--/a0a3bece451965ae48119fe4302fe41c7ee20b61.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '957f30b2-68b0-4285-8ef5-3ffdb35e7d05',
		ProductID: '8772',
		ProductName: '50 BMG Match™ Grade Unprimed Cases',
		UPC: '090255487725',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.750',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487722',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '13.75',
		PalletQtyBoxes: '200',
		Retail: '177.79',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a2d983b-1976-404c-bf84-4fc635f10620',
		ProductID: '22415',
		ProductName: '6mm .243 65 gr V-MAX®',
		UPC: '090255275018',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.995',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255275015',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.8',
		PalletQtyBoxes: '1440',
		Retail: '37.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.28',
		SectionalDensity: '0.157',
		OAL: '0.835',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '65',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WT1WiYuR--/535d802477e3ac82da8d1cf795d2c355adf5d531.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03046ba2-09d4-4d5d-a9e2-8ab0a53c0e23',
		ProductID: '095150',
		ProductName: 'Lock-N-Load® Precision Reloader Kit',
		UPC: '090255951509',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '13',
		ShelfWidth: '17',
		ShelfDepth: '6.25',
		Weight: '11.500',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '13.000',
		CartonWidth: '17.000',
		CartonDepth: '6.250',
		CartonWeight: '11.5',
		PalletQtyBoxes: '49',
		Retail: '623.64',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This time and money-saving kit helps precision reloaders check for bullet runout, head spacing and overall consistency of round-to-round production. Designed to help you produce the most accurate reloads possible, the Lock-N-Load® Precision Reloaders Kit includes tools and gauges that allow the user to fine-tune the reloading process.  Includes: Concentricity Tool Cam Lock™ Trimmer Cam Lock™ Power Adapter Lock-N-Load® OAL Gauge Curved Lock-N-Load® Case Prep Trio Steel Dial Caliper Lock-N-Load® Comparator Set Lock-N-Load® Comparator Headspace Kit',
		ProductImage: 'http://images.salsify.com/image/upload/s--RLevFZNo--/lluu76s2amb74x6ybz8a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--QslHQ0uP--/kamuqc1fidtnsmpnlrbq.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_SUOap0R--/kumqs3x98qwssnbcr7ob.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--TqD2Q7Hz--/cfe376jj7fcauut0mjp8.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--bNEn9GK8--/q3ucjijagscfmar9b3mb.png',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39940a78-0af7-4bd4-946c-dd1b331c9535',
		ProductID: '95903',
		ProductName: 'Hornady® Gun Safe Dehumidifier Rod (12")',
		UPC: '090255959031',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '17.5',
		ShelfWidth: '4.25',
		ShelfDepth: '1.5',
		Weight: '0.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255959038',
		CartonHeight: '6.500',
		CartonWidth: '4.750',
		CartonDepth: '17.750',
		CartonWeight: '2.25',
		PalletQtyBoxes: '6700',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '12',
		ProductExtWidth: '0.9',
		ProductExtDepth: '0.9',
		ProductWeight: '0.29',
		MasterPackQty: '50',
		MasterPackUCC: '30090255959032',
		MasterPackHeight: '25.750',
		MasterPackWidth: '13.500',
		MasterPackDepth: '18.500',
		MasterPackWeight: '22.5',
		ProductDescription:
			'Maintenance-free solution for humidity control in gun safes, cabinets and small enclosures. Mount vertically or horizontally with snap-on mounting brackets. Innovative plug may be removed to help install the cord through small holes or openings. Helps prevent rust and corrosion. Easy to use, just plug it in. 7 watts coverage is approximately 100 cubic feet. Can be used horizontally or vertically. Optimal mounting location is horizontally near the floor of the safe or closet. For indoor use only. Do not touch rod after plugging it in. Plug may be removed to help install the cord through narrow holes or openings.  Dimensions: 0.9"H x 13"W x 0.9"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductImage: 'http://images.salsify.com/image/upload/s--JHXEh92E--/amnbuouhrwjoakakqp2w.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yw3VzAoa--/yu9mwmtpjp22snypu0dq.jpg',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0d352a9-fc4e-4da5-ab6a-72eba7dcae6c',
		ProductID: '190161',
		ProductName: 'Powder Bushing 450',
		UPC: '090255191615',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.062',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191612',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.62',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce28586d-3799-497b-b232-c6bbab11be61',
		ProductID: '82212',
		ProductName: '300 Wby Mag 180 gr GMX Outfitter',
		UPC: '090255822120',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.645',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822127',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.45',
		PalletQtyBoxes: '780',
		Retail: '81.81',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Cartridge: '300 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--yKJ01HRw--/ofolxarnkvhu0suz23nr.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		Videos4: 'https://vimeo.com/367123667',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97185a37-4153-46d2-a1aa-2f1fd2e8e3d1',
		ProductID: '044133',
		ProductName: 'Seater Die (.284) 7mm W/147',
		UPC: '090255441338',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.602',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441335',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5360c0ee-5e8e-4a06-9cde-be06859df3da',
		ProductID: '095352',
		ProductName: 'Lock-N-Load® Bullet Tube 45 Auto',
		UPC: '090255953527',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '22',
		ShelfWidth: '5',
		ShelfDepth: '1',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '22.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '45 AUTO',
		Caliber: '45 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Lock-N-Load® Bullet Tubes for pistol bullets provide a handy, economical way to utilize bullet feeder dies on progressive presses without the complete bullet feeder hopper system. Tubes fit 40+ bullets depending on caliber and weight, and feature a window revealing when quantities are low. Sold in 3-packs.',
		ProductImage: 'http://images.salsify.com/image/upload/s--aoMN8a7F--/cdqyw15buoor2qqfkpii.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ae00417-50d3-4bc6-a6ef-f3e93687256c',
		ProductID: '546326',
		ProductName: 'Full-Length 2-Die Set 7mm Rem Mag (.284)',
		UPC: '090255563269',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.455',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563266',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.275',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '312e76b9-2869-4cb5-87b0-898582d95129',
		ProductID: '99216',
		ProductName: 'Hornady® Retro Tri-Color Cap',
		UPC: '090255992168',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.500',
		ShelfWidth: '8.000',
		ShelfDepth: '8.000',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'BANGLADESH',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--eXgq92Hl--/g2plyphwwdaey04krlu6.png',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a4bde7ea-91b2-4225-8080-613d7e7ac8a4',
		ProductID: '8750',
		ProductName: '44 Remington Magnum Unprimed Cases',
		UPC: '090255487503',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.902',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255487500',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.51',
		PalletQtyBoxes: '200',
		Retail: '62.93',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Handgun Cartridge Cases (Unprimed)',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'de677123-ee11-4db6-8e2e-d55e63df7936',
		ProductID: '050063',
		ProductName: 'Powder Cop',
		UPC: '090255500639',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '1.5',
		ShelfDepth: '5.75',
		Weight: '0.457',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500636',
		CartonHeight: '3.500',
		CartonWidth: '6.500',
		CartonDepth: '8.000',
		CartonWeight: '4.57',
		PalletQtyBoxes: '0',
		Retail: '51.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Install on your progressive press after the powder drop station to automatically check dropped charges. Checking powder charges on your progressive press can be difficult, and is sometimes ignored, even though it’s a smart practice. Hornady® uses a similar device on our own ammo manufacturing presses. It won’t replace careful attention, but helps monitor the reloading process. Works with all powder types and cartridges.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6AFGf2nx--/b18851dfc0810d447cbaca6fa5f7f34a3292e984.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DvUk2v5G--/nbsjryudsxivublv3jqy.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--PhfHFa3E--/l6hxfj1wicbxhtmuboza.jpg',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0373d65b-1d5d-4499-9e91-1adf840cc77c',
		ProductID: '83177',
		ProductName: '17 Mach 2® 17 gr V-MAX® Varmint Express® Rimfire',
		UPC: '090255831771',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '1.625',
		ShelfDepth: '3',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255831778',
		CartonHeight: '6.500',
		CartonWidth: '9.250',
		CartonDepth: '13.000',
		CartonWeight: '30.0',
		PalletQtyBoxes: '4000',
		Retail: '15.17',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Rimfire Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.125',
		MuzzleVelocity: '2100',
		MuzzleEnergy: '166',
		SectionalDensity: '0.082',
		Cartridge: '17 MACH 2',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '17',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--T8AAw77R--/dd9957597be6dfe6e1121dc4b7bf8a7a43357a23.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--az2-XG8R--/f30891mxsah6knifxzvc.png',
		DateLastModified: '2023-12-19 10:10:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '73c1704d-278a-4557-9059-e9a5e1a87e07',
		ProductID: '546280',
		ProductName: 'Full-Length 2-Die Set 6.5-06 (.264)',
		UPC: '090255562804',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562801',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5-06',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '113e9981-a660-4ae2-a560-7509d24e7485',
		ProductID: '81499',
		ProductName: '6.5 Creedmoor 143 gr ELD-X® Precision Hunter®',
		UPC: '090255814996',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.130',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814993',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.3',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.625',
		G7BC: '0.315',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2315',
		SectionalDensity: '0.293',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '143',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--P9uBlEJR--/06498ac49322d9a5ff3e87957369b31f98afe372.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c5c7e825-dff3-4d41-a09b-2bd3f07a064b',
		ProductID: '4503',
		ProductName: '45 Cal .458 350 gr InterLock® FP',
		UPC: '090255245035',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.624',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255245032',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.36',
		PalletQtyBoxes: '540',
		Retail: '56.20',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.195',
		SectionalDensity: '0.238',
		OAL: '0.89',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'FP INTERLOCK®',
		BulletWeightGrain: '350',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x6itahiG--/1b7b23a77d4e14675098e9a22dd40ac621df7b49.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7938a9bd-0520-4652-b8f1-8fa491c9724c',
		ProductID: '546359',
		ProductName: 'Full-Length 2-Die Set 338 Marlin Exp (.338)',
		UPC: '090255563597',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.300',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563594',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9b08216a-90b0-4e3c-8516-5f06e1371d3d',
		ProductID: '044114',
		ProductName: 'Seater Die #14 (.312)',
		UPC: '090255441147',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.575',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441144',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5ae32fa6-94ab-46a6-8133-640f1165f7a3',
		ProductID: '046226',
		ProductName: 'Match™ Grade Full-Length Size Die 7mm WSM (.284)',
		UPC: '090255462265',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462262',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '423cd3e0-2463-46eb-8d0e-94bb24c5cfd9',
		ProductID: '490002',
		ProductName: 'Tube Hopper 14" Powder/Shot',
		UPC: '090255900026',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '1.5',
		ShelfDepth: '0.25',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '1.500',
		CartonWidth: '1.500',
		CartonDepth: '0.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '29.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shotshell Accessories',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"With nearly twice the volume of our standard hoppers, you'll turn out more reloads between refills of your shot.",
		ProductImage: 'http://images.salsify.com/image/upload/s--3gzd-ZA5--/k6gydrlxzs4dhatr566s.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a6361023-2505-4675-8188-eaafc45a9191',
		ProductID: '150206',
		ProductName: 'Lock-N-Load® Sonic Cleaner™ Basket 2L',
		UPC: '090255502060',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.5',
		ShelfWidth: '11.75',
		ShelfDepth: '10.5',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonHeight: '8.500',
		CartonWidth: '11.750',
		CartonDepth: '10.500',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '26.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--D0bO1JlQ--/mhqxmszcicxgvim7qfh3.png',
		DateLastModified: '2023-12-16 08:58:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97711de4-1348-4ea2-ae57-e8c509e06b88',
		ProductID: '90236',
		ProductName: '9mm Luger 135 gr FlexLock® Critical Duty®',
		UPC: '090255902365',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.810',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902362',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '8.1',
		PalletQtyBoxes: '1120',
		Retail: '41.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.195',
		MuzzleVelocity: '1010',
		MuzzleEnergy: '306',
		SectionalDensity: '0.153',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YB8trKJv--/3cc19794503e00f8d5f7d0f2dae4e614e78cb340.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		Videos2: 'https://vimeo.com/321754395',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be94e7d6-a9e6-4788-830c-08d54f5b756c',
		ProductID: '24561',
		ProductName: '6mm .243 108 gr ELD® Match',
		UPC: '090255245615',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.630',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255245612',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.75',
		PalletQtyBoxes: '900',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.536',
		G7BC: '0.27',
		MinTwist: '1-8"',
		SectionalDensity: '0.261',
		OAL: '1.26',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '108',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--da0uBUwo--/590458ae2b2baf4ef8cfd964abb2ed369c692ff6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '83f5a90b-3f3a-4545-b335-b8308d787db7',
		ProductID: '9979',
		ProductName: 'Joyce Hornady® Reloading DVD',
		UPC: '090255299793',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.5',
		ShelfWidth: '7.5',
		ShelfDepth: '5.25',
		Weight: '0.216',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '6.000',
		CartonWidth: '8.000',
		CartonDepth: '18.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '18.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Reloading Handbook & Videos',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Widely acclaimed by shooters, this informative video is for reloading pros and beginners. Bonus feature includes an introduction to metallic reloading by Steve Hornady.',
		ProductImage: 'http://images.salsify.com/image/upload/s--KPMb9gBn--/cw2lkxxeco2j4bzzjuew.jpg',
		DateLastModified: '2023-12-16 09:09:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '54860339-038a-4bcc-9c35-85ee46b065e7',
		ProductID: '51504',
		ProductName: '50 cal .510 570 gr DGX® Bonded',
		UPC: '090255515046',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '4.200',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255515043',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '63.0',
		PalletQtyBoxes: '540',
		Retail: '150.51',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		SectionalDensity: '0.313',
		OAL: '1.269',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '570',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_pzGpJcq--/28e69b11fa1d05c21a5d613f6fef01923e6be0a5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2892cdcc-638c-4ea5-9b6c-2f4b8a77391e',
		ProductID: '75014',
		ProductName: 'Snapsafe® Super Titan XL Double Door',
		UPC: '842631100144',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '24.5',
		ShelfWidth: '43.375',
		ShelfDepth: '64.25',
		Weight: '714.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '24.500',
		CartonWidth: '43.375',
		CartonDepth: '64.250',
		CartonWeight: '714.0',
		PalletQtyBoxes: '1',
		Retail: '3269.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Modular Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '9V',
		BatteryQty: '1',
		BatteryWattHour: '5.49',
		BatteryWeight: '33.9',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '59',
		ProductExtWidth: '38',
		ProductExtDepth: '24',
		ProductWeight: '660',
		ProductIntHeight: '53.5',
		ProductIntWidth: '33',
		ProductIntDepth: '20.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'SnapSafe modular safes are easy to assemble and move anywhere. Simply unpack them piece by piece and assemble them close to your desired location. The SnapSafe modular assembly system locks the walls together from the inside, making them as solid and impenetrable as conventional, welded safes. Their 2300°F fire protection offers peace of mind knowing firearms, jewelry, currency and valuable documents are protected from fire and theft. Here’s all the security of a conventional, welded safe in an easy-to-assemble gun vault that moves anywhere piece-by-piece, then locks together in minutes with no tools. Super Titan home fire safe provides your documents, valuables, firearms and jewelry with protection from fire and theft.  Every Super Titan ships with one full shelf and full gun rack, plus a half gun rack with two half shelves, to let you configure your vault to meet your needs. The Super Titan Double Doors feature a full gun rack. The recommended capacity is 36 long guns (XL) when stored in sleeves with the muzzles up and down, fewer if your guns have optics.  SPECIFICATIONS Exterior Dimensions: 59"H x 38"W x 24"D (add 3" for handle) Interior Dimensions: 53.5"H x 33"W x 20.5"D Shipping Dimensions: 22"H x 40.5"W x 61"D Door Opening: 52"H x 29"W Locking Bolts: 14 Weight: 660 lbs. Capacity: 36+ Long Guns SecuRAM™ Lock: UL-listed digital lock with EMP-proof mechanical key backup  FEATURES Delivered right to your door. Assembles in minutes without additional tools (wrench included). Modular Assembly System. Sledgehammer- and pry-bar resistant 3/16" solid-steel door. Thick 9 gauge 2-ply steel exterior walls 2300°F one-hour Fire Shield protection. Heat-activated door fire seals. Internal panels are made of magnesium oxide (MgO) and are nearly impervious to fire, moisture, insects and mold Comes standard with an EMP Lock that offers electronic or mechanical opening operation. 14 1-inch chrome steel live locking bolts. Spring-loaded relocker. Powder-coated finish. Lined interior. Adjustable lined shelves. One full shelf, one full gun rack, two half shelves and a divided shelf Professional grade "non-breach seal" dead-bolt door. Pre-drilled for floor mounting. Lifetime warranty.',
		ProductImage: 'http://images.salsify.com/image/upload/s--X5ewHo2E--/ttilyted6rzowxqr4sug.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ash6gFCf--/sbmxvg47ysggs14eltmy.png',
		Videos: 'https://vimeo.com/220662709',
		Videos1: 'https://vimeo.com/370420587',
		DateLastModified: '2024-01-22 14:50:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e8e14738-78b4-45dc-85d1-5ebadac054df',
		ProductID: '546397',
		ProductName: 'Full-Length 2-Die Set 338 Federal (.338)',
		UPC: '090255563979',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.468',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563976',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.34',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '338 FEDERAL',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0cbef3fe-ff80-435b-aa45-1254ef5aaf57',
		ProductID: '22271',
		ProductName: '22 Cal .224 55 gr V-MAX®',
		UPC: '090255222715',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.856',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222712',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.24',
		PalletQtyBoxes: '1440',
		Retail: '30.87',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		SectionalDensity: '0.157',
		OAL: '0.813',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--XGoDj0Ah--/e83e04031337f75072602af2306a63827f5566a1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cf5bf444-ff89-4bb9-bdf7-59305d17c0a5',
		ProductID: '546585',
		ProductName: 'Full-Length 4-Die Set 500 S&W (.500)',
		UPC: '090255565850',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.984',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565857',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.92',
		PalletQtyBoxes: '0',
		Retail: '133.57',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series V Four-Die Handgun Die Sets',
		Cartridge: '500 S&W MAG',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ab1dc99-190e-4392-ac30-7371b31a8e65',
		ProductID: '82214',
		ProductName: '30-378 Weatherby Mag 220 gr ELD-X® Precision Hunter®',
		UPC: '090255822144',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.085',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822141',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '20.85',
		PalletQtyBoxes: '780',
		Retail: '178.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.65',
		G7BC: '0.325',
		MuzzleVelocity: '3025',
		MuzzleEnergy: '4470',
		SectionalDensity: '0.331',
		Cartridge: '30-378 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '220',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OcQGdaVw--/3ba21b5f2e7a7c64bbed661e991bdfd8b8c7d6a6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '61edb6da-3ac7-4dc3-8de3-ead200f82489',
		ProductID: '2552',
		ProductName: '25 Cal .257 117 gr InterLock® BTSP',
		UPC: '090255225525',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.772',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255225522',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.3',
		PalletQtyBoxes: '900',
		Retail: '46.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.391',
		SectionalDensity: '0.253',
		OAL: '1.135',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--M5BMAZO0--/cf4992d90e696c08105a6aeaadb7374fa94091ef.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a86a5a38-7618-49cf-8f7a-cd4baa8cb8e7',
		ProductID: '046401',
		ProductName: 'Full-Length Size Die 35 Whelen (.358)',
		UPC: '090255464016',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464013',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '35 WHELEN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8f1f3226-fdea-4301-b48d-f3dc45085c4e',
		ProductID: '546361',
		ProductName: 'Full-Length 2-Die Set 7.5 Swiss K31 (.308)',
		UPC: '090255563610',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563617',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7.5 SWISS K31',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8d80ca8c-9f15-45d8-9a8f-960851548be5',
		ProductID: '546543',
		ProductName: 'Full-Length 3-Die Set Cowboy™ 44/40Win (.429)',
		UPC: '090255565430',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.900',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565437',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '9.5',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '44-40 WIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.429',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2061bd00-c95d-4148-925c-b21560a84f5f',
		ProductID: '546345',
		ProductName: 'Full-Length 2-Die Set 30-30 Ack Imp (.308)',
		UPC: '090255563450',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563457',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.25',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '30-30 ACKLEY IMP',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a481476f-7bc9-46f1-8b3d-c6d920caf152',
		ProductID: '546263',
		ProductName: 'Full-Length 2-Die Set 25 Win SS Mag (.257)',
		UPC: '090255562637',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.346',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562634',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.73',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '25 WSSM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed86d7a5-739f-4962-aa39-feec3aa2c32a',
		ProductID: '400421',
		ProductName: '10mm .400 180 gr HAP®',
		UPC: '090255700961',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '6.25',
		ShelfDepth: '6.875',
		Weight: '13.650',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255700968',
		CartonHeight: '7.125',
		CartonWidth: '7.562',
		CartonDepth: '8.625',
		CartonWeight: '27.3',
		PalletQtyBoxes: '174',
		Retail: '144.17',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.164',
		SectionalDensity: '0.161',
		OAL: '0.624',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'HAP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yey2ipUN--/d38da23b8fb3a0324419ce21a06d2bfdd257e197.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--m0eUJ2fR--/a3796229f73a287a61afa49126a2440194166947.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90dd45d2-284a-468a-97a1-906895c97701',
		ProductID: '594335',
		ProductName: 'Match™ Grade Bushing .335',
		UPC: '090255593358',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593355',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '338 CAL',
		BulletDiameter: '0.335',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--N-G3kWpq--/5c54145827e8cfd2115b38bc956ed95e82c24988.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c6fbe709-896f-42d2-bdb5-4e349ef631f9',
		ProductID: '044130',
		ProductName: 'Seater Die #30 (.358)35 Rem',
		UPC: '090255441307',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.589',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441304',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '15bbcba4-6d67-40e6-92d9-8a8da459dde9',
		ProductID: '044183',
		ProductName: 'Seater Die 6mm Creedmoor (.243)',
		UPC: '090255441833',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441830',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a015065f-6731-43e8-bb98-6f87b960dc7c',
		ProductID: '380703',
		ProductName: 'Cartridge Gauge 357 Mag (.357)',
		UPC: '090255807035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807032',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '2.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7d50a204-06ee-4718-94f7-dfd00b39c259',
		ProductID: '35571',
		ProductName: '9mm .355 124 gr XTP®',
		UPC: '090255200225',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.882',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255200222',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.05',
		PalletQtyBoxes: '900',
		Retail: '32.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.165',
		SectionalDensity: '0.141',
		OAL: '0.575',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--82Wj0uz9--/c9ba591404281ffefe53fa7a584b9ec5ae2876bf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bdc8c165-da9c-41cf-8f8a-d2571eb0990a',
		ProductID: '80572',
		ProductName: '7mm-08 Rem 120 gr SST® Custom Lite®',
		UPC: '090255805727',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.065',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805724',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.65',
		PalletQtyBoxes: '1400',
		Retail: '52.72',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom Lite® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.365',
		MuzzleVelocity: '2675',
		MuzzleEnergy: '1907',
		SectionalDensity: '0.213',
		Cartridge: '7MM-08 REM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'SST®',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Custom Lite® ammunition provides reduced recoil and muzzle blast from the most popular calibers, and puts the fun back into shooting for kids, women, and every shooter looking to keep recoil to a minimum while still enjoying the use of their favorite rifle.  Loaded with Hornady® SST® bullets, Custom Lite® ammunition is designed to deliver less felt recoil and a modified trajectory that still provides the accurate, deadly, and dependable performance you rely on from Hornady®. Putting the fun back into shooting! REDUCED RECOIL By using slightly lighter bullets and modified propellants, shooters will achieve significant recoil reduction over standard loads.  PROVEN BULLETS Loaded with SST® bullets, Custom Lite® ammunition delivers flat trajectories and hard-hitting performance.  CONSISTENT COMPONENTS Like all Hornady® ammunition, we match powders to each load for optimum pressure, velocity and consistency. High quality cases and primers contribute to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6oVKOBUf--/1c348e96fb23e1beecff7a7ab10ef45c36ca77fe.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iE2opGvR--/4e65d06a09fbb3c18f5801e09efe79cff1308043.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--IedbEBai--/cg0qkaxwzqakis570swr.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rU_sQxe2--/jftbvatdsf6czstqk9mn.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Sli1o3qn--/cc6ihett8589l4lhvhjw.jpg',
		Videos: 'https://vimeo.com/96125085',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05a8999c-8f63-424d-ac62-b8090237138a',
		ProductID: '046250',
		ProductName: 'Match™ Grade Full-Length Size Die 338 Norma Mag (.338)',
		UPC: '090255462500',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462507',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '338 NORMA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97b299f2-1d1c-42bd-9159-d8fde4b51939',
		ProductID: '1035',
		ProductName: 'Lock-N-Load® 35 Insert (.358 Cal)',
		UPC: '090255704532',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.023',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704539',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.23',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--_X1OjskM--/tucgzsmxprrxhoklignx.png',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e2886f0-14f3-4c54-8094-49761fc93535',
		ProductID: '400471',
		ProductName: '10mm .400 180 gr FMJ-FP',
		UPC: '090255700978',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '6.25',
		ShelfDepth: '6.875',
		Weight: '13.550',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255700975',
		CartonHeight: '7.125',
		CartonWidth: '7.562',
		CartonDepth: '8.625',
		CartonWeight: '27.1',
		PalletQtyBoxes: '174',
		Retail: '149.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.188',
		SectionalDensity: '0.161',
		OAL: '0.608',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'FMJ-FP',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--sYkwN0oW--/32596150003c9da483f026be9b96f5cc992ac922.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b51858ca-67a0-4e44-ad39-468c90f236d6',
		ProductID: '546462',
		ProductName: 'Full-Length 3-Die Set 50/70 Govt (.510)',
		UPC: '090255564624',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564621',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.75',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '50-70 GOVT',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9496e688-d0b5-4d74-ad51-795eab3e2184',
		ProductID: '81108',
		ProductName: '30-06 Springfield 150 gr. CX™ Outfitter®',
		UPC: '090255811087',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.250',
		Weight: '1.240',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811084',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.4',
		PalletQtyBoxes: '1400',
		Retail: '60.45',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.418',
		SectionalDensity: '0.226',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention. SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection. WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture. VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--UJzUl1hI--/bnswhaxnp9wytm8ryqr0.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/294885426',
		Videos1: 'https://vimeo.com/295682086',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/343308040',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23a8d749-5606-4374-bfc3-8a85d9819dbe',
		ProductID: '390565',
		ProductName: 'Shell Holder #25',
		UPC: '090255905656',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905653',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '228fb5e4-debf-48af-8ce9-64d89232cdba',
		ProductID: '044125',
		ProductName: 'Seater Die 350 Legend (.355)',
		UPC: '090255441253',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.592',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441250',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfb05f04-0f9d-491d-984b-ed712f30cdef',
		ProductID: '40047B',
		ProductName: '10mm .400 180 gr FMJ-FP',
		UPC: '090255600216',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '52.559',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonUCC: '10090255600213',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '105118.0',
		PalletQtyBoxes: '84000',
		Retail: '0.19',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.188',
		SectionalDensity: '0.161',
		OAL: '0.608',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'FMJ-FP',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pZhVeCr5--/ed1bbbfa3170b55c2d327d5fec8855b59b94347c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a97d25bc-8859-4798-b79c-95666981a537',
		ProductID: '81264',
		ProductName: '5.56 NATO 75 gr BTHP Superformance® Match',
		UPC: '090255812640',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255812647',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.5',
		PalletQtyBoxes: '1680',
		Retail: '36.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		MuzzleVelocity: '2910',
		MuzzleEnergy: '1410',
		SectionalDensity: '0.214',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge your match rifle! Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Topped with the finest bullets, Superformance® Match™ ammunition marries the very best cartridge cases with extremely stable propellants. These propellants are custom blended for each individual load to provide true ammunition performance enhancement. FAST Superformance®  Match™ ammunition achieves muzzle velocities of 100 – 200 fps faster than ANY conventional ammunition.  ACCURATE Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Superformance® Match™ ammunition - the limits have been broken!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--X4fswI-K--/c475184b2ba83dbaf8b2f846493cd99ddb26158c.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jAWnV6HQ--/4acaff8cf81d2a714392debea680dffb6a029c8c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1p4zt9b5--/g5lr8ycpphdp3sqhisg3.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s---8dZEoUU--/v6e5gygwqep8fdkfzjlz.jpg',
		Videos: 'https://vimeo.com/241896524',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '124edc79-e2b7-4da1-bcc3-7439c5c1fb5d',
		ProductID: '75241',
		ProductName: 'Snapsafe® Treklite™ Lock Box With TSA Combination Lock XL',
		UPC: '851529004723',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3',
		ShelfWidth: '7.5',
		ShelfDepth: '10.75',
		Weight: '2.540',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004720',
		CartonHeight: '8.500',
		CartonWidth: '12.000',
		CartonDepth: '15.000',
		CartonWeight: '12.7',
		PalletQtyBoxes: '450',
		Retail: '49.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2',
		ProductExtWidth: '7',
		ProductExtDepth: '10',
		ProductWeight: '1.6',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The TrekLite® Lock Box offers heavy-duty protection at a third of the weight of steel! SPECIFICATIONS External Dimensions: 10" x 7" x 2" Weight: 1.6 lbs  FEATURES Convenient 4-Digit TSA lock offers advanced security and 10,000 user programmable codes. Protects firearms, expensive medications, and other valuables while traveling or at home. Easily fits in a suitcase, drawer, or under a car seat. Constructed of advanced, impact-resistant polycarbonate for exceptional toughness. Fits up to full-sized 1911 handguns. Durable, non-slip rubber over-mold provides added impact protection and stability. Foam lining protects firearms and valuables from being marred. Includes 1500 lb. rated security cable with sturdy cable connector that doesn’t limit interior cargo space. Meets TSA requirements.* *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZKaUK5dR--/hgbnpethmkne7rrcuxsl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ZBmOKFi8--/ytutaubl68ak34lotkai.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--vYxvwJxo--/bw2k2sth8xtlwis7iags.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--MRWkpvQy--/ln9uhaywnzptlanbgwyo.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--TQLAj34N--/xburewjssi33pm3fi87e.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--TY7KWO4K--/fvrtnoweohsgfbpoomzv.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--4CUMyYOp--/glf2sgysr23hoimeqrox.jpg',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e5c3b2e-1e4b-4fa0-9b40-dac123b65e1e',
		ProductID: '8622',
		ProductName: '6mm Remington Unprimed Cases',
		UPC: '090255486223',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.450',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486220',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '7.25',
		PalletQtyBoxes: '200',
		Retail: '64.60',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6MM REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '75d7c721-7491-49ae-8ec8-e7c8e2193ad7',
		ProductID: '75874',
		ProductName: 'Snapsafe® Handgun Hangers .440 (4 Pack)',
		UPC: '851529004488',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '5',
		ShelfDepth: '2',
		Weight: '2.480',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004485',
		CartonHeight: '2.000',
		CartonWidth: '14.000',
		CartonDepth: '18.000',
		CartonWeight: '12.4',
		PalletQtyBoxes: '0',
		Retail: '20.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004489',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '62.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--rDkxQkqw--/bt1jmscxg5ooypwszqio.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--TDoVbuBV--/snaqr50pytuerojyemae.jpg',
		Videos: 'https://vimeo.com/213867180',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a805b5ae-482b-4e1d-a530-e78a97259393',
		ProductID: '546355',
		ProductName: 'Full-Length 2-Die Set 300 Olympic (.308)',
		UPC: '090255563559',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563556',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '300 OLYMPIC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ed21c2c9-8f8d-4098-a20e-f01f754a5d47',
		ProductID: '30733',
		ProductName: '30 Cal .308 208 gr BTHP Match',
		UPC: '090255307337',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.125',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307334',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.875',
		PalletQtyBoxes: '540',
		Retail: '63.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.62',
		G7BC: '0.311',
		SectionalDensity: '0.313',
		OAL: '1.485',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '208',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8VaHDZTx--/a85f2349a0fd40363446c8651dd66d3fac0ac275.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1f853324-a23c-43ea-96b4-5932251d2a55',
		ProductID: '8143',
		ProductName: '25-06 Remington 110 gr ELD-X® Precision Hunter®',
		UPC: '090255381436',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.120',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381433',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.2',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.465',
		G7BC: '0.234',
		MuzzleVelocity: '3140',
		MuzzleEnergy: '2408',
		SectionalDensity: '0.238',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Fr0B76YV--/9480dbe4284d786fbef5d7590cf44881bddd8da1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e86129af-a9f5-4bc3-b6e8-13d135c91163',
		ProductID: '91376',
		ProductName: '40 S&W 175 gr FlexLock® Critical Duty®',
		UPC: '090255913767',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.805',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913764',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.05',
		PalletQtyBoxes: '1120',
		Retail: '41.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Duty® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.155',
		MuzzleVelocity: '1010',
		MuzzleEnergy: '396',
		SectionalDensity: '0.156',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'FLEXLOCK®',
		BulletWeightGrain: '175',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed and loaded to perform in full size handguns. Designed to meet the needs of those who demand superior barrier penetration and prefer a full-size handgun for their personal protection. Critical Duty® is loaded with the tough Hornady® FlexLock® bullet that delivers "barrier blind" performance when shot through common urban barriers.  The FlexLock® bullet incorporates two revolutionary Hornady® features to deliver superior barrier penetration and consistent performance in FBI tactical handgun ammunition tests (FBI Protocol).  The patented Hornady® Flex Tip® design eliminates clogging and aids bullet expansion. A large mechanical jacket-to-core InterLock® band works to keep the bullet and core from separating for maximum weight retention, excellent expansion, consistent penetration and terminal performance through all FBI test barriers.  Bright nickel-plated cases simplify chamber checks in reduced light. Additionally, all Critical Duty® ammunition is loaded with low flash propellant to help preserve night vision in low-light firing.  FBI Tested and Selected Barrier Blind Performance. FLEXLOCK® BULLET Incorporates two revolutionary Hornady® features: the no-clog, patented Flex Tip® design and the heavy duty jacket-to-core InterLock® band.  INTERLOCK® BAND Works to keep the bullet and core from separating for maximum weight retention and proven terminal performance through all FBI test barriers.  CORE Made of high-antimony lead making it extremely tough, delivering controlled expansion for unparalleled terminal performance consistency through all FBI test barriers. It\'s also more economical than similar bonded bullets.  NICKEL-PLATED CRIMPED CASES Nickel plating resists corrosion and greatly enhances low-light chamber checks. The cannelured bullet with crimped case ensures no bullet setback during feeding.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4kvj8je--/4be76c8b9108541cdcf1f04cb7d29b86837c29b9.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--28KaAzHK--/4f23c4316ea89e27899f115fa6d2d941cd4729bc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--3zveOuyi--/wfqkynea12zeyizo2mvu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LU3CivW0--/zblejxjkxryjgjlrm7uw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n6U6u_s---/iipjn0kik1hn04cdewtz.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xv6m62-I--/r25zauqswjvgn6jupubo.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--ePtZISaC--/m200clukrfpbmhvgl2nr.jpg',
		Videos: 'https://vimeo.com/145438401',
		Videos1: 'https://vimeo.com/401367153',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9505ef7d-1d8f-433d-867e-e3c84fe348ef',
		ProductID: '390554',
		ProductName: 'Shell Holder #14',
		UPC: '090255905540',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.042',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905547',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.42',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '14a041cf-7356-420a-a66f-47259c4d9423',
		ProductID: '046411',
		ProductName: 'Full-Length Size Die 9.3X57 (.366)',
		UPC: '090255464115',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464112',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '9.3X57',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f3ebdcf6-9a72-4268-9688-4d00086fd7d6',
		ProductID: '99303',
		ProductName: 'Hornady® Tan & Brown Mesh Cap',
		UPC: '090255993035',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--7kymUaKM--/vn65webqc0fidcjzl3ea.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ef400c5-ba5e-4e25-ad21-95d172b3ed38',
		ProductID: '290031',
		ProductName: 'PTX™ Powder Through Expander .357',
		UPC: '090255900316',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.113',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900313',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.13',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'df24f235-a228-444e-b138-93b0612ecc84',
		ProductID: '75901',
		ProductName: 'Snapsafe® Dehumidifier Large',
		UPC: '851529004679',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '9.5',
		ShelfDepth: '2',
		Weight: '2.070',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004676',
		CartonHeight: '13.000',
		CartonWidth: '10.000',
		CartonDepth: '10.250',
		CartonWeight: '10.35',
		PalletQtyBoxes: '525',
		Retail: '32.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '5',
		ProductExtWidth: '7.5',
		ProductExtDepth: '1.75',
		ProductWeight: '1.7',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Absorb humidity and prevent rust or mildew in gun safes, closets, pantries and other enclosed areas. Moisture-control crystals change from orange to green, indicating when the unit needs recharging. Dry out and recharge the crystals by plugging into 110V electrical outlet until crystals turn orange again. Absorbs humidity from enclosed areas and helps prevent mold and mildew. Perfect for closets, gun safes, pantries and other enclosed areas. No cords are needed for the dehumidifier to work. Moisture-control crystals change color to indicate when the unit needs recharging. Simply plug-in to recharge and dry out the crystals for continued use. Contains no harmful chemicals and is child, pet, and home safe. Effective in spaces up to 500 cubic feet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--nNekZzEJ--/ewk9sxdbdnbaki7k95l7.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--quGEE-xT--/pkalzfpq2yhr4j1tyyc4.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--b57QwYC1--/pp4tqb3ixbgafiik2orw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_BbdR9WU--/twmtgd4hdgmsgwgmedje.jpg',
		Videos: 'https://vimeo.com/221605062',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d78a187-5a4a-4f42-8551-745ab410c8aa',
		ProductID: '046367',
		ProductName: 'Full-Length Size Die 303 British (.312)',
		UPC: '090255463675',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463672',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '303 BRITISH',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3b7d11b-0e37-480d-9c3e-964bfdb8afb1',
		ProductID: '6025',
		ProductName: '40 Cal .395 Lead Balls',
		UPC: '090255260250',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.438',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260257',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '35.95',
		PalletQtyBoxes: '900',
		Retail: '14.07',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '40 CAL',
		BulletDiameter: '0.395',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '103285cd-2ef2-44a9-8787-c78d8e2c2bfd',
		ProductID: '100016',
		ProductName: 'Cam Lock™ Trimmer Dust Cover',
		UPC: '090255100167',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12.25',
		ShelfWidth: '4.5',
		ShelfDepth: '0.25',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '12.250',
		CartonWidth: '4.500',
		CartonDepth: '0.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '20.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Dust cover for Cam Lock™ Trimmer.',
		ProductImage: 'http://images.salsify.com/image/upload/s--gdv_Xg5a--/jndyceauhv7lbzook2e1.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9f483a06-4006-4ad2-bda4-ed3916d964a9',
		ProductID: '050127',
		ProductName: '50 BMG Powder Measure',
		UPC: '090255501278',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '4',
		ShelfDepth: '24',
		Weight: '3.927',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '4.000',
		CartonWidth: '4.000',
		CartonDepth: '24.000',
		CartonWeight: '3.927',
		PalletQtyBoxes: '0',
		Retail: '225.24',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--NZqNfLnL--/u4od3v1dyzgukum1fzmx.png',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd8727307-4653-4d5c-b4bf-1462fa5bf384',
		ProductID: '25522',
		ProductName: '25 Cal .257 117 gr SST®',
		UPC: '090255255225',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.776',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255255222',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.4',
		PalletQtyBoxes: '900',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.39',
		SectionalDensity: '0.253',
		OAL: '1.2',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'SST®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Y2d-BMd8--/0e88ec3aa2b41e3a6dbec26b8ce536f8c39c04ad.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e30315c8-a05b-4fab-b05b-6b18778c48f7',
		ProductID: '8302',
		ProductName: '22 Hornet 35 gr V-MAX® Varmint Express®',
		UPC: '090255383027',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.477',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383024',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '4.77',
		PalletQtyBoxes: '1120',
		Retail: '33.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Varmint Express® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.109',
		MuzzleVelocity: '3070',
		MuzzleEnergy: '732',
		SectionalDensity: '0.1',
		Cartridge: '22 HORNET',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '35',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Tack-driving accuracy. Hornady® Varmint Express® ammunition is designed around the hard-hitting performance of our famous V-MAX® bullet. Polymer tipped V-MAX® bullets deliver match accuracy, high ballistic coefficients, wind defying trajectories, and rapid fragmentation upon contact. Each Varmint Express® offering is loaded with high quality cases and carefully selected propellant and primers that are chosen to provide the best performance in each individual load. PROVEN BULLETS Hornady V-MAX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--dipZXjXw--/45f447b7dbd2369e7a6b9c378b0528996c08f671.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gUhvV8vr--/3cdbd14411cb2c2d4802dea411548154587dd3de.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zaUWPtEl--/iqwnwyglk1kszgtwetz8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--htuD3x7N--/z31jefn7wu9r6m9ajtve.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--JofHctCr--/yu7cnkmh38ijwq2lvwl4.png',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2151d956-04cf-41dd-aa84-74032d16f7e0',
		ProductID: '86725',
		ProductName: '300 H&H Magnum Unprimed Cases',
		UPC: '090255867251',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.081',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867258',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.405',
		PalletQtyBoxes: '200',
		Retail: '103.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 H&H MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '585862fa-01d8-4828-a96d-86b19a6fb026',
		ProductID: '392632',
		ProductName: 'Shell Plate #32 Lock-N-Load®AP™ & Projector',
		UPC: '090255926323',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.566',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926320',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.66',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4fff65b9-e160-4a4e-9f20-f3deee60c351',
		ProductID: '046516',
		ProductName: 'Size Die 9mm Luger (.355)',
		UPC: '090255465167',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.480',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255465164',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series II Three-Die Handgun Die Sets',
		Cartridge: '9MM LUGER/9X21',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90867cc8-0d5d-482f-afb3-8a149110f456',
		ProductID: '98014',
		ProductName: 'Hornady® Get Loaded® Sticker',
		UPC: '090255980141',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.75',
		ShelfWidth: '5',
		ShelfDepth: '5.5',
		Weight: '0.008',
		WeightUOM: 'LB',
		CaseQty: '250',
		CartonUCC: '10090255980148',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '2.0',
		PalletQtyBoxes: '450000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Red and white. Measures 4.5"x5"',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZMo15GCX--/icoidsh7owoc3rxgtfgd.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7dd26a0f-a763-4799-bf9d-4fba65816b64',
		ProductID: '053311',
		ProductName: 'Digital Cases & Parts Dryer',
		UPC: '090255533118',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '12',
		ShelfWidth: '14',
		ShelfDepth: '14.5',
		Weight: '7.500',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255533115',
		CartonHeight: '13.000',
		CartonWidth: '14.000',
		CartonDepth: '29.250',
		CartonWeight: '15.0',
		PalletQtyBoxes: '36',
		Retail: '146.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--JlJCoyTp--/doejbc7ol1anmb7ta2ms.pdf',
		ProductDescription:
			'Dry hundreds of cartridge cases as well as small and large gun parts at the same time with the revolutionary Digital Cases & Parts Dryer. Four fixed trays hold cases and small parts while a fifth, adjustable tray holds larger gun parts. The unit’s tall lid makes accommodating larger parts even easier. The dryer’s innovative top-mounted digital powerhead ensures that cases and parts dry thoroughly and efficiently. Dry large quantities of cartridge cases and gun parts Four fixed trays for cases and small parts, and a fifth adjustable tray for larger gun parts Digitally adjust drying time from 15 minutes to two hours Choose from seven temperature levels for quick or gentle drying Easy to clean',
		ProductImage: 'http://images.salsify.com/image/upload/s--Q1rZtJPW--/a6cw47y8hlqcemlbn8un.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--uKP6blxd--/vlfmmfgg5bkgichft5ro.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rMkYoSL8--/oiccnoshvn82bqh1grzf.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_p5fG3rV--/j3w5hskmphb8ctx2rwg7.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--YKQ-nvpW--/xemjxkmxk9ot42yicxpj.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--kPtoPtGY--/fif3njxnszgrl0sbznqo.png',
		Videos: 'https://vimeo.com/294885475',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39158519-e7ab-452e-9149-1c25f3fbefac',
		ProductID: '190154',
		ProductName: 'Powder Bushing 417',
		UPC: '090255191547',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.064',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191544',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.64',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8f50be7-faed-4562-b759-448190342542',
		ProductID: '190117',
		ProductName: 'Shot Bushing 3/4 oz',
		UPC: '090255191172',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.074',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191179',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.74',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Field Load Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Compensates for #6 shot field loads, to be used with lead shot only.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef34dc68-50f5-4a2f-99d4-32dac9cb1389',
		ProductID: '82668',
		ProductName: '450 Rigby 480 gr DGX® Bonded',
		UPC: '090255826685',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.825',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826682',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '16.95',
		PalletQtyBoxes: '396',
		Retail: '187.84',
		ParentCategory: 'Ammunition',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		SectionalDensity: '0.327',
		Cartridge: '450 RIGBY',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '480',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--rIozuiDk--/fe23eb96fab76f3deccc4fca9740faad9359c10c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '07fab430-7030-4df4-827b-ff3d2c87063a',
		ProductID: '9096',
		ProductName: '45 Auto +P 230 gr XTP®',
		UPC: '090255390964',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.028',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390961',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '10.28',
		PalletQtyBoxes: '1120',
		Retail: '36.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.188',
		MuzzleVelocity: '950',
		MuzzleEnergy: '461',
		SectionalDensity: '0.162',
		Cartridge: '45 AUTO+P',
		PressureRating: '+P',
		Caliber: '45 CAL',
		BulletDiameter: '0.451',
		BulletName: 'XTP®',
		BulletWeightGrain: '230',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--L80kLm9U--/c57e79554623f504db16eabbb6adb7ae8d7bce83.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '83f3b40b-52c3-4265-811f-6233f46b0c66',
		ProductID: '82233',
		ProductName: '338 Win Mag 225 gr SST® Superformance®',
		UPC: '090255822335',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.741',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822332',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.41',
		PalletQtyBoxes: '780',
		Retail: '73.88',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.515',
		MuzzleVelocity: '2840',
		MuzzleEnergy: '4029',
		SectionalDensity: '0.281',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SST®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--I16mvsL1--/24c2fc16f2c51241eb9e7f66af7256a076d90436.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '490d7fd5-8876-42c1-bce9-a0ee1e2f72da',
		ProductID: '75435',
		ProductName: 'SnapSafe® Keypad Safe XL',
		UPC: '842631100557',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.25',
		ShelfWidth: '22',
		ShelfDepth: '16.5',
		Weight: '28.600',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '28.6',
		PalletQtyBoxes: '36',
		Retail: '152.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Specialty Gun Boxes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'CHROMIUM',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '8',
		ProductExtWidth: '14.8',
		ProductExtDepth: '20.5',
		ProductWeight: '32',
		ProductIntHeight: '7.5',
		ProductIntWidth: '12',
		ProductIntDepth: '20.3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Protect handguns, electronics and other valuables with the SnapSafe® Keypad Safe. Heavy-duty 16 gauge steel body construction and extra thick 9 gauge steel door. Electronic lock with key backup. Interior light automatically illuminates when opening the safe. LED visual warning light when battery is running low. Includes concrete anchor bolts for mounting. Exterior: 20.5" x 14.8" x 8" Interior: 20.3" x 12" x 7.5" Weight: 32 lbs.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IaYLiBq1--/kikhoyckjgjmbzgc03gv.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8z978byw--/vthfqmoaoldydedc7ctu.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NBRxfHbO--/vqftkah7h0uxef3lxwjp.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--9ZNahyDX--/snxuxlns4ntq1w4bsbhw.png',
		Videos: 'https://vimeo.com/658718282',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c894ec69-a937-49a7-a659-0506a94f7d97',
		ProductID: '91369',
		ProductName: '40 S&W 180 gr XTP Subsonic',
		UPC: '090255913699',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.820',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913696',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.2',
		PalletQtyBoxes: '1120',
		Retail: '33.84',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady® Subsonic Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.164',
		SectionalDensity: '0.161',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shhh... tell everyone! Hornady® Subsonic Ammunition — designed for accuracy and performance below the speed of sound — now comes in both rifle and handgun loads.  Subsonic Handgun utilizes tried-and-true XTP® bullets that expand reliably at subsonic velocities. The Sub-X bullet used in Subsonic Rifle features a lead core. Long grooves in its gilding metal jacket combine with the bullet’s flat profile and the patented Flex Tip® insert within its hollowpoint cavity to help it expand reliably at low velocities.  Powders are selected for optimal performance and consistency from lot to lot. PROVEN PERFORMANCE Performance of 300 Blackout Subsonic meets or exceeds FBI Protocol terminal ballistic test requirements. The XTP® bullet in Subsonic Handgun has built a world-class reputation for accuracy and stopping power.  SILENT AND STEALTHY Hornady® Subsonic Ammunition doesn’t have the loud report of a supersonic round, and paired with a suppressor, it’s even quieter. Unique powders optimized for subsonic use result in a low flash signature, ideal for either suppressed or unsuppressed performance.  HIGH-QUALITY COMPONENTS With high-quality cartridge cases and primers, Subsonic Ammunition offers the performance and accuracy shooters have come to expect from Hornady. Disclaimer: This is subsonic, i.e., reduced velocity ammunition and will not produce the same muzzle energy as conventionally loaded cartridges. If hunting with this product, be sure to read, understand and comply with all applicable regulations and laws pertaining to bullet energy and/or muzzle velocity for the area and game to be hunted.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--o1weoByO--/eod4xl5zcttdjht9ofic.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--BusocNz2--/gozr0wl03pxdmtzvccfy.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lUFZkpqB--/lwccm0zykedo0jl0gnlh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fPHiA1qN--/ip5zbi5umrrlje92o0vb.jpg',
		Videos: 'https://vimeo.com/238318324',
		Videos1: 'https://vimeo.com/368031042',
		Videos2: 'https://vimeo.com/257722661',
		Videos3: 'https://vimeo.com/242146498',
		Videos4: 'https://vimeo.com/396530834',
		Videos5: 'https://vimeo.com/368030863',
		Videos6: 'https://vimeo.com/367123504',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ca949627-ee11-46a0-b9b2-8aab7783c95f',
		ProductID: '546199',
		ProductName: 'Full-Length 2-Die Set 5.45X39 (.221)',
		UPC: '090255561999',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.510',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255561996',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.55',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '5.45X39',
		Caliber: '5.45 CAL',
		BulletDiameter: '0.221',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f840f617-f0d2-4bfa-b958-15a9012953a4',
		ProductID: '2630',
		ProductName: '6.5mm .264 140 gr InterLock® SP',
		UPC: '090255226300',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.105',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255226307',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.625',
		PalletQtyBoxes: '900',
		Retail: '48.33',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.465',
		SectionalDensity: '0.287',
		OAL: '1.247',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PPEM_fPc--/2cdf1dd303125da491ad6dc41045b6f38a316e4f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '947c7071-e0e9-437d-b9e3-0f9ac0745de0',
		ProductID: '050125',
		ProductName: 'Lock-N-Load® Powder Measure Drain Insert',
		UPC: '090255501254',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.5',
		ShelfWidth: '4.5',
		ShelfDepth: '1',
		Weight: '0.106',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255501251',
		CartonHeight: '8.500',
		CartonWidth: '4.500',
		CartonDepth: '1.000',
		CartonWeight: '1.06',
		PalletQtyBoxes: '0',
		Retail: '19.04',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Replaces a metering insert so you can drain powder without removing the measure from its stand. (Compatible with Bench Rest Grade Powder Measure.)',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Fi-0hiI4--/e56079790e679de681196fcc99fae6efe7ffac17.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4c2eb1a9-0003-495d-998b-5a640be6b04d',
		ProductID: '546347',
		ProductName: 'Full-Length 2-Die Set 300 RSAUM (.308)',
		UPC: '090255563474',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.454',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563471',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.27',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '300 REM SA ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '611731e6-6c9e-4002-ae0f-a9d1826fead0',
		ProductID: '046452',
		ProductName: 'Full-Length Size Die 7mm RAUM (.284)',
		UPC: '090255464528',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464525',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM REM SA ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '924e77e4-bcfb-4a80-944c-753abe19d3a7',
		ProductID: '190199',
		ProductName: 'Powder Bushing 447',
		UPC: '090255191998',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191995',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '465c3008-9445-4654-a46d-6f1002d1b60d',
		ProductID: '050128',
		ProductName: 'Handgun Powder Measure Rotor & Metering Assembly',
		UPC: '090255501285',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.75',
		ShelfWidth: '3.25',
		ShelfDepth: '2.25',
		Weight: '1.349',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255501282',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '57.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use in your Lock-N-Load® Powder Measure, this pistol rotor features a smaller chamber for more precise metering of charge weights between .5 and 17 gr.',
		ProductImage: 'http://images.salsify.com/image/upload/s--sUfcbP4U--/u3llenpwxdr7arwfvc3h.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '70c92af5-eb8c-4467-99df-d25b53461084',
		ProductID: '3147B',
		ProductName: '7.62 Cal .310 123 gr FMJ',
		UPC: '090255631470',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '50.330',
		WeightUOM: 'LB',
		CaseQty: '2800',
		CartonUCC: '10090255631477',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '140924.0',
		PalletQtyBoxes: '117600',
		Retail: '0.31',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk FMJ Rifle Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.266',
		SectionalDensity: '0.183',
		OAL: '0.865',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		BulletName: 'FMJ',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HuEs0f6L--/v4953inhgvgde61glugs.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '28e283dd-e7e5-4472-9aa4-8b205d40f36c',
		ProductID: '044151',
		ProductName: 'Seater Die (.451) 45 Cal',
		UPC: '090255441512',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.570',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441519',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31931fa9-fffd-4d99-be2f-9c896be70c33',
		ProductID: '046309',
		ProductName: 'Full-Length Size Die 7X57-7mm Mauser (.284)',
		UPC: '090255463095',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.572',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463092',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '7X57',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '344cce37-c101-47ea-8b33-1bb4d1303a11',
		ProductID: '99262',
		ProductName: 'Hornady® Blaze Orange Cap',
		UPC: '090255992625',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'BANGLADESH',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--XoD7JX6A--/ko0trqu2ghqperi32gc5.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2de03259-88c8-43fb-94e2-221d4b3280fa',
		ProductID: '40061B',
		ProductName: '10mm .400 200 gr HAP®',
		UPC: '090255693034',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '52.559',
		WeightUOM: 'LB',
		CaseQty: '1800',
		CartonUCC: '10090255693031',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '94606.2',
		PalletQtyBoxes: '75600',
		Retail: '0.20',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.199',
		SectionalDensity: '0.179',
		OAL: '0.68',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'HAP®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yey2ipUN--/d38da23b8fb3a0324419ce21a06d2bfdd257e197.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--nCs5uAUD--/e7c391f650dc2c2c188ec830dd46b9540207cc80.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '83f81c1a-2e1b-4e68-a77a-5dc26cc0e0a1',
		ProductID: '64000',
		ProductName: '000 Buckshot .350 Diameter',
		UPC: '090255200188',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '5.281',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255200185',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.686',
		PalletQtyBoxes: '216',
		Retail: '45.48',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Buckshot',
		SectionalDensity: '0.0',
		BulletDiameter: '0.35',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '000',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Made with the same dedication to uniformity as Hornady bullets, Hornady Buckshot is cold swaged using a lead alloy hardened with antimony to prevent deformities after firing. This helps it fly straighter and hit harder.  We use a strict roundness tolerance of +.001" to put more pellets in your targets. The industry standard is a +.006" tolerance.  Buckshot is sold in 5 lb. boxes',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--Ovf_2AmW--/oelwmppsyxg4sm8fpolz.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Zxi1cxg4--/e8pdqszp5hqpuge045ee.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lTGpXr3O--/xa4ijamzgeifkytjhkzi.png',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '436c7d03-d878-4a9a-9f10-5c315435b5b4',
		ProductID: '40040',
		ProductName: '10mm .400 180 gr XTP®',
		UPC: '090255240047',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.697',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255240044',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.455',
		PalletQtyBoxes: '540',
		Retail: '40.13',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.164',
		SectionalDensity: '0.161',
		OAL: '0.624',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GWITVuNo--/0bd12bb9fd28ea16017f4d381e5ef7371ae1ab91.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4760d741-6b12-4ff8-8b26-a94e97797551',
		ProductID: '80786',
		ProductName: '7.62 x 39mm 123 gr HP Match American Gunner®',
		UPC: '090255807868',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '3.125',
		ShelfDepth: '6.125',
		Weight: '2.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807865',
		CartonHeight: '6.500',
		CartonWidth: '6.750',
		CartonDepth: '13.750',
		CartonWeight: '20.55',
		PalletQtyBoxes: '450',
		Retail: '91.80',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Rifle Ammunition',
		GeneralApplication: 'Hunting',
		G1BC: '0.398',
		MuzzleVelocity: '2350',
		MuzzleEnergy: '1508',
		SectionalDensity: '0.183',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.31',
		BulletName: 'HP MATCH™',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs. Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces a variety of rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kcXZTRXE--/iyerxgndyba02kfaeqcr.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--5WLhShAn--/ouwt7qum7fw3whtptiwx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Cn7bWxnr--/jqy5fotaq7bsq8mwwdcx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SzgHkrlW--/zrjrfe1l2jnxjtlm2gdb.jpg',
		Videos: 'https://vimeo.com/163447195',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cf1b8a15-9f61-42d6-915e-8056204d0fc2',
		ProductID: '046392',
		ProductName: 'Full Length Die 8.6 Blackout (.308)',
		UPC: '090255463927',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.250',
		ShelfWidth: '1.250',
		ShelfDepth: '6.875',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '8.6 BLACKOUT',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers. *Other accessories sold separately. HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92b02cdf-0f05-4638-aab6-1160f4f4a8a0',
		ProductID: '390608',
		ProductName: 'Shell Holder #53',
		UPC: '090255906080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.875',
		ShelfDepth: '0.75',
		Weight: '0.300',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906087',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '74a7c343-aa2d-44a3-b236-babf60585b5e',
		ProductID: '046258',
		ProductName: 'Match™ Grade Full-Length Size Die 6mmx47 Lapua (.243)',
		UPC: '090255462586',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462583',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6MMX47 LAPUA',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06fd7763-e539-4740-b629-4c4312b7142a',
		ProductID: '046057',
		ProductName: 'Neck Size Die 30 Cal Mag (.307)',
		UPC: '090255460575',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.448',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460572',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af847636-21dd-4fc1-bf6b-32d8563d8478',
		ProductID: '30715B',
		ProductName: '30 Cal .308 178 gr BTHP Match',
		UPC: '090255700459',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '41.816',
		WeightUOM: 'LB',
		CaseQty: '1600',
		CartonUCC: '10090255700456',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '66905.6',
		PalletQtyBoxes: '67200',
		Retail: '0.42',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.530',
		SectionalDensity: '0.268',
		OAL: '1.345',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--7KkNtQCy--/eacfe92492ef5a2ec97eed735e3cd49724c5411c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7fa76df7-135a-4835-9d53-13d801e2d6f0',
		ProductID: '22716',
		ProductName: '22 Cal .224 55 gr V-MAX®',
		UPC: '090255227161',
		PackagedQTY: '250',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.095',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227168',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.375',
		PalletQtyBoxes: '900',
		Retail: '74.85',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.255',
		SectionalDensity: '0.157',
		OAL: '0.813',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x_RPsQR5--/453f8e51ad511d2acd5d65c3e22629c963997387.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '41cd5014-4d2b-484e-ad38-0afb5bb7fadc',
		ProductID: '546307',
		ProductName: 'Full-Length 2-Die Set 7mm Rem Ultra Mag (.284)',
		UPC: '090255563078',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.412',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563075',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.06',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7MM REM ULTRA MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '432affdf-a9d2-4969-80c7-c7734c3df018',
		ProductID: '044701',
		ProductName: 'Expander Die 500 S&W Mag (.500)',
		UPC: '090255447019',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.455',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447016',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7f6d55bb-a10a-4c43-a9cf-ca08cd3ecbf8',
		ProductID: '30730',
		ProductName: '30 Cal .308 190 gr SUB-X®',
		UPC: '090255307306',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.850',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307303',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.75',
		PalletQtyBoxes: '540',
		Retail: '56.39',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Sub-X® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.437',
		SectionalDensity: '0.286',
		OAL: '1.3',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Reliable subsonic expansion Sub-X® (Subsonic — eXpanding) bullets deliver big results without a big bang! Designed to provide deep penetration below the speed of sound, Sub-X® features a lead core. Long grooves in its gilding metal jacket combine with its flat profile and the patented Flex Tip® insert within the bullet’s hollowpoint cavity to help it expand reliably at low velocities. Cannelures provide positive case crimp, making Sub-X® ideal for semiautomatic weapons. EXPANDS AT SUBSONIC VELOCITIES Patented Flex Tip® technology aids in expansion at velocities as low as 900 fps.  PROVEN PERFORMANCE Meets FBI protocol for terminal ballistic test requirements.  POSITIVE CASE CRIMP Lead core bullet with cannelured jacket provides positive case crimp for use in semiautomatics.  WIDE RANGE OF GUNS Designed to fit, feed and function in a variety of firearms, including gas system guns.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--zvv0GZ7b--/wn9pg5ek1obl63bi0k3c.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--QIUKUWTY--/yv4csh3mqrmzpeew0aab.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--rIjrcN6---/okqswqib3geupj4p07ey.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--RMzZ3xew--/iyn6cbplk0acvziaeybv.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--EZzsov2k--/ntqchorb4flcham6oh9v.png',
		Videos: 'https://vimeo.com/367134791',
		Videos1: 'https://vimeo.com/368030686',
		Videos2: 'https://vimeo.com/321754341',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '12d8d71d-d0fa-48f7-9e41-69ffff8f3281',
		ProductID: '380717',
		ProductName: 'Cartridge Gauge 30-06 Sprg (.308)',
		UPC: '090255807172',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807179',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '4.0',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4dd7fabe-2d84-4f97-94a6-a37b61eb6c7c',
		ProductID: '75870',
		ProductName: 'Snapsafe® Universal Handgun Hangers',
		UPC: '851529004198',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '11.5',
		ShelfWidth: '4.5',
		ShelfDepth: '1.5',
		Weight: '0.560',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004195',
		CartonHeight: '4.750',
		CartonWidth: '5.250',
		CartonDepth: '12.500',
		CartonWeight: '2.8',
		PalletQtyBoxes: '1950',
		Retail: '21.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '2',
		ProductExtWidth: '0.25',
		ProductExtDepth: '10.7',
		ProductWeight: '0.5',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004199',
		MasterPackHeight: '6.500',
		MasterPackWidth: '12.500',
		MasterPackDepth: '28.000',
		MasterPackWeight: '14.0',
		ProductDescription:
			'Maximize space by hanging handguns from shelves in your safe. Convenient and durable, the hangers are made with a PVC coating that prevents marring or scratching inside gun barrels. Available in a number of sizes, or in a mixed 6-pack. Fits shelves that are ½ to 1” thick Maximizes safe space by hanging guns below shelves PVC coating prevents damage to gun barrels Individual caliber 4-packs in 22 Cal, 9mm/38 Cal or 44 Cal.',
		ProductImage: 'http://images.salsify.com/image/upload/s--rDkxQkqw--/bt1jmscxg5ooypwszqio.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--TDoVbuBV--/snaqr50pytuerojyemae.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--7AGtLsZT--/fj1b37qvubjwll7qbmti.jpg',
		Videos: 'https://vimeo.com/213867180',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4256ad75-2a2b-43df-917e-d85cd748e315',
		ProductID: '8665B',
		ProductName: '30-06 Springfield Unprimed Cases',
		UPC: '090255600285',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '38.005',
		WeightUOM: 'LB',
		CaseQty: '1500',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '57007.5',
		PalletQtyBoxes: '66000',
		Retail: '0.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e493245d-6d2a-4500-b3d8-dba871f46e30',
		ProductID: '35572B',
		ProductName: '9mm .356 125 gr HAP®',
		UPC: '090255693027',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '54.701',
		WeightUOM: 'LB',
		CaseQty: '3000',
		CartonUCC: '10090255693024',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '164103.0',
		PalletQtyBoxes: '126000',
		Retail: '0.17',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk HAP® Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppTargetMatch',
		G1BC: '0.158',
		SectionalDensity: '0.141',
		OAL: '0.575',
		Caliber: '9MM',
		BulletDiameter: '0.356',
		BulletName: 'HAP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Hornady Action Pistol Gain the competitive edge with Hornady® HAP® (Hornady® Action Pistol) bullets. Modeled after the legendary XTP® bullet design, HAP® bullets are further refined into the perfect competition projectile. While XTP® bullets use serrations to aid in controlled expansion and terminal performance, we have eliminated these from HAP® bullets, creating a sleek and balanced projectile with a protected nose that aids in consistent and reliable feeding in auto loading pistols. Bullet jackets, featuring industry leading concentricity combined with precision swaged cores, deliver the very best in accuracy and performance. BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our copper jacket protects the nose of our HAP® bullet.  SWAGED CORE The core of the HAP® bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.  GILDING METAL JACKET The gilding metal jacket protects the nose and ensures smooth feeding.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yey2ipUN--/d38da23b8fb3a0324419ce21a06d2bfdd257e197.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jldzl7q_--/81021bfe85a74cb54871d6acf2b81235033c5749.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--DLmI__lc--/rkvthzevmuap4vtr13y3.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Vj2ZqOTW--/wlvbbortnwxwx4aiooe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--71Ekp-pz--/o6k7khjfmrlrkt6xboch.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a7bece1b-0388-4d34-94bc-5a4c28554e16',
		ProductID: 'C500N',
		ProductName: 'Lock-N-Load® 500 Nitro Modified Case',
		UPC: '090255705102',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '0.75',
		ShelfDepth: '0.75',
		Weight: '0.054',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705109',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.54',
		PalletQtyBoxes: '0',
		Retail: '13.81',
		ParentCategory: 'Reloading',
		Cartridge: '500 NITRO EXP 3"',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2024-03-05 08:51:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a27842eb-b2a9-4921-9872-27277d32d2f8',
		ProductID: '526',
		ProductName: 'Lock-N-Load® 26 Insert (.264/6.5mm)',
		UPC: '090255704242',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704249',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ds4H1NnH--/ohzjj1pwehyedhqaqoq6.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5632f9bf-13ef-4bd7-806f-201b787431d9',
		ProductID: '44050',
		ProductName: '44 Cal .430 180 gr XTP®',
		UPC: '090255244052',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.730',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255244059',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.95',
		PalletQtyBoxes: '540',
		Retail: '42.05',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.138',
		SectionalDensity: '0.139',
		OAL: '0.56',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ufhX53DD--/e35116a50ad7fc13113e7f38074e006cf40eb6d0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6ce0d00b-5e81-4015-bc47-15784ec5c6b6',
		ProductID: '81501',
		ProductName: '6.5 Creedmoor 147 gr ELD® Match',
		UPC: '090255815016',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.110',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815013',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.1',
		PalletQtyBoxes: '1400',
		Retail: '53.65',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.697',
		G7BC: '0.351',
		MuzzleVelocity: '2695',
		MuzzleEnergy: '2370',
		SectionalDensity: '0.301',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '147',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ks-D_A_v--/caaaf634b43bbf571018b9370538d869bd48a393.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cefa4335-3d7a-4392-ad8e-418c9664ccf5',
		ProductID: '3039',
		ProductName: '30 Cal .308 155 gr BTHP Match',
		UPC: '090255230390',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.333',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230397',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '34.995',
		PalletQtyBoxes: '540',
		Retail: '50.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.405',
		SectionalDensity: '0.233',
		OAL: '1.15',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--EO6fiofg--/c98b36f5b760f414a54a28f6b5e20ef2123ace9b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '94180f17-2b47-4a9c-ba9c-29db95c7bdaf',
		ProductID: '9948',
		ProductName: 'Hornady® Cartridge Introduction Display Board',
		UPC: '090255299489',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '16',
		ShelfDepth: '1.5',
		Weight: '5.600',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '5.6',
		PalletQtyBoxes: '200',
		Retail: '137.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'Lead',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury. Have adequate ventilation at all times. Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shadowbox style display with wood frame measures 16” x 10". The display features 21 cartridges that Hornady® has introduced as SAAMI cartridges since 1988. Made in the USA.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5YJpTCjm--/it9eejedmswpcysprmmv.jpg',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eefe5883-2c56-4569-903d-03fa4d75f449',
		ProductID: '594269',
		ProductName: 'Match™ Grade Bushing .269',
		UPC: '090255592696',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592693',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.269',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--O_eivCnC--/de2b0f87b35f00ba8cb996097c084c6d9ca74a46.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '424b1d8a-b3f7-48bd-a677-194c9e455cce',
		ProductID: '30452',
		ProductName: '30 Cal .308 165 gr SST®',
		UPC: '090255304527',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.507',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255304524',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '37.605',
		PalletQtyBoxes: '540',
		Retail: '55.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		OAL: '1.27',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1e3SQKFR--/6839bb506e55261d61e5b39d164e22c9bc6bc28d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c3f5a7b-f914-42ca-ab4f-a6d987481e28',
		ProductID: '046216',
		ProductName: 'Match™ Grade Full-Length Size Die 6.5X55 Swede (.264)',
		UPC: '090255462166',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462163',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '221e73a8-92ea-42c0-84b7-52cada0749d2',
		ProductID: '22403',
		ProductName: '22 Cal .224 50 gr GMX®',
		UPC: '090255224030',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.420',
		WeightUOM: 'LB',
		CaseQty: '50',
		CartonUCC: '10090255224037',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '21.0',
		PalletQtyBoxes: '1800',
		Retail: '36.05',
		ParentCategory: 'Bullets',
		Applications: 'AppMediumGame',
		G1BC: '0.215',
		SectionalDensity: '0.142',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'GMX®',
		BulletWeightGrain: '50',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UT5wwDbz--/32915eb06d144a3a5e8d66e747883b052705e00e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c41c439c-a832-4da5-8c78-82b0f79ae269',
		ProductID: '80963',
		ProductName: '308 Win 168 gr ELD® Match Superformance® Match',
		UPC: '090255809633',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.295',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809630',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.95',
		PalletQtyBoxes: '1400',
		Retail: '56.60',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.523',
		G7BC: '0.263',
		MuzzleVelocity: '2840',
		MuzzleEnergy: '3009',
		SectionalDensity: '0.253',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge your match rifle! Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Topped with the finest bullets, Superformance® Match™ ammunition marries the very best cartridge cases with extremely stable propellants. These propellants are custom blended for each individual load to provide true ammunition performance enhancement. FAST Superformance®  Match™ ammunition achieves muzzle velocities of 100 – 200 fps faster than ANY conventional ammunition.  ACCURATE Highpower competitors, as well as law enforcement and military shooters and snipers, benefit from the Superformance® Match™ advantages – higher muzzle velocity, phenomenal accuracy, increased range and reduced wind drift.  Superformance® Match™ ammunition - the limits have been broken!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--X4fswI-K--/c475184b2ba83dbaf8b2f846493cd99ddb26158c.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vnFUoOYZ--/4e56e20280468c8d00ab43d066e73c9cfc7cb110.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--1p4zt9b5--/g5lr8ycpphdp3sqhisg3.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s---8dZEoUU--/v6e5gygwqep8fdkfzjlz.jpg',
		Videos: 'https://vimeo.com/241896524',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f264fff9-7d8a-4640-be28-cdf5d068069a',
		ProductID: '30310',
		ProductName: '30 Cal .308 140 gr MonoFlex® (for 30-30 Win)',
		UPC: '090255303100',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.091',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255303107',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '27.275',
		PalletQtyBoxes: '900',
		Retail: '61.00',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'MonoFlex® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.277',
		SectionalDensity: '0.211',
		OAL: '1.2',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"A solid option for your lever gun. By combining the technologies of the GMX® and FTX® bullet design, the MonoFlex® bullet gives lever gun shooters another option. Constructed of a copper alloy, MonoFlex® bullets offer hunters a solid that won't separate, and when recovered, retains 95% of its original weight. Copper alloy differs from solid copper in that it is harder, tougher and does not foul or increase pressure the way solid copper bullets do.  Upon impact, the patented Flex Tip® design initiates immediate expansion, even at the lower velocities often encountered in mid to long range lever gun shooting situations. Its deep penetration and high weight retention combine to produce yet another accurate, deadly and dependable choice for lever gun hunters. PATENTED FLEX TIP® DESIGN Safe to use in all tubular magazines and initiates expansion, even at lower velocities.  MONOLITHIC CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration and 95% weight retention.  BALLISTICALLY EFFICIENT SECANT OGIVE PROFILE Delivers the flattest possible trajectories from lever guns.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--UukTV5TZ--/4592f94a783d80d5bfd593f7f8a1c5d68866a7d2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8hVQSXwY--/a19voudldx4vifinrkg0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--gWBXpGIc--/x2dgohrlgnrxags0ss7p.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--3uG1h8n7--/gycnsi5k1gyttk06jqp6.jpg',
		Videos: 'https://vimeo.com/359615915',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2b4b5632-bde1-40ee-aba0-1450db9a5711',
		ProductID: '3515',
		ProductName: '35 Cal .358 200 gr InterLock® RN',
		UPC: '090255235159',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.981',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255235156',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '44.715',
		PalletQtyBoxes: '540',
		Retail: '62.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.195',
		SectionalDensity: '0.223',
		OAL: '0.89',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2HLfod2H--/da38268b49929a31386256b3578e458d8906675a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '68bec2c9-f90e-4356-ba6a-1fb849379abe',
		ProductID: '044707',
		ProductName: 'Seater Die 223 Win SS Mag (.224)',
		UPC: '090255047073',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.630',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255047070',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'af54a006-13af-48a8-962a-42b5e63ca0a1',
		ProductID: '81453',
		ProductName: '25-06 Rem 117 gr SST® Superformance®',
		UPC: '090255814538',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.123',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255814535',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.23',
		PalletQtyBoxes: '1400',
		Retail: '58.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.39',
		MuzzleVelocity: '3110',
		MuzzleEnergy: '2513',
		SectionalDensity: '0.253',
		Cartridge: '25-06 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'SST®',
		BulletWeightGrain: '117',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2QgIWSzW--/426fa28f68ee93dcf635ea0de7680886a07cee6c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '15b9fadb-e7c2-4a45-8908-c41fd9b48612',
		ProductID: '75912',
		ProductName: 'SnapSafe® Magnetic Gun Mount',
		UPC: '842631100465',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '5.5',
		ShelfDepth: '1',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100462',
		CartonHeight: '4.000',
		CartonWidth: '5.750',
		CartonDepth: '7.250',
		CartonWeight: '3.0',
		PalletQtyBoxes: '1920',
		Retail: '23.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'PHTHALATES',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '80',
		MasterPackUCC: '30842631100466',
		MasterPackHeight: '8.500',
		MasterPackWidth: '15.750',
		MasterPackDepth: '23.750',
		MasterPackWeight: '48.0',
		ProductDescription:
			'Powerful rare earth magnets rated for 43 lbs. Rubber coating protects firearm and accessories. Compact design and included mounting screws allow installation nearly everywhere.   Rated for 43 lbs. Rubber coating protects firearm and accessories. Compact design and included mounting screws allow installation nearly everywhere.',
		ProductImage: 'http://images.salsify.com/image/upload/s--GqkyHHaH--/kwr1j1ddjhv71ilbnggd.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--DYjFNxYc--/yfte7e4jqrugmnebeawf.jpg',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e0595657-0664-42b6-a5cb-9f1d2025d0ed',
		ProductID: '8052',
		ProductName: '270 Win 130 gr GMX® Superformance®',
		UPC: '090255380521',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.236',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255380528',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.36',
		PalletQtyBoxes: '1400',
		Retail: '58.65',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.46',
		SectionalDensity: '0.242',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'GMX®',
		BulletWeightGrain: '130',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--TkcewjPt--/a340189e94951404932d85ced755ae846e1263b4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c85c792c-a455-4c62-a795-72ee7fbe2661',
		ProductID: '044553',
		ProductName: 'Expander Die 444 Marlin (.430)',
		UPC: '090255445534',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.435',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445531',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92c4348a-e04a-497d-9cce-3728ab7a184d',
		ProductID: 'C9374',
		ProductName: 'Lock-N-Load® 9.3X74R Modified Case',
		UPC: '090255705096',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.035',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705093',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.35',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '9.3X74R',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e5572905-3f9a-43be-af84-dbdb52ffc33c',
		ProductID: '81254',
		ProductName: '5.56 NATO 55 gr GMX® Superformance®',
		UPC: '090255812541',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255812548',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.95',
		PalletQtyBoxes: '1680',
		Retail: '37.92',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.27',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'GMX®',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--cp_lmXpb--/f375a46cb2545f6ffd62cf1c14ab32c2df6031b5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7851b1d4-c6fa-4acd-8834-5b175070bf2a',
		ProductID: '190102',
		ProductName: 'Shot Bushing 1 1/8 oz #9',
		UPC: '090255191028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1.5',
		Weight: '0.065',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191025',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.65',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shot Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with all Hornady shotshell reloaders. Calibrated to measure maximum legal loads for trap and skeet shooting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eeb7d4c8-b279-4515-b06d-f4c228c3131e',
		ProductID: '544303',
		ProductName: 'Match™ Grade 2-Die Set 284 Win (.284)',
		UPC: '090255543032',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255543039',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.75',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '284 WIN',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03f0b27e-4e5f-401b-91a7-e3d7a9a922a7',
		ProductID: '86248',
		ProductName: '20 GA #5 Nickel 3" Turkey',
		UPC: '090255862485',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.5',
		ShelfWidth: '2.75',
		ShelfDepth: '3.625',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862482',
		CartonHeight: '4.187',
		CartonWidth: '6.000',
		CartonDepth: '9.062',
		CartonWeight: '11.5',
		PalletQtyBoxes: '1020',
		Retail: '19.13',
		ParentCategory: 'Ammunition',
		Applications: 'AppTurkey',
		Cartridge: '20 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '#5',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Your answer for turkeys and coyotes!  Take down turkeys and coyotes up to 50 yards away with accurate, deadly and dependable Heavy Magnum® Shotgun ammunition. HEAVY MAGNUM® TURKEY Available in 3", 12 or 20 gauge loads, Heavy Magnum Turkey® delivers true gobbler knockdown power! Shot deformation is minimized, thanks to the thickest nickel-plating in the industry, which reduces fliers and keeps more pellets on target for dense patterns. The Hornady® Versatite® wad does the patterning, so these loads don\'t require shotgun modification or specialized turkey chokes. At 1300 fps for the 12 gauge load, and 1200 fps for the 20 gauge load, Heavy Magnum® Turkey ammunition allows hunters to achieve lethal results out to 50 yards.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--AbE_tenh--/08b9ca2f1042562e09c95c3b0f9c7e9fae1afd2e.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--qCOITQ7Z--/89f8d5ff0df46ccaad2bf6267e27aa0b60b3b3d9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--0Y1n1BVa--/p3qgsaqdchsmz1aokwtz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--37xpNX99--/ng1zr8b2my7llzpzjdh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vrrj_D2T--/medsfy04smayoz3fouqu.jpg',
		Videos: 'https://vimeo.com/145438803',
		Videos1: 'https://vimeo.com/264506193',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a534ee0d-6d9f-4654-b2ed-04a3730f0b4f',
		ProductID: '390958',
		ProductName: 'Trimer Pilot #16 .375',
		UPC: '090255909586',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.011',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909583',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.11',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--H2FuVYXf--/xpulgt2ycxmf5srniahx.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd0ea263f-62c7-4e5e-8142-405de4035936',
		ProductID: '9138',
		ProductName: '480 Ruger 325 gr XTP® Mag',
		UPC: '090255391381',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.511',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391388',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '15.11',
		PalletQtyBoxes: '1120',
		Retail: '59.11',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.15',
		MuzzleVelocity: '1350',
		MuzzleEnergy: '1315',
		SectionalDensity: '0.206',
		Cartridge: '480 RUGER',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '325',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ceoB8Y6z--/f242d32fba649f14eedc3880dd99a270162bc6c5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72b32ef6-8470-42a8-8a17-13f300748a93',
		ProductID: 'A17H',
		ProductName: 'Lock-N-Load® 17 Hornet Adapter & Modified Case',
		UPC: '090255703313',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255703310',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '37.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® OAL Gauges',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs. Contains both Modified Case and Adapter D for 17 Hornet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTJ_wLVt--/wtx0ifz6pjtzmvkvoxmf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a037c6f3-0be2-4c54-8a84-0f9962e216ea',
		ProductID: '8617',
		ProductName: '223 Winchester Super Short Magnum Unprimed Cases',
		UPC: '090255486179',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.650',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486176',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '8.25',
		PalletQtyBoxes: '400',
		Retail: '79.81',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '223 WSSM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b068ce02-7541-45b8-8446-4eb757d03a30',
		ProductID: '190166',
		ProductName: 'Powder Bushing 465',
		UPC: '090255191660',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.060',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191667',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.6',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3c1ffd62-eb3f-40eb-b7a4-d13ad022bd68',
		ProductID: '392370',
		ProductName: 'Lock-N-Load®AP™Case Retainer Spring - 3 Pack',
		UPC: '090255923704',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '1',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255923701',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '11.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--n3HwWTRM--/cmpj3rbbzcgoed4ops58.jpg',
		DateLastModified: '2023-12-16 09:02:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ee46ec2a-9788-49c5-a379-f622c841398b',
		ProductID: '392640',
		ProductName: 'Shell Plate #40 Lock-N-Load®AP™ & Projector',
		UPC: '090255926408',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.614',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926405',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '6.14',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '304bb54d-4b16-46ea-b168-98e3d8d8d597',
		ProductID: '35730',
		ProductName: '38 Cal .357 125 gr FP XTP®',
		UPC: '090255235739',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.877',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255235736',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.925',
		PalletQtyBoxes: '900',
		Retail: '32.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.148',
		SectionalDensity: '0.14',
		OAL: '0.545',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FP-XTP®',
		BulletWeightGrain: '125',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WMhpmcBU--/6c2fc756261c0cd4e10f5500a6e6316b35ec15dc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1e4fb79a-aa80-47a0-bcff-51f8d162e768',
		ProductID: '046358',
		ProductName: 'Full-Length Size Die 308 Marlin Exp (.308)',
		UPC: '090255463583',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.507',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463580',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '308 MARLIN EXP',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51d685fd-0604-46c5-aa86-1d847fb940b5',
		ProductID: '99131',
		ProductName: 'Hornady® Ballistic Band (2 Pk)',
		UPC: '090255991314',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '5',
		ShelfDepth: '5.5',
		Weight: '0.161',
		WeightUOM: 'LB',
		CaseQty: '50',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '8.05',
		PalletQtyBoxes: '80000',
		Retail: '10.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Avoid confusion and tag your guns with these handy Ballistic Bands. Sold as a 2-pack, the bands allow shooters to record the ammunition, bullet weight and ballistic information for quick reference in the field or in storage. Place it on your gun stock or wear on your wrist.',
		ProductImage: 'http://images.salsify.com/image/upload/s--Yvv600Q1--/zc9rky22k5lkxpqywzot.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s---ybqRyp7--/hbmihfhj1g31ayv0h8ci.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--55z945Cv--/ejs2vznudmmpptnfpjuh.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--0ZlW2nsq--/webtu7nhhrm5sqbjzjcn.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5324fb08-cb83-4145-88d6-040717346c16',
		ProductID: 'BANRLG',
		ProductName: 'Red Banner',
		UPC: '090255697384',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.5',
		ShelfWidth: '3',
		ShelfDepth: '40',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '49.99',
		ParentCategory: 'Shop',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Measures 40" x 48"',
		ProductImage: 'http://images.salsify.com/image/upload/s--e96tV-tD--/ca9dhcuv6ksnedrckxmk.jpg',
		DateLastModified: '2023-12-16 08:55:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd514bd79-2df0-4b19-bd1d-4bf3f25f34d4',
		ProductID: '9974',
		ProductName: 'Hornady® Sage & Tan Tshirt',
		Retail: '20.99',
		ProductImage: 'http://images.salsify.com/image/upload/s--z6Tzv5Yz--/bujvzcllcnsme6ngujqp.png',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2909b148-42b1-4a3d-9e4d-b01ce4752217',
		ProductID: '9245',
		ProductName: '50 Action Express 300 gr XTP® HP',
		UPC: '090255392456',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.490',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255392453',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '14.9',
		PalletQtyBoxes: '1120',
		Retail: '57.41',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.12',
		MuzzleVelocity: '1475',
		MuzzleEnergy: '1449',
		SectionalDensity: '0.171',
		Cartridge: '50 AE',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		BulletName: 'XTP® MAG™',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--QqyVmvrj--/487903d423a29892222be37d28b6efa779f4cded.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '312a2ac3-ed08-4be9-85ed-49481ad09fbe',
		ProductID: 'B26N',
		ProductName: 'Lock-N-Load® 26 Nosler Modified Case',
		UPC: '090255715040',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715047',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.55',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '26 NOSLER',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dd1029ff-2ee4-4565-bb58-1f88f1fada78',
		ProductID: '24531',
		ProductName: '6mm .243 110 gr A-TIP Match',
		UPC: '090255245318',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '1.860',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255245315',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '18.6',
		PalletQtyBoxes: '240',
		Retail: '114.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.604',
		G7BC: '0.304',
		MinTwist: '1-7.7"',
		SectionalDensity: '0.266',
		OAL: '1.324',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--yb21ojvY--/t2ndeisumgzttwbzdewo.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4efb932f-a733-440d-ac72-1669db6bdb36',
		ProductID: '98210',
		ProductName: 'Hornady® RAPiD® Safe Vehicle Safe',
		UPC: '090255982107',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '9.5',
		ShelfDepth: '18.5',
		Weight: '10.175',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255982104',
		CartonHeight: '10.500',
		CartonWidth: '19.250',
		CartonDepth: '19.500',
		CartonWeight: '40.7',
		PalletQtyBoxes: '128',
		Retail: '0.00',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		TopItem: 'Y',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AAA',
		BatteryQty: '4',
		BatteryWattHour: '7.48',
		BatteryWeight: '46',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '12',
		ProductExtWidth: '6.4',
		ProductExtDepth: '2.2',
		ProductWeight: '6.755',
		ProductIntHeight: '7.5',
		ProductIntWidth: '5.6',
		ProductIntDepth: '1.7',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The patent-pending mounting system of the RAPiD® Vehicle Safe features an inflatable bladder that conforms to a vehicle interior\'s shape, making modifications to the vehicle unnecessary. Power is supplied by the included 12-volt car adapter or four AAA batteries (not included). EXCEEDS SAFETY STANDARDS Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and high-attack resistance.  FAST AND DEPENDABLE TOUCH-FREE ENTRY RFID[2] activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS User can program four- to six-digit security code for secondary entry method or use barrel key.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 14 gauge steel with two internal hardened locking lugs. A security cable for attaching to the seat frame is included.  SAFE AND READY 12-volt car adaptor or four AAA batteries (not included) ensures your handgun is protected and ready when you are.  Contents Include: RAPiD® Safe, 12V Car Adaptor, RFID Wristband, two RFID Stickers, RFID Key Fob, two Circular Barrel Keys, Security Cable.  Fits many 4-inch barrel pistols and 2-inch revolvers.  Features: Keypad, Inflatable Mounting System Exterior Dimensions: 12"H x 6.4"W x 2.2"D Interior Dimensions: 7.5"H x 5.6"W x 1.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--NQ8NTqsD--/mxbrzhwo4r8tykm54yfi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--NQ8NTqsD--/mxbrzhwo4r8tykm54yfi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--OpjJxvLP--/hjhr4haazk0wqfstz9ny.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--u4u8vjqJ--/d1jtrmiclt7m6sre3y7h.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Bq54fUyH--/mny7zvmimggvnahay7vq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--Wcx7_14n--/kmeyklwjc7wgvueahxpk.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--TJ_1Mqia--/g7gsocxffpez3ee36ylt.png',
		Videos: 'https://vimeo.com/238318123',
		Videos1: 'https://vimeo.com/242146453',
		Videos2: 'https://vimeo.com/257722595',
		DateLastModified: '2024-01-16 16:37:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '10c44eaf-1596-4898-9f77-2671e8c8bee8',
		ProductID: '546536',
		ProductName: '3-Die Set 38/40 Win (.400)',
		UPC: '090255565362',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.700',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565369',
		CartonHeight: '8.000',
		CartonWidth: '11.000',
		CartonDepth: '6.000',
		CartonWeight: '8.5',
		PalletQtyBoxes: '0',
		Retail: '114.80',
		ParentCategory: 'Reloading',
		Cartridge: '38-40 WIN',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '96e76ba7-852a-46f8-8aa1-fe93683b203e',
		ProductID: '046336',
		ProductName: 'Full-Length Size Die 30 TC (.308)',
		UPC: '090255463361',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.535',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463368',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '30 TC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '735866c6-3eea-4a8a-b02e-ea8cbd2d57ea',
		ProductID: '82735',
		ProductName: '35 Rem 200 gr FTX® LEVERevolution®',
		UPC: '090255827354',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.252',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255827351',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.52',
		PalletQtyBoxes: '1400',
		Retail: '54.67',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.3',
		MuzzleVelocity: '2225',
		MuzzleEnergy: '2198',
		SectionalDensity: '0.223',
		Cartridge: '35 REM',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s---e7Q7zFm--/7e5c0027c341615f5f95c14c6180e61b7b20c3a8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:24',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6d2aab38-39f8-4859-8454-01b4f56384ba',
		ProductID: '2716',
		ProductName: '270-6.8mm .277 120 gr SST®',
		UPC: '090255709995',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.820',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255709992',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.5',
		PalletQtyBoxes: '900',
		Retail: '52.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.4',
		SectionalDensity: '0.223',
		OAL: '1.12',
		Caliber: '6.8MM/270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--s1GwOP4y--/39ca60c08a1d209c5de53b33237414737bc9a4b0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aef98e81-a48b-4dbd-9756-578e9fc349de',
		ProductID: '82226',
		ProductName: '338 Win Mag 185 gr GMX® Superformance®',
		UPC: '090255822267',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.640',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822264',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.4',
		PalletQtyBoxes: '780',
		Retail: '63.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.42',
		SectionalDensity: '0.231',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'GMX®',
		BulletWeightGrain: '185',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hkY36JRB--/828d13ce3f86cf113c316620be1420790be15306.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0197c898-7256-4d47-b4bd-a25eec266ab2',
		ProductID: '392602',
		ProductName: 'Shell Plate #2 Lock-N-Load® AP™ & Projector',
		UPC: '090255926026',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.569',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926023',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.69',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2be434ed-12e9-4852-a2e2-d5fbe1e532b9',
		ProductID: '390574',
		ProductName: 'Shell Holder #34',
		UPC: '090255905748',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905745',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '94c4d610-1ac9-4a2e-92d4-c52bb073cf25',
		ProductID: '80920',
		ProductName: '308 Win 155 gr Critical Defense®',
		UPC: '090255809206',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.185',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809203',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.85',
		PalletQtyBoxes: '1400',
		Retail: '55.75',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Rifle Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.313',
		MuzzleVelocity: '2785',
		MuzzleEnergy: '2669',
		SectionalDensity: '0.233',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FTX®',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKoEV_aJ--/zdwwzqo49qghiibnanqz.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--VwSpgb9u--/578df66981333ef9dd081e4eb898a9da2f0a5c2f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ryDaQrK3--/kcfhxhg0kodiwcr6over.png',
		ProductImage2:
			'http://images.salsify.com/image/upload/s--9FXfaIjW--/c5af05d9b6ad4e722289a84ab899f9669829a6f2.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--wly5_HJT--/yt7vaaptixnx6sz5ph6o.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--WtiVk7N3--/xr3oximw0vgyhtgsvcmi.jpg',
		Videos: 'https://vimeo.com/238317634',
		Videos1: 'https://vimeo.com/257722358',
		Videos2: 'https://vimeo.com/241903262',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c3a73377-214f-41c5-9508-256f71c8d079',
		ProductID: '392160',
		ProductName: 'Collet #7 .308/.312 Cal',
		UPC: '090255921601',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255921608',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.34',
		PalletQtyBoxes: '0',
		Retail: '17.20',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet Puller & Cam Lock™ Accessories',
		Caliber: '30 CAL/303 CAL',
		BulletDiameter: '0.308/0.312',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Works with the Cam Lock™ Bullet Puller.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--eMHRHFxV--/ff399e2ffb6376d02a17958eb2299832cc97f8b0.jpg',
		DateLastModified: '2023-12-16 09:02:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c4dae0e-904a-4392-9e53-fababf9c2b5e',
		ProductID: '044101',
		ProductName: 'Seater Die #1 (.172) 17 Cal',
		UPC: '090255441017',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.480',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441014',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc0cbae0-d7ca-477d-bf94-652d8e33b3db',
		ProductID: '010044',
		ProductName: '366 Auto Loader 20 Ga 2-3/4',
		UPC: '090255010442',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '32.150',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '20.250',
		CartonWidth: '16.375',
		CartonDepth: '11.750',
		CartonWeight: '32.15',
		PalletQtyBoxes: '27',
		Retail: '1719.60',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Shotshell Reloader',
		Cartridge: '20 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--fl8hiEi0--/d9fvaqkfzq23mky7kblt.pdf',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--ejnGPOqO--/boekrj6dos8anorhlpbq.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'afa35b07-d760-4ed4-b7b1-7bac927741cd',
		ProductID: '22796',
		ProductName: '22 Cal .224 75 gr BTHP',
		UPC: '090255227963',
		PackagedQTY: '600',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '6.550',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255227960',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.3',
		PalletQtyBoxes: '216',
		Retail: '194.28',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		SectionalDensity: '0.214',
		OAL: '0.99',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ay2RbBxd--/52ff6f352248ab737e19dae1fcd06ce2ddeba873.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9ea2c827-5f21-4787-94aa-e9c8907ece71',
		ProductID: '043400',
		ProductName: 'Zip Spindle™ Kit',
		UPC: '090255434002',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '0.5',
		Weight: '0.097',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255434009',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '16.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady® Die Zip Spindle™ Kit is the ideal kit for updating your older Hornady® Sizing Dies to utilize the new threaded spindle design. This kit can also be used for replacement parts (it’s always good to have spares on hand). The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  This kit includes a threaded spindle lock that tightens the Zip Spindle™ so it will not slip in the die.',
		ProductImage: 'http://images.salsify.com/image/upload/s--TOYZthWW--/cogluhq53vib9gyyjz2r.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e4f83a4c-f5b3-4656-aeca-b7ed9bb6be9b',
		ProductID: '046245',
		ProductName: 'Full-Length Size Die 243 Win (.243)',
		UPC: '090255462456',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.575',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462453',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '19e4f97d-726c-472b-a8f0-08c45c27f4cb',
		ProductID: '041218',
		ProductName: 'Primer Pocket Swage Tool for AP™ Press (308)',
		UPC: '090255412185',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '6.75',
		ShelfDepth: '3',
		Weight: '2.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '6.000',
		CartonWidth: '6.750',
		CartonDepth: '3.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '160.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Cartridge: '308 WIN/7.62X51 NATO',
		Caliber: '30 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady® Lock-N-Load® AP™ Primer Pocket Swage Tool quickly and cleanly removes crimps on cartridge case primer pockets. Designed to be used on the Lock-N-Load® AP™ press, the Lock-N-Load® AP™ Primer Pocket Swage Tool comes with shell plate and dies for feed, swage, and eject to make your job easier.  Available in 223 Rem/5.56 and 308 Win/7.62 models, swage depth can be adjusted to accommodate various case brands.  Swaging out the crimps on primer pockets instead of cutting them eliminates trimmings and mess.  Lock-N-Load® AP™ Primer Pocket Swage Tool 308/7.62x51',
		ProductImage: 'http://images.salsify.com/image/upload/s--KjlTlUzX--/zgohnizrz26q0oantvqb.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e1c81640-56bd-4749-954b-6d28af68c856',
		ProductID: '546310',
		ProductName: 'Full-Length 2-Die Set 7X61 S&H (.284)',
		UPC: '090255563108',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563105',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7X61 S&H',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5ec9d6d8-6546-418b-8145-523904c97a3c',
		ProductID: '75830',
		ProductName: 'Snapsafe® 6 Gun Pistol Rack',
		UPC: '851529004228',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14',
		ShelfWidth: '7',
		ShelfDepth: '6.25',
		Weight: '1.986',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004225',
		CartonHeight: '9.750',
		CartonWidth: '8.250',
		CartonDepth: '15.500',
		CartonWeight: '9.93',
		PalletQtyBoxes: '525',
		Retail: '18.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.25',
		ProductExtWidth: '13.5',
		ProductExtDepth: '7',
		ProductWeight: '1.8',
		MasterPackQty: '25',
		MasterPackUCC: '30851529004229',
		MasterPackHeight: '10.000',
		MasterPackWidth: '16.000',
		MasterPackDepth: '41.000',
		MasterPackWeight: '49.65',
		ProductImage: 'http://images.salsify.com/image/upload/s--lAXmPYlk--/kselb7k7rjiilvf6g83n.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--PXluXe_c--/fuwpj0rdzn6zyubgfird.jpg',
		Videos: 'https://vimeo.com/213867149',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c5894f0-78c9-47d5-affa-2a07c60d92df',
		ProductID: '380702',
		ProductName: 'Cartridge Gauge 38 Spl (.357)',
		UPC: '090255807028',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807025',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '38 SPL',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03783693-d6a3-4a7c-a2e8-2e9863a5a1f9',
		ProductID: '046451',
		ProductName: 'Full-Length Size Die 7mm Win Short Mag (.284)',
		UPC: '090255464511',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.537',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464518',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e9c91cec-1151-413b-b74f-73839b830265',
		ProductID: '594249',
		ProductName: 'Match™ Grade Bushing .249',
		UPC: '090255592498',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592495',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6MM',
		BulletDiameter: '0.249',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ofehQOAX--/fbd952556be303f04c293baa56396276d658eff7.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '522f707b-b705-40f6-a0c3-3c4c69979712',
		ProductID: '390573',
		ProductName: 'Shell Holder #33',
		UPC: '090255905731',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.045',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905738',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.45',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c450ba55-28ae-4494-b70d-02f84d3cfa9a',
		ProductID: '832744',
		ProductName: '223 Rem 55 gr. CX™ Superformance®',
		UPC: '090255719925',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.591',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719922',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.91',
		PalletQtyBoxes: '1680',
		Retail: '39.59',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '.245',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'CX™',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HfdKvNYi--/tqsv1qz7vc6ehijfwqpx.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:09:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ae66916-9f54-48bc-b18a-064dab0ac92b',
		ProductID: '822124',
		ProductName: '300 Weatherby Magnum 180 gr CX™ Outfitter',
		UPC: '090255719888',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.645',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719885',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '16.45',
		PalletQtyBoxes: '780',
		Retail: '87.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.469',
		MuzzleVelocity: '3100',
		MuzzleEnergy: '3841',
		SectionalDensity: '0.271',
		Cartridge: '300 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--EwNfjaqS--/agkkaicbzryf5udxprzi.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '630bd6ce-86df-4dc3-92a8-8f5349a3ba32',
		ProductID: 'A35R',
		ProductName: 'Lock-N-Load® 35 Rem Modified Case',
		UPC: '090255704723',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.027',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704720',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.27',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '35 REM',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--poRx_oSY--/917f593a151c30f23cc3049e87bee9898888290a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a2a8197f-e268-4956-ad43-bced2c66208a',
		ProductID: 'FR300',
		ProductName: '5.56 NATO 62 gr BTHP Match  Frontier®',
		UPC: '090255711592',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.5',
		ShelfWidth: '4.25',
		ShelfDepth: '0.85',
		Weight: '0.590',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255711599',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '14.75',
		PalletQtyBoxes: '4500',
		Retail: '14.19',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.27',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'ORIENTED',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IXcwMmXx--/508febc875fb0c60bd9a2c0de62301bb538df17a.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e44838c8-bc8d-4573-84e5-5ad8b5061f5e',
		ProductID: '813624',
		ProductName: '257 Wby Mag 90 gr. CX™ Outfitter®',
		UPC: '090255719772',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.330',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719779',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '13.3',
		PalletQtyBoxes: '780',
		Retail: '87.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.273',
		MuzzleVelocity: '3625',
		MuzzleEnergy: '2626',
		SectionalDensity: '0.195',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		BulletName: 'CX™',
		BulletWeightGrain: '90',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--tiEEoN87--/gql54u0egabmqlfa94xc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '767213ac-e00a-41bf-9e5a-012646f01b8b',
		ProductID: '86724',
		ProductName: '300 Remington Ultra Magnum Unprimed Cases',
		UPC: '090255867244',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255867241',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '4.25',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'afe7f798-7c6f-40a7-bb1c-4993fda9cbcc',
		ProductID: '546296',
		ProductName: 'Full-Length 2-Die Set 6.5mm TCU (.264)',
		UPC: '090255562965',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562962',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6.5 TCU',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5a06ef23-617d-400a-b6cf-cd1fa9f98759',
		ProductID: '86874',
		ProductName: '416 Remington Magnum Unprimed Cases',
		UPC: '090255868746',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '2.050',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868743',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '10.25',
		PalletQtyBoxes: '200',
		Retail: '103.48',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '416 REM MAG',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a2bc5dd0-51a7-43e9-8c2a-80f38aaf0dd6',
		ProductID: '82318',
		ProductName: '338 Lapua Mag 240 gr. CX™ Custom',
		UPC: '090255823189',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823186',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '396',
		Retail: '176.67',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.3',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'CX™',
		BulletWeightGrain: '240',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition. Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--o5YBTuPt--/nb8kjhp8azpf9q6kscca.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		DateLastModified: '2024-02-21 13:43:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8e1188ce-2b98-45ab-9dd5-87742ec22027',
		ProductID: '046042',
		ProductName: 'Neck Size Die 257 Cal (.257)',
		UPC: '090255460421',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.478',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255460428',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '47.31',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Neck Size Dies',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Neck Size Die features a removable Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™ that positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The Hornady® Neck Size Die can be used to neck size a variety of cartridges that use the same bullet diameter.  This die also features a hardened steel Headed Decap Pin.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® NECK SIZE DIE COMES COMPLETE WITH THE FOLLOWING: Neck Size Die and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--yPBW9jjY--/bghd9l8zikdxjjsicnod.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd824b902-7dc9-4b90-8a2b-279e3dc0e4d8',
		ProductID: '32050',
		ProductName: '32 Cal .312 85 gr XTP®',
		UPC: '090255232059',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '1.292',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255232056',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '51.68',
		PalletQtyBoxes: '1440',
		Retail: '31.73',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.145',
		SectionalDensity: '0.125',
		OAL: '0.495',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		BulletName: 'XTP®',
		BulletWeightGrain: '85',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--jiRrHfQx--/25fa0ec2a7801d8601dc41bdb71c17118ec69e07.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '458b0744-c542-4b69-95cb-78cce3665ebe',
		ProductID: 'C50BMG',
		ProductName: 'Lock-N-Load® 50 BMG Modified Case',
		UPC: '090255708110',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255708117',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '18.07',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '50 BMG',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5781e0ff-15fb-42a5-b355-b12f5b5ba5b1',
		ProductID: '2279',
		ProductName: '22 Cal .224 75 gr BTHP Match',
		UPC: '090255222791',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.178',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255222798',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '29.45',
		PalletQtyBoxes: '900',
		Retail: '34.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		SectionalDensity: '0.214',
		OAL: '0.99',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Ee7XWFbB--/abd64d4a90a1f16155459b183e0d0b6a9e8942aa.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51406163-3408-408c-b3f4-3907c7392621',
		ProductID: '046228',
		ProductName: 'Match™ Grade Full-Length Size Die 280 Ackley Imp (.284',
		UPC: '090255462289',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462286',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'caf29f10-9032-4a76-836d-8f456e662d4d',
		ProductID: '86934',
		ProductName: '450/400 Nitro Express 3 Unprimed Cases',
		UPC: '090255869347',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.145',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255869344',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.725',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '450-400 NITRO EXP 3"',
		Caliber: '400 CAL',
		BulletDiameter: '0.41',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-03-05 08:49:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '245a98e9-9b59-4169-ad24-b38e0613f759',
		ProductID: '8231',
		ProductName: '375 Ruger 270 gr SP-RP Dangerous Game™ Series',
		UPC: '090255382310',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.950',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382317',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.7',
		PalletQtyBoxes: '396',
		Retail: '123.91',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.38',
		MuzzleVelocity: '2840',
		MuzzleEnergy: '4835',
		SectionalDensity: '0.274',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '270',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--628G6xEp--/3376740f43ea2e3773cf3f88761ec1369d63ded3.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd73cefc9-6cfd-4e88-b338-f8e9ee42ca7a',
		ProductID: '81663',
		ProductName: '6mm Rem 95 gr SST® Superformance®',
		UPC: '090255816631',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.070',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255816638',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.7',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.355',
		MuzzleVelocity: '3235',
		MuzzleEnergy: '2207',
		SectionalDensity: '0.23',
		Cartridge: '6MM REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'SST®',
		BulletWeightGrain: '95',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--x8ZiQSa4--/53f817240e19c0efbd9ac09145043c75e904d1fd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:20',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6950fe35-5f6b-4232-8646-58841d93ccbe',
		ProductID: '6088',
		ProductName: '50 Cal .480 Lead Balls',
		UPC: '090255260885',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.536',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255260882',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '38.04',
		PalletQtyBoxes: '540',
		Retail: '22.91',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '50 CAL',
		BulletDiameter: '0.48',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '337a4510-b064-41a0-bd0f-900dd230fe2f',
		ProductID: '9126',
		ProductName: '10mm Auto 180 gr XTP®',
		UPC: '090255391268',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.898',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391265',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '8.98',
		PalletQtyBoxes: '1120',
		Retail: '35.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.164',
		MuzzleVelocity: '1275',
		MuzzleEnergy: '650',
		SectionalDensity: '0.161',
		Cartridge: '10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--JhKLuqIB--/57ce11e2e1312f2253f0066d888931606de83b41.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2bb55105-31a3-40d1-8477-265073d43fc4',
		ProductID: '99143',
		ProductName: 'Hornady® Buck Knife',
		UPC: '090255991437',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.211',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '80.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' Laser engraved Hornady logo. Black glass-filled nylon handle. Tumbled. 420HC Stainless Steel, drop point blade. Deep pocket clip',
		ProductImage: 'http://images.salsify.com/image/upload/s--Bu9ygGAq--/rdt8vy2fepk2jukuxrad.png',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e4efd39a-f5e9-4617-86aa-e75b02df37bc',
		ProductID: '80526',
		ProductName: '270 Win 120 gr SST®  Custom Lite®',
		UPC: '090255805260',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.120',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805267',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.2',
		PalletQtyBoxes: '1400',
		Retail: '39.97',
		ParentCategory: 'Ammunition',
		Applications: 'AppMediumGame',
		G1BC: '0.4',
		SectionalDensity: '0.223',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'SST®',
		BulletWeightGrain: '120',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Custom Lite® ammunition provides reduced recoil and muzzle blast from the most popular calibers, and puts the fun back into shooting for kids, women, and every shooter looking to keep recoil to a minimum while still enjoying the use of their favorite rifle.  Loaded with Hornady® SST® bullets, Custom Lite® ammunition is designed to deliver less felt recoil and a modified trajectory that still provides the accurate, deadly, and dependable performance you rely on from Hornady®. Putting the fun back into shooting! REDUCED RECOIL By using slightly lighter bullets and modified propellants, shooters will achieve significant recoil reduction over standard loads.  PROVEN BULLETS Loaded with SST® bullets, Custom Lite® ammunition delivers flat trajectories and hard-hitting performance.  CONSISTENT COMPONENTS Like all Hornady® ammunition, we match powders to each load for optimum pressure, velocity and consistency. High quality cases and primers contribute to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6oVKOBUf--/1c348e96fb23e1beecff7a7ab10ef45c36ca77fe.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--MXKsevLW--/3c0da909c65d888db5048edecc09281f3801b7c5.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--IedbEBai--/cg0qkaxwzqakis570swr.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rU_sQxe2--/jftbvatdsf6czstqk9mn.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Sli1o3qn--/cc6ihett8589l4lhvhjw.jpg',
		Videos: 'https://vimeo.com/96125085',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '95926041-043c-4cfe-9918-75c929a3cf1b',
		ProductID: '86833',
		ProductName: '338 Norma Magnum Unprimed Cases',
		UPC: '090255868333',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '1.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255868330',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '5.0',
		PalletQtyBoxes: '400',
		Retail: '60.93',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '338 NORMA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:56:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1cd9b2d1-4504-4126-815d-61a83521aff1',
		ProductID: '594306',
		ProductName: 'Match™ Grade Bushing .306',
		UPC: '090255593068',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593065',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '30 CAL',
		BulletDiameter: '0.306',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ea_UB_jd--/acba36a3f6d419cb878a18f69fb341df7ec24bc7.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bbf6a5bf-ffed-491b-b1bf-2213b9df69b5',
		ProductID: '050126',
		ProductName: 'Lock-N-Load®Powder Measure High Capacity Metering Kit',
		UPC: '090255501261',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.875',
		ShelfWidth: '15',
		ShelfDepth: '4.25',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255501268',
		CartonHeight: '2.875',
		CartonWidth: '15.000',
		CartonDepth: '4.250',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '132.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '50 BMG & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The kit’s two metering units have capacities of 80 to 180 grains and 165 to 265 grains of powder, and come with the clear drop tube and large hopper tube. The clear drop tube visually ensures a complete powder drop and the extended hopper tube allows you to reload more rounds between refills of powder. Fits Hornady® Lock-N-Load® Powder Measure.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6TTn3FgS--/efa11dcf8baec47eab1fd3ce468138b7b1b06589.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0390a29c-2630-4d19-aedc-43c7c7ec36d9',
		ProductID: '97436',
		ProductName: 'RAPiD® Safe Keypad Vault',
		UPC: '090255974362',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.375',
		ShelfWidth: '15',
		ShelfDepth: '12.25',
		Weight: '14.600',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10090255974369',
		CartonHeight: '13.375',
		CartonWidth: '15.500',
		CartonDepth: '11.500',
		CartonWeight: '29.2',
		PalletQtyBoxes: '108',
		Retail: '151.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '3.9',
		ProductExtWidth: '13.1',
		ProductExtDepth: '11',
		ProductWeight: '15',
		ProductIntHeight: '3.3',
		ProductIntWidth: '10.6',
		ProductIntDepth: '7.8',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Improved keypad eases code programming for maximum security while the durable 16-gauge steel housing wards off pry attempts. Interior light makes identifying valuables a breeze. Programmable 4 to 6 digit keypad code ensures optimum security for handguns and valuables. Durable 16-gauge steel housing wards off pry attempts. Interior light makes locating valuables a breeze. Premium foam interior cradles and protects valuable contents. California Department of Justice approved. Two barrel keys provide backup entry method. Requires four AA batteries (not included). Pre-drilled for easy mounting. Audible and visible systems indicate low battery level. Fits 1911 size pistols and 4-inch revolvers.[1]  Exterior Dimensions: 12" x 8.3" x 2.6" Interior Dimensions: 11.5” x 6.0” x 2.4”',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--C9APR_0D--/oeizzzjmy8uxbpokuie6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--C9APR_0D--/oeizzzjmy8uxbpokuie6.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6APQpTuo--/lwqzgepkc0yslarreijb.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_bLX1sSu--/nrmbsyrvfbw8m7l8zyix.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--YsgIfYpQ--/vvsxaneqpyjfdm7hhdso.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ElywzD2a--/liv4gxcc1hbnbfrasoa2.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--QdMuzFkK--/jggvjelj2fiqy71iwnh6.jpg',
		Videos: 'https://vimeo.com/638830203',
		DateLastModified: '2023-12-16 09:09:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bd305634-323b-44bf-b746-957032dbeb75',
		ProductID: '044134',
		ProductName: 'Seater Die (.268) 6.5 Carcano',
		UPC: '090255000092',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255000099',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '707fded3-4cdd-4ca8-a2b1-76dc0d534b46',
		ProductID: '392613',
		ProductName: 'Shellplate #13 Lock-N-Load®AP™ & Projector',
		UPC: '090255926132',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.612',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926139',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '6.12',
		PalletQtyBoxes: '0',
		Retail: '53.33',
		ParentCategory: 'Reloading',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b43c1a3b-80b1-47d0-b2bb-6f95267095ce',
		ProductID: '28270',
		ProductName: '7mm .284 139 gr GMX®',
		UPC: '090255282702',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.078',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255282709',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '26.95',
		PalletQtyBoxes: '900',
		Retail: '50.72',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.246',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'GMX®',
		BulletWeightGrain: '139',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--5BjqhvpS--/6c51661537bfab1432a8955ca8d7b5aec0796b09.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23a99b12-c339-4410-8507-6f3a14f798ba',
		ProductID: '81542',
		ProductName: '22 ARC 62 gr. ELD-VT™ V-Match™',
		UPC: '090255815429',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.720',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255815426',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '7.2',
		PalletQtyBoxes: '1400',
		Retail: '39.41',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'V-Match™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppTargetMatch',
		G1BC: '.395',
		G7BC: '.199',
		MinTwist: '1-8"',
		SectionalDensity: '0.177',
		Cartridge: '22 ARC',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD-VT™',
		BulletWeightGrain: '62',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Whether you’re taking aim in competition or outwitting varmints, make V-Match™ your ammunition of choice. It combines exceptional aerodynamics with high-quality components for match-grade accuracy and violent expansion. V-MATCH™ Ammunition Innovation, precision and excitement!Elevate your shooting experience, shatter records, and make your mark like never before with Hornady® V-Match™ ammunition.    NEW ELD-VT™ BULLET Designed using state-of-the-art technology, this bullet boasts exceptional aerodynamics. It guarantees high velocity retention, minimal wind deflection, and reduced weight—resulting in ultra-flat trajectories and violent expansion. Whether you’re aiming for victory on the competition range or seeking to outwit varmints, this bullet’s design will provide the ultimate in precision and expansion. PREMIUM COMPONENTS Every round uses the highest quality components that are meticulously loaded to exacting specifications, resulting in match-grade accuracy that’s second to none. MODERN, CLEAN BURNING PROPELLANTS Carefully chosen for their consistency no matter the temperature, you can shoot with confidence, knowing that every trigger pull will be met with the same exceptional performance, whether you’re competing in the heat of summer or varmint hunting in the chill of winter.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--MJkiXUW7--/olot6xfawci1evuthfp6.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--IWDZg3OC--/mlycrxqdfm2kw5ywbskh.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--AW1BXxhA--/dklj7flicc64kq7wyfe9.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Ig8fUZrI--/o2zglbuxuty13tutbwxt.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--UKCqyswt--/mdnjryhr5n4afc7gg7xw.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--uzxbbZnD--/rwd4cybxkozc6hh4ab7w.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--AMyTTpCR--/casfhsn5lydjp9gx5jws.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--pdO7EdA4--/vzv8n4o9jafgqxureora.png',
		Videos: 'https://vimeo.com/876104327',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '76b7c649-24c3-48d2-aa1d-2446ea958c39',
		ProductID: '046246',
		ProductName: 'Match™ Grade Full-Length Size Die 300 Rem Ultra Mag (.308)',
		UPC: '090255462463',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462460',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '82.00',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Dies',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Match™ Grade Size Die accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin. This die come with a Hornady® Sure-Loc™ lock ring that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers. *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die. 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7e0ea783-85b4-4ab5-9841-6f478228cfb7',
		ProductID: '9919',
		ProductName: 'Hornady® Team Hornady® Range Bag',
		UPC: '090255299199',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '12.25',
		ShelfDepth: '25.5',
		Weight: '4.363',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255299196',
		CartonHeight: '16.000',
		CartonWidth: '14.500',
		CartonDepth: '25.500',
		CartonWeight: '43.63',
		PalletQtyBoxes: '200',
		Retail: '51.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This durable nylon range bag has large compartments for the range shooter or uniformed officer. With embroidered Team Hornady® logos, this range bag can carry a variety of accessories. Imported.',
		ProductImage: 'http://images.salsify.com/image/upload/s--hvs9-ZFm--/va0j18pk3h47oxpo1oha.png',
		DateLastModified: '2023-12-16 09:09:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4f53f48c-a267-442b-b128-720bc5f7440c',
		ProductID: '546327',
		ProductName: 'Full-Length 2-Die Set 7mm WSM (.284)',
		UPC: '090255563276',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.446',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563273',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.23',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '7MM WSM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9e8a7df2-b4dc-4508-8884-7900363a5340',
		ProductID: '8152',
		ProductName: '6.5 Grendel 123 gr SST®',
		UPC: '090255381528',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381525',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1400',
		Retail: '44.24',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.51',
		MuzzleVelocity: '2580',
		MuzzleEnergy: '1818',
		SectionalDensity: '0.252',
		Cartridge: '6.5 GRENDEL',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '123',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--qDFcrwyo--/f0187031d8580c6844c917067bbe2f31cb6152c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3PTtMxBb--/ffe6e851a081b7ac2f25772b2bb5ccb28f51a977.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dfe09a92-3397-4e2b-9eee-34e8a2606de9',
		ProductID: '546274',
		ProductName: 'Full-Length 2-Die Set 257 Roberts (.257)',
		UPC: '090255562743',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.463',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562740',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.315',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '257 ROBERTS',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'caed6040-8cd7-4109-b0b5-7f8e02c6221a',
		ProductID: '86424',
		ProductName: '28 Nosler Unprimed Cases',
		UPC: '090255864243',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4',
		ShelfDepth: '6.375',
		Weight: '0.970',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255864240',
		CartonHeight: '4.625',
		CartonWidth: '4.562',
		CartonDepth: '14.125',
		CartonWeight: '4.85',
		PalletQtyBoxes: '400',
		Retail: '76.33',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '28 NOSLER',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2024-02-29 08:49:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c2437d5-715a-453d-8ef7-cce38e337e63',
		ProductID: '390612',
		ProductName: 'Shell Holder #57',
		UPC: '090255906127',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '1.875',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906124',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Cartridge: '30 SUPER CARRY',
		Caliber: '32 CAL',
		BulletDiameter: '0.3115',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion. A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '734e00d3-9683-4376-83dd-fd647dc64212',
		ProductID: '81153',
		ProductName: '30-06 Springfield 165 gr SST® Superformance®',
		UPC: '090255811537',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.303',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811534',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.03',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3210',
		SectionalDensity: '0.248',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--P9GOzur8--/b07a350a42d4d867929ab24e9eea46bae86afa1c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2f6bf085-987f-4c63-9de8-42670b8eb9a4',
		ProductID: '95796',
		ProductName: 'Square-Lok™ Multi-Pistol Peg Rack',
		UPC: '090255957969',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0',
		ShelfWidth: '0',
		ShelfDepth: '0',
		Weight: '0.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957966',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '23.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '30',
		MasterPackUCC: '30090255957960',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductImage: 'http://images.salsify.com/image/upload/s--zeGVuPF2--/itjvpouw86kkoeof1jig.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b711e784-b503-44b7-9a48-b4382c57c201',
		ProductID: '9989',
		ProductName: 'One Shot® Case Sizing Wax',
		UPC: '090255299892',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '3',
		ShelfDepth: '3',
		Weight: '0.210',
		WeightUOM: 'LB',
		CaseQty: '54',
		CartonUCC: '10090255299899',
		CartonHeight: '6.500',
		CartonWidth: '9.500',
		CartonDepth: '9.500',
		CartonWeight: '11.34',
		PalletQtyBoxes: '0',
		Retail: '14.37',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lubes, Cleaners & Polishes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Simply dab on your index finger and thumb, then apply to cartridge case before sizing. Wax based lube Superior high pressure lubricant Built in tarnish inhibitors Wipes off easily Leaves no sticky residue Far less likely to leave “high spots” on the case as it “self-levels” and limits case denting.',
		ProductImage: 'http://images.salsify.com/image/upload/s--juVz3dS_--/fbyirgqdbp419ux3qty0.jpg',
		DateLastModified: '2024-02-22 09:32:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '67b2b22f-1a97-4baa-a6ec-1434698a0b5d',
		ProductID: '75402',
		ProductName: 'Snapsafe® Under Bed Safe Medium',
		UPC: '842631100199',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '31',
		ShelfDepth: '25',
		Weight: '56.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '10.000',
		CartonWidth: '31.000',
		CartonDepth: '25.000',
		CartonWeight: '56.0',
		PalletQtyBoxes: '14',
		Retail: '478.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Auxiliary Safes',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '5',
		ProductExtWidth: '26',
		ProductExtDepth: '20',
		ProductWeight: '55',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Store valuable belongings out of sight while maintaining easy access with the SnapSafe® Under Bed Safe. Available in three sizes!  Slide-out drawer accommodates firearms, jewelry, documents, and more. Digital lock with key backup can be programmed with 3 to 8 digit access code. Pry-resistant door keeps children and unauthorized users from gaining access. Constructed of 14-gauge heavy-duty steel, with pre-drilled holes for permanent installation. Robust 5-foot cable provides added security when anchored to a stationary object. The medium-sized Under Bed Safe features a discreet and durable tempered glass keypad.  26"W x 5"H x 20" D',
		ProductImage: 'http://images.salsify.com/image/upload/s--KQy2EQ4w--/gk5ectzxgoejkuxzkt1e.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--42VYyK3L--/hp1k0edxby1sjjq6hhtx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--X_K5KHW9--/lly0c670kc7isfwf3jdd.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--7sjYCgzN--/bnqya21smmzmqjw5wdyn.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--OwUdZdvb--/pjbbyu2p99lxt0rfvgx4.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--yrEYXQT0--/kuvfm2q2m3tea7kd2cxf.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--KHXTnv17--/bvrd3pzqdyvzg1ujxh1i.jpg',
		Videos: 'https://vimeo.com/266771633',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1ebdb325-6d45-4491-9dd4-0f965dd47773',
		ProductID: 'C338L',
		ProductName: 'Lock-N-Load® 338 Lapua Modified Case',
		UPC: '090255705171',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.055',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705178',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.55',
		PalletQtyBoxes: '0',
		Retail: '18.07',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '338 LAPUA MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '560dbec8-fa6d-4679-8a9b-1231665ee808',
		ProductID: '98008',
		ProductName: 'Hornady® Superformance® Sticker',
		UPC: '090255980080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '4.25',
		ShelfDepth: '5.5',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '100',
		CartonUCC: '10090255980087',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '1.0',
		PalletQtyBoxes: '180000',
		Retail: '4.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'Black and red. Measures 3"x5.125"',
		ProductImage: 'http://images.salsify.com/image/upload/s--Xbp4UxBf--/bqao5ug9qgrrjd8q0f6w.png',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7c3edae0-8d05-4b19-8609-e28c23a5c9ae',
		ProductID: '85834',
		ProductName: '458 Win 500 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255858341',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.558',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255858348',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.348',
		PalletQtyBoxes: '396',
		Retail: '204.51',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2140',
		MuzzleEnergy: '5084',
		SectionalDensity: '0.341',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xr_oNx3Q--/73fcc05b377a7a59932f3a973332a32a7ee12fc9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ebecac72-51be-4395-9ffd-0e53b59b83bf',
		ProductID: '80463',
		ProductName: '243 Win 95 gr SST® Superformance®',
		UPC: '090255804638',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.024',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255804635',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '10.24',
		PalletQtyBoxes: '1400',
		Retail: '53.05',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.355',
		MuzzleVelocity: '3185',
		MuzzleEnergy: '2140',
		SectionalDensity: '0.23',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'SST®',
		BulletWeightGrain: '95',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xuVbwMC6--/57cdae559c764089aac61216b7dcc58de2cfd85b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '95dc8244-3d67-48f5-afdf-443fde409187',
		ProductID: 'A22A',
		ProductName: 'Lock-N-Load® 22 ARC Modified Case',
		UPC: '090255723311',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255723318',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '22 ARC',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iH8TFAYx--/4f20cfc32fcfe9f210924f14cf411d272fb79b69.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 09:09:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '59f762c6-33da-45ee-89ef-2685a0d6eaea',
		ProductID: '86280',
		ProductName: '6mm Creedmoor Unprimed Cases',
		UPC: '090255862805',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.250',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255862802',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.25',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '6MM ARC',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f1403b9e-d582-4f2e-b344-f19ac483dca4',
		ProductID: '80966',
		ProductName: '308 Win 168 gr ELD® Match',
		UPC: '090255809664',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.280',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809661',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.8',
		PalletQtyBoxes: '1400',
		Retail: '57.72',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.523',
		G7BC: '0.263',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2719',
		SectionalDensity: '0.253',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '168',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oW35wSYE--/982e3ab81c699619de71859902b3ff045d42436a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3d19f246-f283-4210-b8ac-c80a409ab06f',
		ProductID: '095320',
		ProductName: 'Lock-N-Load® AP™ Pistol Bullet Feeder 110 Vt',
		UPC: '090255953206',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '12',
		ShelfDepth: '21',
		Weight: '14.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '10.000',
		CartonWidth: '12.000',
		CartonDepth: '21.000',
		CartonWeight: '14.0',
		PalletQtyBoxes: '40',
		Retail: '526.73',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Lock-N-Load® Pistol Bullet Feeder is designed for the Lock-N-Load® AP™, but can be used with any other press using 7/8"–14 die threads, and requires an open station. Coupled with the Lock-N-Load® Case Feeder (sold separately), you’ll realize dramatic increases in efficiency and reloading speed. (Up to 50% faster!)  The easy-feed bullet hopper holds up to 200 pistol bullets and features an adjustable center plate and bullet feed wipers to ensure smooth feeding.',
		ProductImage: 'http://images.salsify.com/image/upload/s--s07xaTsR--/ibkciyriavzn9ihdqqaj.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LdyNENSD--/te2mzzw4dul0clxr8atr.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KbOBTmuB--/jdjspqm35kf8yrsnddby.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'da78f2f3-a0a2-46a6-9f6a-c6ba830b5d9d',
		ProductID: '044157',
		ProductName: 'Seater Die (.308) 30/378 Wby',
		UPC: '090255441574',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441571',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bb61f320-417d-4b1b-9ca0-70b905886db8',
		ProductID: '8675',
		ProductName: '303 British Unprimed Cases',
		UPC: '090255486759',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.388',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486756',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '6.94',
		PalletQtyBoxes: '400',
		Retail: '64.77',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '303 BRITISH',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ecd3eff-3345-475f-ac75-daceefb964ee',
		ProductID: 'A224',
		ProductName: 'Lock-N-Load® 224 Valkyrie Modified Case',
		UPC: '090255714098',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255714095',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '224 VALKYRIE',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--3pTdhMQU--/0ec5d94fccbd6d4bb77e13d4bed64f9ce85bad0c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '31e6af85-9282-4a78-82a4-01257f71b604',
		ProductID: '45204',
		ProductName: '45 Cal .452 245 gr InterLock',
		UPC: '090255452044',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '1.890',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255452041',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.35',
		PalletQtyBoxes: '540',
		Retail: '48.07',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.165',
		SectionalDensity: '0.171',
		OAL: '0.84',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '245',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Mp4dDxdQ--/ydlcba1nxlcthdromskb.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 09:02:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e74c361e-3b09-4d3a-b143-2a85d8305e1f',
		ProductID: '91340',
		ProductName: '40 S&W 165 gr FTX® Critical Defense®',
		UPC: '090255913408',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.799',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913405',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '7.99',
		PalletQtyBoxes: '1120',
		Retail: '40.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '0.145',
		MuzzleVelocity: '1045',
		MuzzleEnergy: '400',
		SectionalDensity: '0.147',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'FTX®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'When lives are on the line, only the best will do. The best ammunition for personal defense just got better with the addition of Critical Defense® Rifle. Critical Defense® is engineered to deliver the pinnacle of threat-stopping power.  The FTX® — at the forefront of Critical Defense® — maximizes the potential of a hollow point bullet. Its patented Flex Tip® aids expansion and eliminates clogging when passing through clothing. Nickel-plated cases increase visibility in low light situations. Low-flash propellants won’t disrupt night vision and deliver consistent performance, every time.  FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms or self defense rifles. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Vx9Ym8_G--/59cbbeffa1df4b8b5c0d22cfb9bbd2a540fcb64c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--drp1zPz1--/loiwmyn62gusjlu9iyzr.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--rFOo_b9r--/qn5hoiyifoowcxsintxq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ukH_8V1R--/tf5vhamcz7ocps4qevlc.jpg',
		Videos: 'https://vimeo.com/347110177',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa91f11f-0220-428a-a9bb-cd65a1ed89a7',
		ProductID: '8116',
		ProductName: '30-06 Springfield 165 gr GMX® Superformance®',
		UPC: '090255381160',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.315',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255381167',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.15',
		PalletQtyBoxes: '1400',
		Retail: '64.39',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.447',
		SectionalDensity: '0.248',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '165',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RCnJkBtX--/3dad083f94b4ea528756bfc21a6cdc28730231d4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3bd9837f-da7e-4e37-b4b4-c3da83c3a856',
		ProductID: 'FR2815',
		ProductName: '5.56 NATO 62 Gr Spire Point (150 - Oriented)',
		UPC: '090255712971',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '2.25',
		ShelfWidth: '3.75',
		ShelfDepth: '5',
		Weight: '4.090',
		WeightUOM: 'LB',
		CaseQty: '8',
		CartonUCC: '10090255712978',
		CartonHeight: '4.437',
		CartonWidth: '10.000',
		CartonDepth: '11.250',
		CartonWeight: '32.72',
		PalletQtyBoxes: '512',
		Retail: '100.13',
		ParentCategory: 'Ammunition',
		G1BC: '0.264',
		SectionalDensity: '0.177',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTSP',
		BulletWeightGrain: '62',
		Obsolete: 'Obsolete',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WIIWJMc6--/8e430508ef88d148b26b925f501cc095c18e19b9.jpg',
		DateLastModified: '2023-12-16 08:55:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ab6945ba-ae29-460c-8457-33b40f3782c5',
		ProductID: '10508',
		ProductName: '38 Cal .358 158 gr LRN',
		UPC: '090255105087',
		PackagedQTY: '300',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '7.104',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255105084',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '42.624',
		PalletQtyBoxes: '216',
		Retail: '54.99',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Frontier® Lead Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.159',
		SectionalDensity: '0.176',
		Caliber: '38 CAL',
		BulletDiameter: '0.358',
		BulletName: 'LRN',
		BulletWeightGrain: '158',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Traditional swaged lead bullets Hornady® lead pistol bullets are pre-lubricated and cold-swaged for total uniformity and balance. Our exclusive knurling system retains lubricant over the entire bearing surface to reduce leading in your barrel.  For cowboy shooters, authenticity is a strict requirement. That's why we build our Cowboy™ bullets to SASS (Single Action Shooting Society) specifications while holding them to the same stringent production standards as all our products. CLASSIC & CONVENTIONAL DESIGN Traditional conical and flat designs have perfect symmetry when combined with knurling at the base of the bullet, which deliver increased stability and accuracy. This ensures proper positioning in authentic revolvers, with no unwanted nicking of primers as the cylinder turns.  SPECIAL KNURLING AND GREASE RING The knurling system holds an even distribution of lubricating wax over the bearing surface of the Cowboy™ bullet, resulting in less leading.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--J4g4V_5j--/6bf4154a090470613e11006268b72ca4df225c57.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gHQ5tr0c--/5b3fd414d7fbbf4f15c465f62421ae1ac47b96f9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--GcOF-Eht--/vq7dg6jkxcredhrvnl5d.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--fW8aNOpq--/evg87wwfoxwmwlujq31c.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e91c8979-ba3c-4029-aa33-2157c0a76723',
		ProductID: '814874',
		ProductName: '6.5 Creedmoor 120 gr. CX™ Outfitter®',
		UPC: '090255719789',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.100',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719786',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.0',
		PalletQtyBoxes: '1400',
		Retail: '58.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.428',
		MuzzleVelocity: '2925',
		MuzzleEnergy: '2280',
		SectionalDensity: '0.246',
		Cartridge: '6.5 CREEDMOOR',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'CX™',
		BulletWeightGrain: '120',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--xD_74O5e--/mst6ffstrhmibm80rdf2.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f73ec029-a99c-4fa6-973f-a5853bfff594',
		ProductID: '594364',
		ProductName: 'Match™ Grade Bushing .364',
		UPC: '090255593648',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593645',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.364',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--durqU2U0--/7f1bfade3126a2ad4ade7a1c410c82b943f846b1.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6497c6b5-acd3-4d25-8de5-10a2905e0f76',
		ProductID: 'A338M',
		ProductName: 'Lock-N-Load® 338 Marlin Exp Modified Case',
		UPC: '090255704914',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.032',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704911',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.32',
		PalletQtyBoxes: '0',
		Retail: '6.65',
		ParentCategory: 'Reloading',
		Cartridge: '338 MARLIN EXP',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--shmWybOL--/46dfdb5491a4c406790eb2ee1f77adddd251abf0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '23d9446c-cca2-40c6-bb29-e1bbef376d7b',
		ProductID: '486300',
		ProductName: 'Full-Length 2-Die Set 270 Win .277 American Series',
		UPC: '090255483000',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '8.83',
		ShelfWidth: '6.5',
		ShelfDepth: '2.5',
		Weight: '1.270',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255483007',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '12.7',
		PalletQtyBoxes: '0',
		Retail: '38.88',
		ParentCategory: 'Reloading',
		Cartridge: '270 WIN',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Great Dies. Great Value.  Perfect for the handloader looking to maximize the efficiency of their reloads, American Series™ die sets deliver excellent reloading performance at an economical price.  Die bodies are precision reamed from premium steel that is hardened to exacting specifications, then polished to a smooth finish that will endure the rigors of countless reloading sessions. Each die set includes a FREE shell holder. Internal spindles, expanders and seating stems are interchangeable with other brands on the market. All Hornady reloading tools and accessories are warranted against material defects and workmanship for the life of the product.  Basic Reloading Data and extra decapping pins are included with each die set.',
		ProductImage: 'http://images.salsify.com/image/upload/s--9vcvkJsn--/jy5kiuq00qlarhqplmq6.png',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a63f4852-162c-4839-90e5-b98548f8f03e',
		ProductID: '2735',
		ProductName: '270 Cal .277 140 gr InterLock® BTSP',
		UPC: '090255227352',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.108',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227359',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.7',
		PalletQtyBoxes: '900',
		Retail: '47.40',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.261',
		OAL: '1.22',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'BTSP INTERLOCK®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--xb5IGdLh--/c75671a0a9a610a5fbef5107f066ee9c42d55298.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8eb0cfd2-44bb-49f8-91e6-53b38a6e923b',
		ProductID: '82236',
		ProductName: '338 RCM 225 gr SST® Superformance®',
		UPC: '090255822366',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.660',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822363',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '16.6',
		PalletQtyBoxes: '930',
		Retail: '74.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.515',
		MuzzleVelocity: '2750',
		MuzzleEnergy: '3778',
		SectionalDensity: '0.281',
		Cartridge: '338 RCM',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SST®',
		BulletWeightGrain: '225',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--YzeuJunN--/aaa646ec0d1260ed3cccad7026d7e7a5af3c7164.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '54fe9107-197d-4ed8-87b7-376c6095f7b7',
		ProductID: 'FR106',
		ProductName: '223 Remington 55 gr FMJ Frontier®',
		UPC: '090255711295',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '6.375',
		ShelfWidth: '12.375',
		ShelfDepth: '5.625',
		Weight: '26.050',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255711292',
		CartonHeight: '6.375',
		CartonWidth: '12.375',
		CartonDepth: '5.625',
		CartonWeight: '26.05',
		PalletQtyBoxes: '96',
		Retail: '787.51',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE CARTON',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oOMLzdpQ--/96469f14901ef7419af754f362ce1400b72abc80.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dc676134-ed8f-4d1d-9829-9330fc1ce42b',
		ProductID: '586051',
		ProductName: 'Basic Powder Funnel',
		UPC: '090255860511',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.500',
		ShelfWidth: '3.000',
		ShelfDepth: '2.250',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255860518',
		CartonHeight: '8.000',
		CartonWidth: '6.000',
		CartonDepth: '4.000',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '5.39',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		MasterPackQty: '80',
		MasterPackUCC: '30090255860512',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '4.0',
		ProductDescription:
			"Anti-static funnel fits all calibers between 22 and 45. Squared rim design won't roll off the table.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--3wByJrqE--/yk6feinbxd0wruwdb4ui.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--3wByJrqE--/yk6feinbxd0wruwdb4ui.jpg',
		Videos: 'https://vimeo.com/593466907',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e912518-ea15-439b-bbe8-5aa330af059e',
		ProductID: '2279C',
		ProductName: '22 Cal .224 75 gr BTHP Match  with cannelure',
		UPC: '090255693423',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '8.5',
		ShelfDepth: '11.5',
		Weight: '43.987',
		WeightUOM: 'LB',
		CaseQty: '4000',
		CartonUCC: '10090255693420',
		CartonHeight: '3.250',
		CartonWidth: '8.500',
		CartonDepth: '11.500',
		CartonWeight: '175948.0',
		PalletQtyBoxes: '168000',
		Retail: '0.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Bulk Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.395',
		SectionalDensity: '0.214',
		OAL: '0.99',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '75',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--OFLdH0gG--/5b1036f0e961a1ac5b8ebc172e109d16a0b3a34a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7d80bbd3-28b9-48ff-9ab2-4d8574c4a5c5',
		ProductID: '546539',
		ProductName: 'Full-Length 3-Die Set 41 Mag/AE (.410)',
		UPC: '090255565393',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.654',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565390',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.27',
		PalletQtyBoxes: '0',
		Retail: '99.72',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Three-Die Handgun Die Sets',
		Cartridge: '41 AE/41 REM MAG',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3e82a1e6-e67d-40e9-bd26-84695519fa5a',
		ProductID: '085001',
		ProductName: 'Lock-N-Load® Classic Press',
		UPC: '090255850017',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '18.875',
		ShelfDepth: '12.25',
		Weight: '13.150',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '6.500',
		CartonWidth: '18.875',
		CartonDepth: '12.250',
		CartonWeight: '13.15',
		PalletQtyBoxes: '49',
		Retail: '209.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Precision and ease make the Classic Press a winner. A single stage press is perfect for both beginners and those who want complete control over the entire process. The Lock-N-Load Classic delivers both dependability and precision with its uniquely angled, solid cast frame that offers greater visibility and easier access to the cartridge. Designed to assure perfect die and shell holder alignment, its Lock-N-Load quick change bushing system also makes the process quick and easy. LOCK-N-LOAD® QUICK CHANGE BUSHING SYSTEM Lock-N-Load® bushings not only let you switch from one die to another in a matter of seconds, they also offer the quickest and easiest die setup on the market. Just set the die and tighten the Sure-Loc™ ring on to the Lock-N-Load® bushing. Quickly remove and re-install without the need to readjust the die or keep a separate seater die for each of your pet loads.  POWER-PAC LINKAGE AND SOLID STEEL ARMS Arms rotate on steel pins that run completely through the cast frame. The Power-Pac linkage design multiplies the leverage you apply to the handle, making it easier to size cases and reduces user fatigue.  POSITIVE PRIMING SYSTEM™ (PPS) Once the spent primer ejects at the top of the stroke, you can add a new primer to the PPS and it self-aligns to feed and insert the primer at the bottom of the stroke where leverage is best. Our self-aligning primer arm also allows for easy manual inserting of primers without having to raise the handle. All the work is done at the bottom of the stroke. Works easier than ram prime units and much better than old style primer arms. Small and large punch included.  STRONG ANGLED FRAME This high strength alloy frame offers the rigidity and stability needed for precision reloading, and is guaranteed never to break or fail. The frame's unique angle gives the reloader greater visibility and easier access to the cartridge in the press.  EASY GRIP HANDLE Large, ball-style grip reduces fatigue. The long handle increases leverage and reduces effort.",
		ProductImage: 'http://images.salsify.com/image/upload/s--2ge0zOrv--/luktnhbkcf0awzxejydf.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ThzEPw6X--/krsz6vxju0cjtev7nluz.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6eoFzjYl--/hxj0yohvyj1q3telx4vr.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--WU1Ztdgo--/qtkpy0nqox91k0ffvtsk.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--MVz5M_3D--/eu8ork4hhzzw1jdy2zgp.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--r0K6wY_g--/azzq01nhbgqataa3dfl1.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9ac99963-c1a6-4259-a6fe-3d037bdd8f4c',
		ProductID: 'B358',
		ProductName: 'Lock-N-Load® 358 Win Modified Case',
		UPC: '090255703337',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255703334',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '358 WIN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6c4a2c39-7ca0-41fb-bd9b-9c7e540b052d',
		ProductID: '2841',
		ProductName: '7mm .284 175 gr ELD-X®',
		UPC: '090255228410',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.618',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255228417',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '39.27',
		PalletQtyBoxes: '540',
		Retail: '63.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.689',
		G7BC: '0.347',
		MinTwist: '1-8.5"',
		SectionalDensity: '0.31',
		OAL: '1.575',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '175',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--GpFh58J9--/20b543ea49e307cdf8abbf5f2b7daabb789f704c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0c0310d-a77e-40e5-893e-c517c0f96881',
		ProductID: '546260',
		ProductName: 'Full-Length 2-Die Set 25 Rem (.257)',
		UPC: '090255562606',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562603',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '25 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c1f229e-4568-41e8-9129-e5ebfc689c4e',
		ProductID: '392645',
		ProductName: 'Shell Plate #45 Lock-N-Load®AP™ & Projector',
		UPC: '090255926453',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.539',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926450',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.39',
		PalletQtyBoxes: '0',
		Retail: '57.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:19',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1c2797d5-e283-4aa3-8d74-68f5a71e1a6c',
		ProductID: '380718',
		ProductName: 'Cartridge Gauge 300 Win Mag (.308)',
		UPC: '090255807189',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807186',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '4.0',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a5817611-0d5f-4c7b-a2d0-b9855d584ebe',
		ProductID: '085010',
		ProductName: 'Lock-N-Load® Classic Deluxe Kit',
		UPC: '090255850109',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '13.5',
		ShelfWidth: '11.25',
		ShelfDepth: '18',
		Weight: '29.400',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '13.500',
		CartonWidth: '11.250',
		CartonDepth: '18.000',
		CartonWeight: '29.4',
		PalletQtyBoxes: '20',
		Retail: '682.94',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Precision and ease make the Classic Press a winner. A single stage press is perfect for both beginners and those who want complete control over the entire process. The Lock-N-Load Classic delivers both dependability and precision with its uniquely angled, solid cast frame that offers greater visibility and easier access to the cartridge. Designed to assure perfect die and shell holder alignment, its Lock-N-Load quick change bushing system also makes the process quick and easy. LOCK-N-LOAD® QUICK CHANGE BUSHING SYSTEM Lock-N-Load® bushings not only let you switch from one die to another in a matter of seconds, they also offer the quickest and easiest die setup on the market. Just set the die and tighten the Sure-Loc™ ring on to the Lock-N-Load® bushing. Quickly remove and re-install without the need to readjust the die or keep a separate seater die for each of your pet loads.  POWER-PAC LINKAGE AND SOLID STEEL ARMS Arms rotate on steel pins that run completely through the cast frame. The Power-Pac linkage design multiplies the leverage you apply to the handle, making it easier to size cases and reduces user fatigue.  POSITIVE PRIMING SYSTEM™ (PPS) Once the spent primer ejects at the top of the stroke, you can add a new primer to the PPS and it self-aligns to feed and insert the primer at the bottom of the stroke where leverage is best. Our self-aligning primer arm also allows for easy manual inserting of primers without having to raise the handle. All the work is done at the bottom of the stroke. Works easier than ram prime units and much better than old style primer arms. Small and large punch included.  STRONG ANGLED FRAME This high strength alloy frame offers the rigidity and stability needed for precision reloading, and is guaranteed never to break or fail. The frame's unique angle gives the reloader greater visibility and easier access to the cartridge in the press.  EASY GRIP HANDLE Large, ball-style grip reduces fatigue. The long handle increases leverage and reduces effort. Perfect for the reloading novice, this kit offers everything you need to get started. (Reloading dies and shell holders sold separately.)  Includes: Lock-N-Load® Classic™ Reloading Handbook Lock-N-Load® Powder Measure Digital Scale Lock-N-Load® Die Bushings (3) Primer Catcher Positive Priming™ System Handheld Priming Tool Universal Reloading Block Chamfer & Deburr Tool Powder Trickler Powder Funnel One Shot® Case Lube  In addition to everything you receive in the Classic® Kit (above), the Deluxe Classic™ Kit includes shell holders in the most popular sizes, bushings and Sure-Loc™ rings, as well as some other handy tools.  Also includes: Lock-N-Load® Straight OAL Gauge Pistol Rotor & Metering Assembly Powder Measure Stand Shellholders 1,2,5,16,35 Kinetic Bullet Puller Decorative Tin Sign Six Sure-Loc™ Lock Rings Steel Dial Caliper Three Additional Die Bushings",
		ProductImage: 'http://images.salsify.com/image/upload/s--28gsH2iK--/q03n2rxytvlhxqhjx4jt.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--2ge0zOrv--/luktnhbkcf0awzxejydf.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mHe9b3MA--/lnsg0yg47igcqndxszgk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--r0K6wY_g--/azzq01nhbgqataa3dfl1.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ThzEPw6X--/krsz6vxju0cjtev7nluz.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6eoFzjYl--/hxj0yohvyj1q3telx4vr.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0e89bfdb-7068-4bdc-998a-bd867b8f816a',
		ProductID: '86101',
		ProductName: '25-35 Winchester Unprimed Cases',
		UPC: '090255861013',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.080',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255861010',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '5.4',
		PalletQtyBoxes: '400',
		Retail: '67.39',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '25-35 WIN',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '82f02583-ee6d-4a8e-9dbb-6b381580b58c',
		ProductID: '546302',
		ProductName: 'Full-Length 2-Die Set 284 Win (.284)',
		UPC: '090255563023',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.463',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563020',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.315',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '284 WIN',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3826b842-d7f9-4145-8197-750b32226091',
		ProductID: '594267',
		ProductName: 'Match™ Grade Bushing .267',
		UPC: '090255592672',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592679',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.267',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--LJyF7AjE--/844b2ce8c1f01ece6fea04b92383210bf1cf042c.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3663cda9-2676-428b-b726-b3276a90ba76',
		ProductID: '32010',
		ProductName: '32 Cal .312 60 gr XTP®',
		UPC: '090255232011',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2',
		ShelfDepth: '2.25',
		Weight: '0.924',
		WeightUOM: 'LB',
		CaseQty: '50',
		CartonUCC: '10090255232018',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.2',
		PalletQtyBoxes: '1800',
		Retail: '26.00',
		ParentCategory: 'Bullets',
		Applications: 'AppPersonalDefense',
		G1BC: '0.09',
		SectionalDensity: '0.089',
		Caliber: '32 CAL',
		BulletDiameter: '0.311',
		BulletName: 'XTP®',
		BulletWeightGrain: '60',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--p0IZ9zE6--/770026321671208ce70b4ab0847821d8afdec418.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 08:58:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d48a67f-10ea-4519-a6ba-df321c8453e2',
		ProductID: '99142',
		ProductName: 'Hornady® Bullet Guide Counter Mat',
		UPC: '090255991420',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.000',
		ShelfWidth: '35.000',
		ShelfDepth: '0.250',
		Weight: '1.500',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255991427',
		CartonHeight: '3.940',
		CartonWidth: '15.160',
		CartonDepth: '36.220',
		CartonWeight: '37.5',
		PalletQtyBoxes: '500',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--T40i60Pt--/nzxukdejke59zc2ravja.jpg',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b69b2ec-22c4-410b-82fc-7d17f918b755',
		ProductID: '80933',
		ProductName: '308 Win 150 gr SST® Superformance®',
		UPC: '090255809336',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.199',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809333',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.99',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '2997',
		SectionalDensity: '0.226',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Esh2_GnG--/bdb9e1f8296fdeba52c0311f99a89aa48519760b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c2c80426-0fea-4825-b1dc-8e432773d6ec',
		ProductID: '90244',
		ProductName: '9mm Luger 115 gr XTP® American Gunner®',
		UPC: '090255902440',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.25',
		ShelfWidth: '2.5',
		ShelfDepth: '2.5',
		Weight: '0.720',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255902447',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '7.2',
		PalletQtyBoxes: '1120',
		Retail: '29.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.129',
		MuzzleVelocity: '1155',
		MuzzleEnergy: '341',
		SectionalDensity: '0.13',
		Cartridge: '9MM LUGER',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'XTP®',
		BulletWeightGrain: '115',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Life. Liberty. Hornady.® The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs.  Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. Hornady® introduces new rifle calibers to complement the handgun offerings currently available. These rifle options are loaded with match grade hollow point bullets for a broad range of use including self-defense, target shooting, and varmint/small game hunting. HORNADY® BULLETS XTP® (eXtreme Terminal Performance), HP and BTHP bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. VERSATILE AND FUN Designed to offer an all-around fun shooting experience that's affordable, American Gunner® is loaded in the most popular handgun and rifle calibers. QUALITY BRASS, PRIMERS AND PROPELLANT Like all Hornady® ammunition, our American Gunner® ammunition uses the highest quality cases and primers available. Loaded to conventional velocities, American Gunner® functions in any gun. Consistent components translate to consistent shooting in the field. Hornady® XTP® hollow point bullets are exceptionally accurate and deliver excellent versatility and superior ballistic performance. Propellants are matched to each load to ensure optimal pressure, velocity, volume and consistency from lot to lot. Like all Hornady® ammunition, American Gunner® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--kye3Tb_i--/2f2b2d6796cc49d0956e8c874838d75ad9c59d4d.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--IBHll9Hk--/0b2ac6806d083ee9d4b7b4fde1677a05df2db858.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--kl-5beeE--/voqenluor7weinuv6tap.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3P5kTUaC--/wd1nfkvcjci9of2p1mib.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NcptZv2m--/o4pycqh0rkykh2ksjxqa.png',
		DateLastModified: '2023-12-16 09:09:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3b3285d3-0d78-48e0-a732-c83d1859a4f0',
		ProductID: '8631',
		ProductName: '257 Weatherby Magnum Unprimed Cases',
		UPC: '090255486315',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.894',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486312',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.47',
		PalletQtyBoxes: '200',
		Retail: '89.71',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '257 WBY MAG',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '49b652e7-e296-4cdc-bc29-faeac78af111',
		ProductID: '546358',
		ProductName: 'Full-Length 2-Die Set 308 Win (.308)',
		UPC: '090255563580',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.480',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563587',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.4',
		PalletQtyBoxes: '0',
		Retail: '65.79',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series I Two-Die Rifle Die Sets',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '49241b0c-802a-4e9b-b3f9-1214a73a7784',
		ProductID: '82314',
		ProductName: '9.3X74R 300 gr DGS®',
		UPC: '090255823141',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '1.858',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823148',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '11.148',
		PalletQtyBoxes: '396',
		Retail: '109.15',
		ParentCategory: 'Ammunition',
		Applications: 'AppDangerousGame',
		G1BC: '0.28',
		SectionalDensity: '0.32',
		Cartridge: '9.3X74R',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		BulletName: 'DGS®',
		BulletWeightGrain: '300',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--H2kZtxEO--/34ca00298aca689544b8687f245dfc64c544a70c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '64308de3-54b2-4a11-b90d-75698aa010d4',
		ProductID: 'B223',
		ProductName: 'Lock-N-Load® 223 WSSM Modified Case',
		UPC: '090255704877',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.034',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704874',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.34',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '223 WSSM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--oEcKST4P--/027ff5d98fee92f75afb4da3a3683de0b5af9f25.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '85d4f77c-fe0c-4290-ba87-e7b94996c3a7',
		ProductID: 'B6MMG',
		ProductName: 'Lock-N-Load® 6mm GT Modified Case',
		UPC: '090255722284',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255722281',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '6MM GT',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iH8TFAYx--/4f20cfc32fcfe9f210924f14cf411d272fb79b69.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 09:09:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '03bea1c2-9bea-4cca-8f7a-f0406a9c03d3',
		ProductID: '085520',
		ProductName: 'Iron Press®Loader With Manual Prime',
		UPC: '090255855203',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '19',
		ShelfWidth: '12.25',
		ShelfDepth: '6.5',
		Weight: '28.300',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '19.000',
		CartonWidth: '12.250',
		CartonDepth: '6.500',
		CartonWeight: '28.3',
		PalletQtyBoxes: '49',
		Retail: '340.98',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The next evolution in single stage press technology. The Lock-N-Load® Iron Press® loader is built to be the heaviest, most rigid press in its class. Tight tolerances in manufacture and assembly combine to provide consistency and precision that will deliver match accurate ammunition, round-after-round, year-after-year. LOCK-N-LOAD® BUSHING SYSTEM Incorporating our patented Lock-N-Load® bushing system, changeovers are lightning fast.  PATENTED SHELL HOLDER PLATFORM The Iron Press® loader, with its patented shell holder platform, allows handloaders to deprime, pause and remove the case to chamfer and deburr, etc., then easily replace and prime.  AUTOMATIC PRIMING SYSTEM The gravity fed Automatic Priming System (sold separately or with the Kit) and innovative accessory mounting deck helps increase reloading efficiency by allowing more processes to happen simultaneously.  SUPERIOR STRENGTH Industry leading strength and further ease of use comes from the spring assist 1-1/8" solid steel ram.  ACCESSORY DECK The accessory mounting deck provides quick access to trays for bullets or cases, and storage for chamfer and deburr tools, case neck brushes, primer pocket cleaners and more.',
		ProductImage: 'http://images.salsify.com/image/upload/s--QU7rJgm0--/g56kyn6grrxvmjbdqef9.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--bHApt5M4--/y2vkgji3rfjvrntbubbj.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s----OVtRI6--/issvcqyhizyspyqdmcgq.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--aVODZ6Cp--/gvrymninknafogq8okhr.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--2y_OJ9h0--/gvquyhbnelmly6wyelwa.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--0H7PUvQ4--/z37fs8ofguo6wfnnoquv.jpg',
		ProductImage6: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		Videos: 'https://vimeo.com/163452828',
		Videos1: 'https://vimeo.com/171592161',
		DateLastModified: '2023-12-16 08:58:44',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'faf872f0-70ed-4b1a-bc2f-4e72b3c0e8b5',
		ProductID: '8629B',
		ProductName: '6.8 Remington SPC Unprimed Cases',
		UPC: '090255696998',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '44.520',
		WeightUOM: 'LB',
		CaseQty: '2500',
		CartonUCC: '10090255696995',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '111300.0',
		PalletQtyBoxes: '110000',
		Retail: '0.56',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '6.8MM REM SPC',
		Caliber: '6.8MM',
		BulletDiameter: '0.277',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3cbaed59-8665-4eb3-abee-5a5649bfefef',
		ProductID: '190173',
		ProductName: 'Powder Bushing 498',
		UPC: '090255191738',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.057',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191735',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.57',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00643e9c-dc2e-46d3-b250-4d1721b568a8',
		ProductID: '80255',
		ProductName: '223 Remington 55 gr SP Custom',
		UPC: '090255802559',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.450',
		ShelfDepth: '3.750',
		Weight: '1.313',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802556',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '13.13',
		PalletQtyBoxes: '1190',
		Retail: '59.27',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		G1BC: '0.235',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP W/C',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Millions of successful hunts have proven the accuracy and deadly effect of the famous Hornady® InterLock,® SST,® InterBond® and GMX® bullets we load into Hornady® Custom™ rifle ammunition.  Every round of Hornady® Custom™ ammunition is hand inspected before packaging to ensure the highest levels of quality control. At Hornady,® we manufacture Custom™ ammunition to give shooters and hunters the advantage of handloaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of hunting calibers, Custom™ ammunition is loaded with InterLock,® SST,® InterBond,® FTX® and CX™ bullets, providing an all-around line of hunting ammunition for your preferred shooting experience. EXPANSION AND PENETRATION An industry leader and customer favorite, Custom™ ammunition balances expansion and penetration and is well-suited to medium and large sized game. BALLISTIC EFFICIENCY Most Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady,® creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--ANSpGW3N--/mvldaytvadzwlixqzfz2.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--g879RvOV--/8147fe248184de2e352c44ceb6f2c6799af5e5e8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zDa_Xe9K--/bzpbhvthurdwtqxyr0xj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--91PDF0-B--/lizgffwv5a2hh7oujcwz.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--BB-3R1eN--/eibzkoz06npfapntjwfq.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xP2qtYiH--/bzgragykyhzm679lyd4n.jpg',
		Videos: 'https://vimeo.com/241899454',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dd706b24-f46c-46cf-bcd4-681ff47168be',
		ProductID: '90050',
		ProductName: '30 Super Carry 100 gr FTX® Critical Defense®',
		UPC: '090255720853',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.5',
		ShelfWidth: '2.5',
		ShelfDepth: '3.25',
		Weight: '0.503',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255720850',
		CartonHeight: '2.130',
		CartonWidth: '6.940',
		CartonDepth: '13.000',
		CartonWeight: '5.03',
		PalletQtyBoxes: '4200',
		Retail: '37.41',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Critical Defense® Ammunition',
		GeneralApplication: 'Personal Defense',
		Applications: 'AppPersonalDefense',
		G1BC: '.180',
		SectionalDensity: '0.147',
		Cartridge: '30 SUPER CARRY',
		Caliber: '32 CAL',
		BulletDiameter: '0.3115',
		BulletName: 'FTX®',
		BulletWeightGrain: '100',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Concealed Carry Reliability. Since their inception, conventional hollow point pistol bullets have performed well, but have never delivered 100% reliability, especially in self-defense situations. The patented Flex Tip® technology used in Critical Defense® ammunition eliminates the clogging and inconsistency that often plagues hollow point bullets. Hornady® achieved this by using the same tip material used in LEVERevolution® ammunition.  All Critical Defense® ammunition is loaded in nickel-plated cases for increased visibility in low-light situations. Premium low flash propellants deliver proven performance, even in very short-barreled handguns, and won't disrupt your vision. Reliable expansion and dependable terminal performance can be counted on for concealed carry and personal protection. FTX® BULLET TECHNOLOGY Thanks to its patented Flex Tip®, the FTX® expands reliably while avoiding the clogging that can plague other hollow point bullets when passing through heavy clothing and other barriers.  DEFENSE-CENTERED DESIGN Critical Defense® ammunition was developed to provide the best performance for personal protection and is the ultimate choice for concealed carry firearms. Bright nickel-plated cartridge cases ease chamber checks in reduced light, and low-flash propellants preserve night vision.  DEPENDABLE Nickel-plated cases resist corrosion and optimized propellants burn quickly to reduce recoil and limit muzzle flash, making Critical Defense® dependable in every situation.  HIGHER MAGAZINE CAPACITY Load twelve 30 Super Carry cartridges into a magazine instead of 10, giving you the confidence that your concealed-carry firearm will be enough when you need it.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Zz6Dkyuh--/d4f47ad8cd65ebd4533dc5ebbe81bda9a7b96c78.jpg',
		ProductImage: 'http://images.salsify.com/image/upload/s--gfugCTk5--/fv3se8inxugickmjzmkw.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--M4OqZC7d--/l1yn3yzctjoir2chbr58.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--694wSGZr--/smqwqic1uvhrttmalfoq.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--9z0FbJoq--/oikdscyozckxli1lxu9y.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--gr_KXiks--/ymcg1yghxmjwikgunyfb.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--adLzs3HT--/gotx7vxkdb0sjmcdwmnp.png',
		ProductImage6: 'http://images.salsify.com/image/upload/s--GL4b6YVf--/ey9kmugueawtbctpjl3q.jpg',
		Videos: 'https://vimeo.com/347110177',
		Videos1: 'https://vimeo.com/801002379',
		DateLastModified: '2023-12-16 09:09:47',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7b4c0ae8-bd70-40b9-94c7-898ee02a02c2',
		ProductID: '9083',
		ProductName: '44 Remington Mag 200 gr MonoFlex Handgun Hunter',
		UPC: '090255390834',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.056',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390831',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '10.56',
		PalletQtyBoxes: '1120',
		Retail: '49.39',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		SectionalDensity: '0.155',
		Cartridge: '44 REM MAG',
		Caliber: '44 CAL',
		BulletDiameter: '0.43',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Otf0uYBM--/ssxnnd6qqhpvzycdvrf5.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5d8ebcf6-bfb4-49a3-972f-ae334c16789b',
		ProductID: '190255',
		ProductName: 'Powder Bushing 272',
		UPC: '090255192551',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.071',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192558',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.71',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:51',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '81a2eff4-ca38-4fdc-81a4-0847ff8030a9',
		ProductID: '86234',
		ProductName: '12 GA American Whitetail® 1 Ounce Rifled Slug',
		UPC: '090255862348',
		PackagedQTY: '5',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.625',
		ShelfDepth: '4.125',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '20',
		CartonUCC: '10090255862345',
		CartonHeight: '4.687',
		CartonWidth: '5.625',
		CartonDepth: '11.062',
		CartonWeight: '10.0',
		PalletQtyBoxes: '2160',
		Retail: '13.85',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.250',
		MuzzleVelocity: '1600',
		MuzzleEnergy: '2484',
		Cartridge: '12 GA',
		Caliber: '73 CAL',
		BulletDiameter: '0.73',
		BulletName: 'RIFLED SLUG',
		BulletWeightGrain: '1 OZ',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Turn your smooth-bore shotgun into a deer hunting machine with the American Whitetail® rifled slug. Designed for smooth-bore barrels, Hornady® American Whitetail® Rifled Slugs are loaded with a 1-ounce foster style slug. The hollow point style slug features a tough, lead alloy core loaded to 1,600 feet per second. The compression style wad protects the slug at ignition and helps to seal the bore for maximum velocity.  Make it a knockdown, drag out hunt – American Whitetail® from Hornady. Rifled slug for smooth-bore barrels 12 gauge 1-ounce rifled, foster style slug Hollow point, tough lead-alloy core 1,600 feet per second RIFLED SLUG FOR SMOOTH BORE BARRELS The American Whitetail® 12 gauge Rifled Slug turns your smooth bore shotgun into a deer hunting machine!  Designed for smooth bore barrels, Hornady® American Whitetail® Rifled Slugs feature a 1-ounce lead alloy slug that is loaded to 1,600 feet per second. A compression-style wad protects the slug at ignition and helps to seal the bore for maximum velocity.  1 OZ. RIFLED SLUG Optimized for performance in smooth bore shotguns, the lead alloy projectile expands to rapidly transfer energy upon impact.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jkIvrID9--/msngnexowupzmem1nqyo.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--wzR4e555--/dto9pukyrrxwb7aezwog.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VvUEy0gS--/jergu9c7wcnzmadutqlo.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--3uMZymjt--/dgrspckzewlaq2koa29s.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--MEGIHPl6--/o63ieiksmxdbsnnap2g4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		Videos2: 'https://vimeo.com/96125082',
		DateLastModified: '2023-12-16 09:09:28',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b368c477-f009-441e-aa6d-13340893018a',
		ProductID: '546360',
		ProductName: 'Full-Length 2-Die Set 7.5 Swiss (.308)',
		UPC: '090255563603',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.481',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563600',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.405',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7.5 SWISS (7.5X55)',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1953de7e-8568-480c-a473-85f4ecf1f945',
		ProductID: '81193',
		ProductName: '35 Whelen 200 gr SP Superformance®',
		UPC: '090255811933',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.430',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255811930',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '14.3',
		PalletQtyBoxes: '1400',
		Retail: '57.91',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.282',
		MuzzleVelocity: '2910',
		MuzzleEnergy: '3760',
		SectionalDensity: '0.223',
		Cartridge: '35 WHELEN',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		BulletName: 'SP',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--CPbGkc9o--/60210cd87d97ac2571c2da3a5811bbbad5259ff0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9be7e9c8-12a9-41ed-a549-919b9d592122',
		ProductID: '546318',
		ProductName: 'Full-Length 2-Die Set 7mm/223 Ingram (.284)',
		UPC: '090255563184',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563181',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '7MM-223 INGRAM',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3ffb72a1-a124-43be-abac-df5578410b69',
		ProductID: '95109',
		ProductName: 'Hornady® Ammo Cabinet',
		UPC: '090255951097',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '41.2',
		ShelfWidth: '18.5',
		ShelfDepth: '13',
		Weight: '47.800',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '41.200',
		CartonWidth: '18.500',
		CartonDepth: '13.000',
		CartonWeight: '47.8',
		PalletQtyBoxes: '10',
		Retail: '736.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Auxiliary Safes',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'ASSEMBLED IN THE USA',
		Prop65Chem1: 'Lead',
		Prop65Chem2: 'Cadmium',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '40',
		ProductExtWidth: '18',
		ProductExtDepth: '12',
		ProductWeight: '42.4',
		ProductIntHeight: '29.75',
		ProductIntWidth: '17.75',
		ProductIntDepth: '11.75',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Safely store and organize ammo cans, cartons and boxes with the versatile Hornady® Ammo Cabinet. The one-of-a-kind Square-Lok™ system allows you to arrange space and add features that suit your needs while securing valuable reloading tools, hunting and shooting gear, and other supplies. Bolt together two or more for even greater storage capacity. Adaptable Storage Square-Lok™ walls offer increased air flow and a fully customizable modular design. Additional Square-Lok™ accessories can be purchased separately.  Sturdy Shelving Two adjustable shelves support 100 pounds each for maximum storage. Three included shelf/floor mats protect ammo, tools and other gear.  Easy To Organize Magnetic motion light, 10 magnetic rewritable shelf labels and other accessories make organizing and finding ammo easy. Three plastic ammo cans included.  Flexible Door Placement Door can be oriented for left or right opening to suit your space. Door lock opens smoothly with two barrel keys.  Expandable Storage Bolt multiple cabinets together for increased storage or to create a sturdy work bench. Includes:  Two Barrel Keys One Magnetic Motion Light Two Adjustable Shelves Three Plastic Ammo Cans Three Shelf/Floor Mats Ten Magnetic Rewritable Shelf Labels',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vvo7VZJX--/mzjlrtx0uz2uq1m03wzm.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--vvo7VZJX--/mzjlrtx0uz2uq1m03wzm.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ksly7ClZ--/syz0zt3wtqhefjqainec.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--KvAFrpWA--/ohaxotr1fscvzid83b9s.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--WETqTJ95--/mhoklhw1oyp9efidkupt.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--3SQiPumU--/rxpf4afrciu2w9fuzo7r.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--VtpMkQVb--/nuxud3bow2iishkrmgb1.png',
		Videos: 'https://vimeo.com/714237752',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9fd38ec9-e244-4bee-8749-ce98735fdd6f',
		ProductID: '050109',
		ProductName: 'Lock-N-Load® Balance Beam Scale',
		UPC: '090255501094',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '11.75',
		ShelfDepth: '5.75',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '2.500',
		CartonWidth: '11.750',
		CartonDepth: '5.750',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '132.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Scales & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady® Balance Beam Scale is an essential tool for any well-stocked reloading bench. Its classic, time-proven balance system provides a measurement range from 0 to 500 grains with 0.1 grain sensitivity, and will easily handle most reloading tasks. A magnetic dampener provides fast, accurate measurements. The balance bar is laser etched, easy to read, and will not flake or peel. Made in the USA. 500 grain capacity +/- 0.1 grain sensitivity Magnetic dampener for accuracy Durable, easy-to-read laser etched bar Hardened pivot pins & bearings for durability Molded pan hanger Made in USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--MDbXOCD6--/xttbykmji22veatorpb0.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b6dd9ca9-1e5b-4615-9cbf-e6ac4a1f98c8',
		ProductID: '390571',
		ProductName: 'Shell Holder #31',
		UPC: '090255905717',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.044',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905714',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.44',
		PalletQtyBoxes: '0',
		Retail: '10.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2873222c-2360-4424-a83e-260e96cd2edf',
		ProductID: '82213',
		ProductName: '300 Weatherby Mag 200 gr ELD-X® Precision Hunter®',
		UPC: '090255822137',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.710',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822134',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.1',
		PalletQtyBoxes: '780',
		Retail: '90.04',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.597',
		G7BC: '0.301',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3890',
		SectionalDensity: '0.301',
		Cartridge: '300 WBY MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--uR8K_OGL--/9458a1901f2d26414f8ba2ee4acc575876d68aeb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '402bbe77-1edd-4251-b4aa-90d91aaf84f0',
		ProductID: '010046',
		ProductName: '366 Auto Loader 28 Ga 2-3/4',
		UPC: '090255010466',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.25',
		ShelfWidth: '16.375',
		ShelfDepth: '11.75',
		Weight: '30.164',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '20.250',
		CartonWidth: '16.375',
		CartonDepth: '11.750',
		CartonWeight: '30.164',
		PalletQtyBoxes: '27',
		Retail: '2063.53',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: '366 Auto Shotshell Reloader',
		Cartridge: '28 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Quick and easy high-quality, low-cost ammo. The Hornady® 366 Auto™ Shotshell Reloading Press is ideal for the avid target shooter. The time-tested design lets you load high-quality, low-cost ammo in a hurry — just set the case and wad in place and pull the handle. The 366 Auto™ does the rest. AUTOMATIC PRIMER FEED SYSTEM Just pull the handle to prime shells. Smooth and reliable design reduces to nearly zero the chances of crushing the primer. Primer Tube Filler holds a full box of shotshell primers, fills the tube with a turn of the dial and won't drop primers upside-down into the feeder tube.  EASY-EMPTY POWDER AND SHOT HOPPER TUBES Entire assembly can be easily removed without spilling — a feature unique to the 366 Auto™. Baffles let powder and shot flow smoothly for more uniform loads from start to finish.  3-STAGE TAPER-LOC™ CRIMPING The 366 Auto™ reliably starts a crimp, closes and tapers for both six- and eight-point crimps and gives a factory taper to shells.  SPRING-LOADED SEATER PUNCH (Optional) Set your primer seater to one adjustment with no need to readjust the punch for different brands of hulls (12 or 20 GA).  SWING-OUT WAD GUIDE Swing-out wad guide provides better access, speeding up reloading.  AUTOMATIC INDEXING Each pull of the lever automatically rotates the shell plate, so you don't have to do it manually.  FULL-LENGTH RESIZING STATION The 366 Auto™ give you the choice to resize your shells to factory dimensions or skip this station to speed up reloading.  AUTOMATIC SHELL EJECTION Completed shells are automatically ejected behind the press, so you don't have to remove them manually.",
		ProductImage: 'http://images.salsify.com/image/upload/s--vvceX4zV--/qqhhcmhrlbadanqobv7g.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b78c9b82-37b8-4724-af60-e45baab6d23a',
		ProductID: '6050',
		ProductName: '45 Cal .445 Lead Balls',
		UPC: '090255260502',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.970',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260509',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '49.25',
		PalletQtyBoxes: '900',
		Retail: '20.40',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '45 CAL',
		BulletDiameter: '0.445',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e1f95ee0-955f-4593-9584-a024c260ed10',
		ProductID: '95794',
		ProductName: 'Square-Lok™ Rifle/Pistol 6-Gun Rack',
		UPC: '090255957945',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.25',
		ShelfWidth: '18.25',
		ShelfDepth: '4.75',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957942',
		CartonHeight: '4.250',
		CartonWidth: '18.250',
		CartonDepth: '4.750',
		CartonWeight: '8.75',
		PalletQtyBoxes: '0',
		Retail: '17.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductImage: 'http://images.salsify.com/image/upload/s--RwNiOTeh--/qzczgwsbhbbutwgthzac.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3206f177-e99e-4fb4-992a-0a4421387c2a',
		ProductID: '044099',
		ProductName: 'Lock-N-Load® Conversion Kit',
		UPC: '090255440997',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7',
		ShelfWidth: '4',
		ShelfDepth: '1.5',
		Weight: '0.410',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255440994',
		CartonHeight: '4.750',
		CartonWidth: '7.250',
		CartonDepth: '10.500',
		CartonWeight: '4.1',
		PalletQtyBoxes: '0',
		Retail: '27.12',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Single Stage Metallic Presses & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Simply thread a Hornady® Lock-N-Load® Conversion Kit into your RCBS® Rock Chucker or other reloading press using a 1¼\"-12 thread, and you're ready to start using the Lock-N-Load® System.  It's the easiest way to get the most out of your reloading press. These bushings let you take advantage of Hornady's® Lock-N-Load® technology even if you own a competitors reloading press.  The Lock-N-Load® Conversion Kit includes three Lock-N-Load® bushings and one conversion bushing.",
		ProductImage: 'http://images.salsify.com/image/upload/s--JsPZBc6S--/me3vrqdf0gozexhnywlg.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--_L_lAwQ3--/twfxns7snvw53a3mklfh.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '406d7c75-57fe-4ea6-af78-247eb6530833',
		ProductID: '390562',
		ProductName: 'Shell Holder #22',
		UPC: '090255905625',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905622',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '78ff2963-98b4-49bd-9ba2-efd0cadffc70',
		ProductID: '86274',
		ProductName: '12 GA 00 Buckshot Reduced Recoil American Gunner®',
		UPC: '090255862744',
		PackagedQTY: '10',
		PackagedUOM: 'BX',
		ShelfHeight: '1.75',
		ShelfWidth: '2.625',
		ShelfDepth: '4',
		Weight: '0.900',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255862741',
		CartonHeight: '4.625',
		CartonWidth: '6.000',
		CartonDepth: '9.937',
		CartonWeight: '9.0',
		PalletQtyBoxes: '1120',
		Retail: '18.71',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Gunner® Rifle Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		MuzzleVelocity: '1350',
		Cartridge: '12 GA',
		BulletName: 'BUCKSHOT',
		BulletWeightGrain: '00',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The American Gunner® line of ammunition is a collection of tried-and-true, versatile loads that are popular with shooters for their target shooting, hunting or self-defense needs.  Made in the USA with premium components, American Gunner® ammunition combines generations of ballistics know-how with modern technology. SWAGED HIGH ANTIMONY LEAD SHOT The Reduced Recoil 00 Buckshot is loaded with 8 pellets of swaged high antimony lead shot that is held to exacting tolerances. This load is designed to offer less recoil while still cycling most modern semi-automatic shotguns.  HORNADY VERSATITE WAD The Hornady Versatite wad does the patterning so this load does not require shotgun modifications or specialized chokes.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--tJXy0rXb--/chgbx37dcf6jx52ok83l.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--eblO14UC--/be2ed022c462b4c0a760ca96232a49dcf116f511.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--lTGpXr3O--/xa4ijamzgeifkytjhkzi.png',
		DateLastModified: '2023-12-16 09:09:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c859ad0-036a-4c60-b140-2a60d116c9d0',
		ProductID: '050140',
		ProductName: 'Cam Lock™ Trimmer',
		UPC: '090255501407',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '10.625',
		ShelfDepth: '5.25',
		Weight: '3.076',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255501404',
		CartonHeight: '4.750',
		CartonWidth: '6.125',
		CartonDepth: '13.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '156.21',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Thanks to the unique way the case is locked in place in the shell holder, this trimmer accurately restores fired cases to the correct length no matter the thickness of the cartridge rim. The lever locks the case in place. The Micro Adjust cutter allows .001” changes without moving the case (extra cost on competitor trimmers). Plus, its large diameter, replaceable cutting head is made of ultra-hard tool steel and trims cases up to 50 caliber. Use only standard Hornady® shell holders and pilots. Includes ten of the most popular pilot sizes: 22 cal, 6mm, 25 cal, 6.5mm, 270 cal, 7mm, 30 cal, 35 cal, 38 cal, and 45 cal.',
		ProductImage: 'http://images.salsify.com/image/upload/s--NV9bVF_Y--/jt8clhmg8xbj7k9xiwzf.jpg',
		DateLastModified: '2023-12-16 08:58:42',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'fe2f7bb3-cf3a-4ab9-a593-bd17232e71b8',
		ProductID: '044103',
		ProductName: 'Seater Die #3 (.243) 6mm',
		UPC: '090255441031',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.601',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441038',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eaeb8303-fd50-4d61-9285-74e5601af775',
		ProductID: '043360',
		ProductName: 'One Shot® Sonic Clean™ Gun Parts Formula - Quart',
		UPC: '090255433609',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.625',
		ShelfWidth: '5.125',
		ShelfDepth: '2.125',
		Weight: '2.337',
		WeightUOM: 'LB',
		CaseQty: '12',
		CartonUCC: '10090255433606',
		CartonHeight: '8.000',
		CartonWidth: '14.750',
		CartonDepth: '11.000',
		CartonWeight: '28.044',
		PalletQtyBoxes: '0',
		Retail: '34.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Sonic Cleaners, Tumblers & Media',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'DIETHANOLAMINE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Jug',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Cleans all gun parts and is safe for all firearms finishes. Quickly removes carbon, dirt, grease and powder residue. Designed specifically for the Hornady® Lock-N-Load® Sonic Cleaners.™',
		ProductImage: 'http://images.salsify.com/image/upload/s--DYqT5Kjd--/i9kposfk03ds4ogji8qu.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c89fd1e0-b70c-4dc1-a9a6-4336e2af0301',
		ProductID: '8232',
		ProductName: '375 Ruger 300 gr DGS® Dangerous Game™ Series',
		UPC: '090255382327',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '2.076',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382324',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '12.456',
		PalletQtyBoxes: '396',
		Retail: '125.17',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.275',
		MuzzleVelocity: '2660',
		MuzzleEnergy: '4713',
		SectionalDensity: '0.305',
		Cartridge: '375 RUGER',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		BulletName: 'DGS®',
		BulletWeightGrain: '300',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s---unPYoGD--/acde4a16c34126e3841cae538bab6c31161d9d33.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '68f285fd-15c3-497a-846c-e92455b7248a',
		ProductID: '046211',
		ProductName: 'Full-Length Size Die 221 Rem (.224)',
		UPC: '090255462111',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462118',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '221 REM FIREBALL',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b15a8f5c-e56f-40b1-9677-1123b5fd0645',
		ProductID: '546533',
		ProductName: 'Full-Length 3-Die Set 10mm/40 S&W (.400)',
		UPC: '090255565331',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.764',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565338',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.82',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '40 S&W/10MM AUTO',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '470b6c3c-c19e-4eb5-910b-6f2bbc9bf6e8',
		ProductID: '490509',
		ProductName: 'Crimp Starter 28 Ga 6 Pt',
		UPC: '090255945096',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.5',
		ShelfDepth: '0.05',
		Weight: '0.041',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255945093',
		CartonHeight: '10.000',
		CartonWidth: '7.000',
		CartonDepth: '1.750',
		CartonWeight: '0.41',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Universal Crimp Starters',
		Cartridge: '28 GA',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--CE5yeAr4--/baehdwiavoqrlfxfwz26.jpg',
		DateLastModified: '2023-12-16 09:02:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '13bbdfde-ba5a-4350-adfe-56aa81742f4c',
		ProductID: '80877',
		ProductName: '300 Blackout 190 gr Sub-X® Subsonic',
		UPC: '090255808773',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.910',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255808770',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '9.1',
		PalletQtyBoxes: '1680',
		Retail: '41.28',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady® Subsonic Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.437',
		MuzzleVelocity: '1050',
		MuzzleEnergy: '465',
		SectionalDensity: '0.286',
		Cartridge: '300 BLACKOUT',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® 300 Blackout Subsonic Ammunition is designed for accuracy and performance below the speed of sound. The new 190 gr Sub-X® (Subsonic - eXpanding) bullet features a lead core. Long grooves in its gilding metal jacket combine with the bullet’s flat profile and the patented Flex Tip® insert within its hollowpoint cavity to help it expand reliably at low velocities.  Performance of the Hornady® 300 Blackout Subsonic load meets or exceeds FBI Protocol terminal ballistic test requirements. SUB-X® BULLET TECHNOLOGY In addition to its patented Flex Tip®, long grooves in the gilding metal jacket of the 190 gr Sub-X® combine with the bullet’s flat profile to ensure expansion. The Sub-X® features a lead core and a cannelure for a positive case crimp for use in semi-automatics.  PROVEN PERFORMANCE Performance of 300 Blackout Subsonic meets or exceeds FBI Protocol terminal ballistic test requirements. Impact velocity of 1,020 fps into ballistic gelatin provides 16-18” penetration and 90%+ weight retention.  SILENT AND STEALTHY Hornady® Subsonic Ammunition doesn’t have the loud report of a supersonic round, and paired with a suppressor, it’s even quieter. Unique powders optimized for subsonic use result in a low flash signature, ideal for either suppressed or unsuppressed performance.  Disclaimer: This is subsonic, i.e., reduced velocity ammunition and will not produce the same muzzle energy as conventionally loaded cartridges. If hunting with this product, be sure to read, understand and comply with all applicable regulations and laws pertaining to bullet energy and/or muzzle velocity for the area and game to be hunted.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--c2oGeYs_--/wnbpikxtswatfcbcu01l.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--c7CVBLbz--/28704e840c21ef3227074c10a6e20e46de36f32c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--NsEbqDaR--/w9pxeuxpfocyjo3v5b49.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--o57pFF14--/vh11iaoohy5brcgtamzx.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--kqc9kolN--/iw7iwjvxjevcv5za1fze.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--oXoa9e2M--/v4dvpvgndlzaesjtbqui.jpg',
		Videos: 'https://vimeo.com/238318324',
		Videos1: 'https://vimeo.com/368031042',
		Videos2: 'https://vimeo.com/257722661',
		Videos3: 'https://vimeo.com/242146498',
		Videos4: 'https://vimeo.com/396530834',
		Videos5: 'https://vimeo.com/241897154',
		DateLastModified: '2023-12-16 09:06:15',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd2d4d0fc-1600-4f6c-994b-1cffe46ff5f6',
		ProductID: '22774',
		ProductName: '22 Cal .224 73 gr ELD® Match',
		UPC: '090255227741',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.133',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255227748',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.325',
		PalletQtyBoxes: '900',
		Retail: '39.88',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		G7BC: '0.2',
		MinTwist: '1-8"',
		SectionalDensity: '0.208',
		OAL: '1.033',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '73',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--yhGlWSNm--/cca0a4be3948a9babeb6c38d0b8c0633582abdc1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '608c547b-64f8-4a5b-8050-b7c249cb5de5',
		ProductID: '3031-75',
		ProductName: '30 Cal. .308 150 gr. SP InterLock®',
		UPC: '090255723953',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '1.25',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255723950',
		CartonHeight: '7.375',
		CartonWidth: '6.187',
		CartonDepth: '8.750',
		CartonWeight: '24.0',
		PalletQtyBoxes: '3240',
		Retail: '8.32',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		SectionalDensity: '0.226',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SP INTERLOCK®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range. TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities. ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills. CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion. INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy.   Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting. The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--kqs8te8a--/aqmikkqjtfyejy9sfoki.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Ufz7n7kv--/nznp4t4zgzwobrcpwdrc.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LLiK_sYB--/tbxxiiybum2ry6sfsrmj.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kqs8te8a--/aqmikkqjtfyejy9sfoki.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DqdnYBwZ--/fhdldd9giouzk2ro97ek.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		DateLastModified: '2024-01-02 11:49:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '826ccd60-f800-499e-8035-e1f1db13f027',
		ProductID: '98172',
		ProductName: 'Hornady® RAPiD® Safe 2700KP XL',
		UPC: '090255981728',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '10',
		ShelfDepth: '15',
		Weight: '9.150',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255981725',
		CartonHeight: '15.750',
		CartonWidth: '10.750',
		CartonDepth: '15.750',
		CartonWeight: '36.6',
		PalletQtyBoxes: '200',
		Retail: '289.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® RAPiD® Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'LEAD & DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: 'AA',
		BatteryQty: '4',
		BatteryWattHour: '9.6',
		BatteryWeight: '92',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '2.9',
		ProductExtWidth: '8.7',
		ProductExtDepth: '12.7',
		ProductWeight: '7.5',
		ProductIntHeight: '2.2',
		ProductIntWidth: '7.7',
		ProductIntDepth: '9',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The RAPiD® Safe 2600KP and 2700KP models include a keypad that offers a secondary entry method where the user can program a 4 to 6 digit security code in addition to the RFID-enabled access methods. Available in two sizes, the 2600KP and 2700KP offer convenient, tamper-proof security for handguns and other valuables. FAST AND DEPENDABLE TOUCH-FREE ENTRY RFID activated by wristband, key fob or sticker that instantly opens spring-assist lid. Up to five RFID tags can be programmed.  CONVENIENT KEYPAD ACCESS For secondary entry method, user can program a four to six digit security code.  CERTIFIED CHILD-RESISTANT Exceeds ASTM International safety standards for child and pry resistance, lock strength, drop/pick/saw tests and hinge attack resistance.  HEAVY-DUTY, TAMPER PROOF CONSTRUCTION Exterior housing is made of thick 14 gauge steel with two internal hardened locking lugs.  SAFE AND READY AC power means your handgun is both protected and ready to go 24/7.  MOBILE SECURITY Included cable allows the safe to be secured in virtually any location. Meets TSA requirements for handgun safety in checked luggage  RAPiD® Safe 2700KP (X-Large) Features: Keypad Type: 1911 Pistols / 4-Inch Revolvers Exterior Dimensions: 12.7" x 8.7" x 2.9" Interior Dimensions: 9" x 7.7" x 2.2" CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to Lead, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.  IMPORTANT: Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage. Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe\'s interior dimensions. Firearm and firearm accessories not included.  U.S. Patent: 9,530,266 | 10,233,687 U.S. Des. Pat. D786,047',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--dHiCloqM--/sxtufwj8txle85my2ygl.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--dHiCloqM--/sxtufwj8txle85my2ygl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BrAjgrRX--/gflqxqentxmvctzneods.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--73GD1Sm7--/wuja7fezwkkc5w10pjoo.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--WzUCs3yN--/uxhfwcwr4pupekpr35ot.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--HCwrnaLg--/oeksqr8ox2r1mnns8yqy.png',
		Videos: 'https://vimeo.com/190884888',
		Videos1: 'https://vimeo.com/347110028',
		DateLastModified: '2023-12-16 09:09:39',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c57aa716-5543-480d-8f81-6ff6935f2133',
		ProductID: '546236',
		ProductName: 'Full-Length 2-Die Set 5.6X57 (.224)',
		UPC: '090255562361',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562368',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '5.6X57',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dfbcaf8e-bbe8-4d6f-ad32-db977268b84f',
		ProductID: '7110',
		ProductName: '35 Cal Gas Checks',
		UPC: '090255271102',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '0.591',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255271109',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '8.865',
		PalletQtyBoxes: '540',
		Retail: '55.32',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '35 CAL',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3297c957-f36d-4ad8-bfdd-99a9bbe21a59',
		ProductID: '8743B',
		ProductName: '40 Smith & Wesson Unprimed Cases',
		UPC: '090255710342',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '47.377',
		WeightUOM: 'LB',
		CaseQty: '5000',
		CartonUCC: '10090255710349',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '236885.0',
		PalletQtyBoxes: '220000',
		Retail: '0.27',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Handgun Cartridge Cases',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3612d000-481c-4d4e-a519-b11e0a8ea90e',
		ProductID: '3017',
		ProductName: '30 Cal .308 110 gr FMJ',
		UPC: '090255230178',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.663',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255230175',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '41.575',
		PalletQtyBoxes: '900',
		Retail: '34.15',
		ParentCategory: 'Bullets',
		Applications: 'AppVarmint',
		G1BC: '0.178',
		SectionalDensity: '0.166',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '110',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Delivering a Better Performance Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance. The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking. RUGGED AMP® BULLET JACKET Hornady Traditional and FMJ bullets are built with a rugged AMP® bullet jacket (Advanced Manufacturing Process) that clearly delivers better performance.  SUPERIOR DESIGN The thin-plated full metal jacket offered by other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  VIRTUALLY ZERO VARIATION The Hornady AMP bullet jacket features virtually zero tolerance for concentricity and near-zero wall thickness variation, punching through targets without deforming or breaking.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--1kf5KOnz--/jqc6uczhwarvlmorad1z.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--x4K7ORTQ--/gkaahq6qyptulcen6yau.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e856f702-d982-4082-b2bb-63189936df7c',
		ProductID: '190184',
		ProductName: 'Powder Bushing 256',
		UPC: '090255191844',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.072',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255191841',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.72',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dd213f98-23de-4959-bdc7-051ae8fde477',
		ProductID: '28403',
		ProductName: '7mm .284 162 gr ELD® Match',
		UPC: '090255284034',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.435',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255284031',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.525',
		PalletQtyBoxes: '540',
		Retail: '58.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.67',
		G7BC: '0.338',
		MinTwist: '1-9.5"',
		SectionalDensity: '0.287',
		OAL: '1.42',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ckLhHlRi--/b233f9612f3556dda02d28e02de0c6406b88d966.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ea3a294b-eed0-4a93-8e89-1daeadcf2f50',
		ProductID: '546512',
		ProductName: 'Full-Length 3-Die Set 9X18 Makarov (.364)',
		UPC: '090255565126',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.756',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255565123',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '8.78',
		PalletQtyBoxes: '0',
		Retail: '80.33',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series II Three-Die Handgun Die Sets',
		Cartridge: '9X18 MAKAROV',
		Caliber: '9X18 MAKAROV',
		BulletDiameter: '0.364',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 3-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 3-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--tfpiZViN--/aeywdhkmg2lyp3irasqv.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Rp73MTGD--/hhgpgzjj595eoiblmcko.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--P74b6RVc--/smoauicw7l4lh0uem9ih.jpg',
		DateLastModified: '2023-12-16 09:05:59',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'be217dce-b733-4f62-8d59-7cecc725b045',
		ProductID: '046304',
		ProductName: 'Full-Length Size Die 280 Ackley Imp (.284)',
		UPC: '090255463040',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.600',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255463047',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '280 ACKLEY IMP',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a1aae2f1-3a74-4192-a442-a9d010ca8679',
		ProductID: '2249',
		ProductName: '22 Cal .224 52 gr BTHP Match',
		UPC: '090255222494',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.815',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222491',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.6',
		PalletQtyBoxes: '1440',
		Retail: '29.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.229',
		SectionalDensity: '0.148',
		OAL: '0.712',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '52',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--zUzRHkik--/bf35d3f90ccdd8b846451cf85f3fcb10277754a0.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '32493893-a4b5-4f48-ba48-6b0ad18f2552',
		ProductID: '290037',
		ProductName: 'PTX™ Powder Through Expander .475',
		UPC: '090255900378',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '0.25',
		ShelfDepth: '0.05',
		Weight: '0.108',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255900375',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '1.08',
		PalletQtyBoxes: '0',
		Retail: '14.40',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Measure & Accessories',
		Caliber: '475 CAL',
		BulletDiameter: '0.475',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Powder Through™ Expanders (PTX™) are designed to work in conjunction with the Case Activated Powder Drop. These Expanders eliminate the need for a separate case mouth expander die on the Lock-N-Load® AP™ press, freeing up an extra station for a taper crimp die or powder cop. The Expanders work for lead, plated and jacketed bullets.',
		ProductImage: 'http://images.salsify.com/image/upload/s--q5Y7Bd2M--/szqh20iyqjwg0rh7gvbu.jpg',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a522a3e5-cc76-4ab6-8fb7-84c47ac56e15',
		ProductID: '3090',
		ProductName: '30 Cal .308 220 gr InterLock® RN',
		UPC: '090255230901',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.291',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255230908',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '49.365',
		PalletQtyBoxes: '540',
		Retail: '60.77',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'InterLock® Rifle Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.3',
		SectionalDensity: '0.331',
		OAL: '1.257',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'RN INTERLOCK®',
		BulletWeightGrain: '220',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"One of the most ballistically efficient profiles ever developed. Our traditional line of bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Most have our pioneering secant ogive design — one of the most ballistically efficient profiles ever developed (see diagram to right). Most feature our exclusive InterLock® design — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. INNER GROOVES Strategically weaken the upper section of the jacket, ensuring consistent, controlled expansion, even at long range.  TAPERED JACKET Jacket thickness is precisely controlled for expansion at all velocities.  ONE-PIECE CORE Does not separate like two-piece divided cores. The InterLock® retains more mass and energy for deep penetration and large, consistent wound channels that ensure quick, clean kills.  CANNELURE Provides accurate and consistent crimping and also works with InterLock® ring to ensure the core and jacket remain locked during expansion.  INTERLOCK® RING The raised InterLock® ring is embedded in the bullet's core, ensuring the core and jacket are locked in one piece during expansion to retain mass and energy. Secant Ogive Design Pioneered by Hornady® for use in hunting bullets, this technology broke new ground in ballistic engineering and is now used in bullets for everything from match to varmint shooting.  The secant ogive is a geometrically developed design that creates the most ballistically efficient profile, yet retains the optimum bearing surface. The combination of the slender point and increased bearing surface results in lower drag, increased stability, flatter trajectories, and amazing accuracy.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--4cNzs8II--/acf4cef14e5e7c34934a4cb4f6eedf61e24b04fd.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--PleU47Ht--/f2d8e52da4806cf0476f61b846df1116b18a7584.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4rVfmcvz--/poxpndot2ym9kfx46xhs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--6DkQNxOP--/ec2ekg8tklqpzbe0mrak.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--NNW61ayb--/cbenyrq1trvenzwasurx.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KAY5cxj6--/juvsyqash9hshrarcmwe.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--6CekmkAZ--/ecqzrxl1mpsvh14jyxo3.jpg',
		Videos: 'https://vimeo.com/291492357',
		Videos1: 'https://vimeo.com/359798789',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '39be4c29-d32e-47ef-9fcb-1bda877bb8d0',
		ProductID: '546232',
		ProductName: 'Full-Length 2-Die Set 225 Win (.224)',
		UPC: '090255562323',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.478',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562320',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.39',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '225 WIN',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3eb69bd2-468e-4b7a-908b-37f939d7c1a6',
		ProductID: '046455',
		ProductName: 'Full-Length Size Die 300 Rem SAUM (.308)',
		UPC: '090255464559',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.543',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464556',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '300 REM SA ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aa7bb91f-101a-462b-b7b7-9cfb4f9a8e4e',
		ProductID: '046425',
		ProductName: 'Full-Length Size Die 7.62X39R (.308)',
		UPC: '090255464252',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464259',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '7.62X39',
		Caliber: '7.62X39 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '17ad2def-dee8-4f53-b541-832fcf96f8f0',
		ProductID: '392614',
		ProductName: 'Shell Plate #14 Lock-N-Load®AP™ & Projector',
		UPC: '090255926149',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926146',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.63',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:18',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7a0f58c5-5896-4ac2-99de-9d31e75350f8',
		ProductID: '22491',
		ProductName: '22 Cal .224 52 gr ELD® Match',
		UPC: '090255224917',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.807',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255224914',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '32.28',
		PalletQtyBoxes: '1440',
		Retail: '37.95',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.247',
		MinTwist: '1-14"',
		SectionalDensity: '0.148',
		OAL: '0.8',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '52',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The perfect tip! ELD® Match (Extremely Low Drag Match) bullets are technologically advanced, enhanced accuracy target bullets featuring Heat Shield® tips with the PERFECT MEPLAT (tip point) combined with numerous design features that deliver the highest-in-class ballistic coefficients, superior accuracy and extreme consistency from bullet to bullet, lot to lot.  Superior accuracy and industry leading ballistic design has been achieved with the ELD Match bullet. An optimum secant ogive and boattail design along with the Heat Shield tip produce a bullet with the highest possible ballistic coefficient in its class. BEST-IN-CLASS BC'S The Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to provide a perfect meplat (tip) that is always the same shape.  DELIVERS THE HIGHEST DEGREE OF ACCURACY AND CONSISTENCY. Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip creates a supremely accurate, high BC match bullet.  ACCURATE, DOPPLER RADAR VERIFIED BCS ELD® Match bullet BCs are measured with Doppler radar and corrected to standard atmospheric conditions.  THE PERFECT TIP! The new Heat Shield® tip creates the perfect meplat and outperforms BTHP bullets. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--PvxM0DcY--/570289d4351a3bcfa9cf4d82f5dd3cc5bceb83b9.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1NNpfHfT--/482e5be8240e401a8959608d9e05596310b0616f.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1t7PHBib--/ywjqvki61ga4p47od69i.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--_FA82gHF--/i2a1wdcxi7a9beh4wxww.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--UFtyTge8--/ve3wnwnck1yqt3rcqgmb.png',
		Videos: 'https://vimeo.com/163413697',
		Videos1: 'https://vimeo.com/163428543',
		Videos2: 'https://vimeo.com/359414591',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4b087029-0377-40ca-a370-db32d0acb278',
		ProductID: '546414',
		ProductName: 'Full-Length 2-Die Set 9.3X74R (.366)',
		UPC: '090255564143',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564140',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '9.3X74R',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '06bfa2a1-ab31-4721-941c-76872aa25601',
		ProductID: '8343',
		ProductName: '243 Win 58 gr V-MAX® Superformance® Varmint',
		UPC: '090255383430',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '0.920',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255383437',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '9.2',
		PalletQtyBoxes: '1400',
		Retail: '48.08',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Varmint™ Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.25',
		MuzzleVelocity: '3925',
		MuzzleEnergy: '1984',
		SectionalDensity: '0.14',
		Cartridge: '243 WIN',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '58',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Supercharge™ your varmint rifle! Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition. Speed Kills! Varmint hunters can now reap the benefits of Hornady® Superformance® propellant technology in their favorite varmint cartridges. Superformance® Varmint ammunition delivers muzzle velocity increases of 100 to 200 feet per second from EVERY gun. Accuracy, increased range, flatter trajectory, less wind drift and devastating terminal results are all realized with Superformance® Varmint ammunition.  Featuring the industry leading polymer tipped Hornady® V-MAX® bullet that delivers match accuracy and rapid fragmentation, Superformance® Varmint ammunition from Hornady® extends current varmint cartridge efficiency and performance. Optimal results are achieved in all firearms, and Superformance Varmint ammunition is safe to use in all action types, including semi-autos.  FAST Superformance® Varmint is 100 to 200 fps FASTER than ANY conventional ammunition.  ACCURATE Achieve superior accuracy, increased range, flatter trajectory, less wind drift.  DEADLY Polymer tipped Hornady V-MAX® or NTX® bullets deliver match accuracy and rapid fragmentation.  VERSATILE Optimal results are achieved in ALL firearms, including semi-autos.  Supercharge your varmint rifle with Hornady Superformance® Varmint ammunition - It really IS…rocket science!',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--O4pdHOgz--/04b9501ec1a55a5f82facbb69fe48dd1ac0539fa.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--8kH6lif0--/895f2fa7a37d6ffc69c5c45779e0e8a2d4a184e9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--FAnEzplm--/laoh2tjfkvtmtnlxrivs.jpg',
		Videos: 'https://vimeo.com/145439425',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9614e55e-9c49-40e1-81fd-ba5352a75f67',
		ProductID: '76020',
		ProductName: 'Snapsafe® TSA Padlock (2 Pack)',
		UPC: '851529004921',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '4.375',
		ShelfDepth: '1',
		Weight: '0.520',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004928',
		CartonHeight: '5.000',
		CartonWidth: '4.000',
		CartonDepth: '6.500',
		CartonWeight: '2.6',
		PalletQtyBoxes: '3000',
		Retail: '43.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '3',
		ProductExtWidth: '1.6',
		ProductExtDepth: '0.5',
		ProductWeight: '0.22',
		MasterPackQty: '100',
		MasterPackUCC: '30851529004922',
		MasterPackHeight: '11.625',
		MasterPackWidth: '13.250',
		MasterPackDepth: '21.250',
		MasterPackWeight: '52.0',
		ProductDescription:
			'Protect belongings by using this all metal TSA-approved padlock that allows TSA screeners to inspect luggage without damaging the locks. 10 times harder to crack than 3-digit locks. TSA-approved. All-metal 4-digit combination lock SnapSafe or Ruger brand options',
		ProductImage: 'http://images.salsify.com/image/upload/s--FRnMpg7A--/iuodrnng1cludycdz0xu.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MRV080Av--/wjtpyzmdaryqegadnk1t.jpg',
		Videos: 'https://vimeo.com/225307972',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a6f69c7b-7e37-4d2d-8b84-afb8ddb95269',
		ProductID: '044526',
		ProductName: 'Expander Die 38 S&W/Super/Auto(.357)',
		UPC: '090255445268',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.494',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445265',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '51ea5f5f-5f80-40c1-a85e-f4d643b4ae3d',
		ProductID: '82614',
		ProductName: '458 Lott 500 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255826142',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.650',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826149',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '15.9',
		PalletQtyBoxes: '396',
		Retail: '216.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2300',
		MuzzleEnergy: '5873',
		SectionalDensity: '0.341',
		Cartridge: '458 LOTT',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Z-RZO7UA--/a1c7230ee6206c2276ec5966f0265509c7c9fbd1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2023-12-16 09:09:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a9386890-2ac5-43aa-8823-b70c4b568651',
		ProductID: '044160',
		ProductName: 'Seater Die #39 (.308) 300 Win Short',
		UPC: '090255441604',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.586',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441601',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2ccbc7de-7513-4e75-87eb-084fecd2ca3f',
		ProductID: '380707',
		ProductName: 'Cartridge Gauge 223 Rem (.224)',
		UPC: '090255807073',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807070',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9b8ac4fb-2e92-46e0-a0d0-c525d6110b39',
		ProductID: 'C458W',
		ProductName: 'Lock-N-Load® 458 Win Modified Case',
		UPC: '090255705089',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.038',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255705086',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.38',
		PalletQtyBoxes: '0',
		Retail: '10.41',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "C" Cases',
		Cartridge: '458 WIN MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:23',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '420c301d-6263-4f65-8737-c5709c0b0780',
		ProductID: '043402',
		ProductName: 'Zip Spindle™ Kit Straight Wall',
		UPC: '090255434026',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.75',
		ShelfWidth: '1.75',
		ShelfDepth: '0.5',
		Weight: '0.100',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255434023',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '16.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Hornady Custom Grade Die Zip Spindle Kit Straight Wall is the ideal kit for spare parts, or for updating an older Hornady Sizing die to utilize the new zip spindle design. The Zip Spindle has a series of light threads cut on the spindle and spindle lock. This eliminates slippage and makes tightening the spindle lock a breeze when adjusting. This kit includes 3 decap pins, a zip spindle, a spindle lock, and a decap pin retainer. Fits: Any pistol caliber (straight wall cartridges) Hornady Custom Grade Sizing Dies.',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ze1Colc--/l7npvymckptlw12eosxx.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bfc855a3-1179-4727-b698-13a491c93aa1',
		ProductID: '095351',
		ProductName: 'Lock-N-Load® Bullet Tube 40S&W/10mm Auto',
		UPC: '090255953510',
		PackagedQTY: '3',
		PackagedUOM: 'EA',
		ShelfHeight: '22',
		ShelfWidth: '5',
		ShelfDepth: '1',
		Weight: '0.850',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '22.000',
		CartonWidth: '5.000',
		CartonDepth: '1.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '48.59',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Cartridge: '40 S&W/10MM AUTO',
		Caliber: '10MM',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Lock-N-Load® Bullet Tubes for pistol bullets provide a handy, economical way to utilize bullet feeder dies on progressive presses without the complete bullet feeder hopper system. Tubes fit 40+ bullets depending on caliber and weight, and feature a window revealing when quantities are low. Sold in 3-packs.',
		ProductImage: 'http://images.salsify.com/image/upload/s--aoMN8a7F--/cdqyw15buoor2qqfkpii.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '66aaef33-973b-49c3-9793-e8f7fcd036c8',
		ProductID: '82044',
		ProductName: '300 Win Mag 180 gr InterLock® SP American Whitetail®',
		UPC: '090255820447',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820444',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.5',
		PalletQtyBoxes: '780',
		Retail: '51.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.452',
		MuzzleVelocity: '2960',
		MuzzleEnergy: '3502',
		SectionalDensity: '0.271',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime!  Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--laqZ7xgb--/lgaxnkxpk8bbqrbcynob.eps',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6f0dfc41-c102-480c-a052-65b51f8a1aab',
		ProductID: '82164',
		ProductName: '300 PRC 190 gr. CX™ Outfitter®',
		UPC: '090255821642',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.740',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821649',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.4',
		PalletQtyBoxes: '780',
		Retail: '80.21',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.575',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '3797',
		SectionalDensity: '0.286',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '190',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--Xdu3kBnz--/k7cxd6a5romzycmxayfy.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '53ed6e5e-1814-493d-9f01-cc86935a295e',
		ProductID: '75100',
		ProductName: 'Snapsafe® Premium Gun Cabinet (12 Gun)',
		UPC: '842631100137',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '55',
		ShelfWidth: '21.5',
		ShelfDepth: '17',
		Weight: '80.000',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '55.000',
		CartonWidth: '21.500',
		CartonDepth: '17.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '347.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'MEXICO',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--hVJ7IZAU--/v7luw6ll435oypg3fsf3.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gXXc6Exu--/bnqjajs5bj4ox4gh2mzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--5ws3zJ0j--/mze0soghddvuy6a0sf0h.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--C5VAZg-C--/ustk6dg0werbaqvqsbwp.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--n9j7gja---/wurv8uwvrbgbk61sdxc2.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--C5VAZg-C--/ustk6dg0werbaqvqsbwp.jpg',
		Videos: 'https://vimeo.com/370420587',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '368a752f-b72e-4c85-a634-32831d5db239',
		ProductID: '390946',
		ProductName: 'Trimer Pilot #4 .257',
		UPC: '090255909463',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255909460',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '6.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® trimmer pilots are interchangeable in the Hornady Cam Lock Trimmer. Use our sizing charts to find the sizes you need.',
		ProductImage: 'http://images.salsify.com/image/upload/s--R1b-v7hQ--/e05jfohb5ciroleyoyhv.png',
		DateLastModified: '2023-12-16 08:59:10',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '73df2e5e-7cd8-4ba1-8702-a0a5e2fa35cb',
		ProductID: '92755',
		ProductName: '357 Mag 140 gr FTX® LEVERevolution®',
		UPC: '090255927559',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '1.875',
		ShelfWidth: '2.375',
		ShelfDepth: '2.5',
		Weight: '0.926',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255927556',
		CartonHeight: '2.875',
		CartonWidth: '5.312',
		CartonDepth: '10.750',
		CartonWeight: '9.26',
		PalletQtyBoxes: '1120',
		Retail: '41.59',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'LEVERevolution® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.169',
		MuzzleVelocity: '1440',
		MuzzleEnergy: '645',
		SectionalDensity: '0.157',
		Cartridge: '357 MAG',
		Caliber: '38 CAL',
		BulletDiameter: '0.357',
		BulletName: 'FTX®',
		BulletWeightGrain: '140',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'LEVERevolution® represents a breakthrough in ammo design for lever action rifles and revolvers. The key to its innovation and performance is the patented elastomer Flex Tip® technology of the FTX® and MonoFlex® bullets. Safe to use in tubular magazines, these bullets feature higher ballistic coefficients and deliver dramatically flatter trajectory for increased down range performance.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns. FLEX TIP® TECHNOLOGY The patented Flex Tip® technology of the FTX® and MonoFlex® bullets provide higher ballistic coefficients and velocity increases of up to 250 fps over traditional flat point loads while still providing shock-absorbing safety in tubular magazines.  MODERN PROPELLANTS New propellants provide maximum muzzle velocity at conventional pressures, resulting in flatter trajectories and more downrange energy. Exceptional accuracy and overwhelming downrange terminal performance.  OVERWHELMING PERFORMANCE LEVERevolution® ammunition outperforms conventional loads for high weight retention, delivering up to 40% more energy than traditional flat point bullets. The higher ballistic coefficients of the FTX® and MonoFlex® bullets produce consistently flatter trajectories than conventional bullets and provide overwhelming downrange terminal performance. MONOFLEX® Combining the technologies of the GMX® and patented FTX® bullet design, the MonoFlex® bullet is a union of successful bullet designs from Hornady®. An innovative bullet choice is now available for the famed Hornady® LEVERevolution® ammunition line. Constructed of a copper alloy, MonoFlex® bullets will never separate, and when recovered, retain 95+% of their original weight. Deep penetration. High weight retention. Unbeatable power.  In handguns, hollow point bullets typically deliver good performance at modest velocities, but expand too quickly and sacrifice penetration at higher velocities. Hornady® Flex Tip® technology allows the bullet to expand reliably from 800 to 2000+ fps.  NOTE: The innovative LEVERevolution® FTX® and MonoFlex® bullet designs may require a newer magazine follower to provide best possible functioning of the last round out of the magazine in certain guns.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SDxcCCbh--/afdb42a39240036e5206afe89130ee34eb87ef81.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--bIJzWtxH--/8bf6dc99a6b60750582aa6555828e7d1c5f5dd0d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--dp4Iu-Xp--/yw6cydorzeeqxu93ubw0.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U4V2I0ER--/lomhks9gueh1pyefhoh6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DSxo9IKm--/usdhya1fnn7ubkxlzntg.jpg',
		Videos: 'https://vimeo.com/182562264',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'bbff8721-539d-475a-834c-62bc95c8f0a3',
		ProductID: 'B300P',
		ProductName: 'Lock-N-Load® 300 PRC Modified Case',
		UPC: '090255712803',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255712800',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '48bedec1-40d9-4170-84c2-cfc8983f71e0',
		ProductID: '95782',
		ProductName: 'Square-Lok™ Bin',
		UPC: '090255957822',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '14.5',
		ShelfDepth: '6.75',
		Weight: '3.150',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957829',
		CartonHeight: '31.100',
		CartonWidth: '14.960',
		CartonDepth: '7.480',
		CartonWeight: '15.75',
		PalletQtyBoxes: '0',
		Retail: '34.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you. 12"W x 4.5"H x 4.5" D',
		ProductImage: 'http://images.salsify.com/image/upload/s--4-U_Jj2l--/v7tmnhtkyckfgh0hdqbu.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Vp8H1o3a--/n4ife1kqn0psi79l5suw.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cd36a964-8dca-4e01-bcaf-c8df9d61706a',
		ProductID: '728',
		ProductName: 'Lock-N-Load® 28 Insert (.284/7mm)',
		UPC: '090255704402',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704409',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '5.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Bullet Comparator',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with the Lock-N-Load® Bullet Comparator.',
		ProductImage: 'http://images.salsify.com/image/upload/s--MgY31g9F--/jyp2ys8yrdztor8acgy7.png',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '00149471-db27-4f35-afcc-c3d148261f6f',
		ProductID: '050098',
		ProductName: 'Lock-N-Load® Primer Tube Filler',
		UPC: '090255500981',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '11.5',
		ShelfDepth: '17.5',
		Weight: '1.050',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255500988',
		CartonHeight: '10.500',
		CartonWidth: '11.500',
		CartonDepth: '17.500',
		CartonWeight: '5.25',
		PalletQtyBoxes: '160',
		Retail: '104.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Progressive Presses & Accessories',
		CountryofOrigin: 'USA*',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--YOi-oYbR--/evzbgyoczqgmo6mzlwxh.pdf',
		ProductDescription:
			'Shorten your primer tube filling times with this fast and fun Hornady® 1911 Auto™ Primer Tube Filler. The ergonomic handle positions the tray at an optimum angle for feeding primers and fills a 100-count primer tube in 10-15 seconds. Includes small and large trays and tubes. Batteries not included.',
		ProductImage: 'http://images.salsify.com/image/upload/s--9wN27ODs--/xevpuvk57pptmla98kie.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b3624eb4-33c4-40ba-87c6-6fb9b3488e84',
		ProductID: '41697',
		ProductName: '416 Cal .416 500 gr A-TIP Match',
		UPC: '090255416978',
		PackagedQTY: '25',
		PackagedUOM: 'BX',
		ShelfHeight: '3.25',
		ShelfWidth: '2.63',
		ShelfDepth: '2.63',
		Weight: '2.038',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255416975',
		CartonHeight: '3.500',
		CartonWidth: '7.000',
		CartonDepth: '14.375',
		CartonWeight: '20.38',
		PalletQtyBoxes: '600',
		Retail: '56.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.976',
		G7BC: '0.492',
		MinTwist: '1-12"',
		SectionalDensity: '0.413',
		OAL: '2.115',
		Caliber: '416 CAL',
		BulletDiameter: '0.416',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '500',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--3zYFjput--/gzkqciitnoalvrtu2auk.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0745571a-f813-4fa6-b2a7-32b0a687890b',
		ProductID: '060008',
		ProductName: 'Large Decapping Pin (6 Pk)',
		UPC: '090255600087',
		PackagedQTY: '6',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.018',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255600084',
		CartonHeight: '1.000',
		CartonWidth: '7.000',
		CartonDepth: '6.000',
		CartonWeight: '0.18',
		PalletQtyBoxes: '0',
		Retail: '14.47',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--SC-WBhd8--/bz7k4i2m2zcnqwkyza8j.jpg',
		DateLastModified: '2023-12-16 08:58:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c4e98397-c508-4194-9934-cbd756e528c6',
		ProductID: '95787',
		ProductName: 'Square-Lok™ 12" Panel',
		UPC: '090255957877',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.25',
		ShelfWidth: '14',
		ShelfDepth: '20.3',
		Weight: '9.950',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957874',
		CartonHeight: '21.030',
		CartonWidth: '14.960',
		CartonDepth: '16.930',
		CartonWeight: '49.75',
		PalletQtyBoxes: '0',
		Retail: '66.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you. 12" W x 18" H',
		ProductImage: 'http://images.salsify.com/image/upload/s--XEEsg3EX--/glxzwgq2xnlogo1vkjxp.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aBx5Qbfu--/cubmlakhrazllm8dizgs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2c6bd4b6-7a32-4853-abcf-7e7133fbcccb',
		ProductID: '355771',
		ProductName: '9mm .355 124 gr FMJ RN',
		UPC: '090255700954',
		PackagedQTY: '500',
		PackagedUOM: 'BX',
		ShelfHeight: '3.5',
		ShelfWidth: '4.125',
		ShelfDepth: '5.375',
		Weight: '9.283',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255700951',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '55.698',
		PalletQtyBoxes: '216',
		Retail: '111.24',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'FMJ Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.145',
		SectionalDensity: '0.141',
		OAL: '0.595',
		Caliber: '9MM',
		BulletDiameter: '0.355',
		BulletName: 'FMJ-RN',
		BulletWeightGrain: '124',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Full Metal Jacket Hornady® FMJ handgun bullets have long served as a standard for target shooting applications. Hornady® FMJ bullets are built with a rugged jacket and the difference in performance is clear. The thinly plated full metal jacket from other manufacturers is easily distorted and often breaks or separates when the bullet impacts the target.  Hornady® FMJ bullets are carefully designed and manufactured to give superior functioning in semi-automatic handguns, and they deliver match-grade accuracy! BUILT FOR COMPETITION Expansion isn't an issue in action pistol shooting, so we removed the expansion-aiding skives. The result is a bullet that delivers the accuracy its sleek appearance promises.  NO EXPOSED LEAD A jam can cost the match for a competitive shooter, and that's why our jacket protects the nose of our FMJ bullet.  SWAGED CORE The core of the FMJ bullet is cold swaged from pure lead to deliver consistency, balance and stability in flight. It delivers pinpoint accuracy with every shot.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--8OpniQoC--/eata6v2004nng1ssagx4.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Q351jtA8--/dcc3e2d33067ee2924440eeedc0237fe1355d07b.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--VVSDvmpm--/o58reht2v7xrnlokspnx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--887mVprN--/smvbvdyjdmmesfa9371u.jpg',
		DateLastModified: '2023-12-16 08:59:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ab3f396-9ead-4f99-8fe9-3cccf7094467',
		ProductID: '8654',
		ProductName: '300 PRC Unprimed Cases',
		UPC: '090255486544',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.950',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486541',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '9.75',
		PalletQtyBoxes: '200',
		Retail: '78.59',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8a2811af-395f-4383-96f9-5fee8182b084',
		ProductID: '98201',
		ProductName: 'Hornady® Rapid Rack® AR-15 (223)',
		UPC: '090255982015',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '7.75',
		ShelfWidth: '5.25',
		ShelfDepth: '0.5',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255982012',
		CartonHeight: '8.250',
		CartonWidth: '6.250',
		CartonDepth: '3.500',
		CartonWeight: '1.5',
		PalletQtyBoxes: '0',
		Retail: '15.99',
		ParentCategory: 'Shop',
		ProductLine: 'Hornady® Rapid Rack®',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Grip it and rip it with the Hornady® Rapid Rack®, an empty chamber indicator that also operates as a load-assist device for those who prefer to keep their long gun ready with a fully charged magazine and a visibly empty chamber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--ps06KinC--/lnmjlllcs5ezd51o5aal.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--MOVi9UyE--/dzo5sairvx9dbd8epsqf.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--vwHJWaHk--/ekqftobiqpx0t9ojf6aj.jpg',
		Videos: 'https://vimeo.com/163450461',
		DateLastModified: '2023-12-16 09:09:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a12beeb5-8915-44b5-bd49-08966daea74c',
		ProductID: '594259',
		ProductName: 'Match™ Grade Bushing .259',
		UPC: '090255592597',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592594',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.259',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--voB6UsI2--/7989115dbb2b786dac1c5b35f55ea20188736b13.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd1035b1d-2286-4c40-90b1-42d258df46d9',
		ProductID: '044166',
		ProductName: 'Seater Die (.430) 44 Spl Cowboy™',
		UPC: '090255441666',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.700',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441663',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--kFog5u3d--/pgvmtownv8s0p1cqbh8y.png',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c3248b3c-e0a2-4f82-9869-9a438f8a63db',
		ProductID: 'FR102',
		ProductName: '223 Remington 55 gr FMJ Frontier®',
		UPC: '090255711271',
		PackagedQTY: '150',
		PackagedUOM: 'BX',
		ShelfHeight: '3.75',
		ShelfWidth: '6.453',
		ShelfDepth: '3.656',
		Weight: '4.125',
		WeightUOM: 'LB',
		CaseQty: '4',
		CartonUCC: '10090255711278',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '16.5',
		PalletQtyBoxes: '480',
		Retail: '75.00',
		ParentCategory: 'Ammunition',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		SectionalDensity: '0.157',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C',
		BulletWeightGrain: '55',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		Packaging: 'LOOSE',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--2tkGzR8c--/75d17823a235aca2a8c4cde8fb96e331659b7388.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '77d780e9-3e83-4fc8-a97f-222b7b9d0919',
		ProductID: '546364',
		ProductName: 'Full-Length 2-Die Set 32/20 Win (.312)',
		UPC: '090255563641',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.385',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563648',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '6.925',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '32-20 WIN',
		Caliber: '303 CAL',
		BulletDiameter: '0.312',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '35b92e1c-1d7b-4531-ad33-b25c14261579',
		ProductID: '95840',
		ProductName: 'Hornady® 8 Gun Pistol Rack',
		UPC: '090255958409',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '20.75',
		ShelfWidth: '9.5',
		ShelfDepth: '8.5',
		Weight: '2.330',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255958406',
		CartonHeight: '8.000',
		CartonWidth: '18.500',
		CartonDepth: '7.200',
		CartonWeight: '11.65',
		PalletQtyBoxes: '350',
		Retail: '20.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '6.25',
		ProductExtWidth: '18',
		ProductExtDepth: '7',
		ProductWeight: '2.3',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Store guns in your safe or anywhere with these handy gun racks made in four different widths. The rack helps maximize storage space while offering a secure and balanced rack designed for compact pistols, full-size handguns, revolvers, and semi-autos. Its PVC coating prevents scratches or marring. Store guns right side up or upside down, depending on your preference. Ability to maximize storage space while offering a secure and balanced rack. Designed for compact pistols, full size handguns, revolvers and semi autos. Option to store guns right side up or upside down. PVC coating won’t scratch or damage handgun’s finish. Free up room in your gun safe or cabinet. Use at the range to hold handguns while not in use.  Dimensions 8-Gun Rack: 5.1"H x 18"W x 6.7"D CALIFORNIA RESIDENTS  WARNING WARNING: This product can expose you to DI(2-Ethylhexyl) Phthalate, which is know to the State of California to cause cancer, birth defects, or other reproductive harm. For more information go to www.p65warnings.ca.gov.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IxFs2Zxl--/g8hhojmwjwyeytsjiysg.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Lqsqh4mN--/gjzbzbm2ba4l7e7odkkd.png',
		Videos: 'https://vimeo.com/294885397',
		DateLastModified: '2023-12-16 09:09:37',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c10d7299-3b31-4441-b1b9-5aa679d07904',
		ProductID: '99393',
		ProductName: 'Hornady® Blaze Orange Beanie',
		UPC: '090255993936',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '0.25',
		ShelfWidth: '8',
		ShelfDepth: '8.5',
		Weight: '0.010',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--5SDr6rsg--/njhajmay98tx8fzmi56l.png',
		DateLastModified: '2023-12-16 09:09:43',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '73371c35-2237-42b3-8de1-a058c79f87ef',
		ProductID: '390605',
		ProductName: 'Shell Holder #49',
		UPC: '090255906059',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.500',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255906056',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '5.0',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a728dfdb-4aeb-4bf9-bcf1-f464cc153f68',
		ProductID: '75800',
		ProductName: 'Snapsafe® Door Organizer',
		UPC: '851529004280',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '26.25',
		ShelfWidth: '10.25',
		ShelfDepth: '3.5',
		Weight: '5.440',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004287',
		CartonHeight: '21.500',
		CartonWidth: '9.800',
		CartonDepth: '26.600',
		CartonWeight: '27.2',
		PalletQtyBoxes: '100',
		Retail: '45.99',
		ParentCategory: 'Security',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackUCC: '30851529004281',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--qYfr2ChX--/u4dm4kadtitbsyrdcdyc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--IptIQa0n--/ekvcackzhppifgpfxaaa.jpg',
		Videos: 'https://vimeo.com/221428605',
		DateLastModified: '2023-12-16 09:06:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd3e77ab7-fb7b-4f23-b314-f85777f4ff0c',
		ProductID: '546205',
		ProductName: 'Full-Length 2-Die Set 20 Vartarg (.204)',
		UPC: '090255562057',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562054',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '20 VT',
		Caliber: '20 CAL',
		BulletDiameter: '0.204',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '2e6ddcba-9fd9-4f23-b264-6d9df42d61fd',
		ProductID: '87176',
		ProductName: '327 Federal Magnum Unprimed Cases',
		UPC: '090255871760',
		PackagedQTY: '200',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '3.25',
		Weight: '1.710',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255871767',
		CartonHeight: '4.687',
		CartonWidth: '8.312',
		CartonDepth: '17.562',
		CartonWeight: '8.55',
		PalletQtyBoxes: '200',
		Retail: '71.59',
		ParentCategory: 'Cartridge Cases',
		Cartridge: '327 FEDERAL MAG',
		Caliber: '32 CAL',
		BulletDiameter: '0.312',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f302ba13-bd4f-4379-a427-9a6165e4e34f',
		ProductID: '82247',
		ProductName: '450 Bushmaster 395 gr Sub-X® Subsonic',
		UPC: '090255822472',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.855',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822479',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '18.55',
		PalletQtyBoxes: '930',
		Retail: '52.51',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Hornady® Subsonic Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.300',
		MuzzleVelocity: '1050',
		MuzzleEnergy: '967',
		SectionalDensity: '0.276',
		Cartridge: '450 BUSHMASTER',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'SUB-X®',
		BulletWeightGrain: '395',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shhh... tell everyone! Hornady® Subsonic Ammunition — designed for accuracy and performance below the speed of sound — now comes in both rifle and handgun loads.  Subsonic Handgun utilizes tried-and-true XTP® bullets that expand reliably at subsonic velocities. The Sub-X bullet used in Subsonic Rifle features a lead core. Long grooves in its gilding metal jacket combine with the bullet’s flat profile and the patented Flex Tip® insert within its hollowpoint cavity to help it expand reliably at low velocities.  Powders are selected for optimal performance and consistency from lot to lot. PROVEN PERFORMANCE Performance of 300 Blackout Subsonic meets or exceeds FBI Protocol terminal ballistic test requirements. The XTP® bullet in Subsonic Handgun has built a world-class reputation for accuracy and stopping power.  SILENT AND STEALTHY Hornady® Subsonic Ammunition doesn’t have the loud report of a supersonic round, and paired with a suppressor, it’s even quieter. Unique powders optimized for subsonic use result in a low flash signature, ideal for either suppressed or unsuppressed performance.  HIGH-QUALITY COMPONENTS With high-quality cartridge cases and primers, Subsonic Ammunition offers the performance and accuracy shooters have come to expect from Hornady. Disclaimer: This is subsonic, i.e., reduced velocity ammunition and will not produce the same muzzle energy as conventionally loaded cartridges. If hunting with this product, be sure to read, understand and comply with all applicable regulations and laws pertaining to bullet energy and/or muzzle velocity for the area and game to be hunted.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--c2oGeYs_--/wnbpikxtswatfcbcu01l.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--6p0FOyE1--/aczys166v7qn8nocesnj.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--NsEbqDaR--/w9pxeuxpfocyjo3v5b49.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--o57pFF14--/vh11iaoohy5brcgtamzx.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--oXoa9e2M--/v4dvpvgndlzaesjtbqui.jpg',
		Videos: 'https://vimeo.com/238318324',
		Videos1: 'https://vimeo.com/368031042',
		Videos2: 'https://vimeo.com/257722661',
		Videos3: 'https://vimeo.com/242146498',
		Videos4: 'https://vimeo.com/396530834',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0963b8dd-5264-4eb3-88ae-524764caadea',
		ProductID: '594313',
		ProductName: 'Match™ Grade Bushing .313',
		UPC: '090255593136',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.220',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255593133',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.2',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '303 CAL',
		BulletDiameter: '0.313',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hj3GUyK7--/5a24df1b430ea7b35a1c8d2e761a4316dd8dada3.jpg',
		DateLastModified: '2023-12-16 09:06:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e04ddbff-fe53-4fb4-9279-1b3a9e14d13e',
		ProductID: '046460',
		ProductName: 'Full-Length Size Die 44/40 Win Cowboy™(.429)',
		UPC: '090255464603',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464600',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '60.51',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Three-Die Handgun Die Sets',
		Cartridge: '44-40 WIN',
		Caliber: '44 CAL',
		BulletDiameter: '0.429',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dcb8cf4f-96d4-40fe-b435-7d3f0064dbd9',
		ProductID: '546348',
		ProductName: 'Full-Length 2-Die Set 300 Sav (.308)',
		UPC: '090255563481',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.414',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563488',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.07',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '300 SAVAGE',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dfebd455-72dd-4396-9275-60d434b7540a',
		ProductID: '75415',
		ProductName: 'Snapsafe® Vault Door (36" X 80")',
		UPC: '851529004464',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '14.25',
		ShelfWidth: '87',
		ShelfDepth: '44.5',
		Weight: '410.000',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '14.240',
		CartonWidth: '87.000',
		CartonDepth: '44.500',
		CartonWeight: '410.0',
		PalletQtyBoxes: '1',
		Retail: '1819.00',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Vault Doors',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA OR VIETNAM',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		BatteryType: '9V',
		BatteryQty: '1',
		BatteryWattHour: '5.49',
		BatteryWeight: '33.9',
		LithiumBattery: 'No',
		Packaging: 'Crate',
		ProductExtHeight: '80',
		ProductExtWidth: '36',
		ProductExtDepth: '6.3',
		ProductWeight: '350',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Enhance the security of any closet, room, or storm shelter with the SnapSafe Vault Door. Its thick steel construction and easy installation allow an effective and affordable way to protect an existing area from theft and unintended intrusion.  Your SnapSafe vault door comes standard with a SecuRam™ digital lock with key backup. 12 gauge door and door frame. Nine 1" live locking bolts. SecuRam™ digital lock with key backup (standard). Steel trimmed exterior. All tools and hardware are included in the handy tool kit. For Standard 36" door opening  Door height: 81" Inside clearance width: 31.4" Outside width: 36.8" Designed for 38"x82" rough opening Weight: 350 lbs',
		ProductImage: 'http://images.salsify.com/image/upload/s--GbSh0fbR--/jrcnbfsc7hfjddll6znz.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--nTfLwYSI--/r7pjmjvnedw49qjeaud7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--u6Vw40g4--/yhn2shzsycr25fgv26nn.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--mLJvifI6--/oh73hx7o7yb0gt6mnqnv.pdf',
		Videos: 'https://vimeo.com/213867331',
		Videos1: 'https://vimeo.com/370420587',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8b6c4053-c954-4732-a7a2-c2e348047fce',
		ProductID: '546346',
		ProductName: 'Full-Length 2-Die Set 300 H&H Mag (.308)',
		UPC: '090255563467',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563464',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '300 H&H MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '098617f5-b397-4608-9e49-d5dd0e65070c',
		ProductID: '82304',
		ProductName: '9.3 x 74R 286 gr InterLock® SP-RP Dangerous Game™ Series',
		UPC: '090255823042',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '1.826',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255823049',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '10.956',
		PalletQtyBoxes: '396',
		Retail: '158.81',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.4',
		MuzzleVelocity: '2360',
		MuzzleEnergy: '3537',
		SectionalDensity: '0.305',
		Cartridge: '9.3X74R',
		Caliber: '9.3 CAL',
		BulletDiameter: '0.366',
		BulletName: 'SP-RP INTERLOCK®',
		BulletWeightGrain: '286',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--WeWMuSz0--/eda29cd14f46f225e95d96a6a36fa2a9086e3096.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2023-12-16 09:06:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a451f7ec-f3f3-444d-b6d7-f5c89dc8aab7',
		ProductID: '046450',
		ProductName: 'Full-Length Size Die 270 Win Short Mag (.277)',
		UPC: '090255464504',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.536',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255464501',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '54.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series I Two-Die Rifle Die Sets',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:38',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ecf36af-b74b-403b-99f9-83ba62c00422',
		ProductID: '82084',
		ProductName: '300 Rem Ultra Mag 180 gr. CX™ Outfitter®',
		UPC: '090255820843',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.730',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255820840',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.3',
		PalletQtyBoxes: '780',
		Retail: '121.51',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.469',
		MuzzleVelocity: '3200',
		MuzzleEnergy: '4093',
		SectionalDensity: '0.271',
		Cartridge: '300 REM ULTRA MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'CX™',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--i24VDUSA--/xikft9bhf2y3rhhd0n8s.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '90ffb7a6-0fca-4b44-ac89-1e42188d6f1e',
		ProductID: '380066',
		ProductName: 'Case Neck Brush 270 Cal/7mm',
		UPC: '090255800661',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.026',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255800668',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.26',
		PalletQtyBoxes: '0',
		Retail: '7.99',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '270 CAL/7MM',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with the Lock-N-Load® Case Prep Trio, Case Prep Duo, Lock-N-Load® Power Case Prep Center, and Quick Change Hand Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--C_ir5Trz--/pfcimgqkynorlbgb1ug9.png',
		DateLastModified: '2023-12-16 08:59:02',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c8704a15-f014-4bd0-b367-9e0fa11e2d99',
		ProductID: '33209',
		ProductName: '338 Cal .338 225 gr InterBond®',
		UPC: '090255332094',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.180',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255332091',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '47.7',
		PalletQtyBoxes: '540',
		Retail: '112.99',
		ParentCategory: 'Bullets',
		Applications: 'AppDangerousGame',
		G1BC: '0.515',
		SectionalDensity: '0.281',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'INTERBOND®',
		BulletWeightGrain: '225',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The application of Hornady science to the art of hunting. The Hornady® InterBond® bullet uses a proprietary bonding process that holds the core and jacket together. Unlike partitioned or dual-core bullets, where the front core can separate from the bullet mass, the InterBond® bullet holds together in a single destructive mass that delivers a deep, wide wound channel without over-penetrating.  The bonding process, along with a thicker, stiffer jacket, allows InterBond® bullets to retain more than 90% of their mass, even through tough hide and bones. Plus, they immediately expand to more than twice their diameter for maximum energy transfer. POLYMER TIP The sleek polymer tip improves ballistic performance, accuracy and initiation of expansion.  BONDED CORE Solid, one-piece lead core won't separate. The bonded design ensures the bullet achieves controlled expansion with virtually no fragmentation and the core will never separate from the jacket.  THICK, TOUGH JACKET Necessary to retain weight and contributes to expansion of over twice the bullet diameter.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--c7TiELH1--/f2fc3683051b25e1afc74d207d8d70303dfe9084.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hyt_5FRg--/e97dadb3d69458cce782244c66377c51258e893c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--y6CSWNwW--/sxauopgh8fhc4hqmhmu8.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--E4sY3uPp--/b7tm6doq6jwzwecseolm.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--3I_BafKT--/ndt0lwn76gt7873ekbwd.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--aPkqkBTk--/qzdatpiecmh8qyc0c4o5.jpg',
		Videos: 'https://vimeo.com/359155855',
		Videos1: 'https://vimeo.com/145446303',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a3545fda-cff5-46f1-a6b7-8ac58f04a040',
		ProductID: '586055',
		ProductName: 'Powder Funnel Adapter 17 Cal',
		UPC: '090255860559',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.5',
		ShelfDepth: '2.75',
		Weight: '0.037',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255860556',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.37',
		PalletQtyBoxes: '0',
		Retail: '14.05',
		ParentCategory: 'Reloading',
		Caliber: '17 CAL',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fits on the end of Hornady’s funnel for the small 17 and the new 20 caliber necks. Also fits MTM and others.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--1wJVBNwi--/c535e0f56e23f34916ffc9bc3538b3d87d331870.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0ee63a13-741a-4b14-8104-65c73b972152',
		ProductID: '044722',
		ProductName: 'Taper Crimp Die 460 S&W',
		UPC: '090255447224',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.401',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255447221',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Taper Crimp Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--7B-xihm2--/jjy9n4s213vfrxn8pxip.jpg',
		DateLastModified: '2023-12-16 08:55:34',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '92dfd6eb-eac5-4f10-84e7-e03bc5edff7f',
		ProductID: '99125',
		ProductName: 'Hornady® 17" Neon Clock',
		UPC: '090255991253',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '17',
		ShelfWidth: '17',
		ShelfDepth: '3',
		Weight: '4.680',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '169.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DEHP',
		Prop65Chem2: 'Lead',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		BatteryType: 'AA',
		BatteryQty: '1',
		BatteryWattHour: '2.4',
		BatteryWeight: '23',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Light up any room with the Hornady® 17” Retro Neon Clock! Featuring a chrome frame, and red and white neon. The light runs via power cord and the clock requires AA batteries (not included).',
		ProductImage: 'http://images.salsify.com/image/upload/s--HpzMn73D--/hdi0kgazkesuwewa7kzm.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '8ef5f231-9f7c-4dea-9b06-f08575438486',
		ProductID: '82204',
		ProductName: '300 WSM 165 gr InterLock® American Whitetail®',
		UPC: '090255822045',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.560',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255822042',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '15.6',
		PalletQtyBoxes: '930',
		Retail: '51.92',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.435',
		MuzzleVelocity: '3130',
		MuzzleEnergy: '3589',
		SectionalDensity: '0.248',
		Cartridge: '300 WSM',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '165',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition.  Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy.  POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well.  CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--QJvcpzP1--/fe57653ee9254f92001dea99414ac3a0a343b0b9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6fec65f7-c8ea-4bae-9716-46dcb259d8e7',
		ProductID: '050090',
		ProductName: 'Kinetic Bullet Puller',
		UPC: '090255500905',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '13',
		ShelfWidth: '7',
		ShelfDepth: '1.5',
		Weight: '0.400',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255500902',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '4.0',
		PalletQtyBoxes: '0',
		Retail: '34.95',
		ParentCategory: 'Reloading',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Removes bullets from cartridges without damaging the bullets. The hollow head captures the bullet and powder for reuse. Can be used on any rifle or pistol cartridge up to 45 caliber.',
		ProductImage: 'http://images.salsify.com/image/upload/s--IwpzQMKC--/lfnrgcacwajkyqryeobf.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '18727fbf-03a8-49a7-b5e1-e81f81bd73f9',
		ProductID: '546375',
		ProductName: 'Full-Length 2-Die Set 7.92X33 Kurz (.323)',
		UPC: '090255563757',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563754',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '7.92X33 KURZ',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9a2b971a-bb32-4c7b-8aac-0d3a113e836b',
		ProductID: '805574',
		ProductName: '7mm WSM 150 gr. CX™ Outfitter®',
		UPC: '090255719802',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.125',
		ShelfDepth: '6.375',
		Weight: '1.460',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719809',
		CartonHeight: '7.000',
		CartonWidth: '7.062',
		CartonDepth: '8.250',
		CartonWeight: '14.6',
		PalletQtyBoxes: '930',
		Retail: '77.68',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Outfitter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '.455',
		MuzzleVelocity: '3150',
		MuzzleEnergy: '2864',
		SectionalDensity: '0.242',
		Cartridge: '270 WSM',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'CX™',
		BulletWeightGrain: '130',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Nickel-Plated',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Adventure Awaits! From the backcountry to the back-forty, trust your hunt to Outfitter® ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged CX™ bullet, Outfitter® ammunition is designed to perform under the toughest conditions. PROVEN CX™ BULLETS Copper alloy eXpanding) CX™ bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--RBWyxYYI--/agel4sekfr77egol5gbs.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--34zLFJMF--/hcdsnfgzg4erpns9ti1t.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--PyDC_i2E--/r3jsr8e5ta0ismbbgkst.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		Videos: 'https://vimeo.com/638865960',
		DateLastModified: '2023-12-16 09:06:13',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'eb966167-b519-40fa-8613-d898289fe1a0',
		ProductID: '041227',
		ProductName: 'Primer Pocket Single Stage Swage Tool (223/5.56)',
		UPC: '090255412277',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.25',
		ShelfWidth: '1.5',
		ShelfDepth: '1.5',
		Weight: '0.950',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '5.250',
		CartonWidth: '1.500',
		CartonDepth: '1.500',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '90.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Cartridge: '223 REM/5.56 NATO',
		Caliber: '22 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--rBTIVNAE--/eanslasndvj8o6jn7ntp.pdf',
		ProductDescription:
			'The Single-Stage Primer Pocket Swage Tool The Single Stage Primer Pocket Swage Tool quickly and cleanly removes crimps on cartridge case primer pockets. Available in 223/5.56 and 308/7.62x51 sizes, swage depth can be adjusted to accomodate various brands of cases. Swaging out the crimps instead of cutting them eliminates trims and mess. It is designed to be used on any compatible single stage press, and comes with swage tool, case handle, and shell holder to make your job easier.',
		ProductImage: 'http://images.salsify.com/image/upload/s--OEK_VmOa--/ckzvykpefidqwnnjhcrm.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4e888dd6-d95f-4e73-a77c-d554731bd623',
		ProductID: '010350',
		ProductName: '366 Auto Die Set 12 Ga 2-3/4',
		UPC: '090255013504',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.375',
		ShelfWidth: '7.625',
		ShelfDepth: '6.625',
		Weight: '2.459',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonUCC: '10090255013501',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '2.459',
		PalletQtyBoxes: '0',
		Retail: '436.33',
		ParentCategory: 'Reloading',
		Cartridge: '12 GA',
		Season: 'Seasonal',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--T_9cNez3--/nwcgqhrdvoo6hcilhku8.png',
		DateLastModified: '2023-12-16 08:55:29',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '896bdbf5-d688-4290-b902-28c6352e2189',
		ProductID: '8552',
		ProductName: '260 Rem 129 gr SST® Superformance®',
		UPC: '090255385526',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.105',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255385523',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.05',
		PalletQtyBoxes: '1400',
		Retail: '55.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '0.485',
		MuzzleVelocity: '2930',
		MuzzleEnergy: '2459',
		SectionalDensity: '0.264',
		Cartridge: '260 REM',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'SST®',
		BulletWeightGrain: '129',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_dprfxbw--/6c985b6fed2947d034d64dc1d7c56b6733f017d4.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7eddaca6-1c94-4695-89a6-ba8b967d1bb2',
		ProductID: '546378',
		ProductName: 'Full-Length 2-Die Set 8X68S (.323)',
		UPC: '090255563788',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563785',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '8X68S',
		Caliber: '8MM',
		BulletDiameter: '0.323',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f22e41e7-d2ce-4f04-99da-8be2171ba59c',
		ProductID: '546398',
		ProductName: 'Full-Length 2-Die Set 35 Rem (.358)',
		UPC: '090255563986',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.423',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563983',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.115',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '35 REM',
		Caliber: '35 CAL',
		BulletDiameter: '0.358',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0be17da7-7d68-41bf-b08f-92dac41e065b',
		ProductID: '45034',
		ProductName: '45 cal .458 480 gr DGX® Bonded',
		UPC: '090255450347',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.530',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255450344',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '52.95',
		PalletQtyBoxes: '540',
		Retail: '139.11',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.285',
		SectionalDensity: '0.327',
		OAL: '1.325',
		Cartridge: '450 NITRO EXP 3¼"',
		Caliber: '45 CAL',
		BulletDiameter: '0.458',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '480',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The DGX® Bonded (Dangerous Game™ eXpanding) bullet features a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. THICKER JACKET The thicker 0.098” copper-clad steel jacket of DGX® Bonded sets it apart from other dangerous game bullets, allowing it to tear through tough material like hide, muscle and bone.  CONTROLLED EXPANSION DGX® Bonded features a flat nose with serrated sections to deliver a uniform expansion from 100 to 150 yards and straight penetration, reducing possible deflections.  BONDED JACKET AND CORE The bonding process locks the jacket and lead core together, improving the retained weight of the expanded bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--0gVfZiRd--/5f51f96272b6d2178576aca4dd982e62c9c0b47a.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--gLVcdPOk--/1d682bc34ba7724c4cd818ab5bbeb0cb23de66c6.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hhYob9uu--/tea6iqy0ntdwysuqq9yn.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--mEifKhtK--/ertqaygn56enorti7yxk.png',
		DateLastModified: '2024-03-05 08:41:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1dc1ac44-fae0-4f09-8815-c11e1b2ac97e',
		ProductID: '190201',
		ProductName: 'Powder Bushing 489',
		UPC: '090255192018',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '2',
		ShelfDepth: '1',
		Weight: '0.058',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255192015',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.58',
		PalletQtyBoxes: '0',
		Retail: '10.65',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Powder Bushings',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Selecting Bushings for Half-Grain Charges: Hornady powder bushings are identified by numbers that correspond to the size of their inside diameter. (For instance, the inside diameter of the #456 bushing is .456 inches.) Bushings for powder charges in half-grain increments can be calculated from the downloadable chart. IMPORTANT: Due to agitation of powder during the loading operation, different models of loaders require different bushings. Therefore, the chartshould be used only for 366 Auto and Hornady’s APEX. Additional charts are published for other Hornady loaders. All charges listed on this chart are an average of several loads that were weighed following the complete reloading cycle. Powders used in establishing these loads were from samples supplied by the manufacturer. Charges may vary slightly due to operator’s technique and/or powder variables.',
		ProductImage: 'http://images.salsify.com/image/upload/s--bFeE5tsL--/g0coyh6rhlva7el0t0t1.png',
		DateLastModified: '2023-12-16 08:58:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'dcb9952a-1f1f-4766-b73e-2795f14551f1',
		ProductID: '9152',
		ProductName: '460 S&W Magnum 200 gr FTX®',
		UPC: '090255391527',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.239',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255391524',
		CartonHeight: '3.625',
		CartonWidth: '5.312',
		CartonDepth: '13.500',
		CartonWeight: '12.39',
		PalletQtyBoxes: '720',
		Retail: '59.32',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.151',
		MuzzleVelocity: '2200',
		MuzzleEnergy: '2149',
		SectionalDensity: '0.14',
		Cartridge: '460 S&W MAG',
		Caliber: '45 CAL',
		BulletDiameter: '0.452',
		BulletName: 'FTX®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--6-e7muV6--/8e11e2bc0b919faa413b980c7ce69ac35f4a06d9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '01755c1e-7cda-4d8d-9c12-278bbdde4694',
		ProductID: '82197',
		ProductName: '300 WIN Mag 180 gr GMX® Outfitter®',
		UPC: '090255821970',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821977',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '15.95',
		PalletQtyBoxes: '780',
		Retail: '68.33',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.485',
		SectionalDensity: '0.271',
		Cartridge: '300 WIN MAG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '180',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From the backcountry to the back-forty, trust your hunt to Outfitter™ ammunition. Featuring corrosion resistant nickel-plated cases that are sealed watertight and topped with the accurate and rugged GMX® bullet, Outfitter™ ammunition is designed to perform under the toughest conditions. PROVEN GMX® BULLETS Monolithic copper alloy GMX® bullet provides uniform, controlled expansion, deep penetration and +95% weight retention.  SEALED PRIMER AND CASE MOUTH Sealed primer and case mouth provide watertight protection.  WATERPROOFED CASES Nickel-plated cases are corrosion resistant and waterproofed to ensure protection from moisture.  VERSATILE PERFORMANCE California compatible and appropriate for other areas requiring nontraditional bullets.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FWrJf1rM--/93dd9577920f3392bbcec1bca18bd865a51e5751.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--Cyr-_ZQR--/1156755734d99ec1fca65d1d634ed8531ce5d2fa.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--BzKAOnlF--/rogxnkxv5fwtn9zqlq3q.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--hRVezS7o--/wauwswq4kf3eysojayx6.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--n0GoYOYa--/ybhjjgcjkkvyqdxlslxe.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--U3HcmZRL--/fgozwgkqsge5umsnpuhl.png',
		Videos: 'https://vimeo.com/368031429',
		Videos1: 'https://vimeo.com/343308040',
		Videos2: 'https://vimeo.com/302939114',
		Videos3: 'https://vimeo.com/295682086',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '749533f0-68a2-4579-a6b2-b6a98c512ce7',
		ProductID: '391921',
		ProductName: 'Neck Turn Mandrel 270 Cal .275',
		UPC: '090255919219',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255919216',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '14.85',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		Caliber: '270 CAL',
		BulletDiameter: '0.275',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'For use with Hornady® Neck Turn Tool.',
		ProductImage: 'http://images.salsify.com/image/upload/s--jGMDBYdo--/obtfhmmrjutczngsk74q.png',
		DateLastModified: '2023-12-16 08:59:11',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '58bc639e-731d-42ee-bb48-831e396036f6',
		ProductID: '095340',
		ProductName: 'Lock-N-Load® AP™ Rifle Bullet Feeder',
		UPC: '090255953404',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '10',
		ShelfWidth: '12',
		ShelfDepth: '21',
		Weight: '16.650',
		WeightUOM: 'LB',
		CaseQty: '1',
		CartonHeight: '10.000',
		CartonWidth: '12.000',
		CartonDepth: '21.000',
		CartonWeight: '16.65',
		PalletQtyBoxes: '0',
		Retail: '696.67',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Bullet & Case Feeder & Accessories',
		Caliber: '22 CAL',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		InstructionManual: 'http://images.salsify.com/image/upload/s--LQ71Cllu--/y6vu08z9an8ych2w9iq8.pdf',
		ProductDescription:
			'Turn your progressive reloading press into a bench mounted ammo factory! Sold as a complete unit for 22 caliber bullets We also offer a conversion kit for 30 caliber bullets, giving the reloader the versatility to load the two most popular calibers. Plus, it’s compatible with other presses and uses the industry standard 7/8"–14 die threads (30 Cal. Conversion Kit sold separately).  Coupled with the Lock-N-Load® Case Feeder, you’ll realize dramatic increases in efficiency and reloading speed — up to 50% faster (depending on experience and proficiency).  The Bullet Feeder Die is case activated; the bullet will only feed upon contact with the case. A single station is used to feed, seat, and crimp the bullet.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wDA23NoV--/zq4gv6uos26p5ufkf3s0.jpg',
		DateLastModified: '2023-12-16 08:58:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ad4b5964-cb22-4381-a7c4-2b615d0c4f8a',
		ProductID: 'A338',
		ProductName: 'Lock-N-Load® 338 Win Mag Modified Case',
		UPC: '090255704419',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.038',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255704416',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.38',
		PalletQtyBoxes: '0',
		Retail: '7.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "A" Cases',
		Cartridge: '338 WIN MAG',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--e8OVKlpI--/b121b825d92253df21687d8fa4b095638325dd4e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'cfc13c45-595a-4df9-8c87-2c11fc52a341',
		ProductID: '4241',
		ProductName: '423 Cal .423 400 gr DGS®',
		UPC: '090255242416',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.100',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255242413',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.5',
		PalletQtyBoxes: '540',
		Retail: '117.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.315',
		SectionalDensity: '0.319',
		OAL: '1.375',
		Caliber: '423 CAL',
		BulletDiameter: '0.423',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--I088F5Ms--/e0720bae53eb0aa9440f3ec0dfb5ac217012804d.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 09:02:46',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '472284de-8162-4456-857a-48c411078ef0',
		ProductID: '76012',
		ProductName: 'Snapsafe® Hanging Shelf Document Basket',
		UPC: '842631100267',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.5',
		ShelfWidth: '12',
		ShelfDepth: '9',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10842631100264',
		CartonHeight: '7.250',
		CartonWidth: '12.000',
		CartonDepth: '14.750',
		CartonWeight: '7.75',
		PalletQtyBoxes: '450',
		Retail: '29.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Chem2: 'DI(2-ETHYLHEXYL)PHTHALATE',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		ProductExtHeight: '2.5',
		ProductExtWidth: '12',
		ProductExtDepth: '9',
		ProductWeight: '1.55',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Ideal for gun safes, these coated wire baskets maximize storage for ammo and accessories. Simply slide onto a .5" - 1" thick shelf. Holds up to 40 pounds.    Easy Install Holds up to 40 pounds. Maximizes storage for ammo and accessories. Coated wire will not damage accessories. Dimensions: 12"W x 2.5"H x 9"D',
		ProductImage: 'http://images.salsify.com/image/upload/s--y3l17XCG--/i2kh6tfmrziuwgy5amlh.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Fo7lzQGB--/dzp91jzxuq1f5c9mrgmm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--9sNlRxNN--/dl2km72wxiei6rzxpybi.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--uR89_2AV--/egensng2dct2lr1k7t0a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--phm3NZXu--/vqe59lxhkooefsrjfidp.jpg',
		Videos: 'https://vimeo.com/213931086',
		DateLastModified: '2023-12-16 09:06:08',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '88239a0e-b48d-4762-8d30-b48b1a3fdb75',
		ProductID: '75230',
		ProductName: 'Snapsafe® Lock Box With Combination Lock LG',
		UPC: '851529004327',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.75',
		ShelfWidth: '7',
		ShelfDepth: '10.25',
		Weight: '4.000',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10851529004324',
		CartonHeight: '10.500',
		CartonWidth: '7.500',
		CartonDepth: '11.750',
		CartonWeight: '20.0',
		PalletQtyBoxes: '500',
		Retail: '45.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Lock Boxes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '1.75',
		ProductExtWidth: '6.5',
		ProductExtDepth: '9.5',
		ProductWeight: '4',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The SnapSafe® Lock Box provides secure storage for handguns and other valuables at home, on a nightstand, in the car, or when traveling. All SnapSafe Lock Boxes come with a heavy duty 1500 lb. rated steel cable that secures to any stationary object including a vehicle seat or heavy piece of furniture. The patented, space-saving receiver of the cable allows maximum storage space inside the box. The Lock Box also provides security for concealed carry permit holders. SPECIFICATIONS Dimensions: 9.5” x 6.5” x 1.75” Weight: 4 lbs.  FEATURES Easy to operate combination lock mechanism. 1500 lb. rated 4 ft. steel security cable Protective foam interior. Thick 16 gauge steel housing is durable and pry resistant. Meets TSA airline guidelines for firearms storage*. Approved by the California Department of Justice for firearms storage*. *IMPORTANT: Check TSA regulations and airline policies before traveling with any portable safe. Check dimensions of your firearm against safe's internal dimensions to ensure fit. Do not store loaded firearms in any safe or lock box. Follow local laws for firearm storage.",
		ProductImage: 'http://images.salsify.com/image/upload/s--85qvePgd--/fxlwlqsew1wnwzoyurja.png',
		Videos: 'https://vimeo.com/213867246',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '858d369c-62c0-4c1f-9487-33234b613c57',
		ProductID: '046599',
		ProductName: 'Full Length Die 6mm GT (.243)',
		UPC: '090255465990',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonWeight: '0.0',
		Retail: '64.01',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '6MM GT',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackUCC: '10090255465997',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning. With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”. This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers. *Other accessories sold separately. HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		DateLastModified: '2023-02-08 11:22:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6543b8bd-d6c5-415b-8736-d4f93dd98027',
		ProductID: '390546',
		ProductName: 'Shell Holder #6',
		UPC: '090255905465',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.046',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905462',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.46',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '64819e72-ac50-46d8-8e86-5e3c87591f3d',
		ProductID: '27200',
		ProductName: '270-6.8mm .277 110 gr BTHP with cannelure',
		UPC: '090255601657',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.800',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255601654',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '45.0',
		PalletQtyBoxes: '900',
		Retail: '45.48',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.36',
		SectionalDensity: '0.205',
		OAL: '1',
		Caliber: '6.8MM/270 CAL',
		BulletDiameter: '0.277',
		BulletName: 'BTHP MATCH™ W/C',
		BulletWeightGrain: '110',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--s81-7Ya---/fe212d55ac328dedab063c973e847d0b4cf6a021.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:55',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '63df08fb-1bb6-4d4d-a1ef-01bc5cb4613f',
		ProductID: 'FR2005',
		ProductName: '5.56 NATO 55 gr FMJ (M193) Frontier',
		UPC: '090255715248',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.438',
		ShelfWidth: '2.45',
		ShelfDepth: '3.75',
		Weight: '1.380',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255715245',
		CartonHeight: '13.250',
		CartonWidth: '8.000',
		CartonDepth: '3.250',
		CartonWeight: '13.8',
		PalletQtyBoxes: '1190',
		Retail: '43.25',
		Brand: 'Frontier®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Frontier® 5.56 NATO Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppPersonalDefense',
		G1BC: '0.243',
		MuzzleVelocity: '3240',
		MuzzleEnergy: '1282',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'FMJ-BT W/C (XM193)',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'American made and built on tradition – these are the hallmarks of Frontier® Cartridge. Frontier® Cartridge features Hornady bullets and is available in 223 Rem, 5.56 NATO, 300 Blackout and 6.5 Grendel. Applications range from plinking, target shooting and hunting to law enforcement training and self-defense. CONSISTENCY IN EVERY CARTRIDGE State-of-the-industry loading techniques and quality control procedures ensure the reliability of every Frontier® Cartridge round.  ROUNDS FOR ALL APPLICATIONS Frontier® Cartridge offers ammunition configured for a wide range of shooters and applications, everything from plinking, target shooting and hunting to law enforcement training and self-defense.  BRASS CASES In addition to Hornady® target friendly, non-steel core bullets in a variety of offerings, Frontier® Cartridge features brass cartridge cases and military-grade boxer primers and propellant.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--SCA6hzTu--/cf861648d09b87c3673b921557aa3c46104b05af.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--II9OOfAb--/2c336eccf0dbad60d0136545c8c5d172c5cc88af.jpg',
		DateLastModified: '2023-12-16 08:55:26',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1b1873ea-35ca-4cd6-8f0a-f969e81d7c45',
		ProductID: '546432',
		ProductName: 'Full-Length 2-Die Set 6mm Rem BR (.243)',
		UPC: '090255564327',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564324',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6MM BR REM',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0d9c2d3f-fa88-4bfa-9f47-14924e412305',
		ProductID: '95785',
		ProductName: 'Square-Lok™ Vertical Gun Rack (3-Gun)',
		UPC: '090255957853',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.5',
		ShelfWidth: '14',
		ShelfDepth: '14.25',
		Weight: '5.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255957850',
		CartonHeight: '33.660',
		CartonWidth: '14.760',
		CartonDepth: '14.760',
		CartonWeight: '27.75',
		PalletQtyBoxes: '0',
		Retail: '53.99',
		Brand: 'Hornady®',
		ParentCategory: 'Security',
		ProductLine: 'Hornady Security® Accessories',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Utilize your space your way with the revolutionary Square-Lok™ modular organizing system. Square-Lok accessories lock in easily and hold firmly for countless storage configurations. Choose the pieces you need and the arrangement that works best for you.',
		ProductImage: 'http://images.salsify.com/image/upload/s--50RZnehm--/bberhlb94hojrybvc3nf.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ezHN5Zow--/nhytmgrzci1zny1frp4a.jpg',
		Videos: 'https://vimeo.com/763816846',
		DateLastModified: '2023-12-16 09:09:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0e1f3c35-1ac6-42fc-a54d-c3e1ecad7b2f',
		ProductID: '83180',
		ProductName: '17 Win Super Mag 20 gr V-MAX® Varmint Express® Rimfire',
		UPC: '090255831801',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.5',
		ShelfDepth: '4.625',
		Weight: '0.555',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255831808',
		CartonHeight: '4.680',
		CartonWidth: '5.180',
		CartonDepth: '12.870',
		CartonWeight: '5.55',
		PalletQtyBoxes: '1840',
		Retail: '28.81',
		ParentCategory: 'Ammunition',
		Applications: 'AppVarmint',
		G1BC: '0.185',
		SectionalDensity: '0.097',
		Cartridge: '17 WSM',
		Caliber: '17 CAL',
		BulletDiameter: '0.172',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '20',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'From prairie dogs to coyote and fox, the Hornady® Rimfire line of ammunition offers varmint hunters high speed rimfire cartridges. Loaded with either the V-MAX® or NTX® bullet, these loads deliver tack-driving accuracy and dramatic expansion on impact. PROVEN BULLETS Hornady V-MAX® and NTX® bullets consistently achieve accuracy and rapid fragmentation at all practical varmint shooting velocities.  POWDER Each cartridge is loaded to ensure optimal pressure, velocity, accuracy and lot-to-lot consistency.  SELECT BRASS Hornady produces most of the brass for our Varmint Express® ammunition. Brass is chosen to ensure it meets our high standards for reliable feeding, corrosion resistance, proper hardness, and the ability to withstand maximum chamber pressures.  PRIMERS Like the powder, each primer is carefully matched to individual loads, and all are chosen for their ability to quickly, completely and reliably ignite the powder charge.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--sYsEpNHW--/vw2ayvbas4ncoswaqavv.jpg',
		ProductImage:
			'http://images.salsify.com/image/upload/s--hqsq87Y7--/338ff6fba9f8aafa676dad2c6916b7dc49d1d307.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--cdTSNr2Y--/j129xll9li3ih3y8ecdy.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--nqQjRDPX--/wr6ephgt3kku5dezbv8s.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--pIsHC4Jl--/k5ymew3ukdb9z6q5nbal.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--iKv8qhup--/kispqdut5c6mjvlkjcqc.jpg',
		DateLastModified: '2023-12-16 09:09:25',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '5e7eaf9a-43c4-4cb7-833e-03df0e89decc',
		ProductID: '80269',
		ProductName: '223 Rem 73 gr ELD® Match',
		UPC: '090255802696',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.635',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255802693',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '6.35',
		PalletQtyBoxes: '1680',
		Retail: '37.97',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Match™ Ammunition',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.398',
		G7BC: '0.2',
		MuzzleVelocity: '2790',
		MuzzleEnergy: '1262',
		SectionalDensity: '0.208',
		Cartridge: '223 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD® MATCH',
		BulletWeightGrain: '73',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The difference between competing and dominating. We carefully select every component to ensure uniformity, then load to exacting specifications to provide pinpoint accuracy. Each cartridge is loaded with either Hornady® A-MAX® bullets, our high-performance boattail hollow points, or the new, radically superior ELD® Match bullets. Stringent quality control ensures proper bullet seating, consistent charges and pressures, optimal velocity, consistent overall length and repeatable accuracy. THE PERFECT TIP! The new Heat Shield™ tip on the ELD® Match bullet creates the perfect meplat and outperforms BTHP bullets.  HORNADY® MATCH™ BULLETS Hornady® Match™ rifle ammunition is loaded with the most accurate, consistent match bullets in the world, featuring our AMP® bullet jackets.  SPECIALLY SELECTED CASES Cases are carefully selected based on strict criteria: wall thickness uniformity, internal capacity, case weight and consistent wall concentricity.  CAREFULLY MATCHED POWDER Powder is matched carefully to each specific load for optimal pressure, velocity and consistent accuracy.  STRINGENT QUALITY CONTROL With extremely tight tolerances and strict quality control, all Hornady® Match™ ammunition features superior lot-to-lot consistency. From the bullet seating to the optimal charges and velocities, Hornady® Match™ ammunition is designed to live up to company founder, J.W. Hornady\'s original goal: "Ten bullets through one hole."',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8MBWBGJw--/7dc2a6bce244da35ed40588da5fcfd9e79c07c41.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--pReL6CRN--/fe05b51b5f99bb9073fd550465a2e29aa691f56a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sua56Dt8--/dr5nihrmupifbm30t3c5.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--NDWe37DT--/xwu7mkrbrblydokapnfl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--651RkHip--/u3up5uuvqdjuhomeklid.jpg',
		Videos: 'https://vimeo.com/285005061',
		DateLastModified: '2023-12-16 09:06:12',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '773b1361-dc4e-4d2a-ae30-4bea237520f5',
		ProductID: '91361',
		ProductName: '40 S&W 135 gr MonoFlex Handgun Hunter',
		UPC: '090255913613',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '0.699',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255913610',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '6.99',
		PalletQtyBoxes: '1120',
		Retail: '50.47',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Handgun Hunter® Ammunition',
		GeneralApplication: 'Varmint',
		Applications: 'AppPersonalDefense',
		SectionalDensity: '0.121',
		Cartridge: '40 S&W',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'MONOFLEX®',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Power and performance in the palm of your hand Hornady Handgun Hunter™ ammunition is built around a bullet as rough and rugged as the conditions and game demand. The MonoFlex® handgun projectile is manufactured with a tough copper alloy that achieves deep penetration and 95% weight retention. Bullet expansion across a range of velocities is aided with an elastomer material added to the bullet’s open cavity. Upon impact, the elastomer compresses, then pushes out and causes the bullet to expand faster than a standard hollow point design.  Combined with premium cases, primers and propellants, Handgun Hunter™ ammunition benefits from years of producing hard-hitting GMX® and MonoFlex® rifle bullets to introduce a handgun version that lives up to our reputation. MONOFLEX® BULLET TECHNOLOGY The tough copper alloy in the MonoFlex® bullet allows for deep penetration while retaining 95% of its weight for maximum impact.  ELASTOMER MATERIAL An elastomer material in the bullet’s open cavity compresses upon impact and then pushes out, causing rapid expansion.  PREMIUM COMPONENTS Premium cases, primers and propellants combine with the MonoFlex® bullet to create a cartridge that delivers superior performance in the field.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--uZDs0c57--/luuasenj4tvdperv91fu.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--TFY64kvJ--/csbkcry6sgshwk9yzubl.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--hu36-Sng--/ozd2jzeiu5bh3kgotlv5.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--GstEIMxD--/cu9qdzpog0ka1svxpk89.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--z2r06mRg--/e7kyzjmuid64fkmwt1ea.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--hOow2LFD--/n8h2dykix4wrsaabgot2.png',
		Videos: 'https://vimeo.com/367123438',
		Videos1: 'https://vimeo.com/368031296',
		Videos2: 'https://vimeo.com/392307107',
		Videos3: 'https://vimeo.com/392307393',
		DateLastModified: '2023-12-16 09:09:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b95bd8e5-fa99-4359-850f-b1ee526b492d',
		ProductID: '546418',
		ProductName: 'Full-Length 2-Die Set 378 Wby (.375)',
		UPC: '090255564181',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564188',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '378 WBY MAG',
		Caliber: '375 CAL',
		BulletDiameter: '0.375',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f9d98212-d556-4c04-9741-7082ff080bf0',
		ProductID: '044568',
		ProductName: 'Expander Die 45/70-458 Win (.458)',
		UPC: '090255445688',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.435',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255445685',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '39.95',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Expander Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Pistol Style Expander die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® EXPANDER DIE COMES COMPLETE WITH: Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--sodeX5Or--/xf4cginmuqotym4cx4wb.jpg',
		DateLastModified: '2023-12-16 08:55:33',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b58da16c-ba2b-4e63-9f37-d3a4ac1f679d',
		ProductID: '050075',
		ProductName: 'Steel Dial Caliper',
		UPC: '090255050752',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '3.5',
		ShelfDepth: '9.75',
		Weight: '0.729',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255050759',
		CartonHeight: '4.250',
		CartonWidth: '10.750',
		CartonDepth: '12.250',
		CartonWeight: '7.29',
		PalletQtyBoxes: '2000',
		Retail: '72.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Measuring Devices',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD/Nickel/DEHP',
		Prop65Chem2: 'LEAD/Nickel/DEHP',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov.',
		LithiumBattery: 'No',
		MasterPackQty: '50',
		MasterPackUCC: '30090255050753',
		MasterPackHeight: '10.750',
		MasterPackWidth: '12.250',
		MasterPackDepth: '20.500',
		MasterPackWeight: '36.45',
		ProductDescription:
			'Stainless steel construction with shock-resistant dial is accurate to +/- 0.001”. Four-way measurement capability: inside, outside, depth and step. Slide may be locked in any position for precise measurements. Thumb wheel aids in easy opening and closing. Includes plastic storage case.',
		ProductImage: 'http://images.salsify.com/image/upload/s--iz7603zV--/b8xmlr0o4qitrgejzjbs.jpg',
		DateLastModified: '2023-12-16 08:55:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '97c245bb-9b66-4e58-95d8-a8479e1937f9',
		ProductID: '546288',
		ProductName: 'Full-Length 2-Die Set 6.5 Carcano (.268)',
		UPC: '090255562880',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.530',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562887',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.65',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '6.5X52 CARCANO',
		Caliber: '6.5MM',
		BulletDiameter: '0.267',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4ef50bdf-e603-496e-841c-79ae5ca6338f',
		ProductID: 'B25',
		ProductName: 'Lock-N-Load® 25 WSSM Modified Case',
		UPC: '090255709605',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '0.375',
		ShelfDepth: '0.375',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255709602',
		CartonHeight: '14.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '9.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Lock-N-Load® Modified "B" Cases',
		Cartridge: '25 WSSM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'For use with Lock-N-Load® O.A.L. Gauges, the Lock-N-Load® Modified Cases are readily available to fit most popular rifle chambers. All are manufactured to SAAMI specs.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--wc6ICQPu--/1b6fff007803b856be90073a1e8a90d2b37a0965.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--5POYEIfS--/uv6ksztbujpkqh2jurvs.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--saT59Rkm--/ywf6fsmeokhdespug7wb.jpg',
		DateLastModified: '2023-12-16 08:55:22',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '72775cef-6a68-4d8a-aba6-3e1ed3807c9a',
		ProductID: '8610B',
		ProductName: '22-250 Remington Unprimed Cases',
		UPC: '090255698947',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.5',
		ShelfWidth: '10',
		ShelfDepth: '14',
		Weight: '44.148',
		WeightUOM: 'LB',
		CaseQty: '2000',
		CartonUCC: '10090255698944',
		CartonHeight: '9.500',
		CartonWidth: '10.000',
		CartonDepth: '14.000',
		CartonWeight: '88296.0',
		PalletQtyBoxes: '88000',
		Retail: '0.76',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Bulk Rifle Cartridge Cases',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:27',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'baff6871-b3e2-4a56-b8c9-dd574e137a7f',
		ProductID: '75404',
		ProductName: 'SnapSafe® GlideVault™',
		UPC: '842631100632',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6',
		ShelfWidth: '21',
		ShelfDepth: '16.5',
		Weight: '26.000',
		WeightUOM: 'LB',
		CaseQty: '2',
		CartonUCC: '10842631100639',
		CartonHeight: '16.929',
		CartonWidth: '11.614',
		CartonDepth: '20.866',
		CartonWeight: '52.0',
		PalletQtyBoxes: '48',
		Retail: '291.99',
		Brand: 'SnapSafe®',
		ParentCategory: 'Security',
		ProductLine: 'SnapSafe® Auxiliary Safes',
		TopItem: 'Y',
		CountryofOrigin: 'CHINA',
		Prop65Chem1: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Box',
		ProductExtHeight: '4.4',
		ProductExtWidth: '15.9',
		ProductExtDepth: '12.2',
		ProductWeight: '26',
		ProductIntHeight: '3.1',
		ProductIntWidth: '13.5',
		ProductIntDepth: '9.5',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The GlideVault™ has tempered glass touchpad with silent mode which can be programmed with a 4 to 6 digit access code. Spring assisted slide-out drawer accommodates handguns, jewelry, documents and other valuables. Pry resistant door keeps children and unauthorized users from gaining access. Exterior housing is constructed of 16 gauge steel with two internal hardened locking lugs. Anchor to stationery objects with included 5-foot cable. Permanently install using the pre-drilled housing. Barrel key or micro-USB port for backup access. Four AAA Batteries (Not Included). Exterior: 15.9" x 12.2" x 4.4" Interior: 13.5" x 9.5" x 3.1" Weight: 26 lbs.',
		ProductImage: 'http://images.salsify.com/image/upload/s--yzA30tWd--/zuci7ldaxjotuszox7jx.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--eclSucdX--/xy4hos7w8lwluh3l11ut.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--rAlQBWTg--/jnofl1y2akf4a7f8xefu.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--fTBweN_v--/o4zzrpgoxtcxd1y6wwza.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ea3ONiKk--/jedcybtqsw1grhbgqvro.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--M7qECeee--/xpfdor4v7l0gtxyagz3p.jpg',
		Videos: 'https://vimeo.com/714236772',
		DateLastModified: '2023-12-16 09:06:06',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '4132ef29-6252-43bf-8a58-2424444f4953',
		ProductID: '99144',
		ProductName: 'Hornady® Oval Tin Sign',
		UPC: '090255991444',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '9.410',
		ShelfWidth: '17.700',
		ShelfDepth: '0.030',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '24.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Shrink Wrap',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These tin signs provide just the right accent for your trophy room, garage, or reloading area. Measures 12"x18" .024" thick aluminum.',
		ProductImage: 'http://images.salsify.com/image/upload/s--zt5OZ272--/jayuhqyustfxlr9zr1f2.png',
		DateLastModified: '2023-12-16 09:09:48',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ead2ad6f-db79-478e-84c0-04deede5df7d',
		ProductID: '67273',
		ProductName: '50 Cal Sabot Low Drag with 45 Cal 250 SST® Bullet',
		UPC: '090255672732',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '5',
		ShelfWidth: '3.325',
		ShelfDepth: '1.5',
		Weight: '0.955',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255672739',
		CartonHeight: '5.500',
		CartonWidth: '7.687',
		CartonDepth: '8.000',
		CartonWeight: '9.55',
		PalletQtyBoxes: '900',
		Retail: '21.48',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Muzzleloading Sabots With Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.210',
		MuzzleVelocity: '2250',
		MuzzleEnergy: '2735',
		SectionalDensity: '0.175',
		Caliber: '50 CAL',
		BulletDiameter: '0.452',
		BulletName: 'SST® ML™',
		BulletWeightGrain: '250',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		Sabot: 'Low Drag™ Sabot',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The SST®-ML™ is a phenomenal muzzleloading option and an excellent choice for long range blackpowder hunters.  Other "easy-load" bullets often fail to properly engage the rifling, which does not effectively stabilize the bullet and, as a result, accuracy suffers. But Hornady® sabots fully engage the rifling to keep the SST®-ML™ centered and sealed during firing, allowing for maximum velocity and unparalleled long range performance. Upon impact, the Flex Tip® is compressed into the front of the bullet, causing the bullet to expand. The speed sabot features a fumble-free method of pre-loading pellets. PATENTED FLEX TIP® Flex Tip® design delivers devastating terminal performance at all ranges.  SURGICAL ACCURACY 200+ yard performance.  50% EASIER TO LOAD Much easier to load than conventional sabots.  HIGH PERFORMANCE Hornady® sabots deliver the highest velocities and the flattest trajectories on the market.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--bJcP_mnT--/jenllimhkhg8jflxajrz.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--g8x5xI-h--/q066jq8o0bqaxfvtdbnh.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--mMbZLAfe--/nziuerdzggz33veox2fx.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--okgNKDv1--/dioawok6l2ic7hilblrb.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7ca87ce4-53b4-4a72-b90f-f0e6087ee6d2',
		ProductID: '22833',
		ProductName: '22 Cal. .224 80 gr. ELD-X®',
		UPC: '090255228335',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.200',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255228332',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '30.0',
		PalletQtyBoxes: '900',
		Retail: '58.45',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppCoyote',
		G1BC: '.485',
		G7BC: '.244',
		SectionalDensity: '0.228',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '80',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			' The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory. MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency. ELD-X bullets are available in factory loaded Precision Hunter ammunition. DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention. BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities.  Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range. INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--W4qaecE6--/n5sm06utairq5nwdb6hu.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		ProductImage4:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		DateLastModified: '2023-12-16 09:09:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9d2b4cff-9c6a-4a64-80a7-6933fb80176e',
		ProductID: '5051',
		ProductName: '50 Cal .505 525 gr DGS® (505 Gibbs)',
		UPC: '090255250510',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.900',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255250517',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '58.5',
		PalletQtyBoxes: '540',
		Retail: '157.67',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Dangerous Game™ Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.27',
		SectionalDensity: '0.294',
		OAL: '1.205',
		Cartridge: '505 GIBBS',
		Caliber: '505 CAL',
		BulletDiameter: '0.505',
		BulletName: 'DGS®',
		BulletWeightGrain: '525',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'An aggressive, hard-hitting bullet with attitude! The Hornady® DGS® bullets feature an advanced profile built of the toughest materials that penetrate through thick hide, dense muscle and hard bone — delivering maximum stopping power.  The business end of the DGS® bullet features a wide, flat nose that delivers maximum energy upon impact, while resisting bullet deformation and deflection. Incorporating a very hard high antimony lead core with a copper-clad steel jacket, this bullet maintains integrity and overall weight retention when driving through even the toughest hide and bone. Uniform in shape and size to the DGX® (Dangerous Game™ eXpanding) bullet, you can reliably and accurately shoot both from the same firearm with little to no shift in point of aim or impact. FLAT NOSE The flat nose reduces possible deflections and resists deformation to achieve straight, deep penetration. The DGS® provides the perfect follow-up bullet when hunting dangerous game.  DGX®/DGS® UNIFORMITY Each caliber utilizes the same profile for both the DGS® and DGX® bullets, offering the ultimate uniformity, which is ideal when shooting both bullet types through the same firearm.  COPPER CLAD STEEL JACKET The heavy copper clad steel jacket and high antimony lead core penetrate deeply through hide, muscle and bone.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--1hURO8JR--/8a92705344912618f38a9f416e4b43a2c7aad5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--_TNlqNgk--/16c1a279f23132022bd25c0bf9c9c988db8faaa8.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zhU5zD0H--/shbyehx2mnxtqhk96n2o.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--uBZaQYM3--/vvtvqim3pubduvbydvbe.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--S55VRjWO--/fscuvn7zgpmh9d9woak8.jpg',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9238b0a4-4cd2-48bc-b247-93edc0caca0b',
		ProductID: '8655',
		ProductName: '30-30 Winchester Unprimed Cases',
		UPC: '090255486551',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '7.625',
		ShelfWidth: '4.125',
		ShelfDepth: '1.375',
		Weight: '1.211',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255486558',
		CartonHeight: '4.750',
		CartonWidth: '8.250',
		CartonDepth: '8.375',
		CartonWeight: '6.055',
		PalletQtyBoxes: '400',
		Retail: '58.15',
		Brand: 'Hornady®',
		ParentCategory: 'Cartridge Cases',
		ProductLine: 'Rifle Cartridge Cases (Unprimed)',
		Cartridge: '30-30 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The foundation of Hornady® Ammunition.  At Hornady,® brass is the foundation for what could be the most memorable shot of your lifetime. Extra time and care is taken in the creation of our cases, producing smaller lots that meet strict quality standards.  Our cases offer reloaders excellent uniformity in wall thickness, weight and internal capacity. We measure for consistently tight wall concentricity and even run our cases through a pressure calibration test to ensure uniform case expansion during firing.  Our cases allow proper seating of the bullet, not only in the case, but in the chamber as well. High quality brass contributes to consistent charges and pressures. TIGHT WALL CONCENTRICITY Concentricity helps to ensure proper bullet seating in both the case and the chamber of your firearm. Higher concentricity also aids in a uniform release of the bullet on firing, for optimal velocity and accuracy.  UNIFORM CASE WALL THICKNESS Benchrest shooters have long known that uniform case wall thickness is vital to accuracy. We manufacture to extremely tight tolerances to ensure this critical element is as consistent as possible.  MORE RELOADS PER CASE We treat Hornady brass as the foundation for an accurate cartridge, not a commodity. Because we take greater care in its creation you’ll get more reloads from Hornady brass.  CONSISTENT WEIGHT AND CAPACITY Every single Hornady case, regardless of the lot in which it was produced, is virtually identical to other Hornady cases in the same caliber. For you, this means consistent pressures, velocity and accuracy — every time.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--jKtOskDV--/lswhclikuxgjistby1xq.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--0FrX6uau--/v4bfo5ptmypf7g6cuko8.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--CEbPCTBz--/ivghti5z9piccptrier2.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--58JJx5is--/kcvxbniytdt7v7tflt9g.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--vMbn57AT--/soq7kqp6uc2rifufngxs.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--mYul_kJD--/rondfahrxvepke0ljaly.png',
		ProductImage5: 'http://images.salsify.com/image/upload/s--pSTEG3TZ--/oskgaqj14scimnf9sfqz.jpg',
		DateLastModified: '2023-12-16 09:09:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e58cceca-2c65-45d2-8224-35a8093d0100',
		ProductID: '9077',
		ProductName: '41 Rem Mag 210 gr XTP®',
		UPC: '090255390773',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '2',
		ShelfWidth: '2.375',
		ShelfDepth: '3',
		Weight: '1.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255390770',
		CartonHeight: '3.375',
		CartonWidth: '5.312',
		CartonDepth: '10.937',
		CartonWeight: '10.5',
		PalletQtyBoxes: '1120',
		Retail: '37.20',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Custom™ Handgun Ammunition',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.182',
		MuzzleVelocity: '1545',
		MuzzleEnergy: '1113',
		SectionalDensity: '0.178',
		Cartridge: '41 REM MAG',
		Caliber: '41 CAL',
		BulletDiameter: '0.41',
		BulletName: 'XTP®',
		BulletWeightGrain: '210',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Shooters looking for supreme accuracy and maximum knock-down power turn to Hornady® Custom™ ammunition. Loaded with a variety of Hornady® bullets for rifle and pistol, the excellent terminal performance of Hornady® Custom™ ammunition makes it the preferred choice for hunters, competitive shooters, and plinkers.  Every round of Hornady® Custom™ ammunition is hand-inspected before packaging to ensure the highest levels of quality control. At Hornady®, we manufacture Custom™ ammunition to give shooters and hunters the advantage of hand-loaded accuracy in a factory load. HORNADY® BULLETS Available in a wide variety of calibers, Custom™ rifle ammunition is loaded with InterLock®, V-MAX®, SST®, InterBond®, FTX® and GMX® bullets, while Custom™ handgun ammunition features Hornady XTP, FMJ-RN, XTP Mag, FTX or FP (flat point)-XTP bullets.  BALLISTIC EFFICIENCY Many Custom™ loads feature bullets with a secant ogive design. This pioneering profile, developed by Hornady®, creates the optimum blend of ballistic efficiency and bearing surface for flatter shooting and less drag.  MATCHED POWDERS AND PRIMERS Powders in each cartridge are loaded to ensure optimal pressure, velocity and consistency from lot to lot. Each primer is matched to individual loads, and specifically selected for their ability to quickly, completely, and reliably ignite the powder charge.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--Kl_TiofX--/2772c2e2943d9e694dfef98046c8a363206b774d.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--DDgBey45--/048c4af56f6113a5f0b78d1b17ce0ae4f2933dbb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--8M3sF1WI--/tf4ytll7dbuzdecyzb1d.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--QACgw8aC--/u7kumaw2vc16mft2mbme.jpg',
		DateLastModified: '2023-12-16 09:09:35',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '6291b4d9-056a-4a56-b139-66b9ae9d4ce4',
		ProductID: '30370',
		ProductName: '30 Cal .308 150 gr GMX®',
		UPC: '090255303704',
		PackagedQTY: '50',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.150',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255303701',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '28.75',
		PalletQtyBoxes: '900',
		Retail: '53.97',
		ParentCategory: 'Bullets',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		SectionalDensity: '0.226',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'GMX®',
		BulletWeightGrain: '150',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Monolithic construction combined with pioneering ballistic design. Hard-hitting and deep-penetrating, the GMX® bullet combines monolithic construction with pioneering ballistic design to meet the need for a premium, non-traditional bullet. Tougher than pure copper, the mono-metal copper alloy has been proven to shoot cleaner, foul less, and deliver consistent, even pressure curves. The tough alloy material routinely retains 95% or more of its original weight and expands up to 1.5 times its original diameter.  Featuring a long, sleek profile with cannelures, the design reduces overall bearing surface and drag, while achieving some of the highest ballistic coefficients from monolithic, non-traditional bullets. Initiating expansion upon impact, the hard polymer tip drives into the hollow cavity at the front of the bullet, creating a mushroom-style projectile as it travels through the animal. Fully California compatible and appropriate for use in areas requiring the use of non-traditional bullets, GMX® is ideal for any sized game, from antelope to moose. COPPER ALLOY CONSTRUCTION One-piece copper alloy won't separate and delivers devastating terminal performance, deep penetration, and 95% weight retention.  CRIMPING CANNELURE AND PRESSURE RELIEVING GROOVES Reduces both bearing surface and fouling, and aids in consistent reloads.  HIGH WEIGHT-RETENTION High weight retention is a significant benefit to the GMX® and monolithic family of bullets, routinely retaining 95% or more of their original weight.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--d4Ry9L0M--/256bb5d670ad2f2dfa079e4bdb35776f32130166.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--KGoqedom--/1f2a58152e667bd41c90c561075c72b24afe89dd.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--LKxvSUbp--/mrvxzxfmtukphhx241q7.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cc1GHk-B--/nojyigtfiktuh1ussoqk.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--DadPrd2G--/brqhjgijn9fmk9zlm7of.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--7CDTG6WR--/qijkhjw25gi6t36fbupl.jpg',
		Videos: 'https://vimeo.com/340267408',
		Videos1: 'https://vimeo.com/145446289',
		DateLastModified: '2023-12-16 08:58:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e2dd56b9-d1bf-4856-8e6c-aebd75047ff4',
		ProductID: '6093',
		ProductName: '50 Cal .495 Lead Balls',
		UPC: '090255260939',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.750',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255260936',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '68.75',
		PalletQtyBoxes: '900',
		Retail: '18.93',
		Brand: 'Hornady®',
		ParentCategory: 'Muzzleloading',
		ProductLine: 'Lead Balls',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		Caliber: '50 CAL',
		BulletDiameter: '0.495',
		BulletName: 'LEAD BALLS',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Consistent and Accurate Performance Completely uniform in size, weight, and roundness, Hornady® Round Balls deliver consistent and accurate performance. They’re cold swaged from pure lead which eliminates air pockets and voids common to cast balls. And the smoother, rounder surface assures better rotation and consistency. ACCURATE Precision swaged to eliminate air pockets and deliver optimal accuracy.  TRADITIONAL Pure lead replicates traditional design.  CONSISTENT Uniform in size, weight and concentricity.   IMPORTANT: Before choosing a round ball diameter, check the bore size of your firearm and take into consideration whether you're using compression fit or patched projectile loading.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--43QVFvQO--/gpa4pxxuufxdwz5944oi.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--aJ-YePm3--/svi45nycxsd4uplegyoi.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--56Z0luEz--/rpvdaxshh1y6sfrunrd0.jpg',
		DateLastModified: '2023-12-16 09:06:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '42bba5a9-c5c7-444b-abe2-5a6bcd1a7e11',
		ProductID: '99132',
		ProductName: 'Hornady® "H" Hitch Cover',
		UPC: '090255991321',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '4',
		ShelfDepth: '4',
		Weight: '0.250',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '10.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Accessories',
		CountryofOrigin: 'USA',
		LithiumBattery: 'No',
		Packaging: 'Hang Tag & Baggy',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Show off your passion for the Hornady® brand with this plastic hitch cover. Fits most 2-inch hitch receivers with snap clips to hold it in place',
		ProductImage: 'http://images.salsify.com/image/upload/s--661cBKgc--/w3ilhtwhe296cb6skpa3.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '93e5e9a1-eaa2-4620-95d2-0626322c1b29',
		ProductID: '594251',
		ProductName: 'Match™ Grade Bushing .251',
		UPC: '090255592511',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.200',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592518',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '2.0',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '25 CAL',
		BulletDiameter: '0.251',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--e-WKEaY---/fcea5a5704c6b0cca9961e3cac56c7cae12a3a1d.jpg',
		DateLastModified: '2023-12-16 09:06:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a1be8746-55f0-4dbe-bc60-5ff905989126',
		ProductID: '99295',
		ProductName: 'Hornady® Gray & Orange Mesh Cap',
		UPC: '090255992953',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4.5',
		ShelfWidth: '8',
		ShelfDepth: '8',
		Weight: '0.150',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '22.99',
		Brand: 'Hornady®',
		ParentCategory: 'Shop',
		ProductLine: 'Clothing',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'CHINA',
		LithiumBattery: 'No',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription: 'One size fits most.',
		ProductImage: 'http://images.salsify.com/image/upload/s--wq8xgyiX--/efukrgq79uolphdlrsgy.png',
		DateLastModified: '2023-11-07 15:06:49',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'a9e8095f-4ffa-42e8-90c2-ecc9145ce284',
		ProductID: '044152',
		ProductName: 'Seater Die (.458) 45/70 Govt',
		UPC: '090255441529',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.578',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255441526',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '38.91',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Seating Dies',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Seating Die features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.    HORNADY® SEATING DIE COMES COMPLETE WITH THE FOLLOWING: • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • 7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		DateLastModified: '2023-12-16 08:55:32',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'afc4be3d-aa32-4863-8c08-0421f30368f5',
		ProductID: '392607',
		ProductName: 'Shell Plate #7 Lock-N-Load® AP™ & Projector',
		UPC: '090255926071',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '4',
		ShelfWidth: '3.875',
		ShelfDepth: '0.625',
		Weight: '0.563',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255926078',
		CartonHeight: '6.000',
		CartonWidth: '4.000',
		CartonDepth: '4.000',
		CartonWeight: '5.63',
		PalletQtyBoxes: '0',
		Retail: '75.35',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Plates',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Designed for the Lock-N-Load AP Progressive Press, our shell plates feature a subtle radius on each shell holder mouth to ensure smooth and reliable functioning. The retainer spring is designed to stay in place when inserting cases into the shell plate. Please note: a single shell plate may be used for multiple calibers. (Custom plates are also available.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--ZjvvFFRX--/j561eqrqqweacxeky7zq.jpg',
		DateLastModified: '2023-12-16 09:02:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7321f22f-edcc-4cf4-9931-ab18f720a33b',
		ProductID: '8242',
		ProductName: '450-400 Nitro Express 3" 400 gr DGS® Dangerous Game™ Series',
		UPC: '090255382426',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '2.487',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255382423',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '14.922',
		PalletQtyBoxes: '396',
		Retail: '217.45',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.325',
		MuzzleVelocity: '2050',
		MuzzleEnergy: '3732',
		SectionalDensity: '0.34',
		Cartridge: '450-400 NITRO EXP 3"',
		Caliber: '400 CAL',
		BulletDiameter: '0.41',
		BulletName: 'DGS®',
		BulletWeightGrain: '400',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--e7k03IHj--/037cfedada2808d68570ac49bf364dbfc420bd5a.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		DateLastModified: '2024-03-05 08:43:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'feb9947b-80b0-4c20-8a12-b0fef0cf916c',
		ProductID: '397107',
		ProductName: 'Seating Stem 7mm ELD® Match™ 162 Gr',
		UPC: '090255971071',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '5.5',
		ShelfWidth: '1.875',
		ShelfDepth: '1',
		Weight: '0.033',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255971078',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.33',
		PalletQtyBoxes: '0',
		Retail: '20.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Die Accessories',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'These seating stems are designed to fit Hornady® Custom Grade™ Dies and are machined to fit the profile of the A-MAX, A-Tip, ELD Match, ELD-X, FTX and MonoFlex bullets to seat them as precisely as possible without damaging bullets. (Not compatible with other manufacturers’ dies.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--wbihZPQ1--/pkx8hozskwfeupgm0jci.jpg',
		DateLastModified: '2023-12-16 09:02:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '150b356f-78f2-425d-9db9-d75ab16ccf3e',
		ProductID: '81084',
		ProductName: '30-06 Springfield 180 gr InterLock® SP American Whitetail®',
		UPC: '090255810844',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3.375',
		ShelfDepth: '5.25',
		Weight: '1.385',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255810841',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '13.85',
		PalletQtyBoxes: '1400',
		Retail: '39.00',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'American Whitetail® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.452',
		MuzzleVelocity: '2700',
		MuzzleEnergy: '2714',
		SectionalDensity: '0.271',
		Cartridge: '30-06 SPRG',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'INTERLOCK®',
		BulletWeightGrain: '180',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Make it a KNOCK-DOWN, DRAG-OUT hunt!® Opening day of deer season comes only once a year. Make sure you're ready when the big one steps out and load-up with Hornady® American Whitetail® ammunition. Loaded with our legendary Hornady® InterLock® bullets in weights that have been deer hunting favorites for decades, American Whitetail® ammunition combines generations of ballistics know-how with modern components and the technology you need to take the buck of a lifetime! Product Features Proudly made in the USA! INTERLOCK® BULLETS InterLock® bullets feature exposed lead tips for controlled expansion and hard-hitting terminal performance. Bullets used in American Whitetail® ammunition feature our pioneering secant ogive design and exclusive InterLock® ring — a raised ring inside the jacket that is embedded in the bullet's core that keeps the core and jacket locked together during expansion to retain mass and energy. POWDERS Loaded to conventional velocities, powder is matched to each load for optimum pressure and consistency, ensuring each load is compatible with semi-autos as well. CASE AND PRIMER Like all Hornady® ammunition, our American Whitetail® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--M6wk1FB0--/12ec4bc2f8fc9c30310e9ed93850c638687a97ad.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--v4Yqi7TA--/gjmq9vycoh2wgqk7oap1.eps',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sGOoQsYY--/q1segrkc6tflrvhkl7xu.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Np8YLUMO--/xltj4vwveifjb7ha6me7.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xu57sSw8--/z1ihz9wogjfsfpfzzqf4.jpg',
		Videos: 'https://vimeo.com/120302536',
		Videos1: 'https://vimeo.com/120302535',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'f0d2337b-1702-4e9a-b788-8d96f2efa403',
		ProductID: '80994',
		ProductName: '308 Win 178 gr ELD-X® Precision Hunter®',
		UPC: '090255809947',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.255',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255809944',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '12.55',
		PalletQtyBoxes: '1400',
		Retail: '59.87',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.552',
		G7BC: '0.278',
		MuzzleVelocity: '2600',
		MuzzleEnergy: '2671',
		SectionalDensity: '0.268',
		Cartridge: '308 WIN',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--lOK6lWRX--/19663f42d4a02fa932636796facbf7b9caabc8c1.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e0a73597-edb7-4f8c-8bbc-dbbb58be5c7d',
		ProductID: '546381',
		ProductName: 'Full-Length 2-Die Set 33 Nosler (.338)',
		UPC: '090255563818',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.480',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255563815',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.4',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '33 NOSLER',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c146479c-b2ea-490c-ac5f-3a8abb54a9e5',
		ProductID: '544295',
		ProductName: 'Match™ Grade 2-Die Set 6.5-284 Norma (.264)',
		UPC: '090255542950',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.550',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542957',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '7.75',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6.5-284 (NORMA)',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '650a46e2-2768-4ae8-8d52-e8513018e2f8',
		ProductID: '80592',
		ProductName: '7mm Rem Mag 139 gr GMX® Superformance®',
		UPC: '090255805925',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.484',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255805922',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '14.84',
		PalletQtyBoxes: '780',
		Retail: '61.33',
		ParentCategory: 'Ammunition',
		Applications: 'AppLargeGame',
		G1BC: '0.486',
		SectionalDensity: '0.246',
		Cartridge: '7MM REM MAG',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'GMX®',
		BulletWeightGrain: '139',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--14_tvR6J--/4e5fce1e64a237c62752134ed02fb5b1cf8f612e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:14',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '28b84683-8d10-45b0-b4bb-ac6ad6b16001',
		ProductID: '046699',
		ProductName: 'Size Die 500 S&W Mag (.500)',
		UPC: '090255466997',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.462',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255466994',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '61.19',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series V Four-Die Handgun Die Sets',
		Cartridge: '500 S&W MAG',
		Caliber: '50 CAL',
		BulletDiameter: '0.5',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications.  The included headed decap pin is mated to a Zip Spindle™, which is a feature on all Hornady® Full-Length Size Dies.  The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases. This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die with Titanium Nitride Sizing Ring and Sure-Loc™ Lock Ring • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™  7/8”-14 thread die that works with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately. Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:40',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ce23568a-8a21-4eaa-8319-c18c769f96bd',
		ProductID: '380708',
		ProductName: 'Cartridge Gauge 22-250 Rem (.224)',
		UPC: '090255807080',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '6.25',
		ShelfWidth: '2',
		ShelfDepth: '1.25',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255807087',
		CartonHeight: '3.750',
		CartonWidth: '9.250',
		CartonDepth: '5.250',
		CartonWeight: '3.5',
		PalletQtyBoxes: '0',
		Retail: '28.13',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Cartridge Gauges',
		Cartridge: '22-250 REM',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady Lock-N-Load® Cartridge Gauges allow the user to check their cases and ammo to ensure a correct fit in SAAMI chambers. Available in a variety of calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--VSz9BJ-A--/fipsvpj9biflhfkytha5.png',
		Videos: 'https://vimeo.com/190885067',
		DateLastModified: '2023-12-16 08:59:03',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7eb3e066-f9e8-40c2-af01-da418aa616fd',
		ProductID: '812544',
		ProductName: '5.56 NATO 55 gr. CX™ Superformance®',
		UPC: '090255719932',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1',
		ShelfWidth: '2.5',
		ShelfDepth: '4.5',
		Weight: '0.595',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255719939',
		CartonHeight: '5.125',
		CartonWidth: '5.312',
		CartonDepth: '6.937',
		CartonWeight: '5.95',
		PalletQtyBoxes: '1680',
		Retail: '42.52',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppMediumGame',
		G1BC: '.270',
		MuzzleVelocity: '3175',
		MuzzleEnergy: '1231',
		SectionalDensity: '0.157',
		Cartridge: '5.56 NATO',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'CX™',
		BulletWeightGrain: '55',
		BulletCoreMaterial: 'Copper',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy.  Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game.  PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance.  CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.  PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--7eo5Tgcl--/hewkvfiovk8djorja37i.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--HfdKvNYi--/tqsv1qz7vc6ehijfwqpx.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--XBthgG8F--/wlnjt7iysjujsu0tmqzq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--eNYL6JyZ--/ravnu75yfmqulcbf74zv.png',
		Videos: 'https://vimeo.com/145439098',
		DateLastModified: '2023-12-16 09:06:17',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '872a116a-11ac-4772-a34c-18c3b8386f9f',
		ProductID: '30715',
		ProductName: '30 Cal .308 178 gr BTHP Match',
		UPC: '090255307153',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.675',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255307150',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '40.125',
		PalletQtyBoxes: '540',
		Retail: '58.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Match™ Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.53',
		SectionalDensity: '0.268',
		OAL: '1.345',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'BTHP MATCH™',
		BulletWeightGrain: '178',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Technologically advanced to produce the most consistently concentric bullet jackets available! All Hornady® Match™ bullets feature revolutionary AMP® (Advanced Manufacturing Process) bullet jackets. Developed by Hornady® engineers, these bullet jackets are a technological advancement in design, tooling and manufacturing that combine to produce the most consistently concentric bullet jackets available. These proven AMP® jackets are the foundation for exceptional bullet accuracy and have virtually zero runout and near zero wall thickness variation. Coupled with precision swaged cores and manufactured to the tightest standards in the industry, all Hornady® Match™ bullets provide superior consistency, high ballistic coefficients and unprecedented levels of accuracy. SECANT OGIVE PROFILE The geometric profile works to produce low drag and flatter trajectories. The secant ogive design also provides the optimum bearing surface for stability in flight and the best ballistic coefficient possible.  SWAGED LEAD CORE The swaging process provides excellent uniformity and balance for consistent performance and accuracy.  AMP® JACKET The jacket has virtually zero runout and near zero wall thickness variation.  BOATTAIL The angle and length of the boattail is unique and optimized for each caliber and weight of Match™ bullets to maximize ballistic coefficient and performance.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--pUuWLewh--/b738c412e29f8a43e4b8a18ca9118eb9b3df2e1b.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--7KkNtQCy--/eacfe92492ef5a2ec97eed735e3cd49724c5411c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--aJBxMmCb--/plb2usdltwhmcdnpeyqs.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--VIKvDI4j--/l0trbtdsl4l4p5puwxwc.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Xi1qLz8r--/lrxfsxdigfywedzj6eut.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--eBiEzRyz--/lgarg8srec67oawbca9s.jpg',
		DateLastModified: '2023-12-16 08:58:58',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1d8e02f6-1644-4a40-a513-893558fed6a5',
		ProductID: '390550',
		ProductName: 'Shell Holder #10',
		UPC: '090255905502',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.050',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255905509',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.5',
		PalletQtyBoxes: '0',
		Retail: '6.71',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Shell Holders',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Precision machined from solid steel and heat-treated to perform flawlessly. Wide mouth and rounded edge at the opening allow smoother case insertion.  A single shell holder may be used for multiple calibers.',
		ProductImage: 'http://images.salsify.com/image/upload/s--lFhtj4gF--/ukf9urmbijhx6pjm7pob.png',
		DateLastModified: '2023-12-16 08:59:07',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'aee5d834-630c-490b-aae0-77d2eb2f04f1',
		ProductID: '041223',
		ProductName: 'Neck Wall Thickness Gauge',
		UPC: '090255412239',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2.25',
		ShelfWidth: '3.25',
		ShelfDepth: '5.375',
		Weight: '0.650',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255412236',
		CartonHeight: '8.000',
		CartonWidth: '9.000',
		CartonDepth: '12.000',
		CartonWeight: '6.5',
		PalletQtyBoxes: '0',
		Retail: '97.48',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Measuring Devices',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'This accessory to the Concentricity Tool offers the next step in ultra-precision reloading. Its .0005” increment dial indicator helps identify neck thickness variations so you can sort and measure case necks or verify your neck turning operation – ultimately enhancing accuracy. (Concentricity Tool  not included.)',
		ProductImage: 'http://images.salsify.com/image/upload/s--urRVbicW--/wgt03kuwekbzcjfkx5zc.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--mFqCC9y9--/u8tceozebuzpldvuath6.jpg',
		DateLastModified: '2023-12-16 08:55:30',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b370faf1-ae3f-49cd-9983-68f2868b3a95',
		ProductID: '40000',
		ProductName: '10mm .400 155 gr XTP®',
		UPC: '090255240009',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '2.359',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255240006',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '58.975',
		PalletQtyBoxes: '900',
		Retail: '39.13',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'XTP® Handgun Bullets',
		GeneralApplication: 'Shooting',
		Applications: 'AppMediumGame',
		G1BC: '0.137',
		SectionalDensity: '0.138',
		OAL: '0.55',
		Caliber: '10MM',
		BulletDiameter: '0.4',
		BulletName: 'XTP®',
		BulletWeightGrain: '155',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"eXtreme Terminal Performance Designed for hunting, self-defense and law enforcement applications, the XTP® bullet demonstrates the kind of accuracy that led many competitive shooters to adopt it. Reliable performance makes the XTP® the most popular handgun bullet for both target shooters and hunters. But it's the stopping power of the XTP® bullet that has truly built its world-class reputation. From the onset, XTP® bullets were specifically designed to expand reliably at a wide range of handgun velocities to deliver deep penetration with every shot. CONTROLLED EXPANSION Precise serrations divide the XTP® into symmetrical sections, strategically weakening the jacket and initiating controlled expansion even at low velocities.  NO EXPOSED LEAD The gilding metal jacket protects the nose of the bullet, so the hollow cavity functions properly on impact and ensures proper feeding in semi-automatics.  SWAGED CORE Total uniformity of core density ensures balanced expansion as well as in-flight stability.  DRAWN GILDING METAL JACKET Expansion is controlled by varying jacket thickness down the length of the XTP®, providing a definite advantage over plated bullets which have a uniform jacket thickness over the entire bullet.  CANNELURE On revolver bullets, the cannelure helps achieve accurate, consistent crimping. All cannelures are applied before the final forming process to eliminate any distortion to the finished bullet.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--6nYxtiRl--/3789bd5fa72eb755fd3de863753e66b3f1b1df7c.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--NHBNqz7d--/3750b4fac5693fc0cbcdf31faccde6c8d35c32fa.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--gmdOJoBP--/rqmevm3b9m1z5ujz78yq.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--LPXz6Me2--/f9jhc7epnjssbm3hpoe4.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_bg6k0AS--/cby7d0hmvkylxo28cfzc.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--xRce3mp3--/d88bjvvzjuwyercty4o0.png',
		Videos: 'https://vimeo.com/359867404',
		DateLastModified: '2023-12-16 09:02:45',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '822f7d65-3bdc-4782-a351-c9416e0947e0',
		ProductID: '046276',
		ProductName: 'Full-Length Size Die 25 Rem (.257)',
		UPC: '090255462760',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.550',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462767',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '25 REM',
		Caliber: '25 CAL',
		BulletDiameter: '0.257',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '05aa158d-e8e3-4a78-8fa2-5cc793339569',
		ProductID: '546298',
		ProductName: 'Full-Length 2-Die Set 270 Wby (.277)',
		UPC: '090255562989',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.465',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562986',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.325',
		PalletQtyBoxes: '0',
		Retail: '84.93',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series III Two-Die Rifle Die Sets',
		Cartridge: '270 WBY MAG',
		Caliber: '270 CAL',
		BulletDiameter: '0.277',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '363f040d-a5d1-4229-8c67-32b2892b65f1',
		ProductID: '81004',
		ProductName: '30 TC 150 gr SST®  Superformance®',
		UPC: '090255810042',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.125',
		ShelfWidth: '3',
		ShelfDepth: '5.25',
		Weight: '1.147',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255810049',
		CartonHeight: '5.875',
		CartonWidth: '6.437',
		CartonDepth: '8.250',
		CartonWeight: '11.47',
		PalletQtyBoxes: '1400',
		Retail: '56.12',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Superformance® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.415',
		MuzzleVelocity: '3000',
		MuzzleEnergy: '2997',
		SectionalDensity: '0.226',
		Cartridge: '30 TC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'SST®',
		BulletWeightGrain: '150',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Increase your rifle's performance up to 200 fps without extra chamber pressure, recoil, muzzle blast, temperature sensitivity, fouling, or loss of accuracy. Superformance® uses progressive propellants that take your favorite V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets to levels of performance that are simply unattainable with conventional ammunition. It IS rocket science!® PROVEN HORNADY® BULLETS Superformance® ammunition is loaded with Hornady® V-MAX,® NTX,® SST,® CX,™ and InterLock,® bullets for the ultimate in performance, no matter what the game. PROGRESSIVE HORNADY® POWDERS Superformance® Propellants are the heart of Superformance® ammunition and usher in a new era of performance. CASE AND PRIMER Like all Hornady® ammunition, our Superformance® rounds use the highest quality cases and primers available. Consistent components translate to consistent shooting in the field. PERFORMANCE IT IS FAST: 100 to 200 fps faster than conventional ammunition. IT IS ACCURATE: Uncompromising accuracy without increased felt recoil. IT IS CONSISTENT: Unfailing performance across a broad range of temperatures. IT IS VERSATILE: This new breed of ammunition is available in 17 Hornet to 444 Marlin, and is safe for use in all firearm types, including semi-autos, lever guns and pump actions.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--IYTj5yeT--/8fe398438026bcee3c1155429868a04dcccff022.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--ayx1Xbo_--/fda0c0f429d1431bca0eb541f1c3a19e3e111ea9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--ab4I-veb--/mv58zdsb56hdsugxbdnt.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--SJbaEA1Q--/nuipz2kd4cideahdqy7f.png',
		Videos: 'https://vimeo.com/145439098',
		Videos1: 'https://vimeo.com/145439551',
		DateLastModified: '2023-12-16 09:06:16',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '1d5fa2bd-d43d-4f2a-9d5c-e9bf7f966797',
		ProductID: '046280',
		ProductName: 'Full-Length Size Die 26 Nosler (.264)',
		UPC: '090255462807',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1.25',
		ShelfWidth: '1.25',
		ShelfDepth: '6.875',
		Weight: '0.595',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonUCC: '10090255462804',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '65.32',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Full Length Dies For Series III Two-Die Rifle Die Sets',
		Cartridge: '26 NOSLER',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Tube',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Full-Length Size Die sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and headed decap pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements. The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  This die comes with a Hornady® Sure-Loc™ lock ring that clamps around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of the die and eliminates possible damage from pliers.   *Other accessories sold separately.  HORNADY® FULL-LENGTH SIZE DIE COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		DateLastModified: '2023-12-16 08:55:36',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '82e3efdf-264e-4114-8c30-3dbf10d83c73',
		ProductID: '7080',
		ProductName: '32 Cal/8mm Gas Checks',
		UPC: '090255270808',
		PackagedQTY: '1000',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '0.776',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255270805',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '11.64',
		PalletQtyBoxes: '540',
		Retail: '66.67',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Gas Checks',
		Caliber: '32 CAL/8MM',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'If you cast your own bullets, our crimp-on gas checks will enhance their performance. During sizing, the gas check crimps to the base of case lead bullets to seal gasses and protect the base from deformation. Hornady gas checks are the only real choice for bullet casters.  Packaged 1000 per box.',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--vl37iw8z--/cjrsnnlyor7p16cgbunn.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--6a-uSw7p--/kfl88kqiurnf6nizdy1h.jpg',
		DateLastModified: '2023-12-16 09:06:05',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c9227a13-9abd-4a6f-af38-f68f31a57726',
		ProductID: '26179',
		ProductName: '6.5mm .264 135 gr A-TIP Match',
		UPC: '090255261790',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '4.75',
		ShelfWidth: '3.344',
		ShelfDepth: '5.938',
		Weight: '2.217',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255261797',
		CartonHeight: '6.750',
		CartonWidth: '10.000',
		CartonDepth: '18.500',
		CartonWeight: '22.17',
		PalletQtyBoxes: '240',
		Retail: '114.80',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'A-Tip® Match Bullets',
		GeneralApplication: 'Match',
		Applications: 'AppTargetMatch',
		G1BC: '0.637',
		G7BC: '0.321',
		MinTwist: '1-8.5"',
		SectionalDensity: '0.277',
		OAL: '1.387',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'A-TIP® MATCH',
		BulletWeightGrain: '135',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Aluminum',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'It is... ROCKET SCIENCE!® Years of research and testing by the Hornady® Ballistic Development Group, combined with advanced manufacturing processes and quality control measures have led to the creation of the ultimate low drag, high performance match bullet.  Use of a new A-TIP™ seating stem is required for optimal bullet seating. TIP DESIGN Aluminum tip is precision machined and longer than polymer tips which moves the center of gravity and enhances inflight stability. Aeroballistically advanced tip design results in tighter groups and reduced drag variability. Perfect blend of ogive, tip length, bearing surface and optimized boattail by caliber. PERFORMANCE Doppler radar verified low drag coefficient (high BC) bullets are forgiving of twist rate, seating depth and muzzle velocity. Refined design of the AMP® bullet jacket offers industry leading uniformity and concentricity. MANUFACTURING Right off the press – sequentially packaged, one clone after another for the ultimate in consistent performance. Minimal handling throughout the manufacturing process ensures consistency from bullet to bullet. Packaged with a polishing bag to prepare bullets for loading (bullets aren’t bulk washed after manufacture).',
		ProductFamilyImage: 'http://images.salsify.com/image/upload/s--QKkjjhIr--/iqcr9ycopbobknd1nh8k.png',
		ProductImage: 'http://images.salsify.com/image/upload/s--DfS3XNfR--/ttph7evuldynkobgjavt.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--zNY6QgXZ--/e3mtb90dqa9fwz2er9ve.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--eK-qZ-7T--/b7dwtwpl7ydnvfqfxs2m.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--ZXKAPfEf--/gpzsz92r3vqx2xmbtp4h.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--jkXjV88f--/erqgnmguagn1qfxji6jd.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--JFnk5sYe--/mx3g3mk0uzbfk3daaou3.png',
		Videos: 'https://vimeo.com/332099503',
		Videos1: 'https://vimeo.com/331018137',
		Videos2: 'https://vimeo.com/342756247',
		Videos3: 'https://vimeo.com/342756292',
		Videos4: 'https://vimeo.com/359380151',
		Videos5: 'https://vimeo.com/368031592',
		Videos6: 'https://vimeo.com/342756327',
		DateLastModified: '2023-12-16 08:58:54',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'ef8d2606-3929-41e1-a6a9-0c54297212e4',
		ProductID: '594266',
		ProductName: 'Match™ Grade Bushing .266',
		UPC: '090255592665',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.75',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.025',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255592662',
		CartonHeight: '8.000',
		CartonWidth: '7.000',
		CartonDepth: '1.250',
		CartonWeight: '0.25',
		PalletQtyBoxes: '0',
		Retail: '30.97',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Bushings',
		Caliber: '6.5MM',
		BulletDiameter: '0.266',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® Match Grade™ Bushing Dies allow the use of interchangeable neck bushings. This allows versatility with neck size based on your preferences for neck tension. The bushing size will depend on your brass neck thickness.  Available in .001” increments, these bushings fully eliminate neck resizing problems. Tight tolerances here translate into tighter groups.',
		ProductImage:
			'http://images.salsify.com/image/upload/s--iNv3k3K4--/52712ed207a8ed7290ec30a178dc6c659464aaac.jpg',
		DateLastModified: '2023-12-16 09:06:01',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '7349331e-fc0a-456f-b71a-19dd440fe7bc',
		ProductID: '546248',
		ProductName: 'Full-Length 2-Die Set 6mm/223 (.243)',
		UPC: '090255562484',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.400',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255562481',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '7.0',
		PalletQtyBoxes: '0',
		Retail: '144.68',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series IV Specialty Rifle Die Sets',
		Cartridge: '6MM-223',
		Caliber: '6MM',
		BulletDiameter: '0.243',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 2-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications and features an Elliptical Expander that is superior to “ball expanders”.  This Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading prevents it from pulling loose and the elliptical expander eliminates the need for a separate expander die for necking-up to the next caliber. The Elliptical Expander and hardened steel Headed Decap Pin are mated to a Zip Spindle™, which is a feature on all Custom Grade™ Full Length Size Dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction.  The second die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.   HORNADY® CUSTOM GRADE™ 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Elliptical Expander • Headed Decap Pins • Zip Spindle™ • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--ugjhj1Zk--/hb79ojc0lcoe1ddrhly9.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--1ak6xcaf--/zou8aabxc5ytlj0dwd97.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--muUAf2AX--/ak4luzsmp8exe60yoznd.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--N9LFSrUA--/ow8ntfuxas1xrxn5ldnn.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--8JXBXj9L--/bsm3z9lwi7cggpkpkyxy.jpg',
		DateLastModified: '2023-12-16 09:05:53',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '3fe07acc-4629-41e5-8656-c602c42b2135',
		ProductID: '2245',
		ProductName: '22 Cal .224 50 gr SP',
		UPC: '090255222456',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '2.5',
		Weight: '0.784',
		WeightUOM: 'LB',
		CaseQty: '40',
		CartonUCC: '10090255222453',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '31.36',
		PalletQtyBoxes: '1440',
		Retail: '24.27',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'Traditional Varmint Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.214',
		SectionalDensity: '0.142',
		OAL: '0.656',
		Caliber: '22 CAL',
		BulletDiameter: '0.224',
		BulletName: 'SP',
		BulletWeightGrain: '50',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Lead',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Streamlined design with maximum accuracy. The Hornady® line of traditional Varmint™ bullets features a streamlined design for flat trajectory. Its lead core and match-grade copper jacket represent the original standard created by Joyce Hornady for classic varmint hunting. Primarily comprised of spire point profiles and flat base designs, the bullets perform extremely well even at low velocities and deliver excellent performance in many classic varmint rifles. FEATURES: Streamlined design for ultra flat trajectories. Match grade AMP® bullet jackets provides maximum accuracy at all ranges. Explosive expansion, even at low velocities.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--S4JBCyyr--/695e2ffe30116650bbef2b4bbef3b4bcf8342f08.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RXvVZao9--/406748dfed31b9fea2a901add33be9209b9d7f74.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--4h3oy9B6--/wxcsudscst75pnsknjlm.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--dsDrpUlx--/cloifgvflwrfjuz3qdir.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--bv5bKpxU--/bx0gvrmuxqjmfyvtkaey.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '02b0292f-bb36-4e51-8d66-435b327dd50e',
		ProductID: '99181',
		ProductName: 'Hornady® Buck Knife',
		UPC: '090255706482',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '1',
		ShelfWidth: '1',
		ShelfDepth: '1',
		Weight: '0.350',
		WeightUOM: 'LB',
		CaseQty: '0',
		CartonHeight: '0.000',
		CartonWidth: '0.000',
		CartonDepth: '0.000',
		CartonWeight: '0.0',
		PalletQtyBoxes: '0',
		Retail: '55.99',
		ParentCategory: 'Shop',
		Obsolete: 'Obsolete',
		CountryofOrigin: 'USA',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The Buck Vantage™ series knife features a Hornady® logo on the strong side of the blade. High-impact polymer handle and pocket clip. Made in the USA.',
		ProductImage: 'http://images.salsify.com/image/upload/s--w3e2Tyf8--/ky7opkkekudwvf3peeny.jpg',
		DateLastModified: '2023-12-16 09:09:41',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'c3c0456f-7ba2-4fe6-9cf3-11d22374fe10',
		ProductID: '546401',
		ProductName: 'Full-Length 4-Die Set 350 Legend (.355)',
		UPC: '090255564013',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '2.240',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255564010',
		CartonHeight: '8.000',
		CartonWidth: '10.750',
		CartonDepth: '5.500',
		CartonWeight: '11.2',
		PalletQtyBoxes: '0',
		Retail: '132.44',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Series V Four-Die Rifle Die Sets',
		Cartridge: '350 LEGEND',
		Caliber: '35 CAL',
		BulletDiameter: '0.355',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  The Hornady® Custom Grade™ 4-Die Set consists of a Full-Length Size Die that sizes cartridge cases to SAAMI minimum specifications.  The included hardened steel Headed Decap Pin is mated to a Zip Spindle™, which is a feature on all Custom Grade™ full length size dies. The Zip Spindle™ positively locks to eliminate slippage. A series of light threads cut on both the spindle and spindle lock allows incremental adjustments by turning the spindle or it can easily “zip” up or down for larger movements.  The internal die profile is precision machined and polished to a smooth finish for reliable functioning without case sticking or excessive friction. This die features a titanium nitride “gold ring” finish that’s harder than carbide and doesn’t require lubrication. The super hard coating is perfect for resizing soft pistol brass and won’t scratch cases.  NOTE: For bottleneck or non-nitride ring dies, stop at “friction”.  The second die in this set is a Hornady® Pistol Style Expander die.  This die expands the case mouths on straight-walled rifle or pistol cases to achieve proper neck tension on the bullet. In addition it has the ability to put a slight "bell" or flare on the case mouth which prepares the case so powder and bullet insertion are smoother.  The third die in this set is a Seating Die that features an alignment sleeve (comes standard – other manufacturers charge extra for this feature) and a seater adjustment screw with lock ring and rubber washer for necessary tension to make fine bullet seating depth adjustments and works to keep the die set together. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. The fourth die in this set is a Hornady® Crimp Die that removes the case mouth flare and provides a heavy crimp on the case and bullet.  As with all Hornady® Custom Grade™ die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Custom Grade™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Other accessories sold separately.  HORNADY® CUSTOM GRADE™ 4-DIE SET COMES COMPLETE WITH THE FOLLOWING: • Full-Length Size Die* and Sure-Loc™ Lock Ring • Spindle Lock • Decap Pin Retainer • Headed Decap Pins • Zip Spindle™ • Hornady® Pistol Style Expander Die and Sure-Loc™ Lock Ring • In-line Bullet Seating Die and Sure-Loc™ Lock Ring • Crimp Die and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • Stackable Die Storage Box 7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--fCGn-k50--/nkksh5f9hnkonjk9hgs7.jpg',
		DateLastModified: '2023-12-16 09:05:57',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'e59625d4-10ee-40ec-93c0-89046598e359',
		ProductID: '82166',
		ProductName: '300 PRC 212 gr ELD-X® Precision Hunter®',
		UPC: '090255821666',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '3.875',
		ShelfDepth: '6.375',
		Weight: '1.750',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255821663',
		CartonHeight: '7.000',
		CartonWidth: '7.625',
		CartonDepth: '8.937',
		CartonWeight: '17.5',
		PalletQtyBoxes: '780',
		Retail: '75.77',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Precision Hunter® Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.673',
		G7BC: '0.336',
		MuzzleVelocity: '2860',
		MuzzleEnergy: '3850',
		SectionalDensity: '0.319',
		Cartridge: '300 PRC',
		Caliber: '30 CAL',
		BulletDiameter: '0.308',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '212',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		CaseMaterial: 'Brass',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Never compromise at any distance! Accuracy and terminal performance are the cornerstones of Hornady® Precision Hunter® factory loaded ammunition. Great care has been given by Hornady engineers to develop superior, match­-accurate hunting loads that allow the ELD­-X® bullet to achieve its maximum ballistic potential.  Propellants used in the Precision Hunter® ammunition line are clean burning and loaded to uniform capacity for consistent shot to shot results regardless of temperature. This attention to detail provides the highest levels of accuracy and performance uniformity for the most demanding and diverse hunting situations. Featuring the radically superior ELD-­X bullet with Heat Shield tip, Precision Hunter is the ideal load for ANY hunting situation because of its effective terminal performance at ALL practical ranges.  BEST­-IN-­CLASS BCS Verified by Doppler radar, the Heat Shield tip defies the effects of aerodynamic heating and retains its shape to maintain the highest-in­-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP bullet jackets + Heat Shield tip combine for radically superior aerodynamic efficiency.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity, 0-­400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock ring keep the core and jacket together providing 50­-60% weight retention.  BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low velocity, 400+ yard impacts, the Heat Shield tip drives backward into the bullet to initiate expansion. Exhibiting controlled expansion with a large mushroom and 85­-90% retained weight, the bullet provides deep penetration and large cavities. Available as component bullets or in factory loaded Precision Hunter ammunition. In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS!  Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--FK51bdaO--/926b038020b86ba3a2494e17627502a497113ceb.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--twl3DRvj--/2e8a35ac65aa6e3c1c1f58a85274274db3b27d7c.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--sN-EnOVY--/atpjpokag7bjsafehba7.jpg',
		ProductImage2: 'http://images.salsify.com/image/upload/s--lM8ykMDR--/nzqm8h7bm9yjow5ycz6b.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--gSrGfaTo--/ilztjogxscr0staw194w.png',
		Videos: 'https://vimeo.com/188879789',
		Videos1: 'https://vimeo.com/160943649',
		Videos2: 'https://vimeo.com/347110096',
		Videos3: 'https://vimeo.com/294885189',
		Videos4: 'https://vimeo.com/295448905',
		DateLastModified: '2023-12-16 09:06:21',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '9620c2f7-1432-49ee-ac90-961d148d5773',
		ProductID: '82689',
		ProductName: '500 Nitro Express 570 gr DGX® Bonded Dangerous Game™ Series',
		UPC: '090255826890',
		PackagedQTY: '20',
		PackagedUOM: 'BX',
		ShelfHeight: '1.375',
		ShelfWidth: '4.5',
		ShelfDepth: '6.375',
		Weight: '3.060',
		WeightUOM: 'LB',
		CaseQty: '6',
		CartonUCC: '10090255826897',
		CartonHeight: '4.750',
		CartonWidth: '7.000',
		CartonDepth: '10.250',
		CartonWeight: '18.36',
		PalletQtyBoxes: '396',
		Retail: '308.64',
		Brand: 'Hornady®',
		ParentCategory: 'Ammunition',
		ProductLine: 'Dangerous Game™ Ammunition',
		GeneralApplication: 'Hunting',
		Applications: 'AppDangerousGame',
		G1BC: '0.295',
		MuzzleVelocity: '2120',
		MuzzleEnergy: '5688',
		SectionalDensity: '0.313',
		Cartridge: '500 NITRO EXP 3"',
		Caliber: '50 CAL',
		BulletDiameter: '0.51',
		BulletName: 'DGX® BONDED',
		BulletWeightGrain: '570',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper-Clad Steel',
		BulletCannelure: 'Yes',
		CaseMaterial: 'Brass',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Fear no evil.  Hornady® manufactures Dangerous Game™ Series ammunition with only the finest components, under strict quality control measures. Our classic bullet designs are tailored to meet the needs of the serious safari hunter.  We use techniques and processes that rival hand loads, with the ultimate goal of making every cartridge accurate, deadly and dependable! HIGH PERFORMANCE HORNADY® BULLETS From the InterLock® SP-RP bullets to the heavy-hitting DGS® and DGX® bullets, each Dangerous Game™ Series load is topped with a deadly projectile.  InterLock® SP-RP Bullets SP-RP stands for "spire point - recoil proof," and the design of this bullet eliminates the problem of tip deformation during recoil. These heavy-duty InterLock® bullets combine rugged design with improved trajectory in dangerous game rifles.  DGS® Bullets The DGS® non-expanding bullet is recommended for thick-skinned game such as elephant, rhino and hippo. Its tough copper clad steel jacket is designed to provide maximum penetration from all angles on thick-skinned and heavy boned dangerous game animals.  DGX® Bonded Bullets DGX® Bonded bullets are built to the same profile as the corresponding DGS® (Dangerous Game™ Solid) bullets but expand to 1½ to 2 times their bullet diameter. They feature a copper-clad steel jacket bonded to a lead core to provide limited, controlled expansion with deep penetration and high weight retention. Bonding the jacket to the core prevents separation from high-energy impact on tough material like bone, ensuring the bullet stays together for deep expansion.  POWDER Powders are carefully matched to each load to ensure optimum pressure and velocity, and to regulate in double rifles. Some of our Dangerous Game™ Series loads feature Superformance® propellant technology.  CASE AND PRIMER Like all Hornady® ammunition, our Dangerous Game™ ammunition uses the highest quality cases and primers available. Consistent components translate to consistent shooting in the field.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--xUZzganq--/942c68a0066e7fd685944131ab0a34f060247fea.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--vm1iSqqF--/10f951dc12ba4416fb9adddc6184abb7f0670307.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--Mp41pdDz--/zzv6qfgv6gxax68nh1v1.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--c1bUBh8r--/bsq05og3jso1gaah3oyw.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--CsFWYM8B--/smldbq0n358wju9jvcl8.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--KXSKZT6O--/wvno6b6js5nqlsb9yim5.jpg',
		Videos: 'https://vimeo.com/289357200',
		DateLastModified: '2024-03-05 08:47:31',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd15d6816-523a-46b3-918d-e898247cb92f',
		ProductID: '2840',
		ProductName: '7mm .284 162 gr ELD-X®',
		UPC: '090255228403',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '2.435',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255228400',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.525',
		PalletQtyBoxes: '540',
		Retail: '63.08',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'ELD-X® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.63',
		G7BC: '0.315',
		MinTwist: '1-9.5"',
		SectionalDensity: '0.287',
		OAL: '1.474',
		Caliber: '7MM',
		BulletDiameter: '0.284',
		BulletName: 'ELD-X®',
		BulletWeightGrain: '162',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Heat Shield®',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'The ELD-X® (Extremely Low Drag - eXpanding) bullet is a technologically advanced, match accurate, ALL-RANGE hunting bullet featuring highest-in-class ballistic coefficients and consistent, controlled expansion at ALL practical hunting distances. BEST-IN-CLASS BCS Verified by Doppler radar, the Heat Shield® tip is immune to the effects of aerodynamic heating and retains its shape to maintain the highest-in-class BC over its entire trajectory.  MATCH ACCURATE HUNTING BULLET Streamlined secant ogive with optimum boattail design + highly concentric AMP® bullet jackets + Heat Shield® tip combine for radically superior aerodynamic efficiency.  ELD-X bullets are available in factory loaded Precision Hunter ammunition.  DEVASTATING CONVENTIONAL RANGE PERFORMANCE With high velocity 0-400 yard impact, the bullet continually expands throughout its penetration path. The thick shank of the jacket and high InterLock® ring keep the core and jacket together providing 50-60% weight retention.    BEST EXTENDED RANGE TERMINAL PERFORMANCE AVAILABLE Upon low-velocity 400+ yard impacts, the Heat Shield® tip drives backward into the bullet to initiate expansion. Exhibiting conventional expansion with a large mushroom and 85-90% retained weight the bullet provides deep penetration and large wound cavities. Heat Shield® Technology In 2012, Hornady engineers were tasked with creating a new bullet. The main goal was to have a hunting bullet that worked well at all practical distances. Plenty of bullets work well from 0-400 yards, few work well beyond that and none work well at both conventional and extended range.  INTRODUCING THE HEAT SHIELD® TIP... ONE TIP, TWO BULLETS! Extend your range, and never compromise at any distance. Hornady engineers, using state of the art aeroballistics software, Doppler radar and decades of bullet performance knowledge have developed an entirely new class of bullet.',
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--yiqafni1--/71cc0ba0077642881a982e194d84627cffcdd5c7.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--SGOduXY0--/4f80a08f319e5093d9b91f6af937deb2c840fbbb.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--weqUx1-M--/dhcvzv3bsill01jqdkdp.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--jzM-zByo--/qwyzivn6kjrbsujcu38x.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--0z7FNRMP--/zhcdqkiaesmfjchlssgq.png',
		ProductImage4: 'http://images.salsify.com/image/upload/s--psXCwcC3--/mop3m7gocpvebfeeo7go.png',
		Videos: 'https://vimeo.com/163412597',
		Videos1: 'https://vimeo.com/163427845',
		Videos2: 'https://vimeo.com/161495780',
		Videos3: 'https://vimeo.com/359552264',
		Videos4: 'https://vimeo.com/352573368',
		DateLastModified: '2023-12-16 08:58:56',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd85c8f4d-ef65-4f5e-8b4b-2f0138b4d4b4',
		ProductID: '22601',
		ProductName: '6.5mm .264 95 gr V-MAX®',
		UPC: '090255275056',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '2.125',
		ShelfDepth: '4',
		Weight: '1.453',
		WeightUOM: 'LB',
		CaseQty: '25',
		CartonUCC: '10090255275053',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '36.325',
		PalletQtyBoxes: '900',
		Retail: '48.84',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'V-Max® Bullets',
		GeneralApplication: 'Varmint',
		Applications: 'AppVarmint',
		G1BC: '0.365',
		SectionalDensity: '0.195',
		OAL: '1.02',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		BulletName: 'V-MAX®',
		BulletWeightGrain: '95',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		TopItem: 'Y',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"The ideal combination of accuracy, expansion and fragmentation. With its combination of proven materials, innovative design and streamlined profile, the Hornady® V-MAX® represents the pinnacle of what a specialized varmint bullet can achieve, offering straight-line trajectories, enhanced accuracy, dramatic expansion and explosive fragmentation at a wide range of distances and velocities.  The industry's leading varmint bullet with polymer tip and streamlined design results in flat trajectories. The concentricity of the match grade AMP® bullet jacket provides maximum accuracy at all ranges as well as explosive expansion, even at velocities as low as 1600 fps. POLYMER TIP The secret to the explosive terminal performance of the V-Max® is a hollow cavity resting between the tip's shaft and the body of the bullet. Upon impact, the hard shaft builds up speed and energy before driving into the core, causing the entire package to rapidly expand to the point of violent fragmentation, even at low terminal velocities.  HIGHER BALLISTIC COEFFICIENT Hornady® combines the sharp, pointed polymer tip with the most aerodynamic profile for a high ballistic coefficient. The V-MAX® profile also provides the maximum bearing surface for added in-flight stability.  SWAGED LEAD CORE The swaging process allows precise formation of the core up and around the tip, with a cavity under the tip's stem. This allows the tip to build up energy before smashing into the core, causing dramatic fragmentation of the core and jacket.  PRECISE BOATTAIL & FLATBASE DESIGNS Utilizing the proper base design provides incredible in-flight stability for long-range shooting.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--8GIOLGi3--/b1386f0b66d06652721189338290878e722566f6.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--B5401AUi--/a540bdc5102ef280998f9020e891c3d7c3c53547.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--9O404f4I--/rrv9m6vuh9lg46ljh5qh.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--Cw5-N1ft--/r7yf7bla82wbqibpmuhj.jpg',
		ProductImage3: 'http://images.salsify.com/image/upload/s--Wk5ENTaf--/zrlihp4g6tdebo1hwayy.jpg',
		DateLastModified: '2023-12-16 08:58:52',
	},
	{
		'@odata.etag': '',
		ItemInternalId: '0c15b5e6-354d-42b9-ae08-42121511ba74',
		ProductID: '33102',
		ProductName: '338 Cal .338 200 gr SST®',
		UPC: '090255331028',
		PackagedQTY: '100',
		PackagedUOM: 'BX',
		ShelfHeight: '2.125',
		ShelfWidth: '3.5',
		ShelfDepth: '4',
		Weight: '3.100',
		WeightUOM: 'LB',
		CaseQty: '15',
		CartonUCC: '10090255331025',
		CartonHeight: '4.687',
		CartonWidth: '11.125',
		CartonDepth: '11.500',
		CartonWeight: '46.5',
		PalletQtyBoxes: '540',
		Retail: '69.65',
		Brand: 'Hornady®',
		ParentCategory: 'Bullets',
		ProductLine: 'SST® Bullets',
		GeneralApplication: 'Hunting',
		Applications: 'AppLargeGame',
		G1BC: '0.455',
		SectionalDensity: '0.25',
		OAL: '1.322',
		Caliber: '338 CAL',
		BulletDiameter: '0.338',
		BulletName: 'SST®',
		BulletWeightGrain: '200',
		BulletCoreMaterial: 'Lead',
		BulletJacketMaterial: 'Copper',
		BulletTipMaterial: 'Polymer',
		BulletCannelure: 'Yes',
		Season: 'Seasonal',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1:
			'Discharging firearms in poorly ventilated areas, cleaning firearms, or handling ammunition may result in exposure to lead and other substances known to cause birth defects, reproductive harm, and other serious physical injury.  Have adequate ventilation at all times.  Wash hands thoroughly after exposure.',
		LithiumBattery: 'No',
		Packaging: 'Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			"Delivering serious shock on impact. The Hornady® SST® (Super Shock Tip) is designed to deliver tremendous shock on impact while expanding quickly and reliably, particularly at higher velocities.  Flat shooting and deadly accurate, it's an ideal bullet for whitetails, as well as most North American game animals from antelope to moose and similar-sized African plains game. The SST® creates a devastatingly large wound channel. POLYMER TIP Upon impact, the hard polymer tip drives into the lead core like a wedge, initiating lightning-fast, yet controlled expansion.  SECANT OGIVE, BOATTAIL PROFILE Incorporating the pioneering Hornady secant ogive design, the tapered point, increased bearing surface and more aerodynamic profile, combined with a boattail base, makes the SST® more efficient with less drag and greater stability.  CANNELURE A mid-body cannelure helps keep the core and jacket together while providing a consistent, accurate crimp during the loading process.  INTERLOCK® RING This Hornady exclusive design mechanically locks the core and jacket together to maintain bullet integrity during expansion, ensuring maximum weight retention and increasing the chances of complete pass-throughs.",
		ProductFamilyImage:
			'http://images.salsify.com/image/upload/s--P-TQut8c--/df5d863dbd7228b59868d3ed5b7534751ccf2214.png',
		ProductImage:
			'http://images.salsify.com/image/upload/s--RnaKV5tC--/290f68387b4e52952ab5096c4a269b2d159e539e.jpg',
		ProductImage1: 'http://images.salsify.com/image/upload/s--yzWOtEbo--/rtudsghdxynr22w10mym.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--bWuv4Gh_--/wncvr31pfjoaysroyyrl.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--_LSVRI3A--/jgglupmlb6jmi7pssbdw.jpg',
		ProductImage4: 'http://images.salsify.com/image/upload/s--ufgPkoYV--/slgyavsmq1tnp5qcs2x9.jpg',
		ProductImage5: 'http://images.salsify.com/image/upload/s--dJgzwN7Y--/zjh5hpgw8yqpfaulv75z.jpg',
		Videos: 'https://vimeo.com/217517119',
		Videos1: 'https://vimeo.com/360360129',
		DateLastModified: '2023-12-16 08:59:00',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'd1d730f7-8889-418d-86ed-d19551316168',
		ProductID: '390751',
		ProductName: 'Large Primer Reamer',
		UPC: '090255907513',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '3.5',
		ShelfWidth: '2',
		ShelfDepth: '0.75',
		Weight: '0.125',
		WeightUOM: 'LB',
		CaseQty: '10',
		CartonUCC: '10090255907510',
		CartonHeight: '9.000',
		CartonWidth: '6.000',
		CartonDepth: '1.000',
		CartonWeight: '1.25',
		PalletQtyBoxes: '0',
		Retail: '14.52',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Case Prep, Trimmer & Accessories',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Clamshell',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductImage: 'http://images.salsify.com/image/upload/s--WX9jq-LH--/qhlsyk4udsrspfljksqz.png',
		DateLastModified: '2023-12-16 08:59:09',
	},
	{
		'@odata.etag': '',
		ItemInternalId: 'b2e2f0db-3a0b-4fc6-8126-312ffa410cfc',
		ProductID: '544281',
		ProductName: 'Match™ Grade 2-Die Set 6.5X55 Swede (.264)',
		UPC: '090255542813',
		PackagedQTY: '1',
		PackagedUOM: 'EA',
		ShelfHeight: '2',
		ShelfWidth: '4.75',
		ShelfDepth: '7.125',
		Weight: '1.640',
		WeightUOM: 'LB',
		CaseQty: '5',
		CartonUCC: '10090255542810',
		CartonHeight: '10.750',
		CartonWidth: '8.000',
		CartonDepth: '5.500',
		CartonWeight: '8.2',
		PalletQtyBoxes: '0',
		Retail: '145.25',
		Brand: 'Hornady®',
		ParentCategory: 'Reloading',
		ProductLine: 'Match™ Grade Die Sets',
		Cartridge: '6.5X55',
		Caliber: '6.5MM',
		BulletDiameter: '0.264',
		CountryofOrigin: 'USA',
		Prop65Chem1: 'LEAD',
		Prop65Chem2: 'LEAD',
		Prop65Warn1: 'Warning: Cancer and Reproductive Harm - www.P65Warnings.ca.gov',
		LithiumBattery: 'No',
		Packaging: 'Plastic Box',
		MasterPackQty: '0',
		MasterPackHeight: '0.000',
		MasterPackWidth: '0.000',
		MasterPackDepth: '0.000',
		MasterPackWeight: '0.0',
		ProductDescription:
			'Hornady® reloading dies represent the finest in machined craftsmanship. Precise machining allows accurate reloading by offering easier adjustments, better alignment and smooth functioning.  With one of the finest internal finishes in the industry, Hornady® reloading dies provide a lifetime of reloading. They’re so well-crafted that they’re guaranteed never to break or wear out from normal use.  Hornady® Match™ Grade 2-Die set gives you total control over neck tension in the resizing process. At the heart of this die set is the Match™ Grade Size Die that accommodates interchangeable, self-centering Hornady® Neck Size Bushings that eliminate the chance of oversizing your case necks and overworking the brass.* The Size Die features a removable Elliptical Expander that allows the user the option to inside neck size or not.  The Elliptical Expander  is superior to “ball expanders,” this Hornady® exclusive provides extremely smooth neck sizing and significantly reduces friction and case neck stretch. Internal threading on the Elliptical Expander prevents it from pulling loose.  Also included with this die is a Decap Pin Retainer and hardened steel Headed Decap Pin.  The second die in this set is a seating die with an alignment sleeve and a Micro Just™ micrometer for precise bullet seating depth adjustment, a conventional contour bullet seating stem and an ELD® Match bullet seating stem. Key to the Seating Die is the In-line Bullet Seating System that holds the bullet, the case neck and the seating stem in perfect alignment in the floating sleeve BEFORE the bullet enters the neck of the case for optimum seating and enhanced accuracy results. Additionally, this die features a built-in crimper that allows roll crimping without the need for an extra crimp die, saving a step in the process or a station on your press.  The Hornady® Seater Die has a retainer ring toward the base of the die that removes in seconds for easy disassembly and cleaning of the die. As with all Hornady® Match™ Grade die sets, these dies come with Hornady® Sure-Loc™ lock rings that clamp around the entire die body applying constant pressure to hold the ring in place. The locking screw tightens the ring without coming into contact with the threads, and the incorporated wrench flats allow easy removal or replacement of dies and eliminates possible damage from pliers.  All Hornady® Match™ Grade Die Sets are delivered in a stackable Die Storage Box that can also accommodate a shell holder, Lock-N-Load bushings, powder dies etc.*  *Bushings and other dies and accessories sold separately. Select the Hornady® Die Bushing your cartridge requires to complete your Hornady® Match™ Grade Size Die.  HORNADY® MATCH™ GRADE 2-DIE SET COMES COMPLETE WITH THE FOLLOWING: Full Length Bushing Style Size Die* and Sure-Loc™ Lock Ring • Removable Elliptical Expander • Decap Pin Retainer • Headed Decap Pins • In-line Bullet Seating Die with Micro Just™ Seating Micrometer and Sure-Loc™ Lock Ring • Standard Bullet Seating Stem • ELD® Match Bullet Seating Stem • Stackable Die Storage Box  7/8”-14 thread dies that work with all presses that accept standard dies.  Does not include a shell holder. Other accessories sold separately.  Hornady® Lock-N-Load® Die Bushings are necessary for use with modern Hornady® reloading presses: Hornady Item number 044094 (2-Pack), 044093 (3-Pack), 044096 (10-Pack). Hornady® recommends spraying all metal parts with Hornady® One Shot® Gun Cleaner & Lube: Hornady Item number 99901 (10 oz aerosol) 9990 (5 oz aerosol).  No-risk, Lifetime warranty. See Hornady.com for more information. MADE IN THE USA',
		ProductImage: 'http://images.salsify.com/image/upload/s--2yNtRSkP--/rwmsue0shu7im6biqq6r.png',
		ProductImage1: 'http://images.salsify.com/image/upload/s--WD6sc88Z--/uqzxd7chhw2xsuytt5qx.png',
		ProductImage2: 'http://images.salsify.com/image/upload/s--kTsM6pj3--/ak46rfjdklkla9mwgiry.png',
		ProductImage3: 'http://images.salsify.com/image/upload/s--HFeLhzef--/hgwbjtvmbqj0ddiyz4sy.png',
		DateLastModified: '2023-12-16 09:02:50',
	},
];
